import _extends from '@babel/runtime-corejs3/helpers/esm/extends';
import 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

/**
UiAccessibilityFilled icon

```jsx
import { UiAccessibilityFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiAccessibilityFilled />
```

 */
const UiAccessibilityFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M14.5 3.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
  }), /*#__PURE__*/jsx("path", {
    d: "M20.15 6.04c.81-.19 1.61-.05 1.81.76.19.8-.3 1.46-1.11 1.66-1.27.31-3.59.65-5.85.86V22c0 1-1 1-1 1-.55 0-1-.45-1-1v-5.5c0-.28-.22-.5-.5-.5h-1c-.28 0-.5.22-.5.5V22c0 .55-.45 1-1 1s-1-.45-1-1V9.32c-2.24-.21-4.56-.55-5.85-.86-.81-.19-1.3-.85-1.11-1.66.19-.81 1-.96 1.81-.76C5.41 6.42 7 7.055 12 7c5-.054 6.42-.54 8.15-.96z"
  })]
}));

/**
UiAccessibilityFilledSmall icon

```jsx
import { UiAccessibilityFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiAccessibilityFilledSmall />
```

 */
const UiAccessibilityFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsxs("g", {
    clipPath: "url(#omni-gravity-icon-ui-accessibility-filled-small-a)",
    children: [/*#__PURE__*/jsx("path", {
      d: "M9.75 1.75a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0z"
    }), /*#__PURE__*/jsx("path", {
      d: "M14.69 3.041c.53-.16 1.09.12 1.26.65.17.53-.12 1.09-.64 1.26-1.48.47-2.99.74-4.31.88V15c0 .55-.45 1-1 1s-1-.45-1-1v-3.5c0-.28-.22-.5-.5-.5h-1c-.28 0-.5.22-.5.5V15c0 .55-.45 1-1 1s-1-.45-1-1V5.83c-1.98-.22-3.47-.61-4.3-.88a.999.999 0 01-.65-1.26c.17-.52.73-.81 1.26-.64C2.41 3.401 4.76 4 8 4c1.39 0 4.12-.12 6.69-.96z"
    })]
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-accessibility-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiAccountsFilled icon

```jsx
import { UiAccountsFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiAccountsFilled />
```

 */
const UiAccountsFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2h18c1.1 0 2 1 2 2.2v9.6c0 1.2-.9 2.2-2 2.2H3c-1.1 0-2-1-2-2.1V4.2C1 3 1.9 2 3 2zm4.593 6.585C8.471 8.885 9 9.595 9 10.527c0 1.181-.858 1.862-1.746 1.952v.02c0 .41-.34.751-.749.751a.755.755 0 01-.748-.75v-.161c-.649-.17-1.068-.41-1.138-.45a.751.751 0 11.799-1.272c.14.08.768.38 1.576.38.08 0 .5-.02.5-.49 0-.2-.03-.4-.42-.53l-.978-.381-.439-.17C4.499 9.044 4.25 8.153 4.25 7.482c0-.99.689-1.632 1.497-1.872V5.5c0-.41.34-.751.748-.751.41 0 .749.34.749.75V5.6c.649.156 1.1.481 1.19.546l.007.005c.33.25.4.72.15 1.05a.738.738 0 01-1.008.171c-.005-.005-.01-.007-.015-.01a.052.052 0 01-.015-.01l-.014-.009c-.085-.055-.53-.341-1.034-.341-.01 0-.748.01-.748.49 0 .34.09.42.419.53l.778.311.639.25z"
  }), /*#__PURE__*/jsx("path", {
    d: "M19 19H5c-.6 0-1-.5-1-1s.4-1 1-1h14c.5 0 1 .5 1 1s-.5 1-1 1zm-2 3H7c-.6 0-1-.5-1-1s.4-1 1-1h10c.5 0 1 .5 1 1s-.5 1-1 1z"
  })]
}));

/**
UiAccountsFilledSmall icon

```jsx
import { UiAccountsFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiAccountsFilledSmall />
```

 */
const UiAccountsFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1H1c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zM5.093 5.585c.878.3 1.407 1.01 1.407 1.942 0 1.181-.858 1.862-1.746 1.952v.02c0 .41-.34.751-.749.751a.755.755 0 01-.748-.75v-.161c-.649-.17-1.068-.41-1.138-.45a.751.751 0 11.799-1.272c.14.08.768.38 1.576.38.08 0 .5-.02.5-.49 0-.2-.03-.4-.42-.53l-.978-.381-.439-.17C1.999 6.045 1.75 5.154 1.75 4.482c0-.99.689-1.632 1.497-1.872V2.5c0-.41.34-.751.748-.751.41 0 .749.34.749.75V2.6c.649.156 1.1.481 1.19.546l.007.005c.33.25.4.72.15 1.05a.738.738 0 01-1.008.171c-.005-.005-.01-.007-.015-.01a.052.052 0 01-.015-.01l-.014-.009c-.085-.055-.53-.341-1.034-.341-.01 0-.748.01-.748.49 0 .34.09.42.419.53l.778.311.639.25z"
  }), /*#__PURE__*/jsx("path", {
    d: "M14.5 12h-13c-.3 0-.5.2-.5.5s.2.5.5.5h13c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zm-2 2h-9c-.3 0-.5.2-.5.5s.2.5.5.5h9c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  })]
}));

/**
UiAccountsLined icon

```jsx
import { UiAccountsLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiAccountsLined />
```

 */
const UiAccountsLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M7.593 8.585C8.471 8.885 9 9.595 9 10.527c0 1.181-.858 1.862-1.746 1.952v.02c0 .41-.34.751-.749.751a.755.755 0 01-.748-.75v-.161c-.649-.17-1.068-.41-1.138-.45a.751.751 0 11.799-1.272c.14.08.768.38 1.576.38.08 0 .5-.02.5-.49 0-.2-.03-.4-.42-.53l-.978-.381-.439-.17C4.499 9.044 4.25 8.153 4.25 7.482c0-.99.689-1.632 1.497-1.872V5.5c0-.41.34-.751.748-.751.41 0 .749.34.749.75V5.6c.649.156 1.1.481 1.19.546l.007.005c.33.25.4.72.15 1.05a.738.738 0 01-1.008.171c-.005-.005-.01-.007-.015-.01a.052.052 0 01-.015-.01l-.014-.009c-.085-.055-.53-.341-1.034-.341-.01 0-.748.01-.748.49 0 .34.09.42.419.53l.778.311.639.25z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2h18c1.1 0 2 1 2 2.2v9.6c0 1.2-.9 2.2-2 2.2H3c-1.1 0-2-1-2-2.1V4.2C1 3 1.9 2 3 2zm18 2H3v10.1h18V4z"
  }), /*#__PURE__*/jsx("path", {
    d: "M19 19H5c-.6 0-1-.5-1-1s.4-1 1-1h14c.5 0 1 .5 1 1s-.5 1-1 1zm-2 3H7c-.6 0-1-.5-1-1s.4-1 1-1h10c.5 0 1 .5 1 1s-.5 1-1 1z"
  })]
}));

/**
UiAgentFilled icon

```jsx
import { UiAgentFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiAgentFilled />
```

 */
const UiAgentFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M21 8h-.2c-.9-4-4.5-7-8.8-7-4.3 0-7.9 3-8.8 7H3c-1.1 0-2 .9-2 2v1c0 1.1.9 2 2 2h.5c.4 1.2 1.2 2.4 2.1 3.4.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4-1.3-1.4-2-3.1-2-5 0-3.9 3.1-7 7-7s7 3.1 7 7v2c0 .6.4 1 1 1h1c1.1 0 2-.9 2-2v-1c0-1.1-.9-2-2-2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M12 16a6 6 0 100-12 6 6 0 000 12zm-8 5c0-2.5 3-4 8-4s8 1.5 8 4c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1z"
  })]
}));

/**
UiAgentFilledSmall icon

```jsx
import { UiAgentFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiAgentFilledSmall />
```

 */
const UiAgentFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M15 5h-.3c-.9-2.9-3.5-5-6.7-5S2.2 2.1 1.3 5H1c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h.3c.2.7.5 1.4 1 2.1.2.3.5.4.8.4.2 0 .4-.1.6-.2.5-.3.6-.9.2-1.4C3.3 9 3 8 3 7c0-2.8 2.2-5 5-5s5 2.2 5 5v1c0 .6.4 1 1 1h1c.6 0 1-.4 1-1V6c0-.6-.4-1-1-1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M8 11a4 4 0 100-8 4 4 0 000 8zm-6 4c0-2.1 3.1-3 6-3s6 .9 6 3c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1z"
  })]
}));

/**
UiAgentLined icon

```jsx
import { UiAgentLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiAgentLined />
```

 */
const UiAgentLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M21 8h-.2c-.9-4-4.5-7-8.8-7-4.3 0-7.9 3-8.8 7H3c-1.1 0-2 .9-2 2v1c0 1.1.9 2 2 2h.5c.4 1.2 1.2 2.4 2.1 3.4.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4-1.3-1.4-2-3.1-2-5 0-3.9 3.1-7 7-7s7 3.1 7 7v2c0 .6.4 1 1 1h1c1.1 0 2-.9 2-2v-1c0-1.1-.9-2-2-2z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10c0-3.3-2.7-6-6-6s-6 2.7-6 6 2.7 6 6 6 6-2.7 6-6zM8 10c0-2.2 1.8-4 4-4s4 1.8 4 4-1.8 4-4 4-4-1.8-4-4z"
  }), /*#__PURE__*/jsx("path", {
    d: "M4 21c0-2.5 3-4 8-4s8 1.5 8 4c0 .6-.4 1-1 1s-1-.4-1-1c0-1-2.1-2-6-2s-6 1-6 2c0 .6-.4 1-1 1s-1-.4-1-1z"
  })]
}));

/**
UiAgentLinedSmall icon

```jsx
import { UiAgentLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiAgentLinedSmall />
```

 */
const UiAgentLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M15 5h-.3c-.9-2.9-3.5-5-6.7-5S2.2 2.1 1.3 5H1c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h.3c.2.7.5 1.4 1 2.1.2.3.5.4.8.4.2 0 .4-.1.6-.2.5-.3.6-.9.2-1.4C3.3 9 3 8 3 7c0-2.8 2.2-5 5-5s5 2.2 5 5v1c0 .6.4 1 1 1h1c.6 0 1-.4 1-1V6c0-.6-.4-1-1-1z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7c0-2.2-1.8-4-4-4S4 4.8 4 7s1.8 4 4 4 4-1.8 4-4zM6 7c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M2 15c0-2.1 3.1-3 6-3s6 .9 6 3c0 .6-.4 1-1 1s-1-.4-1-1c-.1-.2-1.5-1-4-1s-3.9.8-4 1c0 .6-.4 1-1 1s-1-.4-1-1z"
  })]
}));

/**
UiAggregateLined icon

```jsx
import { UiAggregateLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiAggregateLined />
```

 */
const UiAggregateLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M11.283 1.293a1 1 0 011.414 0l2.83 2.83a1 1 0 11-1.414 1.414L12.99 4.414v5.712l3.034 3.488a1 1 0 11-1.508 1.312l-2.52-2.896-8.236 9.62a1 1 0 01-1.52-1.3l8.75-10.22V4.414L9.867 5.537a1 1 0 01-1.414-1.414l2.83-2.83zm5.77 15.184a1 1 0 011.41.096l3.29 3.77a1 1 0 01-1.506 1.314l-3.29-3.77a1 1 0 01.096-1.41z"
  })
}));

/**
UiAggregateLinedSmall icon

```jsx
import { UiAggregateLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiAggregateLinedSmall />
```

 */
const UiAggregateLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M8.71.306a1 1 0 00-1.44 0L4.77 2.9a1 1 0 101.44 1.388l.783-.812.006 3.856-6.72 6.973a1 1 0 001.441 1.388l6.278-6.515 1.57 1.636a1 1 0 101.444-1.384L8.999 7.333l-.006-3.851.777.806A1 1 0 0011.21 2.9L8.71.306zm3.296 11.587a1 1 0 011.414.026l2.3 2.387a1 1 0 11-1.44 1.387l-2.3-2.386a1 1 0 01.026-1.414z"
  })
}));

/**
UiApiLined icon

```jsx
import { UiApiLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiApiLined />
```

 */
const UiApiLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M9.366 3.685a1 1 0 10-1.457-1.37l-5.638 6A1 1 0 003 10h9.995a1 1 0 100-2H5.312l4.054-4.315zM16.993 8a1 1 0 100 2h3.997a1 1 0 100-2h-3.997zm-6.988 7a1 1 0 011-1H21a1 1 0 01.73 1.684l-5.628 6a1 1 0 01-1.458-1.368L18.692 16h-7.687a1 1 0 01-1-1zM3.01 14a1 1 0 100 2h3.998a1 1 0 100-2H3.01z"
  })
}));

/**
UiApiLinedSmall icon

```jsx
import { UiApiLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiApiLinedSmall />
```

 */
const UiApiLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-api-lined-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M4.8 2.6a1 1 0 00-1.6-1.2l-3 4A1 1 0 001 7h8a1 1 0 000-2H3l1.8-2.4zM13 5a1 1 0 100 2h2a1 1 0 100-2h-2zM0 10a1 1 0 011-1h2a1 1 0 110 2H1a1 1 0 01-1-1zm7-1a1 1 0 100 2h6l-1.8 2.4a1 1 0 001.6 1.2l3-4A1 1 0 0015 9H7z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-api-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiApplicationFilled icon

```jsx
import { UiApplicationFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiApplicationFilled />
```

 */
const UiApplicationFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M18 11c-4.4 0-8 3.6-8 8 0 1.1.2 2.1.6 3H5c-.6 0-1-.4-1-1V9h6c.6 0 1-.4 1-1V2h8c.6 0 1 .4 1 1v8.3c-.6-.2-1.3-.3-2-.3z"
  }), /*#__PURE__*/jsx("path", {
    d: "M9 3v4H5l4-4zm11.5 11.5c-.6-.6-1.4-.6-2 0l-.4.4 2 2 .3-.3c.7-.7.7-1.5.1-2.1zm-3.1 1.1l2 2L15 22h-2v-2l4.4-4.4z"
  })]
}));

/**
UiApplicationFilledSmall icon

```jsx
import { UiApplicationFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiApplicationFilledSmall />
```

 */
const UiApplicationFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M14 6.1c-.3-.1-.7-.1-1-.1-3.9 0-7 3.1-7 7 0 1.1.3 2.1.7 3H3c-.6 0-1-.4-1-1V6h5c.6 0 1-.4 1-1V0h5c.6 0 1 .4 1 1v5.1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M2 4l4-4v4H2zm11.6 4.4l-.5.5 2 2 .4-.4c.6-.6.6-1.4 0-2-.5-.6-1.4-.6-1.9-.1zm.8 3.2L10 16H8v-2l4.4-4.4 2 2z"
  })]
}));

/**
UiApplicationLined icon

```jsx
import { UiApplicationLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiApplicationLined />
```

 */
const UiApplicationLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 20c.6 0 1 .4 1 1s-.4 1-1 1H5c-.6 0-1-.4-1-1V8.5c0-.3.1-.5.3-.7l5.5-5.5c.2-.2.4-.3.7-.3H19c.6 0 1 .4 1 1v9.1c-.1.5-.5.9-1 .9-.2 0-.4-.1-.6-.2-.2-.2-.4-.5-.4-.8V4h-6v5c0 .6-.4 1-1 1H6v10h5zM10 8V4.9L6.9 8H10z"
  }), /*#__PURE__*/jsx("path", {
    d: "M21.1 16.9l.4-.4c.6-.6.6-1.4 0-2-.3-.3-.6-.4-1-.4s-.7.1-1 .4l-.4.4 2 2zm-2.7-1.3L14 20v2h2l4.4-4.4-2-2z"
  })]
}));

/**
UiApplicationLinedSmall icon

```jsx
import { UiApplicationLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiApplicationLinedSmall />
```

 */
const UiApplicationLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 14h1c.6 0 1 .4 1 1s-.4 1-1 1H3c-.6 0-1-.4-1-1V5.4c0-.3.1-.5.3-.7L6.7.3c.2-.2.4-.3.7-.3H13c.6 0 1 .4 1 1v5c0 .6-.4 1-1 1s-1-.4-1-1V2H9v4c0 .6-.4 1-1 1H4v7zm3-9V2.8L4.8 5H7z"
  }), /*#__PURE__*/jsx("path", {
    d: "M15.6 8.4c-.6-.6-1.4-.6-2 0l-.5.5 2 2 .4-.4c.6-.6.6-1.5.1-2.1zM8 14v2h2l4.4-4.4-2-2L8 14z"
  })]
}));

/**
UiArrowDownEncircledFilled icon

```jsx
import { UiArrowDownEncircledFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowDownEncircledFilled />
```

 */
const UiArrowDownEncircledFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M2 12c0 5.52 4.48 10 10 10s10-4.48 10-10S17.52 2 12 2 2 6.48 2 12zm11-5v7.83l2.28-2.52a.997.997 0 111.48 1.34c-.01.01-.02.03-.03.04l-4.01 4-.02.02-.01.01a.87.87 0 01-.28.19c-.13.06-.27.09-.41.09-.02 0-.04-.01-.06-.01a.86.86 0 01-.62-.25l-4.04-4.05a.996.996 0 111.41-1.41l.03.03 2.28 2.5V7c0-.55.45-1 1-1s1 .45 1 1z"
  })
}));

/**
UiArrowDownEncircledFilledSmall icon

```jsx
import { UiArrowDownEncircledFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowDownEncircledFilledSmall />
```

 */
const UiArrowDownEncircledFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8-8 3.6-8 8zm9-4v5.7L10.5 8c.4-.4 1-.4 1.4 0 .2.2.3.5.3.7 0 .2 0 .6-.2.8l-3.3 3.2c-.1.1-.2.2-.3.2-.3.1-.5.1-.8 0-.1-.1-.2-.1-.3-.2L4 9.5c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0L7 9.7V4c0-.6.4-1 1-1s1 .4 1 1z"
  })
}));

/**
UiArrowDownEncircledLined icon

```jsx
import { UiArrowDownEncircledLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowDownEncircledLined />
```

 */
const UiArrowDownEncircledLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11 14.81V7c0-.55.45-1 1-1s1 .45 1 1v7.83l2.27-2.51a.997.997 0 111.48 1.34c-.01.02-.02.03-.03.04l-4.01 4-.03.03c-.08.09-.18.15-.28.19-.12.05-.26.08-.4.08-.01 0-.02-.003-.03-.005a.125.125 0 00-.03-.005c-.22 0-.45-.08-.62-.25l-4.04-4.05a.996.996 0 111.41-1.41l.03.03 2.28 2.5z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C6.48 22 2 17.52 2 12S6.48 2 12 2s10 4.48 10 10-4.48 10-10 10zm0-2c4.41 0 8-3.59 8-8s-3.59-8-8-8-8 3.59-8 8 3.59 8 8 8z"
  })]
}));

/**
UiArrowDownLined icon

```jsx
import { UiArrowDownLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowDownLined />
```

 */
const UiArrowDownLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M11.62 21.92a1 1 0 001.09-.22l6-6a.996.996 0 10-1.41-1.41l-4.3 4.3V3c0-.55-.45-1-1-1s-1 .45-1 1v15.59L6.71 14.3a.996.996 0 00-1.41 0c-.2.19-.3.44-.3.7 0 .26.1.51.29.71l6 6c.09.09.21.16.33.21z"
  })
}));

/**
UiArrowDownLinedSmall icon

```jsx
import { UiArrowDownLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowDownLinedSmall />
```

 */
const UiArrowDownLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M9.005 2.002v9.748l2.291-2.446a.997.997 0 111.411 1.41l-4.003 4.002c-.08.09-.2.16-.32.21a1 1 0 01-.76 0c-.12-.05-.24-.12-.33-.21L3.29 10.715c-.19-.2-.29-.45-.29-.71 0-.26.1-.51.29-.71a.997.997 0 011.411 0l2.302 2.455V2.002c0-.55.45-1 1-1 .551 0 1.002.45 1.002 1z"
  })
}));

/**
UiArrowLeftEncircledFilled icon

```jsx
import { UiArrowLeftEncircledFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowLeftEncircledFilled />
```

 */
const UiArrowLeftEncircledFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H9.17l2.52 2.28a.997.997 0 11-1.34 1.48c-.01-.01-.03-.02-.04-.03l-4-4.01-.02-.02-.01-.01c-.09-.09-.15-.19-.2-.29-.05-.12-.08-.26-.08-.4 0-.02.01-.04.01-.06 0-.23.08-.45.25-.62l4.05-4.04a.996.996 0 111.41 1.41l-.03.03L9.19 11H17c.55 0 1 .45 1 1s-.45 1-1 1z"
  })
}));

/**
UiArrowLeftEncircledFilledSmall icon

```jsx
import { UiArrowLeftEncircledFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowLeftEncircledFilledSmall />
```

 */
const UiArrowLeftEncircledFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm4 9H6.3L8 10.5c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3-.2 0-.6 0-.8-.2L3.3 8.7c-.1-.1-.2-.2-.2-.3-.1-.3-.1-.5 0-.8.1-.1.1-.2.2-.3L6.5 4c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L6.3 7H12c.6 0 1 .4 1 1s-.4 1-1 1z"
  })
}));

/**
UiArrowLeftEncircledLined icon

```jsx
import { UiArrowLeftEncircledLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowLeftEncircledLined />
```

 */
const UiArrowLeftEncircledLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9.19 11H17c.55 0 1 .45 1 1s-.45 1-1 1H9.17l2.51 2.27a.997.997 0 11-1.34 1.48.138.138 0 01-.04-.03l-4-4.01-.03-.03a.735.735 0 01-.19-.28c-.05-.12-.08-.26-.08-.4 0-.01.003-.02.005-.03a.125.125 0 00.005-.03c0-.22.08-.45.25-.62l4.05-4.04a.996.996 0 111.41 1.41l-.03.03L9.19 11z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm2 0c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8-8 3.59-8 8z"
  })]
}));

/**
UiArrowLeftLined icon

```jsx
import { UiArrowLeftLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowLeftLined />
```

 */
const UiArrowLeftLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M21 10.996H5.41L9.7 6.703a.997.997 0 10-1.41-1.41l-6 6.003c-.09.09-.16.2-.21.32-.04.1-.06.22-.07.33 0 .01-.01.03-.01.05 0 .03.01.05.02.08.01.1.02.21.06.3.05.13.12.24.22.33l6 6.004c.19.19.44.29.7.29.26 0 .51-.1.71-.29a.997.997 0 000-1.41l-4.3-4.303H21c.55 0 1-.45 1-1 0-.551-.45-1.001-1-1.001z"
  })
}));

/**
UiArrowLeftLinedSmall icon

```jsx
import { UiArrowLeftLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowLeftLinedSmall />
```

 */
const UiArrowLeftLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14 6.995H4.25l2.447-2.291a.997.997 0 10-1.41-1.411L1.285 7.296c-.09.08-.16.2-.21.32a1 1 0 000 .76c.05.12.12.24.21.33l4.002 4.004c.2.19.45.29.71.29.26 0 .51-.1.71-.29a.997.997 0 000-1.411L4.25 8.997H14c.55 0 1-.45 1-1 0-.551-.45-1.002-1-1.002z"
  })
}));

/**
UiArrowLevelDownLined icon

```jsx
import { UiArrowLevelDownLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowLevelDownLined />
```

 */
const UiArrowLevelDownLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14.263 19.176a1 1 0 001.474 0l2.75-3a1 1 0 00-1.474-1.352L16 15.93V6.99A2.99 2.99 0 0013 4H7a1 1 0 100 2h6c.561 0 1 .446 1 .99v8.94l-1.013-1.106a1 1 0 00-1.474 1.352l2.75 3z"
  })
}));

/**
UiArrowLevelDownLinedSmall icon

```jsx
import { UiArrowLevelDownLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowLevelDownLinedSmall />
```

 */
const UiArrowLevelDownLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M9.232 14.64a1 1 0 001.536 0l2.5-3a1 1 0 10-1.536-1.28l-.732.878V5.04C11 3.374 9.668 2 8 2H3a1 1 0 100 2h5c.532 0 1 .446 1 1.04v6.198l-.732-.878a1 1 0 00-1.536 1.28l2.5 3z"
  })
}));

/**
UiArrowLevelUpLined icon

```jsx
import { UiArrowLevelUpLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowLevelUpLined />
```

 */
const UiArrowLevelUpLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M10.487 4.324a1 1 0 00-1.474 0l-2.75 3a1 1 0 101.474 1.352L8.75 7.57v8.939a2.99 2.99 0 003 2.99h6a1 1 0 100-2h-6a.99.99 0 01-1-.99V7.57l1.013 1.106a1 1 0 101.474-1.352l-2.75-3z"
  })
}));

/**
UiArrowLevelUpLinedSmall icon

```jsx
import { UiArrowLevelUpLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowLevelUpLinedSmall />
```

 */
const UiArrowLevelUpLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.768 1.36a1 1 0 00-1.536 0l-2.5 3a1 1 0 101.536 1.28L5 4.762v6.198C5 12.626 6.332 14 8 14h5a1 1 0 100-2H8c-.532 0-1-.446-1-1.04V4.762l.732.878a1 1 0 101.536-1.28l-2.5-3z"
  })
}));

/**
UiArrowRightEncircledFilled icon

```jsx
import { UiArrowRightEncircledFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowRightEncircledFilled />
```

 */
const UiArrowRightEncircledFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 22c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10zM7 11h7.83l-2.52-2.28a.997.997 0 111.34-1.48c.01.01.03.02.04.03l4 4.01.02.02.01.01c.08.08.15.18.19.28.06.13.09.27.09.41 0 .02-.01.04-.01.06 0 .23-.08.45-.25.62l-4.05 4.04a.996.996 0 11-1.41-1.41l.03-.03 2.5-2.28H7c-.55 0-1-.45-1-1s.45-1 1-1z"
  })
}));

/**
UiArrowRightEncircledFilledSmall icon

```jsx
import { UiArrowRightEncircledFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowRightEncircledFilledSmall />
```

 */
const UiArrowRightEncircledFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16c4.4 0 8-3.6 8-8s-3.6-8-8-8-8 3.6-8 8 3.6 8 8 8zM4 7h5.7L8 5.5c-.4-.4-.4-1 0-1.4.2-.2.5-.3.7-.3.2 0 .6 0 .8.2l3.2 3.3c.1.1.2.2.2.3.1.3.1.5 0 .8-.1.1-.1.2-.2.3L9.5 12c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4L9.7 9H4c-.6 0-1-.4-1-1s.4-1 1-1z"
  })
}));

/**
UiArrowRightEncircledLined icon

```jsx
import { UiArrowRightEncircledLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowRightEncircledLined />
```

 */
const UiArrowRightEncircledLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M14.81 13H7c-.55 0-1-.45-1-1s.45-1 1-1h7.83l-2.52-2.28c-.41-.37-.44-1-.06-1.4.37-.41 1-.44 1.41-.07.02.01.03.02.04.03l4 4.01.03.03c.09.08.15.18.19.28.05.12.08.26.08.4 0 .01-.003.02-.005.03a.125.125 0 00-.005.03c0 .22-.08.45-.25.62l-4.05 4.04a.996.996 0 11-1.41-1.41l.03-.03 2.5-2.28z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2s10 4.48 10 10zm-2 0c0-4.41-3.59-8-8-8s-8 3.59-8 8 3.59 8 8 8 8-3.59 8-8z"
  })]
}));

/**
UiArrowRightLined icon

```jsx
import { UiArrowRightLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowRightLined />
```

 */
const UiArrowRightLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M21.92 12.38a1 1 0 00-.22-1.09l-6-6a.996.996 0 10-1.41 1.41l4.3 4.3H3c-.55 0-1 .45-1 1s.45 1 1 1h15.59l-4.29 4.29a.996.996 0 000 1.41c.19.2.44.3.7.3.26 0 .51-.1.71-.29l6-6c.09-.09.16-.21.21-.33z"
  })
}));

/**
UiArrowRightLinedSmall icon

```jsx
import { UiArrowRightLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowRightLinedSmall />
```

 */
const UiArrowRightLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M2 6.995h9.75L9.303 4.704a.997.997 0 111.41-1.411l4.002 4.003c.09.08.16.2.21.32a1 1 0 010 .76c-.05.12-.12.24-.21.33l-4.002 4.004c-.2.19-.45.29-.71.29-.26 0-.51-.1-.71-.29a.997.997 0 010-1.411l2.457-2.302H2c-.55 0-1-.45-1-1 0-.551.45-1.002 1-1.002z"
  })
}));

/**
UiArrowSortFilled icon

```jsx
import { UiArrowSortFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowSortFilled />
```

 */
const UiArrowSortFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M16.009 14.075h-8c-.4 0-.7.2-.9.6-.2.3-.1.8.1 1.1l4 5c.2.2.5.4.8.4.3 0 .6-.1.8-.4l4-5c.2-.3.3-.7.1-1.1-.2-.4-.5-.6-.9-.6zm-8-4h8c.4 0 .7-.2.9-.6.2-.3.1-.8-.1-1.1l-4-5c-.4-.5-1.2-.5-1.6 0l-4 5c-.2.3-.3.7-.1 1.1.2.4.5.6.9.6z"
  })
}));

/**
UiArrowSortFilledSmall icon

```jsx
import { UiArrowSortFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowSortFilledSmall />
```

 */
const UiArrowSortFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M11.009 10h-6c-.4 0-.7.2-.9.6-.2.4-.1.8.1 1.1l3 3c.2.2.5.3.8.3.3 0 .6-.1.8-.3l3-3c.3-.3.3-.7.1-1.1-.2-.4-.5-.6-.9-.6zM5.01 6h6c.4 0 .7-.2.9-.6.2-.4.1-.8-.1-1.1l-3.001-3c-.4-.4-1.1-.4-1.5 0l-3 3c-.3.3-.3.7-.1 1.1.2.4.4.6.8.6z"
  })
}));

/**
UiArrowSortLined icon

```jsx
import { UiArrowSortLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowSortLined />
```

 */
const UiArrowSortLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M15.205 14.375l-3.2 4-3.2-4c-.3-.4-1-.5-1.4-.2-.4.3-.5 1-.2 1.4l4 5c.2.2.5.4.8.4.3 0 .6-.1.8-.4l4-5c.3-.4.3-1.1-.2-1.4-.4-.3-1-.3-1.4.2zm-6.4-4.8l3.2-4 3.2 4c.2.2.5.4.8.4.2 0 .4-.1.6-.2.4-.3.5-1 .2-1.4l-4-5c-.4-.5-1.2-.5-1.6 0l-4 5c-.3.4-.3 1.1.2 1.4.4.3 1 .3 1.4-.2z"
  })
}));

/**
UiArrowSortLinedSmall icon

```jsx
import { UiArrowSortLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowSortLinedSmall />
```

 */
const UiArrowSortLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M10.155 9.8l-2.2 2.6-2.2-2.6c-.4-.4-1-.5-1.4-.1-.4.4-.5 1-.1 1.4l3 3.5c.2.2.5.3.8.3.3 0 .6-.1.8-.3l3-3.5c.4-.4.3-1-.1-1.4-.6-.4-1.2-.4-1.6.1zm-4.4-3.7l2.2-2.6 2.2 2.6c.2.2.5.3.8.3.2 0 .5-.1.7-.2.4-.4.5-1 .1-1.4l-3-3.5c-.4-.4-1.1-.4-1.5 0l-3 3.5c-.4.4-.3 1 .1 1.4.4.3 1 .3 1.4-.1z"
  })
}));

/**
UiArrowUpEncircledFilled icon

```jsx
import { UiArrowUpEncircledFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowUpEncircledFilled />
```

 */
const UiArrowUpEncircledFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10 10-4.48 10-10zm-11 5V9.17l-2.28 2.52a.997.997 0 11-1.48-1.34c.01-.01.02-.03.03-.04l4.01-4 .03-.03.01-.01c.08-.08.18-.14.28-.19.12-.05.26-.08.4-.08.02 0 .04.01.06.01.23 0 .45.08.62.25l4.04 4.05a.996.996 0 11-1.41 1.41l-.03-.03L13 9.19V17c0 .55-.45 1-1 1s-1-.45-1-1z"
  })
}));

/**
UiArrowUpEncircledFilledSmall icon

```jsx
import { UiArrowUpEncircledFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowUpEncircledFilledSmall />
```

 */
const UiArrowUpEncircledFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-arrow-up-encircled-filled-small-a)",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 8c0-4.4-3.6-8-8-8S0 3.6 0 8s3.6 8 8 8 8-3.6 8-8zm-9 4V6.3L5.5 8c-.4.4-1 .4-1.4 0-.2-.2-.3-.5-.3-.7 0-.2 0-.6.2-.8l3.3-3.2c.1-.1.2-.2.3-.2.3-.1.5-.1.8 0 .1.1.2.1.3.2L12 6.5c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0L9 6.3V12c0 .6-.4 1-1 1s-1-.4-1-1z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-arrow-up-encircled-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiArrowUpEncircledLined icon

```jsx
import { UiArrowUpEncircledLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowUpEncircledLined />
```

 */
const UiArrowUpEncircledLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M13 9.19V17c0 .55-.45 1-1 1s-1-.45-1-1V9.17l-2.28 2.52a.997.997 0 11-1.48-1.34.139.139 0 00.015-.02l.015-.02 4.01-4 .04-.04c.08-.09.18-.15.28-.19.12-.05.26-.08.4-.08.01 0 .02.003.03.005.01.003.02.005.03.005.22 0 .45.08.62.25l4.04 4.05a.996.996 0 11-1.41 1.41l-.03-.03L13 9.19z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm0 2c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8z"
  })]
}));

/**
UiArrowUpLined icon

```jsx
import { UiArrowUpLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowUpLined />
```

 */
const UiArrowUpLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12.38 2.075a1 1 0 00-.76 0c-.12.05-.24.12-.33.21l-6 6a.996.996 0 101.41 1.41l4.3-4.29v15.59c0 .55.45 1 1 1s1-.45 1-1V5.405l4.29 4.29c.39.39 1.02.39 1.41 0 .2-.19.3-.45.3-.7 0-.25-.1-.51-.29-.71l-6-6c-.09-.09-.21-.16-.33-.21z"
  })
}));

/**
UiArrowUpLinedSmall icon

```jsx
import { UiArrowUpLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiArrowUpLinedSmall />
```

 */
const UiArrowUpLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M6.995 14V4.25L4.704 6.698a.997.997 0 11-1.411-1.41l4.003-4.002c.08-.09.2-.16.32-.21a1 1 0 01.76 0c.12.05.24.12.33.21l4.004 4.002c.19.2.29.45.29.71 0 .26-.1.51-.29.71a.997.997 0 01-1.411 0L8.997 4.25V14c0 .551-.45 1.001-1 1.001-.551 0-1.002-.45-1.002-1z"
  })
}));

/**
UiAspectRatioFilled icon

```jsx
import { UiAspectRatioFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiAspectRatioFilled />
```

 */
const UiAspectRatioFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM8 8H6v2c0 .6-.4 1-1 1s-1-.4-1-1V7c0-.6.4-1 1-1h3c.6 0 1 .4 1 1s-.4 1-1 1zm12 9c0 .6-.4 1-1 1h-3c-.6 0-1-.4-1-1s.4-1 1-1h2v-2c0-.6.4-1 1-1s1 .4 1 1v3z"
  })
}));

/**
UiAspectRatioFilledSmall icon

```jsx
import { UiAspectRatioFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiAspectRatioFilledSmall />
```

 */
const UiAspectRatioFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14 1H2c-.6 0-1 .4-1 1v12c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zM6.5 5H5v1.5c0 .6-.4 1-1 1s-1-.4-1-1V4c0-.6.4-1 1-1h2.5c.6 0 1 .4 1 1s-.4 1-1 1zm6.5 7c0 .6-.4 1-1 1H9.5c-.6 0-1-.4-1-1s.4-1 1-1H11V9.5c0-.6.4-1 1-1s1 .4 1 1V12z"
  })
}));

/**
UiAspectRatioLined icon

```jsx
import { UiAspectRatioLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiAspectRatioLined />
```

 */
const UiAspectRatioLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9 7H6c-.6 0-1 .4-1 1v3c0 .6.4 1 1 1s1-.4 1-1V9h2c.6 0 1-.4 1-1s-.4-1-1-1zm8 6c0-.6.4-1 1-1s1 .4 1 1v3c0 .6-.4 1-1 1h-3c-.6 0-1-.4-1-1s.4-1 1-1h2v-2z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 18V6h16v12H4z"
  })]
}));

/**
UiAspectRatioLinedSmall icon

```jsx
import { UiAspectRatioLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiAspectRatioLinedSmall />
```

 */
const UiAspectRatioLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M5 8.5c.6 0 1-.4 1-1V6h1.5c.6 0 1-.4 1-1s-.4-1-1-1H5c-.6 0-1 .4-1 1v2.5c0 .6.4 1 1 1zM8.5 12c-.6 0-1-.4-1-1s.4-1 1-1H10V8.5c0-.6.4-1 1-1s1 .4 1 1V11c0 .6-.4 1-1 1H8.5z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 1H2c-.6 0-1 .4-1 1v12c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zm-1 12H3V3h10v10z"
  })]
}));

/**
UiAtmFilled icon

```jsx
import { UiAtmFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiAtmFilled />
```

 */
const UiAtmFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2h14c2.2 0 4 1.8 4 4s-1.8 4-4 4v11c0 .6-.4 1-1 1H6c-.6 0-1-.4-1-1V10c-2.2 0-4-1.8-4-4s1.8-4 4-4zm14 5v1c1.1 0 2-.9 2-2s-.9-2-2-2H5c-1.1 0-2 .9-2 2s.9 2 2 2V7c-.6 0-1-.4-1-1s.4-1 1-1h14c.6 0 1 .4 1 1s-.4 1-1 1zm-7 12c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1zm-.415-8.343c.3-.878 1.01-1.407 1.942-1.407 1.181 0 1.862.858 1.952 1.746h.02c.41 0 .751.34.751.749s-.34.748-.75.748h-.161c-.17.649-.41 1.068-.45 1.138a.751.751 0 01-1.292-.769s.01-.01.02-.03c.08-.14.38-.768.38-1.576 0-.08-.02-.5-.49-.5-.2 0-.4.03-.53.42l-.381.978-.17.439C12.045 13.751 11.153 14 10.482 14c-.99 0-1.632-.688-1.872-1.497H8.5a.756.756 0 01-.751-.748c0-.41.34-.749.75-.749H8.6c.156-.649.481-1.1.546-1.19l.005-.007a.75.75 0 011.05-.15c.321.24.391.679.171 1.008-.005.005-.007.01-.01.015a.044.044 0 01-.01.015l-.009.014c-.055.085-.341.53-.341 1.034 0 .01.01.748.49.748.34 0 .42-.09.53-.419l.311-.778.25-.639z"
  })
}));

/**
UiAtmFilledSmall icon

```jsx
import { UiAtmFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiAtmFilledSmall />
```

 */
const UiAtmFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 0h14c.6 0 1 .4 1 1v5c0 .6-.4 1-1 1h-2v8c0 .6-.4 1-1 1H4c-.6 0-1-.4-1-1V7H1c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1zm7 12c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zm5-7h1V2H2v3h1V3h10v2zM7.585 6.657c.3-.878 1.01-1.407 1.942-1.407 1.181 0 1.862.858 1.952 1.746h.02c.41 0 .751.34.751.749s-.34.748-.75.748h-.161c-.17.649-.41 1.068-.45 1.138a.751.751 0 01-1.292-.769s.01-.01.02-.03c.08-.14.38-.768.38-1.576 0-.08-.02-.5-.49-.5-.2 0-.4.03-.53.42l-.381.978-.17.439C8.044 9.751 7.153 10 6.482 10c-.99 0-1.632-.689-1.872-1.497H4.5a.756.756 0 01-.751-.748c0-.41.34-.749.75-.749H4.6c.156-.649.481-1.1.546-1.19l.005-.007a.75.75 0 011.05-.15c.321.24.391.679.171 1.008-.005.005-.007.01-.01.015a.052.052 0 01-.01.015l-.009.014c-.055.085-.341.53-.341 1.034 0 .01.01.748.49.748.34 0 .42-.09.53-.419l.311-.778.25-.639z"
  })
}));

/**
UiAtmLined icon

```jsx
import { UiAtmLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiAtmLined />
```

 */
const UiAtmLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M13 17.5a1 1 0 11-2 0 1 1 0 012 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 2H5C2.8 2 1 3.8 1 6s1.8 4 4 4v11c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V10c2.2 0 4-1.8 4-4s-1.8-4-4-4zm0 6V7c.6 0 1-.4 1-1s-.4-1-1-1H5c-.6 0-1 .4-1 1s.4 1 1 1v1c-1.1 0-2-.9-2-2s.9-2 2-2h14c1.1 0 2 .9 2 2s-.9 2-2 2zM7 20V7h10v13H7z"
  }), /*#__PURE__*/jsx("path", {
    d: "M13.527 9.25c-.931 0-1.642.529-1.942 1.407l-.25.639-.311.778c-.11.33-.19.42-.53.42-.481 0-.491-.74-.491-.75 0-.548.34-1.027.35-1.047.01-.01.01-.02.02-.03a.738.738 0 00-.17-1.008.753.753 0 00-1.051.15c-.05.07-.39.529-.551 1.197h-.1c-.41 0-.751.34-.751.749s.34.748.75.748h.111c.24.808.881 1.497 1.872 1.497.671 0 1.562-.25 1.942-1.407l.17-.44.381-.977c.13-.39.33-.42.53-.42.471 0 .491.42.491.5 0 .808-.3 1.437-.38 1.576-.01.02-.02.03-.02.03a.751.751 0 001.292.768c.04-.07.28-.488.45-1.137h.16c.41 0 .751-.34.751-.748 0-.41-.34-.749-.75-.749h-.02c-.091-.888-.772-1.746-1.953-1.746z"
  })]
}));

/**
UiAtmUkFilled icon

```jsx
import { UiAtmUkFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiAtmUkFilled />
```

 */
const UiAtmUkFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M19 2H5C2.8 2 1 3.8 1 6s1.8 4 4 4v11c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V10c2.2 0 4-1.8 4-4s-1.8-4-4-4zm0 6V7c.6 0 1-.4 1-1s-.4-1-1-1H5c-.6 0-1 .4-1 1s.4 1 1 1v1c-1.1 0-2-.9-2-2s.9-2 2-2h14c1.1 0 2 .9 2 2s-.9 2-2 2zm-3 1.7v4.8c0 .4-.3.7-.7.8-.4 0-.7-.2-.8-.6 0 0-.1-.4-.4-.7-.2-.2-.5-.2-.8-.3h-.9v.5c0 .4-.3.8-.8.8s-.6-.4-.6-.8v-.5h-.5c-.5 0-1-.2-1.4-.5-.6-.4-.8-1-.9-1.2-.2-.5-.2-1.2-.1-1.4 0 0 .075-.35.1-.4.1-.2.3-.6.7-.9.3-.3.8-.2 1.1.1.3.3.2.8-.1 1.1-.2.1-.3.2-.3.2s-.1.085-.1.2c0 .1-.1.4 0 .6 0 0 .1.3.4.5.2.1.4.2.6.2h.5V11c0-.4.3-.8.8-.8.4 0 .8.3.8.8v1.2c.2 0 .7 0 1.1.1.3 0 .6.1.9.2V9.8c0-.4.3-.8.7-.8.4 0 .7.3.7.7zM11 18c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1-1-.4-1-1z"
  })
}));

/**
UiAtmUkFilledSmall icon

```jsx
import { UiAtmUkFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiAtmUkFilledSmall />
```

 */
const UiAtmUkFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M15 0H1C.4 0 0 .4 0 1v5c0 .6.4 1 1 1h2v8c0 .6.4 1 1 1h8c.6 0 1-.4 1-1V7h2c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zM7 14c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1-1-.4-1-1zm5-4.2c0 .4-.3.7-.6.7h-.1c-.3 0-.6-.2-.7-.5 0 0-.5-1-1.5-1H9v.8c0 .4-.25.8-.75.8s-.85-.3-.85-.8V9H6.2C5 9 4 8 4 6.8c0-.8.4-1.6 1.1-2 .4-.2.8-.1 1 .3.2.4.1.8-.3 1-.2.1-.3.4-.3.7 0 .4.3.8.8.8h1.2v-.8c0-.5.35-.8.75-.8s.75.3.75.8v.8h.1c.6 0 1 .1 1.4.4V5.8c0-.4.25-.8.75-.8s.75.3.75.8v4zM14 5h-1V3H3v2H2V2h12v3z"
  })
}));

/**
UiAtmUkLined icon

```jsx
import { UiAtmUkLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiAtmUkLined />
```

 */
const UiAtmUkLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12 18.5a1 1 0 100-2 1 1 0 000 2zM15.2 9c.5 0 .8.3.8.8v4.7c0 .4-.2.8-.6.8-.4.1-.6-.2-.7-.6 0 0-.1-.4-.4-.7-.2-.2-.5-.3-.8-.3h-.9v.5c0 .5-.4.8-.8.8-.5 0-.8-.4-.8-.8v-.5h-.5c-.5 0-1-.2-1.4-.5-.517-.345-.737-.838-.852-1.096L8.2 12c-.2-.5-.2-1.2-.1-1.4 0-.05.025-.125.05-.2a.773.773 0 00.05-.2c.1-.2.3-.6.7-.9.3-.3.8-.2 1.1.1.2.3.2.8-.1 1-.1.1-.2.2-.2.3-.1.1-.1.2-.1.2 0 .026-.007.067-.015.115-.024.136-.059.338.015.485 0 .1.1.3.3.5.2.1.4.2.6.2h.5V11c0-.4.3-.8.7-.8.5 0 .8.4.8.8v1.3c.2 0 .7 0 1.1.1.2 0 .6.1.9.2V9.8c0-.5.3-.8.7-.8z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 2H5C2.8 2 1 3.8 1 6s1.8 4 4 4v11c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V10c2.2 0 4-1.8 4-4s-1.8-4-4-4zm0 6V7c.6 0 1-.4 1-1s-.4-1-1-1H5c-.6 0-1 .4-1 1s.4 1 1 1v1c-1.1 0-2-.9-2-2s.9-2 2-2h14c1.1 0 2 .9 2 2s-.9 2-2 2zM7 20V7h10v13H7z"
  })]
}));

/**
UiAttachLined icon

```jsx
import { UiAttachLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiAttachLined />
```

 */
const UiAttachLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20.565 4.43c-2.24-2.24-5.89-2.24-8.14 0l-9.43 9.56a4.249 4.249 0 000 6.01 4.249 4.249 0 006.01-.01l9.44-9.56c.52-.52.81-1.21.81-1.94a2.753 2.753 0 00-4.7-1.93l-7 7.08c-.29.29-.29.77.01 1.06.3.29.77.29 1.06-.01l7-7.08c.24-.24.55-.37.88-.37.69.01 1.25.57 1.25 1.26 0 .33-.13.65-.37.89l-9.44 9.56a2.758 2.758 0 01-3.89 0 2.758 2.758 0 010-3.89l9.43-9.56a4.249 4.249 0 116 6.02l-7.41 7.59c-.29.3-.28.77.01 1.06.3.29.77.28 1.06-.01l7.4-7.58c2.27-2.26 2.27-5.91.02-8.15z"
  })
}));

/**
UiAttachLinedSmall icon

```jsx
import { UiAttachLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiAttachLinedSmall />
```

 */
const UiAttachLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-attach-lined-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M3.3 15c-.8 0-1.7-.3-2.3-.9-1.3-1.3-1.3-3.3 0-4.6l7.3-7.2c1.8-1.7 4.6-1.7 6.4 0 1.8 1.7 1.8 4.6 0 6.3L9.3 14c-.3.3-.8.3-1.1 0-.3-.3-.3-.8 0-1.1l5.4-5.3c1.2-1.2 1.2-3 0-4.2-1.2-1.2-3.1-1.2-4.3 0L2 10.5c-.7.7-.7 1.8 0 2.5s1.8.7 2.5 0l7.1-7c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0l-4.8 4.8c-.3.2-.8.2-1.1 0-.3-.3-.3-.8 0-1.1l4.8-4.8c.8-.8 2.1-.8 2.9 0 .8.8.8 2 0 2.8l-7.1 7c-.6.7-1.5 1-2.3 1z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-attach-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiAutopayLined icon

```jsx
import { UiAutopayLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiAutopayLined />
```

 */
const UiAutopayLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M21 4c-.6 0-1 .4-1 1v1.5c-.7-1.1-1.6-2-2.7-2.8-1.7-1.2-3.9-1.9-6-1.7-2.1.2-4.2 1-5.8 2.4-1.6 1.4-2.8 3.3-3.2 5.4-.2.5.2 1.1.7 1.2.5.1 1.1-.2 1.2-.8.4-1.6 1.3-3.2 2.6-4.3C8.1 4.8 9.7 4.1 11.4 4c1.7-.1 3.3.4 4.7 1.4 1 .7 1.8 1.6 2.6 2.6H17c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M14.7 13.358c0-1.099-.774-1.75-1.455-1.973l-1.413-.55c-.371-.152-.485-.233-.485-.559 0-.478.702-.488.774-.488.577 0 1.073.346 1.083.356a.781.781 0 001.083-.152.756.756 0 00-.155-1.068l-.007-.005a3.591 3.591 0 00-1.23-.555v-.101a.774.774 0 00-1.548 0v.112c-.928.264-1.547.976-1.547 1.912 0 1.362 1.042 1.8 1.454 1.972l1.465.57c.196.06.433.213.433.539 0 .478-.433.498-.515.498-.96 0-1.661-.396-1.661-.396a.78.78 0 00-1.063.264.755.755 0 00.268 1.047c.073.041.506.285 1.177.458v.163a.774.774 0 001.547 0v-.02c.908-.133 1.795-.824 1.795-2.024z"
  }), /*#__PURE__*/jsx("path", {
    d: "M19.8 13.8c.1-.6.7-.9 1.2-.8.5.2.9.7.8 1.2-.4 2.1-1.6 4-3.2 5.4-1.6 1.4-3.7 2.3-5.8 2.4-2.2.2-4.4-.5-6.1-1.7-1.1-.8-2-1.7-2.7-2.8V19c0 .6-.4 1-1 1s-1-.4-1-1v-4c0-.6.4-1 1-1h4c.6 0 1 .4 1 1s-.4 1-1 1H5.3c.8 1 1.6 1.9 2.6 2.6 1.4 1 3 1.5 4.7 1.4 1.7-.1 3.3-.8 4.6-1.9 1.3-1.1 2.2-2.6 2.6-4.3z"
  })]
}));

/**
UiAutopayUkLined icon

```jsx
import { UiAutopayUkLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiAutopayUkLined />
```

 */
const UiAutopayUkLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M21 4c-.6 0-1 .4-1 1v1.5c-.7-1.1-1.6-2-2.7-2.8-1.7-1.2-3.9-1.9-6-1.7-2.1.2-4.2 1-5.8 2.4-1.6 1.4-2.8 3.3-3.2 5.4-.2.5.2 1.1.7 1.2.5.1 1.1-.2 1.2-.8.4-1.6 1.3-3.2 2.6-4.3C8.1 4.8 9.7 4.1 11.4 4c1.7-.1 3.3.4 4.7 1.4 1 .7 1.8 1.6 2.6 2.6H17c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M10 13h.8v.1c0 1-1 1.5-1 1.5-.4.1-.6.4-.5.8 0 .3.3.6.7.6h4c.4 0 .8-.3.8-.8s-.4-.7-.8-.7h-2.1c.2-.4.4-.9.4-1.4V13h.7c.4 0 .8-.3.8-.8s-.4-.7-.8-.7h-.8v-1.3c0-.4.3-.8.8-.8.3 0 .5.1.7.4.2.4.7.5 1 .3.3-.1.5-.6.3-1-.4-.7-1.2-1.1-2-1.1-1.2 0-2.2 1-2.2 2.2v1.2H10c-.4 0-.8.3-.8.8s.4.8.8.8z"
  }), /*#__PURE__*/jsx("path", {
    d: "M19.8 13.8c.1-.6.7-.9 1.2-.8.5.2.9.7.8 1.2-.4 2.1-1.6 4-3.2 5.4-1.6 1.4-3.7 2.3-5.8 2.4-2.2.2-4.4-.5-6.1-1.7-1.1-.8-2-1.7-2.7-2.8V19c0 .6-.4 1-1 1s-1-.4-1-1v-4c0-.6.4-1 1-1h4c.6 0 1 .4 1 1s-.4 1-1 1H5.3c.8 1 1.6 1.9 2.6 2.6 1.4 1 3 1.5 4.7 1.4 1.7-.1 3.3-.8 4.6-1.9 1.3-1.1 2.2-2.6 2.6-4.3z"
  })]
}));

/**
UiBacklogLined icon

```jsx
import { UiBacklogLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBacklogLined />
```

 */
const UiBacklogLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20a8 8 0 100-16 8 8 0 000 16zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
  })
}));

/**
UiBacklogLinedSmall icon

```jsx
import { UiBacklogLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBacklogLinedSmall />
```

 */
const UiBacklogLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14A6 6 0 108 2a6 6 0 000 12zm0 2A8 8 0 108 0a8 8 0 000 16z"
  })
}));

/**
UiBankC1Filled icon

```jsx
import { UiBankC1Filled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBankC1Filled />
```

 */
const UiBankC1Filled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12.006 10.02c-2.23 0-4 .11-4 .11v.86s3.85.11 3.85 1.76-3.85 3.73-3.85 3.73v.54c1.63 0 8-2.81 8-5.19 0-1.55-2.4-1.81-4-1.81z"
  }), /*#__PURE__*/jsx("path", {
    d: "M21.896 20.55l-1-2a.988.988 0 00-.89-.55V9h.5c.38 0 .72-.21.89-.55l.5-1a.996.996 0 00-.41-1.32l-9-5a.986.986 0 00-.97 0l-9 5c-.47.26-.65.84-.41 1.32l.5 1c.18.34.52.55.9.55h.5v9c-.38 0-.72.21-.89.55l-1 2c-.16.31-.14.68.04.97.18.3.5.48.85.48h18c.35 0 .67-.18.85-.47.18-.3.2-.67.04-.98zM6.006 9h12v9h-12V9z"
  })]
}));

/**
UiBankC1FilledSmall icon

```jsx
import { UiBankC1FilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBankC1FilledSmall />
```

 */
const UiBankC1FilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M15.885 14.6l-.5-1c-.199-.3-.498-.6-.897-.6h-.5V6h.5c.399 0 .698-.2.898-.6l.499-1c.1-.2.1-.5 0-.8-.1-.3-.3-.5-.5-.6L8.4 0c-.3 0-.499 0-.798.1l-6.987 3c-.2.1-.399.3-.499.6-.1.2-.1.5 0 .7l.5 1c.199.4.498.6.898.6h.499v7h-.5c-.399 0-.698.2-.898.6l-.499 1c-.2.3-.1.7 0 1 .1.3.6.4.899.4h13.973c.299 0 .698-.2.898-.5.1-.3.2-.6 0-.9zM4.008 6h7.984v7H4.008V6z"
  }), /*#__PURE__*/jsx("path", {
    d: "M8 7c-1.697 0-2.994.1-2.994.1v.6S7.9 7.8 7.9 9s-2.894 2.7-2.894 2.7v.3c1.197 0 5.988-2 5.988-3.7C10.994 7.2 9.198 7 8 7z"
  })]
}));

/**
UiBankC1Lined icon

```jsx
import { UiBankC1Lined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBankC1Lined />
```

 */
const UiBankC1Lined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M20.95 17.68c-.14-.4-.52-.68-.95-.68V9h.5c.38 0 .72-.21.89-.55l.5-1a.996.996 0 00-.41-1.32l-8.997-5a.986.986 0 00-.97 0l-8.997 5c-.47.26-.65.84-.41 1.32l.5 1c.18.34.52.55.9.55h.5v8c-.43 0-.81.28-.95.68l-1 3a1 1 0 00.14.9c.19.27.49.42.81.42H21c.32 0 .62-.15.81-.42a1 1 0 00.14-.9l-1-3zM18 17H6.006V9H18v8zM12.004 3.14L18.94 7H5.065l6.938-3.86zM4.395 20l.33-1h14.556l.33 1H4.394z"
  }), /*#__PURE__*/jsx("path", {
    d: "M11.853 12.55c0 1.53-3.849 3.45-3.849 3.45v.5c1.63 0 7.998-2.61 7.998-4.8 0-1.43-2.4-1.68-4-1.68-2.228 0-3.998.1-3.998.1v.8s3.849.1 3.849 1.63z"
  })]
}));

/**
UiBankFilled icon

```jsx
import { UiBankFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBankFilled />
```

 */
const UiBankFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M21.896 20.547l-1-2a.977.977 0 00-.89-.55v-9h.5c.38 0 .73-.21.89-.55l.5-1a.996.996 0 00-.41-1.32l-9-5a.986.986 0 00-.97 0l-9 5c-.47.26-.65.84-.41 1.32l.5 1c.17.34.52.55.9.55h.5v9c-.38 0-.73.21-.89.55l-1 2c-.15.31-.14.68.04.97.18.29.5.48.85.48h18c.35 0 .67-.18.85-.47.18-.29.2-.67.04-.98zm-11.39-11.55h3v9h-3v-9zm7.5 9h-2.5v-9h2.5v9zm-12-9h2.5v9h-2.5v-9z"
  })
}));

/**
UiBankFilledSmall icon

```jsx
import { UiBankFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBankFilledSmall />
```

 */
const UiBankFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M15.885 14.6l-.5-1c-.199-.3-.498-.6-.897-.6h-.5V6h.5c.399 0 .698-.2.898-.6l.499-1c.1-.2.1-.5 0-.8-.1-.3-.3-.5-.5-.6L8.4 0c-.3 0-.499 0-.798.1l-6.987 3c-.2.1-.399.3-.499.6-.1.2-.1.5 0 .7l.5 1c.199.4.498.6.898.6h.499v7h-.5c-.399 0-.698.2-.898.6l-.499 1c-.2.3-.1.7 0 1 .2.2.6.4.899.4h13.973c.299 0 .698-.2.898-.5.1-.3.2-.6 0-.9zM8.998 6v7H7.002V6h1.996zm2.994 7h-1.497V6h1.497v7zM4.008 6h1.497v7H4.008V6z"
  })
}));

/**
UiBankLined icon

```jsx
import { UiBankLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBankLined />
```

 */
const UiBankLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20.95 17.677c-.14-.4-.52-.68-.95-.68v-8h.5c.38 0 .72-.21.89-.55l.5-1a.996.996 0 00-.41-1.32l-8.997-5a.986.986 0 00-.97 0l-8.997 5c-.47.26-.65.84-.41 1.32l.5 1c.17.34.52.55.9.55h.5v8c-.43 0-.81.28-.95.68l-1 3a1.009 1.009 0 00.95 1.32H21c.32 0 .62-.15.81-.42a1 1 0 00.14-.9l-1-3zm-2.95-.68h-2.498v-8H18v8zm-7.497-8h3v8h-3v-8zm1.5-5.86l6.938 3.86H5.065l6.938-3.86zm-5.998 5.86h2.499v8h-2.5v-8zm-1.61 11l.33-1h14.556l.33 1H4.394z"
  })
}));

/**
UiBasicsFilled icon

```jsx
import { UiBasicsFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBasicsFilled />
```

 */
const UiBasicsFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M5 2v1c-1.1 0-2 .9-2 2v4a1 1 0 001 1h16a1 1 0 001-1V5c0-1.1-.9-2-2-2V2c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v1h-4V2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1zm18 20a1 1 0 01-1 1H2a1 1 0 01-1-1v-4c0-1.1.9-2 2-2v-1c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1h1.5v-1c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1H16v-1c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1c1.1 0 2 .9 2 2v4z"
  })
}));

/**
UiBasicsFilledSmall icon

```jsx
import { UiBasicsFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBasicsFilledSmall />
```

 */
const UiBasicsFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-basics-filled-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M3 .98v.51H2c-.55 0-1 .45-1 1v3a1 1 0 001 1h12a1 1 0 001-1v-3c0-.55-.45-1-1-1h-1V.98c0-.55-.45-1-1-1h-1.5c-.55 0-1 .45-1 1v.51h-3V.98c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1zm13 14.01a1 1 0 01-1 1H1a1 1 0 01-1-1v-3c0-.55.45-1 1-1v-.51c0-.55.45-1 1-1h1.5c.55 0 1 .45 1 1v.51h1.75v-.51c0-.55.45-1 1-1h1.5c.55 0 1 .45 1 1v.51h1.75v-.51c0-.55.45-1 1-1H14c.55 0 1 .45 1 1v.51c.55 0 1 .45 1 1v3z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-basics-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiBatteryFilled icon

```jsx
import { UiBatteryFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBatteryFilled />
```

 */
const UiBatteryFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M10 4a1 1 0 00-1-1H6a1 1 0 00-1 1v1h5V4zm9 0a1 1 0 00-1-1h-3a1 1 0 00-1 1v1h5V4zm2 2H3a2 2 0 00-2 2v11a2 2 0 002 2h18a2 2 0 002-2V8a2 2 0 00-2-2zM9.5 14h-4a.5.5 0 010-1h4a.5.5 0 010 1zm9 0H17v1.5a.5.5 0 01-1 0V14h-1.5a.5.5 0 010-1H16v-1.5a.5.5 0 011 0V13h1.5a.5.5 0 010 1z"
  })
}));

/**
UiBatteryFilledSmall icon

```jsx
import { UiBatteryFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBatteryFilledSmall />
```

 */
const UiBatteryFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-battery-filled-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M14 3h-1a1 1 0 00-1-1h-2a1 1 0 00-1 1H7a1 1 0 00-1-1H4a1 1 0 00-1 1H2a2 2 0 00-2 2v7a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2zM6.5 9h-2a.5.5 0 110-1h2a.5.5 0 110 1zm5 0H11v.5a.5.5 0 01-1 0V9h-.5a.5.5 0 110-1h.5v-.5a.5.5 0 011 0V8h.5a.5.5 0 010 1z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-battery-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiBatteryLined icon

```jsx
import { UiBatteryLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBatteryLined />
```

 */
const UiBatteryLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M21 6H3a2 2 0 00-2 2v11a2 2 0 002 2h18a2 2 0 002-2V8a2 2 0 00-2-2zM3 19V8h18v11H3zm7-15a1 1 0 00-1-1H6a1 1 0 00-1 1v1h5V4zm9 0a1 1 0 00-1-1h-3a1 1 0 00-1 1v1h5V4z"
  }), /*#__PURE__*/jsx("path", {
    d: "M9.5 13h-4a.5.5 0 000 1h4a.5.5 0 000-1zm9 0H17v-1.5a.5.5 0 00-1 0V13h-1.5a.5.5 0 000 1H16v1.5a.5.5 0 001 0V14h1.5a.5.5 0 000-1z"
  })]
}));

/**
UiBatteryLinedSmall icon

```jsx
import { UiBatteryLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBatteryLinedSmall />
```

 */
const UiBatteryLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M14 3h-1a1 1 0 00-1-1h-2a1 1 0 00-1 1H7a1 1 0 00-1-1H4a1 1 0 00-1 1H2a2 2 0 00-2 2v7a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2zM2 12V5h12v7H2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M6.5 8h-2a.5.5 0 100 1h2a.5.5 0 100-1zm5 0H11v-.5a.5.5 0 00-1 0V8h-.5a.5.5 0 100 1h.5v.5a.5.5 0 001 0V9h.5a.5.5 0 000-1z"
  })]
}));

/**
UiBellFilled icon

```jsx
import { UiBellFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBellFilled />
```

 */
const UiBellFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.108 4.736c.017.092.028.185.035.278a6.05 6.05 0 012.006.49l.01.004a6.62 6.62 0 013.412 3.521c.057.132.087.206.112.278l.01.03.022.059a3.21 3.21 0 002.094 1.715l.057.015.055.021a3.36 3.36 0 011.922 1.922 2.5 2.5 0 01-1.418 3.232l-.005.002-4.914 1.894c.16.399.245.828.244 1.265v.039A3.65 3.65 0 0112 23a3.65 3.65 0 01-3.451-2.198l-.055.021-.256.067-.017.004a2.49 2.49 0 01-2.875-1.537v-.002a3.38 3.38 0 01.156-2.755l.023-.045.028-.043a3.26 3.26 0 00.418-2.632l-.046-.116-.101-.281-.005-.015a6.66 6.66 0 011.42-6.556 2.75 2.75 0 114.87-2.177zm-2.982-.222a.75.75 0 011.024.7 6.47 6.47 0 00-1.305.502.75.75 0 01.28-1.202zm1.3 15.585l3.206-1.199c.075.169.116.352.118.54A1.65 1.65 0 0112.039 21h-.078a1.65 1.65 0 01-1.535-.901z"
  })
}));

/**
UiBellFilledSmall icon

```jsx
import { UiBellFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBellFilledSmall />
```

 */
const UiBellFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-bell-filled-small-a)",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.673 3.395a2.094 2.094 0 01.063-2.247c.23-.337.553-.6.932-.752A2.017 2.017 0 016.9.894c.27.287.45.645.524 1.031a4.665 4.665 0 011.616.395l.01.005a5.203 5.203 0 012.65 2.79c.043.102.067.163.088.224l.008.025.01.026c.133.281.324.528.558.725.24.203.518.347.816.426l.058.015.056.022c.358.141.682.357.951.632.269.275.477.603.614.962a2.155 2.155 0 01-.034 1.614 2.12 2.12 0 01-1.157 1.134l-.006.003-3.409 1.342c.08.264.12.539.12.817v.02l-.002.018a3.02 3.02 0 01-.94 2.076 2.934 2.934 0 01-2.09.803 2.934 2.934 0 01-2.091-.803 2.995 2.995 0 01-.604-.803l-.018.005-.018.004a2.08 2.08 0 01-1.467-.202 2.118 2.118 0 01-.965-1.116v-.002a2.833 2.833 0 01.125-2.265l.023-.045.027-.042a2.286 2.286 0 00.283-1.79l-.03-.08-.078-.219-.005-.014a5.364 5.364 0 01-.096-2.908c.214-.87.643-1.67 1.245-2.324zm1.554-1.607a.517.517 0 01.58.132.574.574 0 01.108.165 4.989 4.989 0 00-1.016.395.599.599 0 01.08-.49.548.548 0 01.248-.202zM6.564 13.68a.933.933 0 00.738.32l.04-.002.039.001c.246.01.49-.08.678-.257a1.02 1.02 0 00.314-.682.826.826 0 00-.004-.07l-1.805.69z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-bell-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiBellLined icon

```jsx
import { UiBellLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBellLined />
```

 */
const UiBellLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.092 6.708c.046.07.096.14.148.205a6.66 6.66 0 00-1.42 6.556l.004.015.101.281.046.116a3.26 3.26 0 01-.418 2.632l-.028.043-.023.045a3.38 3.38 0 00-.156 2.755v.002a2.49 2.49 0 002.875 1.537l.017-.003.256-.068.055-.02A3.65 3.65 0 0012 23a3.65 3.65 0 003.75-3.5v-.04a3.37 3.37 0 00-.244-1.264l4.914-1.894.005-.002a2.5 2.5 0 001.418-3.232 3.36 3.36 0 00-1.922-1.922l-.055-.02-.057-.016a3.21 3.21 0 01-2.094-1.715 1.137 1.137 0 01-.021-.058l-.01-.03a3.821 3.821 0 00-.113-.279 6.62 6.62 0 00-3.411-3.521l-.01-.005a6.05 6.05 0 00-2.007-.49 2.748 2.748 0 00-2.154-2.487 2.75 2.75 0 00-2.897 4.182zm2.469-2.229a.75.75 0 00-.716 1.237 6.472 6.472 0 011.305-.501.742.742 0 00-.209-.522.75.75 0 00-.38-.214zM13.632 18.9l-3.206 1.2a1.652 1.652 0 001.535.902l.04-.002.038.002a1.65 1.65 0 001.711-1.562 1.37 1.37 0 00-.118-.539zM11.753 7a4.47 4.47 0 00-2.841 1.061 4.66 4.66 0 00-1.195 4.776l.078.218.073.181.014.05a5.26 5.26 0 01-.622 4.27 1.38 1.38 0 00-.046 1.087.49.49 0 00.553.304l.12-.031 1.523-.573 5.105-1.908 5.182-1.997a.5.5 0 00.281-.646v-.001a1.36 1.36 0 00-.734-.76 5.208 5.208 0 01-3.348-2.804l-.011-.023-.01-.023a2.747 2.747 0 01-.072-.192l-.006-.016v-.001a2.089 2.089 0 00-.062-.15l-.005-.011-.005-.013a4.62 4.62 0 00-2.38-2.463A4.05 4.05 0 0011.754 7z"
  })
}));

/**
UiBellLinedSmall icon

```jsx
import { UiBellLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBellLinedSmall />
```

 */
const UiBellLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-bell-lined-small-a)",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.673 3.395a2.094 2.094 0 01.063-2.247c.23-.337.553-.6.932-.752A2.017 2.017 0 016.9.894c.27.287.45.645.524 1.031a4.665 4.665 0 011.616.395l.01.005a5.203 5.203 0 012.65 2.79c.043.102.067.163.088.224l.008.025.01.026c.133.281.324.528.558.725.24.203.518.347.816.426l.058.015.056.022c.358.141.682.357.951.632.269.275.477.603.614.962a2.155 2.155 0 01-.034 1.614 2.12 2.12 0 01-1.157 1.134l-.006.003-3.409 1.342c.08.264.12.539.12.817v.02l-.002.018a3.02 3.02 0 01-.94 2.076 2.934 2.934 0 01-2.09.803 2.934 2.934 0 01-2.091-.803 2.995 2.995 0 01-.604-.803l-.018.005-.018.004a2.08 2.08 0 01-1.467-.202 2.118 2.118 0 01-.965-1.116v-.002a2.833 2.833 0 01.125-2.265l.023-.045.027-.042a2.286 2.286 0 00.283-1.79l-.03-.08-.078-.219-.005-.014a5.364 5.364 0 01-.096-2.908c.214-.87.643-1.67 1.245-2.324zm1.554-1.607a.517.517 0 01.58.132.574.574 0 01.108.165 4.989 4.989 0 00-1.016.395.599.599 0 01.08-.49.548.548 0 01.248-.202zm1.397 11.954a.964.964 0 01-.06-.062l1.805-.69a.826.826 0 01.004.07 1.02 1.02 0 01-.314.682.933.933 0 01-.678.257l-.04-.001-.039.001a.933.933 0 01-.678-.257zm6.302-4.679L9.1 10.57l-3.77 1.44-1.114.428-.063.017a.08.08 0 01-.05-.01.118.118 0 01-.051-.062.833.833 0 01.02-.63 4.285 4.285 0 00.478-3.397l-.012-.048-.057-.144-.055-.157a3.364 3.364 0 01-.056-1.81 3.3 3.3 0 01.873-1.55 2.99 2.99 0 011.917-.73c.365.002.726.08 1.063.228a3.204 3.204 0 011.626 1.726l.004.012.006.012c.033.077.039.094.04.097l.006.018a2.817 2.817 0 00.055.15l.01.023.01.023a4.17 4.17 0 001.095 1.438c.445.376.965.653 1.524.81a.786.786 0 01.39.426l.001.003a.155.155 0 01-.002.115.12.12 0 01-.062.065z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-bell-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiBillFilled icon

```jsx
import { UiBillFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBillFilled />
```

 */
const UiBillFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2h14c.6 0 1 .4 1 1v18c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1zm2.5 17h6c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-6c-.3 0-.5.2-.5.5s.2.5.5.5zm0-2h9c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-9c-.3 0-.5.2-.5.5s.2.5.5.5zm5.6-8.42c.88.3 1.41 1.01 1.41 1.94 0 1.18-.86 1.86-1.75 1.95v.02c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-.16a4.76 4.76 0 01-1.14-.45.751.751 0 11.8-1.27c.14.08.77.38 1.58.38.08 0 .5-.02.5-.49 0-.2-.03-.4-.42-.53l-.98-.38-.44-.17C10 9.04 9.75 8.15 9.75 7.48c0-.99.69-1.63 1.5-1.87V5.5c0-.41.34-.75.75-.75s.75.34.75.75v.1c.65.155 1.103.48 1.193.545l.007.005c.33.25.4.72.15 1.05a.741.741 0 01-1.025.16c-.005-.003-.01-.005-.015-.01l-.014-.009C12.96 7.286 12.515 7 12.01 7c-.01 0-.75.01-.75.49 0 .34.09.42.42.53l.78.31.64.25z"
  })
}));

/**
UiBillFilledSmall icon

```jsx
import { UiBillFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBillFilledSmall />
```

 */
const UiBillFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M13 0H3c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM7.39 3.2V3c0-.28.22-.5.5-.5s.5.22.5.5v.21c.6.13 1.03.42 1.09.47.22.17.27.48.1.7-.17.22-.48.26-.7.1-.01-.01-.46-.33-.99-.33-.08 0-.79.02-.79.56 0 .34.19.48.49.6l1.18.47c.29.13 1.12.51 1.12 1.53 0 .98-.76 1.52-1.5 1.56V9c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-.25c-.62-.14-1.02-.37-1.04-.39a.502.502 0 11.52-.86s.62.36 1.46.36c.02 0 .57-.01.57-.56 0-.31-.19-.46-.51-.61l-1.16-.46C6.3 5.86 6.11 5.2 6.11 4.7c0-.75.52-1.32 1.28-1.5zM9 13.59c0 .23-.18.41-.41.41H4.41c-.23 0-.41-.18-.41-.41v-.18c0-.23.18-.41.41-.41h4.18c.23 0 .41.18.41.41v.18zM11.5 12h-7c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h7c.28 0 .5.22.5.5s-.22.5-.5.5z"
  })
}));

/**
UiBillLined icon

```jsx
import { UiBillLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBillLined />
```

 */
const UiBillLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M8.5 17h7c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-7c-.3 0-.5.2-.5.5s.2.5.5.5zm4 2h-4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4c.3 0 .5.2.5.5s-.2.5-.5.5z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2h14c.6 0 1 .4 1 1v18c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1zm1 18h12V4H6v16z"
  }), /*#__PURE__*/jsx("path", {
    d: "M14.51 11.52c0-.93-.53-1.64-1.41-1.94l-.64-.25-.78-.31c-.33-.11-.42-.19-.42-.53 0-.48.74-.49.75-.49.55 0 1.03.34 1.05.35.01.01.02.01.03.02.33.22.77.15 1.01-.17a.75.75 0 00-.15-1.05c-.07-.05-.53-.39-1.2-.55v-.1c0-.41-.34-.75-.75-.75s-.75.34-.75.75v.11c-.81.24-1.5.88-1.5 1.87 0 .67.25 1.56 1.41 1.94l.44.17.98.38c.39.13.42.33.42.53 0 .47-.42.49-.5.49-.81 0-1.44-.3-1.58-.38a.751.751 0 10-.8 1.27c.07.04.49.28 1.14.45v.16c0 .41.34.75.75.75s.75-.34.75-.75v-.02c.89-.09 1.75-.77 1.75-1.95z"
  })]
}));

/**
UiBillLinedSmall icon

```jsx
import { UiBillLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBillLinedSmall />
```

 */
const UiBillLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M10.5 11h-5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h5c.28 0 .5.22.5.5s-.22.5-.5.5zm-5.09 2h3.18c.23 0 .41-.18.41-.41v-.18c0-.23-.18-.41-.41-.41H5.41c-.23 0-.41.18-.41.41v.18c0 .23.18.41.41.41zm2.97-6.31l-1.16-.46C6.3 5.86 6.11 5.2 6.11 4.7c0-.75.52-1.32 1.28-1.5V3c0-.28.22-.5.5-.5s.5.22.5.5v.21a3.072 3.072 0 011.09.46c.22.17.27.48.1.7-.17.22-.48.26-.7.1-.01-.01-.46-.33-.99-.33-.08 0-.79.02-.79.56 0 .34.19.48.49.6l1.18.46.01.005c.31.144 1.11.517 1.11 1.525 0 .99-.76 1.53-1.5 1.56V9c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-.25c-.574-.141-.971-.353-1.033-.386L6.35 8.36a.502.502 0 01-.17-.69c.14-.23.45-.31.68-.17.01.01.62.36 1.46.36.02 0 .57 0 .57-.56 0-.32-.19-.46-.51-.61z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0h10c.55 0 1 .45 1 1v14c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1zm1 14h8V2H4v12z"
  })]
}));

/**
UiBillUkFilled icon

```jsx
import { UiBillUkFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBillUkFilled />
```

 */
const UiBillUkFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2h14c.6 0 1 .4 1 1v18c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1zm2.5 17h6c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-6c-.3 0-.5.2-.5.5s.2.5.5.5zm0-2h9c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-9c-.3 0-.5.2-.5.5s.2.5.5.5zm3.3-7H10c-.4 0-.8-.3-.8-.8s.4-.8.8-.8h.8V7.2C10.8 6 11.8 5 13 5c.8 0 1.6.4 2 1.1.2.4 0 .9-.3 1-.3.2-.8.1-1-.3-.2-.3-.4-.4-.7-.4-.5 0-.8.4-.8.8v1.3h.8c.4 0 .8.2.8.7 0 .5-.4.8-.8.8h-.7v.1c0 .5-.2 1-.4 1.4H14c.4 0 .8.2.8.7 0 .5-.4.8-.8.8h-4c-.4 0-.7-.3-.7-.6-.1-.4.1-.7.5-.8 0 0 1-.5 1-1.5V10z"
  })
}));

/**
UiBillUkFilledSmall icon

```jsx
import { UiBillUkFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBillUkFilledSmall />
```

 */
const UiBillUkFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M13 0H3c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM6.48 7c-.01 0 .2-.02.38-.26.14-.17.22-.43.28-.74H7c-.28 0-.5-.22-.5-.5S6.72 5 7 5h.17c-.01-.15-.02-.3-.04-.47-.1-.75.12-1.43.58-1.81.33-.27.94-.53 1.94-.2.26.09.4.37.32.63a.51.51 0 01-.63.32c-.31-.1-.74-.19-.99.02-.19.16-.28.51-.23.91.03.21.04.41.05.6H9c.28 0 .5.22.5.5S9.28 6 9 6h-.85c-.05.38-.14.72-.28 1h1.62c.28 0 .5.22.5.5s-.21.5-.49.5h-3a.5.5 0 01-.02-1zM9 13.59c0 .23-.18.41-.41.41H4.41c-.23 0-.41-.18-.41-.41v-.18c0-.23.18-.41.41-.41h4.18c.23 0 .41.18.41.41v.18zM11.5 12h-7c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h7c.28 0 .5.22.5.5s-.22.5-.5.5z"
  })
}));

/**
UiBillUkLined icon

```jsx
import { UiBillUkLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBillUkLined />
```

 */
const UiBillUkLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M10.8 11H10c-.4 0-.8-.3-.8-.8s.4-.8.8-.8h.8V8.2C10.8 7 11.8 6 13 6c.8 0 1.6.4 2 1.1.2.4 0 .9-.3 1-.3.2-.8.1-1-.3-.2-.3-.4-.4-.7-.4-.5 0-.8.4-.8.8v1.3h.8c.4 0 .8.2.8.7 0 .5-.4.8-.8.8h-.7v.1c0 .5-.2 1-.4 1.4H14c.4 0 .8.2.8.7 0 .5-.4.8-.8.8h-4c-.4 0-.7-.3-.7-.6-.1-.4.1-.7.5-.8 0 0 1-.5 1-1.5V11zm-2.3 6h7c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-7c-.3 0-.5.2-.5.5s.2.5.5.5zm4 2h-4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4c.3 0 .5.2.5.5s-.2.5-.5.5z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2h14c.6 0 1 .4 1 1v18c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1zm1 18h12V4H6v16z"
  })]
}));

/**
UiBillUkLinedSmall icon

```jsx
import { UiBillUkLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBillUkLinedSmall />
```

 */
const UiBillUkLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9.5 9h-3a.5.5 0 01-.02-1h.002c.024-.005.214-.041.378-.26.14-.17.23-.43.28-.74H7c-.28 0-.5-.22-.5-.5S6.72 6 7 6h.17a6.829 6.829 0 01-.008-.155c-.005-.1-.009-.203-.022-.315-.1-.75.11-1.42.58-1.81.33-.28.94-.53 1.94-.2.27.08.41.37.32.63-.09.27-.37.41-.63.32-.32-.1-.74-.19-.99.02-.2.16-.28.51-.23.91.029.204.04.4.049.585V6H9c.28 0 .5.22.5.5S9.28 7 9 7h-.84c-.05.38-.14.72-.28 1H9.5c.28 0 .5.22.5.5s-.22.5-.5.5zm-4 2h5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-5c-.28 0-.5.22-.5.5s.22.5.5.5zm3.09 2H5.41c-.23 0-.41-.18-.41-.41v-.18c0-.23.18-.41.41-.41h3.18c.23 0 .41.18.41.41v.18c0 .23-.18.41-.41.41z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0h10c.55 0 1 .45 1 1v14c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1zm1 14h8V2H4v12z"
  })]
}));

/**
UiBirthdayFilled icon

```jsx
import { UiBirthdayFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBirthdayFilled />
```

 */
const UiBirthdayFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M18.83 16.31c-.13-.14-.25-.28-.37-.41-.57-.64-.83-.9-1.46-.9-.81 0-1.08.24-1.57.68-.62.56-1.48 1.32-3.43 1.32-1.95 0-2.81-.76-3.43-1.32C8.08 15.24 7.81 15 7 15c-.63 0-.89.26-1.46.9-.12.14-.24.27-.37.41-.58.61-1.36.93-2.16.93H3V21c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-3.76h-.01c-.8 0-1.58-.32-2.16-.93zM12 6a2 2 0 002-2c0-1-.78-1.88-1.36-2.68a.786.786 0 00-1.27 0C10.78 2.12 10 3 10 4c0 1.11.89 2 2 2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M11 8v1H6c-2.21 0-4 1.79-4 4v1.24c0 .63.48.87.63.93.15.06.66.22 1.09-.24l.33-.36c.62-.7 1.4-1.58 2.95-1.58 1.58 0 2.31.66 2.9 1.19.53.47.91.81 2.1.81s1.57-.34 2.1-.81c.59-.53 1.33-1.19 2.9-1.19 1.55 0 2.33.87 2.95 1.58.11.12.21.24.33.36.43.45.94.29 1.09.23.15-.06.63-.3.63-.93V13c0-2.21-1.79-4-4-4h-5V8c0-.55-.45-1-1-1s-1 .45-1 1z"
  })]
}));

/**
UiBirthdayFilledSmall icon

```jsx
import { UiBirthdayFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBirthdayFilledSmall />
```

 */
const UiBirthdayFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M13.61 12.19c-.55-.37-1.02-.69-2.11-.69-.63 0-1.02.29-1.51.66-.52.39-1.11.84-1.99.84-.88 0-1.47-.45-1.99-.84-.49-.37-.88-.66-1.51-.66-1.09 0-1.56.32-2.11.69-.57.38-1.22.81-2.39.81v2c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-2c-1.17 0-1.82-.43-2.39-.81z"
  }), /*#__PURE__*/jsx("path", {
    d: "M1.55 10.94c.62-.42 1.4-.94 2.95-.94 1.13 0 1.84.53 2.41.96.91.69 1.27.69 2.18 0 .57-.43 1.28-.96 2.41-.96 1.55 0 2.33.52 2.95.94.48.33.83.56 1.55.56v-1C16 8.57 14.43 7 12.5 7H9V6c0-.06-.02-.12-.04-.17-.3.1-.63.17-.97.17-.34 0-.66-.07-.96-.17-.01.06-.03.11-.03.17v1H3.5C1.57 7 0 8.57 0 10.5v1c.72 0 1.07-.24 1.55-.56zM8 5a2.005 2.005 0 002-2c0-1-.78-1.88-1.36-2.68A.777.777 0 008 0c-.24 0-.48.11-.64.32C6.78 1.12 6 2 6 3c0 1.11.89 2 2 2z"
  })]
}));

/**
UiBirthdayLined icon

```jsx
import { UiBirthdayLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBirthdayLined />
```

 */
const UiBirthdayLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 6a2 2 0 002-2c0-1-.78-1.88-1.36-2.68a.786.786 0 00-1.27 0C10.78 2.12 10 3 10 4c0 1.11.89 2 2 2zm6 3h-5V8c0-.55-.45-1-1-1s-1 .45-1 1v1H6c-2.21 0-4 1.79-4 4v.83c0 .8.38 1.53 1 1.99V21c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-5.18c.62-.46 1-1.19 1-1.99V13c0-2.21-1.79-4-4-4zm0 2c1.1 0 2 .9 2 2v.83c0 .29-.19.41-.31.46-.1.04-.35.1-.57-.13-.74-.78-1.6-1.16-2.63-1.16-1.7 0-2.57.77-3.2 1.34-.5.46-.75.66-1.29.66s-.79-.2-1.3-.66C10.07 13.78 9.2 13 7.5 13c-1.03 0-1.88.38-2.63 1.16-.22.23-.47.17-.57.13-.11-.05-.31-.17-.31-.46V13c0-1.1.9-2 2-2H18zM5 16.27c.49-.1.96-.35 1.32-.73.37-.39.7-.54 1.18-.54.94 0 1.33.35 1.86.83.58.52 1.31 1.17 2.64 1.17s2.05-.65 2.64-1.17c.54-.48.93-.83 1.86-.83.48 0 .81.15 1.18.54.37.39.83.63 1.32.74V20H5v-3.73z"
  })
}));

/**
UiBirthdayLinedSmall icon

```jsx
import { UiBirthdayLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBirthdayLinedSmall />
```

 */
const UiBirthdayLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-birthday-lined-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M13 7H9V6c0-.06-.02-.12-.04-.17-.3.1-.63.17-.97.17-.34 0-.66-.07-.96-.17-.01.06-.03.11-.03.17v1H3c-1.65 0-3 1.35-3 3v5c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-5c0-1.65-1.35-3-3-3zM2 10c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v1.5c-.29 0-.43-.11-.78-.47C12.79 10.6 12.19 10 11 10c-1.19 0-1.79.6-2.22 1.03-.35.35-.49.47-.78.47-.29 0-.43-.11-.78-.47C6.79 10.6 6.19 10 5 10c-1.19 0-1.79.6-2.22 1.03-.35.35-.49.47-.78.47V10zm12 4H2v-1c.94 0 1.46-.53 1.84-.91.35-.36.59-.59 1.16-.59s.8.24 1.16.59c.38.38.9.91 1.84.91.94 0 1.46-.53 1.84-.91.35-.36.59-.59 1.16-.59s.8.24 1.16.59c.38.38.9.91 1.84.91v1zM8 5a2.005 2.005 0 002-2c0-1-.78-1.88-1.36-2.68A.777.777 0 008 0c-.24 0-.48.11-.64.32C6.78 1.12 6 2 6 3c0 1.11.89 2 2 2z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-birthday-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiBookmarkFilled icon

```jsx
import { UiBookmarkFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBookmarkFilled />
```

 */
const UiBookmarkFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M17 2H7c-1.1 0-2 .9-2 2v17c0 .4.2.7.5.9.3.2.7.2 1 0l5.4-3.6 5.4 3.6c.3.2.8.2 1 0 .3-.2.5-.5.5-.9V4c.2-1.1-.7-2-1.8-2z"
  })
}));

/**
UiBookmarkFilledSmall icon

```jsx
import { UiBookmarkFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBookmarkFilledSmall />
```

 */
const UiBookmarkFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M11 1H5c-1.1 0-2 .9-2 2v11c0 .3.2.7.5.9.3.2.7.2 1 0L8 13.1l3.6 1.8c.3.2.7.1 1 0 .3-.2.5-.5.5-.9V3c-.1-1.1-1-2-2.1-2z"
  })
}));

/**
UiBookmarkLined icon

```jsx
import { UiBookmarkLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBookmarkLined />
```

 */
const UiBookmarkLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M17 2H7c-1.1 0-2 .9-2 2v17c0 .4.2.7.5.9.3.2.7.2 1 0l5.4-3.6 5.4 3.6c.3.2.8.2 1 0 .3-.2.5-.5.5-.9V4c.2-1.1-.7-2-1.8-2zm0 17.1l-4.4-3c-.3-.2-.8-.2-1.1 0l-4.4 3V4h10v15.1H17z"
  })
}));

/**
UiBookmarkLinedSmall icon

```jsx
import { UiBookmarkLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBookmarkLinedSmall />
```

 */
const UiBookmarkLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M11 1H5c-1.1 0-2 .9-2 2v11c0 .3.2.7.5.9.3.2.7.2 1 0L8 13.1l3.6 1.8c.3.2.7.1 1 0 .3-.2.5-.5.5-.9V3c-.1-1.1-1-2-2.1-2zm0 11.4l-2.6-1.3c-.2-.1-.6-.1-.9 0L5 12.4V3h6v9.4z"
  })
}));

/**
UiBrightnessDownFilled icon

```jsx
import { UiBrightnessDownFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBrightnessDownFilled />
```

 */
const UiBrightnessDownFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 5a1 1 0 100-2 1 1 0 000 2zm0 1c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm1 14a1 1 0 11-2 0 1 1 0 012 0zm7-7a1 1 0 100-2 1 1 0 000 2zM5 12a1 1 0 11-2 0 1 1 0 012 0zm13.7-6.7c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4zM5.3 18.7c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4-.4.4-1 .4-1.4 0zm0-13.4c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4zm12 12c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0z"
  })
}));

/**
UiBrightnessDownFilledSmall icon

```jsx
import { UiBrightnessDownFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBrightnessDownFilledSmall />
```

 */
const UiBrightnessDownFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M8 3a1 1 0 100-2 1 1 0 000 2zm0 1C5.8 4 4 5.8 4 8s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm1 10a1 1 0 11-2 0 1 1 0 012 0zM2 9a1 1 0 100-2 1 1 0 000 2zm13-1a1 1 0 11-2 0 1 1 0 012 0zm-2.5-3.5a1 1 0 100-2 1 1 0 000 2zm-8-1a1 1 0 11-2 0 1 1 0 012 0zm8 10a1 1 0 100-2 1 1 0 000 2zm-8-1a1 1 0 11-2 0 1 1 0 012 0z"
  })
}));

/**
UiBrightnessDownLined icon

```jsx
import { UiBrightnessDownLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBrightnessDownLined />
```

 */
const UiBrightnessDownLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12 5a1 1 0 100-2 1 1 0 000 2z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm0 10c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z"
  }), /*#__PURE__*/jsx("path", {
    d: "M13 20a1 1 0 11-2 0 1 1 0 012 0zm7-7a1 1 0 100-2 1 1 0 000 2zM5 12a1 1 0 11-2 0 1 1 0 012 0zm13.7-6.7c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4zM5.3 18.7c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4-.4.4-1 .4-1.4 0zm0-13.4c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4zm12 12c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0z"
  })]
}));

/**
UiBrightnessDownLinedSmall icon

```jsx
import { UiBrightnessDownLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBrightnessDownLinedSmall />
```

 */
const UiBrightnessDownLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M8 3a1 1 0 100-2 1 1 0 000 2z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4C5.8 4 4 5.8 4 8s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M9 14a1 1 0 11-2 0 1 1 0 012 0zM2 9a1 1 0 100-2 1 1 0 000 2zm13-1a1 1 0 11-2 0 1 1 0 012 0zm-2.5-3.5a1 1 0 100-2 1 1 0 000 2zm-8-1a1 1 0 11-2 0 1 1 0 012 0zm8 10a1 1 0 100-2 1 1 0 000 2zm-8-1a1 1 0 11-2 0 1 1 0 012 0z"
  })]
}));

/**
UiBrightnessUpFilled icon

```jsx
import { UiBrightnessUpFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBrightnessUpFilled />
```

 */
const UiBrightnessUpFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 5c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1s-1 .4-1 1v2c0 .6.4 1 1 1zm0 14c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1s1-.4 1-1v-2c0-.6-.4-1-1-1zm8-8h2c.6 0 1 .4 1 1s-.4 1-1 1h-2c-.6 0-1-.4-1-1s.4-1 1-1zM5 12c0-.6-.4-1-1-1H2c-.6 0-1 .4-1 1s.4 1 1 1h2c.6 0 1-.4 1-1zm1-5c-.3 0-.5-.1-.7-.3L3.8 5.2c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l1.5 1.5c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3zm12 0c.3 0 .5-.1.7-.3l1.5-1.5c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-1.5 1.5c-.4.4-.4 1 0 1.4.2.2.4.3.7.3zm.8 13.2l-1.5-1.5c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l1.5 1.5c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3zM5.3 17.3l-1.5 1.5c-.4.4-.4 1 0 1.4.2.2.5.3.7.3.2 0 .5-.1.7-.3l1.5-1.5c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0zM6 12c0-3.3 2.7-6 6-6s6 2.7 6 6-2.7 6-6 6-6-2.7-6-6z"
  })
}));

/**
UiBrightnessUpFilledSmall icon

```jsx
import { UiBrightnessUpFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBrightnessUpFilledSmall />
```

 */
const UiBrightnessUpFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M8 3c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1S7 .4 7 1v1c0 .6.4 1 1 1zm0 10c-.6 0-1 .4-1 1v1c0 .6.4 1 1 1s1-.4 1-1v-1c0-.6-.4-1-1-1zM2 7c.6 0 1 .4 1 1s-.4 1-1 1H1c-.6 0-1-.4-1-1s.4-1 1-1h1zm13 0h-1c-.6 0-1 .4-1 1s.4 1 1 1h1c.6 0 1-.4 1-1s-.4-1-1-1zm-1.8-2.8c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l1-1c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-1 1zm-10.4 0c.2.2.4.3.7.3.3 0 .5-.1.7-.3.4-.4.4-1 0-1.4l-1-1c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l1 1zm-1 8.6l1-1c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-1 1c-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4zm10-1c-.4.4-.4 1 0 1.4l1 1c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4l-1-1c-.4-.4-1-.4-1.4 0zM4 8c0-2.2 1.8-4 4-4s4 1.8 4 4-1.8 4-4 4-4-1.8-4-4z"
  })
}));

/**
UiBrightnessUpLined icon

```jsx
import { UiBrightnessUpLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBrightnessUpLined />
```

 */
const UiBrightnessUpLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12 5c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1s-1 .4-1 1v2c0 .6.4 1 1 1zm0 14c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1s1-.4 1-1v-2c0-.6-.4-1-1-1zm8-8h2c.6 0 1 .4 1 1s-.4 1-1 1h-2c-.6 0-1-.4-1-1s.4-1 1-1zM5 12c0-.6-.4-1-1-1H2c-.6 0-1 .4-1 1s.4 1 1 1h2c.6 0 1-.4 1-1zm1-5c-.3 0-.5-.1-.7-.3L3.8 5.2c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l1.5 1.5c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3zm12 0c.3 0 .5-.1.7-.3l1.5-1.5c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-1.5 1.5c-.4.4-.4 1 0 1.4.2.2.4.3.7.3zm.8 13.2l-1.5-1.5c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l1.5 1.5c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3zM5.3 17.3l-1.5 1.5c-.4.4-.4 1 0 1.4.2.2.5.3.7.3.2 0 .5-.1.7-.3l1.5-1.5c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12c0-3.3 2.7-6 6-6s6 2.7 6 6-2.7 6-6 6-6-2.7-6-6zm2 0c0 2.2 1.8 4 4 4s4-1.8 4-4-1.8-4-4-4-4 1.8-4 4z"
  })]
}));

/**
UiBrightnessUpLinedSmall icon

```jsx
import { UiBrightnessUpLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBrightnessUpLinedSmall />
```

 */
const UiBrightnessUpLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M8 3c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1S7 .4 7 1v1c0 .6.4 1 1 1zm0 10c-.6 0-1 .4-1 1v1c0 .6.4 1 1 1s1-.4 1-1v-1c0-.6-.4-1-1-1zM2 7c.6 0 1 .4 1 1s-.4 1-1 1H1c-.6 0-1-.4-1-1s.4-1 1-1h1zm13 0h-1c-.6 0-1 .4-1 1s.4 1 1 1h1c.6 0 1-.4 1-1s-.4-1-1-1zm-1.8-2.8c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l1-1c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-1 1zm-10.4 0c.2.2.4.3.7.3.3 0 .5-.1.7-.3.4-.4.4-1 0-1.4l-1-1c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l1 1zm-1 8.6l1-1c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-1 1c-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4zm10-1c-.4.4-.4 1 0 1.4l1 1c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4l-1-1c-.4-.4-1-.4-1.4 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8c0-2.2 1.8-4 4-4s4 1.8 4 4-1.8 4-4 4-4-1.8-4-4zm2 0c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2z"
  })]
}));

/**
UiBugLined icon

```jsx
import { UiBugLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBugLined />
```

 */
const UiBugLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9 10.022a1 1 0 011-1h3.99a1 1 0 010 2H10a1 1 0 01-1-1zm0 4.995a1 1 0 011-1h3.99a1 1 0 010 2H10a1 1 0 01-1-1z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.38 2.945a1 1 0 00-1.792-.889L15.06 3.12a8.06 8.06 0 00-3.065-.602 8.06 8.06 0 00-3.104.618l-.516-1.063a1 1 0 10-1.799.874l.58 1.194A6.903 6.903 0 005.113 6.66L3.051 5.7a1 1 0 10-.844 1.813L4.48 8.57c.025.011.05.022.075.031a6.37 6.37 0 00-.045.76v2.158H2a1 1 0 100 2h2.51v2.137c0 .264.017.524.048.78-.026.009-.051.02-.077.031l-2.274 1.06a1 1 0 00.844 1.813l2.07-.964c1.163 2.46 3.855 4.124 6.874 4.124 3.02 0 5.713-1.665 6.875-4.128l2.08.967a1 1 0 00.844-1.813l-2.275-1.059a1.02 1.02 0 00-.088-.035c.031-.255.047-.513.047-.776V13.52h2.523a1 1 0 100-2h-2.523V9.363c0-.257-.015-.51-.044-.757.028-.01.057-.022.085-.035l2.275-1.06a1 1 0 10-.845-1.812l-2.07.964a6.91 6.91 0 00-2.08-2.548l.58-1.17zM6.51 9.363c0-2.58 2.356-4.845 5.485-4.845 3.128 0 5.483 2.265 5.483 4.845v6.294c0 2.58-2.355 4.844-5.483 4.844-3.13 0-5.484-2.265-5.484-4.844V9.363z"
  })]
}));

/**
UiBugLinedSmall icon

```jsx
import { UiBugLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBugLinedSmall />
```

 */
const UiBugLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsxs("g", {
    clipPath: "url(#omni-gravity-icon-ui-bug-lined-small-a)",
    children: [/*#__PURE__*/jsx("path", {
      d: "M5.5 7.017a1 1 0 011-1h3a1 1 0 110 2h-3a1 1 0 01-1-1zm0 3.493a1 1 0 011-1h3a1 1 0 110 2h-3a1 1 0 01-1-1z"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.445.075a1 1 0 011.308.538l.312.748a5.757 5.757 0 013.867-.002l.317-.75a1 1 0 011.842.78l-.413.974c.51.434.936.958 1.247 1.55l1.175-.609a1 1 0 11.92 1.776l-1.534.794c.01.124.014.248.014.374v1.546H15a1 1 0 110 2h-1.5v.996c0 .3-.027.595-.077.88l1.597.827a1 1 0 11-.92 1.776l-1.423-.737C11.695 15.03 9.941 16.002 8 16.002c-1.95 0-3.702-.973-4.681-2.469l-1.417.739a1 1 0 01-.924-1.774l1.59-.829c.003 0 .005-.002.008-.004a5.03 5.03 0 01-.076-.875v-.996H1a1 1 0 010-2h1.5V6.248c0-.124.005-.247.013-.369l-1.535-.8a1 1 0 01.924-1.774l1.173.612c.31-.59.735-1.114 1.244-1.548l-.412-.985A1 1 0 014.445.075zM4.5 6.248c0-1.715 1.503-3.222 3.5-3.222 1.999 0 3.5 1.498 3.5 3.222v4.542c0 1.711-1.508 3.212-3.5 3.212-2 0-3.5-1.5-3.5-3.212V6.248z"
    })]
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-bug-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiBundleFilled icon

```jsx
import { UiBundleFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBundleFilled />
```

 */
const UiBundleFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M13 19H8c-1.66 0-3-1.34-3-3V9c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2h-2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M16 16h-5c-1.66 0-3-1.34-3-3V6c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2h-2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M19 3h-8c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
  })]
}));

/**
UiBundleFilledSmall icon

```jsx
import { UiBundleFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBundleFilledSmall />
```

 */
const UiBundleFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9 14H5c-1.65 0-3-1.35-3-3V5.28c-.59.34-1 .98-1 1.72v6c0 1.1.9 2 2 2h6a2 2 0 001.72-1H9z"
  }), /*#__PURE__*/jsx("path", {
    d: "M11 12H7c-1.65 0-3-1.35-3-3V3.28c-.59.34-1 .98-1 1.72v6c0 1.1.9 2 2 2h6c.74 0 1.38-.41 1.72-1H11z"
  }), /*#__PURE__*/jsx("path", {
    d: "M13 1H7c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"
  })]
}));

/**
UiBundleLined icon

```jsx
import { UiBundleLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBundleLined />
```

 */
const UiBundleLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M19 3h-8c-1.1 0-2 .9-2 2v1H8c-1.1 0-2 .9-2 2v1H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-1h1c1.1 0 2-.9 2-2v-1h1c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 11h1v5c0 1.1.9 2 2 2h5v1H5v-8zm3 5V8h1v5c0 1.1.9 2 2 2h5v1H8zm3-3V5h8v8h-8z"
  })
}));

/**
UiBundleLinedSmall icon

```jsx
import { UiBundleLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiBundleLinedSmall />
```

 */
const UiBundleLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9 14H5c-1.65 0-3-1.35-3-3V5.28c-.59.34-1 .98-1 1.72v6c0 1.1.9 2 2 2h6a2 2 0 001.72-1H9z"
  }), /*#__PURE__*/jsx("path", {
    d: "M11 12H7c-1.65 0-3-1.35-3-3V3.28c-.59.34-1 .98-1 1.72v6c0 1.1.9 2 2 2h6c.74 0 1.38-.41 1.72-1H11z"
  }), /*#__PURE__*/jsx("path", {
    d: "M13 3v6H7V3h6m0-2H7c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"
  })]
}));

/**
UiC1AppCircleFilled icon

```jsx
import { UiC1AppCircleFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiC1AppCircleFilled />
```

 */
const UiC1AppCircleFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M3.2 7.4C4.8 4.2 8.2 2 12 2c5.5 0 10 4.5 10.1 10 0 5.5-4.5 10-10 10-2.3 0-4.3-.7-6-2 2-1.1 6-3.4 6-3.4 5.1-3.1 8-5.3 5.7-7.9C16.2 6.8 10 6.8 3.2 7.4z"
  }), /*#__PURE__*/jsx("path", {
    d: "M10.7 10.5c1 1 .8 2.3-.4 3.8-1.8 2.1-4.3 4.3-5.1 5C3.2 17.5 2 14.9 2 12c0-1.2.2-2.3.6-3.3 3.7 0 6.8.5 8.1 1.8z"
  })]
}));

/**
UiC1AppCircleFilledSmall icon

```jsx
import { UiC1AppCircleFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiC1AppCircleFilledSmall />
```

 */
const UiC1AppCircleFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M6.9 9.9c.9-1.2 1.1-2.3.3-3.1-.8-.8-2.5-1.2-4.6-1.4H.5C.2 6.2 0 7.1 0 8c0 2.3 1 4.3 2.5 5.8.4-.3 1-.7 1.6-1.2.9-.8 2-1.8 2.8-2.7z"
  }), /*#__PURE__*/jsx("path", {
    d: "M8 0C4.9 0 2.2 1.8.9 4.3c.9-.1 1.7-.1 2.5-.2 4.5-.3 8.3-.1 9.4 1.2 1.8 2.1-.5 3.9-4.6 6.4 0 0-1.5.8-2.9 1.7-.7.4-1.5.8-2 1.1 1.4.9 3 1.5 4.7 1.5 4.4 0 8-3.6 8-8s-3.6-8-8-8z"
  })]
}));

/**
UiC1AppCircleLined icon

```jsx
import { UiC1AppCircleLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiC1AppCircleLined />
```

 */
const UiC1AppCircleLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM4 12c0-1.1.2-2.2.7-3.2 2.5.2 4.5.7 5.5 1.7s.8 2.3-.4 3.8c-1 1.2-2.3 2.5-3.4 3.4C4.9 16.3 4 14.3 4 12zm8 8c-1.6 0-3.1-.5-4.3-1.3 1.8-1.1 3.8-2.2 3.8-2.2 5.1-3.1 8-5.3 5.7-7.9-1.4-1.6-6-1.8-11.5-1.5C7.1 5.2 9.4 4 12 4c4.4 0 8 3.6 8 8s-3.6 8-8 8z"
  })
}));

/**
UiC1AppCircleLinedSmall icon

```jsx
import { UiC1AppCircleLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiC1AppCircleLinedSmall />
```

 */
const UiC1AppCircleLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM2 8c0-.8.2-1.6.4-2.3 2 .1 3.7.5 4.5 1.3.7.7.5 1.6-.3 2.7-.8 1-1.9 2-2.7 2.7C2.8 11.3 2 9.8 2 8zm6 6c-1.2 0-2.3-.3-3.2-.9 1.4-.8 3-1.8 3-1.8 3.6-2.2 5.7-3.8 4.1-5.6-1-1.2-4.7-1.3-8.9-1C4.1 3 5.9 2 8 2c3.3 0 6 2.7 6 6s-2.7 6-6 6z"
  })
}));

/**
UiC1AppFilled icon

```jsx
import { UiC1AppFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiC1AppFilled />
```

 */
const UiC1AppFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M7 3h10c2.2 0 4 1.8 4 4v10c0 2.2-1.8 4-4 4H7c-.7 0-1.3-.2-1.8-.4.8-.5 6.8-4 6.8-4 5.1-3.1 8-5.3 5.7-7.9C16.1 6.8 9.9 6.8 3 7.4V7c0-2.2 1.8-4 4-4z"
  }), /*#__PURE__*/jsx("path", {
    d: "M10.3 14.3c-2.2 2.6-6.1 5.3-6.1 5.3s-.1 0-.2.1C3.4 19 3 18 3 17V8.7c3.5.1 6.5.6 7.7 1.8 1 1 .8 2.3-.4 3.8z"
  })]
}));

/**
UiC1AppFilledSmall icon

```jsx
import { UiC1AppFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiC1AppFilledSmall />
```

 */
const UiC1AppFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M4 1h8c1.7 0 3 1.3 3 3v8c0 1.7-1.3 3-3 3H4c-.4 0-.8-.1-1-.2 1.1-.7 5.3-3.1 5.3-3.1 4.1-2.5 6.4-4.3 4.6-6.4-1.3-1.5-6.4-1.5-11.9-1V4c0-1.7 1.3-3 3-3z"
  }), /*#__PURE__*/jsx("path", {
    d: "M6.9 9.9c-1.7 2-4.9 4.2-4.9 4.2-.6-.5-1-1.2-1-2.1V5.3c2.9.1 5.2.5 6.2 1.5.8.8.6 1.9-.3 3.1z"
  })]
}));

/**
UiC1AppLined icon

```jsx
import { UiC1AppLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiC1AppLined />
```

 */
const UiC1AppLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M17 3H7C4.8 3 3 4.8 3 7v10c0 2.2 1.8 4 4 4h10c2.2 0 4-1.8 4-4V7c0-2.2-1.8-4-4-4zM5 8.8c2.4.2 4.3.8 5.2 1.7 1 1 .8 2.3-.4 3.8-1.3 1.6-3 3.2-4.1 4.2-.4-.4-.7-.9-.7-1.5V8.8zM19 17c0 1.1-.9 2-2 2H7.2c1.9-1.1 4.2-2.5 4.2-2.5 5.1-3.1 8-5.3 5.7-7.9C15.8 7 10.8 6.8 5 7.2V7c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v10z"
  })
}));

/**
UiC1AppLinedSmall icon

```jsx
import { UiC1AppLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiC1AppLinedSmall />
```

 */
const UiC1AppLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 1H4C2.3 1 1 2.3 1 4v8c0 1.7 1.3 3 3 3h8c1.7 0 3-1.3 3-3V4c0-1.7-1.3-3-3-3zM3 5.8c1.6.2 2.8.6 3.4 1.2.7.7.6 1.6-.3 2.7-.9 1.1-2.1 2.2-2.9 2.9-.1-.1-.2-.4-.2-.6V5.8zM13 12c0 .6-.4 1-1 1H4.4c1.4-.8 2.9-1.7 2.9-1.7 3.6-2.2 5.7-3.8 4.1-5.6C10.4 4.5 7 4.3 3 4.6V4c0-.6.4-1 1-1h8c.6 0 1 .4 1 1v8z"
  })
}));

/**
UiCafeFilled icon

```jsx
import { UiCafeFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCafeFilled />
```

 */
const UiCafeFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M16.06 1.45a.76.76 0 00-.99-.39.76.76 0 00-.39.99l.24.55c.07.15.09.32.07.48-.02.16-.09.31-.2.44l-.01.01c-.28.34-.45.75-.51 1.19-.06.43 0 .88.18 1.28l.23.54c.16.38.6.56.98.4.38-.16.56-.6.4-.98l-.23-.55V5.4a.884.884 0 01.12-.92A2.384 2.384 0 0016.29 2l-.23-.55zm-8.98.01a.75.75 0 00-.98-.4.75.75 0 00-.4.98l.23.55v.01a.884.884 0 01-.12.92c-.28.34-.46.75-.52 1.19-.06.44 0 .88.18 1.29l.24.55c.17.38.61.55.99.39a.76.76 0 00.39-.99l-.24-.55a.884.884 0 01-.07-.48c.02-.16.09-.31.2-.44l.01-.01c.28-.34.45-.75.51-1.19.06-.43 0-.88-.18-1.28l-.24-.54z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.57 12.2c-.29-.58-.71-1.07-1.24-1.45-.52-.38-1.13-.62-1.77-.71-.19-.03-.38-.04-.56-.04 0-.53-.21-1.04-.59-1.41C18.03 8.21 17.53 8 17 8H5c-.53 0-1.04.21-1.41.59C3.21 8.97 3 9.47 3 10v6c0 1.33.53 2.6 1.46 3.54C5.4 20.48 6.67 21 8 21h6c1.15 0 2.27-.4 3.16-1.13.63-.51 1.11-1.16 1.43-1.89.28.03.57.03.86-.01.64-.07 1.25-.3 1.79-.66.53-.36.97-.85 1.28-1.41.31-.56.47-1.2.48-1.84.01-.65-.14-1.29-.43-1.86zm-10.99 4.08c-.85.61-1.73 1.18-2.64 1.7l-.13-.07a3.27 3.27 0 01-.35-.3l.54-.44c1.41-1.17 3.15-2.94 2.11-4.07-.66-.67-2.22-1-4.11-1V12l.35-.72.22-.02c3.43-.26 6.55-.16 7.28.76.73.92-.82 2.55-3.27 4.26zm9.18-1.33c-.15.28-.37.53-.64.71-.27.18-.57.29-.89.33-.07.01-.15.01-.22.01v-4a2.007 2.007 0 011.16.38c.26.19.47.44.62.72a2.01 2.01 0 01-.03 1.85z"
  }), /*#__PURE__*/jsx("path", {
    d: "M10.59 1.06c.38-.16.82.02.98.4l.23.54c.17.4.24.84.18 1.28-.06.44-.24.85-.51 1.19l-.01.01c-.1.13-.17.28-.2.44-.02.16 0 .33.07.48l.24.55a.751.751 0 11-1.38.6L9.95 6c-.18-.41-.24-.85-.18-1.29.06-.44.24-.85.52-1.19a.884.884 0 00.12-.92v-.01l-.23-.55c-.15-.38.03-.82.41-.98z"
  })]
}));

/**
UiCafeFilledSmall icon

```jsx
import { UiCafeFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCafeFilledSmall />
```

 */
const UiCafeFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M13 7c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v5c0 1.65 1.35 3 3 3h5c1.3 0 2.4-.84 2.82-2H13c1.65 0 3-1.35 3-3s-1.35-3-3-3zm-8 5.63s2.89-1.48 2.89-2.66C7.89 8.79 5 8.71 5 8.71V8.1s1.33-.08 3-.08c1.2 0 3 .19 3 1.3 0 1.69-4.78 3.7-6 3.7v-.39zm8-1.13v-3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5zM4.11 4.64c.14.23.39.36.64.36.13 0 .26-.03.38-.11.36-.21.47-.67.26-1.03-.05-.08-.06-.13-.07-.13.02-.04.1-.14.15-.2.28-.35.95-1.17-.19-2.31a.754.754 0 00-1.06 0c-.29.29-.29.77 0 1.06.09.09.14.16.17.2-.03.03-.06.07-.08.11-.25.3-.83 1.01-.2 2.05zm6 0c.14.23.39.36.64.36.13 0 .26-.03.38-.11.36-.21.47-.67.26-1.03-.05-.08-.06-.13-.07-.13.02-.04.1-.14.15-.2.28-.35.95-1.17-.19-2.31a.754.754 0 00-1.06 0c-.29.29-.29.77 0 1.06.09.09.14.16.17.2-.03.03-.06.07-.08.11-.25.3-.83 1.01-.2 2.05zm-3 0c.14.23.39.36.64.36.13 0 .26-.03.38-.11.36-.21.47-.67.26-1.03-.05-.08-.06-.13-.07-.13.02-.04.1-.14.15-.2.28-.35.95-1.17-.19-2.31a.754.754 0 00-1.06 0c-.29.29-.29.77 0 1.06.09.09.14.16.17.2-.03.03-.06.07-.08.11-.25.3-.83 1.01-.2 2.05z"
  })
}));

/**
UiCafeLined icon

```jsx
import { UiCafeLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCafeLined />
```

 */
const UiCafeLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M16.06 1.45a.76.76 0 00-.99-.39.76.76 0 00-.39.99l.24.55c.07.151.09.321.07.481-.02.16-.09.31-.2.44l-.01.01c-.28.34-.45.75-.51 1.191-.06.43 0 .88.18 1.28l.23.541a.75.75 0 001.38-.58l-.23-.55v-.01a.885.885 0 01.12-.921A2.386 2.386 0 0016.29 2l-.23-.55zm-8.98.01a.75.75 0 00-1.38.58l.23.55v.01a.885.885 0 01-.12.92 2.388 2.388 0 00-.34 2.482l.24.55c.17.38.61.55.99.39a.76.76 0 00.39-.99l-.24-.55a.885.885 0 01-.07-.48c.02-.16.09-.31.2-.44l.01-.01c.28-.34.45-.751.51-1.191.06-.43 0-.88-.18-1.281l-.24-.54zM9 17.179l-.54.44c.11.11.23.21.35.3l.13.07c.91-.52 1.79-1.09 2.64-1.7 2.45-1.712 4-3.343 3.27-4.263-.73-.92-3.85-1.02-7.28-.76l-.23.02s-.22.38-.28.53l-.06.29c1.89 0 3.45.33 4.11 1 1.04 1.131-.7 2.902-2.11 4.073z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.59 8.583c.38-.38.88-.59 1.41-.59h12c.53 0 1.04.21 1.41.59.38.38.59.88.59 1.411.19 0 .38.01.56.04.64.09 1.24.34 1.77.71A4.005 4.005 0 0123 14.056c-.01.64-.17 1.281-.48 1.841-.31.57-.74 1.05-1.28 1.411-.53.36-1.15.59-1.79.66-.29.03-.57.03-.86.01-.32.73-.8 1.381-1.43 1.891A4.985 4.985 0 0114 21H8c-1.33 0-2.6-.53-3.54-1.46A4.998 4.998 0 013 15.996V9.994a2 2 0 01.59-1.41zM19 16.007c.07 0 .15 0 .22-.01a2.002 2.002 0 001.77-1.96c0-.32-.07-.641-.21-.931a1.97 1.97 0 00-.62-.72 2.006 2.006 0 00-1.16-.38v4.001zm-2-4.842l-.08 5.523c-.15.64-.51 1.22-1.02 1.64-.54.44-1.21.68-1.9.68H8c-.8 0-1.56-.32-2.12-.88S5 16.798 5 16.008v-6.004h12v1.16z"
  }), /*#__PURE__*/jsx("path", {
    d: "M10.59 1.06c.38-.16.82.02.98.4l.23.54c.17.4.24.84.18 1.28-.06.44-.24.851-.51 1.191l-.01.01c-.1.13-.17.28-.2.44-.02.16 0 .33.07.48l.24.551a.752.752 0 11-1.38.6l-.24-.55c-.18-.41-.24-.85-.18-1.29.06-.44.24-.851.52-1.191a.885.885 0 00.12-.92v-.01l-.23-.551c-.15-.38.03-.82.41-.98z"
  })]
}));

/**
UiCalculatorFilled icon

```jsx
import { UiCalculatorFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCalculatorFilled />
```

 */
const UiCalculatorFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M17 1.02H7c-1.09 0-1.97.89-1.97 1.98v18c0 1.09.89 1.97 1.97 1.97h10c1.09 0 1.97-.89 1.97-1.97V3c0-1.09-.88-1.98-1.97-1.98zM8.5 14h1c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5zM8 12.5v-1c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5zm.5 4.5h1c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5zm3-3h1c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5zm-.5-1.5v-1c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5zm.5 4.5h1c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5zm3-3h1c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5zm-.5-1.5v-1c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5zm.5 4.5h1c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5zM7 8V3h10v5H7z"
  }), /*#__PURE__*/jsx("path", {
    d: "M15.85 4.15A.51.51 0 0015.5 4a.51.51 0 00-.5.5v2c0 .13.05.26.15.35.09.09.22.15.35.15.13 0 .26-.05.35-.15A.51.51 0 0016 6.5v-2a.51.51 0 00-.15-.35z"
  })]
}));

/**
UiCalculatorFilledSmall icon

```jsx
import { UiCalculatorFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCalculatorFilledSmall />
```

 */
const UiCalculatorFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0h8c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V2c0-1.1.9-2 2-2zm8 2H4v4h8V2zm-4.5 9h1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-1c-.3 0-.5.2-.5.5s.2.5.5.5zm1 2c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-1c-.3 0-.5.2-.5.5s.2.5.5.5h1zm-1-4h1c.3 0 .5-.2.5-.5S8.8 8 8.5 8h-1c-.3 0-.5.2-.5.5s.2.5.5.5zm-3 2h1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-1c-.3 0-.5.2-.5.5s.2.5.5.5zm1 2c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-1c-.3 0-.5.2-.5.5s.2.5.5.5h1zm-1-4h1c.3 0 .5-.2.5-.5S5.8 8 5.5 8h-1c-.3 0-.5.2-.5.5s.2.5.5.5zm5.5 1.5c0 .3.2.5.5.5h1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-1c-.3 0-.5.2-.5.5zm1.5 2.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-1c-.3 0-.5.2-.5.5s.2.5.5.5h1zm-1-4h1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-1c-.3 0-.5.2-.5.5s.2.5.5.5zM10 3.2c0-.2.2-.4.5-.4s.5.2.5.4v1.6c0 .2-.2.4-.5.4S10 5 10 4.7V3.2z"
  })
}));

/**
UiCalculatorLined icon

```jsx
import { UiCalculatorLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCalculatorLined />
```

 */
const UiCalculatorLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M8.5 13h1c.28 0 .5-.22.5-.5v-1c0-.28-.22-.5-.5-.5h-1c-.28 0-.5.22-.5.5v1c0 .28.22.5.5.5zm4 0h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5zm3 0c.28 0 .5-.22.5-.5v-1c0-.28-.22-.5-.5-.5h-1c-.28 0-.5.22-.5.5v1c0 .28.22.5.5.5h1zm.5 2.5c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v1zm-.5 3.5c.28 0 .5-.22.5-.5v-1c0-.28-.22-.5-.5-.5h-1c-.28 0-.5.22-.5.5v1c0 .28.22.5.5.5h1zm-6-3h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5zm2 0h1c.28 0 .5-.22.5-.5v-1c0-.28-.22-.5-.5-.5h-1c-.28 0-.5.22-.5.5v1c0 .28.22.5.5.5zm-2 3h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5zm2 0h1c.28 0 .5-.22.5-.5v-1c0-.28-.22-.5-.5-.5h-1c-.28 0-.5.22-.5.5v1c0 .28.22.5.5.5zm4-15a.51.51 0 00-.5.5v2c0 .13.05.26.15.35.09.09.22.15.35.15.13 0 .26-.05.35-.15A.51.51 0 0016 6.5v-2a.51.51 0 00-.5-.5z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 .98h10c1.12 0 2.03.9 2.03 2.02v18c0 1.11-.91 2.02-2.03 2.02H7c-1.12 0-2.03-.9-2.03-2.02V3C4.97 1.89 5.88.98 7 .98zM7 21h10V10H7v11zM7 3v5h10V3H7z"
  })]
}));

/**
UiCalendarAddLined icon

```jsx
import { UiCalendarAddLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCalendarAddLined />
```

 */
const UiCalendarAddLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M19 3v1.5a.5.5 0 01-.5.5H18V2a1 1 0 00-2 0v1H9v1.5a.5.5 0 01-.5.5H8V2a1 1 0 00-2 0v1H5a2 2 0 00-2 2v14a2 2 0 002 2h7a1 1 0 000-2H5V8h14v3.5a1 1 0 002 0V5a2 2 0 00-2-2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M7.293 13.293A1 1 0 018 13h2a1 1 0 011 1v2a1 1 0 01-1 1H8a1 1 0 01-1-1v-2a1 1 0 01.293-.707zm11.414 1A1 1 0 0119 15v2h2a1 1 0 010 2h-2v2a1 1 0 01-2 0v-2h-2a1 1 0 010-2h2v-2a1 1 0 011.707-.707z"
  })]
}));

/**
UiCalendarLined icon

```jsx
import { UiCalendarLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCalendarLined />
```

 */
const UiCalendarLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M7 14c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1v-2z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 4.5V3c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h1V2c0-.55.45-1 1-1s1 .45 1 1v3h.5c.28 0 .5-.22.5-.5V3h7V2a.999.999 0 012-.02V5h.5c.28 0 .5-.22.5-.5zM5 8v11h14V8H5z"
  })]
}));

/**
UiCalendarLinedSmall icon

```jsx
import { UiCalendarLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCalendarLinedSmall />
```

 */
const UiCalendarLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14 2h-2V1c0-.55-.45-1-1-1s-1 .45-1 1v1H6V1c0-.55-.45-1-1-1S4 .45 4 1v1H2c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm-1 11H3V6h10v7z"
  })
}));

/**
UiCameraFilled icon

```jsx
import { UiCameraFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCameraFilled />
```

 */
const UiCameraFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M21 6h-3.59L15.7 4.29A.99.99 0 0015 4H9c-.27 0-.52.11-.71.29L6.59 6H3c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM5.01 10.98c-.04 0-.06.02-.09.02-.55 0-1-.45-1-1s.45-1 1-1c.02 0 .04.01.07.01.38.03.71.26.86.6.04.12.07.25.07.39s-.03.27-.08.39c-.14.33-.46.56-.83.59zM12 17c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
  })
}));

/**
UiCameraFilledSmall icon

```jsx
import { UiCameraFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCameraFilledSmall />
```

 */
const UiCameraFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14.5 4h-2.09L10.7 2.29A.99.99 0 0010 2H6c-.27 0-.52.11-.71.29L3.59 4H1.5C.67 4 0 4.67 0 5.5v8c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-8c0-.83-.67-1.5-1.5-1.5zM8 12c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
  })
}));

/**
UiCameraLined icon

```jsx
import { UiCameraLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCameraLined />
```

 */
const UiCameraLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.09 8c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.25-5-5-5zm0 8c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
  }), /*#__PURE__*/jsx("path", {
    d: "M6 10a1 1 0 11-2 0 1 1 0 012 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 6h-3.59L15.7 4.29A.99.99 0 0015 4H9c-.27 0-.52.11-.71.29L6.59 6H3c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 13H3V8h4c.27 0 .52-.11.71-.29L9.41 6h5.17l1.71 1.71c.19.18.44.29.71.29h4v11z"
  })]
}));

/**
UiCameraLinedSmall icon

```jsx
import { UiCameraLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCameraLinedSmall />
```

 */
const UiCameraLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.41 4h2.09c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5h-13C.67 15 0 14.33 0 13.5v-8C0 4.67.67 4 1.5 4h2.09l1.7-1.71C5.48 2.11 5.73 2 6 2h4c.27 0 .52.11.7.29L12.41 4zM2 6v7h12V6h-2c-.27 0-.52-.11-.71-.29L9.58 4H6.41l-1.7 1.71C4.52 5.89 4.27 6 4 6H2zm9 3a3 3 0 11-6 0 3 3 0 016 0z"
  })
}));

/**
UiCancelLined icon

```jsx
import { UiCancelLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCancelLined />
```

 */
const UiCancelLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM4 12c0-4.4 3.6-8 8-8 1.8 0 3.5.6 4.9 1.7L5.7 16.9C4.6 15.5 4 13.8 4 12zm8 8c-1.8 0-3.5-.6-4.9-1.7L18.3 7.1C19.4 8.5 20 10.2 20 12c0 4.4-3.6 8-8 8z"
  })
}));

/**
UiCancelLinedSmall icon

```jsx
import { UiCancelLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCancelLinedSmall />
```

 */
const UiCancelLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 2c1.3 0 2.5.4 3.5 1.1l-8.4 8.4C2.4 10.5 2 9.3 2 8c0-3.3 2.7-6 6-6zm0 12c-1.3 0-2.5-.4-3.5-1.1l8.4-8.4c.7 1 1.1 2.2 1.1 3.5 0 3.3-2.7 6-6 6z"
  })
}));

/**
UiCarConvertibleFilled icon

```jsx
import { UiCarConvertibleFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarConvertibleFilled />
```

 */
const UiCarConvertibleFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22.92 11.62A1 1 0 0022 11h-5V9.5a.5.5 0 00-1 0V11H9.41l1.3-1.29a1.004 1.004 0 10-1.42-1.42L6.55 11l-4.65.5a1.002 1.002 0 00-.89 1.14l.42 2.93a2 2 0 001.24 1.57l1.43.58a3 3 0 005.72.28h4.36a3 3 0 005.69-.19l.61-.15A2 2 0 0022 15.72v-2.31l.71-.7a1 1 0 00.21-1.09zM7 18a1 1 0 110-2 1 1 0 010 2zm10 0a1 1 0 110-2 1 1 0 010 2z"
  })
}));

/**
UiCarConvertibleLined icon

```jsx
import { UiCarConvertibleLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarConvertibleLined />
```

 */
const UiCarConvertibleLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22.92 11.62A1 1 0 0022 11h-5V9.5a.5.5 0 00-1 0V11H9.41l1.3-1.29a1.004 1.004 0 10-1.42-1.42L6.55 11l-4.65.5a1.002 1.002 0 00-.89 1.14l.42 2.93a2 2 0 001.24 1.57l1.43.58a3 3 0 005.72.28h4.36a3 3 0 005.69-.19l.61-.15A2 2 0 0022 15.72v-2.31l.71-.7a1 1 0 00.21-1.09zM7 18a1 1 0 110-2 1 1 0 010 2zm10 0a1 1 0 110-2 1 1 0 010 2zm3-2.28l-.26.07a3 3 0 00-5.56.21H9.82a3 3 0 00-5.49-.34l-.92-.37-.27-1.9L7 13h13v2.72z"
  })
}));

/**
UiCarCoupeFilled icon

```jsx
import { UiCarCoupeFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarCoupeFilled />
```

 */
const UiCarCoupeFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 11c-.26 0-.53-.31-1.05-1A6.78 6.78 0 0013 7c-2.77 0-4.33 1.63-5.47 2.82C7 10.43 6.4 11 6 11a9.72 9.72 0 00-2.91.5A3 3 0 001 14.36v.2a3 3 0 002.05 2.85l1.06.35a3 3 0 005.71.24h4.36a3 3 0 005.68-.13l.63-.11a3 3 0 002.51-3V14a3 3 0 00-3-3zM7 18a1 1 0 110-2 1 1 0 010 2zm7-7H9.17A5.08 5.08 0 0113 9a7.59 7.59 0 011 .07V11zm1-1.68A4.84 4.84 0 0117.16 11H15V9.32zM17 18a1 1 0 110-2 1 1 0 010 2z"
  })
}));

/**
UiCarCoupeLined icon

```jsx
import { UiCarCoupeLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarCoupeLined />
```

 */
const UiCarCoupeLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 11c-.26 0-.53-.31-1.05-1A6.78 6.78 0 0013 7c-2.77 0-4.33 1.63-5.47 2.82C7 10.43 6.4 11 6 11a9.72 9.72 0 00-2.91.5A3 3 0 001 14.36v.2a3 3 0 002.05 2.85l1.06.35a3 3 0 005.71.24h4.36a3 3 0 005.68-.13l.63-.11a3 3 0 002.51-3V14a3 3 0 00-3-3zm-2.84 0H15V9.32A4.84 4.84 0 0117.16 11zM13 9a7.59 7.59 0 011 .07V11H9.17A5.08 5.08 0 0113 9zm-6 9a1 1 0 110-2 1 1 0 010 2zm10 0a1 1 0 110-2 1 1 0 010 2zm4-3.19a1 1 0 01-.83 1l-.4.07a3 3 0 00-5.59.14H9.82a3 3 0 00-5.52-.29l-.62-.2a1 1 0 01-.68-.97v-.2a1 1 0 01.7-.95A7.657 7.657 0 016 13h14a1 1 0 011 1v.81z"
  })
}));

/**
UiCarCrossoverFilled icon

```jsx
import { UiCarCrossoverFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarCrossoverFilled />
```

 */
const UiCarCrossoverFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-car-crossover-filled-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M23.71 15.29l-.71-.7V9.41l.71-.7a1 1 0 00.23-1 1 1 0 00-.83-.71C22.74 7 14 6 11 6s-5 3.58-5.68 5.05a10.45 10.45 0 00-4.12 1.47 3 3 0 00-1.2 2.4v1.36a2 2 0 001.46 1.92l3.29.8a3 3 0 004.47 0h5.56a3 3 0 004.46 0l3.09-.35a2 2 0 001.67-2V16a1 1 0 00-.29-.71zM7 18a1 1 0 110-2 1 1 0 010 2zm.61-7c.78-1.36 2-3 3.39-3 .94 0 2.49.1 4.17.24l.69 2.76H7.61zM17 18a1 1 0 110-2 1 1 0 010 2zm4-9v2h-4.11l-.67-2.67c1.75.15 3.52.33 4.8.46-.012.07-.018.14-.02.21z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-car-crossover-filled-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z"
      })
    })
  })]
}));

/**
UiCarCrossoverLined icon

```jsx
import { UiCarCrossoverLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarCrossoverLined />
```

 */
const UiCarCrossoverLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-car-crossover-lined-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M23.71 15.29l-.71-.7V9.41l.71-.7a1 1 0 00.23-1 1 1 0 00-.83-.71C22.74 7 14 6 11 6s-5 3.58-5.68 5.05a10.45 10.45 0 00-4.12 1.47 3 3 0 00-1.2 2.4v1.36a2 2 0 001.46 1.92l3.29.8a3 3 0 004.47 0h5.56a3 3 0 004.46 0l3.09-.35a2 2 0 001.67-2V16a1 1 0 00-.29-.71zM21 8.79c-.005.07-.005.14 0 .21v2h-4.11l-.67-2.67c1.78.15 3.52.33 4.78.46zM11 8c.94 0 2.49.1 4.17.24l.69 2.76H7.61C8.39 9.64 9.65 8 11 8zM7 18a1 1 0 110-2 1 1 0 010 2zm10 0a1 1 0 110-2 1 1 0 010 2zm3-1.12a3 3 0 10-6 .12h-4a3.003 3.003 0 00-6-.25l-2-.47v-1.36a1 1 0 01.41-.8A8.63 8.63 0 016 13h15v2a1 1 0 00.29.71l.75.74v.2l-2.04.23z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-car-crossover-lined-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z"
      })
    })
  })]
}));

/**
UiCarFilled icon

```jsx
import { UiCarFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarFilled />
```

 */
const UiCarFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M17.178 4.681A5 5 0 0119 6.52L20.44 9H3.56L5 6.52A5 5 0 019.32 4h5.36a5 5 0 012.498.681z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.57 9h1.93a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1.92l.29.5a1 1 0 01.13.5v8a1 1 0 01-1 1h-2a1 1 0 01-1-1v-1H6v1a1 1 0 01-1 1H3a1 1 0 01-1-1v-8a1 1 0 01.13-.5l.29-.5H.5a.5.5 0 01-.5-.5v-1A.5.5 0 01.5 9h1.93a.53.53 0 01.39.18l.68.82h17l.68-.82a.53.53 0 01.39-.18zM6.444 14.832a1 1 0 101.111-1.663 1 1 0 00-1.11 1.662zM12 15.27a7.76 7.76 0 002.15-.27.522.522 0 10-.3-1 6.46 6.46 0 01-1.85.23 6.46 6.46 0 01-1.85-.23.522.522 0 10-.3 1c.7.19 1.424.281 2.15.27zm4.444-.438a1 1 0 101.111-1.663 1 1 0 00-1.11 1.662z"
  })]
}));

/**
UiCarFilledSmall icon

```jsx
import { UiCarFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarFilledSmall />
```

 */
const UiCarFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12.4 3.2L13.75 5H2.25L3.6 3.2A3 3 0 016 2h4a3 3 0 012.4 1.2z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.5 6h15a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H15v5a1 1 0 01-1 1h-2a1 1 0 01-1-1H5a1 1 0 01-1 1H2a1 1 0 01-1-1V8H.5a.5.5 0 01-.5-.5v-1A.5.5 0 01.5 6zm3.944 3.831a1 1 0 101.112-1.663 1 1 0 00-1.112 1.663zm6 0a1 1 0 101.112-1.663 1 1 0 00-1.112 1.663z"
  })]
}));

/**
UiCarHatchbackFilled icon

```jsx
import { UiCarHatchbackFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarHatchbackFilled />
```

 */
const UiCarHatchbackFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M23 11.91a.705.705 0 000-.2 1.32 1.32 0 00-.07-.18v-.08l-1.64-2.32.42-.42a1 1 0 00.21-1.09A1 1 0 0021 7h-9c-3 0-5.75 3.09-6.58 4.11l-2.9.73A2 2 0 001 13.78v1.87a2 2 0 001.67 2l1.47.24a3 3 0 005.68.11h4.36a3 3 0 005.68-.13l.63-.11a3 3 0 002.51-3V12a.289.289 0 000-.09zM7 18a1 1 0 110-2 1 1 0 010 2zm1.26-7c1.07-1 2.47-2 3.74-2h3.36l.5 2h-7.6zM17 18a1 1 0 110-2 1 1 0 010 2zm-.11-7l-.5-2H19a.92.92 0 00.17.55l1 1.45h-3.28z"
  })
}));

/**
UiCarHatchbackLined icon

```jsx
import { UiCarHatchbackLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarHatchbackLined />
```

 */
const UiCarHatchbackLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M23 11.91a.705.705 0 000-.2 1.32 1.32 0 00-.07-.18v-.08l-1.64-2.32.42-.42a1 1 0 00.21-1.09A1 1 0 0021 7h-9c-3 0-5.75 3.09-6.58 4.11l-2.9.73A2 2 0 001 13.78v1.87a2 2 0 001.67 2l1.47.24a3 3 0 005.68.11h4.36a3 3 0 005.68-.13l.63-.11a3 3 0 002.51-3V12a.289.289 0 000-.09zM19 9a.92.92 0 00.17.55l1 1.45h-3.28l-.5-2H19zm-7 0h3.36l.5 2h-7.6c1.07-1 2.47-2 3.74-2zm-5 9a1 1 0 110-2 1 1 0 010 2zm10 0a1 1 0 110-2 1 1 0 010 2zm4-3.19a1 1 0 01-.83 1l-.4.07a3 3 0 00-5.59.14H9.82a3 3 0 00-5.59-.14L3 15.65v-1.87L6.12 13H21v1.81z"
  })
}));

/**
UiCarHeartFilled icon

```jsx
import { UiCarHeartFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarHeartFilled />
```

 */
const UiCarHeartFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53 6l.13.13c.32.32 1.23 1.14 1.94 1.77a.59.59 0 00.4.1.65.65 0 00.4-.15c.39-.35 1.7-1.53 1.94-1.77h.05c.44-.43 1.65-1.66 1.58-3a2.24 2.24 0 00-.93-1.62A2.09 2.09 0 0013.8.94 2 2 0 0012 2a2 2 0 00-1.77-1A2.23 2.23 0 008 3.08 4.06 4.06 0 009.53 6zm13.97 5h-1.93a.53.53 0 00-.39.18l-.68.82h-17l-.68-.82a.53.53 0 00-.39-.18H.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1.92l-.29.5A1 1 0 002 14v8a1 1 0 001 1h2a1 1 0 001-1v-1h12v1a1 1 0 001 1h2a1 1 0 001-1v-8a1 1 0 00-.13-.5l-.29-.5h1.92a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zM7 17a1 1 0 110-2 1 1 0 010 2zm7.15 0a7.76 7.76 0 01-2.15.27A7.752 7.752 0 019.85 17a.52.52 0 11.3-1 6.46 6.46 0 001.85.23 6.46 6.46 0 001.85-.23.52.52 0 11.3 1zM17 17a1 1 0 110-2 1 1 0 010 2zm.59-10.045A5.001 5.001 0 0119 8.52L20.44 11H3.56L5 8.52a5 5 0 013.26-2.4c.153.168.3.312.427.438l.113.112.13.12.261.231c.349.307.912.803 1.74 1.57a1.6 1.6 0 002.12 0c.06-.057.163-.149.29-.263.529-.475 1.483-1.334 1.71-1.568.213-.206.417-.423.61-.65a5 5 0 011.929.845z"
  })
}));

/**
UiCarHeartLined icon

```jsx
import { UiCarHeartLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarHeartLined />
```

 */
const UiCarHeartLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9.53 6l.13.13c.32.32 1.23 1.14 1.94 1.77a.59.59 0 00.4.1.62.62 0 00.4-.15c.39-.35 1.7-1.53 1.94-1.77h.05c.42-.41 1.68-1.66 1.61-3a2.24 2.24 0 00-.93-1.62A2.09 2.09 0 0013.8.94 2 2 0 0012 2a2 2 0 00-1.77-1A2.23 2.23 0 008 3.08 4.06 4.06 0 009.53 6zM7 17a1 1 0 100-2 1 1 0 000 2zm10 0a1 1 0 100-2 1 1 0 000 2zm-5-.77a6.456 6.456 0 001.85-.23.523.523 0 01.3 1 7.76 7.76 0 01-2.15.27A7.745 7.745 0 019.85 17a.522.522 0 11.3-1 6.456 6.456 0 001.85.23z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.57 11h1.93a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1.92l.29.5c.081.155.126.326.13.5v8a1 1 0 01-1 1h-2a1 1 0 01-1-1v-1H6v1a1 1 0 01-1 1H3a1 1 0 01-1-1v-8a1.13 1.13 0 01.13-.5l.29-.5H.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1.93a.53.53 0 01.39.18l.38.46L5 8.52a5 5 0 013.34-2.4c.153.178.307.33.44.46l.09.09.13.12c.16.21.59.6 1.27 1.21h-.95a3 3 0 00-2.6 1.51L5.29 12h13.42l-1.43-2.51a3 3 0 00-2.6-1.51h-.95l.491-.45c.366-.335.705-.646.829-.77.214-.206.418-.423.61-.65A5 5 0 0119 8.52l1.8 3.12.38-.46a.53.53 0 01.39-.18zM4 19h16v-4.73L19.28 13H4.72L4 14.27V19z"
  })]
}));

/**
UiCarLined icon

```jsx
import { UiCarLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarLined />
```

 */
const UiCarLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M7 15a1 1 0 100-2 1 1 0 000 2zm10 0a1 1 0 100-2 1 1 0 000 2zm-7.15 0c.7.19 1.424.281 2.15.27a7.76 7.76 0 002.15-.27.522.522 0 10-.3-1 6.46 6.46 0 01-1.85.23 6.46 6.46 0 01-1.85-.23.522.522 0 10-.3 1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M23.5 9h-1.93a.53.53 0 00-.39.18l-.38.46L19 6.52A5 5 0 0014.68 4H9.32A5 5 0 005 6.52L3.2 9.64l-.38-.46A.53.53 0 002.43 9H.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1.92l-.29.5A1.13 1.13 0 002 12v8a1 1 0 001 1h2a1 1 0 001-1v-1h12v1a1 1 0 001 1h2a1 1 0 001-1v-8a1.129 1.129 0 00-.13-.5l-.29-.5h1.92a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zM6.72 7.51A3 3 0 019.32 6h5.36a3 3 0 012.6 1.51L18.71 10H5.29l1.43-2.49zM4 12.27L4.72 11h14.56l.72 1.27V17H4v-4.73z"
  })]
}));

/**
UiCarLinedSmall icon

```jsx
import { UiCarLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarLinedSmall />
```

 */
const UiCarLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 6h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H15v5a1 1 0 01-1 1h-2a1 1 0 01-1-1H5a1 1 0 01-1 1H2a1 1 0 01-1-1V8H.5a.5.5 0 01-.5-.5v-1A.5.5 0 01.5 6h.99L3.6 3.2A3 3 0 016 2h4a3 3 0 012.4 1.2L14.5 6zM5.553 4.106A1 1 0 005.2 4.4L4 6h8l-1.2-1.6A1 1 0 0010 4H6a1 1 0 00-.447.106zM3 11h10V7.33L12.75 7h-9.5L3 7.33V11zm2-1a1 1 0 100-2 1 1 0 000 2zm6 0a1 1 0 100-2 1 1 0 000 2z"
  })
}));

/**
UiCarMinivanFilled icon

```jsx
import { UiCarMinivanFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarMinivanFilled />
```

 */
const UiCarMinivanFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-car-minivan-filled-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M23.71 14.29l-.71-.7V11a1.756 1.756 0 000-.2v-.19l-1.63-3.49A3 3 0 0019 5.36C17.7 5.21 14.29 5 11 5 8.6 5 6.92 7.24 5.7 8.88c-.28.394-.588.768-.92 1.12a6.08 6.08 0 00-2.93 1.05A4 4 0 000 14.44v1.12a3 3 0 002.05 2.84h.12l2.59.6A3 3 0 007 20a3 3 0 002.22-1h5.56a3.002 3.002 0 004.46 0l3.09-.35a2 2 0 001.67-2V15a.998.998 0 00-.29-.71zM7 18a1 1 0 110-2 1 1 0 010 2zm6-8H7.36c1-1.29 2.27-3 3.64-3h2v3zm1 0V7.05l2.15.1.71 2.85H14zm3 8a1 1 0 110-2 1 1 0 010 2zm.89-8l-.7-2.79 1.56.13a1 1 0 01.79.59l.92 2.07h-2.57z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-car-minivan-filled-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z"
      })
    })
  })]
}));

/**
UiCarMinivanLined icon

```jsx
import { UiCarMinivanLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarMinivanLined />
```

 */
const UiCarMinivanLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-car-minivan-lined-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M23.71 14.29l-.71-.7V11a1.756 1.756 0 000-.2v-.19l-1.63-3.49A3 3 0 0019 5.36C17.7 5.21 14.29 5 11 5 8.6 5 6.92 7.24 5.7 8.88c-.28.394-.588.768-.92 1.12a6.08 6.08 0 00-2.93 1.05A4 4 0 000 14.44v1.12a3 3 0 002.05 2.84h.12l2.59.6A3 3 0 007 20a3 3 0 002.22-1h5.56a3.002 3.002 0 004.46 0l3.09-.35a2 2 0 001.67-2V15a.998.998 0 00-.29-.71zm-5-6.95a1 1 0 01.79.59l.96 2.07h-2.57l-.7-2.79 1.52.13zM14 7.05l2.15.1.71 2.85H14V7.05zM11 7h2v3H7.36C8.33 8.71 9.63 7 11 7zM7 18a1 1 0 110-2 1 1 0 010 2zm10 0a1 1 0 110-2 1 1 0 010 2zm3-1.12a3 3 0 10-6 .12h-4a3.002 3.002 0 10-6-.22l-1.38-.29a1 1 0 01-.62-.93v-1.12a2 2 0 01.93-1.69A4.07 4.07 0 015 12h16v2a1 1 0 00.29.71l.72.72v1.22l-2.01.23z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-car-minivan-lined-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z"
      })
    })
  })]
}));

/**
UiCarSedanFilled icon

```jsx
import { UiCarSedanFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarSedanFilled />
```

 */
const UiCarSedanFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M21 11h-.59l-.05-.15C19.9 9.6 19 7 14 7c-4.26 0-5.89 1.88-7 3.13-.53.61-.78.87-1 .87a9.72 9.72 0 00-2.91.5A3 3 0 001 14.36v.2a3 3 0 002.05 2.85l1.06.35a3 3 0 005.71.24h4.36a3 3 0 005.68-.13l.63-.11a3 3 0 002.51-3V13a2 2 0 00-2-2zM7 18a1 1 0 110-2 1 1 0 010 2zm7-7H8.93c.92-1 2.15-2 5.07-2v2zm3 7a1 1 0 110-2 1 1 0 010 2zm-2-7V9.05c2.19.21 2.9 1.1 3.27 1.95H15z"
  })
}));

/**
UiCarSedanLined icon

```jsx
import { UiCarSedanLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarSedanLined />
```

 */
const UiCarSedanLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M21 11h-.59l-.05-.15C19.9 9.6 19 7 14 7c-4.26 0-5.89 1.88-7 3.13-.53.61-.78.87-1 .87a9.72 9.72 0 00-2.91.5A3 3 0 001 14.36v.2a3 3 0 002.05 2.85l1.06.35a3 3 0 005.71.24h4.36a3 3 0 005.68-.13l.63-.11a3 3 0 002.51-3V13a2 2 0 00-2-2zm-6-1.95c2.19.21 2.9 1.1 3.27 1.95H15V9.05zM14 9v2H8.93c.92-1 2.15-2 5.07-2zm-7 9a1 1 0 110-2 1 1 0 010 2zm10 0a1 1 0 110-2 1 1 0 010 2zm4-3.19a1 1 0 01-.83 1l-.4.07a3.001 3.001 0 00-5.59.14H9.82a3 3 0 00-5.52-.29l-.62-.2a1 1 0 01-.68-.97v-.2a1 1 0 01.7-.95A7.66 7.66 0 016 13h15v1.81z"
  })
}));

/**
UiCarSuvFilled icon

```jsx
import { UiCarSuvFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarSuvFilled />
```

 */
const UiCarSuvFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-car-suv-filled-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M24 10.88v-.12l-.86-3.45.6-.6a1 1 0 00.21-1.09A1 1 0 0023 5H10C8.3 5 7 6.9 5.86 8.57c-.326.502-.687.98-1.08 1.43a10.79 10.79 0 00-3.53.78A2 2 0 000 12.66v2.9a3 3 0 002.05 2.84h.12l2.59.6A3 3 0 007 20a3 3 0 002.22-1h5.56a3 3 0 004.46 0l3.09-.35a2 2 0 001.67-2v-5.77zM7 18a1 1 0 110-2 1 1 0 010 2zm6-8H7.31l.2-.3C8.11 8.82 9.36 7 10 7h3v3zm1 0V7h3.11l.75 3H14zm3 8a1 1 0 110-1.999 1 1 0 010 2zm1.89-8l-.75-3H21c-.01.08-.01.16 0 .24l.72 2.76h-2.83z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-car-suv-filled-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z"
      })
    })
  })]
}));

/**
UiCarSuvLined icon

```jsx
import { UiCarSuvLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarSuvLined />
```

 */
const UiCarSuvLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-car-suv-lined-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M24 10.88v-.12l-.86-3.45.6-.6a1 1 0 00.21-1.09A1 1 0 0023 5H10C8.3 5 7 6.9 5.86 8.57c-.326.502-.687.98-1.08 1.43a10.79 10.79 0 00-3.53.78A2 2 0 000 12.66v2.9a3 3 0 002.05 2.84h.12l2.59.6A3 3 0 007 20a3 3 0 002.22-1h5.56a3 3 0 004.46 0l3.09-.35a2 2 0 001.67-2v-5.77zM21 7c-.01.08-.01.16 0 .24l.72 2.76h-2.83l-.75-3H21zm-7 0h3.11l.75 3H14V7zM7.51 9.7C8.11 8.82 9.36 7 10 7h3v3H7.31l.2-.3zM7 18a1 1 0 110-2 1 1 0 010 2zm10 0a1 1 0 110-1.999 1 1 0 010 2zm3-1.12a3 3 0 10-6 .12h-4a3.002 3.002 0 10-6-.22l-1.38-.29a1 1 0 01-.62-.93v-2.9A8.69 8.69 0 015 12h17v4.65l-2 .23z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-car-suv-lined-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z"
      })
    })
  })]
}));

/**
UiCarTradeInFilled icon

```jsx
import { UiCarTradeInFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarTradeInFilled />
```

 */
const UiCarTradeInFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11.342 1.317A3 3 0 0112.4 2.2L13.75 4H2.25L3.6 2.2A3 3 0 016 1h4a3 3 0 011.342.317z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.707 12.707A1 1 0 014 13H2a1 1 0 01-1-1V7H.5a.5.5 0 01-.5-.5v-1A.5.5 0 01.5 5h15a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H15v2h-1a5 5 0 00-4 2l-.75 1H5a1 1 0 01-.293.707zm6.849-5.538a1 1 0 10-1.112 1.663 1 1 0 001.112-1.663zm-6 0a1 1 0 10-1.112 1.663 1 1 0 001.112-1.663z"
  }), /*#__PURE__*/jsx("path", {
    d: "M6 18.5a2.5 2.5 0 01-2.45-2H4a.5.5 0 00.46-.31.47.47 0 00-.11-.54l-1-1a.48.48 0 00-.7 0l-1 1a.47.47 0 00-.11.54.5.5 0 00.46.31h.55a3.5 3.5 0 003.45 3 .5.5 0 000-1zM19.581 6.063A2.5 2.5 0 0018 5.5a.5.5 0 010-1 3.5 3.5 0 013.45 3H22a.5.5 0 01.46.31.47.47 0 01-.11.54l-1 1a.48.48 0 01-.7 0l-1-1a.47.47 0 01-.11-.54.5.5 0 01.46-.31h.45a2.5 2.5 0 00-.869-1.437z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 15a.5.5 0 00-.5.5v1a.5.5 0 00.5.5H9v5a1 1 0 001 1h2a1 1 0 001-1h6a1 1 0 001 1h2a1 1 0 001-1v-5h.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-15zm4.5 4a1 1 0 110-2 1 1 0 010 2zm6 0a1 1 0 110-2 1 1 0 010 2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M14 11h4a3 3 0 012.4 1.2l1.35 1.8h-11.5l1.35-1.8A3 3 0 0114 11z"
  })]
}));

/**
UiCarTradeInLined icon

```jsx
import { UiCarTradeInLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarTradeInLined />
```

 */
const UiCarTradeInLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 13a1 1 0 001-1h4.25l.75-1c.283-.38.62-.717 1-1H3V6.33L3.25 6h9.5l.25.33v2.78A4.789 4.789 0 0114 9h1V7h.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1l-2.1-2.8A3 3 0 0010 1H6a3 3 0 00-2.4 1.2L1.49 5H.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5H1v5a1 1 0 001 1h2zm1.2-9.6A1 1 0 016 3h4a1 1 0 01.8.4L12 5H4l1.2-1.6z"
  }), /*#__PURE__*/jsx("path", {
    d: "M19.581 6.063A2.5 2.5 0 0018 5.5a.5.5 0 010-1 3.5 3.5 0 013.45 3H22a.5.5 0 01.46.31.47.47 0 01-.11.54l-1 1a.48.48 0 01-.7 0l-1-1a.47.47 0 01-.11-.54.5.5 0 01.46-.31h.45a2.5 2.5 0 00-.869-1.437zM6 8a1 1 0 11-2 0 1 1 0 012 0zm6 0a1 1 0 11-2 0 1 1 0 012 0zM6 18.5a2.5 2.5 0 01-2.45-2H4a.5.5 0 00.46-.31.47.47 0 00-.11-.54l-1-1a.48.48 0 00-.7 0l-1 1a.47.47 0 00-.11.54.5.5 0 00.46.31h.55a3.5 3.5 0 003.45 3 .5.5 0 000-1zm8-.5a1 1 0 11-2 0 1 1 0 012 0zm5 1a1 1 0 100-2 1 1 0 000 2z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 15h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H23v5a1 1 0 01-1 1h-2a1 1 0 01-1-1h-6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-5h-.51a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1l2.11-2.8A3 3 0 0114 11h4a3 3 0 012.4 1.2l2.1 2.8zm-8.947-1.894a.999.999 0 00-.353.294L12 15h8l-1.2-1.6a1 1 0 00-.8-.4h-4a.999.999 0 00-.447.106zM11 20h10v-3.67l-.25-.33h-9.5l-.25.33V20z"
  })]
}));

/**
UiCarTruckFilled icon

```jsx
import { UiCarTruckFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarTruckFilled />
```

 */
const UiCarTruckFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-car-truck-filled-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M23.71 14.29l-.71-.7V11a1 1 0 00-1-1h-8V6a1 1 0 00-1-1H9c-2.72 0-3.72 2.8-3.95 5H4c-.53.001-1.054.11-1.54.32A4.18 4.18 0 000 14.23v2.05a2 2 0 001.46 1.92l3.29.8a3 3 0 004.47 0h5.56a3 3 0 004.46 0l3.09-.35a2 2 0 001.67-2V15a1 1 0 00-.29-.71zM7 18a1 1 0 110-2 1 1 0 010 2zm5-8H7.08c.16-1.19.61-3 1.92-3h3v3zm5 8a1 1 0 110-2 1 1 0 010 2z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-car-truck-filled-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z"
      })
    })
  })]
}));

/**
UiCarTruckLined icon

```jsx
import { UiCarTruckLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarTruckLined />
```

 */
const UiCarTruckLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-car-truck-lined-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M23.71 14.29l-.71-.7V11a1 1 0 00-1-1h-8V6a1 1 0 00-1-1H9c-2.72 0-3.72 2.8-3.95 5H4c-.53.001-1.054.11-1.54.32A4.18 4.18 0 000 14.23v2.05a2 2 0 001.46 1.92l3.29.8a3 3 0 004.47 0h5.56a3 3 0 004.46 0l3.09-.35a2 2 0 001.67-2V15a1 1 0 00-.29-.71zM9 7h3v3H7.08c.16-1.19.61-3 1.92-3zM7 18a1 1 0 110-2 1 1 0 010 2zm10 0a1 1 0 110-2 1 1 0 010 2zm3-1.12a3 3 0 10-6 .12h-4a3.002 3.002 0 10-6-.25l-2-.47v-2.05a2.21 2.21 0 011.25-2.07A1.78 1.78 0 014 12h17v2a.998.998 0 00.29.71l.72.72v1.22l-2.01.23z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-car-truck-lined-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z"
      })
    })
  })]
}));

/**
UiCarVanFilled icon

```jsx
import { UiCarVanFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarVanFilled />
```

 */
const UiCarVanFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-car-van-filled-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M23.71 14.29l-.71-.7V6.41l.71-.7a1 1 0 00.21-1.09A1 1 0 0023 4H9C5.62 4 4.37 6.87 4.07 9H4a3.9 3.9 0 00-1.54.32A4.18 4.18 0 000 13.23v3.05a2 2 0 001.46 1.92l3.29.8a3 3 0 004.47 0h5.56a3 3 0 004.46 0l3.09-.35a2 2 0 001.67-2V15a1 1 0 00-.29-.71zM7 18a1 1 0 110-2 1 1 0 010 2zm4-9H6.1C6.31 7.81 7 6 9 6h2v3zm1 0V6h4v3h-4zm5 9a1 1 0 110-2 1 1 0 010 2zm4-9h-4V6h4v3z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-car-van-filled-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z"
      })
    })
  })]
}));

/**
UiCarVanLined icon

```jsx
import { UiCarVanLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarVanLined />
```

 */
const UiCarVanLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-car-van-lined-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M23.71 14.29l-.71-.7V6.41l.71-.7a1 1 0 00.21-1.09A1 1 0 0023 4H9C5.62 4 4.37 6.87 4.07 9H4a3.9 3.9 0 00-1.54.32A4.18 4.18 0 000 13.23v3.05a2 2 0 001.46 1.92l3.29.8a3 3 0 004.47 0h5.56a3 3 0 004.46 0l3.09-.35a2 2 0 001.67-2V15a1 1 0 00-.29-.71zM17 6h4v3h-4V6zm-5 0h4v3h-4V6zM9 6h2v3H6.1C6.31 7.81 7 6 9 6zM7 18a1 1 0 110-2 1 1 0 010 2zm10 0a1 1 0 110-2 1 1 0 010 2zm3-1.12a3 3 0 10-6 .12h-4a3.002 3.002 0 10-6-.25l-2-.47v-3.05a2.21 2.21 0 011.25-2.07A1.78 1.78 0 014 11h17v3a.998.998 0 00.29.71l.72.72v1.22l-2.01.23z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-car-van-lined-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z"
      })
    })
  })]
}));

/**
UiCarWagonFilled icon

```jsx
import { UiCarWagonFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarWagonFilled />
```

 */
const UiCarWagonFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-car-wagon-filled-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M24 12a.713.713 0 000-.2.67.67 0 00-.05-.19l-2-4A1 1 0 0021 7h-9a1 1 0 00-.55.17l-5.84 3.89-4.09.78A2 2 0 000 13.78v1.87a2 2 0 001.72 2l2.44.28A3 3 0 007 20a3 3 0 002.82-2h4.36a3 3 0 005.66-.08l1.65-.16a3 3 0 002.51-3V12zM7 18a1 1 0 110-2 1 1 0 010 2zm8-7H9.3l3-2H15v2zm2 7a1 1 0 110-2 1 1 0 010 2zm-1-7V9h4.38l1 2H16z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-car-wagon-filled-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z"
      })
    })
  })]
}));

/**
UiCarWagonLined icon

```jsx
import { UiCarWagonLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCarWagonLined />
```

 */
const UiCarWagonLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-car-wagon-lined-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M24 12a.713.713 0 000-.2.67.67 0 00-.05-.19l-2-4A1 1 0 0021 7h-9a1 1 0 00-.55.17l-5.84 3.89-4.09.78A2 2 0 000 13.78v1.87a2 2 0 001.72 2l2.44.28A3 3 0 007 20a3 3 0 002.82-2h4.36a3 3 0 005.66-.08l1.65-.16a3 3 0 002.51-3V12zm-8-3h4.38l1 2H16V9zm-3.7 0H15v2H9.3l3-2zM7 18a1 1 0 110-2 1 1 0 010 2zm10 0a1 1 0 110-2 1 1 0 010 2zm5-3.19a1 1 0 01-.77 1l-1.44.14a3 3 0 00-5.61.08H9.82a3 3 0 00-5.61-.1L2 15.65v-1.86L6.09 13H22v1.81z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-car-wagon-lined-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z"
      })
    })
  })]
}));

/**
UiCardDamagedFilled icon

```jsx
import { UiCardDamagedFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCardDamagedFilled />
```

 */
const UiCardDamagedFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M20 5h-4.64l-1.33 4H21v3h-4.14c0 .3-.03.6-.12.89L14.1 21H20c1.66 0 3-1.34 3-3V8c0-1.66-1.34-3-3-3z"
  }), /*#__PURE__*/jsx("path", {
    d: "M11.7 22.31l3.25-10a1 1 0 00-.14-.9A1 1 0 0014 11h-2.61l2.56-7.68c.17-.52-.11-1.09-.63-1.27a.988.988 0 00-1.26.63L11.61 4H4C2.34 4 1 5.34 1 7v10c0 1.66 1.34 3 3 3h6.35l-.55 1.69a1.001 1.001 0 00.95 1.31c.42 0 .81-.27.95-.69zM3 11V8h7.28l-1 3H3zm6 5H5c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1z"
  })]
}));

/**
UiCardDamagedFilledSmall icon

```jsx
import { UiCardDamagedFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCardDamagedFilledSmall />
```

 */
const UiCardDamagedFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M14 3.015h-2.45l-.57 1.998H11c.94 0 1.83.44 2.4 1.188.57.75.75 1.728.49 2.627l-1.77 6.173H14c1.1 0 2-.899 2-1.997V5.013c0-1.099-.9-1.998-2-1.998z"
  }), /*#__PURE__*/jsx("path", {
    d: "M9 16c.43 0 .83-.29.96-.73l2-6.991c.09-.3.03-.63-.16-.879-.19-.25-.49-.4-.8-.4H8.33l1.64-5.723A1.01 1.01 0 009.28.038c-.53-.15-1.08.15-1.24.69l-.37 1.288H2c-1.1 0-2 .9-2 1.998v7.99c0 1.1.9 1.998 2 1.998h6.25l-.21.73a1.01 1.01 0 00.69 1.238c.09.02.18.03.27.03zM1 7.01V5.013h5.82L6.25 7.01H1zm5.37 4.375h-3c-.28 0-.5-.22-.5-.5 0-.279.22-.498.5-.498h3c.28 0 .5.22.5.499 0 .28-.23.5-.5.5z"
  })]
}));

/**
UiCardDamagedLined icon

```jsx
import { UiCardDamagedLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCardDamagedLined />
```

 */
const UiCardDamagedLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9.5 14H6c-.55 0-1 .45-1 1s.45 1 1 1h3.5c.55 0 1-.45 1-1s-.45-1-1-1zM20 5h-5.41l-.5 2H20c.55 0 1 .45 1 1v1h-4.79c.06.07.14.13.2.21.57.76.74 1.74.47 2.65L16.53 13H21v5c0 .55-.45 1-1 1h-5.27l-.6 2H20c1.65 0 3-1.35 3-3V8c0-1.65-1.35-3-3-3z"
  }), /*#__PURE__*/jsx("path", {
    d: "M11 22c.43 0 .83-.28.96-.71l3-10a.99.99 0 00-.16-.88c-.19-.25-.49-.4-.8-.4h-2.72l1.69-6.76c.13-.53-.19-1.06-.71-1.21-.01 0-.01-.01-.02-.01a.995.995 0 00-1.21.73L10.72 4H4C2.35 4 1 5.35 1 7v10c0 1.65 1.35 3 3 3h6.26l-.21.71c-.15.52.13 1.05.64 1.23.01 0 .02.01.03.02.09.03.19.04.28.04zM3 7c0-.55.45-1 1-1h6.22l-.5 2H3V7zm1 11c-.55 0-1-.45-1-1v-5h9.66l-1.8 6H4z"
  })]
}));

/**
UiCardDamagedLinedSmall icon

```jsx
import { UiCardDamagedLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCardDamagedLinedSmall />
```

 */
const UiCardDamagedLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M14 3.013h-2.97l-.57 1.997H14v7.985h-1.83l-.57 1.997H14c1.1 0 2-.899 2-1.997V5.01c0-1.098-.9-1.997-2-1.997zM6.5 10h-3c-.28 0-.5.22-.5.5s.22.499.5.499h3c.28 0 .5-.22.5-.5a.5.5 0 00-.5-.498z"
  }), /*#__PURE__*/jsx("path", {
    d: "M9.96 15.261l2-6.987c.09-.3.03-.63-.16-.879-.19-.25-.49-.399-.8-.399H8.33l1.64-5.72A.986.986 0 009.35.078c-.02-.01-.04-.03-.07-.04-.53-.15-1.08.15-1.24.69l-.37 1.287H2c-1.1 0-2 .898-2 1.996v7.986c0 1.098.9 1.997 2 1.997h6.25l-.21.728A1.01 1.01 0 009.01 16c.43-.01.83-.3.95-.739zM6.72 4.011l-.25.999H2v-1h4.72zM2 11.997V8.004h4.03c0 .21.04.43.18.6.19.249.49.398.8.398h2.65l-.03.18-.81 2.815H2z"
  })]
}));

/**
UiCardDeliveryFilled icon

```jsx
import { UiCardDeliveryFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCardDeliveryFilled />
```

 */
const UiCardDeliveryFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20.282 4H7.227c-1.306 0-2.511.8-3.013 2h-2.21C1.402 6 1 6.4 1 7s.402 1 1.004 1h1.808l-.2 2.5H2.003c-.602 0-1.004.4-1.004 1s.402 1 1.004 1H3.41l-.2 2.5H2.003C1.402 15 1 15.4 1 16s.402 1 1.004 1H3.21c.302 1.2 1.306 2 2.612 2h13.055c1.708 0 3.114-1.3 3.315-3l.803-9c.1-1.7-1.105-3-2.712-3zM9.537 15H6.524c-.302 0-.503-.2-.503-.5s.201-.5.503-.5h3.013c.3 0 .502.2.502.5s-.201.5-.502.5zM5.62 10l.2-2.8c0-.1 0-.1.101-.2h14.964l-.301 3H5.62z"
  })
}));

/**
UiCardDeliveryFilledSmall icon

```jsx
import { UiCardDeliveryFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCardDeliveryFilledSmall />
```

 */
const UiCardDeliveryFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-card-delivery-filled-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M14.2 2h-10c-1.1 0-2.1.9-2.3 2H.5c-.3 0-.5.2-.5.5s.2.5.5.5h1.3l-.3 2h-1c-.3 0-.5.2-.5.5s.2.5.5.5h.9l-.3 2H.5c-.3 0-.5.2-.5.5s.2.5.5.5H1c-.1 1.1.6 2 1.7 2h10c1.1 0 2.1-.9 2.3-2l1-7c.1-1.1-.7-2-1.8-2zm-7.7 8h-3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3c.3 0 .5.2.5.5s-.2.5-.5.5zm8.1-3h-12l.3-2h12l-.3 2z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-card-delivery-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiCardDeliveryLined icon

```jsx
import { UiCardDeliveryLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCardDeliveryLined />
```

 */
const UiCardDeliveryLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.227 4h13.055c1.607 0 2.813 1.3 2.712 3l-.803 9c-.201 1.7-1.607 3-3.314 3H5.82c-1.306 0-2.31-.8-2.612-2H2.004C1.402 17 1 16.6 1 16s.402-1 1.004-1H3.21l.201-2.5H2.004c-.602 0-1.004-.4-1.004-1s.402-1 1.004-1h1.607L3.812 8H2.004C1.402 8 1 7.6 1 7s.402-1 1.004-1h2.21a3.29 3.29 0 013.013-2zm13.055 2H7.227c-.703 0-1.306.5-1.306 1.2l-.1.8h15.064l.201-1.2c0-.3-.1-.5-.2-.6-.202-.1-.403-.2-.604-.2zM5.821 17h13.056c.703 0 1.305-.5 1.405-1.2l.302-3.8H5.519l-.502 4.2c0 .3.1.5.201.6.2.1.402.2.603.2zM7.5 14h3c.3 0 .5.2.5.5s-.2.5-.5.5h-3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5z"
  })
}));

/**
UiCardDeliveryLinedSmall icon

```jsx
import { UiCardDeliveryLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCardDeliveryLinedSmall />
```

 */
const UiCardDeliveryLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.157 2c.502 0 1.104.2 1.405.6.402.4.502 1 .402 1.5l-.904 7c-.1 1.1-1.004 1.9-2.108 1.9H2.912c-.502 0-1.105-.2-1.506-.6-.302-.4-.402-.9-.402-1.4H.502C.201 11 0 10.8 0 10.5s.2-.5.502-.5h.703l.2-2H.503C.201 8 0 7.8 0 7.5S.2 7 .502 7h1.104v-.1l.1-1 .101-.9H.502C.201 5 0 4.8 0 4.5S.2 4 .502 4h1.506v-.1C2.108 2.8 3.012 2 4.116 2h10.04zm-.1 2h-9.94c-.101 0-.101.1-.101.1l-.1.9h10.04l.1-1zM3.011 11h9.94c.1 0 .1-.1.1-.1l.402-2.9H3.414l-.402 3zM4.5 9h2c.3 0 .5.2.5.5s-.2.5-.5.5h-2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5z"
  })
}));

/**
UiCardFilled icon

```jsx
import { UiCardFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCardFilled />
```

 */
const UiCardFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 4H4C2.34 4 1 5.34 1 7v10c0 1.66 1.34 3 3 3h16c1.66 0 3-1.34 3-3V7c0-1.66-1.34-3-3-3zM9 16H5c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1zm12-5H3V8h18v3z"
  })
}));

/**
UiCardFilledSmall icon

```jsx
import { UiCardFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCardFilledSmall />
```

 */
const UiCardFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2h12c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2zM1 7h14V5H1v2zm2.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3z"
  })
}));

/**
UiCardLined icon

```jsx
import { UiCardLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCardLined />
```

 */
const UiCardLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M6 14h4c.55 0 1 .45 1 1s-.45 1-1 1H6c-.55 0-1-.45-1-1s.45-1 1-1z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4h16c1.66 0 3 1.34 3 3v10c0 1.66-1.34 3-3 3H4c-1.66 0-3-1.34-3-3V7c0-1.66 1.34-3 3-3zm16 2H4c-.55 0-1 .45-1 1v1h18V7c0-.55-.45-1-1-1zM4 18h16c.55 0 1-.45 1-1v-5H3v5c0 .55.45 1 1 1z"
  })]
}));

/**
UiCardLinedSmall icon

```jsx
import { UiCardLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCardLinedSmall />
```

 */
const UiCardLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2h12c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2zm12 3V4H2v1h12zM2 8v4h12V8H2zm1.5 2a.5.5 0 000 1h3a.5.5 0 000-1h-3z"
  })
}));

/**
UiCardMissingLined icon

```jsx
import { UiCardMissingLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCardMissingLined />
```

 */
const UiCardMissingLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9.002 9a1 1 0 100-2 1 1 0 000 2zm5-1a1 1 0 11-2 0 1 1 0 012 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.002 10h-1c-.3-3.9-2.5-8-8-8-5.9 0-8 4.8-8 9 0 1.71-.632 2.97-1.21 4.12l-.09.18c-.7 1.3-1.3 2.7-.6 4.1.6 1.2 1.7 1 2.3.8.4-.1.9-.2 1.6-.2.4 0 .4 0 .6.4.3.6.8 1.6 2.4 1.6 1.2 0 1.9-.3 2.4-.6.086-.034.166-.069.243-.102.375-.16.694-.298 1.357-.298.5 0 .8.2 1.2.5l.086.065c.398.302.97.735 1.714.735.4 0 .9-.1 1.4-.4 1.2-.6 1.8-2.1 2.2-3.9h1.4c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zm0 6h-6v-.5c.4-.4.8-.9 1.2-1.4h4.8V16zm-4.5-3c0-.3-.1-.7-.2-1h4.8v1h-4.6zm.1 7.1c-.533.266-.592.217-.95-.077l-.15-.123c-.5-.4-1.2-.9-2.4-.9s-1.9.3-2.4.6c-.135.045-.255.09-.369.133-.391.147-.711.267-1.33.267-.192 0-.292 0-.366-.044-.08-.047-.13-.147-.235-.356-.3-.6-.8-1.6-2.4-1.6-.921 0-1.588.17-2 .275l-.1.025h-.1c-.1-.5.2-1.1.7-2.1.7-1.3 1.5-3 1.5-5.2 0-3.4 1.6-7 6-7 4 0 5.7 2.9 5.9 6h-2.9c-.7 0-1.4.4-1.7 1h-2.3c-.6 0-1 .4-1 1s.4 1 1 1h3.5c-.8 1.3-2 2-3.5 2-.6 0-1 .4-1 1s.4 1 1 1c.7 0 1.5-.1 2.1-.4.3.8 1 1.4 1.9 1.4h2.6c-.2 1.1-.5 1.9-1 2.1z"
  })]
}));

/**
UiCardMissingLinedSmall icon

```jsx
import { UiCardMissingLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCardMissingLinedSmall />
```

 */
const UiCardMissingLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M7 7a1 1 0 100-2 1 1 0 000 2zm4-1a1 1 0 11-2 0 1 1 0 012 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 1C5 1 3 2.9 3 7c0 1.1-.5 1.9-1 2.7l-.078.129c-.587.974-1.288 2.135-.522 3.571.6 1.2 1.8.9 2.5.7.15 0 .325-.025.5-.05s.35-.05.5-.05c.029 0 .05 0 .068.005.049.011.09.052.232.195.3.3.8.8 1.8.8.742 0 1.264-.275 1.688-.499.147-.078.283-.15.412-.201.1-.2.3-.3.4-.3.1 0 .3.2.4.3.3.3.9.7 1.6.7.3 0 .7-.1 1.1-.3C14.9 13.4 15 7.1 15 7c0-3-1.7-6-5.5-6zm2.1 11.9c-.05 0-.075 0-.087.012-.013.013-.013.038-.013.088-.1 0-.3-.2-.4-.3-.3-.3-.8-.7-1.6-.7-.548 0-.974.246-1.325.448a5.46 5.46 0 01-.275.152c-.4.3-.6.4-.9.4-.1 0-.2 0-.4-.3-.3-.3-.7-.7-1.5-.7-.565-.08-1.065.034-1.5.134a9.935 9.935 0 01-.3.066c-.05 0-.1.025-.15.05-.05.025-.1.05-.15.05-.097-.386.087-.68.55-1.42l.05-.08C4.2 9.9 5 8.7 5 7c0-2.6.7-4 4.5-4C12.8 3 13 6.3 13 7c0 2.5-.8 5.6-1.4 5.9z"
  })]
}));

/**
UiCardRecurringChargeFilled icon

```jsx
import { UiCardRecurringChargeFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCardRecurringChargeFilled />
```

 */
const UiCardRecurringChargeFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M19.5 11c1.28 0 2.47.35 3.5.94V6c0-1.66-1.34-3-3-3H4C2.34 3 1 4.34 1 6v10c0 1.66 1.34 3 3 3h8.58c-.05-.33-.08-.66-.08-1 0-3.87 3.13-7 7-7zM3 10V7h18v3H3zm6 5H5c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M22.25 13c-.41 0-.75.34-.75.75v.45c-.04-.05-.08-.11-.13-.16-.48-.51-1.17-.91-1.93-1.02-.4-.05-.71-.04-1.05-.01-.34.03-.68.09-1.03.21-.69.2-1.38.72-1.75 1.39-.17.32-.09.73.21.96.33.25.8.18 1.05-.15l.02-.02c.25-.33.55-.56.97-.71.21-.07.44-.12.68-.15.24-.03.52-.03.7-.01.56.05 1.11.44 1.53.97h-1.01c-.41 0-.75.34-.75.75s.34.75.75.75h2.5c.41 0 .75-.34.75-.75v-2.5a.77.77 0 00-.76-.75zm-1.12 6.58l-.02.02c-.25.33-.55.56-.97.71-.21.07-.44.12-.68.15-.24.03-.52.03-.7.01-.56-.05-1.11-.44-1.53-.97h1.01c.41 0 .75-.34.75-.75s-.33-.75-.74-.75h-2.5c-.41 0-.75.34-.75.75v2.5c0 .41.34.75.75.75s.75-.34.75-.75v-.45c.04.05.08.11.13.16.48.51 1.17.91 1.93 1.02.4.05.71.04 1.05.01.34-.03.68-.09 1.03-.21.69-.2 1.38-.72 1.75-1.39.17-.32.09-.73-.21-.96a.76.76 0 00-1.05.15z"
  })]
}));

/**
UiCardRecurringChargeLined icon

```jsx
import { UiCardRecurringChargeLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCardRecurringChargeLined />
```

 */
const UiCardRecurringChargeLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M22.25 13c-.41 0-.75.34-.75.75v.45c-.04-.05-.08-.11-.13-.16-.48-.51-1.17-.91-1.93-1.02-.4-.05-.71-.04-1.05-.01-.34.03-.68.09-1.03.21-.69.2-1.38.72-1.75 1.39-.17.32-.09.73.21.96.33.25.8.18 1.05-.15l.02-.02c.25-.33.55-.56.97-.71.21-.07.44-.12.68-.15.24-.03.52-.03.7-.01.56.05 1.11.44 1.53.97h-1.01c-.41 0-.75.34-.75.75s.34.75.75.75h2.5c.41 0 .75-.34.75-.75v-2.5a.77.77 0 00-.76-.75zm-1.12 6.58l-.02.02c-.25.33-.55.56-.97.71-.21.07-.44.12-.68.15-.24.03-.52.03-.7.01-.56-.05-1.11-.44-1.53-.97h1.01c.41 0 .75-.34.75-.75s-.33-.75-.74-.75h-2.5c-.41 0-.75.34-.75.75v2.5c0 .41.34.75.75.75s.75-.34.75-.75v-.45c.04.05.08.11.13.16.48.51 1.17.91 1.93 1.02.4.05.71.04 1.05.01.34-.03.68-.09 1.03-.21.69-.2 1.38-.72 1.75-1.39.17-.32.09-.73-.21-.96a.76.76 0 00-1.05.15z"
  }), /*#__PURE__*/jsx("path", {
    d: "M20 3H4C2.35 3 1 4.35 1 6v10c0 1.65 1.35 3 3 3h8c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1-.45-1-1v-5h19c.55 0 1-.45 1-1V6c0-1.65-1.35-3-3-3zM3 6c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v1H3V6z"
  }), /*#__PURE__*/jsx("path", {
    d: "M6 13c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1H6z"
  })]
}));

/**
UiCashGenericFilled icon

```jsx
import { UiCashGenericFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCashGenericFilled />
```

 */
const UiCashGenericFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22 5H2c-.6 0-1 .4-1 1v12c0 .6.4 1 1 1h20c.6 0 1-.4 1-1V6c0-.6-.4-1-1-1zM3.5 12c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1-1-.4-1-1zM8 12c0-2.2 1.8-4 4-4s4 1.8 4 4-1.8 4-4 4-4-1.8-4-4zm10.5 0c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1-1-.4-1-1z"
  })
}));

/**
UiCashGenericFilledSmall icon

```jsx
import { UiCashGenericFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCashGenericFilledSmall />
```

 */
const UiCashGenericFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M15 3H1c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V4c0-.6-.4-1-1-1zm-4 5c0 1.7-1.3 3-3 3S5 9.7 5 8s1.3-3 3-3 3 1.3 3 3zM2.5 7c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zm11 2c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
  })
}));

/**
UiCashGenericLined icon

```jsx
import { UiCashGenericLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCashGenericLined />
```

 */
const UiCashGenericLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 12c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4 4 1.8 4 4zm-2 0c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M5.5 13a1 1 0 100-2 1 1 0 000 2zm14-1a1 1 0 11-2 0 1 1 0 012 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5h20c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1H2c-.6 0-1-.4-1-1V6c0-.6.4-1 1-1zm1 2v10h18V7H3z"
  })]
}));

/**
UiCashGenericLinedSmall icon

```jsx
import { UiCashGenericLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCashGenericLinedSmall />
```

 */
const UiCashGenericLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 3h14c.6 0 1 .4 1 1v8c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V4c0-.6.4-1 1-1zm1 2v6h12V5H2zm8 3a2 2 0 11-4 0 2 2 0 014 0zM4 9a1 1 0 100-2 1 1 0 000 2zm9-1a1 1 0 11-2 0 1 1 0 012 0z"
  })
}));

/**
UiCashUkFilled icon

```jsx
import { UiCashUkFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCashUkFilled />
```

 */
const UiCashUkFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22 5H2c-.6 0-1 .4-1 1v12c0 .6.4 1 1 1h20c.6 0 1-.4 1-1V6c0-.6-.4-1-1-1zM5 13c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm9.7-2.8c-.4.2-.8.1-1-.3-.1-.2-.4-.4-.7-.4-.4 0-.8.3-.8.8v1.2h.8c.4 0 .8.3.8.8s-.4.7-.8.7h-.8v.1c0 .6-.1 1-.4 1.4H14c.4 0 .8.3.8.8s-.4.7-.8.7h-4c-.4 0-.7-.3-.7-.6-.1-.4.1-.7.4-.8 0 0 1-.5 1-1.5V13H10c-.4 0-.8-.3-.8-.8s.4-.7.8-.7h.8v-1.3C10.8 9 11.8 8 13 8c.8 0 1.6.4 2 1.1.2.4 0 .9-.3 1.1zM19 13c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
  })
}));

/**
UiCashUkFilledSmall icon

```jsx
import { UiCashUkFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCashUkFilledSmall />
```

 */
const UiCashUkFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M15 3H1c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V4c0-.6-.4-1-1-1zM2.5 7c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zm11 2c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zM11 5.1c.2.4.1.8-.3 1-.4.2-.8.1-1-.3-.2-.2-.4-.3-.7-.3-.4 0-.8.3-.8.8v1.2H9c.4 0 .8.3.8.8S9.4 9 9 9h-.8v.1c0 .6-.1 1-.4 1.4H10c.4 0 .8.3.8.8s-.4.7-.8.7H6c-.4 0-.7-.3-.7-.6-.1-.4.1-.7.4-.8 0 0 1-.5 1-1.5V9H6c-.4 0-.8-.3-.8-.8s.4-.7.8-.7h.8V6.2C6.8 5 7.8 4 9 4c.8 0 1.6.4 2 1.1z"
  })
}));

/**
UiCashUkLined icon

```jsx
import { UiCashUkLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCashUkLined />
```

 */
const UiCashUkLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M7 12a1 1 0 11-2 0 1 1 0 012 0zm11 1a1 1 0 100-2 1 1 0 000 2zm-7.2 0H10c-.4 0-.8-.3-.8-.8s.4-.8.8-.8h.8v-1.2C10.8 9 11.8 8 13 8c.8 0 1.6.4 2 1.1.2.4 0 .9-.3 1-.3.2-.8.1-1-.3-.2-.3-.4-.4-.7-.4-.5 0-.8.4-.8.8v1.3h.8c.4 0 .8.2.8.7 0 .5-.4.8-.8.8h-.7v.1c0 .5-.2 1-.4 1.4H14c.4 0 .8.2.8.7 0 .5-.4.8-.8.8h-4c-.4 0-.7-.3-.7-.6-.1-.4.1-.7.5-.8 0 0 1-.5 1-1.5V13z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5h20c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1H2c-.6 0-1-.4-1-1V6c0-.6.4-1 1-1zm1 12h18V7H3v10z"
  })]
}));

/**
UiCashUsFilled icon

```jsx
import { UiCashUsFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCashUsFilled />
```

 */
const UiCashUsFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5h20c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1H2c-.6 0-1-.4-1-1V6c0-.6.4-1 1-1zm3 6c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zm14 0c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zm-5.9.58c.88.3 1.41 1.01 1.41 1.94 0 1.18-.86 1.86-1.75 1.95v.02c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-.16a4.76 4.76 0 01-1.14-.45.751.751 0 11.8-1.27c.14.08.77.38 1.58.38.08 0 .5-.02.5-.49 0-.2-.03-.4-.42-.53l-.98-.38-.44-.17c-1.16-.38-1.41-1.27-1.41-1.94 0-.99.69-1.63 1.5-1.87V8.5c0-.41.34-.75.75-.75s.75.34.75.75v.1c.65.155 1.103.48 1.193.545l.007.005c.33.25.4.72.15 1.05-.24.32-.68.39-1.01.17-.005-.005-.01-.007-.015-.01a.044.044 0 01-.015-.01l-.014-.009c-.085-.055-.531-.341-1.036-.341-.01 0-.75.01-.75.49 0 .34.09.42.42.53l.78.31.64.25z"
  })
}));

/**
UiCashUsFilledSmall icon

```jsx
import { UiCashUsFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCashUsFilledSmall />
```

 */
const UiCashUsFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 3h14c.6 0 1 .4 1 1v8c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V4c0-.6.4-1 1-1zm.5 5c0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1-1 .4-1 1zm11 0c0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1-1 .4-1 1zm-3.4-.42c.88.3 1.41 1.01 1.41 1.94 0 1.18-.86 1.86-1.75 1.95v.02c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-.16a4.76 4.76 0 01-1.14-.45.751.751 0 11.8-1.27c.14.08.77.38 1.58.38.08 0 .5-.02.5-.49 0-.2-.03-.4-.42-.53l-.98-.38-.44-.17C6 8.04 5.75 7.15 5.75 6.48c0-.99.69-1.63 1.5-1.87V4.5c0-.41.34-.75.75-.75s.75.34.75.75v.1c.65.155 1.103.48 1.193.545l.007.005c.33.25.4.72.15 1.05a.741.741 0 01-1.025.16c-.005-.003-.01-.005-.015-.01l-.014-.009C8.96 6.286 8.515 6 8.01 6c-.01 0-.75.01-.75.49 0 .34.09.42.42.53l.78.31.64.25z"
  })
}));

/**
UiCashUsLined icon

```jsx
import { UiCashUsLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCashUsLined />
```

 */
const UiCashUsLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M6 13a1 1 0 100-2 1 1 0 000 2zm13-1a1 1 0 11-2 0 1 1 0 012 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5h20c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1H2c-.6 0-1-.4-1-1V6c0-.6.4-1 1-1zm1 12h18V7H3v10z"
  }), /*#__PURE__*/jsx("path", {
    d: "M14.51 13.52c0-.93-.53-1.64-1.41-1.94l-.64-.25-.78-.31c-.33-.11-.42-.19-.42-.53 0-.48.74-.49.75-.49.55 0 1.03.34 1.05.35.01.01.02.01.03.02.33.22.77.15 1.01-.17a.75.75 0 00-.15-1.05c-.07-.05-.53-.39-1.2-.55v-.1c0-.41-.34-.75-.75-.75s-.75.34-.75.75v.11c-.81.24-1.5.88-1.5 1.87 0 .67.25 1.56 1.41 1.94l.44.17.98.38c.39.13.42.33.42.53 0 .47-.42.49-.5.49-.81 0-1.44-.3-1.58-.38a.751.751 0 10-.8 1.27c.07.04.49.28 1.14.45v.16c0 .41.34.75.75.75s.75-.34.75-.75v-.02c.89-.09 1.75-.77 1.75-1.95z"
  })]
}));

/**
UiCautionCircleFilled icon

```jsx
import { UiCautionCircleFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCautionCircleFilled />
```

 */
const UiCautionCircleFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zM6 13c0 .55.45 1 1 1h10c.56 0 1-.44 1-1v-2c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v2z"
  })
}));

/**
UiCautionCircleFilledSmall icon

```jsx
import { UiCautionCircleFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCautionCircleFilledSmall />
```

 */
const UiCautionCircleFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-12.5.5c0 .55.45 1 1 1h7c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1h-7c-.55 0-1 .45-1 1v1z"
  })
}));

/**
UiCautionCircleLined icon

```jsx
import { UiCautionCircleLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCautionCircleLined />
```

 */
const UiCautionCircleLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M4 11c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v2z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zM2 10a8 8 0 1116 0 8 8 0 01-16 0z"
  })]
}));

/**
UiCautionCircleLinedSmall icon

```jsx
import { UiCautionCircleLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCautionCircleLinedSmall />
```

 */
const UiCautionCircleLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M3.5 8.5c0 .55.45 1 1 1h7c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1h-7c-.55 0-1 .45-1 1v1z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0a8 8 0 100 16A8 8 0 008 0zM2 8a6 6 0 1112 0A6 6 0 012 8z"
  })]
}));

/**
UiCautionTriangleFilled icon

```jsx
import { UiCautionTriangleFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCautionTriangleFilled />
```

 */
const UiCautionTriangleFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22.23 17.01L13.98 2.99c-.36-.62-1.01-.99-1.72-.99s-1.37.37-1.73.99L2.28 17.01c-.37.63-.37 1.38-.01 2.01A1.98 1.98 0 004 20.03h16.5c.73 0 1.38-.38 1.74-1.01.36-.63.36-1.38-.01-2.01zm-9.97-2.23a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm-1-2.5V8.03c0-.55.45-1 1-1s1 .45 1 1v4.25c0 .55-.45 1-1 1s-1-.45-1-1z"
  })
}));

/**
UiCautionTriangleFilledSmall icon

```jsx
import { UiCautionTriangleFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCautionTriangleFilledSmall />
```

 */
const UiCautionTriangleFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M15.7 11.8L9.7 1C8.9-.3 7.1-.3 6.3 1l-6 10.8C-.5 13.2.5 15 2.2 15h11.7c1.6 0 2.6-1.8 1.8-3.2zM7 5c0-.5.5-1 1-1s1 .4 1 1v3.6c0 .5-.5 1-1 1s-1-.4-1-1V5zm1 8.2c-.7 0-1.2-.6-1.2-1.2 0-.7.6-1.2 1.2-1.2.7 0 1.2.6 1.2 1.2 0 .7-.5 1.2-1.2 1.2z"
  })
}));

/**
UiCautionTriangleLined icon

```jsx
import { UiCautionTriangleLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCautionTriangleLined />
```

 */
const UiCautionTriangleLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12.26 16.78a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm-1-4.5V8.53c0-.56.45-1 1-1s1 .45 1 1v3.75c0 .55-.45 1-1 1s-1-.45-1-1z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.23 17.01L13.98 2.99c-.36-.62-1.01-.99-1.72-.99s-1.37.37-1.73.99L2.28 17.01c-.37.63-.37 1.38-.01 2.01A1.98 1.98 0 004 20.03h16.5c.73 0 1.38-.38 1.74-1.01.36-.63.36-1.38-.01-2.01zM4 18.03L12.25 4l8.25 14.03H4z"
  })]
}));

/**
UiCertifiedLined icon

```jsx
import { UiCertifiedLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCertifiedLined />
```

 */
const UiCertifiedLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M10.9 13l3.3-4.1c.4-.5 1-.5 1.4-.2.5.3.5 1 .2 1.4l-4 5c-.2.2-.4.4-.7.4H11c-.3 0-.5-.1-.7-.3l-2-2c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l1.2 1.2z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9 9.4L21.5 12l1.2 2.6c.2.3.2.5.1.8-.1.3-.3.5-.5.6l-2.8 1.4-.5 2.9c-.1.5-.6.9-1.1.8l-3.1-.4-2.2 2.1c-.2.2-.5.3-.7.3-.3 0-.5-.1-.7-.3L9 20.7l-3.1.4c-.5.1-1-.3-1.1-.8l-.5-2.9L1.5 16c-.2-.1-.4-.3-.5-.6 0-.3 0-.5.1-.8L2.5 12 1.1 9.4C1 9.1 1 8.9 1 8.6c.1-.3.3-.5.6-.6l2.7-1.4.6-2.9c.1-.5.6-.9 1.1-.8l3.1.5 2.3-2.2c.4-.4 1-.4 1.4 0L15 3.3l3.1-.4c.5-.1 1 .3 1.1.8l.5 2.9L22.5 8c.2.1.4.3.5.6 0 .3 0 .5-.1.8zM5 12c0 3.9 3.1 7 7 7s7-3.1 7-7-3.1-7-7-7-7 3.1-7 7z"
  })]
}));

/**
UiCertifiedLinedSmall icon

```jsx
import { UiCertifiedLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCertifiedLinedSmall />
```

 */
const UiCertifiedLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsxs("g", {
    clipPath: "url(#omni-gravity-icon-ui-certified-lined-small-a)",
    children: [/*#__PURE__*/jsx("path", {
      d: "M7 8.6l2.5-2.8c.4-.4.9-.4 1.4 0 .5.4.5 1 .1 1.4l-3.3 3.5c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3L4.8 9.2c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l.8.8z"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.9 6.3L15 8l.8 1.6c.2.3.2.5.1.8-.1.3-.3.5-.5.6l-1.8.9-.3 1.9c-.1.5-.6.9-1.1.8l-2-.3-1.5 1.4c-.2.2-.5.3-.7.3-.2 0-.5-.1-.8-.2l-1.5-1.4-2 .3c-.5.1-1-.3-1.1-.8L2.3 12l-1.8-.9c-.2-.1-.4-.3-.5-.6 0-.3 0-.6.1-.8L1 8 .1 6.3c-.1-.2-.2-.6-.1-.8.1-.2.3-.4.6-.6l1.8-.8.4-2c.1-.5.6-.9 1.1-.8l2 .3L7.3.3c.4-.4 1-.4 1.4 0l1.6 1.3 2-.3c.5-.1 1 .3 1.1.8l.3 1.9 1.8.9c.2.1.5.3.5.6s0 .6-.1.8zM3 8c0 2.8 2.2 5 5 5s5-2.2 5-5-2.2-5-5-5-5 2.2-5 5z"
    })]
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-certified-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiChatFilled icon

```jsx
import { UiChatFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChatFilled />
```

 */
const UiChatFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M21.48 18.32c.98-1.1 1.52-2.44 1.52-3.82 0-2.06-1.18-3.89-3.02-5.08C19.72 14.19 15.13 18 9.5 18c-.43 0-.86-.03-1.29-.07C9.62 19.77 12.13 21 15 21c.72 0 1.43-.08 2.13-.24l3.55 1.18c.1.04.21.05.32.05a1.004 1.004 0 00.98-1.2l-.5-2.47z"
  }), /*#__PURE__*/jsx("path", {
    d: "M9.5 16c4.69 0 8.5-3.14 8.5-7s-3.81-7-8.5-7C4.81 2 1 5.14 1 9c0 1.46.55 2.88 1.57 4.06l-.55 2.75c-.07.36.06.74.35.97.18.15.4.22.63.22.13 0 .27-.03.39-.08l3.16-1.35c.95.28 1.94.43 2.95.43z"
  })]
}));

/**
UiChatFilledSmall icon

```jsx
import { UiChatFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChatFilledSmall />
```

 */
const UiChatFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsxs("g", {
    clipPath: "url(#omni-gravity-icon-ui-chat-filled-small-a)",
    children: [/*#__PURE__*/jsx("path", {
      d: "M15.15 12.3c.56-.85.85-1.81.85-2.8 0-.86-.22-1.67-.6-2.39-.61 3.61-4.14 6.39-8.4 6.39-.4 0-.81-.03-1.2-.08C6.88 14.4 8.37 15 10 15c.43 0 .87-.05 1.36-.16l3.33 1.11c.1.04.21.05.32.05.26 0 .52-.1.71-.29a.99.99 0 00.24-1.02l-.81-2.39z"
    }), /*#__PURE__*/jsx("path", {
      d: "M5.32 11.82c.55.12 1.12.18 1.68.18 3.86 0 7-2.69 7-6s-3.14-6-7-6-7 2.69-7 6c0 1.26.46 2.48 1.31 3.49l-.3 2.38c-.04.35.1.69.37.91a1.03 1.03 0 00.97.15l2.97-1.11z"
    })]
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-chat-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiChatLined icon

```jsx
import { UiChatLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChatLined />
```

 */
const UiChatLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M21.48 18.32c.98-1.1 1.52-2.44 1.52-3.82 0-2.73-2.09-5.07-5.03-6.03C17.64 4.86 13.97 2 9.5 2 4.81 2 1 5.14 1 9c0 1.46.55 2.88 1.57 4.06l-.55 2.74c-.07.36.06.74.35.97a.978.978 0 001.02.15l3.16-1.35c.19.06.39.09.59.13.7 3.01 3.95 5.3 7.86 5.3.72 0 1.43-.08 2.13-.24l3.55 1.18c.11.04.21.06.32.06a1.004 1.004 0 00.98-1.2l-.5-2.48zm-4.55.44c-.63.16-1.28.24-1.93.24-2.61 0-4.83-1.26-5.66-3.01.05 0 .1.01.16.01 4.05 0 7.45-2.35 8.29-5.48 1.91.76 3.21 2.25 3.21 3.98 0 1.28-.7 2.22-1.29 2.78-.25.24-.36.58-.29.92l.26 1.31-2.19-.73c-.1-.03-.21-.05-.32-.05-.08 0-.16.01-.24.03zm-10.1-5.21a.996.996 0 00-.72.03l-1.76.75.28-1.39a.99.99 0 00-.27-.9C3.47 11.16 3 10.11 3 9c0-2.76 2.92-5 6.5-5S16 6.24 16 9s-2.92 5-6.5 5c-.92 0-1.82-.15-2.67-.45z"
  })
}));

/**
UiChatLinedSmall icon

```jsx
import { UiChatLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChatLinedSmall />
```

 */
const UiChatLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-chat-lined-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M15.15 12.3c.56-.85.85-1.81.85-2.8 0-1.64-.79-3.11-2.04-4.12C13.6 2.36 10.62 0 7 0 3.14 0 0 2.69 0 6c0 1.26.46 2.48 1.31 3.49l-.3 2.38c-.04.35.1.69.37.91.18.15.4.22.62.22.12 0 .24-.02.35-.06l2.34-.88C5.7 13.8 7.7 15 10 15c.43 0 .87-.05 1.36-.16l3.33 1.11a1.007 1.007 0 001.02-.24.99.99 0 00.24-1.02l-.8-2.39zM3.07 8.46C2.37 7.75 2 6.9 2 6c0-2.21 2.24-4 5-4s5 1.79 5 4-2.24 4-5 4c-.51 0-1.02-.06-1.51-.19-.2-.05-.41-.04-.6.03l-1.7.64.15-1.2c.04-.3-.06-.6-.27-.82zm10.02 3.99l.32.97-1.7-.57a1.068 1.068 0 00-.57-.02c-.43.12-.79.17-1.14.17-1.09 0-2.08-.39-2.8-1.01 2.96-.07 5.46-1.72 6.4-4 .25.46.4.97.4 1.51 0 .71-.25 1.4-.74 2-.21.27-.27.62-.17.95z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-chat-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiCheckLined icon

```jsx
import { UiCheckLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCheckLined />
```

 */
const UiCheckLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M6 10h5c.6 0 1 .4 1 1s-.4 1-1 1H6c-.6 0-1-.4-1-1s.4-1 1-1zm10.9 3s.4 0 1.5-.8c.4-.3 1.1-.2 1.4.2.3.4.2 1.1-.2 1.4-2.2 1.7-3.3 1.4-4.3.4 0-.1-.2-.2-.2-.2s-.4 0-1.5.8c-.2.1-.4.2-.6.2-.3 0-.6-.1-.8-.4-.3-.4-.2-1.1.2-1.4 2.2-1.7 3.3-1.4 4.3-.4 0 .1.2.2.2.2zM8 13H6c-.6 0-1 .4-1 1s.4 1 1 1h2c.6 0 1-.4 1-1s-.4-1-1-1z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5h20c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1H2c-.6 0-1-.4-1-1V6c0-.6.4-1 1-1zm1 3v9h18V8H3z"
  })]
}));

/**
UiCheckLinedSmall icon

```jsx
import { UiCheckLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCheckLinedSmall />
```

 */
const UiCheckLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11.1 10s.3-.1 1-.9c.2-.1.5-.1.7.1.2.2.2.5 0 .7-.8.8-1.3 1.1-1.8 1.1h-.2c-.5-.1-.7-.5-.8-.8l-.1-.2s-.3.1-1.1.9c-.2.2-.6.2-.7 0-.1-.2-.1-.6 0-.8.9-.8 1.5-1.2 2.1-1.1.5.1.7.5.8.8l.1.2zM3.5 8h5c.3 0 .5-.2.5-.5S8.8 7 8.5 7h-5c-.3 0-.5.2-.5.5s.2.5.5.5zm0 1h2c.3 0 .5.2.5.5s-.2.5-.5.5h-2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2h14c.6 0 1 .4 1 1v10c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1zm1 3v7h12V5H2z"
  })]
}));

/**
UiChecklistFilled icon

```jsx
import { UiChecklistFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChecklistFilled />
```

 */
const UiChecklistFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.707 6.707A1 1 0 0115 7H9a1 1 0 01-1-1V4a1 1 0 011-1h.18a3 3 0 015.64 0H15a1 1 0 011 1v2a1 1 0 01-.293.707zm-3.151-3.539a1 1 0 10-1.112 1.664 1 1 0 001.112-1.664z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4h1a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h1v2a2 2 0 002 2h6a2 2 0 002-2V4zm-5.22 13.62l4-5a1 1 0 00-1.56-1.24l-3.3 4.12-1.21-1.21a1.004 1.004 0 10-1.42 1.42l2 2A1 1 0 0011 18h.06a.999.999 0 00.72-.38z"
  })]
}));

/**
UiChecklistFilledSmall icon

```jsx
import { UiChecklistFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChecklistFilledSmall />
```

 */
const UiChecklistFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsxs("g", {
    clipPath: "url(#omni-gravity-icon-ui-checklist-filled-small-a)",
    children: [/*#__PURE__*/jsx("path", {
      d: "M13 1h-.09c.056.16.086.33.09.5v2A1.5 1.5 0 0111.5 5h-7A1.5 1.5 0 013 3.5v-2a1.64 1.64 0 01.09-.5H3a2 2 0 00-2 2v11a2 2 0 002 2h10a2 2 0 002-2V3a2 2 0 00-2-2zm-1.7 7.6l-3 4a1 1 0 01-.73.4H7.5a.999.999 0 01-.71-.29l-2-2a1.004 1.004 0 111.42-1.42l1.18 1.19L9.7 7.4a1 1 0 111.6 1.2z"
    }), /*#__PURE__*/jsx("path", {
      d: "M4.5 4h7a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5H9.72a2 2 0 00-3.44 0H4.5a.5.5 0 00-.5.5v2a.5.5 0 00.5.5z"
    })]
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-checklist-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiChecklistLined icon

```jsx
import { UiChecklistLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChecklistLined />
```

 */
const UiChecklistLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M14.22 10.38l-3.3 4.12-1.21-1.21a1.004 1.004 0 10-1.42 1.42l2 2A1 1 0 0011 17h.06a.999.999 0 00.72-.38l4-5a1 1 0 00-1.56-1.24z"
  }), /*#__PURE__*/jsx("path", {
    d: "M18 4h-1v2h1v14H6V6h1V4H6a2 2 0 00-2 2v14a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4v2a1 1 0 001 1h6a1 1 0 001-1V4a1 1 0 00-1-1h-.18a3 3 0 00-5.64 0H9a1 1 0 00-1 1zm4-1a1 1 0 110 2 1 1 0 010-2z"
  })]
}));

/**
UiChecklistLinedSmall icon

```jsx
import { UiChecklistLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChecklistLinedSmall />
```

 */
const UiChecklistLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsxs("g", {
    clipPath: "url(#omni-gravity-icon-ui-checklist-lined-small-a)",
    children: [/*#__PURE__*/jsx("path", {
      d: "M13 1h-.09c.056.16.086.33.09.5V14H3V1.5a1.64 1.64 0 01.09-.5H3a2 2 0 00-2 2v11a2 2 0 002 2h10a2 2 0 002-2V3a2 2 0 00-2-2z"
    }), /*#__PURE__*/jsx("path", {
      d: "M9.7 6.4L7.39 9.48 6.21 8.29a1.004 1.004 0 00-1.42 1.42l2 2a1 1 0 00.71.29h.07a1 1 0 00.73-.4l3-4a1 1 0 10-1.6-1.2zM4.5 4h7a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5H9.72a2 2 0 00-3.44 0H4.5a.5.5 0 00-.5.5v2a.5.5 0 00.5.5z"
    })]
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-checklist-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiCheckmarkEncircledFilled icon

```jsx
import { UiCheckmarkEncircledFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCheckmarkEncircledFilled />
```

 */
const UiCheckmarkEncircledFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm4.763-12.354a1 1 0 00-1.526-1.292l-4.798 5.67-1.732-1.731a1 1 0 00-1.414 1.414l2.5 2.5a1 1 0 001.47-.061l5.5-6.5z"
  })
}));

/**
UiCheckmarkEncircledFilledSmall icon

```jsx
import { UiCheckmarkEncircledFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCheckmarkEncircledFilledSmall />
```

 */
const UiCheckmarkEncircledFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3.8 6.1l-4 5c-.2.2-.4.4-.7.4H7c-.3 0-.5-.1-.7-.3l-2-2c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0L6.9 9l3.3-4.1c.3-.4 1-.5 1.4-.2.5.4.5 1 .2 1.4z"
  })
}));

/**
UiCheckmarkEncircledLined icon

```jsx
import { UiCheckmarkEncircledLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCheckmarkEncircledLined />
```

 */
const UiCheckmarkEncircledLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M16.763 9.646a1 1 0 00-1.526-1.292l-4.798 5.67-1.732-1.731a1 1 0 00-1.414 1.414l2.5 2.5a1 1 0 001.47-.061l5.5-6.5z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-2 0a8 8 0 11-16 0 8 8 0 0116 0z"
  })]
}));

/**
UiCheckmarkEncircledLinedSmall icon

```jsx
import { UiCheckmarkEncircledLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCheckmarkEncircledLinedSmall />
```

 */
const UiCheckmarkEncircledLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M6.9 9l3.3-4.1c.4-.5 1-.5 1.4-.2.5.3.5 1 .2 1.4l-4 5c-.2.2-.4.4-.7.4H7c-.3 0-.5-.1-.7-.3l-2-2c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0L6.9 9z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8-8-3.6-8-8zm2 0c0 3.3 2.7 6 6 6s6-2.7 6-6-2.7-6-6-6-6 2.7-6 6z"
  })]
}));

/**
UiCheckmarkLined icon

```jsx
import { UiCheckmarkLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCheckmarkLined />
```

 */
const UiCheckmarkLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M9 20c-.26 0-.52-.1-.71-.29l-5-5A.996.996 0 114.7 13.3l4.23 4.23 10.3-12.17c.36-.42.99-.47 1.41-.12.42.36.47.99.12 1.41l-11 13c-.18.21-.44.34-.72.35H9z"
  })
}));

/**
UiCheckmarkLinedSmall icon

```jsx
import { UiCheckmarkLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCheckmarkLinedSmall />
```

 */
const UiCheckmarkLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M6 14c-.3 0-.5-.1-.7-.3l-4-4c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l3.2 3.2 7.3-9.1c.3-.4 1-.5 1.4-.2.4.3.5 1 .2 1.4l-8 10c-.2.2-.5.4-.8.4z"
  })
}));

/**
UiChevronDownEncircledFilled icon

```jsx
import { UiChevronDownEncircledFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChevronDownEncircledFilled />
```

 */
const UiChevronDownEncircledFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12zm14.707-.293a1 1 0 00-1.414-1.414L12 13.586l-3.293-3.293a1 1 0 10-1.414 1.414l4 4a1 1 0 001.414 0l4-4z"
  })
}));

/**
UiChevronDownEncircledFilledSmall icon

```jsx
import { UiChevronDownEncircledFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChevronDownEncircledFilledSmall />
```

 */
const UiChevronDownEncircledFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8a8 8 0 1016 0A8 8 0 000 8zm11.707-.293a1 1 0 00-1.414-1.414L8 8.586 5.707 6.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3z"
  })
}));

/**
UiChevronDownEncircledLined icon

```jsx
import { UiChevronDownEncircledLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChevronDownEncircledLined />
```

 */
const UiChevronDownEncircledLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L12 13.586l3.293-3.293a1 1 0 011.414 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12a8 8 0 10-16 0 8 8 0 0016 0zM12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2z"
  })]
}));

/**
UiChevronDownLined icon

```jsx
import { UiChevronDownLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChevronDownLined />
```

 */
const UiChevronDownLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.293 9.293a1 1 0 011.414 0L12 13.586l4.293-4.293a1 1 0 111.414 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414z"
  })
}));

/**
UiChevronDownLinedSmall icon

```jsx
import { UiChevronDownLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChevronDownLinedSmall />
```

 */
const UiChevronDownLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.707 6.293a1 1 0 010 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 011.414-1.414L8 8.586l2.293-2.293a1 1 0 011.414 0z"
  })
}));

/**
UiChevronFirstLined icon

```jsx
import { UiChevronFirstLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChevronFirstLined />
```

 */
const UiChevronFirstLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12.41 12l6.29-6.29a.997.997 0 10-1.41-1.41l-7 7a.994.994 0 000 1.41l7 7a.997.997 0 001.41-1.41L12.41 12zM6 4c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1z"
  })
}));

/**
UiChevronFirstLinedSmall icon

```jsx
import { UiChevronFirstLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChevronFirstLinedSmall />
```

 */
const UiChevronFirstLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M9.41 8l3.29-3.29a.997.997 0 10-1.41-1.41l-4 4a.996.996 0 000 1.41l4 4a.997.997 0 001.41-1.41L9.41 8zM4 3c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1z"
  })
}));

/**
UiChevronLastLined icon

```jsx
import { UiChevronLastLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChevronLastLined />
```

 */
const UiChevronLastLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M11.59 12L5.3 18.29a.997.997 0 101.41 1.41l7-7a.996.996 0 000-1.41l-7-7A.997.997 0 005.3 5.7l6.29 6.3zM18 20c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1s-1 .45-1 1v14c0 .55.45 1 1 1z"
  })
}));

/**
UiChevronLastLinedSmall icon

```jsx
import { UiChevronLastLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChevronLastLinedSmall />
```

 */
const UiChevronLastLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M6.59 8l-3.3-3.29A.997.997 0 114.7 3.3l4 4c.39.39.39 1.02 0 1.41l-4 4a.997.997 0 01-1.41-1.41L6.59 8zM12 3c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1s-1-.45-1-1V4c0-.55.45-1 1-1z"
  })
}));

/**
UiChevronLeftEncircledFilled icon

```jsx
import { UiChevronLeftEncircledFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChevronLeftEncircledFilled />
```

 */
const UiChevronLeftEncircledFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm.293 14.707a1 1 0 001.414-1.414L10.414 12l3.293-3.293a1 1 0 00-1.414-1.414l-4 4a1 1 0 000 1.414l4 4z"
  })
}));

/**
UiChevronLeftEncircledFilledSmall icon

```jsx
import { UiChevronLeftEncircledFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChevronLeftEncircledFilledSmall />
```

 */
const UiChevronLeftEncircledFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0a8 8 0 100 16A8 8 0 008 0zm.293 11.707a1 1 0 001.414-1.414L7.414 8l2.293-2.293a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3z"
  })
}));

/**
UiChevronLeftEncircledLined icon

```jsx
import { UiChevronLeftEncircledLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChevronLeftEncircledLined />
```

 */
const UiChevronLeftEncircledLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.707 16.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 111.414 1.414L10.414 12l3.293 3.293a1 1 0 010 1.414z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20a8 8 0 100-16 8 8 0 000 16zm10-8c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z"
  })]
}));

/**
UiChevronLeftLined icon

```jsx
import { UiChevronLeftLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChevronLeftLined />
```

 */
const UiChevronLeftLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.707 4.293a1 1 0 010 1.414L8.414 12l6.293 6.293a1 1 0 01-1.414 1.414l-7-7a1 1 0 010-1.414l7-7a1 1 0 011.414 0z"
  })
}));

/**
UiChevronLeftLinedSmall icon

```jsx
import { UiChevronLeftLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChevronLeftLinedSmall />
```

 */
const UiChevronLeftLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.707 12.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L6.414 8l3.293 3.293a1 1 0 010 1.414z"
  })
}));

/**
UiChevronRightEncircledFilled icon

```jsx
import { UiChevronRightEncircledFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChevronRightEncircledFilled />
```

 */
const UiChevronRightEncircledFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-.293-14.707a1 1 0 10-1.414 1.414L13.586 12l-3.293 3.293a1 1 0 101.414 1.414l4-4a1 1 0 000-1.414l-4-4z"
  })
}));

/**
UiChevronRightEncircledFilledSmall icon

```jsx
import { UiChevronRightEncircledFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChevronRightEncircledFilledSmall />
```

 */
const UiChevronRightEncircledFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16A8 8 0 108 0a8 8 0 000 16zM7.707 4.293a1 1 0 00-1.414 1.414L8.586 8l-2.293 2.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414l-3-3z"
  })
}));

/**
UiChevronRightEncircledLined icon

```jsx
import { UiChevronRightEncircledLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChevronRightEncircledLined />
```

 */
const UiChevronRightEncircledLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.293 7.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L13.586 12l-3.293-3.293a1 1 0 010-1.414z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4a8 8 0 100 16 8 8 0 000-16zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12z"
  })]
}));

/**
UiChevronRightLined icon

```jsx
import { UiChevronRightLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChevronRightLined />
```

 */
const UiChevronRightLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.293 19.707a1 1 0 010-1.414L15.586 12 9.293 5.707a1 1 0 011.414-1.414l7 7a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0z"
  })
}));

/**
UiChevronRightLinedSmall icon

```jsx
import { UiChevronRightLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChevronRightLinedSmall />
```

 */
const UiChevronRightLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.293 3.293a1 1 0 011.414 0l4 4a1 1 0 010 1.415l-4 4a1 1 0 01-1.414-1.415L9.586 8 6.293 4.708a1 1 0 010-1.415z"
  })
}));

/**
UiChevronUpEncircledFilled icon

```jsx
import { UiChevronUpEncircledFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChevronUpEncircledFilled />
```

 */
const UiChevronUpEncircledFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10zm-14.707.293a1 1 0 101.414 1.414L12 10.414l3.293 3.293a1 1 0 001.414-1.414l-4-4a1 1 0 00-1.414 0l-4 4z"
  })
}));

/**
UiChevronUpEncircledFilledSmall icon

```jsx
import { UiChevronUpEncircledFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChevronUpEncircledFilledSmall />
```

 */
const UiChevronUpEncircledFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8A8 8 0 100 8a8 8 0 0016 0zm-11.707.293a1 1 0 001.414 1.414L8 7.414l2.293 2.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3z"
  })
}));

/**
UiChevronUpEncircledLined icon

```jsx
import { UiChevronUpEncircledLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChevronUpEncircledLined />
```

 */
const UiChevronUpEncircledLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.293 13.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L12 10.414l-3.293 3.293a1 1 0 01-1.414 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12a8 8 0 1016 0 8 8 0 00-16 0zm8 10C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"
  })]
}));

/**
UiChevronUpLined icon

```jsx
import { UiChevronUpLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChevronUpLined />
```

 */
const UiChevronUpLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.707 14.707a1 1 0 01-1.414 0L12 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0l5 5a1 1 0 010 1.414z"
  })
}));

/**
UiChevronUpLinedSmall icon

```jsx
import { UiChevronUpLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiChevronUpLinedSmall />
```

 */
const UiChevronUpLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.293 9.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L8 7.414 5.707 9.707a1 1 0 01-1.414 0z"
  })
}));

/**
UiClipboardLined icon

```jsx
import { UiClipboardLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiClipboardLined />
```

 */
const UiClipboardLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 22,
  viewBox: "0 0 16 22",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.667 2H10.6A2.995 2.995 0 008 .5 2.995 2.995 0 005.4 2h-.067A1.34 1.34 0 004 3.35V5.5h.045c.152.577.67 1 1.288 1h5.334c.618 0 1.136-.423 1.288-1H12V3.35A1.34 1.34 0 0010.667 2zM9 3.5a1 1 0 11-2 0 1 1 0 012 0z"
  }), /*#__PURE__*/jsx("path", {
    d: "M3 5.5H2v14h12v-14h-1v-2h1c1.102 0 2 .898 2 2v14c0 1.102-.898 2-2 2H2c-1.102 0-2-.898-2-2v-14c0-1.102.898-2 2-2h1v2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M11.5 8.5c.55 0 1 .45 1 1s-.45 1-1 1h-7c-.55 0-1-.45-1-1s.45-1 1-1h7zm0 3.5c.55 0 1 .45 1 1s-.45 1-1 1h-7c-.55 0-1-.45-1-1s.45-1 1-1h7zM7 15.5H4.5c-.55 0-1 .45-1 1s.45 1 1 1H7c.55 0 1-.45 1-1s-.45-1-1-1z"
  })]
}));

/**
UiClipboardLinedSmall icon

```jsx
import { UiClipboardLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiClipboardLinedSmall />
```

 */
const UiClipboardLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 14,
  height: 16,
  viewBox: "0 0 14 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M10.5 1H8.73C8.383.403 7.736 0 7 0S5.617.403 5.27 1H3.5c-.28 0-.5.22-.5.5V3h8V1.5c0-.28-.22-.5-.5-.5z"
  }), /*#__PURE__*/jsx("path", {
    d: "M12 14H2V1.5c0-.175.03-.344.085-.5H2C.898 1 0 1.898 0 3v11c0 1.102.898 2 2 2h10c1.096 0 2-.881 2-2V3c0-1.102-.898-2-2-2h-.086c.056.157.086.325.086.5V14z"
  }), /*#__PURE__*/jsx("path", {
    d: "M10 7.5c0-.55-.44-1-1-1H5c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1zM7.2 10h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1z"
  })]
}));

/**
UiClockFilled icon

```jsx
import { UiClockFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiClockFilled />
```

 */
const UiClockFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-9-6a1 1 0 10-2 0v6a1 1 0 00.293.707l3 3a1 1 0 001.414-1.414L13 11.586V6z"
  })
}));

/**
UiClockFilledSmall icon

```jsx
import { UiClockFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiClockFilledSmall />
```

 */
const UiClockFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8A8 8 0 110 8a8 8 0 0116 0zM8.98 4.47a1 1 0 10-2 0v3.54a1 1 0 00.297.71l1.79 1.77a1 1 0 101.406-1.421L8.98 7.592V4.47z"
  })
}));

/**
UiClockLined icon

```jsx
import { UiClockLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiClockLined />
```

 */
const UiClockLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M13 6.5a1 1 0 10-2 0V12a1 1 0 00.293.707l3 3a1 1 0 001.414-1.414L13 11.586V6.5z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm8-10a8 8 0 11-16 0 8 8 0 0116 0z"
  })]
}));

/**
UiClockLinedSmall icon

```jsx
import { UiClockLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiClockLinedSmall />
```

 */
const UiClockLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M8.98 4a1 1 0 10-2 0v4.01a1 1 0 00.3.714l1.52 1.49a1 1 0 001.4-1.428L8.98 7.59V4z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0a8 8 0 100 16A8 8 0 008 0zM2 8a6 6 0 1112 0A6 6 0 012 8z"
  })]
}));

/**
UiCloseFilled icon

```jsx
import { UiCloseFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCloseFilled />
```

 */
const UiCloseFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.42 12.83a.996.996 0 01-.71 1.7c-.26 0-.51-.1-.71-.29l-2.83-2.83-2.83 2.83c-.2.2-.45.29-.71.29-.26 0-.51-.1-.71-.29a.996.996 0 010-1.41L10.77 12 7.94 9.17a.996.996 0 111.41-1.41l2.83 2.83 2.83-2.83a.996.996 0 111.41 1.41L13.6 12l2.82 2.83z"
  })
}));

/**
UiCloseFilledSmall icon

```jsx
import { UiCloseFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCloseFilledSmall />
```

 */
const UiCloseFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3.2 9.8c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3L8 9.2l-1.8 2c-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l2-1.8-2-1.8c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l1.8 2 1.8-2c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L9.2 8l2 1.8z"
  })
}));

/**
UiCloseLined icon

```jsx
import { UiCloseLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCloseLined />
```

 */
const UiCloseLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M13.41 12l6.29-6.29a.996.996 0 10-1.41-1.41L12 10.59l-6.29-6.3A.996.996 0 104.3 5.7l6.29 6.3-6.29 6.29a.996.996 0 000 1.41c.19.2.44.3.7.3.26 0 .51-.1.71-.29l6.29-6.3 6.29 6.29c.2.2.45.3.71.3.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-6.3-6.3z"
  })
}));

/**
UiCloseLinedSmall icon

```jsx
import { UiCloseLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCloseLinedSmall />
```

 */
const UiCloseLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M9.41 8l4.29-4.29a.996.996 0 10-1.41-1.41L8 6.59l-4.29-4.3A.996.996 0 102.3 3.7L6.59 8 2.3 12.29a.996.996 0 000 1.41c.19.2.44.3.7.3.26 0 .51-.1.71-.29L8 9.41l4.29 4.29c.2.2.45.3.71.3.26 0 .51-.1.71-.29a.996.996 0 000-1.41L9.41 8z"
  })
}));

/**
UiClothingFilled icon

```jsx
import { UiClothingFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiClothingFilled />
```

 */
const UiClothingFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M17.17 22H6.83C5.82 22 5 21.1 5 20v-7.59L3.71 13.7c-.21.22-.5.33-.81.3a.978.978 0 01-.73-.44l-2-3c-.25-.37-.22-.87.07-1.21l6-7C6.43 2.13 6.71 2 7 2h1c.55 0 1 .45 1 1 0 .6 1.2 2 3 2s3-1.4 3-2c0-.55.45-1 1-1h1c.29 0 .57.13.76.35l6 7c.29.34.32.83.07 1.21l-2 3c-.16.24-.43.41-.73.44-.3.03-.59-.08-.81-.29L19 12.41V20c0 1.1-.82 2-1.83 2z"
  })
}));

/**
UiClothingFilledSmall icon

```jsx
import { UiClothingFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiClothingFilledSmall />
```

 */
const UiClothingFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M11.87 15h-8c-.55 0-1-.45-1-1V8l-1.18.69c-.28.16-.63.02-.73-.28L.05 5.55a.982.982 0 01.21-.97l2.91-3.24c.18-.22.45-.34.74-.34h1.47c.28 0 .5.22.5.5v.42c0 .99.68 1.9 1.65 2.05 1.25.2 2.34-.75 2.34-1.97v-.5c0-.28.22-.5.5-.5h1.47a1 1 0 01.74.33l2.93 3.27c.22.25.31.59.23.91l-.72 2.89c-.08.31-.42.47-.71.33L12.87 8v6c0 .55-.44 1-1 1z"
  })
}));

/**
UiClothingLined icon

```jsx
import { UiClothingLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiClothingLined />
```

 */
const UiClothingLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-clothing-lined-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M17.17 22H6.83C5.82 22 5 21.1 5 20v-7.13l-1.45.96c-.24.16-.53.21-.81.13a.982.982 0 01-.64-.52l-2-4c-.19-.38-.11-.84.19-1.15l6-6C6.48 2.11 6.73 2 7 2h2c.55 0 1 .45 1 1 0 .6.2 2 2 2s2-1.4 2-2c0-.55.45-1 1-1h2c.27 0 .52.11.71.29l6 6c.3.3.38.77.19 1.15l-2 4c-.13.26-.36.45-.64.52s-.57.02-.81-.13L19 12.87V20c0 1.1-.82 2-1.83 2zM7 20h9.99l.01-9c0-.37.2-.71.53-.88.32-.17.72-.16 1.03.05l2.06 1.37 1.17-2.34-5.2-5.2h-.69c-.39 1.83-1.86 3-3.9 3S8.49 5.83 8.1 4h-.69l-5.2 5.2 1.17 2.34 2.06-1.37c.31-.2.7-.22 1.03-.05.33.17.53.51.53.88v9z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-clothing-lined-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z"
      })
    })
  })]
}));

/**
UiClothingLinedSmall icon

```jsx
import { UiClothingLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiClothingLinedSmall />
```

 */
const UiClothingLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-clothing-lined-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M12 15H4c-.55 0-1-.45-1-1V9.1l-.58.27a.97.97 0 01-.8.01.972.972 0 01-.56-.58l-1-2.77c-.14-.38-.03-.8.26-1.07l4-3.69C4.51 1.09 4.75 1 5 1h1c.55 0 1 .45 1 1 .01.45.19 1 1 1s.99-.55 1-1.01c.01-.54.46-.99 1-.99h1c.25 0 .49.09.68.27l4 3.69c.29.27.4.7.26 1.07l-1 2.77c-.09.26-.3.47-.55.58-.26.11-.55.1-.8-.01L13 9.1V14c0 .55-.45 1-1 1zm-7-2h6V7.54c0-.34.17-.66.46-.84.29-.18.65-.21.96-.07l1.01.47.4-1.12-3.06-2.82C10.41 4.11 9.55 5 8 5s-2.41-.89-2.78-1.84L2.17 5.98l.4 1.12 1.01-.47c.31-.14.67-.12.96.07.29.19.46.5.46.84V13z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-clothing-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiCodeExpressionLined icon

```jsx
import { UiCodeExpressionLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCodeExpressionLined />
```

 */
const UiCodeExpressionLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M6 2a1 1 0 00-.707.293l-2 2A1 1 0 003 5v4.15l-1.78 2.225a1 1 0 000 1.25L3 14.85V19a1 1 0 00.293.707l2 2A1 1 0 006 22h1.65a1 1 0 100-2H6.414L5 18.586V14.5a1 1 0 00-.22-.625L3.28 12l1.5-1.875A1 1 0 005 9.5V5.414L6.414 4H7.65a1 1 0 000-2H6zm12 0h-1.65a1 1 0 100 2h1.236L19 5.414V9.5a1 1 0 00.22.625L20.72 12l-1.5 1.875a1 1 0 00-.22.625v4.086L17.586 20H16.35a1 1 0 100 2H18a1 1 0 00.707-.293l2-2A1 1 0 0021 19v-4.15l1.78-2.225a1 1 0 000-1.25L21 9.15V5a1 1 0 00-.293-.707l-2-2A1 1 0 0018 2z"
  })
}));

/**
UiCodeExpressionLinedSmall icon

```jsx
import { UiCodeExpressionLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCodeExpressionLinedSmall />
```

 */
const UiCodeExpressionLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M4 0a1 1 0 00-.707.293l-1.5 1.5A1 1 0 001.5 2.5v3.167L.2 7.4a1 1 0 000 1.2l1.3 1.733V13.5a1 1 0 00.293.707l1.5 1.5A1 1 0 004 16h1.5a1 1 0 100-2H4.414l-.914-.914V10a1 1 0 00-.2-.6L2.25 8 3.3 6.6a1 1 0 00.2-.6V2.914L4.414 2H5.5a1 1 0 000-2H4zm8 0h-1.5a1 1 0 100 2h1.086l.914.914V6a1 1 0 00.2.6L13.75 8 12.7 9.4a1 1 0 00-.2.6v3.086l-.914.914H10.5a1 1 0 100 2H12a1 1 0 00.707-.293l1.5-1.5a1 1 0 00.293-.707v-3.167L15.8 8.6a1 1 0 000-1.2l-1.3-1.733V2.5a1 1 0 00-.293-.707l-1.5-1.5A1 1 0 0012 0z"
  })
}));

/**
UiCodeLined icon

```jsx
import { UiCodeLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCodeLined />
```

 */
const UiCodeLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M15.943 3.833a1 1 0 00-1.886-.666l-6 17a1 1 0 101.886.666l6-17zM5.514 6.143a1 1 0 01.343 1.372L3.167 12l2.69 4.486a1 1 0 01-1.714 1.029l-3-5a1 1 0 010-1.03l3-5a1 1 0 011.372-.342zm12.971 0a1 1 0 011.373.343l3 5a1 1 0 010 1.029l-3 5a1 1 0 01-1.716-1.03L20.834 12l-2.692-4.485a1 1 0 01.343-1.372z"
  })
}));

/**
UiCodeLinedSmall icon

```jsx
import { UiCodeLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCodeLinedSmall />
```

 */
const UiCodeLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M10.47 2.243a1 1 0 10-1.94-.485l-3 12a1 1 0 001.94.485l3-12zM3.555 4.168a1 1 0 01.277 1.387L2.202 8l1.63 2.445a1 1 0 01-1.664 1.11l-2-3a1 1 0 010-1.11l2-3a1 1 0 011.387-.277zm8.89 0a1 1 0 011.387.278l2 3a1 1 0 010 1.109l-2 3a1 1 0 01-1.664-1.11L13.798 8l-1.63-2.445a1 1 0 01.277-1.387z"
  })
}));

/**
UiCollapseLined icon

```jsx
import { UiCollapseLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCollapseLined />
```

 */
const UiCollapseLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M3.318 4.728l3.789 3.52H5.248a1 1 0 100 2h4a1 1 0 001-1v-4a1 1 0 00-2 0v1.86l-3.52-3.79a.12.12 0 00-.05-.05.997.997 0 00-1.41.05c-.38.4-.35 1.03.05 1.41zm14.93 3.52H16.39l3.788-3.52a.1.1 0 00.032-.029.997.997 0 00-.032-1.43.997.997 0 00-1.41.05l-3.52 3.788V5.248a1 1 0 10-2 0v4a1 1 0 001 1h4a1 1 0 100-2zm-4 5a1 1 0 00-1 1v4a1 1 0 102 0v-1.859l3.52 3.789a.1.1 0 00.03.032l.006.005a.997.997 0 001.424-.037c.38-.4.35-1.03-.05-1.41l-3.788-3.52h1.858a1 1 0 100-2h-4zm-9 0a1 1 0 000 2h1.86l-3.79 3.52a.1.1 0 00-.031.03.997.997 0 00.032 1.43c.4.38 1.03.35 1.41-.05l3.52-3.789v1.859a1 1 0 102 0v-4a1 1 0 00-1-1h-4z"
  })
}));

/**
UiCollapseLinedSmall icon

```jsx
import { UiCollapseLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCollapseLinedSmall />
```

 */
const UiCollapseLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M3.588 4.742L.323 1.732A.996.996 0 111.673.264l.06.06 3.009 3.265V2.133a1 1 0 112 0v3.609a1 1 0 01-1 1H2.133a1 1 0 110-2h1.455zm10.28 0h-1.456l3.265-3.01.06-.06a.997.997 0 10-1.47-1.35L11.26 3.588V2.133a1 1 0 00-2 0v3.609a1 1 0 001 1h3.609a1 1 0 100-2zm-4.609 5.517a1 1 0 011-1h3.609a1 1 0 010 2h-1.444l3.253 2.998a.996.996 0 11-1.35 1.47l-.06-.06-3.008-3.264v1.464a1 1 0 11-2 0V10.26zm-7.126-1a1 1 0 000 2h1.443L.323 14.257c-.02.02-.04.04-.06.07a.997.997 0 101.47 1.35l3.009-3.265v1.455a1 1 0 102 0V10.26a1 1 0 00-1-1H2.133z"
  })
}));

/**
UiCommentFilled icon

```jsx
import { UiCommentFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCommentFilled />
```

 */
const UiCommentFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 3C6.49 3 2 7.04 2 12c0 2.21.88 4.3 2.5 5.95l-.48 2.89c-.06.35.07.7.34.92.18.16.42.24.65.24.11 0 .21-.02.32-.05l3.91-1.3c.91.24 1.84.36 2.77.36 5.51 0 10-4.04 10-9S17.51 3 12 3zm-1 12H8c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1s-.45 1-1 1zm5-4H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1z"
  })
}));

/**
UiCommentFilledSmall icon

```jsx
import { UiCommentFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCommentFilledSmall />
```

 */
const UiCommentFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M8 1C3.59 1 0 3.92 0 7.5c0 1.38.53 2.71 1.52 3.82l-.5 2.49a1.004 1.004 0 00.98 1.2c.11 0 .21-.02.32-.05l3.55-1.18c.7.16 1.41.24 2.13.24 4.41 0 8-2.92 8-6.5S12.41 1 8 1zm0 9H5c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1s-.45 1-1 1zm3-3H5c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1z"
  })
}));

/**
UiCommentLined icon

```jsx
import { UiCommentLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCommentLined />
```

 */
const UiCommentLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M16 9H8c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1zm-5 4H8c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M12 3C6.49 3 2 7.04 2 12c0 2.21.88 4.3 2.5 5.95l-.48 2.89c-.06.35.07.7.34.92.17.16.41.24.64.24.11 0 .21-.02.32-.05l3.91-1.3c.9.23 1.84.35 2.77.35 5.51 0 10-4.04 10-9s-4.49-9-10-9zm0 16c-.85 0-1.7-.12-2.52-.36-.19-.06-.4-.05-.6.01l-2.62.88.29-1.77a.98.98 0 00-.31-.9C4.8 15.54 4 13.81 4 12c0-3.86 3.59-7 8-7s8 3.14 8 7-3.59 7-8 7z"
  })]
}));

/**
UiCommentLinedSmall icon

```jsx
import { UiCommentLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCommentLinedSmall />
```

 */
const UiCommentLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M8 1C3.59 1 0 3.92 0 7.5c0 1.38.53 2.71 1.52 3.82l-.5 2.49c-.07.35.05.71.32.95.18.15.42.24.66.24.11 0 .21-.02.32-.05l3.55-1.18c.7.16 1.41.24 2.13.24 4.41 0 8-2.92 8-6.5S12.41 1 8 1zm0 11c-.65 0-1.3-.08-1.93-.24a.97.97 0 00-.56.02l-2.19.73.26-1.31a.988.988 0 00-.29-.92C2.7 9.72 2 8.78 2 7.5 2 5.02 4.69 3 8 3s6 2.02 6 4.5S11.31 12 8 12z"
  }), /*#__PURE__*/jsx("path", {
    d: "M8.07 8.17h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1zm3-3h-6c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1z"
  })]
}));

/**
UiContentLined icon

```jsx
import { UiContentLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiContentLined />
```

 */
const UiContentLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 3c0-1.102.898-2 2-2h18c1.102 0 2 .898 2 2v6c0 1.102-.898 2-2 2H3c-1.102 0-2-.898-2-2V3zm20 0H3v6h18V3z"
  }), /*#__PURE__*/jsx("path", {
    d: "M1 14a1 1 0 011-1h9a1 1 0 110 2H2a1 1 0 01-1-1zm0 4a1 1 0 011-1h9a1 1 0 110 2H2a1 1 0 01-1-1zm1 3a1 1 0 100 2h9a1 1 0 100-2H2zm12.99 2h7c.54 0 1-.45 1-1v-8c0-.55-.45-1-1-1h-7c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1z"
  })]
}));

/**
UiContentLinedSmall icon

```jsx
import { UiContentLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiContentLinedSmall />
```

 */
const UiContentLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 .898.898 0 2 0h12c1.102 0 2 .898 2 2v4c0 1.102-.898 2-2 2H2C.898 8 0 7.102 0 6V2zm2 0v4h12V2H2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M1 10a1 1 0 100 2h6a1 1 0 100-2H1zm0 4a1 1 0 100 2h6a1 1 0 100-2H1zm9.98 2H15c.55 0 1-.45 1-1v-3.99c0-.55-.45-1-1-1h-4.02c-.55 0-1 .45-1 1V15c0 .55.45 1 1 1z"
  })]
}));

/**
UiContrastDownLined icon

```jsx
import { UiContrastDownLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiContrastDownLined />
```

 */
const UiContrastDownLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1 18.3C8.5 19.4 10.2 20 12 20c.6 0 .9.3.9.9 0 .6-.4 1-1 1-2.7 0-5.2-1.1-7-2.9C3.1 17.2 2 14.7 2 12 2 6.5 6.5 2 12 2c2.7 0 5.2 1.1 7.1 3 1.8 1.8 2.9 4.3 2.9 7 0 .7 0 1.5-.2 2.2-.1.6-.7.9-1.2.8-.6-.1-.9-.7-.8-1.2.1-.6.2-1.2.2-1.8 0-1.8-.6-3.5-1.7-4.9L7.1 18.3zm5.5-8.3H4.3c-.1.3-.2.7-.2 1h7.5l1-1zm3-3H5.8c-.3.3-.5.6-.7 1h9.5l1-1zm-7 7l1-1H4.1c0 .3.1.7.2 1h4.3zm-2 2H5.1l.6.9.9-.9zM8.1 5h7.8c-1.2-.6-2.5-1-3.9-1s-2.7.4-3.9 1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M15 17h6c.6 0 1 .4 1 1s-.4 1-1 1h-6c-.6 0-1-.4-1-1s.4-1 1-1z"
  })]
}));

/**
UiContrastDownLinedSmall icon

```jsx
import { UiContrastDownLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiContrastDownLinedSmall />
```

 */
const UiContrastDownLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 12.9c1 .7 2.2 1.1 3.5 1.1.6 0 1 .4 1 1s-.4 1-1 1c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8c0 .6-.4 1-1 1s-1-.4-1-1c0-1.3-.4-2.5-1.1-3.5l-8.4 8.4zm6-8.9h-7a5.323 5.323 0 01-.245.328c-.157.2-.327.416-.455.672h6.7l1-1zM7.6 7l1-1H2.4c-.13.194-.175.43-.218.654-.024.122-.047.24-.082.346h5.5zM2.1 9h3.5l1-1H2c0 .3 0 .7.1 1zm1 2.5L4.6 10H2.4c.1.5.4 1 .7 1.5zM4.7 3h6.6c-.9-.6-2.1-1-3.3-1-1.2 0-2.4.4-3.3 1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M15 11h-4c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1z"
  })]
}));

/**
UiContrastLined icon

```jsx
import { UiContrastLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiContrastLined />
```

 */
const UiContrastLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M19.1 5c0-.1 0-.1 0 0 0-.1 0-.1 0 0-1.9-1.8-4.3-3-7.1-3C6.5 2 2 6.5 2 12c0 2.7 1.1 5.2 2.9 7 1.8 1.8 4.3 2.9 7 2.9 5.5 0 10-4.5 10-10 .1-2.6-1-5.1-2.8-6.9zM5.7 16.9l-.6-.9h1.5l-.9.9zM8.6 14H4.3c-.1-.3-.2-.7-.2-1h5.5l-1 1zm3-3H4.1c0-.3.1-.7.2-1h8.3l-1 1zm3-3H5.1c.2-.4.4-.7.7-1h9.8l-1 1zm1.3-3H8.1c1.2-.6 2.5-1 3.9-1s2.7.4 3.9 1zM12 20c-1.8 0-3.5-.6-4.9-1.7l5.6-5.6 3-3 2.6-2.6C19.4 8.5 20 10.2 20 12c0 4.4-3.6 8-8 8z"
  })
}));

/**
UiContrastLinedSmall icon

```jsx
import { UiContrastLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiContrastLinedSmall />
```

 */
const UiContrastLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM3.1 11.5c-.3-.5-.6-1-.7-1.5h2.2l-1.5 1.5zM5.6 9H2.1C2 8.7 2 8.3 2 8h4.6l-1 1zm2-2H2.1c.1-.3.1-.7.3-1h6.2l-1 1zm2-2H2.8c.2-.4.5-.7.7-1h7l-.9 1zm1.7-2H4.7c.9-.6 2.1-1 3.3-1 1.2 0 2.4.4 3.3 1zM8 14c-1.3 0-2.5-.4-3.5-1.1l8.4-8.4c.7 1 1.1 2.2 1.1 3.5 0 3.3-2.7 6-6 6z"
  })
}));

/**
UiContrastUpLined icon

```jsx
import { UiContrastUpLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiContrastUpLined />
```

 */
const UiContrastUpLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1 18.3C8.5 19.4 10.2 20 12 20c.6 0 .9.3.9.9 0 .6-.4 1-1 1-2.7 0-5.2-1.1-7-2.9C3.1 17.2 2 14.7 2 12 2 6.5 6.5 2 12 2c2.7 0 5.2 1.1 7.1 3 1.8 1.8 2.9 4.3 2.9 7 0 .6-.4 1-1 1s-1-.4-1-1c0-1.8-.6-3.5-1.7-4.9L7.1 18.3zm5.5-8.3H4.3c-.1.3-.2.7-.2 1h7.5l1-1zm3-3H5.8c-.3.3-.5.6-.7 1h9.5l1-1zm-7 7l1-1H4.1c0 .3.1.7.2 1h4.3zm-2 2H5.1l.6.9.9-.9zM8.1 5h7.8c-1.2-.6-2.5-1-3.9-1s-2.7.4-3.9 1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M18 14c.6 0 1 .4 1 1v2h2c.6 0 1 .4 1 1s-.4 1-1 1h-2v2c0 .6-.4 1-1 1s-1-.4-1-1v-2h-2c-.6 0-1-.4-1-1s.4-1 1-1h2v-2c0-.6.4-1 1-1z"
  })]
}));

/**
UiContrastUpLinedSmall icon

```jsx
import { UiContrastUpLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiContrastUpLinedSmall />
```

 */
const UiContrastUpLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 12.9c1 .7 2.2 1.1 3.5 1.1.6 0 1 .4 1 1s-.4 1-1 1c-4.4 0-8-3.6-8-8s3.6-8 8-8c4 0 7.4 2.9 7.9 6.9.1.5-.3 1-.8 1.1-.6.1-1.1-.3-1.2-.8-.2-1-.6-1.8-1.1-2.6l-8.3 8.3zm6-8.9h-7a5.323 5.323 0 01-.245.328c-.157.2-.327.416-.455.672h6.7l1-1zM7.6 7l1-1H2.4c-.13.194-.175.43-.218.654-.024.122-.047.24-.082.346h5.5zM2.1 9h3.5l1-1H2c0 .3 0 .7.1 1zm1 2.5L4.6 10H2.4c.1.5.4 1 .7 1.5zM4.7 3h6.6c-1-.6-2.1-1-3.3-1-1.2 0-2.4.4-3.3 1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M14 11h1c.6 0 1 .4 1 1s-.4 1-1 1h-1v1c0 .6-.4 1-1 1s-1-.4-1-1v-1h-1c-.6 0-1-.4-1-1s.4-1 1-1h1v-1c0-.6.4-1 1-1s1 .4 1 1v1z"
  })]
}));

/**
UiCopyFilled icon

```jsx
import { UiCopyFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCopyFilled />
```

 */
const UiCopyFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M8.5 3H19c1.1 0 2 .9 2 2v10.5c0 1.1-.9 2-2 2H8.5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M5.5 6.5v10c0 1.1.9 2 2 2h10v.5c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V8.5c0-1.1.9-2 2-2h.5z"
  })]
}));

/**
UiCopyFilledSmall icon

```jsx
import { UiCopyFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCopyFilledSmall />
```

 */
const UiCopyFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M3 12V4H2c-.6 0-1 .4-1 1v9c0 .6.4 1 1 1h9c.6 0 1-.4 1-1v-1H4c-.6 0-1-.4-1-1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M14 1H5c-.6 0-1 .4-1 1v9c0 .6.4 1 1 1h9c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1z"
  })]
}));

/**
UiCopyLined icon

```jsx
import { UiCopyLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCopyLined />
```

 */
const UiCopyLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M19 3H8.5c-1.1 0-2 .9-2 2v1.5H5c-1.1 0-2 .9-2 2V19c0 1.1.9 2 2 2h10.5c1.1 0 2-.9 2-2v-1.5H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3.5 16H5V8.5h1.5v7c0 1.1.9 2 2 2h7V19zm3.5-3.5H8.5V5H19v10.5z"
  })
}));

/**
UiCopyLinedSmall icon

```jsx
import { UiCopyLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCopyLinedSmall />
```

 */
const UiCopyLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14 1H5c-.6 0-1 .4-1 1v2H2c-.6 0-1 .4-1 1v9c0 .6.4 1 1 1h9c.6 0 1-.4 1-1v-2h2c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zm-4 12H3V6h1v5c0 .6.4 1 1 1h5v1zm3-3H6V3h7v7z"
  })
}));

/**
UiCreditBureauFilled icon

```jsx
import { UiCreditBureauFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCreditBureauFilled />
```

 */
const UiCreditBureauFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12 5C5.9 5 1 9.9 1 16v1c0 .6.4 1 1 1h6c.6 0 1-.4 1-1v-1c0-1.7 1.3-3 3-3 .2 0 .5 0 .7.1l3.5-3.1c.8-.7 2-.6 2.8.2.6.7.6 1.9 0 2.6l-3.9 4.5c.1.4.5.7.9.7h6c.6 0 1-.4 1-1v-1c0-6.1-4.9-11-11-11z"
  }), /*#__PURE__*/jsx("path", {
    d: "M17.8 11.8c.2-.2.2-.4 0-.6-.2-.2-.5-.2-.7 0l-5.9 5.1-.1.1c-.4.4-.3 1 .1 1.4.4.4 1 .3 1.4-.1l5.2-5.9z"
  })]
}));

/**
UiCreditBureauFilledSmall icon

```jsx
import { UiCreditBureauFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCreditBureauFilledSmall />
```

 */
const UiCreditBureauFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M8 3c-4.4 0-8 3.6-8 8v1c0 .6.4 1 1 1h2.8c.7 0 2 .2 2.2-.7V11c0-1.2 1.2-2.2 2.4-2l2.3-1.9c1.4-1.2 3.3.8 2.1 2.1l-2.7 3.3c.2.3.5.5.9.5h4c.6 0 1-.4 1-1v-1c0-4.4-3.6-8-8-8z"
  }), /*#__PURE__*/jsx("path", {
    d: "M12.1 8.6c.4-.5-.3-1.1-.7-.7l-4.1 3.4c-1.1 1 .5 2.5 1.4 1.4l3.4-4.1z"
  })]
}));

/**
UiCreditBureauLined icon

```jsx
import { UiCreditBureauLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCreditBureauLined />
```

 */
const UiCreditBureauLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M1 16C1 9.9 5.9 5 12 5s11 4.9 11 11v1c0 .6-.4 1-1 1h-6c-.5 0-1-.4-1-.9l1.8-2.4c.1.4.2.8.2 1.3h4c0-5-4-9-9-9s-9 4-9 9h4c0-2.8 2.2-5 5-5 1 0 2 .3 2.8.9L13 13.2c-.3-.1-.7-.2-1-.2-1.7 0-3 1.3-3 3v1c0 .6-.4 1-1 1H2c-.6 0-1-.4-1-1v-1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M17.8 11.2c.2.2.2.4 0 .6l-5.2 5.9c-.4.4-1 .5-1.4.1-.4-.4-.5-1-.1-1.4l.1-.1 5.9-5.1c.2-.2.5-.2.7 0z"
  })]
}));

/**
UiCreditBureauLinedSmall icon

```jsx
import { UiCreditBureauLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCreditBureauLinedSmall />
```

 */
const UiCreditBureauLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12.1 8.6c.4-.5-.3-1.1-.7-.7l-4.1 3.4c-1.1 1 .5 2.5 1.4 1.4l3.4-4.1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M8 3c-4.4 0-8 3.6-8 8v1c0 .6.4 1 1 1h2.8c.7 0 1.9.2 2.2-.7V11c0-1.2 1.2-2.2 2.4-2l1.7-1.4c-1.1-.7-2.8-.8-4-.1C4.8 8.1 4 9.6 4 11H2c.3-7.9 11.7-7.9 12 0h-2c0-.2 0-.4-.1-.6l-1.8 2.1c.2.3.5.5.9.5h4c.6 0 1-.4 1-1v-1c0-4.4-3.6-8-8-8z"
  })]
}));

/**
UiCreditLineIncreaseFilled icon

```jsx
import { UiCreditLineIncreaseFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCreditLineIncreaseFilled />
```

 */
const UiCreditLineIncreaseFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 13.4c-1.1-.9-2.5-1.4-4-1.4-3.6 0-6.5 2.9-6.5 6.5 0 .5.1 1 .2 1.5H4c-1.7 0-3-1.3-3-3V7c0-1.7 1.3-3 3-3h16c1.7 0 3 1.3 3 3v6.4zM3 8v3h18V8H3zm2 8h4c.5 0 1-.5 1-1s-.5-1-1-1H5c-.5 0-1 .5-1 1s.5 1 1 1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M21 18c-.2 0-.5-.1-.7-.3l-.3-.4V21c0 .6-.4 1-1 1s-1-.4-1-1v-3.7l-.3.4c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l2-2c.4-.4 1-.4 1.4 0l2 2c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3z"
  })]
}));

/**
UiCreditLineIncreaseLined icon

```jsx
import { UiCreditLineIncreaseLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCreditLineIncreaseLined />
```

 */
const UiCreditLineIncreaseLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 4H4C2.3 4 1 5.3 1 7v10c0 1.7 1.3 3 3 3h11c.6 0 1-.4 1-1s-.4-1-1-1H4c-.6 0-1-.4-1-1v-5h19c.6 0 1-.4 1-1V7c0-1.7-1.3-3-3-3zM3 7c0-.6.4-1 1-1h16c.6 0 1 .4 1 1v1H3V7z"
  }), /*#__PURE__*/jsx("path", {
    d: "M6 14c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1H6zm11.3 1.3l2-2c.4-.4 1-.4 1.4 0l2 2c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3l-.3-.4V20c0 .6-.4 1-1 1s-1-.4-1-1v-3.7l-.3.4c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4z"
  })]
}));

/**
UiCreditwiseFilled icon

```jsx
import { UiCreditwiseFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCreditwiseFilled />
```

 */
const UiCreditwiseFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 9c-4.4 0-8 3.6-8 8 0 .6.4 1 1 1h14c.6 0 1-.4 1-1 0-4.4-3.6-8-8-8zM2 16a1 1 0 100-2 1 1 0 000 2zm10-8a1 1 0 100-2 1 1 0 000 2zm10 8a1 1 0 100-2 1 1 0 000 2zm-5-7a1 1 0 100-2 1 1 0 000 2zM7 9a1 1 0 100-2 1 1 0 000 2zm-3.5 2.5a1 1 0 100-2 1 1 0 000 2zm17 .5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  })
}));

/**
UiCreditwiseFilledSmall icon

```jsx
import { UiCreditwiseFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCreditwiseFilledSmall />
```

 */
const UiCreditwiseFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M8 6c-3.3 0-6 2.7-6 6 0 .6.4 1 1 1h10c.6 0 1-.4 1-1 0-3.3-2.7-6-6-6zM1 9a1 1 0 100-2 1 1 0 000 2zm14 0a1 1 0 100-2 1 1 0 000 2zM8 5a1 1 0 100-2 1 1 0 000 2zM4 6a1 1 0 100-2 1 1 0 000 2zm8.5.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  })
}));

/**
UiCreditwiseLined icon

```jsx
import { UiCreditwiseLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCreditwiseLined />
```

 */
const UiCreditwiseLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 9c-4.4 0-8 3.6-8 8 0 .6.4 1 1 1s1-.4 1-1c0-3.3 2.7-6 6-6s6 2.7 6 6c0 .6.4 1 1 1s1-.4 1-1c0-4.4-3.6-8-8-8zM2 16a1 1 0 100-2 1 1 0 000 2zm10-8a1 1 0 100-2 1 1 0 000 2zm10 8a1 1 0 100-2 1 1 0 000 2zm-5-7a1 1 0 100-2 1 1 0 000 2zM7 9a1 1 0 100-2 1 1 0 000 2zm-3.5 2.5a1 1 0 100-2 1 1 0 000 2zm17 .5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  })
}));

/**
UiCreditwiseLinedSmall icon

```jsx
import { UiCreditwiseLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCreditwiseLinedSmall />
```

 */
const UiCreditwiseLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M8 6c-3.3 0-6 2.7-6 6 0 .6.4 1 1 1s1-.4 1-1c0-2.2 1.8-4 4-4s4 1.8 4 4c0 .6.4 1 1 1s1-.4 1-1c0-3.3-2.7-6-6-6zM1 9a1 1 0 100-2 1 1 0 000 2zm14 0a1 1 0 100-2 1 1 0 000 2zM8 5a1 1 0 100-2 1 1 0 000 2zM4 6a1 1 0 100-2 1 1 0 000 2zm8.5.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  })
}));

/**
UiCropLined icon

```jsx
import { UiCropLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCropLined />
```

 */
const UiCropLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M8 6h10v10h2V6c0-1.1-.9-2-2-2H8v2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M22 18H6V2c0-.6-.4-1-1-1s-1 .4-1 1v2H2c-.6 0-1 .4-1 1s.4 1 1 1h2v12c0 1.1.9 2 2 2h12v2c0 .6.4 1 1 1s1-.4 1-1v-2h2c.6 0 1-.4 1-1s-.4-1-1-1z"
  })]
}));

/**
UiCropLinedSmall icon

```jsx
import { UiCropLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiCropLinedSmall />
```

 */
const UiCropLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M6 4h6v6h2V3c0-.6-.4-1-1-1H6v2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M15 12H4V1c0-.6-.4-1-1-1S2 .4 2 1v1H1c-.6 0-1 .4-1 1s.4 1 1 1h1v9c0 .6.4 1 1 1h9v1c0 .6.4 1 1 1s1-.4 1-1v-1h1c.6 0 1-.4 1-1s-.4-1-1-1z"
  })]
}));

/**
UiDashboardLined icon

```jsx
import { UiDashboardLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDashboardLined />
```

 */
const UiDashboardLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M5 7a2 2 0 100-4 2 2 0 000 4zm7 0a2 2 0 100-4 2 2 0 000 4zm9-2a2 2 0 11-4 0 2 2 0 014 0zM5 14a2 2 0 100-4 2 2 0 000 4zm9-2a2 2 0 11-4 0 2 2 0 014 0zm5 2a2 2 0 100-4 2 2 0 000 4zM7 19a2 2 0 11-4 0 2 2 0 014 0zm5 2a2 2 0 100-4 2 2 0 000 4zm9-2a2 2 0 11-4 0 2 2 0 014 0z"
  })
}));

/**
UiDashboardLinedSmall icon

```jsx
import { UiDashboardLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDashboardLinedSmall />
```

 */
const UiDashboardLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M2.5 4a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM8 4a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm7-1.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-12.5 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm7-1.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm4 1.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-9.5 4a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM8 15a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm7-1.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
  })
}));

/**
UiDatasetLined icon

```jsx
import { UiDatasetLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDatasetLined />
```

 */
const UiDatasetLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M4 6h1c.56 0 1-.45 1-1V4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zm0 15h1c.56 0 1-.45 1-1v-1c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zm1-5H4c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1c0 .55-.44 1-1 1zm-1-5h1c.56 0 1-.45 1-1V9c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zm6-5H9c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1c0 .55-.44 1-1 1zM9 21h1c.56 0 1-.45 1-1v-1c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zm1-5H9c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1c0 .55-.44 1-1 1zm-1-5h1c.56 0 1-.45 1-1V9c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zm6 10h-1c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1c0 .55-.44 1-1 1zm-1-5h1c.56 0 1-.45 1-1v-1c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zm1-5h-1c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1c0 .55-.44 1-1 1zm4 5h1c.56 0 1-.45 1-1v-1c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1z"
  })
}));

/**
UiDatasetLinedSmall icon

```jsx
import { UiDatasetLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDatasetLinedSmall />
```

 */
const UiDatasetLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M2 3H1c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1zM1 7.5h1c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zM1 16h1c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zm4.33 0h1c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zm1-8.5h-1c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1zm-1-4.5h1c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zM2 11.5H1c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1zm3.33 0h1c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zm5.33 4.5h-1c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1zm-1-8.5h1c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zm1 4h-1c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1zm3.33 0h1c.56 0 1-.45 1-1v-1c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1z"
  })
}));

/**
UiDealershipFilled icon

```jsx
import { UiDealershipFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDealershipFilled />
```

 */
const UiDealershipFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22 7h-3V5a2 2 0 00-2-2H7a2 2 0 00-2 2v2H2a1 1 0 00-1 1v12a1 1 0 001 1h20a1 1 0 001-1V8a1 1 0 00-1-1zM5 19H3v-7h2v7zm0-8H3V9h2v2zm10 8H9v-6a1 1 0 011-1h4a1 1 0 011 1v6zM14 9h-4a1 1 0 010-2h4a1 1 0 110 2zm7 10h-2v-7h2v7zm0-8h-2V9h2v2z"
  })
}));

/**
UiDealershipFilledSmall icon

```jsx
import { UiDealershipFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDealershipFilledSmall />
```

 */
const UiDealershipFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M15 6h-2V4a2 2 0 00-2-2H5a2 2 0 00-2 2v2H1a1 1 0 00-1 1v7a1 1 0 001 1h14a1 1 0 001-1V7a1 1 0 00-1-1zM3 13H2V8h1v5zm7 0H6V9.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5V13zm-.5-7h-3a.5.5 0 110-1h3a.5.5 0 110 1zm4.5 7h-1V8h1v5z"
  })
}));

/**
UiDealershipLined icon

```jsx
import { UiDealershipLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDealershipLined />
```

 */
const UiDealershipLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M22 7h-3V5a2 2 0 00-2-2H7a2 2 0 00-2 2v2H2a1 1 0 00-1 1v12a1 1 0 001 1h20a1 1 0 001-1V8a1 1 0 00-1-1zm-1 2v2h-2V9h2zM5 9v2H3V9h2zm-2 3h2v7H3v-7zm11 0h-4a1 1 0 00-1 1v6H7V5h10v14h-2v-6a1 1 0 00-1-1zm5 7v-7h2v7h-2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M14 7h-4a1 1 0 000 2h4a1 1 0 100-2z"
  })]
}));

/**
UiDealershipLinedSmall icon

```jsx
import { UiDealershipLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDealershipLinedSmall />
```

 */
const UiDealershipLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9.5 6h-3a.5.5 0 100 1h3a.5.5 0 100-1zm0 3h-3a.5.5 0 00-.5.5V13h4V9.5a.5.5 0 00-.5-.5z"
  }), /*#__PURE__*/jsx("path", {
    d: "M15 6h-2V4a2 2 0 00-2-2H5a2 2 0 00-2 2v2H1a1 1 0 00-1 1v7a1 1 0 001 1h14a1 1 0 001-1V7a1 1 0 00-1-1zM2 8h1v5H2V8zm3-4h6v9H5V4zm9 9h-1V8h1v5z"
  })]
}));

/**
UiDeeplinkLined icon

```jsx
import { UiDeeplinkLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDeeplinkLined />
```

 */
const UiDeeplinkLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M8 1a1 1 0 00-1 1v3a1 1 0 002 0V3h12v11H9v-1.5a1 1 0 10-2 0V15a1 1 0 001 1h14a1 1 0 001-1V2a1 1 0 00-1-1H8z"
  }), /*#__PURE__*/jsx("path", {
    d: "M2 7a1 1 0 00-1 1v14a1 1 0 001 1h14a1 1 0 001-1v-3a1 1 0 10-2 0v2H3V9h12v1.5a1 1 0 102 0V8a1 1 0 00-1-1H2z"
  })]
}));

/**
UiDeeplinkLinedSmall icon

```jsx
import { UiDeeplinkLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDeeplinkLinedSmall />
```

 */
const UiDeeplinkLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M6 0a1 1 0 00-1 1v2a1 1 0 002 0V2h7v7.25H7V8.5a1 1 0 00-2 0v1.75a1 1 0 001 1h9a1 1 0 001-1V1a1 1 0 00-1-1H6z"
  }), /*#__PURE__*/jsx("path", {
    d: "M1 4.75a1 1 0 00-1 1V15a1 1 0 001 1h9a1 1 0 001-1v-2a1 1 0 10-2 0v1H2V6.75h7v.5a1 1 0 102 0v-1.5a1 1 0 00-1-1H1z"
  })]
}));

/**
UiDeviceDesktopFilled icon

```jsx
import { UiDeviceDesktopFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDeviceDesktopFilled />
```

 */
const UiDeviceDesktopFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M3 19h7v2H8a1 1 0 000 2h8a1 1 0 000-2h-2v-2h7a2 2 0 002-2H1a2 2 0 002 2zM21 2H3a2 2 0 00-2 2v11h22V4a2 2 0 00-2-2z"
  })
}));

/**
UiDeviceDesktopFilledSmall icon

```jsx
import { UiDeviceDesktopFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDeviceDesktopFilledSmall />
```

 */
const UiDeviceDesktopFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M2 13h4v1H4a1 1 0 000 2h8a1 1 0 000-2h-2v-1h4a2 2 0 002-2H0a2 2 0 002 2zM14 1H2a2 2 0 00-2 2v6h16V3a2 2 0 00-2-2z"
  })
}));

/**
UiDeviceDesktopLined icon

```jsx
import { UiDeviceDesktopLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDeviceDesktopLined />
```

 */
const UiDeviceDesktopLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M21 2H3a2 2 0 00-2 2v13a2 2 0 002 2h7v2H8a1 1 0 000 2h8a1 1 0 000-2h-2v-2h7a2 2 0 002-2V4a2 2 0 00-2-2zm0 2v11H3V4h18z"
  })
}));

/**
UiDeviceDesktopLinedSmall icon

```jsx
import { UiDeviceDesktopLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDeviceDesktopLinedSmall />
```

 */
const UiDeviceDesktopLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-device-desktop-lined-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M14 1H2a2 2 0 00-2 2v8a2 2 0 002 2h4v1H4a1 1 0 000 2h8a1 1 0 000-2h-2v-1h4a2 2 0 002-2V3a2 2 0 00-2-2zm0 2v7H2V3h12z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-device-desktop-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiDeviceLaptopFilled icon

```jsx
import { UiDeviceLaptopFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDeviceLaptopFilled />
```

 */
const UiDeviceLaptopFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22 18h-2a2 2 0 002-2V6a2 2 0 00-2-2H4a2 2 0 00-2 2v10a2 2 0 002 2H2a1 1 0 000 2h20a1 1 0 000-2z"
  })
}));

/**
UiDeviceLaptopFilledSmall icon

```jsx
import { UiDeviceLaptopFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDeviceLaptopFilledSmall />
```

 */
const UiDeviceLaptopFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-device-laptop-filled-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M15 12h-2a2 2 0 002-2V4a2 2 0 00-2-2H3a2 2 0 00-2 2v6a2 2 0 002 2H1a1 1 0 00-1 1 1 1 0 001 1h14a1 1 0 000-2z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-device-laptop-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiDeviceLaptopLined icon

```jsx
import { UiDeviceLaptopLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDeviceLaptopLined />
```

 */
const UiDeviceLaptopLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22 18h-2a2 2 0 002-2V6a2 2 0 00-2-2H4a2 2 0 00-2 2v10a2 2 0 002 2H2a1 1 0 000 2h20a1 1 0 000-2zM4 6h16v10H4V6z"
  })
}));

/**
UiDeviceLaptopLinedSmall icon

```jsx
import { UiDeviceLaptopLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDeviceLaptopLinedSmall />
```

 */
const UiDeviceLaptopLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-device-laptop-lined-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M15 12h-2a2 2 0 002-2V4a2 2 0 00-2-2H3a2 2 0 00-2 2v6a2 2 0 002 2H1a1 1 0 00-1 1 1 1 0 001 1h14a1 1 0 000-2zM3 4h10v6H3V4z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-device-laptop-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiDevicePhoneLandscapeFilled icon

```jsx
import { UiDevicePhoneLandscapeFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDevicePhoneLandscapeFilled />
```

 */
const UiDevicePhoneLandscapeFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 5H6v14h14a3 3 0 003-3V8a3 3 0 00-3-3zm1 9h-.5a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h.5v4zM1 8v8a3 3 0 003 3V5a3 3 0 00-3 3z"
  })
}));

/**
UiDevicePhoneLandscapeFilledSmall icon

```jsx
import { UiDevicePhoneLandscapeFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDevicePhoneLandscapeFilledSmall />
```

 */
const UiDevicePhoneLandscapeFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M2 3.18A3 3 0 000 6v4a3 3 0 002 2.82V3.18zM13 3H4v10h9a3 3 0 003-3V6a3 3 0 00-3-3zm1 6h-.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h.5v2z"
  })
}));

/**
UiDevicePhoneLandscapeLined icon

```jsx
import { UiDevicePhoneLandscapeLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDevicePhoneLandscapeLined />
```

 */
const UiDevicePhoneLandscapeLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 5H4a3 3 0 00-3 3v8a3 3 0 003 3h16a3 3 0 003-3V8a3 3 0 00-3-3zM3 16V8a1 1 0 011-1h1v10H4a1 1 0 01-1-1zm17 1H7V7h13a1 1 0 011 1v2h-.5a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h.5v2a1 1 0 01-1 1z"
  })
}));

/**
UiDevicePhoneLandscapeLinedSmall icon

```jsx
import { UiDevicePhoneLandscapeLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDevicePhoneLandscapeLinedSmall />
```

 */
const UiDevicePhoneLandscapeLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-device-phone-landscape-lined-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M13 3H3a3 3 0 00-3 3v4a3 3 0 003 3h10a3 3 0 003-3V6a3 3 0 00-3-3zM2 10V6a1 1 0 011-1v6a1 1 0 01-1-1zm11 1H5V5h8a1 1 0 011 1v1h-.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h.5v1a1 1 0 01-1 1z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-device-phone-landscape-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiDevicePhonePortraitFilled icon

```jsx
import { UiDevicePhonePortraitFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDevicePhonePortraitFilled />
```

 */
const UiDevicePhonePortraitFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M8 23h8a3 3 0 003-3H5a3 3 0 003 3zm8-22H8a3 3 0 00-3 3v14h14V4a3 3 0 00-3-3zm-2 2.5a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5V3h4v.5z"
  })
}));

/**
UiDevicePhonePortraitFilledSmall icon

```jsx
import { UiDevicePhonePortraitFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDevicePhonePortraitFilledSmall />
```

 */
const UiDevicePhonePortraitFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M3.18 14A3 3 0 006 16h4a3 3 0 002.82-2H3.18zM10 0H6a3 3 0 00-3 3v9h10V3a3 3 0 00-3-3zM9 2.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V2h2v.5z"
  })
}));

/**
UiDevicePhonePortraitLined icon

```jsx
import { UiDevicePhonePortraitLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDevicePhonePortraitLined />
```

 */
const UiDevicePhonePortraitLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M16 1H8a3 3 0 00-3 3v16a3 3 0 003 3h8a3 3 0 003-3V4a3 3 0 00-3-3zM8 3h2v.5a.5.5 0 00.5.5h3a.5.5 0 00.5-.5V3h2a1 1 0 011 1v13H7V4a1 1 0 011-1zm8 18H8a1 1 0 01-1-1v-1h10v1a1 1 0 01-1 1z"
  })
}));

/**
UiDevicePhonePortraitLinedSmall icon

```jsx
import { UiDevicePhonePortraitLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDevicePhonePortraitLinedSmall />
```

 */
const UiDevicePhonePortraitLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M10 0H6a3 3 0 00-3 3v10a3 3 0 003 3h4a3 3 0 003-3V3a3 3 0 00-3-3zM6 2h1v.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V2h1a1 1 0 011 1v8H5V3a1 1 0 011-1zm4 12H6a1 1 0 01-1-1h6a1 1 0 01-1 1z"
  })
}));

/**
UiDeviceTabletLandscapeFilled icon

```jsx
import { UiDeviceTabletLandscapeFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDeviceTabletLandscapeFilled />
```

 */
const UiDeviceTabletLandscapeFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 3H4a3 3 0 00-3 3v12a3 3 0 003 3h16a3 3 0 003-3V6a3 3 0 00-3-3zM5 13a1 1 0 110-2 1 1 0 010 2z"
  })
}));

/**
UiDeviceTabletLandscapeFilledSmall icon

```jsx
import { UiDeviceTabletLandscapeFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDeviceTabletLandscapeFilledSmall />
```

 */
const UiDeviceTabletLandscapeFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-device-tablet-landscape-filled-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M13 1H3a3 3 0 00-3 3v8a3 3 0 003 3h10a3 3 0 003-3V4a3 3 0 00-3-3zM4 9a1 1 0 110-2 1 1 0 010 2z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-device-tablet-landscape-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiDeviceTabletLandscapeLined icon

```jsx
import { UiDeviceTabletLandscapeLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDeviceTabletLandscapeLined />
```

 */
const UiDeviceTabletLandscapeLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M20 3H4a3 3 0 00-3 3v12a3 3 0 003 3h16a3 3 0 003-3V6a3 3 0 00-3-3zm1 15a1 1 0 01-1 1H4a1 1 0 01-1-1V6a1 1 0 011-1h16a1 1 0 011 1v12z"
  }), /*#__PURE__*/jsx("path", {
    d: "M5 13a1 1 0 100-2 1 1 0 000 2z"
  })]
}));

/**
UiDeviceTabletLandscapeLinedSmall icon

```jsx
import { UiDeviceTabletLandscapeLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDeviceTabletLandscapeLinedSmall />
```

 */
const UiDeviceTabletLandscapeLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M13 1H3a3 3 0 00-3 3v8a3 3 0 003 3h10a3 3 0 003-3V4a3 3 0 00-3-3zm1 11a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1h10a1 1 0 011 1v8z"
  }), /*#__PURE__*/jsx("path", {
    d: "M4 9a1 1 0 100-2 1 1 0 000 2z"
  })]
}));

/**
UiDeviceTabletPortraitFilled icon

```jsx
import { UiDeviceTabletPortraitFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDeviceTabletPortraitFilled />
```

 */
const UiDeviceTabletPortraitFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M18 1H6a3 3 0 00-3 3v16a3 3 0 003 3h12a3 3 0 003-3V4a3 3 0 00-3-3zm-6 19a1 1 0 110-2 1 1 0 010 2z"
  })
}));

/**
UiDeviceTabletPortraitFilledSmall icon

```jsx
import { UiDeviceTabletPortraitFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDeviceTabletPortraitFilledSmall />
```

 */
const UiDeviceTabletPortraitFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 0H4a3 3 0 00-3 3v10a3 3 0 003 3h8a3 3 0 003-3V3a3 3 0 00-3-3zM8 13a1 1 0 110-2 1 1 0 010 2z"
  })
}));

/**
UiDeviceTabletPortraitLined icon

```jsx
import { UiDeviceTabletPortraitLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDeviceTabletPortraitLined />
```

 */
const UiDeviceTabletPortraitLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M18 1H6a3 3 0 00-3 3v16a3 3 0 003 3h12a3 3 0 003-3V4a3 3 0 00-3-3zm1 19a1 1 0 01-1 1H6a1 1 0 01-1-1V4a1 1 0 011-1h12a1 1 0 011 1v16z"
  }), /*#__PURE__*/jsx("path", {
    d: "M12 20a1 1 0 100-2 1 1 0 000 2z"
  })]
}));

/**
UiDeviceTabletPortraitLinedSmall icon

```jsx
import { UiDeviceTabletPortraitLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDeviceTabletPortraitLinedSmall />
```

 */
const UiDeviceTabletPortraitLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12 0H4a3 3 0 00-3 3v10a3 3 0 003 3h8a3 3 0 003-3V3a3 3 0 00-3-3zm1 13a1 1 0 01-1 1H4a1 1 0 01-1-1V3a1 1 0 011-1h8a1 1 0 011 1v10z"
  }), /*#__PURE__*/jsx("path", {
    d: "M8 13a1 1 0 100-2 1 1 0 000 2z"
  })]
}));

/**
UiDeviceWatchFilled icon

```jsx
import { UiDeviceWatchFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDeviceWatchFilled />
```

 */
const UiDeviceWatchFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M8.06 20l.28 2.13a1 1 0 001 .87h5.34a1 1 0 001-.87l.26-2.13H8.06zm7.88-16l-.28-2.13a1 1 0 00-1-.87H9.33a1 1 0 00-1 .87L8.06 4h7.88zM19 9V8a3 3 0 00-2.92-3H7.92A3 3 0 005 8v8a3 3 0 002.92 3h8.16A3 3 0 0019 16v-4a1 1 0 001-1v-1a1 1 0 00-1-1z"
  })
}));

/**
UiDeviceWatchFilledSmall icon

```jsx
import { UiDeviceWatchFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDeviceWatchFilledSmall />
```

 */
const UiDeviceWatchFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-device-watch-filled-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M5.68 15.16a1 1 0 001 .84h2.65a1 1 0 001-.84l.18-1.16h-5l.17 1.16zM10.32.84a1 1 0 00-1-.84H6.67a1 1 0 00-1 .84L5.49 2h5L10.32.84zM13.25 6H13v-.5A2.5 2.5 0 0010.5 3h-5A2.5 2.5 0 003 5.5v5A2.5 2.5 0 005.5 13h5a2.5 2.5 0 002.5-2.5V8h.25a.76.76 0 00.75-.75v-.5a.76.76 0 00-.75-.75z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-device-watch-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiDeviceWatchLined icon

```jsx
import { UiDeviceWatchLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDeviceWatchLined />
```

 */
const UiDeviceWatchLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M19 9V8a3 3 0 00-2.92-3l-.42-3.14a1 1 0 00-1-.87H9.33a1 1 0 00-1 .87L7.92 5A3 3 0 005 8v8a3 3 0 002.92 3l.42 3.14a1 1 0 001 .87h5.34a1 1 0 001-.87l.4-3.14A3 3 0 0019 16v-4a1 1 0 001-1v-1a1 1 0 00-1-1zm-5.21-6l.27 2H9.94l.27-2h3.58zm-3.58 18l-.27-2h4.12l-.27 2h-3.58zM17 16a1 1 0 01-1 1H8a1 1 0 01-1-1V8a1 1 0 011-1h8a1 1 0 011 1v8z"
  })
}));

/**
UiDeviceWatchLinedSmall icon

```jsx
import { UiDeviceWatchLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDeviceWatchLinedSmall />
```

 */
const UiDeviceWatchLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-device-watch-lined-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M13.25 6H13v-.5A2.48 2.48 0 0010.68 3L10.32.84a1 1 0 00-1-.84H6.67a1 1 0 00-1 .84L5.32 3A2.48 2.48 0 003 5.5v5A2.48 2.48 0 005.32 13l.36 2.18a1 1 0 001 .84h2.65a1 1 0 001-.84l.35-2.18A2.48 2.48 0 0013 10.5V8h.25a.76.76 0 00.75-.75v-.5a.76.76 0 00-.75-.75zM11 10.5a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h5a.5.5 0 01.5.5v5z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-device-watch-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiDiningFilled icon

```jsx
import { UiDiningFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDiningFilled />
```

 */
const UiDiningFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M11 3c0-.6.4-1 1-1s1 .4 1 1v5c0 2-1.2 3.8-3 4.6V20c0 1.1-.9 2-2 2s-2-.9-2-2v-7.4C4.2 11.8 3 10 3 8V3c0-.6.4-1 1-1s1 .4 1 1v4c0 .6.4 1 1 1s1-.4 1-1V3c0-.6.4-1 1-1s1 .4 1 1v4c0 .6.4 1 1 1s1-.4 1-1V3zm4 0c0-.6.4-1 1-1 .5 0 5 .3 5 12 0 .6-.4 1-1 1h-1v5c0 1.1-.9 2-2 2s-2-.9-2-2V3z"
  })
}));

/**
UiDiningFilledSmall icon

```jsx
import { UiDiningFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDiningFilledSmall />
```

 */
const UiDiningFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M10.4 1.2c.3-.2.6-.3.9-.1.2 0 3.7 1.3 3.7 7.9 0 .6-.4 1-1 1h-1v3.5c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5V2c0-.3.2-.6.4-.8zm-2.9.6c0-.5.3-.8.7-.8.5 0 .8.3.8.8V6c0 1.5-1.1 2.7-2.5 2.9v4.6c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5V8.9C2.1 8.7 1 7.5 1 6V1.8c0-.5.4-.8.8-.8s.7.3.7.8v3c0 .4.3.9.8.9s.9-.4.9-.9v-3c0-.5.4-.8.8-.8s.8.3.8.8v3c0 .4.3.9.8.9s.9-.4.9-.9v-3z"
  })
}));

/**
UiDiningLined icon

```jsx
import { UiDiningLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDiningLined />
```

 */
const UiDiningLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M7 9c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1s-1 .4-1 1v5c0 .6.4 1 1 1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M11 2c-.6 0-1 .4-1 1v5c0 1.1-.6 2-1.5 2.6-.3.2-.5.5-.5.8V19c0 .6-.4 1-1 1s-1-.4-1-1v-7.6c0-.4-.2-.7-.5-.9C4.6 10 4 9.1 4 8V3c0-.6-.4-1-1-1s-1 .4-1 1v5c0 1.6.8 3 2 4v7c0 1.7 1.3 3 3 3s3-1.3 3-3v-7c1.2-.9 2-2.4 2-4V3c0-.6-.4-1-1-1zm4 0c-.6 0-1 .4-1 1v16c0 1.7 1.3 3 3 3s3-1.3 3-3v-4h1c.6 0 1-.4 1-1 0-11.9-6.7-12-7-12zm4 11c-.6 0-1 .4-1 1v5c0 .6-.4 1-1 1s-1-.4-1-1V4.2c1.4.6 3.8 2.5 4 8.8h-1z"
  })]
}));

/**
UiDirectionsFilled icon

```jsx
import { UiDirectionsFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDirectionsFilled />
```

 */
const UiDirectionsFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.67 1.59c.39-.39.9-.59 1.41-.59.51 0 1.02.2 1.41.58l9.08 9.08c.78.78.78 2.05 0 2.83l-9.08 9.08c-.39.39-.9.59-1.41.59-.51 0-1.02-.2-1.41-.59l-9.08-9.08c-.78-.78-.78-2.05 0-2.83l9.08-9.07zM8.08 16.08a1 1 0 002 .01v-3c0-.55.45-1 1-1h3.59l-1.29 1.29a.996.996 0 000 1.41c.2.19.45.29.71.29.26 0 .51-.09.71-.29l3-3a.996.996 0 000-1.41l-3-3c-.2-.19-.45-.29-.71-.29a.996.996 0 00-.71 1.7l1.29 1.29h-3.59c-1.65 0-3 1.35-3 3v3z"
  })
}));

/**
UiDirectionsFilledSmall icon

```jsx
import { UiDirectionsFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDirectionsFilledSmall />
```

 */
const UiDirectionsFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-directions-filled-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M15.71 7.29l-7-7a.996.996 0 00-1.41 0l-7 7a.996.996 0 000 1.41l7 7c.19.2.44.3.7.3.26 0 .51-.1.71-.29l7-7c.39-.39.39-1.03 0-1.42zm-3.86.56l-2.5 2.5a.47.47 0 01-.35.15.47.47 0 01-.35-.15c-.2-.2-.2-.51 0-.71L10.29 8H6v2.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5V8c0-.55.45-1 1-1h4.29L8.65 5.35c-.2-.2-.2-.51 0-.71.2-.2.51-.2.71 0l2.5 2.5c.19.2.19.52-.01.71z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-directions-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiDirectionsLined icon

```jsx
import { UiDirectionsLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDirectionsLined />
```

 */
const UiDirectionsLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M13.66 10.07l-1.29-1.29a.996.996 0 01.01-1.41.996.996 0 011.41 0l3 3c.39.39.39 1.02 0 1.41l-3 3c-.2.19-.45.29-.71.29a.996.996 0 01-.71-1.7l1.29-1.29H10.5c-.23 0-.42.19-.42.42v2.57c0 .55-.45 1-1 1s-1-.45-1-1v-2.58c0-1.33 1.08-2.42 2.42-2.42h3.16z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.49 1.58l9.08 9.08c.78.78.78 2.05 0 2.83l-9.08 9.08c-.39.39-.9.59-1.41.59-.51 0-1.02-.2-1.41-.59l-9.08-9.08c-.78-.78-.78-2.05 0-2.83l9.08-9.07c.39-.39.9-.59 1.41-.59.51 0 1.02.2 1.41.58zM3 12.08l9.08 9.07 9.07-9.07L12.07 3 3 12.08z"
  })]
}));

/**
UiDirectionsLinedSmall icon

```jsx
import { UiDirectionsLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDirectionsLinedSmall />
```

 */
const UiDirectionsLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsxs("g", {
    clipPath: "url(#omni-gravity-icon-ui-directions-lined-small-a)",
    children: [/*#__PURE__*/jsx("path", {
      d: "M9.29 7L8.15 5.85c-.2-.19-.21-.5-.01-.7.2-.2.51-.2.71 0l2 2c.05.04.08.1.11.16a.5.5 0 010 .38c-.03.06-.06.11-.11.16l-2 2a.47.47 0 01-.35.15.495.495 0 01-.35-.85L9.29 8H6v1.5c0 .28-.22.5-.5.5S5 9.78 5 9.5V8c0-.55.45-1 1-1h3.29z"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.71.29l7 7c.39.39.39 1.03 0 1.42l-7 7c-.2.19-.45.29-.71.29-.26 0-.51-.1-.7-.3l-7-7a.996.996 0 010-1.41l7-7a.996.996 0 011.41 0zM2.41 8L8 13.59 13.59 8 8 2.41 2.41 8z"
    })]
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-directions-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiDocumentCsvFilled icon

```jsx
import { UiDocumentCsvFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDocumentCsvFilled />
```

 */
const UiDocumentCsvFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9 7V3L5 7h4z"
  }), /*#__PURE__*/jsx("path", {
    d: "M20 15V3c0-.55-.45-1-1-1h-8v6c0 .55-.45 1-1 1H4v12c0 .55.45 1 1 1h15c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm-1.53 5.68c-.07.2-.26.32-.47.32-.21 0-.39-.13-.47-.32l-1.5-4c-.1-.26.03-.55.29-.64.26-.1.55.03.64.29l1.03 2.75 1.03-2.75c.1-.26.39-.39.64-.29.26.1.39.38.29.64l-1.48 4zm-6.02-.03a.507.507 0 01-.11-.7c.16-.22.48-.27.7-.11 0 0 .24.15.7.15.42 0 .75-.27.75-.5 0-.28-.22-.5-.5-.5h-.5c-.83 0-1.5-.67-1.5-1.5 0-.88.92-1.5 1.75-1.5.73 0 1.22.29 1.27.33.23.15.3.46.15.69a.51.51 0 01-.69.16c-.01 0-.3-.17-.74-.17-.39 0-.75.28-.75.5 0 .28.22.5.5.5h.5c.83 0 1.5.67 1.5 1.5s-.79 1.5-1.75 1.5c-.78 0-1.23-.31-1.28-.35zM8 19.25v-1.5c0-1 .92-1.75 1.75-1.75.76 0 1.33.47 1.39.52.21.18.24.49.06.7-.18.21-.49.23-.7.06-.01-.01-.35-.29-.75-.29-.33 0-.75.35-.75.75v1.5c0 .42.4.75.75.75.42 0 .73-.27.73-.27.21-.18.52-.17.7.04.18.2.17.51-.03.7-.06.06-.6.54-1.41.54C8.82 21 8 20.18 8 19.25z"
  })]
}));

/**
UiDocumentCsvLined icon

```jsx
import { UiDocumentCsvLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDocumentCsvLined />
```

 */
const UiDocumentCsvLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 15V3c0-.55-.45-1-1-1h-8.59c-.27 0-.52.11-.71.29L4.29 7.7a.99.99 0 00-.29.71V21c0 .55.45 1 1 1h15c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm-1.53 5.68c-.07.2-.26.32-.47.32-.21 0-.39-.13-.47-.32l-1.5-4c-.1-.26.03-.55.29-.64.26-.1.55.03.64.29l1.03 2.75 1.03-2.75c.1-.26.39-.39.64-.29.26.1.39.38.29.64l-1.48 4zm-6.12-.73c.16-.22.48-.27.7-.11 0 0 .24.15.7.15.42 0 .75-.27.75-.5 0-.28-.22-.5-.5-.5h-.5c-.83 0-1.5-.67-1.5-1.5 0-.88.92-1.5 1.75-1.5.73 0 1.22.29 1.27.33.23.15.3.46.15.69a.51.51 0 01-.69.16c-.01 0-.3-.17-.74-.17-.39 0-.75.28-.75.5 0 .28.22.5.5.5h.5c.83 0 1.5.67 1.5 1.5S14.7 21 13.74 21c-.8 0-1.25-.31-1.3-.35a.503.503 0 01-.09-.7zM8 19.25v-1.5c0-1 .92-1.75 1.75-1.75.76 0 1.33.47 1.39.52.21.18.24.49.06.7-.18.21-.49.23-.7.06-.01-.01-.35-.29-.75-.29-.33 0-.75.35-.75.75v1.5c0 .42.4.75.75.75.42 0 .73-.27.73-.27.21-.18.52-.17.7.04.18.2.17.51-.03.7-.06.06-.6.54-1.41.54C8.82 21 8 20.18 8 19.25zm2-14.42V8H6.83L10 4.83zM6 10h5c.55 0 1-.45 1-1V4h6v11H8c-.55 0-1 .45-1 1v4H6V10z"
  })
}));

/**
UiDocumentDocFilled icon

```jsx
import { UiDocumentDocFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDocumentDocFilled />
```

 */
const UiDocumentDocFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9 7V3L5 7h4zm6.5 12.25v-1.5c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.5c0 .41.34.75.75.75s.75-.34.75-.75zm-4-.75c0-.83-.67-1.5-1.5-1.5v3c.83 0 1.5-.67 1.5-1.5z"
  }), /*#__PURE__*/jsx("path", {
    d: "M20 15V3c0-.55-.45-1-1-1h-8v6c0 .55-.45 1-1 1H4v12c0 .55.45 1 1 1h15c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm-3.5 2.75v1.5c0 .96-.79 1.75-1.75 1.75S13 20.21 13 19.25v-1.5c0-.96.79-1.75 1.75-1.75s1.75.79 1.75 1.75zM9 20.5v-4c0-.28.22-.5.5-.5h.5a2.5 2.5 0 010 5h-.5c-.28 0-.5-.22-.5-.5zm11.16-.04c-.06.06-.6.54-1.41.54-.93 0-1.75-.82-1.75-1.75v-1.5c0-1 .92-1.75 1.75-1.75.76 0 1.33.47 1.39.52.21.18.24.49.06.7-.18.21-.49.23-.7.06-.01-.01-.35-.29-.75-.29-.33 0-.75.35-.75.75v1.5c0 .42.4.75.75.75.42 0 .73-.27.73-.27.21-.18.52-.17.7.04.19.21.18.52-.02.7z"
  })]
}));

/**
UiDocumentDocLined icon

```jsx
import { UiDocumentDocLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDocumentDocLined />
```

 */
const UiDocumentDocLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11.5 18.5c0-.83-.67-1.5-1.5-1.5v3c.83 0 1.5-.67 1.5-1.5zm4 .75v-1.5c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.5c0 .41.34.75.75.75s.75-.34.75-.75z"
  }), /*#__PURE__*/jsx("path", {
    d: "M20 15V3c0-.55-.45-1-1-1h-8.59c-.27 0-.52.11-.71.29L4.29 7.7a.99.99 0 00-.29.71V21c0 .55.45 1 1 1h15c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm-3.5 2.75v1.5c0 .96-.79 1.75-1.75 1.75S13 20.21 13 19.25v-1.5c0-.96.79-1.75 1.75-1.75s1.75.79 1.75 1.75zM9 16.5c0-.28.22-.5.5-.5h.5a2.5 2.5 0 010 5h-.5c-.28 0-.5-.22-.5-.5v-4zm1-11.67V8H6.83L10 4.83zM6 10h5c.55 0 1-.45 1-1V4h6v11H9c-.55 0-1 .45-1 1v4H6V10zm14.16 10.46c-.06.06-.6.54-1.41.54-.93 0-1.75-.82-1.75-1.75v-1.5c0-1 .92-1.75 1.75-1.75.76 0 1.33.47 1.39.52.21.18.24.49.06.7-.18.21-.49.23-.7.06-.01-.01-.35-.29-.75-.29-.33 0-.75.35-.75.75v1.5c0 .42.4.75.75.75.42 0 .73-.27.73-.27.21-.18.52-.17.7.04.19.21.18.52-.02.7z"
  })]
}));

/**
UiDocumentDocxFilled icon

```jsx
import { UiDocumentDocxFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDocumentDocxFilled />
```

 */
const UiDocumentDocxFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9 7V3L5 7h4zm1.5 12.25v-1.5c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.5c0 .41.34.75.75.75s.75-.34.75-.75zm-4-.75c0-.83-.67-1.5-1.5-1.5v3c.83 0 1.5-.67 1.5-1.5z"
  }), /*#__PURE__*/jsx("path", {
    d: "M20 15V3c0-.55-.45-1-1-1h-8v6c0 .55-.45 1-1 1H4v6c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm-.58 5.24c.15.23.08.54-.16.69-.08.05-.17.08-.26.08a.47.47 0 01-.42-.24l-.83-1.32-.83 1.32c-.09.15-.26.24-.42.24a.42.42 0 01-.26-.08.504.504 0 01-.16-.69l1.08-1.74-1.08-1.74a.495.495 0 01.16-.69c.23-.15.54-.08.69.16l.83 1.32.83-1.32c.15-.24.46-.3.69-.16.23.15.31.46.16.69l-1.08 1.74 1.06 1.74zM8 19.25v-1.5c0-.96.79-1.75 1.75-1.75s1.75.79 1.75 1.75v1.5c0 .96-.79 1.75-1.75 1.75S8 20.21 8 19.25zm4 0v-1.5c0-1 .92-1.75 1.75-1.75.76 0 1.33.47 1.39.52.21.18.24.49.06.7-.18.21-.49.23-.7.06-.01-.01-.35-.29-.75-.29-.33 0-.75.35-.75.75v1.5c0 .42.4.75.75.75.42 0 .73-.27.73-.27.21-.18.52-.17.7.04.18.2.17.51-.03.7-.06.06-.6.54-1.41.54-.92 0-1.74-.82-1.74-1.75zM4.5 16H5a2.5 2.5 0 010 5h-.5c-.28 0-.5-.22-.5-.5v-4c0-.28.22-.5.5-.5z"
  })]
}));

/**
UiDocumentDocxLined icon

```jsx
import { UiDocumentDocxLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDocumentDocxLined />
```

 */
const UiDocumentDocxLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M10.5 19.25v-1.5c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.5c0 .41.34.75.75.75s.75-.34.75-.75zm-4-.75c0-.83-.67-1.5-1.5-1.5v3c.83 0 1.5-.67 1.5-1.5z"
  }), /*#__PURE__*/jsx("path", {
    d: "M20 15V3c0-.55-.45-1-1-1h-8.59c-.27 0-.52.11-.71.29L4.29 7.7a.99.99 0 00-.29.71V15c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm-.58 5.24c.15.23.08.54-.16.69-.08.05-.17.08-.26.08a.47.47 0 01-.42-.24l-.83-1.32-.83 1.32c-.09.15-.26.24-.42.24a.42.42 0 01-.26-.08.504.504 0 01-.16-.69l1.08-1.74-1.08-1.74a.495.495 0 01.16-.69c.23-.15.54-.08.69.16l.83 1.32.83-1.32c.15-.24.46-.3.69-.16.23.15.31.46.16.69l-1.08 1.74 1.06 1.74zm-4.26.22c-.06.06-.6.54-1.41.54-.93 0-1.75-.82-1.75-1.75v-1.5c0-1 .92-1.75 1.75-1.75.76 0 1.33.47 1.39.52.21.18.24.49.06.7-.18.21-.49.23-.7.06-.01-.01-.35-.29-.75-.29-.33 0-.75.35-.75.75v1.5c0 .42.4.75.75.75.42 0 .73-.27.73-.27.21-.18.52-.17.7.04.19.21.18.52-.02.7zM8 19.25v-1.5c0-.96.79-1.75 1.75-1.75s1.75.79 1.75 1.75v1.5c0 .96-.79 1.75-1.75 1.75S8 20.21 8 19.25zM4.5 16H5a2.5 2.5 0 010 5h-.5c-.28 0-.5-.22-.5-.5v-4c0-.28.22-.5.5-.5zM10 4.83V8H6.83L10 4.83zM6 10h5c.55 0 1-.45 1-1V4h6v11H6v-5z"
  })]
}));

/**
UiDocumentJpgFilled icon

```jsx
import { UiDocumentJpgFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDocumentJpgFilled />
```

 */
const UiDocumentJpgFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9 7V3L5 7h4zm5 10h-1v1h1c.28 0 .5-.22.5-.5s-.22-.5-.5-.5z"
  }), /*#__PURE__*/jsx("path", {
    d: "M20 15V3c0-.55-.45-1-1-1h-8v6c0 .55-.45 1-1 1H4v12c0 .55.45 1 1 1h15c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm-1.39 5.8c-.24.12-.52.2-.86.2-1 0-1.75-.73-1.75-1.69v-1.56c0-1 .92-1.75 1.75-1.75.76 0 1.33.47 1.39.52.21.18.24.49.06.7-.18.21-.49.23-.7.06-.02-.01-.36-.29-.75-.29-.33 0-.75.35-.75.75v1.56c0 .41.31.69.75.69.61 0 .75-.44.75-.61V19c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h.5c.28 0 .5.22.5.5v2a.495.495 0 01-.89.3zM12 20.5v-4c0-.28.22-.5.5-.5H14c.83 0 1.5.67 1.5 1.5S14.83 19 14 19h-1v1.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5zm-3.71.29a.507.507 0 01-.21-.68.51.51 0 01.68-.21c.12.06.29.1.49.1.71 0 .75-.42.75-.5v-3c0-.28.22-.5.5-.5s.5.22.5.5v3c0 .6-.47 1.5-1.75 1.5-.37 0-.69-.07-.96-.21z"
  })]
}));

/**
UiDocumentJpgLined icon

```jsx
import { UiDocumentJpgLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDocumentJpgLined />
```

 */
const UiDocumentJpgLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M14 17h-1v1h1c.28 0 .5-.22.5-.5s-.22-.5-.5-.5z"
  }), /*#__PURE__*/jsx("path", {
    d: "M20 15V3c0-.55-.45-1-1-1h-8.59c-.27 0-.52.11-.71.29L4.29 7.7a.99.99 0 00-.29.71V21c0 .55.45 1 1 1h15c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm-8 1.5c0-.28.22-.5.5-.5H14c.83 0 1.5.67 1.5 1.5S14.83 19 14 19h-1v1.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-4zm4 2.81v-1.56c0-1 .92-1.75 1.75-1.75.76 0 1.33.47 1.39.52.21.18.24.49.06.7-.18.21-.49.23-.7.06-.02-.01-.36-.29-.75-.29-.33 0-.75.35-.75.75v1.56c0 .41.31.69.75.69.61 0 .75-.44.75-.61V19c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h.5c.28 0 .5.22.5.5v2a.495.495 0 01-.89.3c-.24.12-.52.2-.86.2-1 0-1.75-.73-1.75-1.69zm-7.91.8c.13-.25.43-.33.68-.21.12.06.29.1.49.1.71 0 .75-.42.75-.5v-3c0-.28.22-.5.5-.5s.5.22.5.5v3c0 .6-.47 1.5-1.75 1.5-.37 0-.69-.07-.96-.21a.501.501 0 01-.21-.68zM10 4.83V8H6.83L10 4.83zM6 10h5c.55 0 1-.45 1-1V4h6v11H8c-.55 0-1 .45-1 1v4H6V10z"
  })]
}));

/**
UiDocumentPdfFilled icon

```jsx
import { UiDocumentPdfFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDocumentPdfFilled />
```

 */
const UiDocumentPdfFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9 7V3L5 7h4zm2 10h-1v1h1c.28 0 .5-.22.5-.5s-.22-.5-.5-.5zm4.5 2v-1c0-.55-.45-1-1-1H14v3h.5c.55 0 1-.45 1-1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M20 15V3c0-.55-.45-1-1-1h-8v6c0 .55-.45 1-1 1H4v12c0 .55.45 1 1 1h15c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm-1 3c.28 0 .5.22.5.5s-.22.5-.5.5h-1v1.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-4c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5s-.22.5-.5.5H18v1h1zm-6 2.5v-4c0-.28.22-.5.5-.5h1c1.1 0 2 .9 2 2v1c0 1.1-.9 2-2 2h-1c-.28 0-.5-.22-.5-.5zm-4 0v-4c0-.28.22-.5.5-.5H11c.83 0 1.5.67 1.5 1.5S11.83 19 11 19h-1v1.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5z"
  })]
}));

/**
UiDocumentPdfLined icon

```jsx
import { UiDocumentPdfLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDocumentPdfLined />
```

 */
const UiDocumentPdfLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11 17h-1v1h1c.28 0 .5-.22.5-.5s-.22-.5-.5-.5zm4.5 2v-1c0-.55-.45-1-1-1H14v3h.5c.55 0 1-.45 1-1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M20 15V3c0-.55-.45-1-1-1h-8.59c-.27 0-.52.11-.71.29L4.29 7.7a.99.99 0 00-.29.71V21c0 .55.45 1 1 1h15c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm-1 3c.28 0 .5.22.5.5s-.22.5-.5.5h-1v1.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-4c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5s-.22.5-.5.5H18v1h1zm-6-1.5c0-.28.22-.5.5-.5h1c1.1 0 2 .9 2 2v1c0 1.1-.9 2-2 2h-1c-.28 0-.5-.22-.5-.5v-4zm-4 0c0-.28.22-.5.5-.5H11c.83 0 1.5.67 1.5 1.5S11.83 19 11 19h-1v1.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-4zm1-11.67V8H6.83L10 4.83zM6 10h5c.55 0 1-.45 1-1V4h6v11H9c-.55 0-1 .45-1 1v4H6V10z"
  })]
}));

/**
UiDocumentPngFilled icon

```jsx
import { UiDocumentPngFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDocumentPngFilled />
```

 */
const UiDocumentPngFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9 7V3L5 7h4zm0 10H8v1h1c.28 0 .5-.22.5-.5S9.28 17 9 17z"
  }), /*#__PURE__*/jsx("path", {
    d: "M20 15V3c0-.55-.45-1-1-1h-8v6c0 .55-.45 1-1 1H4v12c0 .55.45 1 1 1h15c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm-1.39 5.8c-.24.12-.52.2-.86.2-1 0-1.75-.73-1.75-1.69v-1.56c0-1 .92-1.75 1.75-1.75.76 0 1.33.47 1.39.52.21.18.24.49.06.7-.18.21-.49.23-.7.06-.02-.01-.36-.29-.75-.29-.33 0-.75.35-.75.75v1.56c0 .41.31.69.75.69.61 0 .75-.44.75-.61V19c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h.5c.28 0 .5.22.5.5v2a.495.495 0 01-.89.3zm-4.51 0L12 18v2.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-4c0-.21.14-.41.34-.47s.43 0 .56.17L14 19v-2.5c0-.28.22-.5.5-.5s.5.22.5.5v4c0 .21-.14.41-.34.47-.05.02-.11.03-.16.03-.15 0-.3-.07-.4-.2zM7 20.5v-4c0-.28.22-.5.5-.5H9c.83 0 1.5.67 1.5 1.5S9.83 19 9 19H8v1.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5z"
  })]
}));

/**
UiDocumentPngLined icon

```jsx
import { UiDocumentPngLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDocumentPngLined />
```

 */
const UiDocumentPngLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9 17H8v1h1c.28 0 .5-.22.5-.5S9.28 17 9 17z"
  }), /*#__PURE__*/jsx("path", {
    d: "M20 15V3c0-.55-.45-1-1-1h-8.59c-.27 0-.52.11-.71.29L4.29 7.7a.99.99 0 00-.29.71V21c0 .55.45 1 1 1h15c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm-8 3v2.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-4c0-.21.14-.41.34-.47s.43 0 .56.17L14 19v-2.5c0-.28.22-.5.5-.5s.5.22.5.5v4c0 .21-.14.41-.34.47-.05.02-.11.03-.16.03-.15 0-.3-.07-.4-.2L12 18zm4 1.31v-1.56c0-1 .92-1.75 1.75-1.75.76 0 1.33.47 1.39.52.21.18.24.49.06.7-.18.21-.49.23-.7.06-.02-.01-.36-.29-.75-.29-.33 0-.75.35-.75.75v1.56c0 .41.31.69.75.69.61 0 .75-.44.75-.61V19c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h.5c.28 0 .5.22.5.5v2a.495.495 0 01-.89.3c-.24.12-.52.2-.86.2-1 0-1.75-.73-1.75-1.69zM7 16.5c0-.28.22-.5.5-.5H9c.83 0 1.5.67 1.5 1.5S9.83 19 9 19H8v1.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-4zM18 15H7c-.55 0-1 .45-1 1v-6h5c.55 0 1-.45 1-1V4h6v11zM10 4.83V8H6.83L10 4.83z"
  })]
}));

/**
UiDocumentPptFilled icon

```jsx
import { UiDocumentPptFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDocumentPptFilled />
```

 */
const UiDocumentPptFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M14 17h1c.3 0 .5.2.5.5s-.2.5-.5.5h-1v-1zm-3 0h-1v1h1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 2c.6 0 1 .4 1 1v12c.6 0 1 .4 1 1v5c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1V9h6c.6 0 1-.4 1-1V2h8zm0 18.5V17h.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-2c-.3 0-.5.2-.5.5s.2.5.5.5h.5v3.5c0 .3.2.5.5.5s.5-.2.5-.5zm-6-4v4c0 .3.2.5.5.5s.5-.2.5-.5V19h1c.8 0 1.5-.7 1.5-1.5S15.8 16 15 16h-1.5c-.3 0-.5.2-.5.5zm-4 0v4c0 .3.2.5.5.5s.5-.2.5-.5V19h1c.8 0 1.5-.7 1.5-1.5S11.8 16 11 16H9.5c-.3 0-.5.2-.5.5z"
  }), /*#__PURE__*/jsx("path", {
    d: "M9 3v4H5l4-4z"
  })]
}));

/**
UiDocumentPptLined icon

```jsx
import { UiDocumentPptLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDocumentPptLined />
```

 */
const UiDocumentPptLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M15 17h-1v1h1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zm-4 0h-1v1h1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 2c.6 0 1 .4 1 1v12c.6 0 1 .4 1 1v5c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1V8.4c0-.3.1-.5.3-.7l5.4-5.4c.2-.2.4-.3.7-.3H19zm0 18.5V17h.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-2c-.3 0-.5.2-.5.5s.2.5.5.5h.5v3.5c0 .3.2.5.5.5s.5-.2.5-.5zM13.5 16c-.3 0-.5.2-.5.5v4c0 .3.2.5.5.5s.5-.2.5-.5V19h1c.8 0 1.5-.7 1.5-1.5S15.8 16 15 16h-1.5zm-4 0c-.3 0-.5.2-.5.5v4c0 .3.2.5.5.5s.5-.2.5-.5V19h1c.8 0 1.5-.7 1.5-1.5S11.8 16 11 16H9.5zm.5-8V4.8L6.8 8H10zm1 2H6v10h2v-4c0-.6.4-1 1-1h9V4h-6v5c0 .6-.4 1-1 1z"
  })]
}));

/**
UiDocumentPptxFilled icon

```jsx
import { UiDocumentPptxFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDocumentPptxFilled />
```

 */
const UiDocumentPptxFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9 7V3L5 7h4zm2 10h-1v1h1c.28 0 .5-.22.5-.5s-.22-.5-.5-.5zm-4 0H6v1h1c.28 0 .5-.22.5-.5S7.28 17 7 17z"
  }), /*#__PURE__*/jsx("path", {
    d: "M20 15V3c0-.55-.45-1-1-1h-8v6c0 .55-.45 1-1 1H4v12c0 .55.45 1 1 1h15c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm-.08 5.24c.15.23.08.54-.16.69-.08.05-.17.08-.26.08a.47.47 0 01-.42-.24l-.83-1.32-.83 1.32c-.09.15-.26.24-.42.24a.42.42 0 01-.26-.08.504.504 0 01-.16-.69l1.08-1.74-1.08-1.74a.495.495 0 01.16-.69c.23-.15.54-.08.69.16l.83 1.32.83-1.32c.15-.24.46-.3.69-.16.23.15.31.46.16.69l-1.08 1.74 1.06 1.74zM5 20.5v-4c0-.28.22-.5.5-.5H7c.83 0 1.5.67 1.5 1.5S7.83 19 7 19H6v1.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5zm4 0v-4c0-.28.22-.5.5-.5H11c.83 0 1.5.67 1.5 1.5S11.83 19 11 19h-1v1.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5zm5 0V17h-.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h2c.28 0 .5.22.5.5s-.22.5-.5.5H15v3.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5z"
  })]
}));

/**
UiDocumentPptxLined icon

```jsx
import { UiDocumentPptxLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDocumentPptxLined />
```

 */
const UiDocumentPptxLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M7 17H6v1h1c.28 0 .5-.22.5-.5S7.28 17 7 17zm4 0h-1v1h1c.28 0 .5-.22.5-.5s-.22-.5-.5-.5z"
  }), /*#__PURE__*/jsx("path", {
    d: "M20 15V3c0-.55-.45-1-1-1h-8.59c-.27 0-.52.11-.71.29L4.29 7.7a.99.99 0 00-.29.71V21c0 .55.45 1 1 1h15c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm-.08 5.24c.15.23.08.54-.16.69-.08.05-.17.08-.26.08a.47.47 0 01-.42-.24l-.83-1.32-.83 1.32c-.09.15-.26.24-.42.24a.42.42 0 01-.26-.08.504.504 0 01-.16-.69l1.08-1.74-1.08-1.74a.495.495 0 01.16-.69c.23-.15.54-.08.69.16l.83 1.32.83-1.32c.15-.24.46-.3.69-.16.23.15.31.46.16.69l-1.08 1.74 1.06 1.74zM9 16.5c0-.28.22-.5.5-.5H11c.83 0 1.5.67 1.5 1.5S11.83 19 11 19h-1v1.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-4zm5 .5h-.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h2c.28 0 .5.22.5.5s-.22.5-.5.5H15v3.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5V17zm-9-.5c0-.28.22-.5.5-.5H7c.83 0 1.5.67 1.5 1.5S7.83 19 7 19H6v1.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-4zM18 15H6v-5h5c.55 0 1-.45 1-1V4h6v11zM10 4.83V8H6.83L10 4.83z"
  })]
}));

/**
UiDocumentXlsFilled icon

```jsx
import { UiDocumentXlsFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDocumentXlsFilled />
```

 */
const UiDocumentXlsFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9 7V3L5 7h4z"
  }), /*#__PURE__*/jsx("path", {
    d: "M20 15V3c0-.55-.45-1-1-1h-8v6c0 .55-.45 1-1 1H4v12c0 .55.45 1 1 1h15c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm-1.75 6c-.8 0-1.25-.31-1.3-.35a.507.507 0 01-.11-.7c.17-.22.48-.27.7-.11 0 0 .24.15.7.15.42 0 .75-.27.75-.5 0-.28-.22-.5-.5-.5H18c-.83 0-1.5-.67-1.5-1.5 0-.88.92-1.5 1.75-1.5.73 0 1.22.29 1.27.33.23.15.3.46.15.69-.15.23-.46.3-.69.16-.01 0-.3-.17-.74-.17-.39 0-.75.28-.75.5 0 .28.22.5.5.5h.5c.83 0 1.5.67 1.5 1.5s-.78 1.5-1.74 1.5zM13 20.5v-4c0-.28.22-.5.5-.5s.5.22.5.5V20h1.5c.28 0 .5.22.5.5s-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5zm-3.76.42a.504.504 0 01-.16-.69l1.08-1.74-1.08-1.74a.495.495 0 01.16-.69c.23-.15.54-.08.69.16l.83 1.32.83-1.32c.15-.24.46-.31.69-.16.23.15.31.46.16.69l-1.08 1.74 1.08 1.74c.15.23.08.54-.16.69-.08.05-.17.08-.26.08a.47.47 0 01-.42-.24l-.83-1.32-.83 1.32c-.09.15-.26.24-.42.24a.44.44 0 01-.28-.08z"
  })]
}));

/**
UiDocumentXlsLined icon

```jsx
import { UiDocumentXlsLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDocumentXlsLined />
```

 */
const UiDocumentXlsLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 15V3c0-.55-.45-1-1-1h-8.59c-.27 0-.52.11-.71.29L4.29 7.7a.99.99 0 00-.29.71V21c0 .55.45 1 1 1h15c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm-4 5.5c0 .28-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5v-4c0-.28.22-.5.5-.5s.5.22.5.5V20h1.5c.28 0 .5.22.5.5zm.85-.55c.16-.22.48-.27.7-.11 0 0 .24.15.7.15.42 0 .75-.27.75-.5 0-.28-.22-.5-.5-.5H18c-.83 0-1.5-.67-1.5-1.5 0-.88.92-1.5 1.75-1.5.73 0 1.22.29 1.27.33.23.15.3.46.15.69-.15.23-.46.3-.69.16-.01 0-.3-.17-.74-.17-.39 0-.75.28-.75.5 0 .28.22.5.5.5h.5c.83 0 1.5.67 1.5 1.5S19.2 21 18.24 21c-.8 0-1.25-.31-1.3-.35a.503.503 0 01-.09-.7zm-7.77.29l1.08-1.74-1.08-1.74a.495.495 0 01.16-.69c.23-.15.54-.08.69.16l.83 1.32.83-1.32c.15-.24.46-.31.69-.16.23.15.31.46.16.69l-1.08 1.74 1.08 1.74c.15.23.08.54-.16.69-.08.05-.17.08-.26.08a.47.47 0 01-.42-.24l-.83-1.32-.83 1.32c-.09.15-.26.24-.42.24a.42.42 0 01-.26-.08.485.485 0 01-.18-.69zM10 4.83V8H6.83L10 4.83zM6 10h5c.55 0 1-.45 1-1V4h6v11H9c-.55 0-1 .45-1 1v4H6V10z"
  })
}));

/**
UiDocumentXlsxFilled icon

```jsx
import { UiDocumentXlsxFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDocumentXlsxFilled />
```

 */
const UiDocumentXlsxFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9 7V3L5 7h4z"
  }), /*#__PURE__*/jsx("path", {
    d: "M20 15V3c0-.55-.45-1-1-1h-8v6c0 .55-.45 1-1 1H4v12c0 .55.45 1 1 1h15c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm-.08 5.24c.15.23.08.54-.16.69-.08.05-.17.08-.26.08a.47.47 0 01-.42-.24l-.83-1.32-.83 1.32c-.09.15-.26.24-.42.24a.42.42 0 01-.26-.08.504.504 0 01-.16-.69l1.08-1.74-1.08-1.74a.495.495 0 01.16-.69c.23-.15.54-.08.69.16l.83 1.32.83-1.32c.15-.24.46-.31.69-.16.23.15.31.46.16.69l-1.08 1.74 1.06 1.74zm-12.34.52l-.83-1.32-.83 1.32c-.09.15-.26.24-.42.24a.42.42 0 01-.26-.08.504.504 0 01-.16-.69l1.08-1.74-1.08-1.74a.495.495 0 01.16-.69c.23-.15.54-.08.69.16l.83 1.32.83-1.32c.15-.24.46-.31.69-.16.23.15.31.46.16.69l-1.08 1.74 1.08 1.74c.15.23.08.54-.16.69-.08.05-.17.08-.26.08a.48.48 0 01-.44-.24zM9 20.5v-4c0-.28.22-.5.5-.5s.5.22.5.5V20h1.5c.28 0 .5.22.5.5s-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5zm3.95.15a.507.507 0 01-.11-.7c.16-.22.48-.27.7-.11 0 0 .24.15.7.15.42 0 .75-.27.75-.5 0-.28-.22-.5-.5-.5H14c-.83 0-1.5-.67-1.5-1.5 0-.88.92-1.5 1.75-1.5.73 0 1.22.29 1.27.33.23.15.3.46.15.69-.15.23-.46.3-.69.16-.01 0-.3-.17-.74-.17-.39 0-.75.28-.75.5 0 .28.22.5.5.5h.5c.83 0 1.5.67 1.5 1.5S15.2 21 14.24 21c-.79 0-1.24-.31-1.29-.35z"
  })]
}));

/**
UiDocumentXlsxLined icon

```jsx
import { UiDocumentXlsxLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDocumentXlsxLined />
```

 */
const UiDocumentXlsxLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 15V3c0-.55-.45-1-1-1h-8.59c-.27 0-.52.11-.71.29L4.29 7.7a.99.99 0 00-.29.71V21c0 .55.45 1 1 1h15c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zm-.08 5.24c.15.23.08.54-.16.69-.08.05-.17.08-.26.08a.47.47 0 01-.42-.24l-.83-1.32-.83 1.32c-.09.15-.26.24-.42.24a.42.42 0 01-.26-.08.504.504 0 01-.16-.69l1.08-1.74-1.08-1.74a.495.495 0 01.16-.69c.23-.15.54-.08.69.16l.83 1.32.83-1.32c.15-.24.46-.31.69-.16.23.15.31.46.16.69l-1.08 1.74 1.06 1.74zM12 20.5c0 .28-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5v-4c0-.28.22-.5.5-.5s.5.22.5.5V20h1.5c.28 0 .5.22.5.5zm.85-.55c.16-.22.48-.27.7-.11 0 0 .24.15.7.15.42 0 .75-.27.75-.5 0-.28-.22-.5-.5-.5H14c-.83 0-1.5-.67-1.5-1.5 0-.88.92-1.5 1.75-1.5.73 0 1.22.29 1.27.33.23.15.3.46.15.69a.51.51 0 01-.69.16c-.01 0-.3-.17-.74-.17-.39 0-.75.28-.75.5 0 .28.22.5.5.5h.5c.83 0 1.5.67 1.5 1.5S15.2 21 14.24 21c-.8 0-1.25-.31-1.3-.35a.503.503 0 01-.09-.7zm-7.77-3.19a.495.495 0 01.16-.69c.23-.15.54-.08.69.16l.83 1.32.83-1.32c.15-.24.46-.31.69-.16.23.15.31.46.16.69L7.36 18.5l1.08 1.74c.15.23.08.54-.16.69-.08.05-.17.08-.26.08a.47.47 0 01-.42-.24l-.83-1.32-.83 1.32c-.09.15-.26.24-.42.24a.42.42 0 01-.26-.08.504.504 0 01-.16-.69l1.08-1.74-1.1-1.74zM18 15H6v-5h5c.55 0 1-.45 1-1V4h6v11zM10 4.83V8H6.83L10 4.83z"
  })
}));

/**
UiDownloadLined icon

```jsx
import { UiDownloadLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDownloadLined />
```

 */
const UiDownloadLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11.6 15.9c-.1 0-.2-.1-.3-.2l-4-4c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l2.3 2.3V3c0-.6.4-1 1-1s1 .4 1 1v9.6l2.3-2.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-4 4c-.05.05-.1.075-.15.1-.05.025-.1.05-.15.1-.1.1-.3.1-.4.1-.1 0-.3 0-.4-.1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M19 16c0-.6.4-1 1-1s1 .4 1 1v3c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-3c0-.6.4-1 1-1s1 .4 1 1v3h14v-3z"
  })]
}));

/**
UiDownloadLinedSmall icon

```jsx
import { UiDownloadLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDownloadLinedSmall />
```

 */
const UiDownloadLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M7.6 10.9c-.1 0-.2-.1-.3-.2l-3-3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0L7 7.75V1c0-.6.4-1 1-1s1 .4 1 1v6.75l1.3-1.45c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-3 3c-.05.05-.1.075-.15.1-.05.025-.1.05-.15.1-.1.1-.3.1-.4.1-.1 0-.3 0-.4-.1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M13 11c0-.6.4-1 1-1s1 .4 1 1v3c0 .6-.4 1-1 1H2c-.6 0-1-.4-1-1v-3c0-.6.4-1 1-1s1 .4 1 1v2h10v-2z"
  })]
}));

/**
UiDraggableColumnLined icon

```jsx
import { UiDraggableColumnLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDraggableColumnLined />
```

 */
const UiDraggableColumnLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22 15H2c-.55 0-1-.45-1-1s.45-1 1-1h20c.55 0 1 .45 1 1s-.45 1-1 1zm0-4H2c-.55 0-1-.45-1-1s.45-1 1-1h20c.55 0 1 .45 1 1s-.45 1-1 1z"
  })
}));

/**
UiDraggableColumnLinedSmall icon

```jsx
import { UiDraggableColumnLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDraggableColumnLinedSmall />
```

 */
const UiDraggableColumnLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M0 6a1 1 0 011-1h14a1 1 0 110 2H1a1 1 0 01-1-1zm0 4a1 1 0 011-1h14a1 1 0 110 2H1a1 1 0 01-1-1z"
  })
}));

/**
UiDraggableCornerLined icon

```jsx
import { UiDraggableCornerLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDraggableCornerLined />
```

 */
const UiDraggableCornerLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M18.7 4.3c-.4-.4-1-.4-1.4 0l-13 13c-.4.4-.4 1 0 1.4.2.2.5.3.7.3.2 0 .5-.1.7-.3l13-13c.4-.4.4-1 0-1.4zm1 7c-.4-.4-1-.4-1.4 0l-7 7c-.4.4-.4 1 0 1.4.2.2.5.3.7.3.2 0 .5-.1.7-.3l7-7c.4-.4.4-1 0-1.4z"
  })
}));

/**
UiDraggableCornerLinedSmall icon

```jsx
import { UiDraggableCornerLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDraggableCornerLinedSmall />
```

 */
const UiDraggableCornerLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M13.7 2.3c-.4-.4-1-.4-1.4 0l-10 10c-.4.4-.4 1 0 1.4.2.2.5.3.7.3.2 0 .5-.1.7-.3l10-10c.4-.4.4-1 0-1.4zm-1.4 7l-3 3c-.4.4-.4 1 0 1.4.2.2.5.3.7.3.2 0 .5-.1.7-.3l3-3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0z"
  })
}));

/**
UiDraggableGridLined icon

```jsx
import { UiDraggableGridLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDraggableGridLined />
```

 */
const UiDraggableGridLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M16 4h-2c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1zm0 12h-2c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-2c0-.6-.4-1-1-1zm0-6h-2c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-2c0-.6-.4-1-1-1zm-6 0H8c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-2c0-.6-.4-1-1-1zm0 6H8c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-2c0-.6-.4-1-1-1zm0-12H8c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1z"
  })
}));

/**
UiDraggableGridLinedSmall icon

```jsx
import { UiDraggableGridLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDraggableGridLinedSmall />
```

 */
const UiDraggableGridLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M6 2H5c-.6 0-1 .4-1 1v1c0 .6.4 1 1 1h1c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1zm0 4.5H5c-.6 0-1 .4-1 1v1c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-1c0-.6-.4-1-1-1zM6 11H5c-.6 0-1 .4-1 1v1c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-1c0-.6-.4-1-1-1zm4.5-9h-1c-.6 0-1 .4-1 1v1c0 .6.4 1 1 1h1c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1zm0 4.5h-1c-.6 0-1 .4-1 1v1c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-1c0-.6-.4-1-1-1zm0 4.5h-1c-.6 0-1 .4-1 1v1c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-1c0-.6-.4-1-1-1z"
  })
}));

/**
UiDrivetrainFilled icon

```jsx
import { UiDrivetrainFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDrivetrainFilled />
```

 */
const UiDrivetrainFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M18 7h2a1 1 0 001-1V2a1 1 0 00-1-1h-2a1 1 0 00-1 1v1H7V2a1 1 0 00-1-1H4a1 1 0 00-1 1v4a1 1 0 001 1h2a1 1 0 001-1V5h1v3a1 1 0 001 1h.18A3 3 0 0011 12.82v4.36A3 3 0 009.18 19H7v-1a1 1 0 00-1-1H4a1 1 0 00-1 1v4a1 1 0 001 1h2a1 1 0 001-1v-1h2.18a3 3 0 005.64 0H17v1a1 1 0 001 1h2a1 1 0 001-1v-4a1 1 0 00-1-1h-2a1 1 0 00-1 1v1h-2.18A3 3 0 0013 17.18v-4.36A3 3 0 0014.82 9H15a1 1 0 001-1V5h1v1a1 1 0 001 1z"
  })
}));

/**
UiDrivetrainLined icon

```jsx
import { UiDrivetrainLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiDrivetrainLined />
```

 */
const UiDrivetrainLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M18 7h2a1 1 0 001-1V2a1 1 0 00-1-1h-2a1 1 0 00-1 1v1H7V2a1 1 0 00-1-1H4a1 1 0 00-1 1v4a1 1 0 001 1h2a1 1 0 001-1V5h1v3a1 1 0 001 1h.18A3 3 0 0011 12.82v4.36A3 3 0 009.18 19H7v-1a1 1 0 00-1-1H4a1 1 0 00-1 1v4a1 1 0 001 1h2a1 1 0 001-1v-1h2.18a3 3 0 005.64 0H17v1a1 1 0 001 1h2a1 1 0 001-1v-4a1 1 0 00-1-1h-2a1 1 0 00-1 1v1h-2.18A3 3 0 0013 17.18v-4.36A3 3 0 0014.82 9H15a1 1 0 001-1V5h1v1a1 1 0 001 1zm-6 14a1 1 0 110-2 1 1 0 010 2zm0-10a1 1 0 110-2 1 1 0 010 2zm2-4h-4V5h4v2z"
  })
}));

/**
UiEditFilled icon

```jsx
import { UiEditFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiEditFilled />
```

 */
const UiEditFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20.2 3.824c.5.599.8 1.298.8 1.997 0 .7-.3 1.398-.8 1.897l-1 .999-3.9-3.895 1-.998c1.1-1.099 2.8-1.099 3.9 0zM3.3 16.806L13.8 6.32l3.9 3.894L7.2 20.7c-.2.2-.4.3-.7.3H4c-.6 0-1-.4-1-.999v-2.496c0-.2.1-.5.3-.7z"
  })
}));

/**
UiEditFilledSmall icon

```jsx
import { UiEditFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiEditFilledSmall />
```

 */
const UiEditFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M15.32 4.107l-.807.806-3.426-3.426.806-.807c.907-.907 2.52-.907 3.427 0s.907 2.52 0 3.427zM.302 12.27l9.374-9.372 3.426 3.527-9.373 9.273c-.201.201-.403.302-.705.302H.504C.202 16 0 15.798 0 15.496v-2.52c0-.201.1-.504.302-.705z"
  })
}));

/**
UiEditLined icon

```jsx
import { UiEditLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiEditLined />
```

 */
const UiEditLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 4c-1.4-1.4-3.6-1.4-4.9 0L3.3 15.8c-.2.2-.3.4-.3.7V20c0 .6.4 1 1 1h3.5c.3 0 .5-.1.7-.3L20 8.9c.7-.7 1-1.5 1-2.5 0-.9-.4-1.7-1-2.4zM7.1 19H5v-2.1l9.3-9.2 2.1 2.1L7.1 19zM18.5 7.5l-.8.8-2.1-2.1.8-.8c.6-.6 1.5-.6 2.1 0 .3.3.4.6.4 1 .1.5-.1.8-.4 1.1z"
  })
}));

/**
UiEditLinedSmall icon

```jsx
import { UiEditLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiEditLinedSmall />
```

 */
const UiEditLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M15.1.9c-1.2-1.2-3.2-1.2-4.4 0L8.8 2.8.3 11.3c-.2.1-.3.4-.3.7v3.5c0 .2.2.5.5.5H4c.3 0 .5-.1.7-.3L15.1 5.3c.6-.6.9-1.4.9-2.2 0-.8-.3-1.6-.9-2.2zM3.6 14H2v-1.6l7.5-7.5 1.6 1.6L3.6 14zM13.7 3.9l-1.2 1.2-1.6-1.6 1.2-1.2c.4-.4 1.2-.4 1.6 0 .2.2.3.5.3.8 0 .3-.1.6-.3.8z"
  })
}));

/**
UiEmployerLined icon

```jsx
import { UiEmployerLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiEmployerLined />
```

 */
const UiEmployerLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M18 11h-2v2h2v-2zm-2 4h2v2h-2v-2z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 7h-8V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v16h20V9c0-1.1-.9-2-2-2zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zM8 7V5h2v2H8zm4 12v-2h2v-2h-2v-2h2v-2h-2V9h8v10h-8z"
  })]
}));

/**
UiEmployerLinedSmall icon

```jsx
import { UiEmployerLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiEmployerLinedSmall />
```

 */
const UiEmployerLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M13 5h-2V3c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12h14V7c0-1.1-.9-2-2-2zM7 3h2v2H7V3zm0 4h2v2H7V7zm-2 6H3v-2h2v2zm0-4H3V7h2v2zm0-4H3V3h2v2zm2 8v-2h2v2H7zm6 0h-2V7h2v6z"
  })
}));

/**
UiEmpty icon

```jsx
import { UiEmpty } from '@cof/omni-gravity-icons-react'

const Example = () => <UiEmpty />
```

 */
const UiEmpty = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props));

/**
UiEmptySmall icon

```jsx
import { UiEmptySmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiEmptySmall />
```

 */
const UiEmptySmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props));

/**
UiEngineFilled icon

```jsx
import { UiEngineFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiEngineFilled />
```

 */
const UiEngineFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M21 9h-1a1 1 0 00-1 1h-1V9a1 1 0 00-.11-.45l-1-2A1 1 0 0016 6h-3V5h1a1 1 0 100-2h-4a1 1 0 000 2h1v1H8a1 1 0 00-.89.55L6.38 8H5a1 1 0 00-1 1v3H3v-1a1 1 0 10-2 0v4a1 1 0 102 0v-1h1v2a1 1 0 001 1h2.25l.51 1.73a.77.77 0 00.07.16A2 2 0 009.62 20H17a1 1 0 001-1v-1h1a1 1 0 001 1h1a2 2 0 002-2v-6a2 2 0 00-2-2z"
  })
}));

/**
UiEngineLined icon

```jsx
import { UiEngineLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiEngineLined />
```

 */
const UiEngineLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M21 9h-2a1 1 0 00-1 1V9a1 1 0 00-.11-.45l-1-2A1 1 0 0016 6h-3V5h1a1 1 0 100-2h-4a1 1 0 000 2h1v1H8a1 1 0 00-.89.55L6.38 8H5a1 1 0 00-1 1v3H3v-1a1 1 0 10-2 0v4a1 1 0 102 0v-1h1v2a1 1 0 001 1h2.25l.51 1.73a.77.77 0 00.07.16A2 2 0 009.62 20H17a1 1 0 001-1v-1a1 1 0 001 1h2a2 2 0 002-2v-6a2 2 0 00-2-2zm0 8h-1a1 1 0 00-1-1h-2a1 1 0 00-1 1v1H9.63L9 15.72A1 1 0 008 15H6v-5h1a1 1 0 00.89-.55L8.62 8h6.76L16 9.24V11a1 1 0 001 1h2a1 1 0 001-1h1v6z"
  })
}));

/**
UiEnoFilled icon

```jsx
import { UiEnoFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiEnoFilled />
```

 */
const UiEnoFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 11.9c.1-4.3-1.2-6.6-2.7-8.1C16.7 2.2 13.8 2 12.6 2h-1.2c-1.2 0-4 .2-5.7 1.8C4.2 5.3 2.9 7.6 3 11.9c0 0-.2 2.8.9 5.5.1.2.1.4.1.6l-.9 2.7s-.2 1 .8 1H4l2.3-.7h.3c.1-.1.3 0 .4 0 1.1.7 2.5 1 4.6 1h.5c9.5 0 8.9-10.1 8.9-10.1zM15.8 16c0 .1-1.3 2-3.8 2s-3.8-1.9-3.8-2c-.3-.4-.2-1 .2-1.3.5-.3 1.1-.2 1.4.3.1 0 .8 1 2.2 1 1.4 0 2.1-1 2.2-1.1.3-.5.9-.6 1.4-.3.4.4.5 1 .2 1.4z"
  })
}));

/**
UiEnoFilledSmall icon

```jsx
import { UiEnoFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiEnoFilledSmall />
```

 */
const UiEnoFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-eno-filled-small-a)",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.2 8c.1-2.6-.7-4.7-2.2-6.2-.6-.6-1.5-1.1-2.7-1.4-1.5-.4-3-.4-4.4 0-1.1.3-2 .8-2.7 1.4C1.7 3.2 1 5.3 1 8c0 .1 0 2.1.6 3.7l-.5 1.8c-.1.3-.3 1.1.2 1.7.2.2.8.6 1.7.2l1.5-.6.2.2c.8.5 1.7 1 3.2 1h.2c2 0 3.7-.6 5-1.9 2.1-2.3 2.1-5.7 2.1-6.1zm-3.9 3.6c-.1.1-1 1.4-3.3 1.4s-3.2-1.3-3.3-1.4c-.3-.5-.2-1.1.2-1.4.5-.3 1.1-.2 1.4.2 0 0 .5.6 1.7.6s1.7-.6 1.7-.6c.3-.4 1-.5 1.4-.2.4.3.5.9.2 1.4z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-eno-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiEnoLined icon

```jsx
import { UiEnoLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiEnoLined />
```

 */
const UiEnoLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12 16c1.4 0 2.2-1.1 2.2-1.1.3-.4.9-.5 1.3-.2.5.3.6.9.3 1.4 0 0-1.3 1.9-3.8 1.9s-3.8-1.9-3.8-2c-.3-.4-.2-1 .2-1.4.5-.3 1.1-.2 1.4.3l.045.051c.194.23.888 1.049 2.155 1.049z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3 3.8c1.5 1.5 2.8 3.8 2.7 8.1 0 0 .6 10.1-8.9 10.1h-.5c-2.1 0-3.5-.3-4.6-1-.03 0-.07-.01-.113-.02-.099-.022-.217-.05-.287.02h-.3l-2.3.7h-.1c-1 0-.8-1-.8-1L4 18c0-.2 0-.4-.1-.6-1.1-2.7-.9-5.5-.9-5.5-.1-4.3 1.2-6.6 2.7-8.1C7.4 2.2 10.2 2 11.4 2h1.2c1.2 0 4.1.2 5.7 1.8zM12.1 20c2.1 0 3.7-.6 4.9-1.8 2.032-2.225 2.004-5.667 2-6.16v-.24c.1-3.9-1.1-5.6-2.1-6.6C16 4.3 14.1 4 12.6 4h-1.2C9.9 4 8 4.3 7.1 5.3 5.6 6.7 4.9 8.9 5 11.9v.162c-.009.427-.05 2.57.7 4.538.3.6.3 1.4.1 2l-.1.4c.3-.1.5-.1.8-.1.5 0 1 .1 1.5.4.8.5 1.9.7 3.6.7h.5z"
  })]
}));

/**
UiEnoLinedSmall icon

```jsx
import { UiEnoLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiEnoLinedSmall />
```

 */
const UiEnoLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M8 10c.7 0 1.2-.6 1.2-.6.3-.4 1-.5 1.4-.2.4.3.5 1 .2 1.4a1.177 1.177 0 00-.04.044C10.54 10.894 9.569 12 8 12c-1.4 0-2.4-.9-2.8-1.4-.3-.4-.2-1.1.2-1.4.5-.3 1.1-.2 1.4.2 0 0 .5.6 1.2.6z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 1.8c1.5 1.5 2.3 3.6 2.2 6.2 0 .4 0 3.8-2.1 6-1.3 1.2-3 1.9-5 1.9h-.2c-1.5 0-2.4-.5-3.2-1l-.2-.1-1.5.6c-.9.4-1.5 0-1.7-.2-.5-.6-.3-1.4-.2-1.7l.5-1.8C1 10.1 1 8.1 1 8c0-2.7.7-4.8 2.1-6.3C3.8 1.1 4.7.6 5.8.3 6.5.1 7.3 0 8.1 0c.7 0 1.4.1 2.2.4 1.2.3 2.1.8 2.7 1.4zm-1.4 10.9c1.6-1.6 1.6-4.2 1.6-4.7 0-2.1-.5-3.7-1.6-4.9-.4-.4-1-.7-1.8-.9-1.1-.3-2.3-.3-3.4 0-.8.2-1.4.5-1.8.9C3.5 4.2 3 5.8 3 7.9c0 .1.1 1.9.6 3.2.1.4.1.7 0 1.1l-.3 1 .8-.3c.1-.1.3-.1.5-.1.3 0 .6.1.8.2l.4.3c.7.4 1.3.7 2.3.7 1.5 0 2.7-.4 3.5-1.3z"
  })]
}));

/**
UiEnvelopeFilled icon

```jsx
import { UiEnvelopeFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiEnvelopeFilled />
```

 */
const UiEnvelopeFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12.6 14.8c-.2.2-.4.2-.6.2-.2 0-.4-.1-.6-.2L1.1 6.4c-.1.2-.1.4-.1.6v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-.2 0-.4-.1-.6l-10.3 8.4z"
  }), /*#__PURE__*/jsx("path", {
    d: "M12 12.7L21.4 5H2.6l9.4 7.7z"
  })]
}));

/**
UiEnvelopeFilledSmall icon

```jsx
import { UiEnvelopeFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiEnvelopeFilledSmall />
```

 */
const UiEnvelopeFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M14.3 3H1.7L8 7.8 14.3 3z"
  }), /*#__PURE__*/jsx("path", {
    d: "M8.6 9.8c-.2.1-.4.2-.6.2-.2 0-.4-.1-.6-.2L0 4.2V12c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V4.2L8.6 9.8z"
  })]
}));

/**
UiEnvelopeLined icon

```jsx
import { UiEnvelopeLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiEnvelopeLined />
```

 */
const UiEnvelopeLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-1.6 2L12 12.8 4.6 7.1 19.4 7zM3 17V8.2l8.4 6.5c.2.1.4.2.6.2.2 0 .4-.1.6-.2L21 8.2v8.7L3 17z"
  })
}));

/**
UiEnvelopeLinedSmall icon

```jsx
import { UiEnvelopeLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiEnvelopeLinedSmall />
```

 */
const UiEnvelopeLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M15 3H1c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V4c0-.6-.4-1-1-1zm-2.8 2L8 7.8 3.8 5h8.4zM2 11V6.2l5.4 3.6c.2.1.4.2.6.2.2 0 .4-.1.6-.2L14 6.2V11H2z"
  })
}));

/**
UiEqualLined icon

```jsx
import { UiEqualLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiEqualLined />
```

 */
const UiEqualLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M21 10H3c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1zm0 6H3c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1z"
  })
}));

/**
UiEqualLinedSmall icon

```jsx
import { UiEqualLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiEqualLinedSmall />
```

 */
const UiEqualLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M0 6a1 1 0 011-1h14a1 1 0 110 2H1a1 1 0 01-1-1zm0 4a1 1 0 011-1h14a1 1 0 110 2H1a1 1 0 01-1-1z"
  })
}));

/**
UiExpandLined icon

```jsx
import { UiExpandLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiExpandLined />
```

 */
const UiExpandLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M4 3a1 1 0 00-1 1v4a1 1 0 002 0V6.141L8.52 9.93c.01.02.03.04.05.05.4.38 1.03.35 1.41-.05.38-.4.35-1.03-.05-1.41L6.141 5H8a1 1 0 000-2H4zm12 0a1 1 0 100 2h1.859L14.07 8.52a.1.1 0 00-.032.03c-.005.006-.01.013-.018.02-.38.4-.35 1.03.05 1.41.4.38 1.03.35 1.41-.05L19 6.141V8a1 1 0 102 0V4a1 1 0 00-1-1h-4zm4 12a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 110-2h1.858l-3.788-3.52a.997.997 0 01-.05-1.41.997.997 0 011.43-.031c.013.01.024.018.03.031L19 17.86V16a1 1 0 011-1zM5 16a1 1 0 10-2 0v4a1 1 0 001 1h4a1 1 0 100-2H6.141l3.789-3.52c.013-.006.022-.017.032-.029a.997.997 0 00-.032-1.43.997.997 0 00-1.41.05L5 17.858V16z"
  })
}));

/**
UiExpandLinedSmall icon

```jsx
import { UiExpandLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiExpandLinedSmall />
```

 */
const UiExpandLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M11 1a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 11-2 0v-.855L11.48 5.92A.997.997 0 1110 4.58l.07-.07L12.843 2H12a1 1 0 01-1-1zM2 12a1 1 0 10-2 0v3a1 1 0 001 1h3a1 1 0 100-2h-.865l2.785-2.52.07-.07a.997.997 0 10-1.48-1.34L2 12.834V12zm14 0a1 1 0 10-2 0v.854l-2.52-2.784-.07-.07a.997.997 0 10-1.34 1.48L12.845 14H12a1 1 0 100 2h3a1 1 0 001-1v-3zM1 0a1 1 0 00-1 1v3a1 1 0 002 0v-.842L4.5 5.92a.402.402 0 00.021.02c.017.014.035.03.049.05.41.37 1.05.34 1.42-.07a.997.997 0 00-.07-1.41L3.156 2H4a1 1 0 000-2H1z"
  })
}));

/**
UiExperimentLined icon

```jsx
import { UiExperimentLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiExperimentLined />
```

 */
const UiExperimentLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 14.5c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5S10.6 12 12 12s2.5 1.1 2.5 2.5zm-1 0c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5.7 1.5 1.5 1.5 1.5-.7 1.5-1.5z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 9.7l5.2 7.3c.6.8.7 1.9.3 2.8-.4.9-1.2 1.6-2.2 1.8l-.8.2c-.9.2-1.9.3-2.9.3H8.4c-.9 0-1.9-.1-2.9-.3l-.8-.2c-1-.2-1.8-.9-2.2-1.8-.4-.9-.3-2 .2-2.8L8 9.7V3c0-.6.4-1 1-1h6c.6 0 1 .4 1 1v6.7zm-6 .3c0 .2-.1.4-.2.6L4.5 18h15l-5.3-7.4c-.1-.2-.2-.4-.2-.6V4h-4v6z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 6.5C22 7.9 20.9 9 19.5 9S17 7.9 17 6.5 18.1 4 19.5 4 22 5.1 22 6.5zm-1 0c0-.8-.7-1.5-1.5-1.5S18 5.7 18 6.5 18.7 8 19.5 8 21 7.3 21 6.5zM4.5 11C5.9 11 7 9.9 7 8.5S5.9 6 4.5 6 2 7.1 2 8.5 3.1 11 4.5 11zm0-4C5.3 7 6 7.7 6 8.5S5.3 10 4.5 10 3 9.3 3 8.5 3.7 7 4.5 7z"
  })]
}));

/**
UiExperimentLinedSmall icon

```jsx
import { UiExperimentLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiExperimentLinedSmall />
```

 */
const UiExperimentLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsxs("g", {
    clipPath: "url(#omni-gravity-icon-ui-experiment-lined-small-a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    children: [/*#__PURE__*/jsx("path", {
      d: "M8 12c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0-3c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1z"
    }), /*#__PURE__*/jsx("path", {
      d: "M11 1v4.6l4.1 5.1c.7.8 1 1.9.7 2.9-.3 1-1.1 1.8-2.2 2-1 .2-2.1.3-3.1.3H5.4c-1.1 0-2.1-.1-3.1-.3-1-.2-1.9-1-2.2-2-.3-1 0-2.1.7-2.9L5 5.6V1c0-.6.4-1 1-1h4c.6 0 1 .4 1 1zM6.8 6.6l-4.5 5.5c-.3.4-.3.7-.3.9h12c0-.2 0-.5-.3-.9-.1 0-.1-.1-.1-.1L9.2 6.6C9.1 6.5 9 6.2 9 6V2H7v4c0 .2-.1.5-.2.6z"
    }), /*#__PURE__*/jsx("path", {
      d: "M4 5c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zM3 5c0-.6-.4-1-1-1s-1 .4-1 1 .4 1 1 1 1-.4 1-1zm13-2c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-1 0c0-.6-.4-1-1-1s-1 .4-1 1 .4 1 1 1 1-.4 1-1z"
    })]
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-experiment-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiExternalLined icon

```jsx
import { UiExternalLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiExternalLined />
```

 */
const UiExternalLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M16 3h4c.5 0 1 .4 1 1v4c0 .6-.4 1-1 1s-1-.4-1-1V6.1l-6.3 6.6c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4L17.9 5H16c-.6 0-1-.4-1-1s.4-1 1-1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M18 13c0-.6.4-1 1-1s1 .4 1 1v6c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h6c.6 0 1 .4 1 1s-.4 1-1 1H5v13h13v-6z"
  })]
}));

/**
UiExternalLinedSmall icon

```jsx
import { UiExternalLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiExternalLinedSmall />
```

 */
const UiExternalLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11 1h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1s-1-.45-1-1v-.97L9.72 7.7c-.37.41-1.01.44-1.42.07-.41-.37-.44-1-.07-1.41.01-.02.03-.04.05-.06L11.74 3H11c-.55 0-1-.45-1-1s.45-1 1-1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M12 9.47c0-.55.45-1 1-1s1 .45 1 1V13c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1s-.45 1-1 1H4v8h8V9.47z"
  })]
}));

/**
UiFaceIdLined icon

```jsx
import { UiFaceIdLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFaceIdLined />
```

 */
const UiFaceIdLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M1 6c0 .55.45 1 1 1s1-.45 1-1V3.99c0-.55.44-.99.99-.99H6c.55 0 1-.45 1-1s-.45-1-1-1H3.99C2.34 1 1 2.34 1 3.99V6zm17 17h2.01c1.65 0 2.99-1.34 2.99-2.99V18c0-.55-.45-1-1-1s-1 .45-1 1v2.01c0 .55-.45.99-.99.99H18c-.55 0-1 .45-1 1s.45 1 1 1zm4-16c-.55 0-1-.45-1-1V3.99c0-.55-.44-.99-.99-.99H18c-.55 0-1-.45-1-1s.45-1 1-1h2.01C21.66 1 23 2.34 23 3.99V6c0 .55-.45 1-1 1zM3.99 23H6c.55 0 1-.45 1-1s-.45-1-1-1H3.99c-.55 0-.99-.44-.99-.99V18c0-.55-.45-1-1-1s-1 .45-1 1v2.01C1 21.66 2.34 23 3.99 23zM7 11c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1zm9-1c0 .55.45 1 1 1s1-.45 1-1V8c0-.55-.45-1-1-1s-1 .45-1 1v2zm-3.5-3c-.55 0-1 .45-1 1v3.01c0 .99-.34.99-.5.99-.55 0-1 .45-1 1s.45 1 1 1c1.21 0 2.5-.78 2.5-2.99V8c0-.55-.45-1-1-1zM8.2 17.1c.11.14 1.13 1.4 3.8 1.4s3.69-1.26 3.79-1.4a.981.981 0 00-.18-1.36c-.41-.34-1.03-.27-1.39.13-.02.03-.58.63-2.22.63-1.6 0-2.17-.57-2.22-.63a.995.995 0 00-1.38-.17c-.44.33-.53.96-.2 1.4z"
  })
}));

/**
UiFaceIdLinedSmall icon

```jsx
import { UiFaceIdLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFaceIdLinedSmall />
```

 */
const UiFaceIdLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M2 5c0 .6-.4 1-1 1s-1-.4-1-1V2.5C0 1.1 1.1 0 2.5 0H5c.6 0 1 .4 1 1s-.4 1-1 1H2.5c-.3 0-.5.2-.5.5V5zm9-5h2.5C14.9 0 16 1.1 16 2.5V5c0 .6-.4 1-1 1s-1-.4-1-1V2.5c0-.3-.2-.5-.5-.5H11c-.6 0-1-.4-1-1s.4-1 1-1zm4 10c-.6 0-1 .4-1 1v2.5c0 .3-.2.5-.5.5H11c-.6 0-1 .4-1 1s.4 1 1 1h2.5c1.4 0 2.5-1.1 2.5-2.5V11c0-.6-.4-1-1-1zM2.5 14H5c.6 0 1 .4 1 1s-.4 1-1 1H2.5C1.1 16 0 14.9 0 13.5V11c0-.6.4-1 1-1s1 .4 1 1v2.5c0 .3.2.5.5.5z"
  }), /*#__PURE__*/jsx("path", {
    d: "M3 5v1c0 .6.4 1 1 1s1-.4 1-1V5c0-.6-.4-1-1-1s-1 .4-1 1zm10 1c0 .6-.4 1-1 1s-1-.4-1-1V5c0-.6.4-1 1-1s1 .4 1 1v1zM7 9c1.1 0 2-.9 2-2V5c0-.6-.4-1-1-1s-1 .4-1 1v2c-.6 0-1 .4-1 1s.4 1 1 1zm1 2c1.5 0 2.3-.7 2.3-.7.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4-.1.1-1.4 1.3-3.7 1.3-2.3 0-3.6-1.2-3.7-1.3-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0 0 0 .8.7 2.3.7z"
  })]
}));

/**
UiFacebookFilled icon

```jsx
import { UiFacebookFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFacebookFilled />
```

 */
const UiFacebookFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M17.96 5.08V2.29c-.71-.11-1.84-.3-3.61-.29C11.99 2.01 10 3.72 10 6.08v3H7v3.5h3v9.5h4v-9.5h3l.5-3.5H14v-3c0-1 1.41-1 3.96-1z"
  })
}));

/**
UiFeatureBlindSpotMonitorFilled icon

```jsx
import { UiFeatureBlindSpotMonitorFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeatureBlindSpotMonitorFilled />
```

 */
const UiFeatureBlindSpotMonitorFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M14.5 10A3.5 3.5 0 0111 6.5a.5.5 0 00-1 0 4.51 4.51 0 004.5 4.5.5.5 0 000-1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M14.5 12A5.51 5.51 0 019 6.5a.5.5 0 10-1 0 6.51 6.51 0 006.5 6.5.5.5 0 000-1zm8.25-10.66A1 1 0 0022 1h-9a1 1 0 00-.99 1.13c0 .11.34 2.54.55 3.51A3 3 0 0015.49 8h4a3 3 0 002.93-2.36c.21-1 .54-3.4.55-3.51a1.001 1.001 0 00-.22-.79zM19.5 4h-4a.5.5 0 010-1h4a.5.5 0 010 1zM14 19h-1.37c-.08-.51-.15-1-.23-1.49l-.15-1a3 3 0 00-3-2.55H5.71a3 3 0 00-3 2.55l-.15.92c-.07.48-.15 1-.23 1.53H1.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h.6c0 .32-.07.63-.1.92a1.05 1.05 0 00.26.76A.999.999 0 003 23h9a1 1 0 00.74-.32 1.05 1.05 0 00.26-.76c0-.29-.06-.6-.1-.92H14a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zm-4.12 1.83a.5.5 0 01-.38.17h-4a.5.5 0 01-.38-.17.49.49 0 01-.11-.4l.15-1a.49.49 0 01.49-.43h3.7a.49.49 0 01.49.43l.15 1a.49.49 0 01-.11.4z"
  })]
}));

/**
UiFeatureBlindSpotMonitorLined icon

```jsx
import { UiFeatureBlindSpotMonitorLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeatureBlindSpotMonitorLined />
```

 */
const UiFeatureBlindSpotMonitorLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M14 19h-1.37c-.08-.51-.15-1-.23-1.49l-.15-1a3 3 0 00-3-2.55H5.71a3 3 0 00-3 2.55l-.15.92c-.07.48-.15 1-.23 1.53H1.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h.6c0 .32-.07.63-.1.92a1.003 1.003 0 102 .16c.1-1.2.36-2.92.58-4.3l.14-.93a1 1 0 011-.85h3.57a1 1 0 011 .85l.15 1c.21 1.37.48 3.07.57 4.26A1 1 0 0012 23h.08a1 1 0 00.92-1.08c0-.29-.06-.6-.1-.92H14a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zm1.65-15h3.7a.49.49 0 00.49-.43l.15-1a.49.49 0 00-.11-.4.5.5 0 00-.38-.17h-4a.5.5 0 00-.38.17.49.49 0 00-.11.4l.15 1a.49.49 0 00.49.43z"
  }), /*#__PURE__*/jsx("path", {
    d: "M9.25 19h-3.5a.51.51 0 00-.5.44l-.25 2a.55.55 0 00.12.39.52.52 0 00.38.17h4a.52.52 0 00.38-.17.55.55 0 00.12-.39l-.25-2a.51.51 0 00-.5-.44zM22.13 1a1 1 0 00-1.13.87s-.33 2.45-.52 3.35a1 1 0 01-1 .78h-4a1 1 0 01-1-.78c-.19-.9-.52-3.33-.52-3.35a1.008 1.008 0 10-2 .26c0 .11.34 2.54.55 3.51A3 3 0 0015.49 8h4a3 3 0 002.93-2.36c.21-1 .54-3.4.55-3.51A1 1 0 0022.13 1zm-7.63 9A3.5 3.5 0 0111 6.5a.5.5 0 00-1 0 4.51 4.51 0 004.5 4.5.5.5 0 000-1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M14.5 12A5.51 5.51 0 019 6.5a.5.5 0 00-1 0 6.51 6.51 0 006.5 6.5.5.5 0 000-1z"
  })]
}));

/**
UiFeatureBluetoothFilled icon

```jsx
import { UiFeatureBluetoothFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeatureBluetoothFilled />
```

 */
const UiFeatureBluetoothFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 9.59L14.59 8 13 6.41v3.18z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C7.27 1 4 3.28 4 12s3.27 11 8 11 8-2.28 8-11-3.26-11-8-11zm4.71 14.29a1.002 1.002 0 010 1.42l-4 4A1 1 0 0112 21a.84.84 0 01-.38-.08A1 1 0 0111 20v-5.59l-2.29 2.3a1.004 1.004 0 11-1.42-1.42l3.3-3.29-3.3-3.29a1.004 1.004 0 111.42-1.42L11 9.59V4a1 1 0 01.62-.92 1 1 0 011.09.21l4 4a1 1 0 010 1.42L13.41 12l3.3 3.29z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 17.59L14.59 16 13 14.41v3.18z"
  })]
}));

/**
UiFeatureBluetoothLined icon

```jsx
import { UiFeatureBluetoothLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeatureBluetoothLined />
```

 */
const UiFeatureBluetoothLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M13.52 12l4.15-3.76a1 1 0 000-1.48l-5-4.5A1 1 0 0011 3v6.72L7.17 6.26a1 1 0 00-1.34 1.48L10.54 12l-4.71 4.26a1 1 0 001.34 1.48L11 14.28V21a1 1 0 001.67.74l5-4.5a1 1 0 000-1.48L13.52 12zM13 5.25l2.51 2.25L13 9.77V5.25zm0 13.5v-4.52l2.51 2.27L13 18.75z"
  })
}));

/**
UiFeatureCooledSeatsFilled icon

```jsx
import { UiFeatureCooledSeatsFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeatureCooledSeatsFilled />
```

 */
const UiFeatureCooledSeatsFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M19 16h-6.8a3 3 0 01-3-2.58L8 4.58A3 3 0 004.58 2 3 3 0 002 5.42l1.26 8.85A9 9 0 0012.2 22H19a3 3 0 000-6zm-3-6a1 1 0 100-2 1 1 0 000 2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M19 11.05a3.13 3.13 0 00-1.11-1.43A2 2 0 0116.37 11c0 .85-.72 1.7-.59 2.49.28 1.61 3.69-.84 3.22-2.44zM14 12a3.13 3.13 0 001.43-1.11A2 2 0 0114 9.37c-.85 0-1.7-.72-2.49-.59-1.61.28.84 3.69 2.49 3.22zm.11-3.62A2 2 0 0115.63 7c0-.85.72-1.7.59-2.49C15.94 2.9 12.53 5.35 13 7a3.13 3.13 0 001.11 1.38zm3.89.25c.85 0 1.7.72 2.49.59 1.65-.28-.8-3.69-2.4-3.22a3.13 3.13 0 00-1.43 1.11A2 2 0 0118 8.63z"
  })]
}));

/**
UiFeatureCooledSeatsLined icon

```jsx
import { UiFeatureCooledSeatsLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeatureCooledSeatsLined />
```

 */
const UiFeatureCooledSeatsLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M19 16h-6.8a3 3 0 01-3-2.58L8 4.58A3 3 0 004.58 2 3 3 0 002 5.42l1.26 8.85A9 9 0 0012.2 22H19a3 3 0 000-6zm0 4h-6.8a7 7 0 01-6.93-6L4 5.14a1 1 0 01.2-.74 1 1 0 01.65-.4H5a1 1 0 011 .86l1.26 8.85A5 5 0 0012.2 18H19a1 1 0 110 2zm-3-10a1 1 0 100-2 1 1 0 000 2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M19 11.05a3.13 3.13 0 00-1.11-1.43A2 2 0 0116.37 11c0 .85-.72 1.7-.59 2.49.28 1.61 3.69-.84 3.22-2.44zM14 12a3.13 3.13 0 001.43-1.11A2 2 0 0114 9.37c-.85 0-1.7-.72-2.49-.59-1.61.28.84 3.69 2.49 3.22zm.11-3.62A2 2 0 0115.63 7c0-.85.72-1.7.59-2.49C15.94 2.9 12.53 5.35 13 7a3.13 3.13 0 001.11 1.38zm3.89.25c.85 0 1.7.72 2.49.59 1.65-.28-.8-3.69-2.4-3.22a3.13 3.13 0 00-1.43 1.11A2 2 0 0118 8.63z"
  })]
}));

/**
UiFeatureGpsFilled icon

```jsx
import { UiFeatureGpsFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeatureGpsFilled />
```

 */
const UiFeatureGpsFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22.71 16.61l-1.47-10a3 3 0 00-3-2.57H5.73a3 3 0 00-3 2.57L1.29 16.63a3 3 0 003 3.37h15.44a3.001 3.001 0 003-3.39h-.02zm-7.39-.73A.49.49 0 0115 16a.57.57 0 01-.28-.08L12 14.1l-2.72 1.82a.51.51 0 01-.74-.62l3-7A.51.51 0 0112 8a.51.51 0 01.46.3l3 7a.49.49 0 01-.14.58z"
  })
}));

/**
UiFeatureGpsLined icon

```jsx
import { UiFeatureGpsLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeatureGpsLined />
```

 */
const UiFeatureGpsLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M22.71 16.61l-1.47-10a3 3 0 00-3-2.57H5.73a3 3 0 00-3 2.57L1.29 16.63a3 3 0 003 3.37h15.44a3.001 3.001 0 003-3.39h-.02zm-2.23 1.05a1 1 0 01-.75.34H4.27a1 1 0 01-.75-.34 1 1 0 01-.25-.76l1.47-10a1 1 0 011-.86h12.53a1 1 0 011 .86l1.47 10a1 1 0 01-.26.76z"
  }), /*#__PURE__*/jsx("path", {
    d: "M12.48 8.3A.51.51 0 0012 8a.51.51 0 00-.46.3l-3 7a.51.51 0 00.74.62L12 14.1l2.72 1.82A.57.57 0 0015 16a.508.508 0 00.46-.7l-2.98-7z"
  })]
}));

/**
UiFeatureHeatedSeatsFilled icon

```jsx
import { UiFeatureHeatedSeatsFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeatureHeatedSeatsFilled />
```

 */
const UiFeatureHeatedSeatsFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M19 16h-6.8a3 3 0 01-3-2.58L8 4.58A3 3 0 004.58 2 3 3 0 002 5.42l1.26 8.85A9 9 0 0012.2 22H19a3 3 0 000-6zm-1.29-6.52a2 2 0 01.2 1.62l-.39 1.25a.51.51 0 00.33.63L18 13a.51.51 0 00.48-.35l.39-1.25a3 3 0 00-.31-2.4l-.27-.43a2 2 0 01-.2-1.62l.39-1.25a.522.522 0 00-1-.3l-.35 1.2a3 3 0 00.31 2.45l.27.43z"
  }), /*#__PURE__*/jsx("path", {
    d: "M14.71 9.48a2 2 0 01.2 1.62l-.39 1.25a.51.51 0 00.33.63L15 13a.51.51 0 00.48-.35l.39-1.25a3 3 0 00-.31-2.4l-.27-.43a2 2 0 01-.2-1.62l.39-1.25a.52.52 0 00-.748-.61.52.52 0 00-.252.31l-.35 1.2a3 3 0 00.31 2.45l.27.43zm-3 0a2 2 0 01.2 1.62l-.39 1.25a.51.51 0 00.33.63L12 13a.51.51 0 00.48-.35l.39-1.25a3 3 0 00-.31-2.4l-.27-.43a2 2 0 01-.2-1.62l.39-1.25a.522.522 0 00-1-.3l-.35 1.2a3 3 0 00.31 2.45l.27.43z"
  })]
}));

/**
UiFeatureHeatedSeatsLined icon

```jsx
import { UiFeatureHeatedSeatsLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeatureHeatedSeatsLined />
```

 */
const UiFeatureHeatedSeatsLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M19 16h-6.8a3 3 0 01-3-2.58L8 4.58A3 3 0 004.58 2 3 3 0 002 5.42l1.26 8.85A9 9 0 0012.2 22H19a3 3 0 000-6zm0 4h-6.8a7 7 0 01-6.93-6L4 5.14a1 1 0 01.2-.74 1 1 0 01.65-.4H5a1 1 0 011 .86l1.26 8.85A5 5 0 0012.2 18H19a1 1 0 110 2zM17.71 9.48a2 2 0 01.2 1.62l-.39 1.25a.51.51 0 00.33.63L18 13a.51.51 0 00.48-.35l.39-1.25a3 3 0 00-.31-2.4l-.27-.43a2 2 0 01-.2-1.62l.39-1.25a.522.522 0 00-1-.3l-.35 1.2a3 3 0 00.31 2.45l.27.43z"
  }), /*#__PURE__*/jsx("path", {
    d: "M14.71 9.48a2 2 0 01.2 1.62l-.39 1.25a.51.51 0 00.33.63L15 13a.51.51 0 00.48-.35l.39-1.25a3 3 0 00-.31-2.4l-.27-.43a2 2 0 01-.2-1.62l.39-1.25a.52.52 0 00-.748-.61.52.52 0 00-.252.31l-.35 1.2a3 3 0 00.31 2.45l.27.43zm-3 0a2 2 0 01.2 1.62l-.39 1.25a.51.51 0 00.33.63L12 13a.51.51 0 00.48-.35l.39-1.25a3 3 0 00-.31-2.4l-.27-.43a2 2 0 01-.2-1.62l.39-1.25a.522.522 0 00-1-.3l-.35 1.2a3 3 0 00.31 2.45l.27.43z"
  })]
}));

/**
UiFeatureLeatherSeatsFilled icon

```jsx
import { UiFeatureLeatherSeatsFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeatureLeatherSeatsFilled />
```

 */
const UiFeatureLeatherSeatsFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M19 16h-6.8a3 3 0 01-3-2.58L8 4.58A3 3 0 004.58 2 3 3 0 002 5.42l1.26 8.85A9 9 0 0012.2 22H19a3 3 0 000-6z"
  }), /*#__PURE__*/jsx("path", {
    d: "M12.51 10a.5.5 0 00-.48.66l.5 1.5a.51.51 0 00.51.34 3.7 3.7 0 013.05 1.28.49.49 0 00.82 0A3.7 3.7 0 0120 12.5a.49.49 0 00.51-.34l.5-1.5a.46.46 0 00-.07-.45.49.49 0 00-.4-.21c-.17 0-1-.08-1-1.5s.83-1.5 1-1.5a.51.51 0 00.41-.2.47.47 0 00.05-.46l-.5-1.5a.49.49 0 00-.5-.34 2.38 2.38 0 01-2-1.28.51.51 0 00-.5-.22h-2a.51.51 0 00-.42.22 2.43 2.43 0 01-2 1.28.49.49 0 00-.52.34L12 6.34a.46.46 0 00.07.45.49.49 0 00.4.21c.17 0 1 .08 1 1.5s-.8 1.5-.96 1.5zm4-4a.5.5 0 11-.01 0h.01zm0 2a.5.5 0 11-.01 0h.01zm0 2a.5.5 0 11-.01 0h.01z"
  })]
}));

/**
UiFeatureLeatherSeatsLined icon

```jsx
import { UiFeatureLeatherSeatsLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeatureLeatherSeatsLined />
```

 */
const UiFeatureLeatherSeatsLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 16h-6.8a3 3 0 01-3-2.58L8 4.58A3 3 0 004.58 2 3 3 0 002 5.42l1.26 8.85A9 9 0 0012.2 22H19a3 3 0 000-6zm0 4h-6.8a7 7 0 01-6.93-6L4 5.14a1 1 0 01.2-.74 1 1 0 01.65-.4H5a1 1 0 011 .86l1.26 8.85A5 5 0 0012.2 18H19a1 1 0 110 2z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.51 10a.51.51 0 00-.506.42.47.47 0 00.026.24l.5 1.5a.5.5 0 00.51.34 3.71 3.71 0 013.05 1.28.49.49 0 00.82 0A3.7 3.7 0 0120 12.5a.49.49 0 00.51-.34l.5-1.5a.46.46 0 00-.07-.45.49.49 0 00-.4-.21c-.17 0-1-.08-1-1.5s.83-1.5 1-1.5a.48.48 0 00.495-.423A.47.47 0 0021 6.34l-.5-1.5a.5.5 0 00-.5-.34 2.38 2.38 0 01-2-1.28.51.51 0 00-.5-.22h-2a.51.51 0 00-.42.22 2.43 2.43 0 01-2 1.28.49.49 0 00-.52.34L12 6.34a.46.46 0 00.07.45.49.49 0 00.4.21c.17 0 1 .08 1 1.5s-.8 1.5-.96 1.5zm1.3.45a2.61 2.61 0 00.69-1.95 2.61 2.61 0 00-.69-1.95 1.87 1.87 0 00-.66-.42l.22-.64A3.55 3.55 0 0015.76 4h1.48a3.55 3.55 0 002.39 1.49l.22.64a1.87 1.87 0 00-.66.42 2.609 2.609 0 00-.69 2 2.61 2.61 0 00.69 1.95c.188.185.413.328.66.42l-.21.63a4.63 4.63 0 00-3.14 1.22 4.63 4.63 0 00-3.14-1.22l-.21-.63a1.87 1.87 0 00.66-.47z"
  }), /*#__PURE__*/jsx("path", {
    d: "M16.5 7a.5.5 0 100-1 .5.5 0 000 1zm0 2a.5.5 0 100-1 .5.5 0 000 1zm0 2a.5.5 0 100-1 .5.5 0 000 1z"
  })]
}));

/**
UiFeatureRearViewCameraFilled icon

```jsx
import { UiFeatureRearViewCameraFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeatureRearViewCameraFilled />
```

 */
const UiFeatureRearViewCameraFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M18.5 6.5h-.76c-.15-1-.32-2.11-.47-3A3 3 0 0014.32 1H9.68a3 3 0 00-2.95 2.5c-.15.89-.32 2-.47 3H5.5A.5.5 0 005 7v1a.5.5 0 00.5.5H6a.88.88 0 010 .16v.18c.13 1.44.46 3.6.73 5.16a3 3 0 002.95 2.5h4.64a3 3 0 002.95-2.5c.27-1.56.6-3.72.73-5.16v-.18a.873.873 0 010-.16h.52A.5.5 0 0019 8V7a.5.5 0 00-.5-.5zm-4.16 5.57a.49.49 0 01-.49.43h-3.7a.49.49 0 01-.49-.43l-.15-1a.49.49 0 01.49-.57h4a.5.5 0 01.38.17.49.49 0 01.11.4l-.15 1zm.54-3.74a.52.52 0 01-.38.17h-5a.52.52 0 01-.38-.17.55.55 0 01-.12-.39l.25-2a.51.51 0 01.5-.44h4.5a.51.51 0 01.5.44l.25 2a.55.55 0 01-.12.39zM7.53 18.84a.5.5 0 00.1.7 7.47 7.47 0 008.87 0 .5.5 0 10-.59-.81 6.58 6.58 0 01-7.69 0 .48.48 0 00-.69.11z"
  }), /*#__PURE__*/jsx("path", {
    d: "M12.06 19a5.43 5.43 0 003-.88.49.49 0 00.15-.69.5.5 0 00-.69-.15 4.52 4.52 0 01-4.85 0 .502.502 0 00-.55.84 5.48 5.48 0 002.94.88zm5.26 1.17a8.46 8.46 0 01-10.51 0 .502.502 0 00-.62.79 9.48 9.48 0 0011.75 0 .502.502 0 10-.62-.79z"
  })]
}));

/**
UiFeatureRearViewCameraLined icon

```jsx
import { UiFeatureRearViewCameraLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeatureRearViewCameraLined />
```

 */
const UiFeatureRearViewCameraLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M18.5 6.5h-.76c-.15-1-.32-2.11-.47-3A3 3 0 0014.32 1H9.68a3 3 0 00-2.95 2.5c-.15.89-.32 2-.47 3H5.5A.5.5 0 005 7v1a.5.5 0 00.5.5H6a.88.88 0 010 .16v.18c.13 1.44.46 3.6.73 5.16a3 3 0 002.95 2.5h4.64a3 3 0 002.95-2.5c.27-1.56.6-3.72.73-5.16v-.18a.873.873 0 010-.16h.52A.5.5 0 0019 8V7a.5.5 0 00-.5-.5zm-3.2 7.17a1 1 0 01-1 .83H9.68a1 1 0 01-1-.83c-.25-1.49-.57-3.54-.7-4.92.13-1.38.45-3.43.7-4.92a1 1 0 011-.83h4.64a1 1 0 011 .83c.25 1.49.57 3.54.7 4.92-.15 1.38-.47 3.43-.72 4.92z"
  }), /*#__PURE__*/jsx("path", {
    d: "M14 10.5h-4a.5.5 0 00-.38.17.49.49 0 00-.11.4l.15 1a.49.49 0 00.49.43h3.7a.49.49 0 00.49-.43l.15-1a.49.49 0 00-.11-.4.499.499 0 00-.38-.17zm.25-5h-4.5a.51.51 0 00-.5.44l-.25 2a.55.55 0 00.12.39.52.52 0 00.38.17h5a.52.52 0 00.38-.17.55.55 0 00.12-.39l-.25-2a.51.51 0 00-.5-.44zM7.46 18.84a.5.5 0 00.11.7 7.45 7.45 0 008.86 0 .499.499 0 00-.218-.896.51.51 0 00-.372.086 6.54 6.54 0 01-7.68 0 .51.51 0 00-.7.11z"
  }), /*#__PURE__*/jsx("path", {
    d: "M12 19a5.43 5.43 0 003-.88.5.5 0 10-.54-.84 4.54 4.54 0 01-4.86 0 .5.5 0 10-.54.84A5.43 5.43 0 0012 19zm5.25 1.17a8.45 8.45 0 01-10.5 0 .52.52 0 00-.71.08.51.51 0 00.09.71 9.47 9.47 0 0011.74 0 .51.51 0 00.09-.71.52.52 0 00-.71-.08z"
  })]
}));

/**
UiFeatureSunroofLined icon

```jsx
import { UiFeatureSunroofLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeatureSunroofLined />
```

 */
const UiFeatureSunroofLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11.69 16.89a.49.49 0 00.62 0l2.5-2a.5.5 0 00-.31-.89h-5a.5.5 0 00-.31.89l2.5 2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M20 3H4a3 3 0 00-3 3v12a3 3 0 003 3h16a3 3 0 003-3V6a3 3 0 00-3-3zM9.19 9.11l2.5-2a.48.48 0 01.62 0l2.5 2a.5.5 0 01-.31.89h-5a.5.5 0 01-.31-.89zM21 18a1 1 0 01-1 1H4a1 1 0 01-1-1v-6h18v6z"
  })]
}));

/**
UiFeatureThirdRowSeatsFilled icon

```jsx
import { UiFeatureThirdRowSeatsFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeatureThirdRowSeatsFilled />
```

 */
const UiFeatureThirdRowSeatsFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M19 16h-6.8a3 3 0 01-3-2.58L8 4.58A3 3 0 004.58 2 3 3 0 002 5.42l1.26 8.85A9 9 0 0012.2 22H19a3 3 0 000-6z"
  }), /*#__PURE__*/jsx("path", {
    d: "M14.5 12h4A2.5 2.5 0 0021 9.5v-4A2.5 2.5 0 0018.5 3h-4A2.5 2.5 0 0012 5.5v4a2.5 2.5 0 002.5 2.5zm.06-6.23C14.62 5.64 15 5 16.5 5c1.31 0 2 .75 2 1.5a1.3 1.3 0 01-.49 1l.12.1a1.21 1.21 0 01.37.87c0 .72-.63 1.5-2 1.5s-1.88-.64-1.94-.77a.5.5 0 11.88-.46c.316.199.688.29 1.06.26.59 0 1-.21 1-.5a.18.18 0 00-.07-.15A2.38 2.38 0 0016.09 8H16a.51.51 0 01-.465-.693A.49.49 0 0116 7h.09a4 4 0 001-.1c.44-.13.44-.31.44-.4 0-.24-.35-.5-1-.5-.86 0-1.08.27-1.08.27a.48.48 0 01-.66.19.51.51 0 01-.23-.69z"
  })]
}));

/**
UiFeatureThirdRowSeatsLined icon

```jsx
import { UiFeatureThirdRowSeatsLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeatureThirdRowSeatsLined />
```

 */
const UiFeatureThirdRowSeatsLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M19 16h-6.8a3 3 0 01-3-2.58L8 4.58A3 3 0 004.58 2 3 3 0 002 5.42l1.26 8.85A9 9 0 0012.2 22H19a3 3 0 000-6zm0 4h-6.8a7 7 0 01-6.93-6L4 5.14a1 1 0 01.2-.74 1 1 0 01.65-.4H5a1 1 0 011 .86l1.26 8.85A5 5 0 0012.2 18H19a1 1 0 110 2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M14.5 12h4A2.5 2.5 0 0021 9.5v-4A2.5 2.5 0 0018.5 3h-4A2.5 2.5 0 0012 5.5v4a2.5 2.5 0 002.5 2.5zM13 5.5A1.5 1.5 0 0114.5 4h4A1.5 1.5 0 0120 5.5v4a1.5 1.5 0 01-1.5 1.5h-4A1.5 1.5 0 0113 9.5v-4z"
  }), /*#__PURE__*/jsx("path", {
    d: "M14.76 6.46a.48.48 0 00.66-.19S15.64 6 16.5 6c.65 0 1 .26 1 .5 0 .09 0 .27-.44.4a4 4 0 01-1 .1H16a.49.49 0 00-.48.5.51.51 0 00.48.5h.08a2.38 2.38 0 011.34.35.18.18 0 01.07.15c0 .29-.41.5-1 .5a1.73 1.73 0 01-1.06-.23.5.5 0 10-.88.46c.06.13.47.77 1.94.77s2-.78 2-1.5a1.21 1.21 0 00-.37-.87l-.12-.1a1.301 1.301 0 00.49-1c0-.75-.69-1.5-2-1.5-1.47 0-1.88.64-1.94.77a.51.51 0 00.21.66z"
  })]
}));

/**
UiFeatureTowHitchFilled icon

```jsx
import { UiFeatureTowHitchFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeatureTowHitchFilled />
```

 */
const UiFeatureTowHitchFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22 16h-1.5c-1.22 0-2.25-1.44-2.25-3.14.003-.485.091-.966.26-1.42a4 4 0 10-4 0c.169.454.257.935.26 1.42 0 1.7-1 3.13-2.24 3.14a3 3 0 01-2.86-2.2L8 7.73a1.036 1.036 0 10-2 .54l.2.73H1.5a.5.5 0 00-.5.5v2a.5.5 0 00.5.5h5.57l.65 2.34A5 5 0 0012.47 18h2.28v1a1 1 0 001 1h1.5a1 1 0 001-1v-1H22a1 1 0 000-2z"
  })
}));

/**
UiFeatureTowHitchLined icon

```jsx
import { UiFeatureTowHitchLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeatureTowHitchLined />
```

 */
const UiFeatureTowHitchLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22 16h-1.5c-1.22 0-2.25-1.44-2.25-3.14.003-.485.091-.966.26-1.42a4 4 0 10-4 0c.169.454.257.935.26 1.42 0 1.7-1 3.13-2.24 3.14a3 3 0 01-2.86-2.2L8 7.73a1.036 1.036 0 10-2 .54l.2.73H1.5a.5.5 0 00-.5.5v2a.5.5 0 00.5.5h5.57l.65 2.34A5 5 0 0012.47 18h2.28v1a1 1 0 001 1h1.5a1 1 0 001-1v-1H22a1 1 0 000-2zm-5.5-6a2 2 0 110-4 2 2 0 010 4z"
  })
}));

/**
UiFeaturesLined icon

```jsx
import { UiFeaturesLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeaturesLined />
```

 */
const UiFeaturesLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 5h-1c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1a.994.994 0 01-.032.252L8.034 6.82l2.978-2.667A.976.976 0 0111 4V3c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1c0 .56-.45 1-1 1h-1a.991.991 0 01-.36-.068L8.741 7.528l3.003 3.005A.995.995 0 0112 10.5h1c.09 0 .176.012.259.034l6.275-6.275A.991.991 0 0119.5 4V3c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1c0 .56-.45 1-1 1h-1a.992.992 0 01-.259-.034l-6.275 6.275c.022.083.034.17.034.259v1a.976.976 0 01-.033.256l6.275 6.278A.993.993 0 0120.5 19h1c.55 0 1 .45 1 1v1c0 .56-.45 1-1 1h-1c-.55 0-1-.45-1-1v-1c0-.09.012-.176.034-.26l-6.271-6.274A1.01 1.01 0 0113 13.5h-1a.991.991 0 01-.259-.034l-3 3 2.905 2.6A.992.992 0 0112 19h1c.55 0 1 .45 1 1v1c0 .56-.45 1-1 1h-1c-.55 0-1-.45-1-1v-1c0-.054.004-.108.013-.16l-2.98-2.666-2.567 2.567c.022.083.034.17.034.259v1c0 .56-.45 1-1 1h-1c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1h1c.09 0 .176.012.259.034l2.527-2.528-3.431-3.07c-.11.041-.23.064-.355.064h-1c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1h1a.99.99 0 01.353.065l3.435-3.077-2.522-2.524A1.01 1.01 0 014.5 5zm3.496 3.196l-3.509 3.143a.998.998 0 01.013.161v1a.934.934 0 01-.013.16l3.508 3.138 3.04-3.04A.991.991 0 0111 12.5v-1c0-.09.012-.18.035-.263L7.996 8.196z"
  })
}));

/**
UiFeaturesLinedSmall icon

```jsx
import { UiFeaturesLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeaturesLinedSmall />
```

 */
const UiFeaturesLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 3h-1a.993.993 0 01-.259-.034L5.457 4.75l1.784 1.784A.993.993 0 017.5 6.5h1.01L13 1.837V1c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1c0 .55-.44 1-1 1h-1a.993.993 0 01-.563-.175L9.384 7.034c.074.14.116.298.116.466v1c0 .09-.012.177-.034.26l4.275 4.274A.991.991 0 0114 13h1c.55 0 1 .45 1 1v1c0 .55-.44 1-1 1h-1c-.55 0-1-.45-1-1v-1c0-.09.012-.176.034-.259L8.76 9.467a1.044 1.044 0 01-.259.033h-1a.99.99 0 01-.407-.087l-1.704 1.77 1.852 1.851A.992.992 0 017.5 13h1c.55 0 1 .45 1 1v1c0 .55-.44 1-1 1h-1c-.55 0-1-.45-1-1v-1c0-.09.012-.176.034-.259l-1.839-1.838-1.739 1.805c.029.093.044.19.044.292v1c0 .55-.44 1-1 1H1c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1h1c.077 0 .153.009.225.026l1.763-1.83-1.729-1.73A.958.958 0 012 9.5H1c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1h1c.09 0 .176.012.259.034L4.043 4.75 2.259 2.967A1.044 1.044 0 012 3H1c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1c0 .09-.012.176-.034.26L4.75 4.042l1.784-1.784A.993.993 0 016.5 2V1c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1c0 .55-.44 1-1 1zM4.75 5.457L2.966 7.241c.022.083.034.17.034.259v1c0 .09-.012.177-.034.26l1.716 1.715 1.821-1.892A1.002 1.002 0 016.5 8.5v-1c0-.09.012-.176.034-.259L4.75 5.457z"
  })
}));

/**
UiFeedbackDissatisfiedFilled icon

```jsx
import { UiFeedbackDissatisfiedFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeedbackDissatisfiedFilled />
```

 */
const UiFeedbackDissatisfiedFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zM9.5 8c.83 0 1.5.67 1.5 1.5S10.33 11 9.5 11 8 10.33 8 9.5 8.67 8 9.5 8zm6.05 8.33c-.17.11-.36.17-.55.17a1 1 0 01-.83-.44C14.13 16 13.4 15 12 15c-1.41 0-2.14 1.02-2.17 1.06-.31.45-.94.57-1.39.26a.996.996 0 01-.27-1.38c.05-.08 1.33-1.95 3.83-1.95s3.78 1.87 3.83 1.95a1 1 0 01-.28 1.39zM14.5 11c-.83 0-1.5-.67-1.5-1.5S13.67 8 14.5 8s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
  })
}));

/**
UiFeedbackDissatisfiedLined icon

```jsx
import { UiFeedbackDissatisfiedLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeedbackDissatisfiedLined />
```

 */
const UiFeedbackDissatisfiedLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
  }), /*#__PURE__*/jsx("path", {
    d: "M9.5 11a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm5 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM12 13c-2.51 0-3.78 1.87-3.83 1.95-.3.46-.18 1.07.27 1.38.45.31 1.07.19 1.39-.26.03-.04.76-1.06 2.17-1.06 1.4 0 2.13 1 2.17 1.06.19.28.51.44.83.44.19 0 .38-.05.55-.17.46-.31.58-.93.28-1.39C15.78 14.87 14.51 13 12 13z"
  })]
}));

/**
UiFeedbackDissatisfiedLinedSmall icon

```jsx
import { UiFeedbackDissatisfiedLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeedbackDissatisfiedLinedSmall />
```

 */
const UiFeedbackDissatisfiedLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M7 5.5a1 1 0 11-2 0 1 1 0 012 0zm3 1a1 1 0 100-2 1 1 0 000 2zm-3.85 4.47c.543-.466 1.178-.72 1.84-.72.697 0 1.352.27 1.895.767a1 1 0 101.35-1.475C10.36 8.74 9.233 8.25 7.99 8.25c-1.198 0-2.283.465-3.14 1.2a1 1 0 101.3 1.52z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.978 16a8 8 0 10.044-16 8 8 0 00-.044 16zM14 8.017a6 6 0 11-12-.034 6 6 0 0112 .034z"
  })]
}));

/**
UiFeedbackFilled icon

```jsx
import { UiFeedbackFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeedbackFilled />
```

 */
const UiFeedbackFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M16 9c-.1.1-.1.1-.1.2 0 .2-.1.5-.1.7 0 .1 0 .2-.1.3-.1.2-.1.5-.2.7-.3.8-.7 1.5-1.2 2.2h.1s.1 0 .1.1c.1 0 .1.1.2.1l.1.1c.1.1.1.1.1.2 0 0 0 .1.1.1 0 .1.1.2.1.4 0 .6-.4 1-1 1-.1 0-.2 0-.3-.1 0 0-.1 0-.1-.1-.1 0-.1-.1-.2-.1l-.1-.1c0-.1-.1-.1-.1-.2 0 0 0-.1-.1-.1v-.1c-.6.5-1.4.9-2.2 1.2-.2.1-.5.2-.7.2-.1 0-.2.1-.3.1-.2.1-.5.1-.7.1h-.2L9 16c0 1.7.6 3.2 1.6 4.5.3.3.6.7.9.9 1.2 1 2.8 1.6 4.5 1.6 3.9 0 7-3.1 7-7s-3.1-7-7-7zm1 5c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1-1-.4-1-1zm-4 4.3c.1-.1.1-.2.2-.2.8-.7 1.7-1.1 2.8-1.1 1.1 0 2.1.4 2.9 1.1.1.1.1.2.2.2.2.4.2.8-.1 1.2-.4.4-1 .4-1.4.1-.4-.4-1-.6-1.5-.6s-1 .2-1.5.6c-.4.4-1 .3-1.4-.1-.4-.4-.4-.8-.2-1.2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M15 8c0-3.9-3.1-7-7-7S1 4.1 1 8s3.1 7 7 7 7-3.1 7-7zm-5-3c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zM6 5c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zm2 8c-2.2 0-3.9-1.4-4-3.4 0-.2.1-.3.2-.4.1-.1.3-.2.4-.2h6.8c.2 0 .3.1.4.2.1.1.2.3.2.4-.1 2-1.8 3.4-4 3.4z"
  })]
}));

/**
UiFeedbackLined icon

```jsx
import { UiFeedbackLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeedbackLined />
```

 */
const UiFeedbackLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M6 7a1 1 0 100-2 1 1 0 000 2zm4 0a1 1 0 100-2 1 1 0 000 2zm1.999 1.614c-.093 1.98-1.844 3.386-4 3.386C5.844 12 4.093 10.594 4 8.614c0-.159.062-.326.176-.435A.66.66 0 014.622 8h6.766c.165 0 .331.06.445.179a.58.58 0 01.166.435z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 8a7 7 0 1114 0A7 7 0 011 8zm7-5a5 5 0 100 10A5 5 0 008 3z"
  }), /*#__PURE__*/jsx("path", {
    d: "M15.938 9H16a7 7 0 11-7 7v-.062a7.945 7.945 0 002.035-.533 5 5 0 104.37-4.37c.262-.64.444-1.323.533-2.035z"
  }), /*#__PURE__*/jsx("path", {
    d: "M13.026 14.226c.441-.357.844-.76 1.2-1.201a1 1 0 11-1.2 1.2zm4.974.773a1 1 0 100-2 1 1 0 000 2zm-3.495 3.577c.435-.377.946-.576 1.475-.576.553 0 1.08.218 1.53.623a1 1 0 001.34-1.486C18.079 16.442 17.087 16 15.98 16c-1.052 0-2.02.401-2.785 1.064a1 1 0 001.31 1.512zM10 7a1 1 0 100-2 1 1 0 000 2z"
  })]
}));

/**
UiFeedbackNeutralFilled icon

```jsx
import { UiFeedbackNeutralFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeedbackNeutralFilled />
```

 */
const UiFeedbackNeutralFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM8 9.5C8 8.7 8.7 8 9.5 8s1.5.7 1.5 1.5-.7 1.5-1.5 1.5S8 10.3 8 9.5zm6 6.5h-4c-.6 0-1-.4-1-1s.4-1 1-1h4c.6 0 1 .4 1 1s-.4 1-1 1zm.5-5c-.8 0-1.5-.7-1.5-1.5S13.7 8 14.5 8s1.5.7 1.5 1.5-.7 1.5-1.5 1.5z"
  })
}));

/**
UiFeedbackNeutralLined icon

```jsx
import { UiFeedbackNeutralLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeedbackNeutralLined />
```

 */
const UiFeedbackNeutralLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11 9.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm3.5 1.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM9 15c0-.6.4-1 1-1h4c.6 0 1 .4 1 1s-.4 1-1 1h-4c-.6 0-1-.4-1-1z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.5 6.5 2 12 2s10 4.5 10 10-4.5 10-10 10S2 17.5 2 12zm2 0c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8-8 3.6-8 8z"
  })]
}));

/**
UiFeedbackNeutralLinedSmall icon

```jsx
import { UiFeedbackNeutralLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeedbackNeutralLinedSmall />
```

 */
const UiFeedbackNeutralLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M7 5.5a1 1 0 11-2 0 1 1 0 012 0zm3 1a1 1 0 100-2 1 1 0 000 2zM5.5 9a1 1 0 100 2h5a1 1 0 100-2h-5z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0a8 8 0 100 16A8 8 0 008 0zM2 8a6 6 0 1112 0A6 6 0 012 8z"
  })]
}));

/**
UiFeedbackSatisfiedFilled icon

```jsx
import { UiFeedbackSatisfiedFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeedbackSatisfiedFilled />
```

 */
const UiFeedbackSatisfiedFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm2.5 6c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5.7-1.5 1.5-1.5zm-5 0c.8 0 1.5.7 1.5 1.5S10.3 11 9.5 11 8 10.3 8 9.5 8.7 8 9.5 8zm8 6.4c-1 2.2-3.1 3.6-5.5 3.6s-4.5-1.4-5.5-3.6c-.2-.5 0-1.1.5-1.3.5-.2 1.1 0 1.3.5C9 15.1 10.4 16 12 16s3-.9 3.7-2.4c.2-.5.8-.7 1.3-.5.5.2.7.8.5 1.3z"
  })
}));

/**
UiFeedbackSatisfiedLined icon

```jsx
import { UiFeedbackSatisfiedLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeedbackSatisfiedLined />
```

 */
const UiFeedbackSatisfiedLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11 9.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm3.5 1.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm1.2 2.6c.2-.5.8-.7 1.3-.5.5.2.7.8.5 1.3-1 2.2-3.1 3.6-5.5 3.6s-4.5-1.4-5.5-3.6c-.2-.5 0-1.1.5-1.3.5-.2 1.1 0 1.3.5C9 15.1 10.4 16 12 16s3-.9 3.7-2.4z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.5 6.5 2 12 2s10 4.5 10 10-4.5 10-10 10S2 17.5 2 12zm2 0c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8-8 3.6-8 8z"
  })]
}));

/**
UiFeedbackSatisfiedLinedSmall icon

```jsx
import { UiFeedbackSatisfiedLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeedbackSatisfiedLinedSmall />
```

 */
const UiFeedbackSatisfiedLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 17,
  height: 17,
  viewBox: "0 0 17 17",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M5.478 9.273a1 1 0 10-1.956.415c.426 2.009 2.38 3.342 4.528 3.342 2.103 0 4.011-1.274 4.49-3.22a1 1 0 10-1.94-.479c-.221.894-1.193 1.7-2.55 1.7-1.392 0-2.378-.847-2.572-1.758zM6.05 6.53a1 1 0 100-2 1 1 0 000 2zm5-1a1 1 0 11-2 0 1 1 0 012 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.05.03a8 8 0 100 16 8 8 0 000-16zm-6 8a6 6 0 1112 0 6 6 0 01-12 0z"
  })]
}));

/**
UiFeedbackTriggerFilled icon

```jsx
import { UiFeedbackTriggerFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeedbackTriggerFilled />
```

 */
const UiFeedbackTriggerFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M11.995 3C6.488 3 2 7.04 2 12c0 2.21.88 4.3 2.499 5.95l-.48 2.89c-.06.35.07.7.34.92.18.16.42.24.65.24.11 0 .21-.02.32-.05l3.907-1.3c.91.24 1.84.36 2.769.36 5.507 0 9.995-4.04 9.995-9S17.502 3 11.995 3zm2.499 5c.83 0 1.499.67 1.499 1.5a1.498 1.498 0 11-2.998 0c0-.83.67-1.5 1.499-1.5zM9.496 8c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.499-.67-1.499-1.5.67-1.5 1.5-1.5zm7.426 5.87c-.05.13-1.299 3.13-4.927 3.13-3.628 0-4.878-3-4.928-3.13-.14-.35-.07-.75.17-1.03.25-.28.63-.4 1-.31.02 0 1.909.47 3.758.47 1.86 0 3.738-.47 3.758-.47.36-.09.75.03 1 .31.24.28.31.68.17 1.03z"
  })
}));

/**
UiFeedbackTriggerLined icon

```jsx
import { UiFeedbackTriggerLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeedbackTriggerLined />
```

 */
const UiFeedbackTriggerLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11.995 3C6.488 3 2 7.04 2 12c0 2.21.88 4.3 2.499 5.95l-.48 2.89c-.06.35.07.7.34.92.18.16.42.24.65.24.11 0 .21-.02.32-.05l3.907-1.3c.91.24 1.84.36 2.769.36 5.507 0 9.995-4.04 9.995-9S17.502 3 11.995 3zm0 16c-.85 0-1.7-.12-2.519-.36-.19-.06-.4-.05-.6.01l-2.618.88.29-1.77a.98.98 0 00-.31-.9c-1.45-1.31-2.239-3.04-2.239-4.85 0-3.86 3.588-7 7.996-7s7.996 3.14 7.996 7S16.403 19 11.995 19z"
  }), /*#__PURE__*/jsx("path", {
    d: "M9.496 11a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm4.998 0a1.5 1.5 0 10-.001-3 1.5 1.5 0 000 3zm1.259 1.53c-.02 0-1.899.47-3.758.47-1.85 0-3.738-.47-3.758-.47-.36-.09-.75.03-1 .31s-.31.68-.17 1.03c.05.13 1.29 3.13 4.928 3.13s4.878-3 4.928-3.13c.14-.35.07-.75-.18-1.03a.994.994 0 00-.99-.31z"
  })]
}));

/**
UiFeedbackTriggerLinedSmall icon

```jsx
import { UiFeedbackTriggerLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeedbackTriggerLinedSmall />
```

 */
const UiFeedbackTriggerLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M7.13 4.69a.86.86 0 11-1.72 0 .86.86 0 011.72 0zm4.76 2.8c-.09 2.06-1.8 3.67-3.89 3.67S4.2 9.55 4.11 7.49c0-.16.06-.33.17-.45.11-.12.27-.19.43-.19h6.58c.16 0 .31.07.43.19s.18.28.17.45zM9.73 5.55a.86.86 0 100-1.72.86.86 0 000 1.72z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 .5C3.746.5 0 3.434 0 7.39c0 1.695.708 3.232 1.849 4.41l-.797 2.383a1 1 0 001.416 1.2l2.832-1.5a9.198 9.198 0 002.7.407c4.254 0 8-2.933 8-6.89C16 3.445 12.257.5 8 .5zM2 7.39C2 4.846 4.514 2.5 8 2.5c3.483 0 6 2.354 6 4.9 0 2.544-2.514 4.89-6 4.89a7.218 7.218 0 01-2.45-.43 1 1 0 00-.808.056l-1 .53.206-.619a1 1 0 00-.298-1.077C2.6 9.853 2 8.658 2 7.39z"
  })]
}));

/**
UiFeedbackVeryDissatisfiedFilled icon

```jsx
import { UiFeedbackVeryDissatisfiedFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeedbackVeryDissatisfiedFilled />
```

 */
const UiFeedbackVeryDissatisfiedFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm2.5 6c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm-5 0c.83 0 1.5.67 1.5 1.5S10.33 11 9.5 11 8 10.33 8 9.5 8.67 8 9.5 8zm7.47 8.92c-.13.06-.27.08-.4.08-.38 0-.75-.22-.92-.6A3.989 3.989 0 0012 14c-1.58 0-3.01.94-3.65 2.4-.22.51-.81.74-1.32.51a.989.989 0 01-.51-1.32c.96-2.19 3.11-3.6 5.49-3.6 2.38 0 4.53 1.41 5.49 3.6.21.51-.02 1.1-.53 1.33z"
  })
}));

/**
UiFeedbackVeryDissatisfiedLined icon

```jsx
import { UiFeedbackVeryDissatisfiedLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeedbackVeryDissatisfiedLined />
```

 */
const UiFeedbackVeryDissatisfiedLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
  }), /*#__PURE__*/jsx("path", {
    d: "M9.5 11a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm5 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM12 12c-2.37 0-4.53 1.41-5.49 3.6-.22.51.01 1.1.51 1.32.5.22 1.1-.01 1.32-.51.64-1.46 2.07-2.4 3.65-2.4s3.01.94 3.65 2.4c.16.38.53.6.92.6.13 0 .27-.03.4-.08.51-.22.74-.81.51-1.32-.94-2.2-3.1-3.61-5.47-3.61z"
  })]
}));

/**
UiFeedbackVeryDissatisfiedLinedSmall icon

```jsx
import { UiFeedbackVeryDissatisfiedLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeedbackVeryDissatisfiedLinedSmall />
```

 */
const UiFeedbackVeryDissatisfiedLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M7 5.5a1 1 0 11-2 0 1 1 0 012 0zm3 1a1 1 0 100-2 1 1 0 000 2zM7.99 7.75c-2.075 0-3.977 1.247-4.46 3.166a1 1 0 101.94.488c.217-.861 1.175-1.654 2.52-1.654 1.376 0 2.342.83 2.533 1.712a1 1 0 001.954-.424C12.048 9.06 10.114 7.75 7.99 7.75z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0a8 8 0 100 16A8 8 0 008 0zM2 8a6 6 0 1112 0A6 6 0 012 8z"
  })]
}));

/**
UiFeedbackVerySatisfiedFilled icon

```jsx
import { UiFeedbackVerySatisfiedFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeedbackVerySatisfiedFilled />
```

 */
const UiFeedbackVerySatisfiedFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm2.5 6c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5.7-1.5 1.5-1.5zm-5 0c.8 0 1.5.7 1.5 1.5S10.3 11 9.5 11 8 10.3 8 9.5 8.7 8 9.5 8zm8.4 5.7c-.6 2.8-3 4.8-5.9 4.8-2.9 0-5.3-2-5.9-4.8-.1-.4.1-.8.4-1 .3-.2.7-.3 1.1-.1 0 0 1.7.9 4.4.9s4.4-.9 4.4-.9c.3-.2.8-.1 1.1.1.3.2.5.6.4 1z"
  })
}));

/**
UiFeedbackVerySatisfiedLined icon

```jsx
import { UiFeedbackVerySatisfiedLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeedbackVerySatisfiedLined />
```

 */
const UiFeedbackVerySatisfiedLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M16.4 12.6c.4-.2.8-.1 1.1.1.3.2.5.6.4 1-.6 2.8-3 4.8-5.9 4.8-2.9 0-5.3-2-5.9-4.8-.1-.4.1-.8.4-1 .3-.2.8-.3 1.1-.1 0 0 1.8.9 4.4.9 2.6 0 4.4-.9 4.4-.9zM9.5 11a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM16 9.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.5 6.5 2 12 2s10 4.5 10 10-4.5 10-10 10S2 17.5 2 12zm2 0c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8-8 3.6-8 8z"
  })]
}));

/**
UiFeedbackVerySatisfiedLinedSmall icon

```jsx
import { UiFeedbackVerySatisfiedLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFeedbackVerySatisfiedLinedSmall />
```

 */
const UiFeedbackVerySatisfiedLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12.5 8.75C12.4 11.13 10.42 13 8 13s-4.4-1.87-4.5-4.25c-.01-.2.06-.39.19-.53S4 8 4.19 8h7.62c.19 0 .37.08.5.22.13.15.2.34.19.53zM6 6.5a1 1 0 100-2 1 1 0 000 2zm5-1a1 1 0 11-2 0 1 1 0 012 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0a8 8 0 100 16A8 8 0 008 0zM2 8a6 6 0 1112 0A6 6 0 012 8z"
  })]
}));

/**
UiFilterAltFilled icon

```jsx
import { UiFilterAltFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFilterAltFilled />
```

 */
const UiFilterAltFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 17h-6.18c-.41-1.16-1.51-2-2.82-2s-2.4.84-2.82 2H4c-.55 0-1 .45-1 1s.45 1 1 1h4.18c.42 1.16 1.52 2 2.82 2s2.4-.84 2.82-2H20c.55 0 1-.45 1-1s-.45-1-1-1zM4 7h.18C4.6 8.16 5.7 9 7 9s2.4-.84 2.82-2H20c.55 0 1-.45 1-1s-.45-1-1-1H9.82C9.4 3.84 8.3 3 7 3s-2.4.84-2.82 2H4c-.55 0-1 .45-1 1s.45 1 1 1zm15 2c-1.3 0-2.4.84-2.82 2H4c-.55 0-1 .45-1 1s.45 1 1 1h12.18c.41 1.16 1.51 2 2.82 2 1.65 0 3-1.35 3-3s-1.35-3-3-3z"
  })
}));

/**
UiFilterAltFilledSmall icon

```jsx
import { UiFilterAltFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFilterAltFilledSmall />
```

 */
const UiFilterAltFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M2 4h.21c.39.88 1.27 1.5 2.29 1.5S6.4 4.88 6.79 4H14c.55 0 1-.45 1-1s-.45-1-1-1H6.79C6.4 1.12 5.52.5 4.5.5S2.6 1.12 2.21 2H2c-.55 0-1 .45-1 1s.45 1 1 1zm10.5 1.5c-1.02 0-1.9.62-2.29 1.5H2c-.55 0-1 .45-1 1s.45 1 1 1h8.21c.39.88 1.27 1.5 2.29 1.5a2.5 2.5 0 000-5zM14 12H9.79c-.39-.88-1.27-1.5-2.29-1.5s-1.9.62-2.29 1.5H2c-.55 0-1 .45-1 1s.45 1 1 1h3.21c.39.88 1.27 1.5 2.29 1.5s1.9-.62 2.29-1.5H14c.55 0 1-.45 1-1s-.45-1-1-1z"
  })
}));

/**
UiFilterAltLined icon

```jsx
import { UiFilterAltLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFilterAltLined />
```

 */
const UiFilterAltLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 17h-6.18c-.41-1.16-1.51-2-2.82-2s-2.4.84-2.82 2H4c-.55 0-1 .45-1 1s.45 1 1 1h4.18c.42 1.16 1.52 2 2.82 2s2.4-.84 2.82-2H20c.55 0 1-.45 1-1s-.45-1-1-1zm-8 1c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zM4 7h.18C4.6 8.16 5.7 9 7 9s2.4-.84 2.82-2H20c.55 0 1-.45 1-1s-.45-1-1-1H9.82C9.4 3.84 8.3 3 7 3s-2.4.84-2.82 2H4c-.55 0-1 .45-1 1s.45 1 1 1zm2-1c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1zm13 3c-1.3 0-2.4.84-2.82 2H4c-.55 0-1 .45-1 1s.45 1 1 1h12.18c.41 1.16 1.51 2 2.82 2 1.65 0 3-1.35 3-3s-1.35-3-3-3zm-1 3c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1z"
  })
}));

/**
UiFilterAltLinedSmall icon

```jsx
import { UiFilterAltLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFilterAltLinedSmall />
```

 */
const UiFilterAltLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8 6c-.4 1.4-1.7 2.5-3.3 2.5C1.6 8.5 0 6.9 0 5s1.6-3.5 3.5-3.5c1.6 0 2.9 1.1 3.3 2.5H15c.6 0 1 .4 1 1s-.4 1-1 1H6.8zm-3.3.5C4.3 6.5 5 5.8 5 5s-.7-1.5-1.5-1.5S2 4.2 2 5s.7 1.5 1.5 1.5zM9.2 10c.4-1.4 1.7-2.5 3.3-2.5 1.9 0 3.5 1.6 3.5 3.5s-1.6 3.5-3.5 3.5c-1.5 0-2.9-1.1-3.3-2.5H1c-.6 0-1-.4-1-1s.4-1 1-1h8.2zm1.8 1c0 .8.7 1.5 1.5 1.5S14 11.8 14 11s-.7-1.5-1.5-1.5-1.5.7-1.5 1.5z"
  })
}));

/**
UiFilterFilled icon

```jsx
import { UiFilterFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFilterFilled />
```

 */
const UiFilterFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4a1 1 0 011-1h16a1 1 0 011 1v1.2a2.97 2.97 0 01-.893 2.107L14 13.414V20a1 1 0 01-.553.894l-2 1A1 1 0 0110 21v-7.586L3.893 7.307A2.974 2.974 0 013 5.2V4z"
  })
}));

/**
UiFilterFilledSmall icon

```jsx
import { UiFilterFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFilterFilledSmall />
```

 */
const UiFilterFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14 1H2c-.6 0-1 .4-1 1v1.2c0 .8.3 1.5.9 2.1L6 9.4V15c0 .3.2.7.5.9.1.1.3.1.5.1s.3 0 .4-.1l2-1c.4-.2.6-.5.6-.9V9.4l4.1-4.1c.6-.6.9-1.3.9-2.1V2c0-.6-.4-1-1-1z"
  })
}));

/**
UiFilterLined icon

```jsx
import { UiFilterLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFilterLined />
```

 */
const UiFilterLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4a1 1 0 011-1h16a1 1 0 011 1v2.2a2.97 2.97 0 01-.893 2.107L15 13.414V19a1 1 0 01-.553.894l-4 2A1 1 0 019 21v-7.586L3.893 8.307A2.974 2.974 0 013 6.2V4zm2 1v1.2a.98.98 0 00.307.693l5.4 5.4A1 1 0 0111 13v6.382l2-1V13a1 1 0 01.293-.707l5.4-5.4A.976.976 0 0019 6.2V5H5z"
  })
}));

/**
UiFilterLinedSmall icon

```jsx
import { UiFilterLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFilterLinedSmall />
```

 */
const UiFilterLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14 1H2c-.6 0-1 .4-1 1v1.2c0 .8.3 1.5.9 2.1L5 8.4V15c0 .3.2.7.5.9.1.1.3.1.5.1s.3 0 .4-.1l4-2c.4-.2.6-.5.6-.9V8.4l3.1-3.1c.6-.6.9-1.3.9-2.1V2c0-.6-.4-1-1-1zm-1 2.2c0 .3-.1.5-.3.7L9.3 7.3c-.2.2-.3.4-.3.7v4.4l-2 1V8c0-.3-.1-.5-.3-.7L3.3 3.9c-.2-.2-.3-.5-.3-.7V3h10v.2z"
  })
}));

/**
UiFingerprintLined icon

```jsx
import { UiFingerprintLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFingerprintLined />
```

 */
const UiFingerprintLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M5.966 4.13c3.52-2.14 8.21-2.13 11.72.04.12.08.26.11.39.11.25 0 .5-.13.64-.35.22-.35.11-.81-.24-1.03-3.98-2.46-9.29-2.48-13.28-.05a.75.75 0 00-.25 1.03c.21.35.67.46 1.02.25zm10.32 14.4c-2.19-.63-3.83-2.58-3.83-4.53 0-.41-.34-.75-.75-.75s-.75.34-.75.75c0 2.6 2.11 5.16 4.92 5.97.07.02.14.03.21.03.33 0 .63-.21.72-.54.1-.4-.12-.82-.52-.93z"
  }), /*#__PURE__*/jsx("path", {
    d: "M6.326 14c0-3.34 2.16-5.5 5.5-5.5a5.5 5.5 0 015.46 4.84c.05.41.42.71.83.66.41-.05.71-.42.66-.83A7.003 7.003 0 0011.826 7c-4.12 0-7 2.88-7 7 0 4.21 2.55 7.57 2.66 7.71a.758.758 0 001.06.13c.33-.25.39-.72.14-1.05-.04-.03-2.36-3.09-2.36-6.79z"
  }), /*#__PURE__*/jsx("path", {
    d: "M11.826 4c-3.87 0-7.55 2.27-8.94 5.52-1.03 2.4-1.17 5.3-.38 7.95.12.4.53.63.93.51s.62-.53.51-.93c-.32-1.1-.94-3.97.33-6.93 1.16-2.71 4.27-4.61 7.56-4.61 4.79 0 8.5 4.03 8.5 7.5 0 1.54-.86 2.5-2.25 2.5-1.57 0-1.97-.84-2.54-2.33-.56-1.42-1.24-3.18-3.72-3.18-2.32 0-4 1.68-4 4 0 6.29 5.71 8.83 5.95 8.94.1.04.2.06.3.06a.751.751 0 00.3-1.44c-.21-.09-5.05-2.27-5.05-7.56 0-1.47 1.03-2.5 2.5-2.5 1.39 0 1.75.76 2.31 2.21.54 1.39 1.27 3.29 3.94 3.29 2.21 0 3.75-1.65 3.75-4 0-4.25-4.28-9-10-9z"
  })]
}));

/**
UiFingerprintLinedSmall icon

```jsx
import { UiFingerprintLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFingerprintLinedSmall />
```

 */
const UiFingerprintLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11.09 12.51C9.44 12.3 8.5 11.39 8.5 10c0-.41-.34-.75-.75-.75S7 9.59 7 10c0 2.16 1.5 3.69 3.91 3.99.03 0 .06.01.09.01.37 0 .7-.28.74-.66a.737.737 0 00-.65-.83z"
  }), /*#__PURE__*/jsx("path", {
    d: "M8 3c-3.86 0-7 3.14-7 7 0 1.1.25 2.32.73 3.52.15.39.59.58.97.42.38-.15.57-.59.42-.97-.41-1.04-.62-2.06-.62-2.98 0-3.03 2.47-5.5 5.5-5.5 3.08 0 5.5 1.98 5.5 4.5 0 .9-.7 1-1 1-.74 0-.95-.79-1.01-1.12C11.16 6.91 10.05 6 8 6c-2.21 0-4 1.79-4 4 0 2.17.44 4.58 3.71 5.94a.746.746 0 00.98-.4.75.75 0 00-.4-.98C5.72 13.49 5.5 11.72 5.5 10A2.5 2.5 0 018 7.5c1.48 0 1.83.52 2.01 1.62.24 1.44 1.22 2.38 2.49 2.38 1.2 0 2.5-.78 2.5-2.5 0-3.36-3.08-6-7-6z"
  }), /*#__PURE__*/jsx("path", {
    d: "M3.2 3.05C4.54 2.05 6.24 1.5 8 1.5c1.76 0 3.46.55 4.8 1.55.13.1.29.15.45.15a.75.75 0 00.45-1.35C12.1.66 10.08 0 8 0S3.9.66 2.3 1.85a.75.75 0 00.9 1.2z"
  })]
}));

/**
UiFlagFilled icon

```jsx
import { UiFlagFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFlagFilled />
```

 */
const UiFlagFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M19.988 3.645a1.002 1.002 0 00-1.7-.572c-.03.03-3.038 2.779-5.647.414-2.62-2.374-5.879-1.438-7.668-.394a.99.99 0 00-1.14-.788.99.99 0 00-.82 1.133l3 17.734c.08.483.5.828.99.828.05 0 .11 0 .17-.01a.99.99 0 00.819-1.133l-1.34-7.921c1.56-.75 3.19-1.212 4.649.118a5.038 5.038 0 003.469 1.34c2.67 0 5.228-1.833 5.938-2.532a.949.949 0 00.28-.828l-1-7.39z"
  })
}));

/**
UiFlagFilledSmall icon

```jsx
import { UiFlagFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFlagFilledSmall />
```

 */
const UiFlagFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14.984 6.821l-.999-5.5a1 1 0 00-.69-.78.995.995 0 00-1.008.25c-.729.74-2.177 1.77-3.636.43-1.867-1.72-4.204-1.31-5.743-.6-.17-.41-.579-.68-1.048-.61a.995.995 0 00-.85 1.13l1.998 14c.07.5.5.86.99.86.049 0 .089 0 .139-.01.55-.08.929-.58.849-1.13l-.87-6.08c1.36-.62 2.348-.56 3.177.21.81.74 1.698 1.03 2.597 1.03 1.908 0 3.815-1.31 4.804-2.31.24-.23.35-.56.29-.89z"
  })
}));

/**
UiFlagLined icon

```jsx
import { UiFlagLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFlagLined />
```

 */
const UiFlagLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M19.988 3.64a1.002 1.002 0 00-1.7-.572c-.03.03-3.038 2.778-5.647.414-2.62-2.364-5.879-1.438-7.668-.384a.984.984 0 00-1.14-.788.985.985 0 00-.82 1.132l3 17.73c.08.483.5.828.99.828.05 0 .11 0 .17-.01a.99.99 0 00.819-1.133l-1.34-7.92c1.56-.748 3.19-1.21 4.649.12a5.04 5.04 0 003.469 1.339c2.67 0 5.228-1.833 5.938-2.532a.949.949 0 00.28-.827l-1-7.398zm-7.347 7.948c-2.29-2.068-4.859-1.33-6.338-.68l-.97-5.732c.09-.03.18-.06.26-.128.03-.02 3.239-2.335 5.688-.108 2.45 2.216 5.188 1.546 6.938.58l.71 5.211c-1.05.788-4.169 2.778-6.288.857z"
  })
}));

/**
UiFlagLinedSmall icon

```jsx
import { UiFlagLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFlagLinedSmall />
```

 */
const UiFlagLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14.983 6.821l-.999-5.5a1 1 0 00-1.697-.53c-.74.74-2.178 1.77-3.636.43-1.868-1.72-4.205-1.31-5.743-.6A.98.98 0 001.86.011a.995.995 0 00-.85 1.13l1.998 14c.07.5.5.86.989.86.05 0 .09 0 .14-.01a.995.995 0 00.849-1.13l-.87-6.08c1.349-.62 2.338-.56 3.177.21.809.74 1.698 1.03 2.596 1.03 1.908 0 3.816-1.32 4.804-2.31.25-.23.35-.56.29-.89zm-6.322.7c-1.328-1.22-2.946-1.49-4.824-.79l-.57-4.02c.59-.36 2.558-1.38 4.046-.01 1.678 1.55 3.525 1.38 5.003.57l.61 3.36c-.84.7-2.907 2.14-4.265.89z"
  })
}));

/**
UiFlashOffFilled icon

```jsx
import { UiFlashOffFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFlashOffFilled />
```

 */
const UiFlashOffFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M9.76 18.48l-.73 3.3c-.1.46.13.93.56 1.12.13.06.28.09.42.09.31 0 .61-.14.8-.4l9-12a.996.996 0 00-.59-1.57l-9.46 9.46zM21.71 3.71A.996.996 0 1020.3 2.3l-6.08 6.08.78-6.25a.988.988 0 00-.6-1.04.993.993 0 00-1.17.29l-9 11c-.24.3-.29.71-.13 1.06.17.35.52.57.9.57h3.59L2.3 20.3a.996.996 0 101.41 1.41l18-18z"
  })
}));

/**
UiFlashOffFilledSmall icon

```jsx
import { UiFlashOffFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFlashOffFilledSmall />
```

 */
const UiFlashOffFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M6.31 13.08l-.29 1.76a.995.995 0 001.78.76l6-8a.996.996 0 00-.48-1.54l-7.01 7.02zm8.4-10.37c.07-.07.1-.14.15-.22a.97.97 0 00-.15-1.19.996.996 0 00-1.41 0L9.31 5.29 10 1.17A.995.995 0 008.22.41l-6 8c-.23.3-.26.71-.09 1.05a1 1 0 00.89.55h1.59L1.32 13.3a.996.996 0 00.71 1.7 1 1 0 00.49-.15c.08-.04.16-.08.22-.15L14.71 2.71z"
  })
}));

/**
UiFlashOnFilled icon

```jsx
import { UiFlashOnFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFlashOnFilled />
```

 */
const UiFlashOnFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M19.89 9.55A.988.988 0 0019 9h-4.87l.86-6.88a.988.988 0 00-.6-1.04c-.41-.17-.88-.06-1.17.29l-9 11c-.24.3-.29.71-.13 1.06.17.35.52.57.9.57h5.75l-1.73 7.78c-.1.46.13.93.56 1.12.13.06.28.09.42.09.31 0 .61-.14.8-.4l9-12c.24-.29.27-.7.1-1.04z"
  })
}));

/**
UiFlashOnFilledSmall icon

```jsx
import { UiFlashOnFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFlashOnFilledSmall />
```

 */
const UiFlashOnFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-flash-on-filled-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M13.892 6.55A.99.99 0 0013 6H9.175l.811-4.84A.997.997 0 008.205.4L2.2 8.4c-.23.3-.26.71-.09 1.05A1 1 0 003 10h3.825l-.811 4.84a.995.995 0 00.98 1.16c.311 0 .612-.14.802-.4l6.006-8c.23-.3.26-.71.09-1.05z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-flash-on-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiFolderAddFilled icon

```jsx
import { UiFolderAddFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFolderAddFilled />
```

 */
const UiFolderAddFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M20 9c-3.9 0-7 3.1-7 7 0 1.1.3 2.1.7 3H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h4.6c.5 0 1 .2 1.4.6L11.4 5H20c1.1 0 2 .9 2 2v2.3c-.6-.2-1.3-.3-2-.3z"
  }), /*#__PURE__*/jsx("path", {
    d: "M21 13v2h2c.6 0 1 .4 1 1s-.4 1-1 1h-2v2c0 .6-.4 1-1 1s-1-.4-1-1v-2h-2c-.6 0-1-.4-1-1s.4-1 1-1h2v-2c0-.6.4-1 1-1s1 .4 1 1z"
  })]
}));

/**
UiFolderAddLined icon

```jsx
import { UiFolderAddLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFolderAddLined />
```

 */
const UiFolderAddLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M14 19H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h4.6c.5 0 1 .2 1.4.6L11.4 5H20c1.1 0 2 .9 2 2v2.5c0 .6-.4 1-1 1s-1-.4-1-1V7h-9c-.3 0-.5-.1-.7-.3L8.6 5H4v12h10c.6 0 1 .4 1 1s-.4 1-1 1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M21 13v2h2c.6 0 1 .4 1 1s-.4 1-1 1h-2v2c0 .6-.4 1-1 1s-1-.4-1-1v-2h-2c-.6 0-1-.4-1-1s.4-1 1-1h2v-2c0-.6.4-1 1-1s1 .4 1 1z"
  })]
}));

/**
UiFolderDeleteFilled icon

```jsx
import { UiFolderDeleteFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFolderDeleteFilled />
```

 */
const UiFolderDeleteFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M13 16c0-3.9 3.1-7 7-7 .7 0 1.4.1 2 .3V7c0-1.1-.9-2-2-2h-8.6L10 3.6c-.4-.4-.9-.6-1.4-.6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9.7c-.4-.9-.7-1.9-.7-3z"
  }), /*#__PURE__*/jsx("path", {
    d: "M22 15h-5v4c0 .6.4 1 1 1h3c.6 0 1-.4 1-1v-4zm.5-2c.3 0 .5.2.5.5s-.2.5-.5.5h-6c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H18s0-1 1-1h1c1 0 1 1 1 1h1.5z"
  })]
}));

/**
UiFolderDeleteLined icon

```jsx
import { UiFolderDeleteLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFolderDeleteLined />
```

 */
const UiFolderDeleteLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M14 17H4V5h4.6l1.7 1.7c.2.2.4.3.7.3h9v2.5c0 .6.4 1 1 1s1-.4 1-1V7c0-1.1-.9-2-2-2h-8.6L10 3.6c-.4-.4-.9-.6-1.4-.6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h10c.6 0 1-.4 1-1s-.4-1-1-1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M17 19c0 .6.4 1 1 1h3c.6 0 1-.4 1-1v-4h-5v4zm4-6h1.5c.3 0 .5.2.5.5s-.2.5-.5.5h-6c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H18s0-1 1-1h1c1 0 1 1 1 1z"
  })]
}));

/**
UiFolderDownloadFilled icon

```jsx
import { UiFolderDownloadFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFolderDownloadFilled />
```

 */
const UiFolderDownloadFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M20 9c-3.9 0-7 3.1-7 7 0 1.1.3 2.1.7 3H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h4.6c.5 0 1 .2 1.4.6L11.4 5H20c1.1 0 2 .9 2 2v2.3c-.6-.2-1.3-.3-2-.3z"
  }), /*#__PURE__*/jsx("path", {
    d: "M20 20c-.2 0-.5-.1-.7-.3l-2-2c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l.4.4L19 13c0-.5.5-1 1-1s1 .4 1 1l-.1 3.7.4-.4c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-2 2c-.2.2-.5.3-.7.3z"
  })]
}));

/**
UiFolderDownloadLined icon

```jsx
import { UiFolderDownloadLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFolderDownloadLined />
```

 */
const UiFolderDownloadLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-folder-download-lined-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M15 19H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h4.6c.5 0 1 .2 1.4.6L11.4 5H20c1.1 0 2 .9 2 2v2c0 .6-.4 1-1 1s-1-.4-1-1V7h-9c-.3 0-.5-.1-.7-.3L8.6 5H4v12h11c.6 0 1 .4 1 1s-.4 1-1 1zm7.3-2.7c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-2 2c-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3l-2-2c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l.4.4L20 13c0-.5.5-1 1-1s1 .4 1 1l-.1 3.7.4-.4z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-folder-download-lined-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z"
      })
    })
  })]
}));

/**
UiFolderFilled icon

```jsx
import { UiFolderFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFolderFilled />
```

 */
const UiFolderFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 5h-8.6L10 3.6c-.4-.4-.9-.6-1.4-.6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2z"
  })
}));

/**
UiFolderFilledSmall icon

```jsx
import { UiFolderFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFolderFilledSmall />
```

 */
const UiFolderFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14 4H8.4L6.7 2.3C6.5 2.1 6.3 2 6 2H2c-.6 0-1 .4-1 1v10c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1z"
  })
}));

/**
UiFolderLevelDownFilled icon

```jsx
import { UiFolderLevelDownFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFolderLevelDownFilled />
```

 */
const UiFolderLevelDownFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M13.5 19H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h4.6c.5 0 1 .2 1.4.6L11.4 5H20c1.1 0 2 .9 2 2v3.5c-.8-.3-1.6-.5-2.5-.5-3.6 0-6.5 2.9-6.5 6.5 0 .9.2 1.7.5 2.5z"
  }), /*#__PURE__*/jsx("path", {
    d: "M21.7 14.3l2 2c.4.4.4 1 0 1.4l-2 2c-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l.3-.3H17c-.6 0-1-.4-1-1v-2c0-.6.4-1 1-1s1 .4 1 1v1h2.6l-.3-.3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0z"
  })]
}));

/**
UiFolderLevelDownLined icon

```jsx
import { UiFolderLevelDownLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFolderLevelDownLined />
```

 */
const UiFolderLevelDownLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11 19H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h4.6c.5 0 1 .2 1.4.6L11.4 5H20c1.1 0 2 .9 2 2v5c0 .6-.4 1-1 1s-1-.4-1-1V7h-9c-.3 0-.5-.1-.7-.3L8.6 5H4v12h7c.6 0 1 .4 1 1s-.4 1-1 1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M20.7 15.3l2 2c.4.4.4 1 0 1.2l-2 2c-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l.4-.4-4.7.1c-.6 0-1-.4-1-.9v-2c0-.5.4-1 1-1 .5 0 1 .4 1 1V17l3.7.1-.4-.4c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0z"
  })]
}));

/**
UiFolderLined icon

```jsx
import { UiFolderLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFolderLined />
```

 */
const UiFolderLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 5h-8.6L10 3.6c-.4-.4-.9-.6-1.4-.6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM4 17V5h4.6l1.7 1.7c.2.2.4.3.7.3h9v10H4z"
  })
}));

/**
UiFolderLinedSmall icon

```jsx
import { UiFolderLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFolderLinedSmall />
```

 */
const UiFolderLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14 4H8.4L6.7 2.3C6.5 2.1 6.3 2 6 2H2c-.6 0-1 .4-1 1v10c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1zm-1 8H3V4h2.6l1.7 1.7c.2.2.4.3.7.3h5v6z"
  })
}));

/**
UiFolderMoveRightFilled icon

```jsx
import { UiFolderMoveRightFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFolderMoveRightFilled />
```

 */
const UiFolderMoveRightFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M13.7 19H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h4.6c.5 0 1 .2 1.4.6L11.4 5H20c1.1 0 2 .9 2 2v3c-.8-.3-1.6-.5-2.5-.5-3.6 0-6.5 2.9-6.5 6.5 0 1.1.2 2.1.7 3z"
  }), /*#__PURE__*/jsx("path", {
    d: "M19.7 16.9L16 17c-.6 0-1-.4-1-1 0-.5.4-1 1-1l3.7.1-.4-.4c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l2 2c.4.4.4 1 0 1.4l-2 2c-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l.4-.4z"
  })]
}));

/**
UiFolderMoveRightLined icon

```jsx
import { UiFolderMoveRightLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFolderMoveRightLined />
```

 */
const UiFolderMoveRightLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12.5 19H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h4.6c.5 0 1 .2 1.4.6L11.4 5H20c1.1 0 2 .9 2 2v3c0 .6-.4 1-1 1s-1-.4-1-1V7h-9c-.3 0-.5-.1-.7-.3L8.6 5H4v12h8.5c.6 0 1 .4 1 1s-.4 1-1 1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M20.7 13.3l2 2c.4.4.4 1 0 1.4l-2 2c-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l.4-.4-3.7.1c-.5 0-1-.4-1-1 0-.5.4-1 1-1l3.7.1-.4-.4c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0z"
  })]
}));

/**
UiFolderUploadFilled icon

```jsx
import { UiFolderUploadFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFolderUploadFilled />
```

 */
const UiFolderUploadFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M20 9c-3.9 0-7 3.1-7 7 0 1.1.3 2.1.7 3H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h4.6c.5 0 1 .2 1.4.6L11.4 5H20c1.1 0 2 .9 2 2v2.3c-.6-.2-1.3-.3-2-.3z"
  }), /*#__PURE__*/jsx("path", {
    d: "M20.7 12.3l2 2c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3l-.4-.4.1 3.7c0 .5-.5 1-1 1s-1-.4-1-1l.1-3.7-.4.4c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l2-2c.4-.4 1-.4 1.4 0z"
  })]
}));

/**
UiFolderUploadLined icon

```jsx
import { UiFolderUploadLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFolderUploadLined />
```

 */
const UiFolderUploadLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsxs("g", {
    clipPath: "url(#omni-gravity-icon-ui-folder-upload-lined-a)",
    children: [/*#__PURE__*/jsx("path", {
      d: "M17 18c0 .6-.4 1-1 1H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h4.6c.5 0 1 .2 1.4.6L11.4 5H20c1.1 0 2 .9 2 2v2c0 .6-.4 1-1 1s-1-.4-1-1V7h-9c-.3 0-.5-.1-.7-.3L8.6 5H4v12h12c.6 0 1 .4 1 1z"
    }), /*#__PURE__*/jsx("path", {
      d: "M18.3 14.3l2-2c.4-.4 1-.4 1.4 0l2 2c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3l-.4-.4.1 3.7c0 .5-.5 1-1 1s-1-.4-1-1l.1-3.7-.4.4c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4z"
    })]
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-folder-upload-lined-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z"
      })
    })
  })]
}));

/**
UiFraudFilled icon

```jsx
import { UiFraudFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFraudFilled />
```

 */
const UiFraudFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22.9 11.497c-.3-.5-.9-.6-1.4-.3 0 0-.2.1-.5.3v-3.9c0-.9-.4-1.8-1.2-2.4-.7-.6-1.7-.8-2.6-.5l-5.2 1.3-5.3-1.3c-.9-.2-1.8 0-2.6.5-.7.6-1.1 1.5-1.1 2.4v3.9c-.3-.2-.5-.3-.5-.3-.5-.3-1.1-.1-1.4.3-.2.5-.1 1.1.4 1.4.1 0 .7.4 1.7.9-.1.4-.2.8-.2 1.2 0 2.8 2.2 5 5 5 1.6 0 3.1-.8 4-2 .9 1.2 2.4 2 4 2 2.8 0 5-2.2 5-5 0-.4-.1-.8-.2-1.3 1-.5 1.6-.8 1.7-.9.5-.2.6-.8.4-1.3zM8 17.997c-1.7 0-3-1.3-3-3v-.5c1.6.6 3.7 1.2 5.8 1.4-.4 1.3-1.5 2.1-2.8 2.1zm11-3c0 1.7-1.3 3-3 3-1.3 0-2.4-.9-2.8-2.1 2.1-.2 4.2-.8 5.8-1.4v.5z"
  })
}));

/**
UiFraudLined icon

```jsx
import { UiFraudLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFraudLined />
```

 */
const UiFraudLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22.9 11.497c-.3-.5-.9-.6-1.4-.3 0 0-.2.1-.5.3v-3.9c0-.9-.4-1.8-1.2-2.4-.7-.6-1.7-.8-2.6-.5l-5.2 1.3-5.3-1.3c-.9-.2-1.8 0-2.6.5-.7.6-1.1 1.5-1.1 2.4v3.9c-.3-.2-.5-.3-.5-.3-.5-.3-1.1-.1-1.4.3-.2.5-.1 1.1.4 1.4.1 0 .7.4 1.7.9-.1.4-.2.8-.2 1.2 0 2.8 2.2 5 5 5 1.6 0 3.1-.8 4-2 .9 1.2 2.4 2 4 2 2.8 0 5-2.2 5-5 0-.4-.1-.8-.2-1.3 1-.5 1.6-.8 1.7-.9.5-.2.6-.8.4-1.3zm-17.5-4.7c.2-.2.5-.2.8-.2l5.5 1.4h.5l5.6-1.4c.3-.1.6 0 .9.2.2.2.3.5.3.8v3.4H5v-3.4c0-.3.1-.6.4-.8zm2.6 11.2c-1.7 0-3-1.3-3-3v-.5c1.6.6 3.7 1.2 5.8 1.4-.4 1.3-1.5 2.1-2.8 2.1zm11-3c0 1.7-1.3 3-3 3-1.3 0-2.4-.9-2.8-2.1 2.1-.2 4.2-.8 5.8-1.4v.5z"
  })
}));

/**
UiFraudLinedSmall icon

```jsx
import { UiFraudLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFraudLinedSmall />
```

 */
const UiFraudLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-fraud-lined-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M16 8.2c-.2-.5-.7-.8-1.2-.7l-.8.2V4.5c0-.8-.4-1.5-1-2s-1.4-.6-2.2-.4L8 2.9l-2.8-.8c-.7-.2-1.6-.1-2.2.4-.6.5-1 1.2-1 2v3.2l-.7-.2c-.6-.1-1.1.2-1.3.7-.2.5.2 1.1.7 1.2l1.5.4c-.1.4-.2.8-.2 1.2 0 1.9 1.6 3.5 3.5 3.5 1 0 1.9-.4 2.5-1.1.6.7 1.5 1.1 2.5 1.1 1.9 0 3.5-1.6 3.5-3.5 0-.4-.1-.8-.2-1.1l1.5-.4c.5-.2.8-.8.7-1.3zM4.2 4.1c.1-.1.2-.1.4-.1l3.1.9c.2.1.4.1.6 0l3.1-.9c.2-.1.4 0 .4.1.1.1.2.2.2.4v2H4v-2c0-.2.1-.3.2-.4zm1.3 8.4c-.8 0-1.5-.7-1.5-1.5 0-.2 0-.4.1-.6l2.9.8c-.1.7-.8 1.3-1.5 1.3zM12 11c0 .8-.7 1.5-1.5 1.5-.7 0-1.4-.5-1.5-1.3l2.9-.8c.1.2.1.4.1.6z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-fraud-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiFuelPumpFilled icon

```jsx
import { UiFuelPumpFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFuelPumpFilled />
```

 */
const UiFuelPumpFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22.3 5.94l-3.15-2.7a1 1 0 10-1.3 1.52L20.46 7H20a1 1 0 00-1 1v2a.999.999 0 00.4.8L21 12v4a1 1 0 01-2 0v-2a3 3 0 00-3-3h-1V4a2 2 0 00-2-2H5a2 2 0 00-2 2v16H2a1 1 0 000 2h14a1 1 0 000-2h-1v-7h1a1 1 0 011 1v2a3 3 0 006 0V7.46a2 2 0 00-.7-1.52zM13 12H5V7h8v5z"
  })
}));

/**
UiFuelPumpLined icon

```jsx
import { UiFuelPumpLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiFuelPumpLined />
```

 */
const UiFuelPumpLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22.3 5.94l-3.15-2.7a1 1 0 10-1.3 1.52L20.46 7H20a1 1 0 00-1 1v2a.999.999 0 00.4.8L21 12v4a1 1 0 01-2 0v-2a3 3 0 00-3-3h-1V4a2 2 0 00-2-2H5a2 2 0 00-2 2v16H2a1 1 0 000 2h14a1 1 0 000-2h-1v-7h1a1 1 0 011 1v2a3 3 0 006 0V7.46a2 2 0 00-.7-1.52zM5 8h8v3H5V8zm8-4v2H5V4h8zM5 20v-7h8v7H5z"
  })
}));

/**
UiGalleryFilled icon

```jsx
import { UiGalleryFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiGalleryFilled />
```

 */
const UiGalleryFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 .75.42 1.4 1.04 1.74.28.16.61.26.96.26h16c.42 0 .81-.13 1.14-.36.52-.36.86-.96.86-1.64V6c0-1.1-.9-2-2-2zM9 9c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-5 9l3.25-3.66c.19-.21.45-.33.72-.34.27-.01.54.1.74.29l2.21 2.21 3.3-4.13c.19-.24.53-.37.8-.37.31.01.6.16.79.41L19.93 18H4z"
  })
}));

/**
UiGalleryFilledSmall icon

```jsx
import { UiGalleryFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiGalleryFilledSmall />
```

 */
const UiGalleryFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M1 14h14c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1zm5-8.5C6 6.33 5.33 7 4.5 7S3 6.33 3 5.5 3.67 4 4.5 4 6 4.67 6 5.5zM4.23 9.36c.18-.22.44-.35.73-.36.28-.02.55.09.75.29L7 10.59 9.29 8.3c.2-.2.47-.3.74-.3.28.01.54.13.72.34L13.99 12H2.03l2.2-2.64z"
  })
}));

/**
UiGalleryLined icon

```jsx
import { UiGalleryLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiGalleryLined />
```

 */
const UiGalleryLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 2v10.59l-3.92-3.92c-.29-.29-.7-.45-1.1-.44-.41.01-.8.2-1.08.5l-3 3.38-1.91-1.59c-.6-.5-1.47-.46-2.02.09L4 17.59V6h16z"
  }), /*#__PURE__*/jsx("path", {
    d: "M8 12a2 2 0 100-4 2 2 0 000 4z"
  })]
}));

/**
UiGalleryLinedSmall icon

```jsx
import { UiGalleryLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiGalleryLinedSmall />
```

 */
const UiGalleryLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M1 14h14c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1zM14 4v7.59L10.71 8.3a.996.996 0 00-1.41 0L7 10.59l-1.29-1.3a.996.996 0 00-1.41 0L2 11.59V4h12z"
  }), /*#__PURE__*/jsx("path", {
    d: "M5.5 8a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  })]
}));

/**
UiGaugeHighFilled icon

```jsx
import { UiGaugeHighFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiGaugeHighFilled />
```

 */
const UiGaugeHighFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 2a10 10 0 100 20 10 10 0 000-20zm3.54 5.05a1 1 0 111.418 1.41 1 1 0 01-1.418-1.41zM12 5a1 1 0 110 2 1 1 0 010-2zm-6 8a1 1 0 110-2 1 1 0 010 2zm2.46 4a1 1 0 11-1.418-1.41A1 1 0 018.46 17zm0-8.49a1 1 0 110-1.41 1 1 0 010 1.36v.05zM17 17a1 1 0 01-.71.29 1 1 0 01-.6-.2l-4.86-3.62A1.88 1.88 0 0110 12a1.89 1.89 0 012.764-1.79c.236.124.443.298.606.51L17 15.64A1 1 0 0117 17zm1-4a1 1 0 110-2 1 1 0 010 2z"
  })
}));

/**
UiGaugeHighFilledSmall icon

```jsx
import { UiGaugeHighFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiGaugeHighFilledSmall />
```

 */
const UiGaugeHighFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-gauge-high-filled-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M8 0a8 8 0 100 16A8 8 0 008 0zm3.54 11.54a1 1 0 01-1.25.13L6.83 9.46A1.93 1.93 0 016 8a1.89 1.89 0 012.764-1.79c.236.124.443.298.606.51l2.27 3.53a1 1 0 01-.1 1.29z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-gauge-high-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiGaugeHighLined icon

```jsx
import { UiGaugeHighLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiGaugeHighLined />
```

 */
const UiGaugeHighLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M13.4 10.76A1.85 1.85 0 0012 10a1.89 1.89 0 00-1.26 3.39l4.9 3.61a1 1 0 001.4-1.4l-3.64-4.84z"
  }), /*#__PURE__*/jsx("path", {
    d: "M12 2a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16.001A8 8 0 0112 20z"
  }), /*#__PURE__*/jsx("path", {
    d: "M18 13a1 1 0 100-2 1 1 0 000 2zm-6-6a1 1 0 100-2 1 1 0 000 2zm5 1.46a1 1 0 10-1.41-1.418A1 1 0 0017 8.46zm-9.95 7.08a1 1 0 101.41 1.418 1 1 0 00-1.41-1.418zm0-8.49a1 1 0 101.41 1.418A1 1 0 007.05 7.05zM6 13a1 1 0 100-2 1 1 0 000 2z"
  })]
}));

/**
UiGaugeHighLinedSmall icon

```jsx
import { UiGaugeHighLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiGaugeHighLinedSmall />
```

 */
const UiGaugeHighLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsxs("g", {
    clipPath: "url(#omni-gravity-icon-ui-gauge-high-lined-small-a)",
    children: [/*#__PURE__*/jsx("path", {
      d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 14A6 6 0 118 2a6 6 0 010 12z"
    }), /*#__PURE__*/jsx("path", {
      d: "M9.4 6.76A1.85 1.85 0 008 6a1.89 1.89 0 00-2 2 1.93 1.93 0 00.79 1.43l3.46 2.21a1 1 0 001.536-.732 1 1 0 00-.156-.648L9.4 6.76z"
    })]
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-gauge-high-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiGaugeLowFilled icon

```jsx
import { UiGaugeLowFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiGaugeLowFilled />
```

 */
const UiGaugeLowFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 2a10 10 0 100 20 10 10 0 000-20zm3.54 5.05a1 1 0 111.418 1.41 1 1 0 01-1.418-1.41zM12 5a1 1 0 110 2 1 1 0 010-2zM7.05 7.05a1 1 0 111.418 1.41A1 1 0 017.05 7.05zM6 13a1 1 0 110-2 1 1 0 010 2zm7.24.4L8.36 17a1 1 0 01-1.4-1.4l3.62-4.86A1.879 1.879 0 0112 10a1.79 1.79 0 011.44.55A1.81 1.81 0 0114 12a1.85 1.85 0 01-.76 1.4zM17 17a1 1 0 11-1.418-1.41A1 1 0 0117 17zm1-4a1 1 0 110-2 1 1 0 010 2z"
  })
}));

/**
UiGaugeLowFilledSmall icon

```jsx
import { UiGaugeLowFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiGaugeLowFilledSmall />
```

 */
const UiGaugeLowFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-gauge-low-filled-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M8 0a8 8 0 100 16A8 8 0 008 0zm1.24 9.4l-3.53 2.27a1 1 0 01-1.536-.732 1 1 0 01.156-.648l2.21-3.46A1.93 1.93 0 018 6a1.78 1.78 0 011.44.55A1.81 1.81 0 0110 8a1.85 1.85 0 01-.76 1.4z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-gauge-low-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiGaugeLowLined icon

```jsx
import { UiGaugeLowLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiGaugeLowLined />
```

 */
const UiGaugeLowLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12 2a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16.001A8 8 0 0112 20z"
  }), /*#__PURE__*/jsx("path", {
    d: "M6 13a1 1 0 100-2 1 1 0 000 2zm6-6a1 1 0 100-2 1 1 0 000 2zM8.46 8.46a1 1 0 10-1.41-1.418A1 1 0 008.46 8.46zm7.08 7.08a1 1 0 101.41 1.418 1 1 0 00-1.41-1.418zM17 8.46a1 1 0 10-1.41-1.418A1 1 0 0017 8.46zM18 13a1 1 0 100-2 1 1 0 000 2zm-6-3a1.88 1.88 0 00-1.39.74L7 15.64a1 1 0 001.4 1.4l4.88-3.64A1.85 1.85 0 0014 12a1.81 1.81 0 00-.55-1.44A1.79 1.79 0 0012 10z"
  })]
}));

/**
UiGaugeLowLinedSmall icon

```jsx
import { UiGaugeLowLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiGaugeLowLinedSmall />
```

 */
const UiGaugeLowLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsxs("g", {
    clipPath: "url(#omni-gravity-icon-ui-gauge-low-lined-small-a)",
    children: [/*#__PURE__*/jsx("path", {
      d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 14A6 6 0 118 2a6 6 0 010 12z"
    }), /*#__PURE__*/jsx("path", {
      d: "M8 6a1.93 1.93 0 00-1.43.79l-2.24 3.5a1 1 0 00.456 1.466 1 1 0 00.924-.086L9.24 9.4A1.85 1.85 0 0010 8a1.81 1.81 0 00-.55-1.44A1.78 1.78 0 008 6z"
    })]
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-gauge-low-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiGaugeMediumFilled icon

```jsx
import { UiGaugeMediumFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiGaugeMediumFilled />
```

 */
const UiGaugeMediumFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 2a10 10 0 100 20 10 10 0 000-20zm3.54 5.05a1 1 0 111.418 1.41 1 1 0 01-1.418-1.41zM6 13a1 1 0 110-2 1 1 0 010 2zm2.46 4a1 1 0 11-1.418-1.41A1 1 0 018.46 17zm0-8.49a1 1 0 110-1.41 1 1 0 010 1.36v.05zm4.95 4.9a1.87 1.87 0 01-2.82 0 1.89 1.89 0 01-.46-1.48l.88-6a1 1 0 012 0l.88 6a1.91 1.91 0 01-.48 1.43v.05zM17 17a1 1 0 11-1.418-1.41A1 1 0 0117 17zm1-4a1 1 0 110-2 1 1 0 010 2z"
  })
}));

/**
UiGaugeMediumFilledSmall icon

```jsx
import { UiGaugeMediumFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiGaugeMediumFilledSmall />
```

 */
const UiGaugeMediumFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-gauge-medium-filled-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M8 0a8 8 0 100 16A8 8 0 008 0zm1.41 9.36a1.87 1.87 0 01-2.82 0 1.89 1.89 0 01-.46-1.48L7 3.79a1 1 0 012 0l.87 4a1.91 1.91 0 01-.46 1.57z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-gauge-medium-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiGaugeMediumLined icon

```jsx
import { UiGaugeMediumLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiGaugeMediumLined />
```

 */
const UiGaugeMediumLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12 2a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16.001A8 8 0 0112 20z"
  }), /*#__PURE__*/jsx("path", {
    d: "M6 13a1 1 0 100-2 1 1 0 000 2zm1.05-5.95a1 1 0 101.41 1.418A1 1 0 007.05 7.05zm8.49 8.49a1 1 0 101.41 1.418 1 1 0 00-1.41-1.418zM17 8.46a1 1 0 10-1.41-1.418A1 1 0 0017 8.46zM18 13a1 1 0 100-2 1 1 0 000 2zm-5-7.14a1 1 0 00-2 0l-.88 6a1.89 1.89 0 00.46 1.48 1.87 1.87 0 002.82 0 1.91 1.91 0 00.46-1.5L13 5.86zm-5.95 9.68a1 1 0 101.41 1.418 1 1 0 00-1.41-1.418z"
  })]
}));

/**
UiGaugeMediumLinedSmall icon

```jsx
import { UiGaugeMediumLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiGaugeMediumLinedSmall />
```

 */
const UiGaugeMediumLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsxs("g", {
    clipPath: "url(#omni-gravity-icon-ui-gauge-medium-lined-small-a)",
    children: [/*#__PURE__*/jsx("path", {
      d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 14A6 6 0 118 2a6 6 0 010 12z"
    }), /*#__PURE__*/jsx("path", {
      d: "M9 3.79a1 1 0 10-2 0l-.87 4.09a1.89 1.89 0 00.46 1.48 1.87 1.87 0 003.216-.736 1.91 1.91 0 00.044-.834l-.85-4z"
    })]
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-gauge-medium-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiGithubLined icon

```jsx
import { UiGithubLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiGithubLined />
```

 */
const UiGithubLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM3 12a9 9 0 1111.01 8.775V14.82c0-.67-.22-1.16-.66-1.47.28-.02.53-.06.76-.11.23-.05.47-.12.73-.21.25-.09.49-.2.69-.33.21-.13.4-.29.59-.5.18-.21.34-.44.47-.7a4 4 0 00.3-.94c.07-.37.11-.77.11-1.21 0-.85-.26-1.57-.8-2.17.24-.66.22-1.38-.08-2.15l-.2-.03c-.13-.02-.38.04-.74.18-.36.14-.76.37-1.21.68-.64-.18-1.29-.27-1.97-.27-.69 0-1.34.09-1.96.27-.28-.2-.55-.36-.8-.49-.26-.12-.46-.21-.61-.26-.15-.05-.29-.08-.42-.09-.13-.01-.21-.01-.25-.01l-.038.008a.154.154 0 00-.042.012c-.3.78-.32 1.49-.08 2.15-.53.59-.8 1.32-.8 2.17 0 .44.03.84.12 1.22.07.37.17.68.3.94.12.26.28.49.47.7.19.2.39.37.59.5.2.13.43.24.69.33.26.09.5.16.73.21.23.04.48.08.76.11-.43.31-.65.8-.65 1.47v5.95A9.003 9.003 0 013 12z"
  })
}));

/**
UiGithubLinedSmall icon

```jsx
import { UiGithubLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiGithubLinedSmall />
```

 */
const UiGithubLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0a8 8 0 100 16A8 8 0 008 0zM2 8a6 6 0 117.42 5.831V10.29c0-.46-.15-.79-.46-1.01.19-.02.37-.05.53-.08.16-.04.33-.09.51-.15s.34-.14.48-.23a2.182 2.182 0 00.74-.83c.09-.18.16-.4.21-.65.05-.25.08-.53.08-.83 0-.58-.18-1.08-.56-1.49.17-.45.15-.95-.06-1.48l-.14-.02c-.1-.02-.27.03-.52.12s-.53.24-.84.46a5.094 5.094 0 00-2.75 0c-.2-.14-.38-.25-.56-.34-.17-.09-.31-.15-.42-.18-.11-.03-.21-.05-.3-.06-.1-.01-.15-.01-.18-.01a.163.163 0 00-.045.007.068.068 0 01-.015.003c-.21.54-.23 1.03-.06 1.48-.37.41-.56.91-.56 1.49 0 .31.03.58.1.82.05.26.12.47.21.65.09.18.2.34.33.48.13.15.27.26.41.35.14.09.3.17.48.23.18.07.35.12.51.15.16.03.34.06.53.08-.31.21-.46.55-.46 1.01v3.578A6.003 6.003 0 012 8z"
  })
}));

/**
UiGlobeLined icon

```jsx
import { UiGlobeLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiGlobeLined />
```

 */
const UiGlobeLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C5.926 1 1 5.925 1 12s4.925 11 11 11c6.076 0 11.002-4.925 11.002-11S18.076 1 12 1zm-.211 2.002L12 3a9 9 0 011.114 17.932l5.113-4.362-.089-.96-1.792-1.06-.139-.98-3.04-1.76-1.109 1.1-2.396-2.04.05-.82-1.07-.05.03-1.24 1.832-.02.505.91.534.05-.02-1.15L14.565 6l-.227-.66-1.347-1.01-.564-.04-.09.75-1.02-.57.189-.51.284-.958zm-5.335 1.91a9.001 9.001 0 004.863 16.063l.693-3.165-1.485-1.36.02-2.51.772-.63-5.575-4.08V6.21l1.02-.78-.308-.518z"
  })
}));

/**
UiGlobeLinedSmall icon

```jsx
import { UiGlobeLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiGlobeLinedSmall />
```

 */
const UiGlobeLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0a8 8 0 100 16A8 8 0 008 0zm-.148 2.002L8 2a6 6 0 011.372 11.842L12.51 11.2l-.06-.68-1.27-.73-.1-.69-2.16-1.23-.79.77-1.69-1.43.03-.57-.75-.04.01-.87 1.3-.01.36.64.38.03-.01-.8L9.91 3.8l-.16-.46-.96-.71-.39-.03-.07.53-.72-.4.13-.36.112-.367zM3.66 3.857a6 6 0 004.012 10.134L8.1 12.07l-1.05-.96.01-1.75.55-.44-3.95-2.86V3.857z"
  })
}));

/**
UiGridFilled icon

```jsx
import { UiGridFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiGridFilled />
```

 */
const UiGridFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M4 3h6c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1H4c-.6 0-1-.4-1-1V4c0-.6.4-1 1-1zm10 0h6c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1V4c0-.6.4-1 1-1zm-4 10H4c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h6c.6 0 1-.4 1-1v-6c0-.6-.4-1-1-1zm4 0h6c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1v-6c0-.6.4-1 1-1z"
  })
}));

/**
UiGridFilledSmall icon

```jsx
import { UiGridFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiGridFilledSmall />
```

 */
const UiGridFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14 1h-4c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h4c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zm0 8h-4c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-4c0-.6-.4-1-1-1zM6 9H2c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-4c0-.6-.4-1-1-1zm0-8H2c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h4c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1z"
  })
}));

/**
UiGridLined icon

```jsx
import { UiGridLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiGridLined />
```

 */
const UiGridLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3h6c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1H4c-.6 0-1-.4-1-1V4c0-.6.4-1 1-1zm1 6h4V5H5v4zm9-6h6c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1V4c0-.6.4-1 1-1zm1 6h4V5h-4v4zm-5 4H4c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h6c.6 0 1-.4 1-1v-6c0-.6-.4-1-1-1zm-1 6H5v-4h4v4zm5-6h6c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1v-6c0-.6.4-1 1-1zm1 6h4v-4h-4v4z"
  })
}));

/**
UiGridLinedSmall icon

```jsx
import { UiGridLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiGridLinedSmall />
```

 */
const UiGridLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14 1h-4c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h4c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zm-1 4h-2V3h2v2zm1 4h-4c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-4c0-.6-.4-1-1-1zm-1 4h-2v-2h2v2zM6 9H2c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-4c0-.6-.4-1-1-1zm-1 4H3v-2h2v2zM6 1H2c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h4c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zM5 5H3V3h2v2z"
  })
}));

/**
UiHandbookLined icon

```jsx
import { UiHandbookLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiHandbookLined />
```

 */
const UiHandbookLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M10.5 7H16c.6 0 1 .4 1 1s-.4 1-1 1h-5.5c-.6 0-1-.4-1-1s.4-1 1-1zm5.5 4h-5.5c-.6 0-1 .4-1 1s.4 1 1 1H16c.6 0 1-.4 1-1s-.4-1-1-1zm-5.5 4H14c.6 0 1 .4 1 1s-.4 1-1 1h-3.5c-.6 0-1-.4-1-1s.4-1 1-1z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3h13c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2v-2h-.5c-.6 0-1-.4-1-1s.4-1 1-1H4v-2h-.5c-.6 0-1-.4-1-1s.4-1 1-1H4V9h-.5c-.6 0-1-.4-1-1s.4-1 1-1H4V5c0-1.1.9-2 2-2zm0 14v2h13V5H6v2h.5c.6 0 1 .4 1 1s-.4 1-1 1H6v2h.5c.6 0 1 .4 1 1s-.4 1-1 1H6v2h.5c.6 0 1 .4 1 1s-.4 1-1 1H6z"
  })]
}));

/**
UiHandbookLinedSmall icon

```jsx
import { UiHandbookLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiHandbookLinedSmall />
```

 */
const UiHandbookLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M6 7h4c.6 0 1-.4 1-1s-.4-1-1-1H6c-.6 0-1 .4-1 1s.4 1 1 1zm2 4H6c-.6 0-1-.4-1-1s.4-1 1-1h2c.6 0 1 .4 1 1s-.4 1-1 1z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 1H3c-.6 0-1 .4-1 1v1h-.5c-.6 0-1 .4-1 1s.4 1 1 1H2v2h-.5c-.6 0-1 .4-1 1s.4 1 1 1H2v2h-.5c-.6 0-1 .4-1 1s.4 1 1 1H2v1c0 .6.4 1 1 1h10c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zm-1 2v10H4V3h8z"
  })]
}));

/**
UiHandshakeFilled icon

```jsx
import { UiHandshakeFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiHandshakeFilled />
```

 */
const UiHandshakeFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M13.5 9l1.8-1.8 5.5 5.6c.3.4.5.8.6 1.3.1.6-.1 1.2-.5 1.6-.3.3-.8.5-1.3.5-.1 0-.2-.025-.3-.05-.1-.025-.2-.05-.3-.05.2.6 0 1.3-.4 1.7-.3.3-.7.5-1.2.5h-.3c-.2 0-.4-.1-.6-.2.1.5-.1 1-.4 1.3-.3.2-.7.4-1.1.4h-.4c-.4-.1-.8-.3-1.1-.6 0 .6-.1 1-.5 1.4-.3.3-.8.5-1.2.5-.6 0-1.2-.3-1.7-.8l-7.2-7.2C1.4 11.5.7 9.2 1.2 7 1.7 4.6 3.6 2.7 6 2.2c.5-.1 1-.2 1.4-.2 1.2 0 2.4.3 3.4.9L7.6 6.1c-.3.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.5 1.6 1.6 4.3 1.6 5.9 0z"
  }), /*#__PURE__*/jsx("path", {
    d: "M8.7 7.2l3.7-3.7C13.6 2.5 15 2 16.5 2c3.6 0 6.5 2.9 6.6 6.5 0 1.3-.4 2.4-1.1 3.3l-6.1-6.1c-.3-.3-.8-.3-1.1 0L12.5 8c-1.1 1-2.8 1-3.8 0-.2-.1-.2-.3-.2-.4 0-.2.1-.3.2-.4z"
  })]
}));

/**
UiHandshakeFilledSmall icon

```jsx
import { UiHandshakeFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiHandshakeFilledSmall />
```

 */
const UiHandshakeFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsxs("g", {
    clipPath: "url(#omni-gravity-icon-ui-handshake-filled-small-a)",
    children: [/*#__PURE__*/jsx("path", {
      d: "M9.6 7.5l.7-.6 3.6 3.6c.2.3.4.6.4 1 0 .8-.7 1.5-1.5 1.5a.773.773 0 01-.2-.05.773.773 0 00-.2-.05c.1.2.1.4.1.6 0 .8-.7 1.5-1.5 1.5-.6 0-1.1-.3-1.3-.8.2.9-.7 1.8-1.5 1.8-.61 0-1.045-.405-1.394-.732-.11-.102-.21-.196-.306-.268L1.4 9.6C.3 8.5-.2 6.9 0 5.3c.4-2.2 2.1-3.9 4.2-4.2 1-.2 2-.1 2.9.4.041 0 .083.018.131.038A.654.654 0 007.5 1.6L4.2 4.9c-.5.5-.5 1.3 0 1.8l.8.8c1.2 1.3 3.4 1.3 4.6 0z"
    }), /*#__PURE__*/jsx("path", {
      d: "M6.1 6.5l-.7-.7 3.8-3.9c.6-.3 1.3-.5 2-.5 2.7 0 4.8 2.2 4.8 4.8 0 1.2-.4 2.3-1.1 3.1l-4-4c-.3-.3-.8-.3-1.1 0L8.6 6.5c-.7.7-1.8.7-2.5 0z"
    })]
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-handshake-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiHandshakeLined icon

```jsx
import { UiHandshakeLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiHandshakeLined />
```

 */
const UiHandshakeLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M23 8.514a6.49 6.49 0 00-6.512-6.493c-1.703 0-3.306.6-4.508 1.798C10.377 2.32 8.173 1.72 5.97 2.12c-2.406.6-4.31 2.498-4.81 4.895-.5 2.198.2 4.495 1.703 6.094l7.213 7.192c.502.5 1.102.699 1.804.699.701 0 1.302-.3 1.803-.7.2-.199.3-.399.4-.599.301.1.602.2.902.2.702 0 1.303-.3 1.804-.699.3-.3.5-.6.6-.899h.301c.601 0 1.303-.2 1.804-.7.4-.399.6-.898.7-1.398.502-.1 1.003-.3 1.404-.699.5-.5.7-1.099.7-1.798 0-.5-.1-.999-.4-1.399C22.499 11.211 23 9.912 23 8.514zm-5.11 7.591c-.2.2-.5.2-.7 0l-2.01-1.995c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l1.506 1.494c.1.1.1.3.1.4 0 .1 0 .2-.1.4-.2.2-.5.2-.701 0l-1.002-1-.503-.494c-.4-.4-1-.4-1.4 0-.4.4-.4.99 0 1.39l.5.503c.2.2.2.5 0 .7-.1.1-.3.1-.4.1-.1 0-.2 0-.401-.1L4.166 11.71c-1.002-1.099-1.403-2.697-1.102-4.195.4-1.598 1.703-2.997 3.306-3.297 1.503-.3 3.005.1 4.107 1.1L7.973 7.913c-.802.8-.802 1.998 0 2.797.801.8 1.803 1.199 2.805 1.199 1.002 0 2.003-.4 2.805-1.199l1.903-1.898 4.508 4.495c.1.1.136.3.136.4 0 .1-.035.2-.136.4-.2.2-.5.2-.7 0L17.29 12.11c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l2 1.996c.201.1.201.4 0 .6zm3.106-7.591c0 .799-.2 1.598-.6 2.297l-4.108-4.095a.97.97 0 00-1.403 0l-2.604 2.597c-.802.799-2.004.799-2.806 0l3.908-3.896c.801-.8 2.003-1.299 3.205-1.299 2.405-.1 4.408 1.898 4.408 4.396z"
  })
}));

/**
UiHandshakeLinedSmall icon

```jsx
import { UiHandshakeLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiHandshakeLinedSmall />
```

 */
const UiHandshakeLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-handshake-lined-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M16 6c0-2.8-2.194-5-4.987-5-1.097 0-2.194.4-2.991 1-.3-.2-.599-.4-.898-.5-.898-.5-1.895-.6-2.892-.4-2.095.3-3.79 2-4.189 4.2-.2 1.6.3 3.2 1.396 4.3 0 0 5.286 5.5 5.286 5.6.499.3.997.6 1.596.6.997 0 1.795-.5 2.293-1.2 1.197 0 2.195-.8 2.494-1.9 1.097-.4 1.895-1.4 1.895-2.6 0-.3-.1-.6-.2-.9C15.601 8.1 16 7.1 16 6zm-8.178 7.3L2.935 8.1c-.698-.7-.997-1.6-.897-2.6.2-1.2 1.296-2.3 2.493-2.5.598-.1 1.197 0 1.695.2.1 0 .2.1.2.1L4.63 5.4c-.599.5-.599 1.5 0 2.1l.2.2c.697.7 1.495 1 2.492 1 .898 0 1.796-.4 2.494-1l.698-.7 2.393 2.4c.3.3.3.8 0 1.1-.1.1-.299.2-.498.2a.76.76 0 01-.499-.2l-.698-.7c-.2-.2-.499-.2-.698 0-.2.2-.2.5 0 .7l.698.7c.3.3.3.7 0 1-.1.1-.3.2-.499.2a.76.76 0 01-.498-.2l-.998-1c-.2-.2-.498-.2-.698 0-.2.2-.2.5 0 .7 0 0 .698.6.698 1s-.299.8-.798.8c-.199-.1-.398-.2-.598-.4zM14.005 6c0 .5-.1.9-.299 1.3l-2.393-2.5-.3-.2c-.399-.1-.797-.1-1.097.2L8.42 6.3c-.498.5-1.396.6-1.994.1l2.493-2.5c.499-.6 1.297-.9 2.094-.9 1.696 0 2.992 1.3 2.992 3z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-handshake-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiHashEncircledFilled icon

```jsx
import { UiHashEncircledFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiHashEncircledFilled />
```

 */
const UiHashEncircledFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M10.77 13h1.96l.5-2h-1.96z"
  }), /*#__PURE__*/jsx("path", {
    d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm4.25 9h-1.48l-.5 2h1.48c.41 0 .75.34.75.75s-.34.75-.75.75H13.9l-.42 1.68c-.08.34-.39.57-.73.57-.06 0-.12-.01-.18-.02-.4-.1-.65-.51-.55-.91l.33-1.32H10.4l-.42 1.68c-.08.34-.39.57-.73.57-.06 0-.12-.01-.18-.02-.4-.1-.65-.51-.55-.91l.33-1.32h-1.1c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.48l.5-2H8.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.85l.42-1.68a.75.75 0 111.46.36l-.33 1.32h1.95l.42-1.68c.1-.4.51-.64.91-.55.4.1.65.51.55.91l-.33 1.32h1.1c.41 0 .75.34.75.75s-.34.75-.75.75z"
  })]
}));

/**
UiHashEncircledFilledSmall icon

```jsx
import { UiHashEncircledFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiHashEncircledFilledSmall />
```

 */
const UiHashEncircledFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M6.77 9h1.96l.5-2H7.27z"
  }), /*#__PURE__*/jsx("path", {
    d: "M8 0C3.59 0 0 3.59 0 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm3.75 9c.41 0 .75.34.75.75s-.34.75-.75.75H9.9l-.42 1.68c-.08.34-.39.57-.73.57-.06 0-.12-.01-.18-.02-.4-.1-.65-.51-.55-.91l.33-1.32H6.4l-.42 1.68c-.08.34-.39.57-.73.57-.06 0-.12-.01-.18-.02-.4-.1-.65-.51-.55-.91l.33-1.32h-1.1c-.41 0-.75-.34-.75-.75S3.34 9 3.75 9h1.48l.5-2H4.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75H6.1l.42-1.68c.1-.4.51-.64.91-.55.4.1.65.51.55.91L7.65 5.5H9.6l.42-1.68c.1-.4.5-.64.91-.55.4.1.65.51.55.91l-.33 1.32h1.1c.41 0 .75.34.75.75s-.34.75-.75.75h-1.48l-.5 2h1.48z"
  })]
}));

/**
UiHashEncircledLined icon

```jsx
import { UiHashEncircledLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiHashEncircledLined />
```

 */
const UiHashEncircledLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
  }), /*#__PURE__*/jsx("path", {
    d: "M16.25 9.5h-1.1l.33-1.32c.1-.4-.14-.81-.55-.91-.4-.1-.81.14-.91.55L13.6 9.5h-1.95l.33-1.32c.1-.4-.14-.81-.55-.91-.41-.1-.81.14-.91.55L10.1 9.5H8.25c-.41 0-.75.34-.75.75s.34.75.75.75h1.48l-.5 2H7.75c-.41 0-.75.34-.75.75s.34.75.75.75h1.1l-.33 1.32c-.1.4.14.81.55.91.06.02.12.02.18.02.34 0 .64-.23.73-.57l.42-1.68h1.95l-.33 1.32c-.1.4.14.81.55.91.06.02.12.02.18.02.34 0 .64-.23.73-.57l.42-1.68h1.85c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-1.48l.5-2h1.48c.41 0 .75-.34.75-.75s-.34-.75-.75-.75zM12.73 13h-1.95l.5-2h1.95l-.5 2z"
  })]
}));

/**
UiHeartFilled icon

```jsx
import { UiHeartFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiHeartFilled />
```

 */
const UiHeartFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M16.5 2c-1.9 0-3.4 1.3-4.5 2.9C10.9 3.3 9.4 2 7.5 2 3.9 2 1 4.9 1 8.5c0 1.7.7 3.4 1.9 4.6l8.4 8.4c.2.2.5.3.7.3.3 0 .5-.1.7-.3l7.8-7.7c1.7-1.7 2.5-3.4 2.5-5.2C23 4.9 20.1 2 16.5 2z"
  })
}));

/**
UiHeartFilledSmall icon

```jsx
import { UiHeartFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiHeartFilledSmall />
```

 */
const UiHeartFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M11.4 1C10 1 8.8 2.1 8 3.2 7.2 2.1 6 1 4.6 1 2.1 1 0 3.2 0 5.9c0 1.3.5 2.5 1.4 3.5l5.9 5.4c.2.1.5.2.7.2.2 0 .5-.1.7-.3l5.5-5C15.4 8.5 16 7.2 16 5.9 16 3.2 13.9 1 11.4 1z"
  })
}));

/**
UiHeartLined icon

```jsx
import { UiHeartLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiHeartLined />
```

 */
const UiHeartLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 21.8c-.3 0-.5-.1-.7-.3l-8.4-8.4C1.7 11.9 1 10.2 1 8.5 1 4.9 3.9 2 7.5 2c2 0 3.5 1.1 4.5 2.5C13 3.1 14.5 2 16.5 2 20.1 2 23 4.9 23 8.5c0 1.8-.9 3.6-2.5 5.2l-7.8 7.7c-.2.3-.5.4-.7.4zM7.5 4C5 4 3 6 3 8.5c0 1.2.5 2.3 1.3 3.2l7.7 7.7 7.1-7c1.3-1.3 2-2.6 2-3.8C21 6 19 4 16.5 4c-1.7 0-3 1.5-3.6 2.9-.2.4-.5.6-.9.6s-.8-.2-.9-.6C10.5 5.5 9.2 4 7.5 4z"
  })
}));

/**
UiHeartLinedSmall icon

```jsx
import { UiHeartLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiHeartLinedSmall />
```

 */
const UiHeartLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M8 15c-.2 0-.5-.1-.7-.3L1.4 9.3C.5 8.4 0 7.1 0 5.9 0 3.2 2.2 1 4.8 1c1.4 0 2.4.7 3.2 1.6.8-.9 1.8-1.6 3.2-1.6C13.8 1 16 3.2 16 5.9c0 1.3-.6 2.7-1.9 3.9l-5.5 5c-.1.1-.4.2-.6.2zM4.8 3C3.3 3 2 4.3 2 5.9c0 .8.3 1.5.8 2L8 12.6l4.7-4.4c.6-.5 1.3-1.4 1.3-2.3C14 4.3 12.7 3 11.2 3c-1 0-1.9 1-2.2 1.9-.2.4-.6.6-1 .6s-.8-.2-.9-.6C6.7 4 5.9 3 4.8 3z"
  })
}));

/**
UiHelpEncircledFilled icon

```jsx
import { UiHelpEncircledFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiHelpEncircledFilled />
```

 */
const UiHelpEncircledFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.48 2 12 2s9.99 4.48 10 10c0 5.52-4.48 10-10 10S2 17.52 2 12zm10-5.97c-2.03 0-3.38 1.02-3.79 2.86-.12.55.22 1.08.76 1.2a.996.996 0 001.19-.76c.15-.67.48-1.3 1.84-1.3 2 0 2 1.06 2 1.47 0 .932-.334 1.087-1.05 1.421l-.02.009c-.72.33-1.93.89-1.93 2.57 0 .55.45 1 1 1s1-.45 1-1c0-.35.04-.42.76-.75l.011-.005C14.612 12.355 16 11.71 16 9.5c0-1.68-1.05-3.47-4-3.47zm0 12.22a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z"
  })
}));

/**
UiHelpEncircledLined icon

```jsx
import { UiHelpEncircledLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiHelpEncircledLined />
```

 */
const UiHelpEncircledLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12 18.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM8.21 8.89C8.62 7.05 9.97 6.03 12 6.03c2.95 0 4 1.79 4 3.47 0 2.21-1.388 2.854-2.229 3.245l-.011.005c-.72.33-.76.4-.76.75 0 .55-.45 1-1 1s-1-.45-1-1c0-1.68 1.21-2.24 1.93-2.57l.02-.009c.716-.334 1.05-.49 1.05-1.421 0-.41 0-1.47-2-1.47-1.36 0-1.69.63-1.84 1.3-.12.54-.65.88-1.19.76-.54-.12-.88-.65-.76-1.2z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c-.01-5.52-4.48-10-10-10zm0 17.99c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
  })]
}));

/**
UiHelpLined icon

```jsx
import { UiHelpLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiHelpLined />
```

 */
const UiHelpLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M10.8 15.8c0 .6.5 1.2 1.2 1.2s1.2-.6 1.3-1.3c0-1.8.7-2.2 2.1-2.9l.024-.013C16.922 11.988 19 10.88 19 7.2 19 3.4 16.3 1 12 1 8.5 1 5 3 5 6.8 5 7.4 5.5 8 6.2 8s1.3-.6 1.4-1.3c0-2.1 2.3-3.2 4.5-3.2 2.1 0 4.5.7 4.5 3.8 0 2.2-.9 2.7-2.3 3.4-1.5.7-3.5 1.8-3.5 5.1zm2.7 5.7a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
  })
}));

/**
UiHelpLinedSmall icon

```jsx
import { UiHelpLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiHelpLinedSmall />
```

 */
const UiHelpLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M3 4c0-2.4 2-4 5-4 3.1 0 5 1.7 5 4.5s-1.7 3.6-2.8 4.1c-.067.038-.132.073-.193.106C9.257 9.12 9 9.26 9 10c0 .6-.4 1-1 1s-1-.4-1-1c0-2.01 1.282-2.646 2.27-3.135L9.4 6.8l.167-.083C10.467 6.273 11 6.01 11 4.5 11 2.8 10 2 8 2c-.7 0-3 .1-3 2 0 .6-.4 1-1 1s-1-.4-1-1zm6.5 10.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
  })
}));

/**
UiHomeFilled icon

```jsx
import { UiHomeFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiHomeFilled />
```

 */
const UiHomeFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22.7 10.3l-10-9c-.4-.3-1-.3-1.3 0l-10 9c-.4.4-.4 1-.1 1.4.4.4 1 .4 1.4.1l.3-.4V20c0 .6.4 1 1 1h5c.6 0 1-.4 1-1v-6h4v6c0 .6.4 1 1 1h5c.6 0 1-.4 1-1v-8.6l.3.3c.2.2.4.3.7.3.3 0 .5-.1.7-.3.4-.4.4-1.1 0-1.4z"
  })
}));

/**
UiHomeFilledSmall icon

```jsx
import { UiHomeFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiHomeFilledSmall />
```

 */
const UiHomeFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-home-filled-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M15.7 6.2l-7-6c-.4-.3-.9-.3-1.3 0l-7 6c-.4.4-.5 1-.1 1.4.1.3.4.4.7.4v6c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V9h4v5c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V8c.3 0 .6-.1.8-.3.3-.5.3-1.1-.1-1.5z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-home-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiHomeLined icon

```jsx
import { UiHomeLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiHomeLined />
```

 */
const UiHomeLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22.7 10.3l-10-9c-.4-.3-1-.3-1.3 0l-10 9c-.4.4-.4 1-.1 1.4.4.4 1 .4 1.4.1l.3-.4V20c0 .6.4 1 1 1h6c.6 0 1-.4 1-1v-6h2v6c0 .6.4 1 1 1h6c.6 0 1-.4 1-1v-8.6l.3.3c.2.2.4.3.7.3.3 0 .5-.1.7-.3.4-.4.4-1.1 0-1.4zM19 19h-4v-6c0-.6-.4-1-1-1h-4c-.6 0-1 .4-1 1v6H5V9.6l7-6.3 7 6.3V19z"
  })
}));

/**
UiHomeLinedSmall icon

```jsx
import { UiHomeLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiHomeLinedSmall />
```

 */
const UiHomeLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-home-lined-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M15.7 6.2l-7-6c-.4-.3-.9-.3-1.3 0l-7 6c-.4.4-.5 1-.1 1.4.1.3.4.4.7.4v6c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-4h2v4c0 .6.4 1 1 1h4c.6 0 1-.4 1-1V8c.3 0 .6-.1.8-.3.3-.5.3-1.1-.1-1.5zM11 13V9c0-.6-.4-1-1-1H6c-.6 0-1 .4-1 1v4H3V6.6l5-4.3 5 4.3V13h-2z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-home-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiHourglassLined icon

```jsx
import { UiHourglassLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiHourglassLined />
```

 */
const UiHourglassLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M18.7 4h.3c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1H5c-.6 0-1 .4-1 1v1c0 .6.4 1 1 1h.3l3.6 8-3.6 8H5c-.6 0-1 .4-1 1v1c0 .6.4 1 1 1h14c.6 0 1-.4 1-1v-1c0-.6-.4-1-1-1h-.3l-3.6-8 3.6-8zm-2.2 16h-9l3.4-7.6c.1-.3.1-.6 0-.8L7.5 4h8.9L13 11.6c-.1.3-.1.6 0 .8l3.5 7.6z"
  })
}));

/**
UiHourglassLinedSmall icon

```jsx
import { UiHourglassLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiHourglassLinedSmall />
```

 */
const UiHourglassLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M13.6 3h.4c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1H3c-.6 0-1 .4-1 1v1c0 .6.4 1 1 1h.4l2.5 5-2.5 5H3c-.6 0-1 .4-1 1v1c0 .6.4 1 1 1h11c.6 0 1-.4 1-1v-1c0-.6-.4-1-1-1h-.4l-2.5-5 2.5-5zm-2.2 10H5.6l2.3-4.6c.1-.2.1-.6 0-.8L5.6 3h5.8L9.1 7.6c-.1.2-.1.6 0 .8l2.3 4.6z"
  })
}));

/**
UiIconPlaceholderLined icon

```jsx
import { UiIconPlaceholderLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiIconPlaceholderLined />
```

 */
const UiIconPlaceholderLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M6.603 15c0-.42.03-.77.09-1.05a2.49 2.49 0 01.35-.81c.167-.26.44-.57.82-.93l.74-.71c.287-.273.497-.513.63-.72.134-.213.2-.42.2-.62 0-.26-.093-.46-.28-.6-.18-.14-.44-.21-.78-.21-.533 0-1.036.177-1.51.53V8.55c.247-.18.537-.317.87-.41.34-.1.697-.15 1.07-.15.5 0 .934.09 1.3.27.374.173.657.417.85.73.2.307.3.66.3 1.06 0 .373-.096.723-.29 1.05-.186.32-.513.683-.98 1.09l-.63.55c-.233.2-.406.367-.52.5-.106.127-.18.25-.22.37h1.28c.42 0 .88-.02 1.38-.06V15h-4.67zm8.239 0v-1.31h-3.11v-1.32l2.97-4.22h1.74v4.23c.26-.007.543-.027.85-.06v1.37h-.85V15h-1.6zm0-2.62v-2.29l-1.62 2.29h1.62z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6a3 3 0 013-3h1.5a1 1 0 010 2H6a1 1 0 00-1 1v1.5a1 1 0 01-2 0V6zm12.5-2a1 1 0 011-1H18a3 3 0 013 3v1.5a1 1 0 11-2 0V6a1 1 0 00-1-1h-1.5a1 1 0 01-1-1zM4 15.5a1 1 0 011 1V18a1 1 0 001 1h1.5a1 1 0 110 2H6a3 3 0 01-3-3v-1.5a1 1 0 011-1zm16 0a1 1 0 011 1V18a3 3 0 01-3 3h-1.5a1 1 0 110-2H18a1 1 0 001-1v-1.5a1 1 0 011-1z"
  })]
}));

/**
UiIconPlaceholderLinedSmall icon

```jsx
import { UiIconPlaceholderLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiIconPlaceholderLinedSmall />
```

 */
const UiIconPlaceholderLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 3.75A2.75 2.75 0 013.75 1h.75a.75.75 0 010 1.5h-.75c-.69 0-1.25.56-1.25 1.25v.75a.75.75 0 01-1.5 0v-.75zm10.25-2A.75.75 0 0112 1h.25A2.75 2.75 0 0115 3.75v.75a.75.75 0 01-1.5 0v-.75c0-.69-.56-1.25-1.25-1.25H12a.75.75 0 01-.75-.75zm-9.5 9.5a.75.75 0 01.75.75v.25c0 .69.56 1.25 1.25 1.25h.75a.75.75 0 010 1.5h-.75A2.75 2.75 0 011 12.25V12a.75.75 0 01.75-.75zm12.5 0A.75.75 0 0115 12v.25A2.75 2.75 0 0112.25 15H12a.75.75 0 010-1.5h.25c.69 0 1.25-.56 1.25-1.25V12a.75.75 0 01.75-.75z"
  }), /*#__PURE__*/jsx("path", {
    d: "M5.365 11V6.068l-1.44.918-.242-.963 1.872-1.188H6.58V11H5.364zm6.329-5.346c-.882.054-1.57.261-2.061.621-.486.354-.762.849-.828 1.485.174-.192.39-.342.648-.45a2 2 0 01.819-.171c.372 0 .699.087.98.261.283.168.499.399.649.693.156.288.234.615.234.981 0 .414-.096.78-.288 1.098a1.915 1.915 0 01-.792.72 2.521 2.521 0 01-1.143.252c-.732 0-1.302-.24-1.71-.72-.402-.48-.603-1.152-.603-2.016 0-.756.156-1.407.468-1.953a3.176 3.176 0 011.35-1.269c.594-.3 1.302-.465 2.124-.495l.153.963zM9.966 8.021c-.228 0-.447.06-.657.18-.204.12-.375.282-.513.486.048 1.014.423 1.521 1.125 1.521.306 0 .552-.099.738-.297.186-.204.279-.471.279-.801 0-.324-.09-.585-.27-.783-.174-.204-.408-.306-.702-.306z"
  })]
}));

/**
UiInProgressFilled icon

```jsx
import { UiInProgressFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiInProgressFilled />
```

 */
const UiInProgressFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
  })
}));

/**
UiInProgressFilledSmall icon

```jsx
import { UiInProgressFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiInProgressFilledSmall />
```

 */
const UiInProgressFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16A8 8 0 108 0a8 8 0 000 16z"
  })
}));

/**
UiInboxFilled icon

```jsx
import { UiInboxFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiInboxFilled />
```

 */
const UiInboxFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22.67 12.04l-3.49-7.85A2.034 2.034 0 0017.34 3H6.66c-.79 0-1.51.47-1.83 1.19l-3.49 7.84c-.23.5-.34 1.03-.34 1.58V19c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-5.39c0-.54-.11-1.07-.33-1.57zM6.66 5h10.69l3.12 7H15c-.55 0-1 .45-1 1 0 1.1-.9 2-2 2s-2-.9-2-2c0-.55-.45-1-1-1H3.54l3.12-7z"
  })
}));

/**
UiInboxFilledSmall icon

```jsx
import { UiInboxFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiInboxFilledSmall />
```

 */
const UiInboxFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M15.54 5.84l-2.68-4.37C12.67 1.18 12.35 1 12 1H4a1 1 0 00-.87.51L.37 6.48c-.2.42-.29.87-.33 1.34C.03 7.88 0 7.94 0 8v6c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V7.71c0-.62-.15-1.24-.46-1.87zM4.59 3h6.85l2.35 3.81c.03.06.04.12.07.19H11c-.55 0-1 .45-1 1 0 1.1-.9 2-2 2s-2-.9-2-2c0-.55-.45-1-1-1H2.37l2.22-4z"
  })
}));

/**
UiInboxLined icon

```jsx
import { UiInboxLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiInboxLined />
```

 */
const UiInboxLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22.67 12.04l-3.49-7.85A2.034 2.034 0 0017.34 3H6.66c-.79 0-1.51.47-1.83 1.19l-3.49 7.84c-.23.5-.34 1.03-.34 1.58V19c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-5.39c0-.54-.11-1.07-.33-1.57zM6.66 5h10.69l3.12 7H15c-.55 0-1 .45-1 1 0 1.1-.9 2-2 2s-2-.9-2-2c0-.55-.45-1-1-1H3.54l3.12-7zM21 19H3v-5h5.13c.44 1.72 2.01 3 3.87 3 1.86 0 3.43-1.28 3.87-3H21v5z"
  })
}));

/**
UiInboxLinedSmall icon

```jsx
import { UiInboxLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiInboxLinedSmall />
```

 */
const UiInboxLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M15.54 5.84l-2.68-4.37C12.67 1.18 12.35 1 12 1H4a1 1 0 00-.87.51L.37 6.48c-.2.42-.29.87-.33 1.34C.03 7.88 0 7.94 0 8v6c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V7.71c0-.62-.15-1.24-.46-1.87zM4.59 3h6.85l2.35 3.81c.03.06.04.12.07.19H11c-.55 0-1 .45-1 1 0 1.1-.9 2-2 2s-2-.9-2-2c0-.55-.45-1-1-1H2.37l2.22-4zM14 13H2V9h2.13c.44 1.72 2.01 3 3.87 3 1.86 0 3.43-1.28 3.87-3H14v4z"
  })
}));

/**
UiInfoFilled icon

```jsx
import { UiInfoFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiInfoFilled />
```

 */
const UiInfoFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm10-2.5A1.25 1.25 0 1012 7a1.25 1.25 0 000 2.5zM11 12a1 1 0 112 0v4a1 1 0 11-2 0v-4z"
  })
}));

/**
UiInfoFilledSmall icon

```jsx
import { UiInfoFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiInfoFilledSmall />
```

 */
const UiInfoFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8c0-4.42 3.58-8 8-8s8 3.58 8 8-3.58 8-8 8-8-3.58-8-8zm8-2.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM8 7c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1s1-.45 1-1V8c0-.55-.45-1-1-1z"
  })
}));

/**
UiInfoLined icon

```jsx
import { UiInfoLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiInfoLined />
```

 */
const UiInfoLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M13.25 8.25a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm2 0c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8-8 3.59-8 8z"
  }), /*#__PURE__*/jsx("path", {
    d: "M11 12a1 1 0 112 0v4a1 1 0 11-2 0v-4z"
  })]
}));

/**
UiInfoLinedSmall icon

```jsx
import { UiInfoLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiInfoLinedSmall />
```

 */
const UiInfoLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M8 7c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1s1-.45 1-1V8c0-.55-.45-1-1-1zm1.25-2.5a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
  })]
}));

/**
UiInstagramLined icon

```jsx
import { UiInstagramLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiInstagramLined />
```

 */
const UiInstagramLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.5c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zm0 7.2c-1.49 0-2.7-1.21-2.7-2.7 0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7 0 1.49-1.21 2.7-2.7 2.7z"
  }), /*#__PURE__*/jsx("path", {
    d: "M17.5 7.5a1 1 0 11-2 0 1 1 0 012 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.94 8.29c-.01-.75-.15-1.48-.41-2.18a4.45 4.45 0 00-1.05-1.61 4.54 4.54 0 00-1.63-1.02c-.7-.26-1.43-.4-2.18-.42C14.72 3 14.41 3 11.97 3c-2.44 0-2.75 0-3.7.06-.74.01-1.48.15-2.17.41-.6.23-1.15.58-1.6 1.03-.45.45-.8 1-1.03 1.6-.26.7-.4 1.44-.41 2.18C3 9.24 3 9.56 3 12c0 2.44 0 2.76.06 3.71.01.75.15 1.48.41 2.18.22.6.58 1.15 1.03 1.6.45.45 1 .81 1.6 1.03.69.28 1.43.44 2.18.47h3.7c2.43 0 2.75 0 3.7-.06a6.3 6.3 0 002.18-.42c.6-.23 1.14-.58 1.6-1.03.46-.45.8-1 1.03-1.6.28-.7.44-1.43.47-2.18-.01-.43-.002-.73.01-1.162.012-.514.03-1.214.03-2.538 0-1.502-.023-2.201-.04-2.738-.011-.335-.02-.607-.02-.972zm-1.98 6.38l-.004.124c-.008.287-.016.542-.016.866-.03.51-.14 1.01-.34 1.53-.13.34-.32.64-.57.89-.25.25-.55.45-.88.57-.48.18-.99.28-1.51.29h-.08c-.9.06-1.15.06-3.59.06H8.32c-.51-.03-1-.14-1.52-.34-.33-.13-.63-.32-.88-.57-.25-.25-.44-.55-.57-.89-.18-.49-.28-1-.29-1.52v-.08C5 14.7 5 14.44 5 12c0-2.44 0-2.7.05-3.6v-.08c.02-.52.12-1.03.3-1.51.13-.34.32-.64.57-.89.25-.26.55-.45.88-.57.48-.18.99-.28 1.51-.29h.08C9.28 5 9.54 5 11.97 5s2.69 0 3.58.05h.08c.52.01 1.03.11 1.54.3.33.12.65.32.9.57.25.25.46.56.58.88.18.49.28 1 .29 1.48 0 .338.008.6.016.898l.004.142c.02.54.04 1.21.04 2.68 0 1.47-.02 2.14-.04 2.67z"
  })]
}));

/**
UiJoinAltLined icon

```jsx
import { UiJoinAltLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiJoinAltLined />
```

 */
const UiJoinAltLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 3c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1zm10 8h-4.41l1.12-1.12a.996.996 0 10-1.41-1.41l-2.83 2.83a.996.996 0 000 1.41l2.83 2.83c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 000-1.41L17.59 13H22c.55 0 1-.45 1-1s-.45-1-1-1zM6.71 8.46A.996.996 0 105.3 9.87L6.41 11H2c-.55 0-1 .45-1 1s.45 1 1 1h4.41l-1.12 1.12a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l2.83-2.83c.19-.19.29-.44.29-.71s-.11-.52-.29-.71L6.71 8.46z"
  })
}));

/**
UiJoinAltLinedSmall icon

```jsx
import { UiJoinAltLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiJoinAltLinedSmall />
```

 */
const UiJoinAltLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M8 1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1zM3.44 5.31c-.14-.15-.33-.22-.53-.22s-.38.07-.53.22c-.29.29-.29.77 0 1.06l.72.72L1 7H.92a.99.99 0 00-.96 1.04c.02.55.49.98 1.04.96l2.11-.09-.73.72c-.29.29-.29.77 0 1.06s.77.29 1.06 0L5.6 8.53c.29-.29.29-.77 0-1.06L3.44 5.31zM15 7l-2.11.09.72-.72c.29-.29.29-.77 0-1.06s-.77-.29-1.06 0l-2.16 2.16c-.29.29-.29.77 0 1.06l2.16 2.16c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06l-.72-.72L15 9h.08c.55-.02.98-.49.96-1.04-.02-.55-.49-.98-1.04-.96z"
  })
}));

/**
UiJoinLined icon

```jsx
import { UiJoinLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiJoinLined />
```

 */
const UiJoinLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 6c0 .55.45 1 1 1h8.382l2.5 4.99-2.5 5.01H2c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3h4a1 1 0 00.895-.553L14.614 13H17v3.99c0 .55.45 1 1 1h4c.56 0 1-.45 1-1v-4c0-.55-.45-1-1-1 .56 0 1-.45 1-1v-4c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1V11h-2.377l-2.729-5.448A1 1 0 0011 5H7V2c0-.55-.45-1-1-1H2c-.55 0-1 .45-1 1v4zm1.5-2.01c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5-1.5.67-1.5 1.5zm17.5 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
  })
}));

/**
UiJoinLinedSmall icon

```jsx
import { UiJoinLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiJoinLinedSmall />
```

 */
const UiJoinLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5.003c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v2.002h1.44a1 1 0 01.836.451L9.61 7.005H11V4.002c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v3.002c0 .55-.45 1-1 1 .55 0 1 .451 1 1.002v3.001c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1V9.005H9.681l-2.413 3.563a1 1 0 01-.828.44H5v1.991A.997.997 0 014 16H1c-.55 0-1-.45-1-1v-3.002c0-.55.45-1.001 1-1.001h3c.049 0 .097.004.144.01H5.91l1.998-2.95L5.9 5.002H4.035L4 5.003H1zm1.5-1.502c-.55 0-1-.45-1-1S1.95 1.5 2.5 1.5s1 .45 1 1-.45 1.001-1 1.001zm10 2.001c0 .55.45 1.001 1 1.001s1-.45 1-1-.45-1.001-1-1.001-1 .45-1 1z"
  })
}));

/**
UiKeyFilled icon

```jsx
import { UiKeyFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiKeyFilled />
```

 */
const UiKeyFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20.71 17.29l-7.12-7.12c.26-.67.41-1.4.41-2.17 0-3.31-2.69-6-6-6S2 4.69 2 8s2.69 6 6 6c.77 0 1.5-.15 2.17-.41l1.12 1.12c.19.18.44.29.71.29h2v2c0 .55.45 1 1 1h2v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2c0-.27-.11-.52-.29-.71zM6.5 5C7.33 5 8 5.67 8 6.5S7.33 8 6.5 8 5 7.33 5 6.5 5.67 5 6.5 5z"
  })
}));

/**
UiKeyFilledSmall icon

```jsx
import { UiKeyFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiKeyFilledSmall />
```

 */
const UiKeyFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M15.71 12.29l-4.92-4.92c.12-.44.21-.89.21-1.37 0-2.76-2.24-5-5-5S1 3.24 1 6s2.24 5 5 5c.48 0 .93-.09 1.37-.22l.92.92A1 1 0 009 12h1v1c0 .55.45 1 1 1h1v1c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2c0-.27-.11-.52-.29-.71zM4.5 3C5.33 3 6 3.67 6 4.5S5.33 6 4.5 6 3 5.33 3 4.5 3.67 3 4.5 3z"
  })
}));

/**
UiLeafFilled icon

```jsx
import { UiLeafFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLeafFilled />
```

 */
const UiLeafFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M19.91 1.426c-.2-.3-.7-.5-1.1-.4-.3.1-7.3 2.098-11.4 6.293-2 1.997-3.3 4.494-3.4 6.592-.1 1.898.6 3.595 2 4.794 0-.3.1-.6.1-.999.8-3.895 3.2-7.49 6.4-9.588.5-.3 1.1-.2 1.4.3.3.499.2 1.098-.3 1.398-2.8 1.897-4.9 4.994-5.6 8.39-.1.599-.1 2.796-.1 3.196.2.4.2.7.2.799.1.5.5.799 1 .799h.2c.5-.1.9-.6.8-1.199 0 0-.1-.599-.1-1.298.4.1.8.1 1.2.1.4 0 .8 0 1.3-.1 2.3-.3 4.5-1.498 5.5-2.997 2.3-3.495 1.4-7.89 1.1-8.79-.9-3.495.8-6.192.9-6.192.2-.3.2-.799-.1-1.098z"
  })
}));

/**
UiLeafFilledSmall icon

```jsx
import { UiLeafFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLeafFilledSmall />
```

 */
const UiLeafFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-leaf-filled-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M13.81.411a1.002 1.002 0 00-1.09-.37C12.51.1 7.493 1.55 4.516 4.503c-.616.61-2.604 2.782-2.513 5.333.04 1.221.575 2.302 1.544 3.132.07.06.151.11.232.16v-.04c.192-1.09.585-1.99 1.05-2.881.464-.88 1.019-1.691 1.614-2.472.606-.77 1.232-1.5 1.948-2.2a.54.54 0 01.747 0c.202.2.202.52.02.72l-.02.02c-1.231 1.35-2.362 2.881-3.149 4.502-.383.8-.686 1.691-.797 2.471a11 11 0 00-.01 1.411c.03.27.06.46.06.51.081.49.515.831.99.831.06 0 .11 0 .171-.01.545-.09.918-.61.828-1.15 0 0-.03-.22-.061-.511.08 0 .151.02.232.02.303 0 .616-.02.929-.06 1.735-.23 3.34-1.1 4.087-2.221 1.705-2.532.999-5.773.848-6.404-.586-2.311.524-4.032.575-4.112.222-.35.212-.8-.03-1.14z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-leaf-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiLeafLined icon

```jsx
import { UiLeafLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLeafLined />
```

 */
const UiLeafLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M19.91 1.426c-.2-.3-.7-.5-1.1-.4-.3.1-7.3 2.098-11.4 6.293-.8.799-3.6 3.795-3.4 7.29.1 1.599.8 3.097 2 4.196.3.3.7.5 1 .7-.1 1.298.1 2.596.1 2.696.1.5.5.799 1 .799h.2c.5-.1.9-.6.8-1.199 0 0-.1-.699-.1-1.498.7.2 1.4.3 2.2.3.4 0 .8 0 1.3-.1 2.3-.3 4.5-1.498 5.5-2.997 2.3-3.495 1.4-7.89 1.1-8.79-.9-3.495.8-6.192.9-6.192.2-.3.2-.799-.1-1.098zm-3.6 14.982c-.7.999-2.4 1.897-4.1 2.097-.7.1-1.8.1-2.9-.2 1.3-4.394 5.5-8.59 5.5-8.59.4-.399.4-.998 0-1.398-.4-.4-1-.4-1.4 0-.2.2-4.3 4.395-5.9 9.09-.1-.1-.1-.1-.2-.1-.9-.8-1.3-1.698-1.4-2.697-.1-2.098 1.4-4.395 2.8-5.793 2.4-2.397 6.2-4.095 8.5-4.994-.3 1.298-.6 3.196-.1 5.393.1.5 1 4.395-.8 7.192z"
  })
}));

/**
UiLeafLinedSmall icon

```jsx
import { UiLeafLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLeafLinedSmall />
```

 */
const UiLeafLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-leaf-lined-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M13.8.4c-.2-.3-.7-.5-1.1-.4-.2.1-5.2 1.5-8.1 4.5C4 5.1 2 7.3 2.1 9.8c0 1.2.6 2.3 1.5 3.1.2.2.4.3.6.4-.1.9.1 1.7.1 1.8.1.5.5.8 1 .8h.2c.5-.1.9-.6.8-1.2 0 0 0-.3-.1-.6.4.1.8.1 1.2.1.3 0 .6 0 .9-.1 1.7-.2 3.3-1.1 4.1-2.2 1.7-2.5 1-5.8.8-6.4-.6-2.3.5-4 .6-4.1.3-.2.3-.7 0-1zm-3 10.5c-.4.5-1.3 1.2-2.7 1.3-.4.1-1 .1-1.6-.1.8-2 2.5-4.1 3.2-5 .4-.4.3-1-.1-1.4-.4-.4-1-.3-1.4.1-1 1.1-2.6 3.2-3.5 5.5-.4-.4-.6-.9-.7-1.5C4 8.4 5 6.9 5.9 6c1.5-1.5 3.7-2.6 5.3-3.2-.2.9-.3 2.1 0 3.5.2 0 .8 2.7-.4 4.6z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-leaf-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiLensLined icon

```jsx
import { UiLensLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLensLined />
```

 */
const UiLensLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.084 7.034A8.126 8.126 0 0114.936 1a8.122 8.122 0 012.1 15.966A8.126 8.126 0 019.183 23a8.122 8.122 0 01-2.1-15.966zm2.2-.274A6.125 6.125 0 0114.937 3a6.122 6.122 0 012.37 11.765A8.122 8.122 0 009.285 6.76zm5.55 10.48A6.125 6.125 0 019.185 21a6.122 6.122 0 01-2.37-11.765 8.122 8.122 0 008.02 8.004zm.463-2.01a6.102 6.102 0 01-2.951-.563l2.384-2.384a6.094 6.094 0 01.567 2.947zm-1.085-3.843l-2.764 2.763a6.157 6.157 0 01-1.544-1.543l2.762-2.761c.603.417 1.127.94 1.546 1.541zM11.768 9.33l-2.381 2.38a6.094 6.094 0 01-.564-2.94 6.103 6.103 0 012.945.56z"
  })
}));

/**
UiLensLinedSmall icon

```jsx
import { UiLensLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLensLinedSmall />
```

 */
const UiLensLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-lens-lined-small-a)",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.01 0c-2.71 0-5 1.8-5.74 4.27a5.99 5.99 0 107.459 7.46A5.99 5.99 0 0010.01 0zm0 2a3.99 3.99 0 00-3.484 2.043 5.992 5.992 0 015.43 5.43A3.99 3.99 0 0010.01 2zM5.99 14c1.497 0 2.8-.825 3.484-2.044a5.992 5.992 0 01-5.43-5.43A3.99 3.99 0 005.99 14zm.866-5.566A3.972 3.972 0 016.02 6.02a3.972 3.972 0 012.411.833L6.856 8.434zm.707.708l1.576-1.583c.521.67.834 1.509.84 2.42a3.972 3.972 0 01-2.416-.837z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-lens-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiLightbulbFilled icon

```jsx
import { UiLightbulbFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLightbulbFilled />
```

 */
const UiLightbulbFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22.587 1.293a1 1 0 010 1.414l-.88.88a1 1 0 11-1.414-1.414l.88-.88a1 1 0 011.414 0zm-19.88 0a1 1 0 00-1.414 1.414l.88.88a1 1 0 001.414-1.414l-.88-.88zM3.25 13H2a1 1 0 110-2h1.25a1 1 0 110 2zm16.5-1a1 1 0 011-1H22a1 1 0 110 2h-1.25a1 1 0 01-1-1zm-6.81 11c1.14 0 2.06-.93 2.06-2.07V19.5c0-.29-.24-.5-.53-.5H9.53c-.29 0-.53.21-.53.5v1.43c0 1.14.92 2.07 2.06 2.07h1.88zM4.5 8.39C4.5 4.292 7.874 1 12 1c4.126 0 7.5 3.292 7.5 7.39 0 2.25-1.01 4.243-2.605 5.6l-.866 2.355a1 1 0 01-.939.655H8.9a1 1 0 01-.939-.656l-.866-2.363A7.32 7.32 0 014.5 8.39z"
  })
}));

/**
UiLightbulbFilledSmall icon

```jsx
import { UiLightbulbFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLightbulbFilledSmall />
```

 */
const UiLightbulbFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-lightbulb-filled-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M1.854.146a.5.5 0 10-.708.708l1 1a.5.5 0 10.708-.708l-1-1zM3 5.11C3 2.314 5.212 0 8 0s5 2.314 5 5.11c0 1.505-.64 2.85-1.653 3.789l-.503 1.432A1 1 0 019.9 11H6.09a1 1 0 01-.944-.669L4.643 8.9A5.16 5.16 0 013 5.11zM0 5.5A.5.5 0 01.5 5h1.25a.5.5 0 010 1H.5a.5.5 0 01-.5-.5zm13.75 0a.5.5 0 01.5-.5h1.25a.5.5 0 010 1h-1.25a.5.5 0 01-.5-.5zM8.78 15c.95 0 1.72-.62 1.72-1.38v-1.26c0-.2-.2-.36-.44-.36H5.94c-.24 0-.44.16-.44.36v1.26c0 .76.77 1.38 1.72 1.38h1.56zM14.854.146a.5.5 0 010 .708l-1 1a.5.5 0 01-.708-.708l1-1a.5.5 0 01.708 0z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-lightbulb-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiLightbulbLined icon

```jsx
import { UiLightbulbLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLightbulbLined />
```

 */
const UiLightbulbLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M22.587 2.707a1 1 0 00-1.414-1.414l-.88.88a1 1 0 001.414 1.414l.88-.88zM1.293 1.293a1 1 0 011.414 0l.88.88a1 1 0 01-1.414 1.414l-.88-.88a1 1 0 010-1.414zM2 13h1.25a1 1 0 100-2H2a1 1 0 100 2zm18.75-2a1 1 0 100 2H22a1 1 0 100-2h-1.25zM15 20.93c0 1.14-.92 2.07-2.06 2.07h-1.88C9.92 23 9 22.07 9 20.93V19.5c0-.29.24-.5.53-.5h4.94c.29 0 .53.21.53.5v1.43z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C7.874 1 4.5 4.292 4.5 8.39a7.32 7.32 0 002.595 5.59l.866 2.364A1 1 0 008.9 17h6.19a1 1 0 00.939-.655l.866-2.354C18.49 12.633 19.5 10.64 19.5 8.39 19.5 4.292 16.126 1 12 1zM6.5 8.39C6.5 5.428 8.946 3 12 3s5.5 2.428 5.5 5.39c0 1.706-.795 3.212-2.068 4.214a1 1 0 00-.32.44L14.391 15H9.6l-.72-1.964a1 1 0 00-.321-.442A5.327 5.327 0 016.5 8.39z"
  })]
}));

/**
UiLightbulbLinedSmall icon

```jsx
import { UiLightbulbLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLightbulbLinedSmall />
```

 */
const UiLightbulbLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsxs("g", {
    clipPath: "url(#omni-gravity-icon-ui-lightbulb-lined-small-a)",
    children: [/*#__PURE__*/jsx("path", {
      d: "M1.146.146a.5.5 0 01.708 0l1 1a.5.5 0 11-.708.708l-1-1a.5.5 0 010-.708z"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 0C5.212 0 3 2.314 3 5.11c0 1.5.636 2.855 1.643 3.789l.503 1.432A1 1 0 006.09 11H9.9a1 1 0 00.944-.669l.503-1.432A5.144 5.144 0 0013 5.11C13 2.314 10.788 0 8 0zM5 5.11C5 3.366 6.368 2 8 2s3 1.366 3 3.11c0 .989-.447 1.86-1.147 2.439a1 1 0 00-.307.44L9.191 9H6.8l-.355-1.011a1 1 0 00-.308-.44A3.154 3.154 0 015 5.11z"
    }), /*#__PURE__*/jsx("path", {
      d: "M.5 5a.5.5 0 000 1h1.25a.5.5 0 000-1H.5zm13.75 0a.5.5 0 000 1h1.25a.5.5 0 000-1h-1.25zm-3.75 8.62c0 .76-.77 1.38-1.72 1.38H7.22c-.95 0-1.72-.62-1.72-1.38v-1.26c0-.2.2-.36.44-.36h4.12c.24 0 .44.16.44.36v1.26zM14.854.854a.5.5 0 00-.708-.708l-1 1a.5.5 0 00.708.708l1-1z"
    })]
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-lightbulb-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiLinkLined icon

```jsx
import { UiLinkLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLinkLined />
```

 */
const UiLinkLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M14.32 4.32c1.75-1.75 4.6-1.75 6.36 0 1.75 1.75 1.75 4.6 0 6.36l-4.5 4.5c-.87.88-2.03 1.32-3.18 1.32-1.15 0-2.3-.44-3.18-1.32-.45-.44-.78-.95-1.01-1.53-.21-.52.05-1.1.56-1.3.52-.2 1.1.05 1.3.56.13.32.31.6.56.85.98.97 2.57.97 3.54 0l4.5-4.5c.97-.98.97-2.57 0-3.54-.98-.98-2.57-.97-3.54 0l-1.02 1.02a.996.996 0 11-1.41-1.41l1.02-1.01z"
  }), /*#__PURE__*/jsx("path", {
    d: "M7.27 18.26l1.07-1.07a.996.996 0 011.41.01c.39.39.39 1.02 0 1.41l-1.07 1.07C7.81 20.56 6.65 21 5.5 21c-1.15 0-2.31-.44-3.17-1.33a4.509 4.509 0 010-6.36l4.5-4.5c1.75-1.75 4.6-1.75 6.36 0 .38.39.69.83.91 1.31.22.51 0 1.1-.5 1.33-.51.22-1.1 0-1.33-.5-.12-.27-.29-.52-.5-.73-.98-.98-2.57-.97-3.54 0l-4.5 4.5c-.97.98-.98 2.57 0 3.54.98.97 2.57.97 3.54 0z"
  })]
}));

/**
UiLinkLinedSmall icon

```jsx
import { UiLinkLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLinkLinedSmall />
```

 */
const UiLinkLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M10.118 1.977c1.296-1.303 3.59-1.303 4.885 0 .598.701.997 1.403.997 2.404 0 1.002-.3 1.804-.997 2.505l-3.39 3.507c-.697.701-1.594 1.002-2.492 1.002-.897 0-1.794-.3-2.492-1.002-.398-.4-.698-1.002-.897-1.503-.1-.5.2-1.102.698-1.302.498-.1 1.096.2 1.196.701.1.3.2.501.399.701a1.646 1.646 0 002.093 0l3.49-3.406c.199-.3.398-.702.398-1.102 0-.401-.2-.802-.399-1.102-.498-.602-1.495-.602-2.093 0a.96.96 0 01-1.396 0 .972.972 0 010-1.403z"
  }), /*#__PURE__*/jsx("path", {
    d: "M2.542 11.495c.499.601 1.495.601 2.094 0 .299-.4.996-.4 1.395.1a.972.972 0 010 1.403C5.333 13.6 4.436 14 3.54 14c-.997 0-1.794-.3-2.492-1.002a3.52 3.52 0 010-5.01l3.489-3.406c1.296-1.303 3.589-1.303 4.885 0 .398.4.697.902.897 1.503.1.5-.2 1.102-.698 1.202-.498.1-.997-.2-1.196-.701-.1-.2-.2-.401-.4-.601-.597-.602-1.594-.602-2.093 0L2.442 9.39a1.555 1.555 0 00.1 2.104z"
  })]
}));

/**
UiLinkUnlinkLined icon

```jsx
import { UiLinkUnlinkLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLinkUnlinkLined />
```

 */
const UiLinkUnlinkLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M13 4.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5s.5.22.5.5v3zm10.03 2.87a4.508 4.508 0 00-2.68-2.16 4.465 4.465 0 00-3.43.37l-1.26.69c-.48.26-.66.87-.4 1.36.26.48.87.66 1.36.4l1.26-.69c.59-.32 1.26-.39 1.9-.21.64.19 1.17.61 1.49 1.2.32.59.39 1.26.21 1.9-.19.64-.61 1.17-1.2 1.49l-5.58 3.05c-.59.32-1.26.39-1.9.21-.64-.19-1.17-.61-1.49-1.2-.17-.3-.27-.63-.3-.97-.05-.55-.54-.96-1.09-.91-.55.05-.96.54-.91 1.09.06.62.24 1.21.54 1.75a4.508 4.508 0 002.68 2.16c.42.12.85.18 1.27.18.74 0 1.48-.19 2.15-.55l5.58-3.05a4.508 4.508 0 002.16-2.68 4.41 4.41 0 00-.36-3.43z"
  }), /*#__PURE__*/jsx("path", {
    d: "M8.34 17.19l-1.07 1.07c-.97.97-2.56.97-3.54 0-.97-.97-.97-2.56 0-3.54l4.5-4.5c.97-.97 2.56-.98 3.54 0 .21.21.38.46.5.73.23.5.82.72 1.33.5.5-.23.72-.82.5-1.33-.22-.48-.53-.92-.91-1.31-1.76-1.75-4.61-1.75-6.36 0l-4.5 4.5a4.509 4.509 0 000 6.36A4.38 4.38 0 005.5 21c1.16 0 2.31-.44 3.18-1.32l1.07-1.07a.996.996 0 000-1.41.996.996 0 00-1.41-.01zm1.81-11.34a.485.485 0 00.7 0c.2-.2.2-.51 0-.71l-2-2c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l2.01 2zm4.7-1a.47.47 0 01-.35.15c-.13 0-.25-.05-.36-.15-.2-.2-.2-.51 0-.71l2-2c.2-.2.51-.2.71 0 .2.2.2.51 0 .71l-2 2z"
  })]
}));

/**
UiLinkUnlinkLinedSmall icon

```jsx
import { UiLinkUnlinkLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLinkUnlinkLinedSmall />
```

 */
const UiLinkUnlinkLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsxs("g", {
    clipPath: "url(#omni-gravity-icon-ui-link-unlink-lined-small-a)",
    children: [/*#__PURE__*/jsx("path", {
      d: "M9 .502a.5.5 0 10-1 0v2.009a.5.5 0 101 0V.502zM15.477 5.9c-.862-1.424-2.688-1.99-4.142-1.409a1.004 1.004 0 10.746 1.865c.553-.22 1.333.012 1.68.589l.014.022c.42.66.215 1.613-.463 2.008l-.028.018-3.518 2.21-.004.002c-.66.42-1.614.216-2.01-.462a.999.999 0 00-.064-.097.929.929 0 01-.2-.602 1.005 1.005 0 00-2.01 0c0 .576.147 1.179.568 1.76 1.024 1.69 3.256 2.073 4.792 1.098l3.502-2.2c1.717-1.013 2.113-3.257 1.137-4.802z"
    }), /*#__PURE__*/jsx("path", {
      d: "M4.052 6.13c1.327-1.441 3.583-1.376 4.95-.01.454.453.731 1.028.867 1.571a1.004 1.004 0 11-1.95.487c-.065-.26-.19-.49-.339-.638-.634-.634-1.574-.577-2.06-.038a1.004 1.004 0 01-.048.05l-3.008 2.906c-.629.634-.57 1.57-.033 2.053a.99.99 0 01.038.037c.408.407 1.105.553 1.685.36a1.005 1.005 0 01.636 1.905c-1.22.407-2.724.157-3.723-.826-1.45-1.325-1.388-3.586-.019-4.955l.012-.012 2.992-2.89zM5.17 1.151a.502.502 0 01.71 0l1.51 1.507a.502.502 0 11-.71.71L5.17 1.862a.502.502 0 010-.71zm6.69.711a.502.502 0 10-.71-.71L9.64 2.657a.502.502 0 000 .71.514.514 0 00.72 0l1.5-1.506z"
    })]
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-link-unlink-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiLinkedInFilled icon

```jsx
import { UiLinkedInFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLinkedInFilled />
```

 */
const UiLinkedInFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M2.88 5.24a2.121 2.121 0 014.24 0 2.121 2.121 0 01-4.24 0zM16.81 8.7c-2.86 0-3.81 1.8-3.81 1.8V9H9v12h4v-6c0-1.93.81-2.99 2.19-2.99S17 13.06 17 15v6h4v-6c0-4-.7-6.3-4.19-6.3zM7 9H3v12h4V9z"
  })
}));

/**
UiListLined icon

```jsx
import { UiListLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiListLined />
```

 */
const UiListLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M5 6a1 1 0 11-2 0 1 1 0 012 0zm0 6a1 1 0 11-2 0 1 1 0 012 0zm0 6a1 1 0 11-2 0 1 1 0 012 0zM7 6a1 1 0 011-1h12a1 1 0 110 2H8a1 1 0 01-1-1zm0 6a1 1 0 011-1h12a1 1 0 110 2H8a1 1 0 01-1-1zm0 6a1 1 0 011-1h12a1 1 0 110 2H8a1 1 0 01-1-1z"
  })
}));

/**
UiListLinedSmall icon

```jsx
import { UiListLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiListLinedSmall />
```

 */
const UiListLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M3 4a1 1 0 11-2 0 1 1 0 012 0zm0 4a1 1 0 11-2 0 1 1 0 012 0zm0 4a1 1 0 11-2 0 1 1 0 012 0zm1-8a1 1 0 011-1h9a1 1 0 110 2H5a1 1 0 01-1-1zm0 4a1 1 0 011-1h9a1 1 0 110 2H5a1 1 0 01-1-1zm0 4a1 1 0 011-1h9a1 1 0 110 2H5a1 1 0 01-1-1z"
  })
}));

/**
UiLocationAndroidFilled icon

```jsx
import { UiLocationAndroidFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLocationAndroidFilled />
```

 */
const UiLocationAndroidFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12 16a4 4 0 100-8 4 4 0 000 8z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9 11H22c.6 0 1 .4 1 1s-.4 1-1 1h-1.1c-.4 4.1-3.7 7.4-7.9 7.9V22c0 .6-.4 1-1 1s-1-.4-1-1v-1.1c-4.1-.4-7.4-3.7-7.9-7.9H2c-.6 0-1-.4-1-1s.4-1 1-1h1.1c.4-4.2 3.7-7.5 7.9-7.9V2c0-.6.4-1 1-1s1 .4 1 1v1.1c4.1.4 7.4 3.7 7.9 7.9zM12 19c3.9 0 7-3.1 7-7s-3.1-7-7-7-7 3.1-7 7 3.1 7 7 7z"
  })]
}));

/**
UiLocationAndroidFilledSmall icon

```jsx
import { UiLocationAndroidFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLocationAndroidFilledSmall />
```

 */
const UiLocationAndroidFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M10 8a2 2 0 11-4 0 2 2 0 014 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9 7H15c.6 0 1 .4 1 1s-.4 1-1 1h-1.1c-.4 2.5-2.4 4.5-4.9 4.9V15c0 .6-.4 1-1 1s-1-.4-1-1v-1.1c-2.5-.4-4.5-2.4-4.9-4.9H1c-.6 0-1-.4-1-1s.4-1 1-1h1.1C2.5 4.5 4.5 2.5 7 2.1V1c0-.6.4-1 1-1s1 .4 1 1v1.1c2.5.4 4.5 2.4 4.9 4.9zM8 12c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4z"
  })]
}));

/**
UiLocationAndroidLined icon

```jsx
import { UiLocationAndroidLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLocationAndroidLined />
```

 */
const UiLocationAndroidLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22 11h-1.1c-.5-4.2-3.8-7.5-7.9-7.9V2c0-.6-.4-1-1-1s-1 .4-1 1v1.1c-4.2.4-7.5 3.7-7.9 7.9H2c-.6 0-1 .4-1 1s.4 1 1 1h1.1c.5 4.2 3.8 7.5 7.9 7.9V22c0 .6.4 1 1 1s1-.4 1-1v-1.1c4.2-.5 7.5-3.8 7.9-7.9H22c.6 0 1-.4 1-1s-.4-1-1-1zm-3 1c0 3.9-3.1 7-7 7s-7-3.1-7-7 3.1-7 7-7 7 3.1 7 7z"
  })
}));

/**
UiLocationAndroidLinedSmall icon

```jsx
import { UiLocationAndroidLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLocationAndroidLinedSmall />
```

 */
const UiLocationAndroidLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M15 7h-1.1c-.4-2.5-2.4-4.5-4.9-4.9V1c0-.6-.4-1-1-1S7 .4 7 1v1.1C4.5 2.5 2.5 4.5 2.1 7H1c-.6 0-1 .4-1 1s.4 1 1 1h1.1c.4 2.5 2.4 4.5 4.9 4.9V15c0 .6.4 1 1 1s1-.4 1-1v-1.1c2.5-.4 4.5-2.4 4.9-4.9H15c.6 0 1-.4 1-1s-.4-1-1-1zm-3 1c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4 4 1.8 4 4z"
  })
}));

/**
UiLocationFilled icon

```jsx
import { UiLocationFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLocationFilled />
```

 */
const UiLocationFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M19.575 2.21c-.299-.2-.797-.301-1.097-.1L2.524 11.15c-.399.202-.598.603-.499 1.005.1.402.4.703.798.804l7.479 1.406 2.792 7.032c.2.402.498.603.897.603h.1a.959.959 0 00.897-.703l4.986-18.082c.1-.302-.1-.704-.399-1.005z"
  })
}));

/**
UiLocationFilledSmall icon

```jsx
import { UiLocationFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLocationFilledSmall />
```

 */
const UiLocationFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-location-filled-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M14.1.2c-.3-.2-.7-.3-1.1-.1l-12 7c-.4.2-.6.7-.5 1.1.1.4.4.7.8.8l5.9.9 2.3 5.5c.2.4.6.6 1 .6h.1c.4 0 .8-.4.9-.8l3-14c.1-.4-.1-.8-.4-1z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-location-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiLocationLined icon

```jsx
import { UiLocationLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLocationLined />
```

 */
const UiLocationLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M19.575 2.21c-.299-.2-.797-.301-1.097-.1L2.524 11.15c-.399.202-.598.603-.499 1.005.1.402.4.703.798.804l7.479 1.406 2.792 7.032c.2.402.498.603.897.603h.1a.959.959 0 00.897-.703l4.986-18.082c.1-.302-.1-.704-.399-1.005zm-5.783 15.772l-1.895-4.822c-.1-.302-.399-.502-.698-.603l-5.285-1.005 11.467-6.53-3.59 12.96z"
  })
}));

/**
UiLocationLinedSmall icon

```jsx
import { UiLocationLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLocationLinedSmall />
```

 */
const UiLocationLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-location-lined-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M14.1.2c-.3-.2-.7-.3-1.1-.1l-12 7c-.4.2-.6.7-.5 1.1.1.4.4.7.8.8l5.9.9 2.3 5.5c.2.4.6.6 1 .6h.1c.4 0 .8-.4.9-.8l3-14c.1-.4-.1-.8-.4-1zm-3.9 11.5l-1.3-3c-.1-.4-.4-.6-.7-.7l-3.8-.6L12 3l-1.8 8.7z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-location-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiLockFilled icon

```jsx
import { UiLockFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLockFilled />
```

 */
const UiLockFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M18 8h-.5V7c0-3.03-2.47-5.5-5.5-5.5A5.51 5.51 0 006.5 7v1H6c-1.1 0-2 .9-2 2v5c0 3.31 2.69 6 6 6h4c3.31 0 6-2.69 6-6v-5c0-1.1-.9-2-2-2zM8.5 7c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5v1h-7V7zm4 7.91v1.59c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-1.59c-.58-.21-1-.76-1-1.41 0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5c0 .65-.42 1.2-1 1.41z"
  })
}));

/**
UiLockFilledSmall icon

```jsx
import { UiLockFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLockFilledSmall />
```

 */
const UiLockFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4v1c1.1 0 2 .9 2 2v4c0 2.21-1.79 4-4 4H6c-2.21 0-4-1.79-4-4V7c0-1.1.9-2 2-2V4c0-2.21 1.79-4 4-4s4 1.79 4 4zM8 2c-1.1 0-2 .9-2 2v1h4V4c0-1.1-.9-2-2-2zm1 8a1 1 0 11-2 0 1 1 0 012 0z"
  })
}));

/**
UiLockLined icon

```jsx
import { UiLockLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLockLined />
```

 */
const UiLockLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11.5 16.5v-1.59c-.58-.21-1-.76-1-1.41 0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5c0 .65-.42 1.2-1 1.41v1.59c0 .28-.22.5-.5.5s-.5-.22-.5-.5z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 8h.5c1.1 0 2 .9 2 2v5c0 3.31-2.69 6-6 6h-4c-3.31 0-6-2.69-6-6v-5c0-1.1.9-2 2-2h.5V7c0-3.03 2.47-5.5 5.5-5.5s5.5 2.47 5.5 5.5v1zM12 3.5c-1.93 0-3.5 1.57-3.5 3.5v1h7V7c0-1.93-1.57-3.5-3.5-3.5zM14 19c2.21 0 4-1.79 4-4v-5H6v5c0 2.21 1.79 4 4 4h4z"
  })]
}));

/**
UiLockLinedSmall icon

```jsx
import { UiLockLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLockLinedSmall />
```

 */
const UiLockLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9 10a1 1 0 11-2 0 1 1 0 012 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4v1c1.1 0 2 .9 2 2v4c0 2.21-1.79 4-4 4H6c-2.21 0-4-1.79-4-4V7c0-1.1.9-2 2-2V4c0-2.21 1.79-4 4-4s4 1.79 4 4zM8 2c-1.1 0-2 .9-2 2v1h4V4c0-1.1-.9-2-2-2zm2 11c1.1 0 2-.9 2-2V7H4v4c0 1.1.9 2 2 2h4z"
  })]
}));

/**
UiLockNoAccessFilled icon

```jsx
import { UiLockNoAccessFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLockNoAccessFilled />
```

 */
const UiLockNoAccessFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M18 8h-.5V7c0-3-2.5-5.5-5.5-5.5S6.5 4 6.5 7v1H6c-1.1 0-2 .9-2 2v5c0 3.3 2.7 6 6 6h4c3.3 0 6-2.7 6-6v-5c0-1.1-.9-2-2-2zm-3 7.8c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3L12 15.7l-1.5 1.5c-.2.2-.5.3-.7.3-.2 0-.6-.1-.8-.3-.4-.4-.4-1 0-1.4l1.5-1.5L9 12.7c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l1.6 1.5 1.5-1.5c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-1.5 1.5 1.6 1.6zm.5-7.8h-7V7c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5v1z"
  })
}));

/**
UiLockNoAccessFilledSmall icon

```jsx
import { UiLockNoAccessFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLockNoAccessFilledSmall />
```

 */
const UiLockNoAccessFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5V4c0-2.2-1.8-4-4-4S4 1.8 4 4v1c-1.1 0-2 .9-2 2v4c0 2.2 1.8 4 4 4h4c2.2 0 4-1.8 4-4V7c0-1.1-.9-2-2-2zM6 4c0-1.1.9-2 2-2s2 .9 2 2v1H6V4zm4.7 7.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3L8 11.4l-1.3 1.3c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L6.6 10 5.3 8.7c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0L8 8.6l1.3-1.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L9.4 10l1.3 1.3z"
  })
}));

/**
UiLockNoAccessLined icon

```jsx
import { UiLockNoAccessLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLockNoAccessLined />
```

 */
const UiLockNoAccessLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M10 17.3c-.2 0-.5-.1-.7-.3-.4-.4-.4-1.1 0-1.5l1.3-1.3-1.3-1.3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l1.3 1.3 1.3-1.2c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-1.3 1.3 1.3 1.3c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3L12 15.7 10.7 17c-.2.2-.5.3-.7.3z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 8h.5c1.1 0 2 .9 2 2v5c0 3.3-2.7 6-6 6h-4c-3.3 0-6-2.7-6-6v-5c0-1.1.9-2 2-2h.5V7C6.5 4 9 1.5 12 1.5S17.5 4 17.5 7v1zM12 3.5c-1.9 0-3.5 1.6-3.5 3.5v1h7V7c0-1.9-1.6-3.5-3.5-3.5zM14 19c2.2 0 4-1.8 4-4v-5H6v5c0 2.2 1.8 4 4 4h4z"
  })]
}));

/**
UiLockUnlockFilled icon

```jsx
import { UiLockUnlockFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLockUnlockFilled />
```

 */
const UiLockUnlockFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M18 8.58h-.14c.49-1.2.57-2.51.17-3.76a5.477 5.477 0 00-2.72-3.21C12.61.22 9.29 1.29 7.9 3.99l-.31.6a1.006 1.006 0 001.79.92l.31-.6c.88-1.72 3-2.4 4.71-1.52a3.46 3.46 0 011.73 2.04c.29.89.21 1.84-.22 2.67l-.22.42c-.01.02-.01.04-.02.06H6c-1.1 0-2 .9-2 2v5c0 3.31 2.69 6 6 6h4c3.31 0 6-2.69 6-6v-5a2 2 0 00-2-2zm-7.5 5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5c0 .65-.42 1.2-1 1.41v1.59c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-1.59c-.58-.21-1-.76-1-1.41z"
  })
}));

/**
UiLockUnlockFilledSmall icon

```jsx
import { UiLockUnlockFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLockUnlockFilledSmall />
```

 */
const UiLockUnlockFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9 2.4c.4.9.4 1.7.2 2.6 1.1.1 1.9.9 1.9 2v4c0 2.2-1.8 4-4 4H6c-2.2 0-4-1.8-4-4V7c0-1.1.9-2 2-2h6l.1-.3c.2-.5.2-1 0-1.5S9.5 2.3 9 2.1c-.9-.3-1.9 0-2.4.8-.3.5-.9.6-1.4.3-.5-.3-.6-.9-.3-1.4C5.9.2 8-.4 9.7.3c1 .4 1.8 1.1 2.2 2.1zM9 10a1 1 0 11-2 0 1 1 0 012 0z"
  })
}));

/**
UiLockUnlockLined icon

```jsx
import { UiLockUnlockLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLockUnlockLined />
```

 */
const UiLockUnlockLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11.5 17.078v-1.59a1.498 1.498 0 01.5-2.91c.83 0 1.5.67 1.5 1.5 0 .65-.42 1.2-1 1.41v1.59c0 .28-.22.5-.5.5s-.5-.22-.5-.5z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.88 8.578H18c1.1 0 2 .9 2 2.01v5c0 3.31-2.69 6-6 6h-4c-3.31 0-6-2.69-6-6v-5c0-1.1.9-2 2-2h9.67a.14.14 0 00.01-.03.14.14 0 01.01-.03l.22-.42c.88-1.71.2-3.83-1.52-4.71-.83-.43-1.78-.51-2.67-.22-.89.28-1.61.9-2.04 1.73l-.31.6c-.25.49-.85.68-1.34.43a.998.998 0 01-.44-1.35l.31-.6a5.443 5.443 0 013.21-2.72 5.45 5.45 0 014.19.34 5.498 5.498 0 012.58 6.97zm-3.88 11c2.21 0 4-1.79 4-4v-5H6v5c0 2.21 1.79 4 4 4h4z"
  })]
}));

/**
UiLockUnlockLinedSmall icon

```jsx
import { UiLockUnlockLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiLockUnlockLinedSmall />
```

 */
const UiLockUnlockLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9 10a1 1 0 11-2 0 1 1 0 012 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9 2.4c.4.9.4 1.7.2 2.6 1.1.1 1.9.9 1.9 2v4c0 2.2-1.8 4-4 4H6c-2.2 0-4-1.8-4-4V7c0-1.1.9-2 2-2h6l.1-.3c.2-.5.2-1 0-1.5S9.5 2.3 9 2.1c-.9-.3-1.9 0-2.4.8-.3.5-.9.6-1.4.3-.5-.3-.6-.9-.3-1.4C5.9.2 8-.4 9.7.3c1 .4 1.8 1.1 2.2 2.1zM10 13c1.1 0 2-.9 2-2V7H4v4c0 1.1.9 2 2 2h4z"
  })]
}));

/**
UiMagicBallFilled icon

```jsx
import { UiMagicBallFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMagicBallFilled />
```

 */
const UiMagicBallFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M6 9c0-1.1-.9-2-2-2h-.5c-.6 0-1-.4-1-1s.4-1 1-1H4c1.1 0 2-.9 2-2v-.5c0-.6.4-1 1-1s1 .4 1 1V3c0 1.1.9 2 2 2h.5c.6 0 1 .4 1 1s-.4 1-1 1H10c-1.1 0-2 .9-2 2v.5c0 .6-.4 1-1 1s-1-.4-1-1V9z"
  }), /*#__PURE__*/jsx("path", {
    d: "M21 11c0 2.5-1 4.8-2.8 6.5l.8 3.2c.1.3 0 .7-.2.9-.2.3-.5.4-.8.4H6c-.3 0-.6-.2-.8-.4-.2-.3-.3-.6-.2-.9l.8-3.2C4 15.8 3 13.5 3 11c0-.6.4-1 1-1s1 .4 1 1c0 1.9.8 3.7 2.1 5h9.8c1.3-1.3 2.1-3.1 2.1-5 0-3.9-3.1-7-7-7-.6 0-1-.4-1-1s.4-1 1-1c5 0 9 4 9 9z"
  })]
}));

/**
UiMagicBallLined icon

```jsx
import { UiMagicBallLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMagicBallLined />
```

 */
const UiMagicBallLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M6 9c0-1.1-.9-2-2-2h-.5c-.6 0-1-.4-1-1s.4-1 1-1H4c1.1 0 2-.9 2-2v-.5c0-.6.4-1 1-1s1 .4 1 1V3c0 1.1.9 2 2 2h.5c.6 0 1 .4 1 1s-.4 1-1 1H10c-1.1 0-2 .9-2 2v.5c0 .6-.4 1-1 1s-1-.4-1-1V9z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 11c0 2.5-1 4.8-2.8 6.5l.8 3.2c.1.3 0 .7-.2.9-.2.3-.5.4-.8.4H6c-.3 0-.6-.2-.8-.4-.2-.3-.3-.6-.2-.9l.8-3.2C4 15.8 3 13.5 3 11c0-.6.4-1 1-1s1 .4 1 1c0 1.9.8 3.7 2.1 5h9.8c1.3-1.3 2.1-3.1 2.1-5 0-3.9-3.1-7-7-7-.6 0-1-.4-1-1s.4-1 1-1c5 0 9 4 9 9zM7.8 18l-.5 2h9.4l-.5-2H7.8z"
  })]
}));

/**
UiMagicBallLinedSmall icon

```jsx
import { UiMagicBallLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMagicBallLinedSmall />
```

 */
const UiMagicBallLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M16 8c0 2.1-.8 4-2.1 5.4l.8.9c.3.3.4.7.2 1.1-.1.4-.5.6-.9.6H2c-.4 0-.8-.2-.9-.6-.2-.4-.1-.8.1-1.1l.9-.9C.8 12 0 10.1 0 8c0-.6.4-1 1-1s1 .4 1 1c0 2.1 1.1 3.9 2.7 5h6.6c1.6-1.1 2.7-2.9 2.7-5 0-3.3-2.7-6-6-6-.6 0-1-.4-1-1s.4-1 1-1c4.4 0 8 3.6 8 8z"
  }), /*#__PURE__*/jsx("path", {
    d: "M3 7c0-1.1-.9-2-2-2-.6 0-1-.4-1-1s.4-1 1-1c1.1 0 2-.9 2-2 0-.6.4-1 1-1s1 .4 1 1c0 1.1.9 2 2 2 .6 0 1 .4 1 1s-.4 1-1 1c-1.1 0-2 .9-2 2 0 .6-.4 1-1 1s-1-.4-1-1z"
  })]
}));

/**
UiMagicWandFilled icon

```jsx
import { UiMagicWandFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMagicWandFilled />
```

 */
const UiMagicWandFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M18.87 3.09a.14.14 0 01.26 0l.26.69a1.42 1.42 0 00.83.83l.69.26a.14.14 0 010 .26l-.69.26a1.42 1.42 0 00-.83.83l-.26.69a.14.14 0 01-.26 0l-.26-.69a1.42 1.42 0 00-.83-.83l-.69-.26a.14.14 0 010-.26l.69-.26a1.42 1.42 0 00.83-.83l.26-.69zM15.8 15.14a.21.21 0 01.324-.106.21.21 0 01.076.106l.38 1a2.09 2.09 0 001.25 1.25l1 .38a.21.21 0 010 .4l-1 .38a2.09 2.09 0 00-1.25 1.25l-.38 1a.21.21 0 01-.4 0l-.38-1a2.092 2.092 0 00-1.25-1.25l-1-.38a.21.21 0 010-.4l1-.38a2.092 2.092 0 001.25-1.25l.38-1zm-8-12a.21.21 0 01.4 0l.38 1a2.09 2.09 0 001.25 1.28l1 .38a.21.21 0 010 .4l-1 .38a2.09 2.09 0 00-1.25 1.25l-.38 1a.21.21 0 01-.4 0l-.38-1a2.09 2.09 0 00-1.25-1.25l-1-.38a.21.21 0 010-.4l1-.38a2.09 2.09 0 001.25-1.25l.38-1.03z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 10.22l2.08-2.05 1 1-2.07 2.07-1.01-1.02zM14.83 6c-.196 0-.39.04-.57.12-.179.07-.34.18-.47.32L3.44 16.79a1.48 1.48 0 00-.44 1c0 .2.04.397.12.58.082.172.19.33.32.47l1.68 1.68c.14.13.298.238.47.32a1.43 1.43 0 001.15 0 1.56 1.56 0 00.47-.32l10.35-10.31a1.56 1.56 0 00.32-.47 1.43 1.43 0 000-1.15 1.86 1.86 0 00-.32-.47l-1.68-1.68a1.858 1.858 0 00-.47-.32 1.43 1.43 0 00-.58-.12z"
  })]
}));

/**
UiMagicWandFilledSmall icon

```jsx
import { UiMagicWandFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMagicWandFilledSmall />
```

 */
const UiMagicWandFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M3.87 1.09a.14.14 0 01.26 0l.26.69a1.42 1.42 0 00.83.83l.69.26a.14.14 0 010 .26l-.69.26a1.42 1.42 0 00-.83.83l-.26.69a.14.14 0 01-.26 0l-.26-.69a1.42 1.42 0 00-.83-.83l-.69-.26a.14.14 0 010-.26l.69-.26a1.42 1.42 0 00.83-.83l.26-.69zm9 10a.14.14 0 01.26 0l.26.69a1.422 1.422 0 00.83.83l.69.26a.14.14 0 01.088.13.14.14 0 01-.088.13l-.69.26a1.422 1.422 0 00-.83.83l-.26.69a.14.14 0 01-.13.088.14.14 0 01-.13-.088l-.26-.69a1.422 1.422 0 00-.83-.83l-.69-.26a.14.14 0 010-.26l.69-.26a1.422 1.422 0 00.83-.83l.26-.69z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.82 5.42L12 3.28l.77.77-2.19 2.13-.76-.76zM11 1.43l-9.57 9.49a1.46 1.46 0 000 2.07L3 14.57A1.42 1.42 0 004 15a1.46 1.46 0 001-.43l9.48-9.49a1.459 1.459 0 000-2.07L13 1.43A1.42 1.42 0 0012 1a1.46 1.46 0 00-1 .43z"
  })]
}));

/**
UiMailboxFilled icon

```jsx
import { UiMailboxFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMailboxFilled />
```

 */
const UiMailboxFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M18 5h.5C21 5 23 7 23 9.5V18c0 .6-.4 1-1 1h-8v2c0 .6-.4 1-1 1s-1-.4-1-1V9.5c0-1.7-.7-3.3-1.8-4.5H14V2c0-.5.5-1 1-1h2c.5 0 1 .5 1 1v1c0 .5-.5 1-1 1h-1v7c1.1 0 2-.9 2-2V5zM1 9.5C1 7 3 5 5.5 5S10 7 10 9.5V19H2c-.6 0-1-.4-1-1V9.5z"
  })
}));

/**
UiMailboxFilledSmall icon

```jsx
import { UiMailboxFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMailboxFilledSmall />
```

 */
const UiMailboxFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M13 6V4c1.7 0 3 1.3 3 3v6c0 .6-.4 1-1 1h-5v1c0 .6-.4 1-1 1s-1-.4-1-1V7c0-1.1-.4-2.2-1-3h3V1c0-.6.4-1 1-1h2c.6 0 1 .4 1 1v1c0 .6-.4 1-1 1h-1v4c.6 0 1-.4 1-1zM0 7c0-1.7 1.3-3 3-3s3 1.3 3 3v7H1c-.6 0-1-.4-1-1V7z"
  })
}));

/**
UiMailboxLined icon

```jsx
import { UiMailboxLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMailboxLined />
```

 */
const UiMailboxLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M18.5 5H16V4h1c.5 0 1-.4 1-1V2c0-.5-.5-1-1-1h-2c-.6 0-1 .5-1 1v3H5.5C3 5 1 7 1 9.5V18c0 .5.5 1 1 1h10v2c0 .5.4 1 1 1s1-.5 1-1v-2h8c.5 0 1-.5 1-1V9.5C23 7 21 5 18.5 5zM3 17V9.5C3 8.1 4.1 7 5.5 7S8 8.1 8 9.5V17H3zm18 0H10V9.5c0-.9-.3-1.8-.8-2.5H14v3c0 .6.4 1 1 1s1-.4 1-1V7h2.5C19.9 7 21 8.1 21 9.5V17z"
  })
}));

/**
UiMailboxLinedSmall icon

```jsx
import { UiMailboxLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMailboxLinedSmall />
```

 */
const UiMailboxLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 4V3h1c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1h-2c-.6 0-1 .4-1 1v3H4C1.8 4 0 5.8 0 8v5c0 .6.4 1 1 1h7v1c0 .6.4 1 1 1s1-.4 1-1v-1h5c.6 0 1-.4 1-1V8c0-2.2-1.8-4-4-4zM2 12V8c0-1.1.9-2 2-2s2 .9 2 2v4H2zm12 0H8V8c0-.7-.2-1.4-.6-2H10v1c0 .6.4 1 1 1s1-.4 1-1V6c1.1 0 2 .9 2 2v4z"
  })
}));

/**
UiMapFilled icon

```jsx
import { UiMapFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMapFilled />
```

 */
const UiMapFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M21.6 3.2c-.3-.2-.6-.3-.9-.1L17 4.3v16.1l4.3-1.4c.4-.1.7-.5.7-.9V4c0-.3-.2-.6-.4-.8zM7 3.6L2.7 5.1c-.4.1-.7.5-.7.9v14c0 .3.2.6.4.8.2.1.4.2.6.2.1 0 .2 0 .3-.1L7 19.7V3.6zm8 1.3v16.2c-.05 0-.1-.025-.15-.05a.355.355 0 00-.15-.05L9 19.1V3s.1 0 .1.1h.2L15 4.9z"
  })
}));

/**
UiMapFilledSmall icon

```jsx
import { UiMapFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMapFilledSmall />
```

 */
const UiMapFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14.5 1.1c-.3-.2-.7-.2-1 0l-1.5.8v12.2l2.4-1.2c.3-.2.6-.5.6-.9V2c0-.3-.2-.7-.5-.9zM4 1.9L1.6 3.1c-.4.2-.6.5-.6.9v10c0 .3.2.7.5.9.1.1.3.1.5.1s.3 0 .4-.1l1.6-.8V1.9zm6 1V15c-.1 0-.3 0-.4-.1L6 13.1V1s.1 0 .1.1h.3L10 2.9z"
  })
}));

/**
UiMapLined icon

```jsx
import { UiMapLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMapLined />
```

 */
const UiMapLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M21.6 3.2c-.3-.2-.6-.3-.9-.1L15 4.9 9.3 3.1h-.2C9.1 3 9 3 9 3h-.3l-6 2c-.4.2-.7.6-.7 1v14c0 .3.2.6.4.8.2.1.4.2.6.2.1 0 .2 0 .3-.1L9 19.1l5.7 1.9c.1 0 .2.1.3.1.1 0 .2 0 .3-.1l6-2c.4-.1.7-.5.7-.9V4c0-.3-.2-.6-.4-.8zM4 6.7l4-1.3v11.9l-4 1.3V6.7zm6-1.3l4 1.3v11.9l-4-1.3V5.4zm10 11.9l-4 1.3V6.7l4-1.3v11.9z"
  })
}));

/**
UiMapLinedSmall icon

```jsx
import { UiMapLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMapLinedSmall />
```

 */
const UiMapLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14.5 1.1c-.3-.2-.7-.2-1 0L10 2.9 6.4 1.1h-.3C6.1 1 6 1 6 1h-.4l-4 2c-.4.3-.6.6-.6 1v10c0 .3.2.7.5.9.1.1.3.1.5.1s.3 0 .4-.1L6 13.1l3.6 1.8c.1.1.3.1.4.1.1 0 .3 0 .4-.1l4-2c.3-.2.6-.5.6-.9V2c0-.3-.2-.7-.5-.9zM5 11.4l-2 1V4.6l2-1v7.8zm4 1l-2-1V3.6l2 1v7.8zm4-1l-2 1V4.6l2-1v7.8z"
  })
}));

/**
UiMapPinFilled icon

```jsx
import { UiMapPinFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMapPinFilled />
```

 */
const UiMapPinFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63 3.64c3.52-3.51 9.22-3.51 12.73 0 3.15 3.14 3.47 8.04.98 11.56a.202.202 0 00-.008.02.051.051 0 01-.012.02l-.05.06c-.2.28-5.73 6.99-5.73 6.99-.8.97-2.29.97-3.09 0 0 0-5.53-6.71-5.73-6.99l-.05-.06a.188.188 0 01-.008-.019c-.004-.008-.006-.014-.012-.02-2.49-3.52-2.17-8.41.98-11.56zM8.5 10A3.51 3.51 0 0112 6.5a3.51 3.51 0 013.5 3.5 3.51 3.51 0 01-3.5 3.5A3.51 3.51 0 018.5 10z"
  })
}));

/**
UiMapPinFilledSmall icon

```jsx
import { UiMapPinFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMapPinFilledSmall />
```

 */
const UiMapPinFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-map-pin-filled-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M12.23 1.76A5.928 5.928 0 007.99 0c-1.6 0-3.11.62-4.25 1.76C2.05 3.45 1.6 5.91 2.36 8.02c.14.42.33.82.57 1.2l.11.17 4.11 6.17a1 1 0 001.66 0l4.11-6.17.11-.17c.24-.38.42-.78.57-1.19.77-2.12.32-4.58-1.37-6.27zM7.99 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-map-pin-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiMapPinLined icon

```jsx
import { UiMapPinLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMapPinLined />
```

 */
const UiMapPinLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10c0-2.2 1.8-4 4-4s4 1.8 4 4-1.8 4-4 4-4-1.8-4-4zm2 0c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1c2.3 0 4.6.9 6.4 2.6 3.1 3.2 3.4 8.1.8 11.6v.1c-.2.3-5.7 7-5.7 7-.4.5-.9.7-1.5.7s-1.1-.2-1.7-.7c0 0-5.5-6.7-5.7-7v-.1c-2.5-3.6-2.2-8.5 1-11.6C7.4 1.9 9.7 1 12 1zm5.6 13.1l.1-.1c2-2.8 1.7-6.5-.7-9-1.4-1.3-3.1-2-5-2s-3.6.7-4.9 2c-2.4 2.5-2.8 6.2-.8 9l.1.1c.4.5 3.6 4.5 5.6 6.9 2-2.4 5.2-6.3 5.6-6.9z"
  })]
}));

/**
UiMapPinLinedSmall icon

```jsx
import { UiMapPinLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMapPinLinedSmall />
```

 */
const UiMapPinLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M7.99 2c1.07 0 2.07.42 2.83 1.17 1.08 1.08 1.44 2.72.92 4.18-.12.31-.24.57-.36.76l-.11.17-3.28 4.92L4.7 8.28l-.08-.14c-.15-.22-.27-.48-.38-.79-.52-1.46-.16-3.1.92-4.18C5.91 2.42 6.92 2 7.99 2zm0-2c-1.6 0-3.11.62-4.25 1.76C2.05 3.45 1.6 5.91 2.36 8.02c.14.42.33.82.57 1.2l.11.17 4.11 6.17c.2.29.52.44.84.44a1 1 0 00.83-.44l4.11-6.17.11-.17c.24-.38.42-.78.57-1.19.76-2.12.31-4.57-1.39-6.27A5.889 5.889 0 007.99 0zm2 6c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2z"
  })
}));

/**
UiMegaphoneFilled icon

```jsx
import { UiMegaphoneFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMegaphoneFilled />
```

 */
const UiMegaphoneFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M19.4 3.1c-.3-.2-.7-.1-1 .1 0 0-3.8 2.8-7.6 2.8H7v13c0 1.7 1.3 3 3 3 .6 0 1-.4 1-1v-4c2 .1 4 1.1 5.4 1.9 1.1.6 1.9 1 2.6 1 .3 0 .5-.1.7-.3.2-.2.3-.3.3-.6V4c0-.4-.2-.7-.6-.9zM1 11.5c0 2.9 2.2 5.2 5 5.5V6c-2.8.3-5 2.6-5 5.5zm22 0c0 1.3-.8 2.4-2 2.8V8.7c1.2.4 2 1.5 2 2.8z"
  })
}));

/**
UiMegaphoneFilledSmall icon

```jsx
import { UiMegaphoneFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMegaphoneFilledSmall />
```

 */
const UiMegaphoneFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M13 2v12c0 .4-.3.7-.6.9-.1.1-.2.1-.4.1s-.4-.1-.6-.2C9.8 13.6 7.1 12 6 12v2c0 .6-.4 1-1 1s-1-.4-1-1V4h2c2.5 0 5.3-2.7 5.3-2.7.3-.3.7-.4 1.1-.2.4.1.6.5.6.9zM3 4.1c-1.7.5-3 2-3 3.9s1.3 3.4 3 3.9V4.1zM16 8c0-1.3-.8-2.4-2-2.8v5.6c1.2-.4 2-1.5 2-2.8z"
  })
}));

/**
UiMegaphoneLined icon

```jsx
import { UiMegaphoneLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMegaphoneLined />
```

 */
const UiMegaphoneLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 8.5V4c0-.4-.2-.7-.6-.9-.3-.2-.7-.1-1 .1 0 0-3.8 2.8-7.6 2.8H6.5C3.5 6 1 8.5 1 11.5S3.5 17 6.5 17H7v2c0 1.7 1.3 3 3 3h1c.6 0 1-.4 1-1v-3.9c1.7.3 3.2 1.2 4.4 1.8 1.1.6 1.9 1 2.6 1 .6 0 1-.4 1-1v-4.5c1.7 0 3-1.3 3-3s-1.3-2.9-3-2.9zm-17 3C3 9.6 4.6 8 6.5 8H7v7h-.5C4.6 15 3 13.4 3 11.5zM9 19v-2h1v3c-.6 0-1-.4-1-1zm9-1.4c-.2-.1-.4-.2-.6-.4-1.7-.9-4-2.2-6.6-2.2H9V8h1.8c2.9 0 5.6-1.2 7.2-2.2v11.8zm2-5.1v-2c.6 0 1 .4 1 1s-.4 1-1 1z"
  })
}));

/**
UiMegaphoneLinedSmall icon

```jsx
import { UiMegaphoneLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMegaphoneLinedSmall />
```

 */
const UiMegaphoneLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M13 5V2c0-.4-.2-.8-.6-.9-.4-.2-.8-.1-1.1.2C11.3 1.3 8.5 4 6 4H4C1.8 4 0 5.8 0 8c0 2.1 1.6 3.8 3.7 4v2c0 .6.4 1 1 1s1-.4 1-1v-2H6c1.1 0 3.8 1.6 5.4 2.8.2.1.4.2.6.2.2 0 .3 0 .4-.1.3-.2.6-.5.6-.9v-3c1.7 0 3-1.3 3-3s-1.3-3-3-3zM2 8c0-1 .7-1.8 1.7-2v4C2.7 9.8 2 9 2 8zm9 4.1c-1.5-1-3.5-2.1-5-2.1h-.3V6H6c1.9 0 3.7-1 5-1.9v8zM13 9V7c.6 0 1 .4 1 1s-.4 1-1 1z"
  })
}));

/**
UiMenuLined icon

```jsx
import { UiMenuLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMenuLined />
```

 */
const UiMenuLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M5 7h14c.6 0 1-.4 1-1s-.4-1-1-1H5c-.6 0-1 .4-1 1s.4 1 1 1zm14 10H5c-.6 0-1 .4-1 1s.4 1 1 1h14c.6 0 1-.4 1-1s-.4-1-1-1zm0-6H5c-.6 0-1 .4-1 1s.4 1 1 1h14c.6 0 1-.4 1-1s-.4-1-1-1z"
  })
}));

/**
UiMenuLinedSmall icon

```jsx
import { UiMenuLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMenuLinedSmall />
```

 */
const UiMenuLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M3 5h10c.6 0 1-.4 1-1s-.4-1-1-1H3c-.6 0-1 .4-1 1s.4 1 1 1zm10 6H3c-.6 0-1 .4-1 1s.4 1 1 1h10c.6 0 1-.4 1-1s-.4-1-1-1zm0-4H3c-.6 0-1 .4-1 1s.4 1 1 1h10c.6 0 1-.4 1-1s-.4-1-1-1z"
  })
}));

/**
UiMessagesLined icon

```jsx
import { UiMessagesLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMessagesLined />
```

 */
const UiMessagesLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3h16c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2zm2 6.8c.1.1.3.2.5.2.3 0 .5-.1.6-.3l3.5-4.4c.3-.4.2-.8-.1-1.1-.4-.3-.8-.2-1.1.1l-3 3.8L5.3 7c-.3-.3-.8-.3-1.1 0-.3.3-.3.7 0 1L6 9.8zM4 13h16c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2zm0 2v4h16v-4H4z"
  })
}));

/**
UiMessagesLinedSmall icon

```jsx
import { UiMessagesLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMessagesLinedSmall />
```

 */
const UiMessagesLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 0h14c.6 0 1 .4 1 1v5c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1zm4.1 5.7l2.5-3.5c.3-.4.2-.8-.1-1.1-.3-.2-.8-.1-1 .2l-2 2.8-.9-.9c-.3-.3-.8-.3-1.1 0-.3.3-.3.8 0 1.1L4 5.8c.1.1.3.2.5.2h.1c.2 0 .4-.1.5-.3zM1 9h14c.6 0 1 .4 1 1v5c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1v-5c0-.6.4-1 1-1zm1 5h12v-3H2v3z"
  })
}));

/**
UiMicrophoneFilled icon

```jsx
import { UiMicrophoneFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMicrophoneFilled />
```

 */
const UiMicrophoneFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M16 12c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-2.21 1.79-4 4-4s4 1.79 4 4v7z"
  }), /*#__PURE__*/jsx("path", {
    d: "M19 11c.55 0 1 .45 1 1 0 4.07-3.06 7.44-7 7.93V22c0 .55-.45 1-1 1s-1-.45-1-1v-2.07c-3.94-.49-7-3.86-7-7.93 0-.55.45-1 1-1s1 .45 1 1c0 3.31 2.69 6 6 6s6-2.69 6-6c0-.55.45-1 1-1z"
  })]
}));

/**
UiMicrophoneFilledSmall icon

```jsx
import { UiMicrophoneFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMicrophoneFilledSmall />
```

 */
const UiMicrophoneFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11 8c0 1.7-1.3 3-3 3S5 9.7 5 8V3c0-1.7 1.3-3 3-3s3 1.3 3 3v5z"
  }), /*#__PURE__*/jsx("path", {
    d: "M13 7c.6 0 1 .4 1 1 0 3-2.2 5.4-5 5.9V15c0 .6-.4 1-1 1s-1-.4-1-1v-1.1C4.2 13.4 2 11 2 8c0-.6.4-1 1-1s1 .4 1 1c0 2.2 1.8 4 4 4s4-1.8 4-4c0-.6.4-1 1-1z"
  })]
}));

/**
UiMicrophoneLined icon

```jsx
import { UiMicrophoneLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMicrophoneLined />
```

 */
const UiMicrophoneLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 12c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-2.21 1.79-4 4-4s4 1.79 4 4v7zm-4-9c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2s2-.9 2-2V5c0-1.1-.9-2-2-2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M19 11c.55 0 1 .45 1 1 0 4.07-3.06 7.44-7 7.93V22c0 .55-.45 1-1 1s-1-.45-1-1v-2.07c-3.94-.49-7-3.86-7-7.93 0-.55.45-1 1-1s1 .45 1 1c0 3.31 2.69 6 6 6s6-2.69 6-6c0-.55.45-1 1-1z"
  })]
}));

/**
UiMicrophoneLinedSmall icon

```jsx
import { UiMicrophoneLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMicrophoneLinedSmall />
```

 */
const UiMicrophoneLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 8c0 1.7-1.3 3-3 3S5 9.7 5 8V3c0-1.7 1.3-3 3-3s3 1.3 3 3v5zM8 2c-.6 0-1 .4-1 1v5c0 .6.4 1 1 1s1-.4 1-1V3c0-.6-.4-1-1-1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M13 7c.6 0 1 .4 1 1 0 3-2.2 5.4-5 5.9V15c0 .6-.4 1-1 1s-1-.4-1-1v-1.1C4.2 13.4 2 11 2 8c0-.6.4-1 1-1s1 .4 1 1c0 2.2 1.8 4 4 4s4-1.8 4-4c0-.6.4-1 1-1z"
  })]
}));

/**
UiMileageFilled icon

```jsx
import { UiMileageFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMileageFilled />
```

 */
const UiMileageFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M8 17H6a1 1 0 00-1 1v3a1 1 0 001 1h2a1 1 0 001-1v-3a1 1 0 00-1-1zm5 0h-2a1 1 0 00-1 1v3a1 1 0 001 1h2a1 1 0 001-1v-3a1 1 0 00-1-1zm5.5 0h-3a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5zm-.5 4h-2v-3h2v3zM12 2a10 10 0 00-9.42 13.33 1 1 0 00.94.67h17a1 1 0 00.94-.67A10 10 0 0012 2zm0 3a1 1 0 110 2 1 1 0 010-2zm-6 8a1 1 0 110-2 1 1 0 010 2zm2.46-4.54a1 1 0 11-1.418-1.41A1 1 0 018.46 8.46zM12 14h-.11a1.848 1.848 0 01-1.33-.56A1.81 1.81 0 0110 12a1.85 1.85 0 01.72-1.37L15.64 7A1 1 0 0117 8.36l-3.62 4.86A1.879 1.879 0 0112 14zm6-1a1 1 0 110-2 1 1 0 010 2z"
  })
}));

/**
UiMileageLined icon

```jsx
import { UiMileageLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMileageLined />
```

 */
const UiMileageLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M10 12a1.809 1.809 0 00.55 1.44 1.849 1.849 0 001.33.56H12a1.88 1.88 0 001.39-.74L17 8.36A1 1 0 0015.64 7l-4.88 3.6A1.85 1.85 0 0010 12zm8 1a1 1 0 100-2 1 1 0 000 2zm-6-6a1 1 0 100-2 1 1 0 000 2zM8.46 8.46a1 1 0 10-1.41-1.418A1 1 0 008.46 8.46zM6 13a1 1 0 100-2 1 1 0 000 2zm2 4H6a1 1 0 00-1 1v3a1 1 0 001 1h2a1 1 0 001-1v-3a1 1 0 00-1-1zm5 0h-2a1 1 0 00-1 1v3a1 1 0 001 1h2a1 1 0 001-1v-3a1 1 0 00-1-1zm5.5 0h-3a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5zm-.5 4h-2v-3h2v3z"
  }), /*#__PURE__*/jsx("path", {
    d: "M18.67 4.55a10 10 0 00-16.6 6.28 10 10 0 00.33 3.95 1 1 0 101.92-.56 8 8 0 0110.112-9.846A7.93 7.93 0 0117.34 6.05 8 8 0 0120 12a7.794 7.794 0 01-.33 2.21.999.999 0 00.67 1.25.9.9 0 00.28 0 1.001 1.001 0 001-.71A9.74 9.74 0 0022 12a10 10 0 00-3.33-7.45z"
  })]
}));

/**
UiMinusEncircledFilled icon

```jsx
import { UiMinusEncircledFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMinusEncircledFilled />
```

 */
const UiMinusEncircledFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4 11H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1z"
  })
}));

/**
UiMinusEncircledFilledSmall icon

```jsx
import { UiMinusEncircledFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMinusEncircledFilledSmall />
```

 */
const UiMinusEncircledFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8-8-3.6-8-8zm5-1a1 1 0 000 2h6a1 1 0 100-2H5z"
  })
}));

/**
UiMinusEncircledLined icon

```jsx
import { UiMinusEncircledLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMinusEncircledLined />
```

 */
const UiMinusEncircledLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M7 12c0-.55.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1H8c-.55 0-1-.45-1-1z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm2 0c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8-8 3.59-8 8z"
  })]
}));

/**
UiMinusEncircledLinedSmall icon

```jsx
import { UiMinusEncircledLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMinusEncircledLinedSmall />
```

 */
const UiMinusEncircledLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8-8-3.6-8-8zm2 0c0 3.3 2.7 6 6 6s6-2.7 6-6-2.7-6-6-6-6 2.7-6 6zm3-1a1 1 0 000 2h6a1 1 0 100-2H5z"
  })
}));

/**
UiMinusLined icon

```jsx
import { UiMinusLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMinusLined />
```

 */
const UiMinusLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M21 13H3c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1z"
  })
}));

/**
UiMinusLinedSmall icon

```jsx
import { UiMinusLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMinusLinedSmall />
```

 */
const UiMinusLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("rect", {
    y: 7,
    width: 16,
    height: 2,
    rx: 1
  })
}));

/**
UiModalLined icon

```jsx
import { UiModalLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiModalLined />
```

 */
const UiModalLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 4c-1.102 0-2 .898-2 2v6H2c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-1h8c1.102 0 2-.898 2-2V6c0-1.102-.898-2-2-2H7zm6 12h8V6H7v6h5c.55 0 1 .45 1 1v3z"
  })
}));

/**
UiModalLinedSmall icon

```jsx
import { UiModalLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiModalLinedSmall />
```

 */
const UiModalLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2c-1.102 0-2 .898-2 2v3.5H1c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V13h3c1.102 0 2-.898 2-2V4c0-1.102-.898-2-2-2H4zm7 9h3V4H4v3.5h6c.55 0 1 .45 1 1V11z"
  })
}));

/**
UiMoneyBagFilled icon

```jsx
import { UiMoneyBagFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyBagFilled />
```

 */
const UiMoneyBagFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M17.46 7.993H6.55C4.99 9.744 3 12.635 3 15.997c0 3.211 1.15 4.992 2.11 5.922C5.83 22.62 6.8 23 7.85 23h8.3c1.04 0 2.02-.38 2.74-1.08.96-.93 2.11-2.712 2.11-5.923.01-3.362-1.98-6.253-3.54-8.004zm-6.45 3.122v-.12c0-.55.45-1 1-1s1 .45 1 1v.19c.73.23 1.23.6 1.31.66.44.34.52.97.18 1.4-.34.43-.96.51-1.4.18-.02-.01-.59-.43-1.24-.43-.01 0-.85.01-.85.57 0 .43.12.51.47.631l1.75.71c1.11.38 1.77 1.3 1.77 2.501 0 1.431-.95 2.291-2 2.522v.07c0 .55-.45 1-1 1s-1-.45-1-1v-.18c-.87-.22-1.44-.55-1.53-.6a1.003 1.003 0 011.06-1.7c0-.002.82.489 1.93.489.09 0 .54-.03.54-.58 0-.29-.08-.49-.47-.63l-1.75-.711c-1.46-.5-1.77-1.64-1.77-2.501 0-1.34.93-2.181 2-2.471zm5.62-5.123l1.28-2.55c.17-.351.13-.771-.11-1.071-.25-.3-.65-.44-1.02-.34-1.88.47-2.3.2-2.87-.17C13.35 1.5 12.59 1 11.02 1 7.77 1 6.53 2.08 6.31 2.29c-.3.3-.38.77-.19 1.151L7.4 5.992h9.23z"
  })
}));

/**
UiMoneyBagFilledSmall icon

```jsx
import { UiMoneyBagFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyBagFilledSmall />
```

 */
const UiMoneyBagFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12.8 1.9L10.7 4H5.3L3.1 1.9c-.1-.2-.1-.6 0-.8a.492.492 0 00.13-.077C3.596.773 4.735 0 7 0c1.2 0 1.9.4 2.5.8.7.4 1.3.7 2.8.2.3 0 .5 0 .6.2.1.2.1.5-.1.7z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4 5h7.2c1.3 1.2 3.4 3.5 3.4 6 0 2.9-2.2 4.2-3.1 4.7-.4.2-.8.3-1.3.3H5.4c-.5 0-.9-.1-1.3-.3C3.2 15.2 1 13.9 1 11c0-2.5 2.1-4.8 3.4-6zm4.69 4.57c.88.3 1.41 1.01 1.41 1.94 0 1.18-.86 1.86-1.75 1.95v.02c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-.16a4.76 4.76 0 01-1.14-.45.751.751 0 11.8-1.27c.14.08.77.38 1.58.38.08 0 .5-.02.5-.49 0-.2-.03-.4-.42-.53l-.98-.38-.44-.17c-1.16-.38-1.41-1.27-1.41-1.94 0-.99.69-1.63 1.5-1.87v-.11c0-.41.34-.75.75-.75s.75.34.75.75v.1c.65.155 1.103.48 1.193.545l.007.005c.33.25.4.72.15 1.05a.741.741 0 01-1.04.15l-.014-.009C8.95 8.276 8.505 7.99 8 7.99c-.01 0-.75.01-.75.49 0 .34.09.42.42.53l.78.31.64.25z"
  })]
}));

/**
UiMoneyBagLined icon

```jsx
import { UiMoneyBagLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyBagLined />
```

 */
const UiMoneyBagLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M17.38 7.913c.36-.15.62-.51.62-.92 0-.55-.45-1-1-1h-.38L17.9 3.44c.17-.35.13-.77-.11-1.07-.25-.3-.65-.44-1.02-.34-1.88.47-2.3.2-2.87-.17-.56-.36-1.32-.86-2.89-.86C7.76 1 6.52 2.08 6.3 2.29c-.3.3-.38.77-.19 1.151l1.28 2.551H7c-.55 0-1 .45-1 1 0 .42.25.771.62.921C5.05 9.653 3 12.575 3 15.997c0 3.211 1.15 4.992 2.11 5.922C5.83 22.62 6.8 23 7.85 23h8.3c1.04 0 2.02-.38 2.74-1.08.96-.93 2.11-2.712 2.11-5.923 0-3.412-2.05-6.343-3.62-8.084zM11 2.991c.98 0 1.34.24 1.8.54.66.43 1.32.77 2.44.74l-.86 1.721H9.62l-1.3-2.6C8.83 3.2 9.69 2.99 11 2.99zm6.5 17.488c-.35.33-.82.52-1.35.52h-8.3c-.52 0-1-.18-1.35-.52-.68-.66-1.5-1.971-1.5-4.482 0-3.832 3.4-7.143 4.37-8.004h5.26c.97.86 4.37 4.172 4.37 8.004 0 2.511-.82 3.822-1.5 4.482z"
  }), /*#__PURE__*/jsx("path", {
    d: "M13.23 13.916l-1.75-.71c-.35-.12-.47-.2-.47-.63 0-.571.84-.571.85-.571.65 0 1.22.42 1.24.43.44.33 1.06.25 1.4-.18a.993.993 0 00-.18-1.4c-.08-.06-.58-.43-1.31-.66v-.2c0-.551-.45-1.001-1-1.001s-1 .45-1 1v.12c-1.07.29-2 1.12-2 2.451 0 .87.32 2.011 1.77 2.501l1.75.71c.4.14.47.33.47.631 0 .55-.45.58-.54.58-1.11 0-1.93-.49-1.93-.49-.47-.29-1.08-.15-1.38.32-.29.47-.15 1.09.32 1.38.09.05.66.391 1.53.601v.2c0 .55.45 1 1 1s1-.45 1-1v-.06c1.05-.22 2-1.08 2-2.521 0-1.2-.67-2.121-1.77-2.501z"
  })]
}));

/**
UiMoneyBagSmallFilled icon

```jsx
import { UiMoneyBagSmallFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyBagSmallFilled />
```

 */
const UiMoneyBagSmallFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12.8 1.9L10.7 4H5.3L3.1 1.9c-.1-.2-.1-.6 0-.8a.492.492 0 00.13-.077C3.596.773 4.735 0 7 0c1.2 0 1.9.4 2.5.8.7.4 1.3.7 2.8.2.3 0 .5 0 .6.2.1.2.1.5-.1.7z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4 5h7.2c1.3 1.2 3.4 3.5 3.4 6 0 2.9-2.2 4.2-3.1 4.7-.4.2-.8.3-1.3.3H5.4c-.5 0-.9-.1-1.3-.3C3.2 15.2 1 13.9 1 11c0-2.5 2.1-4.8 3.4-6zm4.69 4.57c.88.3 1.41 1.01 1.41 1.94 0 1.18-.86 1.86-1.75 1.95v.02c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-.16a4.76 4.76 0 01-1.14-.45.751.751 0 11.8-1.27c.14.08.77.38 1.58.38.08 0 .5-.02.5-.49 0-.2-.03-.4-.42-.53l-.98-.38-.44-.17c-1.16-.38-1.41-1.27-1.41-1.94 0-.99.69-1.63 1.5-1.87v-.11c0-.41.34-.75.75-.75s.75.34.75.75v.1c.65.155 1.103.48 1.193.545l.007.005c.33.25.4.72.15 1.05a.741.741 0 01-1.04.15l-.014-.009C8.95 8.276 8.505 7.99 8 7.99c-.01 0-.75.01-.75.49 0 .34.09.42.42.53l.78.31.64.25z"
  })]
}));

/**
UiMoneyBagUkFilled icon

```jsx
import { UiMoneyBagUkFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyBagUkFilled />
```

 */
const UiMoneyBagUkFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M7.4 6L6.1 3.4c-.2-.3-.1-.8.2-1.1C6.5 2.1 7.8 1 11 1c1.391 0 2.102.378 2.658.674.084.044.164.087.242.126l.033.022c.582.389 1.002.669 2.867.178.4-.1.8 0 1 .3.2.3.3.8.1 1.1L16.6 6H7.4z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 8c1.5 1.7 3.5 4.6 3.4 8 0 3.2-1.1 5-2.1 5.9-.7.7-1.7 1.1-2.7 1.1H7.8c-1 0-2-.4-2.7-1.1C4.1 21 3 19.2 3 16c0-3.4 2-6.3 3.5-8h11zm-5 2c-1.5 0-2.8 1.3-2.8 2.8V14H9c-.6 0-1 .4-1 1s.4 1 1 1h.7v.3c0 1.3-1.1 1.8-1.1 1.8-.5.2-.7.6-.6 1.1.1.5.5.8 1 .8h5c.6 0 1-.4 1-1s-.4-1-1-1h-2.7c.2-.5.4-1 .4-1.7V16H13c.6 0 1-.4 1-1s-.4-1-1-1h-1.2v-1.2c0-.4.3-.8.7-.8.2 0 .5.2.6.5.3.5.9.7 1.4.4.5-.3.7-.9.4-1.4-.5-.9-1.4-1.5-2.4-1.5z"
  })]
}));

/**
UiMoneyBagUkFilledSmall icon

```jsx
import { UiMoneyBagUkFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyBagUkFilledSmall />
```

 */
const UiMoneyBagUkFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M10.7 4l2.1-2.1c.2-.2.2-.5.1-.7-.1-.2-.3-.2-.6-.2-1.5.5-2.1.2-2.8-.2C8.9.4 8.2 0 7 0 4.736 0 3.597.774 3.23 1.023a.492.492 0 01-.13.077c-.1.2-.1.6 0 .8L5.3 4h5.4z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6 5H4.4C3.1 6.2 1 8.5 1 11c0 2.9 2.2 4.2 3.1 4.7.4.2.8.3 1.3.3h5.2c.5 0 .9-.1 1.3-.3.9-.5 3.1-1.8 3.1-4.7 0-2.5-2.1-4.8-3.4-6zm-1.1 3.1c.4-.2.5-.6.3-1-.4-.7-1.2-1.1-2-1.1-1.2 0-2.2 1-2.2 2.2v1.3h-.8c-.4 0-.8.2-.8.7 0 .5.4.8.8.8h.7v.1c0 1-1 1.5-1 1.5-.3.1-.5.4-.4.8 0 .3.3.6.7.6h4c.4 0 .8-.2.8-.7 0-.5-.4-.8-.8-.8H7.6c.3-.4.4-.8.4-1.4V11h.8c.4 0 .8-.2.8-.7 0-.5-.4-.8-.8-.8H8V8.3c0-.5.4-.8.8-.8.3 0 .5.1.7.3.2.4.6.5 1 .3z"
  })]
}));

/**
UiMoneyBagUkLined icon

```jsx
import { UiMoneyBagUkLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyBagUkLined />
```

 */
const UiMoneyBagUkLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11.4 17H14c.6 0 1 .4 1 1s-.4 1-1 1H9c-.5 0-.9-.3-1-.8-.1-.4.2-.9.6-1.1 0 0 1.1-.6 1.1-1.8V15H9c-.6 0-1-.4-1-1s.4-1 1-1h.7v-1.2C9.7 10.3 11 9 12.5 9c1 0 1.9.6 2.3 1.5.3.5.1 1.1-.4 1.4-.5.3-1.1.1-1.4-.4-.1-.3-.4-.5-.6-.5-.4 0-.7.3-.7.8V13H13c.6 0 1 .4 1 1s-.4 1-1 1h-1.2v.3c0 .7-.2 1.2-.4 1.7z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 7c0 .4-.3.8-.6.9C19 9.7 21 12.6 20.9 16c0 3.2-1.1 5-2.1 5.9-.7.7-1.7 1.1-2.7 1.1H7.8c-1 0-2-.4-2.7-1.1C4.1 21 3 19.2 3 16c0-3.4 2-6.3 3.6-8.1-.3-.1-.6-.5-.6-.9 0-.6.4-1 1-1h.4L6.1 3.4c-.2-.3-.1-.8.2-1.1C6.5 2.1 7.8 1 11 1c1.391 0 2.102.378 2.658.674.084.044.164.087.242.126l.033.022c.582.389 1.002.669 2.867.178.4-.1.8 0 1 .3.2.3.3.8.1 1.1L16.6 6h.4c.6 0 1 .4 1 1zm-5.247-3.528C12.28 3.188 11.968 3 11 3c-1.3 0-2.2.2-2.7.4L9.6 6h4.8l.8-1.8c-1.025.093-1.616-.248-2.258-.618a42.533 42.533 0 00-.189-.11zM16.2 21c.5 0 1-.2 1.3-.5.7-.7 1.5-2 1.6-4.5 0-3.8-3.4-7.1-4.4-8H9.4c-1 .9-4.4 4.2-4.4 8 0 2.5.8 3.8 1.5 4.5.3.3.8.5 1.3.5h8.4z"
  })]
}));

/**
UiMoneyBagUkSmallFilled icon

```jsx
import { UiMoneyBagUkSmallFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyBagUkSmallFilled />
```

 */
const UiMoneyBagUkSmallFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M10.7 4l2.1-2.1c.2-.2.2-.5.1-.7-.1-.2-.3-.2-.6-.2-1.5.5-2.1.2-2.8-.2C8.9.4 8.2 0 7 0 4.736 0 3.597.774 3.23 1.023a.492.492 0 01-.13.077c-.1.2-.1.6 0 .8L5.3 4h5.4z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6 5H4.4C3.1 6.2 1 8.5 1 11c0 2.9 2.2 4.2 3.1 4.7.4.2.8.3 1.3.3h5.2c.5 0 .9-.1 1.3-.3.9-.5 3.1-1.8 3.1-4.7 0-2.5-2.1-4.8-3.4-6zm-1.1 3.1c.4-.2.5-.6.3-1-.4-.7-1.2-1.1-2-1.1-1.2 0-2.2 1-2.2 2.2v1.3h-.8c-.4 0-.8.2-.8.7 0 .5.4.8.8.8h.7v.1c0 1-1 1.5-1 1.5-.3.1-.5.4-.4.8 0 .3.3.6.7.6h4c.4 0 .8-.2.8-.7 0-.5-.4-.8-.8-.8H7.6c.3-.4.4-.8.4-1.4V11h.8c.4 0 .8-.2.8-.7 0-.5-.4-.8-.8-.8H8V8.3c0-.5.4-.8.8-.8.3 0 .5.1.7.3.2.4.6.5 1 .3z"
  })]
}));

/**
UiMoneyFilled icon

```jsx
import { UiMoneyFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyFilled />
```

 */
const UiMoneyFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.5 6.5 2 12 2s10 4.5 10 10-4.5 10-10 10S2 17.5 2 12zm11.41-.54c1.31.41 2.09 1.41 2.1 2.73 0 1.65-1.23 2.6-2.51 2.77 0 .012.003.02.006.027a.036.036 0 01.004.013v.5c0 .55-.45 1-1 1s-1-.45-1-1V17c0-.042.01-.078.019-.114a.84.84 0 00.011-.046 7.624 7.624 0 01-2.018-.694l-.012-.006a1 1 0 01.98-1.74s.04.01.09.04c.27.13 1.24.55 2.49.55.04 0 .92-.01.92-.8 0-.22 0-.62-.74-.85l-1.51-.56-.66-.25c-1.37-.43-2.09-1.36-2.09-2.74 0-1.54 1.17-2.45 2.52-2.71a.188.188 0 01-.02-.08v-.5c0-.55.45-1 1-1s1 .45 1 1V7a.39.39 0 01-.018.1c-.004.017-.009.033-.012.05.96.24 1.62.69 1.72.76.45.32.56.94.24 1.39-.32.45-.94.56-1.39.24l-.012-.008C13.412 9.466 12.671 9 11.8 9c-.34 0-1.31.15-1.31.8 0 .49.15.66.74.85l2.18.81z"
  })
}));

/**
UiMoneyFilledSmall icon

```jsx
import { UiMoneyFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyFilledSmall />
```

 */
const UiMoneyFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm.83 12.68v.04c0 .55-.45 1-1 1s-1-.45-1-1v-.23c-.91-.23-1.5-.58-1.54-.6a.995.995 0 01-.34-1.37c.28-.47.9-.63 1.37-.34 0 0 .93.53 2.19.53.07 0 .69-.02.69-.67 0-.44-.31-.63-.58-.72L6.7 8.56c-.54-.23-1.89-.8-1.89-2.61 0-1.23.81-2.18 2.02-2.52v-.16c0-.55.45-1 1-1s1 .45 1 1v.14c.91.23 1.54.68 1.63.75a1.005 1.005 0 01-1.2 1.61c-.02-.02-.67-.48-1.43-.48-.1 0-1.02.02-1.02.67 0 .44.16.55.65.75l1.85.73c.89.29 1.89 1.15 1.89 2.6-.01 1.59-1.17 2.5-2.37 2.64z"
  })
}));

/**
UiMoneyInFilled icon

```jsx
import { UiMoneyInFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyInFilled />
```

 */
const UiMoneyInFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11zm-2.936-4A9 9 0 0012 3a9 9 0 00-8.064 5h16.128z"
  })
}));

/**
UiMoneyInFilledSmall icon

```jsx
import { UiMoneyInFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyInFilledSmall />
```

 */
const UiMoneyInFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8A8 8 0 110 8a8 8 0 0116 0zM2.803 5h10.394A5.997 5.997 0 008 2a5.997 5.997 0 00-5.197 3z"
  })
}));

/**
UiMoneyInSmallFilled icon

```jsx
import { UiMoneyInSmallFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyInSmallFilled />
```

 */
const UiMoneyInSmallFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8A8 8 0 110 8a8 8 0 0116 0zM2.803 5h10.394A5.997 5.997 0 008 2a5.997 5.997 0 00-5.197 3z"
  })
}));

/**
UiMoneyLined icon

```jsx
import { UiMoneyLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyLined />
```

 */
const UiMoneyLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
  }), /*#__PURE__*/jsx("path", {
    d: "M13.41 11.46l-2.18-.81c-.59-.19-.74-.36-.74-.85 0-.65.97-.8 1.31-.8.93 0 1.71.53 1.73.54.45.32 1.07.21 1.39-.24a.996.996 0 00-.24-1.39c-.1-.07-.76-.52-1.72-.76.01-.05.03-.1.03-.15v-.5c0-.55-.45-1-1-1s-1 .45-1 1V7c0 .03.01.06.02.08-1.35.26-2.52 1.17-2.52 2.71 0 1.38.72 2.31 2.09 2.74l.66.25 1.51.56c.74.23.74.63.74.85 0 .79-.88.8-.92.8-1.25 0-2.22-.42-2.49-.55-.05-.03-.09-.04-.09-.04a1 1 0 00-.98 1.74c.04.02.83.46 2.03.7-.01.05-.03.1-.03.16v.5c0 .55.45 1 1 1s1-.45 1-1V17c0-.01-.01-.02-.01-.04 1.28-.17 2.51-1.12 2.51-2.77-.01-1.32-.79-2.32-2.1-2.73z"
  })]
}));

/**
UiMoneyLinedSmall icon

```jsx
import { UiMoneyLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyLinedSmall />
```

 */
const UiMoneyLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9.2 7.39c.82.28 1.75 1.07 1.75 2.42 0 1.45-1.03 2.29-2.12 2.46-.04.52-.46.93-.99.93-.55 0-1-.45-1-1v-.11c-.75-.2-1.23-.48-1.31-.53-.47-.28-.62-.9-.34-1.37.29-.48.9-.63 1.37-.34l.02.01c.133.068.885.45 1.87.45.12 0 .5-.04.5-.49 0-.26-.15-.44-.44-.54L6.8 8.61c-.45-.19-1.75-.75-1.75-2.42 0-1.13.72-2 1.8-2.33v-.05c0-.55.45-1 1-1s1 .45 1 1v.04c.78.21 1.32.6 1.4.66.44.33.53.96.2 1.4-.33.44-.95.53-1.39.2-.004 0-.016-.008-.036-.02-.136-.083-.624-.38-1.174-.38-.08 0-.8.01-.8.48 0 .3.07.38.51.56l1.64.64z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0a8 8 0 100 16A8 8 0 008 0zM2 8a6 6 0 1112 0A6 6 0 012 8z"
  })]
}));

/**
UiMoneyOutFilled icon

```jsx
import { UiMoneyOutFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyOutFilled />
```

 */
const UiMoneyOutFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11zM3.936 16h16.128a9 9 0 10-16.129 0z"
  })
}));

/**
UiMoneyOutFilledSmall icon

```jsx
import { UiMoneyOutFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyOutFilledSmall />
```

 */
const UiMoneyOutFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8A8 8 0 110 8a8 8 0 0116 0zM2.803 11h10.394a6 6 0 10-10.395 0z"
  })
}));

/**
UiMoneyOutSmallFilled icon

```jsx
import { UiMoneyOutSmallFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyOutSmallFilled />
```

 */
const UiMoneyOutSmallFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8A8 8 0 110 8a8 8 0 0116 0zM2.803 11h10.394a6 6 0 10-10.395 0z"
  })
}));

/**
UiMoneyProtectedFilled icon

```jsx
import { UiMoneyProtectedFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyProtectedFilled />
```

 */
const UiMoneyProtectedFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.69 1.09a.586.586 0 01.62 0c2.8 1.88 5.75 2.83 10.19 3.21.29.02.51.28.5.57-.35 8.15-2.31 14.34-10.78 18.08-.07.03-.14.05-.22.05-.07 0-.15-.02-.22-.05C3.37 19.26 1.39 13.05 1 4.87c-.01-.29.21-.54.5-.57 3.24-.29 6.72-.88 10.19-3.21zm1.82 10.43c1.03.34 2.18 1.32 2.18 2.98 0 1.9-1.46 2.95-2.89 3.05v.26c0 .55-.45 1-1 1s-1-.45-1-1v-.46c-1.18-.28-1.95-.72-2-.75-.47-.28-.62-.9-.34-1.37.28-.47.9-.62 1.37-.34 0 0 1.18.68 2.79.68.05 0 1.07-.01 1.07-1.05 0-.71-.54-.99-.86-1.1l-2.34-.92c-.62-.26-2.18-.92-2.18-2.98 0-1.46 1-2.57 2.48-2.92v-.37c0-.55.45-1 1-1s1 .45 1 1v.35c1.15.24 1.97.83 2.08.91.44.33.53.96.2 1.4-.34.44-.96.53-1.4.2l-.005-.003c-.079-.054-.906-.627-1.875-.627-.15 0-1.48.02-1.48 1.04 0 .67.28.86.93 1.13l2.27.89z"
  })
}));

/**
UiMoneyProtectedFilledSmall icon

```jsx
import { UiMoneyProtectedFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyProtectedFilledSmall />
```

 */
const UiMoneyProtectedFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-money-protected-filled-small-a)",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.64 2.397c-3.23-.29-5.38-.97-7.42-2.33a.409.409 0 00-.45 0c-2.51 1.69-5.05 2.12-7.41 2.33-.21.02-.37.2-.36.42.28 5.95 1.72 10.47 7.84 13.15a.453.453 0 00.32 0c6.16-2.72 7.59-7.23 7.84-13.16.02-.21-.14-.39-.36-.41zM9.09 7.57c.88.3 1.41 1.01 1.41 1.94 0 1.18-.86 1.86-1.75 1.95v.02c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-.16a4.76 4.76 0 01-1.14-.45.751.751 0 11.8-1.27c.14.08.77.38 1.58.38.08 0 .5-.02.5-.49 0-.2-.03-.4-.42-.53l-.98-.38-.44-.17c-1.16-.38-1.41-1.27-1.41-1.94 0-.99.69-1.63 1.5-1.87v-.11c0-.41.34-.75.75-.75s.75.34.75.75v.1c.65.155 1.103.48 1.193.545l.007.005c.33.25.4.72.15 1.05a.741.741 0 01-1.025.16c-.005-.003-.01-.005-.015-.01l-.014-.009C8.95 6.276 8.505 5.99 8 5.99c-.01 0-.75.01-.75.49 0 .34.09.42.42.53l.78.31.64.25z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-money-protected-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiMoneyProtectedLined icon

```jsx
import { UiMoneyProtectedLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyProtectedLined />
```

 */
const UiMoneyProtectedLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M13.51 11.52c1.03.34 2.18 1.32 2.18 2.98 0 1.9-1.46 2.95-2.89 3.05v.26c0 .55-.45 1-1 1s-1-.45-1-1v-.46c-1.18-.28-1.95-.72-2-.75-.47-.28-.62-.9-.34-1.37.28-.47.9-.62 1.37-.34 0 0 1.18.68 2.79.68.05 0 1.07-.01 1.07-1.05 0-.71-.54-.99-.86-1.1l-2.34-.92c-.62-.26-2.18-.92-2.18-2.98 0-1.46 1-2.57 2.48-2.92v-.37c0-.55.45-1 1-1s1 .45 1 1v.35c1.15.24 1.97.83 2.08.91.44.33.53.96.2 1.4-.34.44-.96.53-1.4.2l-.005-.003c-.079-.054-.906-.627-1.875-.627-.15 0-1.48.02-1.48 1.04 0 .67.28.86.93 1.13l2.27.89z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.69 1.09a.586.586 0 01.62 0c2.8 1.88 5.75 2.83 10.19 3.21.29.02.51.28.5.57-.35 8.15-2.31 14.34-10.78 18.08-.07.03-.14.05-.22.05-.07 0-.15-.02-.22-.05C3.37 19.26 1.39 13.05 1 4.87c-.01-.29.21-.54.5-.57 3.24-.29 6.72-.88 10.19-3.21zm9.24 5.06c-3.61-.44-6.38-1.34-8.93-2.88-3.06 1.85-6.07 2.54-8.92 2.88.5 6.74 2.35 11.6 8.92 14.71 6.62-3.14 8.47-8 8.93-14.71z"
  })]
}));

/**
UiMoneyProtectedSmallFilled icon

```jsx
import { UiMoneyProtectedSmallFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyProtectedSmallFilled />
```

 */
const UiMoneyProtectedSmallFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-money-protected-small-filled-a)",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.64 2.397c-3.23-.29-5.38-.97-7.42-2.33a.409.409 0 00-.45 0c-2.51 1.69-5.05 2.12-7.41 2.33-.21.02-.37.2-.36.42.28 5.95 1.72 10.47 7.84 13.15a.453.453 0 00.32 0c6.16-2.72 7.59-7.23 7.84-13.16.02-.21-.14-.39-.36-.41zM9.09 7.57c.88.3 1.41 1.01 1.41 1.94 0 1.18-.86 1.86-1.75 1.95v.02c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-.16a4.76 4.76 0 01-1.14-.45.751.751 0 11.8-1.27c.14.08.77.38 1.58.38.08 0 .5-.02.5-.49 0-.2-.03-.4-.42-.53l-.98-.38-.44-.17c-1.16-.38-1.41-1.27-1.41-1.94 0-.99.69-1.63 1.5-1.87v-.11c0-.41.34-.75.75-.75s.75.34.75.75v.1c.65.155 1.103.48 1.193.545l.007.005c.33.25.4.72.15 1.05a.741.741 0 01-1.025.16c-.005-.003-.01-.005-.015-.01l-.014-.009C8.95 6.276 8.505 5.99 8 5.99c-.01 0-.75.01-.75.49 0 .34.09.42.42.53l.78.31.64.25z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-money-protected-small-filled-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiMoneyProtectedUkFilled icon

```jsx
import { UiMoneyProtectedUkFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyProtectedUkFilled />
```

 */
const UiMoneyProtectedUkFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.69 1.09a.586.586 0 01.62 0c2.8 1.88 5.75 2.83 10.19 3.21.29.02.51.28.5.57-.35 8.15-2.31 14.34-10.78 18.08-.07.03-.14.05-.22.05-.07 0-.15-.02-.22-.05C3.37 19.26 1.39 13.05 1 4.87c-.01-.29.21-.54.5-.57 3.24-.29 6.72-.88 10.19-3.21zM11.1 15H15c.6 0 1 .4 1 1s-.4 1-1 1H9c-.4 0-.8-.3-1-.7-.2-.4 0-.8.3-1.1.1 0 1.1-.9 1.5-2.2H9c-.6 0-1-.4-1-1s.4-1 1-1h1V9c0-1.8 1.2-3 3-3 1.1 0 2.2.5 2.8 1.4.4.5.3 1.1-.2 1.4-.5.4-1.1.3-1.4-.2-.3-.4-.7-.6-1.2-.6-.7 0-1 .3-1 1v2h1c.6 0 1 .4 1 1s-.4 1-1 1h-1.1c-.2.8-.5 1.4-.8 2z"
  })
}));

/**
UiMoneyProtectedUkFilledSmall icon

```jsx
import { UiMoneyProtectedUkFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyProtectedUkFilledSmall />
```

 */
const UiMoneyProtectedUkFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-money-protected-uk-filled-small-a)",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.22.068c2.04 1.36 4.19 2.04 7.42 2.33.22.02.38.2.36.41-.25 5.93-1.68 10.44-7.84 13.16a.453.453 0 01-.32 0C1.72 13.287.28 8.767 0 2.817c-.01-.22.15-.4.36-.42 2.36-.21 4.9-.64 7.41-2.33.14-.09.31-.09.45 0zM10.5 6.1c.4-.2.5-.6.3-1-.4-.7-1.2-1.1-2-1.1-1.2 0-2.2 1-2.2 2.2v1.3h-.8c-.4 0-.8.2-.8.7 0 .5.4.8.8.8h.7v.1c0 1-1 1.5-1 1.5-.3.1-.5.4-.4.8 0 .3.3.6.7.6h4c.4 0 .8-.2.8-.7 0-.5-.4-.8-.8-.8H7.6c.3-.4.4-.8.4-1.4V9h.8c.4 0 .8-.2.8-.7 0-.5-.4-.8-.8-.8H8V6.3c0-.5.4-.8.8-.8.3 0 .5.1.7.3.2.4.6.5 1 .3z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-money-protected-uk-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiMoneyProtectedUkLined icon

```jsx
import { UiMoneyProtectedUkLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyProtectedUkLined />
```

 */
const UiMoneyProtectedUkLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11.1 15H15c.6 0 1 .4 1 1s-.4 1-1 1H9c-.4 0-.8-.3-1-.7-.2-.4 0-.8.3-1.1.1 0 1.1-.9 1.5-2.2H9c-.6 0-1-.4-1-1s.4-1 1-1h1V9c0-1.8 1.2-3 3-3 1.1 0 2.2.5 2.8 1.4.4.5.3 1.1-.2 1.4-.5.4-1.1.3-1.4-.2-.3-.4-.7-.6-1.2-.6-.7 0-1 .3-1 1v2h1c.6 0 1 .4 1 1s-.4 1-1 1h-1.1c-.2.8-.5 1.4-.8 2z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.69 1.09a.586.586 0 01.62 0c2.8 1.88 5.75 2.83 10.19 3.21.29.02.51.28.5.57-.35 8.15-2.31 14.34-10.78 18.08-.07.03-.14.05-.22.05-.07 0-.15-.02-.22-.05C3.37 19.26 1.39 13.05 1 4.87c-.01-.29.21-.54.5-.57 3.24-.29 6.72-.88 10.19-3.21zm9.24 5.06c-3.61-.44-6.38-1.34-8.93-2.88-3.06 1.85-6.07 2.54-8.92 2.88.5 6.74 2.35 11.6 8.92 14.71 6.62-3.14 8.47-8 8.93-14.71z"
  })]
}));

/**
UiMoneyProtectedUkSmallFilled icon

```jsx
import { UiMoneyProtectedUkSmallFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyProtectedUkSmallFilled />
```

 */
const UiMoneyProtectedUkSmallFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-money-protected-uk-small-filled-a)",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.22.068c2.04 1.36 4.19 2.04 7.42 2.33.22.02.38.2.36.41-.25 5.93-1.68 10.44-7.84 13.16a.453.453 0 01-.32 0C1.72 13.287.28 8.767 0 2.817c-.01-.22.15-.4.36-.42 2.36-.21 4.9-.64 7.41-2.33.14-.09.31-.09.45 0zM10.5 6.1c.4-.2.5-.6.3-1-.4-.7-1.2-1.1-2-1.1-1.2 0-2.2 1-2.2 2.2v1.3h-.8c-.4 0-.8.2-.8.7 0 .5.4.8.8.8h.7v.1c0 1-1 1.5-1 1.5-.3.1-.5.4-.4.8 0 .3.3.6.7.6h4c.4 0 .8-.2.8-.7 0-.5-.4-.8-.8-.8H7.6c.3-.4.4-.8.4-1.4V9h.8c.4 0 .8-.2.8-.7 0-.5-.4-.8-.8-.8H8V6.3c0-.5.4-.8.8-.8.3 0 .5.1.7.3.2.4.6.5 1 .3z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-money-protected-uk-small-filled-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiMoneySmallFilled icon

```jsx
import { UiMoneySmallFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneySmallFilled />
```

 */
const UiMoneySmallFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm.83 12.68v.04c0 .55-.45 1-1 1s-1-.45-1-1v-.23c-.91-.23-1.5-.58-1.54-.6a.995.995 0 01-.34-1.37c.28-.47.9-.63 1.37-.34 0 0 .93.53 2.19.53.07 0 .69-.02.69-.67 0-.44-.31-.63-.58-.72L6.7 8.56c-.54-.23-1.89-.8-1.89-2.61 0-1.23.81-2.18 2.02-2.52v-.16c0-.55.45-1 1-1s1 .45 1 1v.14c.91.23 1.54.68 1.63.75a1.005 1.005 0 01-1.2 1.61c-.02-.02-.67-.48-1.43-.48-.1 0-1.02.02-1.02.67 0 .44.16.55.65.75l1.85.73c.89.29 1.89 1.15 1.89 2.6-.01 1.59-1.17 2.5-2.37 2.64z"
  })
}));

/**
UiMoneySmallLined icon

```jsx
import { UiMoneySmallLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneySmallLined />
```

 */
const UiMoneySmallLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9.2 7.39c.82.28 1.75 1.07 1.75 2.42 0 1.45-1.03 2.29-2.12 2.46-.04.52-.46.93-.99.93-.55 0-1-.45-1-1v-.11c-.75-.2-1.23-.48-1.31-.53-.47-.28-.62-.9-.34-1.37.29-.48.9-.63 1.37-.34l.02.01c.133.068.885.45 1.87.45.12 0 .5-.04.5-.49 0-.26-.15-.44-.44-.54L6.8 8.61c-.45-.19-1.75-.75-1.75-2.42 0-1.13.72-2 1.8-2.33v-.05c0-.55.45-1 1-1s1 .45 1 1v.04c.78.21 1.32.6 1.4.66.44.33.53.96.2 1.4-.33.44-.95.53-1.39.2-.004 0-.016-.008-.036-.02-.136-.083-.624-.38-1.174-.38-.08 0-.8.01-.8.48 0 .3.07.38.51.56l1.64.64z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0a8 8 0 100 16A8 8 0 008 0zM2 8a6 6 0 1112 0A6 6 0 012 8z"
  })]
}));

/**
UiMoneyUkFilled icon

```jsx
import { UiMoneyUkFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyUkFilled />
```

 */
const UiMoneyUkFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm3 15H9c-.4 0-.8-.3-.9-.7-.1-.4 0-.8.3-1.1 0 0 1.1-.9 1.5-2.2H9c-.6 0-1-.4-1-1s.4-1 1-1h1V9c0-1.8 1.2-3 3-3 1.1 0 2.2.5 2.8 1.4.3.5.2 1.1-.2 1.4-.5.3-1.1.2-1.4-.2-.3-.4-.7-.6-1.2-.6-.7 0-1 .3-1 1v2h1c.6 0 1 .4 1 1s-.4 1-1 1h-1.1c-.1.8-.4 1.4-.8 2H15c.6 0 1 .4 1 1s-.4 1-1 1z"
  })
}));

/**
UiMoneyUkFilledSmall icon

```jsx
import { UiMoneyUkFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyUkFilledSmall />
```

 */
const UiMoneyUkFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8c0 4.41 3.59 8 8 8 4.42 0 8-3.59 8-8s-3.59-8-8-8-8 3.59-8 8zm10.5-1.9c.4-.2.5-.6.3-1-.4-.7-1.2-1.1-2-1.1-1.2 0-2.2 1-2.2 2.2v1.3h-.8c-.4 0-.8.2-.8.7 0 .5.4.8.8.8h.7v.1c0 1-1 1.5-1 1.5-.3.1-.5.4-.4.8 0 .3.3.6.7.6h4c.4 0 .8-.2.8-.7 0-.5-.4-.8-.8-.8H7.6c.3-.4.4-.8.4-1.4V9h.8c.4 0 .8-.2.8-.7 0-.5-.4-.8-.8-.8H8V6.3c0-.5.4-.8.8-.8.3 0 .5.1.7.3.2.4.6.5 1 .3z"
  })
}));

/**
UiMoneyUkLined icon

```jsx
import { UiMoneyUkLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyUkLined />
```

 */
const UiMoneyUkLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11.1 15H15c.6 0 1 .4 1 1s-.4 1-1 1H9c-.4 0-.8-.3-1-.7-.2-.4 0-.8.3-1.1.1 0 1.1-.9 1.5-2.2H9c-.6 0-1-.4-1-1s.4-1 1-1h1V9c0-1.8 1.2-3 3-3 1.1 0 2.2.5 2.8 1.4.4.5.3 1.1-.2 1.4-.5.4-1.1.3-1.4-.2-.3-.4-.7-.6-1.2-.6-.7 0-1 .3-1 1v2h1c.6 0 1 .4 1 1s-.4 1-1 1h-1.1c-.2.8-.5 1.4-.8 2z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.5 6.5 2 12 2s10 4.5 10 10-4.5 10-10 10S2 17.5 2 12zm2 0c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8-8 3.6-8 8z"
  })]
}));

/**
UiMoneyUkLinedSmall icon

```jsx
import { UiMoneyUkLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyUkLinedSmall />
```

 */
const UiMoneyUkLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M10.5 6.1c.4-.2.5-.6.3-1-.4-.7-1.2-1.1-2-1.1-1.2 0-2.2 1-2.2 2.2v1.3h-.8c-.4 0-.8.2-.8.7 0 .5.4.8.8.8h.7v.1c0 1-1 1.5-1 1.5-.3.1-.5.4-.4.8 0 .3.3.6.7.6h4c.4 0 .8-.2.8-.7 0-.5-.4-.8-.8-.8H7.6c.3-.4.4-.8.4-1.4V9h.8c.4 0 .8-.2.8-.7 0-.5-.4-.8-.8-.8H8V6.3c0-.5.4-.8.8-.8.3 0 .5.1.7.3.2.4.6.5 1 .3z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8c0 4.41 3.59 8 8 8 4.42 0 8-3.59 8-8s-3.59-8-8-8-8 3.59-8 8zm2 0c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6z"
  })]
}));

/**
UiMoneyUkSmallFilled icon

```jsx
import { UiMoneyUkSmallFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyUkSmallFilled />
```

 */
const UiMoneyUkSmallFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8c0 4.41 3.59 8 8 8 4.42 0 8-3.59 8-8s-3.59-8-8-8-8 3.59-8 8zm10.5-1.9c.4-.2.5-.6.3-1-.4-.7-1.2-1.1-2-1.1-1.2 0-2.2 1-2.2 2.2v1.3h-.8c-.4 0-.8.2-.8.7 0 .5.4.8.8.8h.7v.1c0 1-1 1.5-1 1.5-.3.1-.5.4-.4.8 0 .3.3.6.7.6h4c.4 0 .8-.2.8-.7 0-.5-.4-.8-.8-.8H7.6c.3-.4.4-.8.4-1.4V9h.8c.4 0 .8-.2.8-.7 0-.5-.4-.8-.8-.8H8V6.3c0-.5.4-.8.8-.8.3 0 .5.1.7.3.2.4.6.5 1 .3z"
  })
}));

/**
UiMoneyUkSmallLined icon

```jsx
import { UiMoneyUkSmallLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoneyUkSmallLined />
```

 */
const UiMoneyUkSmallLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M10.5 6.1c.4-.2.5-.6.3-1-.4-.7-1.2-1.1-2-1.1-1.2 0-2.2 1-2.2 2.2v1.3h-.8c-.4 0-.8.2-.8.7 0 .5.4.8.8.8h.7v.1c0 1-1 1.5-1 1.5-.3.1-.5.4-.4.8 0 .3.3.6.7.6h4c.4 0 .8-.2.8-.7 0-.5-.4-.8-.8-.8H7.6c.3-.4.4-.8.4-1.4V9h.8c.4 0 .8-.2.8-.7 0-.5-.4-.8-.8-.8H8V6.3c0-.5.4-.8.8-.8.3 0 .5.1.7.3.2.4.6.5 1 .3z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8c0 4.41 3.59 8 8 8 4.42 0 8-3.59 8-8s-3.59-8-8-8-8 3.59-8 8zm2 0c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6z"
  })]
}));

/**
UiMoveMoneyFilled icon

```jsx
import { UiMoveMoneyFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoveMoneyFilled />
```

 */
const UiMoveMoneyFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 5c.3 0 .5.1.7.3.2.2.3.5.3.8l-1 12c0 .5-.5.9-1 .9H3c-.3 0-.5-.1-.7-.3-.2-.2-.3-.5-.3-.8l.1-.9H1c-.6 0-1-.4-1-1s.4-1 1-1h1.2l.2-2h-.9c-.6 0-1-.4-1-1s.4-1 1-1h1.1l.1-2H2c-.6 0-1-.4-1-1s.4-1 1-1h.9L3 5.9c0-.5.5-.9 1-.9h18zM5 12c0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1-1 .4-1 1zm13 0c0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1-1 .4-1 1zm-4.407-.415c.878.3 1.407 1.01 1.407 1.942 0 1.181-.858 1.862-1.746 1.952v.02c0 .41-.34.751-.749.751a.755.755 0 01-.748-.75v-.161c-.649-.17-1.068-.41-1.138-.45a.751.751 0 11.799-1.272c.14.08.768.38 1.576.38.08 0 .5-.02.5-.49 0-.2-.03-.4-.42-.53l-.978-.381-.439-.17c-1.158-.38-1.407-1.272-1.407-1.943 0-.99.688-1.632 1.497-1.872v-.11c0-.41.34-.751.748-.751.41 0 .749.34.749.75v.101c.649.156 1.1.481 1.19.546l.007.005c.33.25.4.72.15 1.05a.738.738 0 01-1.008.171c-.005-.005-.01-.007-.015-.01a.044.044 0 01-.015-.01l-.014-.009c-.085-.055-.53-.341-1.034-.341-.01 0-.748.01-.748.49 0 .34.09.42.419.53l.778.311.639.25z"
  })
}));

/**
UiMoveMoneyLined icon

```jsx
import { UiMoveMoneyLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoveMoneyLined />
```

 */
const UiMoveMoneyLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M7 13a1 1 0 100-2 1 1 0 000 2zm12-1a1 1 0 11-2 0 1 1 0 012 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 5c.3 0 .5.1.7.3.2.2.3.5.3.8l-1 12c0 .5-.5.9-1 .9H3c-.3 0-.5-.1-.7-.3-.2-.2-.3-.5-.3-.8l.1-.9H1c-.6 0-1-.4-1-1s.4-1 1-1h1.2l.2-2h-.9c-.6 0-1-.4-1-1s.4-1 1-1h1.1l.1-2H2c-.6 0-1-.4-1-1s.4-1 1-1h.9L3 5.9c0-.5.5-.9 1-.9h18zM4.1 17h16l.8-10h-16l-.8 10z"
  }), /*#__PURE__*/jsx("path", {
    d: "M15 13.527c0-.931-.529-1.642-1.407-1.942l-.639-.25-.778-.311c-.33-.11-.42-.19-.42-.53 0-.481.74-.491.75-.491.548 0 1.027.34 1.047.35.01.01.02.01.03.02.33.22.768.15 1.008-.17a.753.753 0 00-.15-1.051c-.07-.05-.529-.39-1.197-.551v-.1c0-.41-.34-.751-.749-.751s-.748.34-.748.75v.111c-.808.24-1.497.881-1.497 1.872 0 .671.25 1.562 1.407 1.942l.44.17.977.381c.39.13.42.33.42.53 0 .471-.42.491-.5.491a3.47 3.47 0 01-1.576-.38c-.02-.01-.03-.02-.03-.02a.751.751 0 00-.768 1.292c.07.04.488.28 1.137.45v.16c0 .41.34.751.748.751.41 0 .749-.34.749-.75v-.02c.888-.091 1.746-.772 1.746-1.953z"
  })]
}));

/**
UiMoveMoneyUkFilled icon

```jsx
import { UiMoveMoneyUkFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoveMoneyUkFilled />
```

 */
const UiMoveMoneyUkFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22.7 5.3c-.2-.2-.4-.3-.7-.3H4c-.5 0-1 .4-1 .9L2.9 7H2c-.6 0-1 .4-1 1s.4 1 1 1h.7l-.1 2H1.5c-.6 0-1 .4-1 1s.4 1 1 1h.9l-.2 2H1c-.6 0-1 .4-1 1s.4 1 1 1h1.1l-.1.9c0 .3.1.6.3.8.2.2.4.3.7.3h18c.5 0 1-.4 1-.9l1-12c0-.3-.1-.6-.3-.8zM6 13c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm8.9-2.8c-.4.2-.8.1-1-.3-.1-.2-.4-.4-.7-.4-.4 0-.8.3-.8.8v1.2h.8c.4 0 .8.3.8.8s-.3.7-.8.7h-.8v.1c0 .6-.1 1-.4 1.4h2.1c.4 0 .8.3.8.8s-.2.7-.7.7h-4c-.4 0-.7-.3-.7-.6-.1-.4.1-.7.5-.8 0 0 1-.5 1-1.5V13h-.8c-.4 0-.7-.3-.7-.8s.3-.8.8-.8h.7v-1.2C11 9 12 8 13.2 8c.8 0 1.6.4 2 1.1.2.4.1.9-.3 1.1zM19 13c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
  })
}));

/**
UiMoveMoneyUkLined icon

```jsx
import { UiMoveMoneyUkLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiMoveMoneyUkLined />
```

 */
const UiMoveMoneyUkLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M8 12a1 1 0 11-2 0 1 1 0 012 0zm10 1a1 1 0 100-2 1 1 0 000 2zm-7 0h-.8c-.4 0-.8-.3-.8-.8s.4-.8.8-.8h.8v-1.2C11 9 12 8 13.2 8c.9 0 1.6.4 2 1.1.2.3.1.8-.3 1-.3.2-.8.1-1-.3-.2-.3-.4-.4-.7-.4-.5 0-.8.4-.8.8v1.2h.8c.5 0 .8.3.8.8s-.3.8-.7.8h-.8c0 .5-.2 1-.4 1.4h2.1c.5 0 .8.3.8.8s-.4.8-.8.8h-4c-.3 0-.6-.2-.7-.6-.1-.4.1-.7.5-.8 0 0 1-.5 1-1.5V13z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 5c.3 0 .5.1.7.3.2.2.3.5.3.8l-1 12c0 .5-.5.9-1 .9H3c-.3 0-.5-.1-.7-.3-.2-.2-.3-.5-.3-.8l.1-.9H1c-.6 0-1-.4-1-1s.4-1 1-1h1.2l.2-2h-.9c-.6 0-1-.4-1-1s.4-1 1-1h1.1l.1-2H2c-.6 0-1-.4-1-1s.4-1 1-1h.9L3 5.9c0-.5.5-.9 1-.9h18zM4.1 17h16l.8-10h-16l-.8 10z"
  })]
}));

/**
UiNotesCloseFilled icon

```jsx
import { UiNotesCloseFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiNotesCloseFilled />
```

 */
const UiNotesCloseFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 12c-3.3 0-6 2.7-6 6 0 1.1.3 2.1.8 3H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v7.3c-.6-.2-1.3-.3-2-.3zM8 15c-.6 0-1 .4-1 1s.4 1 1 1h2c.6 0 1-.4 1-1s-.4-1-1-1H8zm0-2h5c.6 0 1-.4 1-1s-.4-1-1-1H8c-.6 0-1 .4-1 1s.4 1 1 1zm0-4h8c.6 0 1-.4 1-1s-.4-1-1-1H8c-.6 0-1 .4-1 1s.4 1 1 1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M21.7 16.7L20.4 18l1.3 1.3c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3L19 19.4l-1.3 1.3c-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l1.3-1.3-1.3-1.3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l1.3 1.3 1.3-1.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4z"
  })]
}));

/**
UiNotesCloseLined icon

```jsx
import { UiNotesCloseLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiNotesCloseLined />
```

 */
const UiNotesCloseLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M13 19H5V5h14v8c0 .6.4 1 1 1s1-.4 1-1V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c.6 0 1-.4 1-1s-.4-1-1-1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M16 7H8c-.6 0-1 .4-1 1s.4 1 1 1h8c.6 0 1-.4 1-1s-.4-1-1-1zm0 4c.6 0 1 .4 1 1s-.4 1-1 1H8c-.6 0-1-.4-1-1s.4-1 1-1h8zm-8 4c-.6 0-1 .4-1 1s.4 1 1 1h3.5c.6 0 1-.4 1-1s-.4-1-1-1H8zm13.7 2.7L20.4 19l1.3 1.3c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3L19 20.4l-1.3 1.3c-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l1.3-1.3-1.3-1.3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l1.3 1.3 1.3-1.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4z"
  })]
}));

/**
UiNotesFilled icon

```jsx
import { UiNotesFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiNotesFilled />
```

 */
const UiNotesFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 14H8c-.6 0-1-.4-1-1s.4-1 1-1h4c.6 0 1 .4 1 1s-.4 1-1 1zm4-4H8c-.6 0-1-.4-1-1s.4-1 1-1h8c.6 0 1 .4 1 1s-.4 1-1 1zm0-4H8c-.6 0-1-.4-1-1s.4-1 1-1h8c.6 0 1 .4 1 1s-.4 1-1 1z"
  })
}));

/**
UiNotesFilledSmall icon

```jsx
import { UiNotesFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiNotesFilledSmall />
```

 */
const UiNotesFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14 1H2c-.6 0-1 .4-1 1v12c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zM8 11H5c-.6 0-1-.4-1-1s.4-1 1-1h3c.6 0 1 .4 1 1s-.4 1-1 1zm3-4H5c-.6 0-1-.4-1-1s.4-1 1-1h6c.6 0 1 .4 1 1s-.4 1-1 1z"
  })
}));

/**
UiNotesHideFilled icon

```jsx
import { UiNotesHideFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiNotesHideFilled />
```

 */
const UiNotesHideFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 12c-3.3 0-6 2.7-6 6 0 1.1.3 2.1.8 3H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v7.3c-.6-.2-1.3-.3-2-.3zM8 15c-.6 0-1 .4-1 1s.4 1 1 1h2c.6 0 1-.4 1-1s-.4-1-1-1H8zm0-2h5c.6 0 1-.4 1-1s-.4-1-1-1H8c-.6 0-1 .4-1 1s.4 1 1 1zm0-4h8c.6 0 1-.4 1-1s-.4-1-1-1H8c-.6 0-1 .4-1 1s.4 1 1 1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M15 18c0-.6.4-1 1-1h6c.6 0 1 .4 1 1s-.4 1-1 1h-6c-.6 0-1-.4-1-1z"
  })]
}));

/**
UiNotesHideLined icon

```jsx
import { UiNotesHideLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiNotesHideLined />
```

 */
const UiNotesHideLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M13 19H5V5h14v9c0 .6.4 1 1 1s1-.4 1-1V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c.6 0 1-.4 1-1s-.4-1-1-1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M16 7H8c-.6 0-1 .4-1 1s.4 1 1 1h8c.6 0 1-.4 1-1s-.4-1-1-1zm0 4c.6 0 1 .4 1 1s-.4 1-1 1H8c-.6 0-1-.4-1-1s.4-1 1-1h8zm-8 4c-.6 0-1 .4-1 1s.4 1 1 1h3.5c.6 0 1-.4 1-1s-.4-1-1-1H8zm7 3c0-.6.4-1 1-1h6c.6 0 1 .4 1 1s-.4 1-1 1h-6c-.6 0-1-.4-1-1z"
  })]
}));

/**
UiNotesLined icon

```jsx
import { UiNotesLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiNotesLined />
```

 */
const UiNotesLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M8 7h8c.6 0 1 .4 1 1s-.4 1-1 1H8c-.6 0-1-.4-1-1s.4-1 1-1zm8 4H8c-.6 0-1 .4-1 1s.4 1 1 1h8c.6 0 1-.4 1-1s-.4-1-1-1zm-8 4h4c.6 0 1 .4 1 1s-.4 1-1 1H8c-.6 0-1-.4-1-1s.4-1 1-1z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2zm0 2v14h14V5H5z"
  })]
}));

/**
UiNotesLinedSmall icon

```jsx
import { UiNotesLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiNotesLinedSmall />
```

 */
const UiNotesLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M5 7h6c.6 0 1-.4 1-1s-.4-1-1-1H5c-.6 0-1 .4-1 1s.4 1 1 1zm3 4H5c-.6 0-1-.4-1-1s.4-1 1-1h3c.6 0 1 .4 1 1s-.4 1-1 1z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 1H2c-.6 0-1 .4-1 1v12c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zm-1 2v10H3V3h10z"
  })]
}));

/**
UiNotesOpenFilled icon

```jsx
import { UiNotesOpenFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiNotesOpenFilled />
```

 */
const UiNotesOpenFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 12c-3.3 0-6 2.7-6 6 0 1.1.3 2.1.8 3H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v7.3c-.6-.2-1.3-.3-2-.3zM8 15c-.6 0-1 .4-1 1s.4 1 1 1h2c.6 0 1-.4 1-1s-.4-1-1-1H8zm0-2h5c.6 0 1-.4 1-1s-.4-1-1-1H8c-.6 0-1 .4-1 1s.4 1 1 1zm0-4h8c.6 0 1-.4 1-1s-.4-1-1-1H8c-.6 0-1 .4-1 1s.4 1 1 1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M19 14c.6 0 1 .4 1 1v2h2c.6 0 1 .4 1 1s-.4 1-1 1h-2v2c0 .6-.4 1-1 1s-1-.4-1-1v-2h-2c-.6 0-1-.4-1-1s.4-1 1-1h2v-2c0-.6.4-1 1-1z"
  })]
}));

/**
UiNotesOpenLined icon

```jsx
import { UiNotesOpenLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiNotesOpenLined />
```

 */
const UiNotesOpenLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M13 19H5V5h14v6c0 .6.4 1 1 1s1-.4 1-1V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c.6 0 1-.4 1-1s-.4-1-1-1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M16 7H8c-.6 0-1 .4-1 1s.4 1 1 1h8c.6 0 1-.4 1-1s-.4-1-1-1zm0 4c.6 0 1 .4 1 1s-.4 1-1 1H8c-.6 0-1-.4-1-1s.4-1 1-1h8zm-8 4c-.6 0-1 .4-1 1s.4 1 1 1h3.5c.6 0 1-.4 1-1s-.4-1-1-1H8zm11-1c.6 0 1 .4 1 1v2h2c.6 0 1 .4 1 1s-.4 1-1 1h-2v2c0 .6-.4 1-1 1s-1-.4-1-1v-2h-2c-.6 0-1-.4-1-1s.4-1 1-1h2v-2c0-.6.4-1 1-1z"
  })]
}));

/**
UiOfferLined icon

```jsx
import { UiOfferLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiOfferLined />
```

 */
const UiOfferLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M21.8 10.4L19 7.6V2c0-.6-.4-1-1-1H4c-.6 0-1 .4-1 1v19c0 .6.4 1 1 1h11c0 .6.4 1 1 1s1-.4 1-1h1c.2 0 .4-.1.6-.2.4-.3.5-1 .2-1.4l-.5-.7-2.6-3.2c-.4-.5-.5-1.1-.4-1.7.1-.3.3-.3.4-.4.1 0 .3-.1.5.1l2.1 2.1c.1.1.3.2.5.3.3.1.7 0 .9-.3.4-.4.4-1 0-1.4l-.7-.6v-4.2l1.4 1.4c.4.4.6.9.6 1.4V22c0 .6.4 1 1 1s1-.4 1-1v-8.8c0-1-.4-2-1.2-2.8zM5 20V3h12v9.7c-.6-.3-1.2-.4-1.9-.2-.9.2-1.5.9-1.8 1.8-.3 1.2 0 2.5.8 3.4l1.8 2.2H5v.1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M13.5 10.5c0-.9-.5-1.6-1.4-1.9l-.6-.3-.8-.3c-.4-.1-.5-.2-.5-.5 0-.5.8-.5.8-.5.6 0 1 .3 1.1.4.3.2.8.2 1-.2.2-.3.2-.8-.1-1.1-.1 0-.5-.4-1.2-.6v-.3c0-.4-.3-.8-.8-.8s-.8.4-.8.8v.4c-.8.3-1.4.9-1.4 1.9 0 1 .5 1.6 1.4 1.9l.4.2 1 .4c.4.1.4.3.4.5 0 .5-.4.5-.5.5-.8 0-1.4-.3-1.6-.4-.4-.2-.8-.1-1 .3-.2.4-.1.8.3 1 .1 0 .5.3 1.1.4v.4c0 .4.3.8.8.8s.8-.3.8-.8v-.3c.7 0 1.6-.7 1.6-1.9z"
  })]
}));

/**
UiOilFilled icon

```jsx
import { UiOilFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiOilFilled />
```

 */
const UiOilFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20.88 8.52A1 1 0 0020 8h-1a1 1 0 00-.41.09l-4.87 2.21-1-1A1 1 0 0012 9H2a1 1 0 00-.99 1.12l.5 4a1 1 0 001 .88H5v1a2 2 0 002 2h8a1 1 0 00.85-.47l5-8a1 1 0 00.03-1.01zM3.38 13l-.25-2H5v2H3.38zM7 8h4a1 1 0 100-2H7a1 1 0 000 2zm14.92 4.72a.54.54 0 00-.84 0A6.91 6.91 0 0020 16c0 1.58 1 2 1.5 2s1.5-.42 1.5-2a6.91 6.91 0 00-1.08-3.28z"
  })
}));

/**
UiOilLined icon

```jsx
import { UiOilLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiOilLined />
```

 */
const UiOilLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20.88 8.52A1 1 0 0020 8h-1a1 1 0 00-.41.09l-4.87 2.21-1-1A1 1 0 0012 9H2a1 1 0 00-.99 1.12l.5 4a1 1 0 001 .88H5v1a2 2 0 002 2h8a1 1 0 00.85-.47l5-8a1 1 0 00.03-1.01zM3.38 13l-.25-2H5v2H3.38zm11.07 3H7v-5h4.59l1.2 1.21a1 1 0 001.12.2l3.88-1.76L14.45 16zM7 8h4a1 1 0 100-2H7a1 1 0 000 2zm14.92 4.72a.54.54 0 00-.84 0A6.91 6.91 0 0020 16c0 1.58 1 2 1.5 2s1.5-.42 1.5-2a6.91 6.91 0 00-1.08-3.28z"
  })
}));

/**
UiOverflowEncircledFilled icon

```jsx
import { UiOverflowEncircledFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiOverflowEncircledFilled />
```

 */
const UiOverflowEncircledFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM7.5 13.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5S9 11.2 9 12s-.7 1.5-1.5 1.5zm4.5 0c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5zm4.5 0c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5z"
  })
}));

/**
UiOverflowEncircledFilledSmall icon

```jsx
import { UiOverflowEncircledFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiOverflowEncircledFilledSmall />
```

 */
const UiOverflowEncircledFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM3.5 9.5C2.7 9.5 2 8.8 2 8s.7-1.5 1.5-1.5S5 7.2 5 8s-.7 1.5-1.5 1.5zm4.5 0c-.8 0-1.5-.7-1.5-1.5S7.2 6.5 8 6.5s1.5.7 1.5 1.5S8.8 9.5 8 9.5zm4.5 0c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5S14 7.2 14 8s-.7 1.5-1.5 1.5z"
  })
}));

/**
UiOverflowEncircledLined icon

```jsx
import { UiOverflowEncircledLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiOverflowEncircledLined />
```

 */
const UiOverflowEncircledLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9 12a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm3 1.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm6-1.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.5 6.5 2 12 2s10 4.5 10 10-4.5 10-10 10S2 17.5 2 12zm2 0c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8-8 3.6-8 8z"
  })]
}));

/**
UiOverflowEncircledSmallFilled icon

```jsx
import { UiOverflowEncircledSmallFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiOverflowEncircledSmallFilled />
```

 */
const UiOverflowEncircledSmallFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM3.5 9.5C2.7 9.5 2 8.8 2 8s.7-1.5 1.5-1.5S5 7.2 5 8s-.7 1.5-1.5 1.5zm4.5 0c-.8 0-1.5-.7-1.5-1.5S7.2 6.5 8 6.5s1.5.7 1.5 1.5S8.8 9.5 8 9.5zm4.5 0c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5S14 7.2 14 8s-.7 1.5-1.5 1.5z"
  })
}));

/**
UiOverflowLined icon

```jsx
import { UiOverflowLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiOverflowLined />
```

 */
const UiOverflowLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M6 14a2 2 0 100-4 2 2 0 000 4zm6 0a2 2 0 100-4 2 2 0 000 4zm8-2a2 2 0 11-4 0 2 2 0 014 0z"
  })
}));

/**
UiOverflowLinedSmall icon

```jsx
import { UiOverflowLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiOverflowLinedSmall />
```

 */
const UiOverflowLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M3 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm5 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm5 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  })
}));

/**
UiOverflowSmallLined icon

```jsx
import { UiOverflowSmallLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiOverflowSmallLined />
```

 */
const UiOverflowSmallLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M3 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm5 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm5 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  })
}));

/**
UiOverflowVerticalEncircledFilled icon

```jsx
import { UiOverflowVerticalEncircledFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiOverflowVerticalEncircledFilled />
```

 */
const UiOverflowVerticalEncircledFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M2 12c0 5.5 4.5 10 10 10s10-4.5 10-10S17.5 2 12 2 2 6.5 2 12zm11.5 4.5c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5.7-1.5 1.5-1.5 1.5.7 1.5 1.5zm0-4.5c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5.7-1.5 1.5-1.5 1.5.7 1.5 1.5zm0-4.5c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5S11.2 6 12 6s1.5.7 1.5 1.5z"
  })
}));

/**
UiOverflowVerticalEncircledFilledSmall icon

```jsx
import { UiOverflowVerticalEncircledFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiOverflowVerticalEncircledFilledSmall />
```

 */
const UiOverflowVerticalEncircledFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M0 8c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8-8 3.6-8 8zm9.5 4.5c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5S7.2 11 8 11s1.5.7 1.5 1.5zm0-4.5c0 .8-.7 1.5-1.5 1.5S6.5 8.8 6.5 8 7.2 6.5 8 6.5s1.5.7 1.5 1.5zm0-4.5C9.5 4.3 8.8 5 8 5s-1.5-.7-1.5-1.5S7.2 2 8 2s1.5.7 1.5 1.5z"
  })
}));

/**
UiOverflowVerticalEncircledLined icon

```jsx
import { UiOverflowVerticalEncircledLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiOverflowVerticalEncircledLined />
```

 */
const UiOverflowVerticalEncircledLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12 15a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm1.5-3a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM12 6a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C6.5 22 2 17.5 2 12S6.5 2 12 2s10 4.5 10 10-4.5 10-10 10zm0-2c4.4 0 8-3.6 8-8s-3.6-8-8-8-8 3.6-8 8 3.6 8 8 8z"
  })]
}));

/**
UiOverflowVerticalEncircledSmallFilled icon

```jsx
import { UiOverflowVerticalEncircledSmallFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiOverflowVerticalEncircledSmallFilled />
```

 */
const UiOverflowVerticalEncircledSmallFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M0 8c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8-8 3.6-8 8zm9.5 4.5c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5S7.2 11 8 11s1.5.7 1.5 1.5zm0-4.5c0 .8-.7 1.5-1.5 1.5S6.5 8.8 6.5 8 7.2 6.5 8 6.5s1.5.7 1.5 1.5zm0-4.5C9.5 4.3 8.8 5 8 5s-1.5-.7-1.5-1.5S7.2 2 8 2s1.5.7 1.5 1.5z"
  })
}));

/**
UiOverflowVerticalLined icon

```jsx
import { UiOverflowVerticalLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiOverflowVerticalLined />
```

 */
const UiOverflowVerticalLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20a2 2 0 100-4 2 2 0 000 4zm0-6a2 2 0 100-4 2 2 0 000 4zm0-6a2 2 0 100-4 2 2 0 000 4z"
  })
}));

/**
UiOverflowVerticalLinedSmall icon

```jsx
import { UiOverflowVerticalLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiOverflowVerticalLinedSmall />
```

 */
const UiOverflowVerticalLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M9.5 13a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zm0-5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zm0-5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z"
  })
}));

/**
UiOverflowVerticalSmallLined icon

```jsx
import { UiOverflowVerticalSmallLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiOverflowVerticalSmallLined />
```

 */
const UiOverflowVerticalSmallLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M9.5 13a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zm0-5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zm0-5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z"
  })
}));

/**
UiPaperFilled icon

```jsx
import { UiPaperFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPaperFilled />
```

 */
const UiPaperFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11 2h8c.6 0 1 .4 1 1v18c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1V9h6c.6 0 1-.4 1-1V2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M9 3v4H5l4-4z"
  })]
}));

/**
UiPaperFilledSmall icon

```jsx
import { UiPaperFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPaperFilledSmall />
```

 */
const UiPaperFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M8 0h5c.6 0 1 .4 1 1v14c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V6h5c.6 0 1-.4 1-1V0z"
  }), /*#__PURE__*/jsx("path", {
    d: "M2 4l4-4v4H2z"
  })]
}));

/**
UiPaperLined icon

```jsx
import { UiPaperLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPaperLined />
```

 */
const UiPaperLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M19 2h-8.6c-.3 0-.5.1-.7.3L4.3 7.7c-.2.2-.3.4-.3.7V21c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1zm-9 2.8V8H6.8L10 4.8zM18 20H6V10h5c.6 0 1-.4 1-1V4h6v16z"
  })
}));

/**
UiPaperLinedSmall icon

```jsx
import { UiPaperLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPaperLinedSmall />
```

 */
const UiPaperLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M13 0H6.4c-.3 0-.5.1-.7.3L2.3 3.7c-.2.2-.3.4-.3.7V15c0 .6.4 1 1 1h10c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-1 14H4V5h2c.6 0 1-.4 1-1V2h5v12z"
  })
}));

/**
UiPaperlessFilled icon

```jsx
import { UiPaperlessFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPaperlessFilled />
```

 */
const UiPaperlessFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M22.2 4.2l-18 18c-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L4 19.6V9h6c.6 0 1-.4 1-1V2h8c.6 0 1 .4 1 1v.6l.8-.8c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4z"
  }), /*#__PURE__*/jsx("path", {
    d: "M9 7V3L5 7h4zM7.2 22H19c.6 0 1-.4 1-1V9.2L7.2 22z"
  })]
}));

/**
UiPaperlessFilledSmall icon

```jsx
import { UiPaperlessFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPaperlessFilledSmall />
```

 */
const UiPaperlessFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsxs("g", {
    clipPath: "url(#omni-gravity-icon-ui-paperless-filled-small-a)",
    children: [/*#__PURE__*/jsx("path", {
      d: "M15.8 1.6c0 .1-.1.1-.1.1l-14 14c-.1 0-.1.1-.1.1-.2.1-.4.2-.6.2-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L2 12.6V6h5c.6 0 1-.4 1-1V0h5c.4 0 .8.3.9.7l.4-.4c.4-.4 1-.4 1.4 0 .4.4.4.9.1 1.3z"
    }), /*#__PURE__*/jsx("path", {
      d: "M6 0L2 4h4V0zm7 16c.6 0 1-.4 1-1V6.2L4.2 16H13z"
    })]
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-paperless-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiPaperlessLined icon

```jsx
import { UiPaperlessLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPaperlessLined />
```

 */
const UiPaperlessLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2 4.2l-18 18c-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L4 19.6V8.4c0-.3.1-.5.3-.7l5.4-5.4c.2-.2.4-.3.7-.3H19c.6 0 1 .4 1 1v.6l.8-.8c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4zM10 8V4.8L6.8 8H10zm1 2H6v7.6l12-12V4h-6v5c0 .6-.4 1-1 1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M9.2 20H18v-8.8l2-2V21c0 .6-.4 1-1 1H7.2l2-2z"
  })]
}));

/**
UiPaperlessLinedSmall icon

```jsx
import { UiPaperlessLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPaperlessLinedSmall />
```

 */
const UiPaperlessLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsxs("g", {
    clipPath: "url(#omni-gravity-icon-ui-paperless-lined-small-a)",
    children: [/*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.8 1.6c0 .1-.1.1-.1.1l-14 14c-.1 0-.1.1-.1.1-.2.1-.4.2-.6.2-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L2 12.6V4.4c0-.3.1-.5.3-.7L5.7.3c.2-.2.4-.3.7-.3H13c.4 0 .8.3.9.7l.4-.4c.4-.4 1-.4 1.4 0 .4.4.4.9.1 1.3zM6 5H4v5.6l8-8V2H7v2c0 .6-.4 1-1 1z"
    }), /*#__PURE__*/jsx("path", {
      d: "M6.2 14H12V8.2l2-2V15c0 .6-.4 1-1 1H4.2l2-2z"
    })]
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-paperless-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiPartialPaymentLined icon

```jsx
import { UiPartialPaymentLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPartialPaymentLined />
```

 */
const UiPartialPaymentLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M3 17V7h10V5H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h11v-2H3zm18 0h-1v2h2c.55 0 1-.45 1-1v-2.5h-2V17zm0-6.5h2v2.92h-2zM22 5h-2v2h1v1.5h2V6c0-.55-.45-1-1-1zm-7 0h3v2h-3zm0 12h3v2h-3z"
  }), /*#__PURE__*/jsx("path", {
    d: "M13.09 11.57l-.64-.25-.78-.31c-.33-.11-.42-.19-.42-.53 0-.48.74-.49.75-.49.55 0 1.03.34 1.05.35.01.01.02.01.03.02.33.22.77.15 1.01-.17a.75.75 0 00-.15-1.05c-.07-.05-.53-.39-1.2-.55V8.5c0-.41-.34-.75-.75-.75s-.75.34-.75.75v.11c-.81.24-1.5.88-1.5 1.87 0 .98.49 1.63 1.41 1.94l1.42.56c.39.13.42.33.42.53 0 .47-.42.49-.5.49-.93 0-1.61-.39-1.61-.39a.751.751 0 10-.77 1.29c.07.04.49.28 1.14.45v.16c0 .41.34.75.75.75s.75-.34.75-.75v-.02c.89-.11 1.75-.79 1.75-1.97 0-.94-.53-1.65-1.41-1.95z"
  }), /*#__PURE__*/jsx("circle", {
    cx: 6,
    cy: 12,
    r: 1
  }), /*#__PURE__*/jsx("circle", {
    cx: 18,
    cy: 12,
    r: 1
  })]
}));

/**
UiPaypalFilled icon

```jsx
import { UiPaypalFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPaypalFilled />
```

 */
const UiPaypalFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9 19.2c-.1.5-.5.8-1 .8H4c-.3 0-.6-.2-.8-.4-.2-.2-.2-.5-.2-.8l2.5-16c.1-.4.5-.8 1-.8H14c2.8 0 5 2.2 5 5 0 3.9-3.1 7-7 7H9.9L9 19.2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M12 15.5c4.5 0 8.1-3.4 8.5-7.7.3.7.5 1.4.5 2.2 0 3.9-3.1 7-7 7h-.3l-.7 4.2c-.1.4-.5.8-1 .8H9.4c.5-.4.9-.9 1-1.6l.8-4.9h.8z"
  })]
}));

/**
UiPaypalFilledSmall icon

```jsx
import { UiPaypalFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPaypalFilledSmall />
```

 */
const UiPaypalFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsxs("g", {
    clipPath: "url(#omni-gravity-icon-ui-paypal-filled-small-a)",
    children: [/*#__PURE__*/jsx("path", {
      d: "M6.5 14.2c-.1.4-.5.8-1 .8H2c-.3 0-.6-.1-.8-.4-.2-.2-.2-.5-.2-.8l2-13c.1-.4.5-.8 1-.8h6c2.2 0 4 1.8 4 4 0 3.3-2.7 6-6 6h-.9l-.6 4.2z"
    }), /*#__PURE__*/jsx("path", {
      d: "M8.5 11.4c3.6-.2 6.6-3.1 7-6.7.3.8.5 1.6.5 2.3 0 3.3-2.7 6-6 6h-.1l-.4 2.2c-.1.5-.5.8-1 .8H7c.5-.4.9-.9 1-1.6l.5-3z"
    })]
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-paypal-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiPaypalLined icon

```jsx
import { UiPaypalLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPaypalLined />
```

 */
const UiPaypalLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M18.9 5.9C18.4 3.7 16.4 2 14 2H6.5c-.5 0-.9.4-1 .8L3 18.8c0 .3 0 .6.2.8.2.2.5.4.8.4h3.2l-.2.8c0 .3 0 .6.2.8.2.2.5.4.8.4h4c.5 0 .9-.4 1-.8l.7-4.2h.3c3.9 0 7-3.1 7-7 0-1.7-.8-3.2-2.1-4.1zM8.1 12.8L7.2 18h-2L7.4 4H14c1.7 0 3 1.3 3 3 0 2.8-2.2 5-5 5H9.1c-.5 0-.9.3-1 .8zM14 15h-1.2c-.5 0-.9.4-1 .8l-.6 4.2h-2l1-6H12c3.2 0 6-2.2 6.8-5.2.1.4.2.8.2 1.2 0 2.8-2.2 5-5 5z"
  })
}));

/**
UiPaypalLinedSmall icon

```jsx
import { UiPaypalLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPaypalLinedSmall />
```

 */
const UiPaypalLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M13.7 2.6C13.1 1.1 11.7 0 10 0H4c-.5 0-.9.4-1 .8l-2 13c0 .3 0 .6.2.8.2.3.5.4.8.4h1.5c0 .2.1.5.2.6.2.3.5.4.8.4h4c.5 0 .9-.4 1-.8l.4-2.2h.1c3.3 0 6-2.7 6-6 0-1.5-.9-3.5-2.3-4.4zM6 2h4c1.1 0 2 .9 2 2 0 2.2-1.8 4-4 4H6.3c-.5 0-.9.4-1 .8L4.6 13H3.2L4.9 2H6zm4 9H9c-.5 0-.9.4-1 .8L7.7 14H6.5l.6-4H8c2.7 0 5-1.8 5.7-4.2.2.4.3.8.3 1.2 0 2.2-1.8 4-4 4z"
  })
}));

/**
UiPeopleFilled icon

```jsx
import { UiPeopleFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPeopleFilled />
```

 */
const UiPeopleFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 7.5c0 1.83-1.1 3.41-2.68 4.11-.56.25-1.17.39-1.82.39-.52 0-1.02-.11-1.49-.27C4.26 11.11 3 9.46 3 7.5 3 5.02 5.02 3 7.5 3S12 5.02 12 7.5zm5.5 3.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm-3.66 2.55c.95-.61 2.15-1.05 3.49-1.05 3 0 5.67 2.51 5.67 4.5 0 .55-.45 1-1 1h-5.12c-.35-1.59-1.45-3.22-3.04-4.45zM1 19.02c0-2.44 3.3-5.52 7-5.52s7 3.08 7 5.52c0 .55-.45 1-1 1H2c-.55 0-1-.45-1-1z"
  })
}));

/**
UiPeopleFilledSmall icon

```jsx
import { UiPeopleFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPeopleFilledSmall />
```

 */
const UiPeopleFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-people-filled-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M15 4a3 3 0 11-6 0 3 3 0 016 0zM8.9 9.5C9.7 8.6 10.8 8 12 8c2.2 0 4 1.8 4 4 0 .6-.4 1-1 1h-4.1c-.3-1.4-1-2.6-2-3.5zM5 10c-2.2 0-4 1.8-4 4 0 .6.4 1 1 1h6c.6 0 1-.4 1-1 0-2.2-1.8-4-4-4zm3-4c0 .9-.4 1.8-1.1 2.3-.5.4-1.2.7-1.9.7s-1.4-.3-1.9-.7C2.4 7.8 2 6.9 2 6c0-1.7 1.3-3 3-3s3 1.3 3 3z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-people-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiPeopleLined icon

```jsx
import { UiPeopleLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPeopleLined />
```

 */
const UiPeopleLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.5c0 2-1.4 3.7-3.2 4.3-.4.1-.8.2-1.3.2-.214 0-.4-.029-.572-.055A2.812 2.812 0 006.5 11.9C4.5 11.4 3 9.6 3 7.5 3 5 5 3 7.5 3S12 5 12 7.5zM7.5 5C6.1 5 5 6.1 5 7.5S6.1 10 7.5 10 10 8.9 10 7.5 8.9 5 7.5 5zM21 7.5c0 1.9-1.6 3.5-3.5 3.5S14 9.4 14 7.5 15.6 4 17.5 4 21 5.6 21 7.5zm-2 0c0-.8-.7-1.5-1.5-1.5S16 6.7 16 7.5 16.7 9 17.5 9 19 8.3 19 7.5z"
  }), /*#__PURE__*/jsx("path", {
    d: "M13.8 13.6c.9-.7 2.1-1.1 3.5-1.1 3 0 5.7 2.5 5.7 4.5 0 .5-.5 1-1 1-.6 0-1-.5-1-1 0-.7-1.6-2.5-3.7-2.5-.7 0-1.4.2-2 .5-.4-.5-.9-1-1.5-1.4zM2 20c.6 0 1-.4 1-1 0-1.9 2.3-3.5 5-3.5s5 1.6 5 3.5c0 .6.4 1 1 1s1-.4 1-1c0-3-3.1-5.5-7-5.5S1 16 1 19c0 .6.4 1 1 1z"
  })]
}));

/**
UiPeopleLinedSmall icon

```jsx
import { UiPeopleLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPeopleLinedSmall />
```

 */
const UiPeopleLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsxs("g", {
    clipPath: "url(#omni-gravity-icon-ui-people-lined-small-a)",
    children: [/*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15 4c0 1.7-1.3 3-3 3S9 5.7 9 4s1.3-3 3-3 3 1.3 3 3zm-2 0c0-.6-.4-1-1-1s-1 .4-1 1 .4 1 1 1 1-.4 1-1z"
    }), /*#__PURE__*/jsx("path", {
      d: "M8.9 9.6C9.6 8.6 10.7 8 12 8c2.2 0 4 1.8 4 4 0 .6-.4 1-1 1s-1-.4-1-1c0-1.1-.9-2-2-2-.8 0-1.5.5-1.7 1.2-.4-.6-.9-1.1-1.4-1.6zm-4.4.4C2 10 0 11.8 0 14c0 .6.4 1 1 1s1-.4 1-1c0-1.1 1.1-2 2.5-2s2.5.9 2.5 2c0 .6.4 1 1 1s1-.4 1-1c0-2.2-2-4-4.5-4z"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 5.5c0 1.2-.6 2.2-1.4 2.8-.6.4-1.3.7-2.1.7S3 8.7 2.4 8.3A3.5 3.5 0 011 5.5C1 3.6 2.6 2 4.5 2S8 3.6 8 5.5zM4.5 4C3.7 4 3 4.7 3 5.5S3.7 7 4.5 7 6 6.3 6 5.5 5.3 4 4.5 4z"
    })]
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-people-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiPercentageEncircledFilled icon

```jsx
import { UiPercentageEncircledFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPercentageEncircledFilled />
```

 */
const UiPercentageEncircledFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M15.5 16.5a1 1 0 100-2 1 1 0 000 2zm-7-7a1 1 0 100-2 1 1 0 000 2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M2 12C2 6.5 6.5 2 12 2s10 4.5 10 10-4.5 10-10 10S2 17.5 2 12zm11 3.5c0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5zm3.2-8.8l-9.5 9.5c-.3.3-.3.8.1 1.1.1.1.3.2.5.2s.4-.1.5-.2l9.5-9.5c.3-.3.3-.8 0-1.1-.3-.3-.8-.3-1.1 0zM8.5 6C7.1 6 6 7.1 6 8.5S7.1 11 8.5 11 11 9.9 11 8.5 9.9 6 8.5 6z"
  })]
}));

/**
UiPercentageEncircledFilledSmall icon

```jsx
import { UiPercentageEncircledFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPercentageEncircledFilledSmall />
```

 */
const UiPercentageEncircledFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M4.5 6.5a1 1 0 100-2 1 1 0 000 2zm7 5a1 1 0 100-2 1 1 0 000 2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M0 8c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8-8-3.6-8-8zm3.3 4.8c.1.1.3.2.5.2.062 0 .162-.038.3-.091.085-.033.185-.07.3-.109l8.5-8.5c.3-.3.3-.8 0-1.1-.3-.3-.8-.3-1.1 0l-8.5 8.5c-.3.3-.3.8 0 1.1zM7 5.5C7 4.1 5.9 3 4.5 3S2 4.1 2 5.5 3.1 8 4.5 8 7 6.9 7 5.5zM11.5 8C10.1 8 9 9.1 9 10.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5S12.9 8 11.5 8z"
  })]
}));

/**
UiPercentageEncircledLined icon

```jsx
import { UiPercentageEncircledLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPercentageEncircledLined />
```

 */
const UiPercentageEncircledLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M8.5 7C9.9 7 11 8.1 11 9.5S9.9 12 8.5 12 6 10.9 6 9.5 7.1 7 8.5 7zm0 1.5c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zm7 3.5c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5-1.1-2.5-2.5-2.5zm0 3.5c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm.2-8.3c.3-.3.8-.3 1.1 0 .3.3.3.8 0 1.1l-8.5 8.5c-.1.1-.3.2-.5.2s-.4-.1-.6-.2c-.3-.3-.3-.8 0-1.1l8.5-8.5z"
  }), /*#__PURE__*/jsx("path", {
    d: "M2 12C2 6.5 6.5 2 12 2s10 4.5 10 10-4.5 10-10 10S2 17.5 2 12zm2 0c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8-8 3.6-8 8z"
  })]
}));

/**
UiPercentageFilled icon

```jsx
import { UiPercentageFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPercentageFilled />
```

 */
const UiPercentageFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M15.5 16.5a1 1 0 100-2 1 1 0 000 2zm-7-7a1 1 0 100-2 1 1 0 000 2z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.5 6.5 2 12 2s10 4.5 10 10-4.5 10-10 10S2 17.5 2 12zm11 3.5c0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5zm3.2-8.8l-9.5 9.5c-.3.3-.3.8.1 1.1.1.1.3.2.5.2s.4-.1.5-.2l9.5-9.5c.3-.3.3-.8 0-1.1-.3-.3-.8-.3-1.1 0zM8.5 6C7.1 6 6 7.1 6 8.5S7.1 11 8.5 11 11 9.9 11 8.5 9.9 6 8.5 6z"
  })]
}));

/**
UiPercentageLined icon

```jsx
import { UiPercentageLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPercentageLined />
```

 */
const UiPercentageLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M7.5 11C9.4 11 11 9.4 11 7.5S9.4 4 7.5 4 4 5.6 4 7.5 5.6 11 7.5 11zm0-5C8.3 6 9 6.7 9 7.5S8.3 9 7.5 9 6 8.3 6 7.5 6.7 6 7.5 6zm9 7c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5 3.5-1.6 3.5-3.5-1.6-3.5-3.5-3.5zm0 5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5zm3.2-13.7c-.4-.4-1-.4-1.4 0l-14 14c-.4.4-.4 1 0 1.4.4.4 1.2.2 1.4 0l14-14c.4-.4.4-1 0-1.4z"
  })
}));

/**
UiPercentageLinedSmall icon

```jsx
import { UiPercentageLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPercentageLinedSmall />
```

 */
const UiPercentageLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M4 7c1.7 0 3-1.3 3-3S5.7 1 4 1 1 2.3 1 4s1.3 3 3 3zm0-4c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zm8 6c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm2.2-11.2c-.4-.4-1-.4-1.4 0l-11 11c-.4.4-.4 1 0 1.4.5.5 1.2.2 1.4 0l11-11c.4-.4.4-1 0-1.4z"
  })
}));

/**
UiPersonEncircledFilled icon

```jsx
import { UiPersonEncircledFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPersonEncircledFilled />
```

 */
const UiPersonEncircledFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 3c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4zm0 15c-2.3 0-4.5-1-5.9-2.6.4-1.9 2.8-3.4 5.9-3.4 3.1 0 5.5 1.5 5.9 3.4C16.5 19 14.3 20 12 20z"
  })
}));

/**
UiPersonEncircledFilledSmall icon

```jsx
import { UiPersonEncircledFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPersonEncircledFilledSmall />
```

 */
const UiPersonEncircledFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 3c1.7 0 3 1.3 3 3S9.7 9 8 9 5 7.7 5 6s1.3-3 3-3zm0 11c-1.8 0-3.4-.8-4.5-2 .8-1.2 2.5-2 4.5-2s3.7.8 4.5 2c-1.1 1.2-2.7 2-4.5 2z"
  })
}));

/**
UiPersonEncircledLined icon

```jsx
import { UiPersonEncircledLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPersonEncircledLined />
```

 */
const UiPersonEncircledLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M16 10a4 4 0 11-8 0 4 4 0 018 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.5 6.5 2 12 2s10 4.5 10 10-4.5 10-10 10S2 17.5 2 12zm10 3c2.7 0 4.9 1.2 5.7 2.7 1.4-1.5 2.3-3.5 2.3-5.7 0-4.4-3.6-8-8-8s-8 3.6-8 8c0 2.2.9 4.2 2.3 5.7.9-1.6 3-2.7 5.7-2.7z"
  })]
}));

/**
UiPersonEncircledLinedSmall icon

```jsx
import { UiPersonEncircledLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPersonEncircledLinedSmall />
```

 */
const UiPersonEncircledLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11 7a3 3 0 11-6 0 3 3 0 016 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8-8-3.6-8-8zm8 3c1.7 0 3.1.6 4 1.4 1.2-1.1 2-2.6 2-4.4 0-3.3-2.7-6-6-6S2 4.7 2 8c0 1.8.8 3.3 2 4.4.9-.8 2.3-1.4 4-1.4z"
  })]
}));

/**
UiPersonFilled icon

```jsx
import { UiPersonFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPersonFilled />
```

 */
const UiPersonFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M17.5 7.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zM4 20c0-2.54 3.49-5.5 8-5.5s8 2.96 8 5.5c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1z"
  })
}));

/**
UiPersonFilledSmall icon

```jsx
import { UiPersonFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPersonFilledSmall />
```

 */
const UiPersonFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 5a4 4 0 11-8 0 4 4 0 018 0zM2 14c0-2.2 2.6-4 6-4s6 1.8 6 4c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1z"
  })
}));

/**
UiPersonLined icon

```jsx
import { UiPersonLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPersonLined />
```

 */
const UiPersonLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 7.5c0 3.03-2.47 5.5-5.5 5.5a5.51 5.51 0 01-5.5-5.5C6.5 4.47 8.97 2 12 2s5.5 2.47 5.5 5.5zm-2 0C15.5 5.57 13.93 4 12 4S8.5 5.57 8.5 7.5 10.07 11 12 11s3.5-1.57 3.5-3.5z"
  }), /*#__PURE__*/jsx("path", {
    d: "M4 20c0-2.54 3.49-5.5 8-5.5s8 2.96 8 5.5c0 .55-.45 1-1 1s-1-.45-1-1c0-1.23-2.47-3.5-6-3.5S6 18.77 6 20c0 .55-.45 1-1 1s-1-.45-1-1z"
  })]
}));

/**
UiPersonLinedSmall icon

```jsx
import { UiPersonLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPersonLinedSmall />
```

 */
const UiPersonLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5c0 2.2-1.8 4-4 4S4 7.2 4 5s1.8-4 4-4 4 1.8 4 4zm-2 0c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M2 14c0-2.2 2.6-4 6-4s6 1.8 6 4c0 .6-.4 1-1 1s-1-.4-1-1c0-.9-1.7-2-4-2s-4 1.1-4 2c0 .6-.4 1-1 1s-1-.4-1-1z"
  })]
}));

/**
UiPersonSettingsFilled icon

```jsx
import { UiPersonSettingsFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPersonSettingsFilled />
```

 */
const UiPersonSettingsFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12 13a5.5 5.5 0 100-11 5.5 5.5 0 000 11zm0 1.5c-6.6 0-8 4-8 5.5 0 .6.4 1 1 1h8.8c-.5-.9-.8-1.9-.8-3 0-1.2.4-2.4 1-3.4-.288 0-.6-.023-.924-.047A14.516 14.516 0 0012 14.5z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 18.4l.7.5c.4.3.6.9.3 1.3l-.1.2c-.3.4-.8.6-1.3.4l-.8-.4c-.2.2-.4.3-.6.4l-.1.8c-.1.5-.5.9-1 .9h-.2c-.5 0-.9-.4-1-.9l-.1-.8c-.1-.05-.2-.125-.3-.2-.1-.075-.2-.15-.3-.2l-.8.4c-.5.2-1 0-1.3-.4l-.1-.2c-.2-.4-.1-1 .3-1.3l.7-.5v-.8l-.7-.5c-.4-.3-.6-.9-.3-1.3l.1-.2c.3-.4.8-.6 1.3-.4l.8.4c.2-.2.4-.3.6-.4l.1-.8c.1-.5.5-.9 1-.9h.2c.5 0 .9.4 1 .9l.1.8c.1.05.2.125.3.2.1.075.2.15.3.2l.8-.4c.5-.2 1 0 1.3.4l.1.2c.2.4.1 1-.3 1.3l-.7.5v.8zm-4.5-.4c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5-.7-1.5-1.5-1.5-1.5.7-1.5 1.5z"
  })]
}));

/**
UiPersonSettingsLined icon

```jsx
import { UiPersonSettingsLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPersonSettingsLined />
```

 */
const UiPersonSettingsLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13c3 0 5.5-2.5 5.5-5.5S15 2 12 2 6.5 4.5 6.5 7.5 9 13 12 13zm0-9c1.9 0 3.5 1.6 3.5 3.5S13.9 11 12 11 8.5 9.4 8.5 7.5 10.1 4 12 4z"
  }), /*#__PURE__*/jsx("path", {
    d: "M12 14.5c-6.6 0-8 4-8 5.5 0 .6.4 1 1 1s1-.4 1-1c0 0 .2-3.5 6-3.5.6 0 1-.4 1-1s-.4-1-1-1z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 18.4l.7.5c.4.3.6.9.3 1.3l-.1.2c-.3.4-.8.6-1.3.4l-.8-.4c-.2.2-.4.3-.6.4l-.1.8c-.1.5-.5.9-1 .9h-.2c-.5 0-.9-.4-1-.9l-.1-.8c-.1-.05-.2-.125-.3-.2-.1-.075-.2-.15-.3-.2l-.8.4c-.5.2-1 0-1.3-.4l-.1-.2c-.2-.4-.1-1 .3-1.3l.7-.5v-.8l-.7-.5c-.4-.3-.6-.9-.3-1.3l.1-.2c.3-.4.8-.6 1.3-.4l.8.4c.2-.2.4-.3.6-.4l.1-.8c.1-.5.5-.9 1-.9h.2c.5 0 .9.4 1 .9l.1.8c.1.05.2.125.3.2.1.075.2.15.3.2l.8-.4c.5-.2 1 0 1.3.4l.1.2c.2.4.1 1-.3 1.3l-.7.5v.8zm-4.5-.4c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5-.7-1.5-1.5-1.5-1.5.7-1.5 1.5z"
  })]
}));

/**
UiPhoneFilled icon

```jsx
import { UiPhoneFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPhoneFilled />
```

 */
const UiPhoneFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20.8 14.8l-3.3-1.5c-.8-.3-1.6-.2-2.2.4L13 16.1c-2.1-1-3.9-2.6-4.9-4.7l2.3-2.3c.5-.5.7-1.3.5-2L9.7 3.4C9.4 2.6 8.6 2 7.8 2H6C4.3 2 3 3.3 3 5v2c0 7.7 6.3 14 14 14h2c1.7 0 3-1.3 3-3v-1.3c0-.8-.5-1.6-1.2-1.9z"
  })
}));

/**
UiPhoneFilledSmall icon

```jsx
import { UiPhoneFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPhoneFilledSmall />
```

 */
const UiPhoneFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-phone-filled-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M15 10.9l-1.9-1.4c-.7-.4-1.6-.3-2.2.1l-2.3 1.6c-1.6-.7-3-2-3.8-3.6l1.5-1.9c.6-.7.7-1.5.3-2.2l-1-2.4C5.3.4 4.6 0 3.9 0H3C1.3 0 0 1.3 0 3c0 0 0 1.8.1 2.2 0 .3.1 1 .2 1.1.6 3.3 2.7 6.2 5.5 7.9 0 0 3.1 1.6 5.3 1.8h2c.8 0 1.5-.3 2.1-.9.6-.6.9-1.3.9-2.1v-.4c-.1-.7-.5-1.4-1.1-1.7z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-phone-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiPhoneLined icon

```jsx
import { UiPhoneLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPhoneLined />
```

 */
const UiPhoneLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20.8 14.8l-3.3-1.5c-.8-.3-1.6-.2-2.2.4l-1.6 1.6c-2.2-.9-4-2.6-4.9-4.7l1.5-1.5c.5-.5.7-1.3.5-2L9.7 3.4C9.4 2.6 8.6 2 7.8 2H6C4.3 2 3 3.3 3 5v2c0 7.7 6.3 14 14 14h2c1.7 0 3-1.3 3-3v-1.3c0-.8-.5-1.6-1.2-1.9zM20 18c0 .6-.4 1-1 1h-2C10.4 19 5 13.6 5 7V5c0-.6.4-1 1-1h1.8l1.1 3.7-2 2c-.3.3-.4.7-.2 1 1.2 3.2 3.8 5.7 7 6.7.4.1.7 0 1-.2l2-2 3.3 1.5V18z"
  })
}));

/**
UiPhoneLinedSmall icon

```jsx
import { UiPhoneLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPhoneLinedSmall />
```

 */
const UiPhoneLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M13 16h-2C4.8 15.4 0 10.1 0 4V3c0-1.7 1.3-3 3-3h1.4c.8 0 1.4.4 1.8 1.1L7.1 3c.4.7.3 1.6-.3 2.2L5.5 6.7c.7 1.6 1.9 2.9 3.5 3.6l1.4-1.1c.6-.6 1.5-.6 2.2-.2l2.4 1.4c.6.4 1 1 1 1.7v.9c0 .8-.3 1.6-.9 2.1-.6.5-1.3.9-2.1.9zM4.4 2H3c-.6 0-1 .4-1 1v1c0 5.1 4 9.5 9.1 10H13c.3 0 .5-.1.7-.3.2-.2.3-.4.3-.7v-.9l-2.4-1.4-1.8 1.5c-.3.2-.7.3-1 .2-2.5-1-4.5-3-5.3-5.6-.1-.3 0-.7.2-1l1.7-2-1-1.8z"
  })
}));

/**
UiPinFilled icon

```jsx
import { UiPinFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPinFilled />
```

 */
const UiPinFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 9.5c0 .3-.2.5-.5.5h-3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3c.3 0 .5.2.5.5zM3.5 12c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5zm5 0c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5zm6.5 1.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5z"
  })
}));

/**
UiPinFilledSmall icon

```jsx
import { UiPinFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPinFilledSmall />
```

 */
const UiPinFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M15 3H1c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V4c0-.6-.4-1-1-1zM3.5 9c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm3 0c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm3 0c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm4 2h-2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2c.3 0 .5.2.5.5s-.2.5-.5.5z"
  })
}));

/**
UiPinLined icon

```jsx
import { UiPinLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPinLined />
```

 */
const UiPinLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M5.5 13.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm6-1.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm3 1.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm2 .5h3c.3 0 .5.2.5.5s-.2.5-.5.5h-3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H3V7h18v10z"
  })]
}));

/**
UiPinLinedSmall icon

```jsx
import { UiPinLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPinLinedSmall />
```

 */
const UiPinLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M4 9a1 1 0 100-2 1 1 0 000 2zm4-1a1 1 0 11-2 0 1 1 0 012 0zm2 1a1 1 0 100-2 1 1 0 000 2zm2.5 1h-1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h1c.3 0 .5.2.5.5s-.2.5-.5.5z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3H1c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V4c0-.6-.4-1-1-1zm-1 2v6H2V5h12z"
  })]
}));

/**
UiPistonFilled icon

```jsx
import { UiPistonFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPistonFilled />
```

 */
const UiPistonFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22.31 8.76l-7.07-7.07a2 2 0 00-2.83 0L6.76 7.34a2 2 0 000 2.83l1.41 1.42L5.79 14a4 4 0 00-3 1.69 4 4 0 002.91 6.24c.117.01.234.01.35 0a4 4 0 004-3.74l2.38-2.38 1.42 1.41a2 2 0 002.83 0l5.65-5.65a2 2 0 00-.02-2.81zm-15.55 9.9a1 1 0 11-1.41-1.421 1 1 0 011.41 1.421zm12.73-7.07l-7.08-7.08 1.42-1.41 7.07 7.07-1.41 1.42z"
  })
}));

/**
UiPistonLined icon

```jsx
import { UiPistonLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPistonLined />
```

 */
const UiPistonLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M5.34 17.24a1 1 0 101.42 1.409 1 1 0 00-1.42-1.409z"
  }), /*#__PURE__*/jsx("path", {
    d: "M22.31 8.76l-7.07-7.07a2 2 0 00-2.83 0L6.76 7.34a2 2 0 000 2.83l1.41 1.42L5.79 14a4 4 0 00-3 1.69 4 4 0 002.91 6.24c.117.01.234.01.35 0a4 4 0 004-3.74l2.38-2.38 1.42 1.41a2 2 0 002.83 0l5.65-5.65a2 2 0 00-.02-2.81zm-7.07 7.07l-2.12-2.12a1 1 0 00-1.41 0l-3.38 3.38a1 1 0 00-.29.76 2 2 0 01-.58 1.51 1.93 1.93 0 01-1.58.58 2 2 0 01-1.48-3.13A2 2 0 016 16h.12a1 1 0 00.75-.29l3.38-3.38a1 1 0 000-1.41L8.17 8.76 11 5.93 18.07 13l-2.83 2.83zm4.25-4.24l-7.08-7.08 1.42-1.41 7.07 7.07-1.41 1.42z"
  })]
}));

/**
UiPlaneFilled icon

```jsx
import { UiPlaneFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPlaneFilled />
```

 */
const UiPlaneFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M19.841 19.702l-2.14-10.05 2.6-2.6c1.51-1.51 2.46-4.05 1.7-4.8-.75-.75-3.21.27-4.72 1.78l-2.6 2.6-10.05-2.13c-.41-.1-.84.02-1.14.31-.6.58-.48 1.57.25 1.99l7.24 3.55-2.81 2.81-3.14-.69c-.36-.08-.73.03-.99.29l-.73.73c-.53.53-.36 1.44.33 1.74l3.83 1.64 1.64 3.83c.3.7 1.2.87 1.74.33l.74-.74c.25-.25.36-.62.29-.97l-.64-3.21 2.75-2.75 3.55 7.24c.41.73 1.41.85 1.99.25.29-.31.4-.74.31-1.15z"
  })
}));

/**
UiPlaneFilledSmall icon

```jsx
import { UiPlaneFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPlaneFilledSmall />
```

 */
const UiPlaneFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M11.42 6.708l1.74-1.74c.37-.37 3.33-3.33 2.27-4.39-1.06-1.06-4.02 1.9-4.39 2.27l-1.75 1.74-7.04-2.71c-.37-.14-.8-.06-1.08.23l-.53.52a.5.5 0 00.07.76l6.14 3.64-2.03 2.03c-.15.15-.45.54-.72.95l-2.22-.74c-.36-.12-.76-.03-1.03.24l-.38.38c-.33.33-.28.88.1 1.15l2.83 1.56 1.56 2.83c.27.38.82.43 1.15.1l.38-.38a.99.99 0 00.24-1.02l-.74-2.23c.41-.27.79-.56.95-.72l2.03-2.03 3.64 6.14c.18.26.54.29.76.07l.53-.53c.28-.28.37-.71.22-1.08l-2.7-7.04z"
  })
}));

/**
UiPlaneLined icon

```jsx
import { UiPlaneLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPlaneLined />
```

 */
const UiPlaneLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M9.66 21.73c-.13 0-.25-.01-.38-.04-.65-.13-1.2-.57-1.46-1.18L6.44 17.3l-3.22-1.38c-.61-.26-1.05-.81-1.18-1.46-.13-.65.08-1.32.55-1.79l.69-.69c.49-.49 1.18-.69 1.84-.54l2.41.53 1.32-1.32-4.71-2.68c-.6-.34-1-.93-1.08-1.62-.09-.69.15-1.36.65-1.83.53-.51 1.28-.71 2-.54l7.93 1.87 2.04-2.04c.79-.79 1.74-1.38 2.67-1.65 1.11-.32 2.09-.16 2.7.45.6.6.78 1.59.5 2.7-.25.97-.83 1.94-1.62 2.74l-2.04 2.04 1.88 7.93c.17.72-.03 1.46-.54 1.99-.48.5-1.15.75-1.84.66-.69-.08-1.28-.48-1.62-1.08l-2.67-4.71-1.27 1.27.5 2.49c.13.66-.07 1.33-.55 1.81l-.7.7c-.39.38-.9.58-1.42.58zm-4.97-8.34l-.69.69 3.96 1.7 1.7 3.96.7-.7-.71-3.54 3.88-3.88 3.97 6.99c.03.05.07.08.13.08.05.01.1-.01.14-.05.04-.04.05-.1.04-.15l-2.13-9.02 2.83-2.83c1.14-1.14 1.27-2.39 1.11-2.62-.22-.14-1.41.09-2.53 1.2l-2.83 2.83-9.01-2.13c-.05-.01-.11 0-.15.04-.05.04-.06.09-.06.15.01.06.04.1.08.13l6.99 3.97-3.95 3.95-3.47-.77z"
  })
}));

/**
UiPlayEncircledFilled icon

```jsx
import { UiPlayEncircledFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPlayEncircledFilled />
```

 */
const UiPlayEncircledFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4 10.9l-5.5 3.2c-.2.1-.3.1-.5.1s-.3 0-.5-.1c-.3-.2-.5-.5-.5-.8V8.8c0-.4.2-.7.5-.9.3-.2.7-.2 1 0l5.5 3.2c.3.2.5.5.5.9s-.2.7-.5.9z"
  })
}));

/**
UiPlayEncircledFilledSmall icon

```jsx
import { UiPlayEncircledFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPlayEncircledFilledSmall />
```

 */
const UiPlayEncircledFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm3.12 8.85L7.14 11.3c-.5.3-1.14-.06-1.14-.64V5.34c0-.58.64-.94 1.14-.64l3.97 2.44c.64.4.64 1.32.01 1.71z"
  })
}));

/**
UiPlayEncircledLined icon

```jsx
import { UiPlayEncircledLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPlayEncircledLined />
```

 */
const UiPlayEncircledLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M10.5 7.9l5.5 3.2c.3.2.5.6.5 1s-.2.7-.5.9l-5.5 3.2c-.1.1-.3.1-.5.1s-.3 0-.5-.1c-.3-.2-.5-.5-.5-.9V8.8c0-.4.2-.7.5-.9.3-.2.7-.2 1 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.5 6.5 2 12 2s10 4.5 10 10-4.5 10-10 10S2 17.5 2 12zm2 0c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8-8 3.6-8 8z"
  })]
}));

/**
UiPlayFilled icon

```jsx
import { UiPlayFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPlayFilled />
```

 */
const UiPlayFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M7 21c-.3 0-.7-.1-1-.3-.6-.4-1-1-1-1.7V5c0-.7.4-1.4 1-1.7.6-.4 1.4-.4 2 0l12 7c.6.4 1 1 1 1.7s-.4 1.4-1 1.7l-12 7c-.3.2-.7.3-1 .3z"
  })
}));

/**
UiPlayFilledSmall icon

```jsx
import { UiPlayFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPlayFilledSmall />
```

 */
const UiPlayFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M3.5 14.5c-.3 0-.5-.1-.8-.2-.4-.299-.7-.798-.7-1.297v-9.98c0-.5.3-.999.7-1.298.5-.3 1-.3 1.5 0l9 4.99c.5.2.8.798.8 1.297 0 .5-.3 1.098-.8 1.298l-9 4.99c-.2.1-.5.2-.7.2z"
  })
}));

/**
UiPlayLined icon

```jsx
import { UiPlayLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPlayLined />
```

 */
const UiPlayLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M7 21c-.3 0-.7-.1-1-.3-.6-.4-1-1-1-1.7V5c0-.7.4-1.4 1-1.7.6-.4 1.4-.4 2 0l12 7c.6.4 1 1 1 1.7s-.4 1.4-1 1.7l-12 7c-.3.2-.7.3-1 .3zM7 5v14l12-7L7 5z"
  })
}));

/**
UiPlayLinedSmall icon

```jsx
import { UiPlayLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPlayLinedSmall />
```

 */
const UiPlayLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M3.5 14.5c-.3 0-.5-.1-.8-.2-.4-.299-.7-.798-.7-1.297v-9.98c0-.5.3-.999.7-1.298.5-.3 1-.3 1.5 0l9 4.99c.5.2.8.798.8 1.297 0 .5-.3 1.098-.8 1.298l-9 4.99c-.2.1-.5.2-.7.2zM4 3.82v8.285l7.4-4.192L4 3.82z"
  })
}));

/**
UiPlusEncircledFilled icon

```jsx
import { UiPlusEncircledFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPlusEncircledFilled />
```

 */
const UiPlusEncircledFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4 11h-3v3c0 .55-.45 1-1 1s-1-.45-1-1v-3H8c-.55 0-1-.45-1-1s.45-1 1-1h3V8c0-.55.45-1 1-1s1 .45 1 1v3h3c.55 0 1 .45 1 1s-.45 1-1 1z"
  })
}));

/**
UiPlusEncircledFilledSmall icon

```jsx
import { UiPlusEncircledFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPlusEncircledFilledSmall />
```

 */
const UiPlusEncircledFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3 9H9v2c0 .5-.5 1-1 1s-1-.5-1-1V9H5c-.5 0-1-.5-1-1s.5-1 1-1h2V5c0-.5.5-1 1-1s1 .5 1 1v2h2c.5 0 1 .5 1 1s-.5 1-1 1z"
  })
}));

/**
UiPlusEncircledLined icon

```jsx
import { UiPlusEncircledLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPlusEncircledLined />
```

 */
const UiPlusEncircledLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M13 11h3c.55 0 1 .45 1 1s-.45 1-1 1h-3v3c0 .55-.45 1-1 1s-1-.45-1-1v-3H8c-.55 0-1-.45-1-1s.45-1 1-1h3V8c0-.55.45-1 1-1s1 .45 1 1v3z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm2 0c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8-8 3.59-8 8z"
  })]
}));

/**
UiPlusEncircledLinedSmall icon

```jsx
import { UiPlusEncircledLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPlusEncircledLinedSmall />
```

 */
const UiPlusEncircledLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9 7h2c.5 0 1 .5 1 1s-.5 1-1 1H9v2c0 .5-.5 1-1 1s-1-.5-1-1V9H5c-.5 0-1-.5-1-1s.5-1 1-1h2V5c0-.5.5-1 1-1s1 .5 1 1v2z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8-8-3.6-8-8zm2 0c0 3.3 2.7 6 6 6s6-2.7 6-6-2.7-6-6-6-6 2.7-6 6z"
  })]
}));

/**
UiPlusLined icon

```jsx
import { UiPlusLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPlusLined />
```

 */
const UiPlusLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 11h-7V4c0-.55-.45-1-1-1s-1 .45-1 1v7H4c-.55 0-1 .45-1 1s.45 1 1 1h7v7c0 .55.45 1 1 1s1-.45 1-1v-7h7c.55 0 1-.45 1-1s-.45-1-1-1z"
  })
}));

/**
UiPlusLinedSmall icon

```jsx
import { UiPlusLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPlusLinedSmall />
```

 */
const UiPlusLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14 7H9V2c0-.5-.4-1-1-1s-1 .5-1 1v5H2c-.5 0-1 .4-1 1s.5 1 1 1h5v5c0 .5.4 1 1 1s1-.5 1-1V9h5c.5 0 1-.4 1-1s-.5-1-1-1z"
  })
}));

/**
UiPreQualifyFilled icon

```jsx
import { UiPreQualifyFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPreQualifyFilled />
```

 */
const UiPreQualifyFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M15.8 4.1c-.1-.1-.2-.1-.3-.1-.05 0-.125.025-.2.05a.773.773 0 01-.2.05c-.1.1-.1.2-.1.4v2c0 .05.025.125.05.2.025.075.05.15.05.2.041 0 .083.017.131.037A.654.654 0 0015.5 7c.05 0 .125-.025.2-.05a.773.773 0 01.2-.05c0-.117.034-.2.063-.269A.358.358 0 0016 6.5v-2c0-.2-.1-.3-.2-.4z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h5.7c-1.1-1.2-1.7-2.8-1.7-4.5v-1c0-.05.025-.1.05-.15.025-.05.05-.1.05-.15.1-.4.2-.8.4-1.2-.3 0-.5-.3-.5-.5v-1c0-.3.2-.5.5-.5h1.2c.4-.5.9-.9 1.4-1.2-.1-.1-.1-.2-.1-.3v-1c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v.5l.199-.034c.516-.087.98-.166 1.601-.166.4 0 .8 0 1.2.1V3c-.1-1.1-.9-2-2-2zM8.5 14h1c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5zM8 12.5v-1c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5zm.5 4.5h1c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5zm4.5-4.5c0 .3-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v1zM7 8V3h10v5H7z"
  }), /*#__PURE__*/jsx("path", {
    d: "M14 15.1s1.8-.1 4-.1c1.6 0 4 .3 4 1.8 0 2.4-6.4 5.2-8 5.2v-.5s3.9-2.1 3.9-3.7c0-1.7-3.9-1.8-3.9-1.8v-.9z"
  })]
}));

/**
UiPreQualifyLined icon

```jsx
import { UiPreQualifyLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPreQualifyLined />
```

 */
const UiPreQualifyLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M15.8 4.1c-.1-.1-.2-.1-.3-.1-.05 0-.125.025-.2.05a.773.773 0 01-.2.05c-.1.1-.1.2-.1.4v2c0 .05.025.125.05.2.025.075.05.15.05.2.041 0 .083.017.131.037A.654.654 0 0015.5 7c.05 0 .125-.025.2-.05a.773.773 0 01.2-.05c0-.117.034-.2.063-.269A.358.358 0 0016 6.5v-2c0-.2-.1-.3-.2-.4z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6 21.2c.2.2.4.5.4.8 0 .5-.4.9-.9 1H7c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v9.1c-.1.5-.5.9-1 .9-.237 0-.35-.063-.485-.138a2.835 2.835 0 00-.115-.062c-.2-.2-.4-.5-.4-.8v-2H7v11h4c.2 0 .4.1.6.2zM7 3v5h10V3H7z"
  }), /*#__PURE__*/jsx("path", {
    d: "M8.5 11h1c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5zm3 0h1c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5zm3 0c-.3 0-.5.2-.5.5v1c0 .3.2.5.5.5h1c.3 0 .5-.2.5-.5v-1c0-.3-.2-.5-.5-.5h-1zm-6 3h1c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5zm4 0h-1c-.3 0-.5.2-.5.5v1c0 .3.2.5.5.5h1c.3 0 .5-.2.5-.5v-1c0-.3-.2-.5-.5-.5zm-4 3h1c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5zm4 0h-1c-.3 0-.5.2-.5.5v1c0 .3.2.5.5.5h1c.3 0 .5-.2.5-.5v-1c0-.3-.2-.5-.5-.5zm6.5-2c1.5.1 3 .6 3 1.8 0 1.1-1.4 2.3-3.1 3.3h-.1c-1.9 1.1-4.1 1.9-5 1.9v-.5s3.9-2.1 3.9-3.7c0-1.1-1.6-1.5-2.7-1.7-.6-.1-1.1-.1-1.1-.1v-.9s.8-.1 1.9-.1H19z"
  })]
}));

/**
UiPrintFilled icon

```jsx
import { UiPrintFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPrintFilled />
```

 */
const UiPrintFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 7h-1V4c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v3H4c-1.65 0-3 1.35-3 3v8c0 .55.45 1 1 1h3v1c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-1h3c.55 0 1-.45 1-1v-8c0-1.65-1.35-3-3-3zM7 19v-5h10v5H7zm-2-9c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2-5h10v2H7V5z"
  })
}));

/**
UiPrintFilledSmall icon

```jsx
import { UiPrintFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPrintFilledSmall />
```

 */
const UiPrintFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14 4h-1V2c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v2H2C.9 4 0 4.9 0 6v6c0 .55.45 1 1 1h2v1c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1h2c.55 0 1-.45 1-1V6c0-1.1-.9-2-2-2zm-9 9v-3h6v3H5zM5 3h6v1H5V3z"
  })
}));

/**
UiPrintLined icon

```jsx
import { UiPrintLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPrintLined />
```

 */
const UiPrintLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M6 11a1 1 0 11-2 0 1 1 0 012 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 7h1c1.65 0 3 1.35 3 3v8c0 .55-.45 1-1 1h-3v1c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-1H2c-.55 0-1-.45-1-1v-8c0-1.65 1.35-3 3-3h1V4c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v3zm-2-2H7v2h10V5zm0 10H7v4h10v-4zm2 2h2v-7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v7h2v-3c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v3z"
  })]
}));

/**
UiPrintLinedSmall icon

```jsx
import { UiPrintLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiPrintLinedSmall />
```

 */
const UiPrintLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14 4h-1V2c0-.6-.4-1-1-1H4c-.6 0-1 .4-1 1v2H2C.9 4 0 4.9 0 6v6c0 .6.4 1 1 1h2v1c0 .6.4 1 1 1h8c.6 0 1-.4 1-1v-1h2c.6 0 1-.4 1-1V6c0-1.1-.9-2-2-2zM5 3h6v1H5V3zm6 10H5v-3h6v3zm3-2h-1V9c0-.6-.4-1-1-1H4c-.6 0-1 .4-1 1v2H2V6h12v5z"
  })
}));

/**
UiProtectedFilled icon

```jsx
import { UiProtectedFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiProtectedFilled />
```

 */
const UiProtectedFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22.5 4.3c-4.44-.38-7.39-1.33-10.19-3.21a.58.58 0 00-.62 0C8.22 3.42 4.74 4.01 1.5 4.3c-.29.03-.51.28-.5.57.39 8.18 2.37 14.39 10.78 18.08.14.06.3.06.44 0C20.69 19.21 22.65 13.02 23 4.87a.55.55 0 00-.5-.57z"
  })
}));

/**
UiProtectedFilledSmall icon

```jsx
import { UiProtectedFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiProtectedFilledSmall />
```

 */
const UiProtectedFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-protected-filled-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M15.64 2.4c-3.23-.29-5.38-.97-7.42-2.33a.409.409 0 00-.45 0C5.26 1.76 2.72 2.19.36 2.4c-.21.02-.37.2-.36.42.28 5.95 1.72 10.48 7.84 13.16.06.03.25.03.32 0 6.16-2.72 7.59-7.23 7.84-13.17.02-.21-.14-.39-.36-.41z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-protected-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiProtectedLined icon

```jsx
import { UiProtectedLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiProtectedLined />
```

 */
const UiProtectedLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22.5 4.3c-4.44-.38-7.39-1.33-10.19-3.21a.58.58 0 00-.62 0C8.22 3.42 4.74 4.01 1.5 4.3c-.29.03-.51.28-.5.57.39 8.18 2.37 14.39 10.78 18.08.14.06.3.06.44 0C20.69 19.21 22.65 13.02 23 4.87a.55.55 0 00-.5-.57zM12 20.86c-6.57-3.11-8.42-7.97-8.92-14.71C5.93 5.81 8.94 5.12 12 3.27c2.55 1.54 5.32 2.44 8.93 2.88-.46 6.71-2.31 11.57-8.93 14.71z"
  })
}));

/**
UiProtectedLinedSmall icon

```jsx
import { UiProtectedLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiProtectedLinedSmall />
```

 */
const UiProtectedLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-protected-lined-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M15.64 2.4c-3.23-.29-5.38-.97-7.42-2.33A.39.39 0 007.99 0c-.07 0-.15.02-.22.07C5.26 1.76 2.72 2.19.36 2.4c-.21.02-.37.2-.36.42.28 5.95 1.72 10.48 7.84 13.16.03.01.09.02.15.02.07 0 .13-.01.17-.02 6.16-2.72 7.59-7.23 7.84-13.17.02-.21-.14-.39-.36-.41zM8 13.85c-4.21-2.08-5.51-5.17-5.9-9.63 1.86-.27 3.89-.78 5.9-1.94 1.71.98 3.58 1.59 5.91 1.93-.37 4.44-1.66 7.53-5.91 9.64z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-protected-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiQrCodeLined icon

```jsx
import { UiQrCodeLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiQrCodeLined />
```

 */
const UiQrCodeLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M8 5H5v3h3V5z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2H3c-.6 0-1 .4-1 1v7c0 .6.4 1 1 1h7c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1zM9 9H4V4h5v5z"
  }), /*#__PURE__*/jsx("path", {
    d: "M19 5h-3v3h3V5z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2h7c.6 0 1 .4 1 1v7c0 .6-.4 1-1 1h-7c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1zm1 7h5V4h-5v5z"
  }), /*#__PURE__*/jsx("path", {
    d: "M8 16H5v3h3v-3z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 13h7c.6 0 1 .4 1 1v7c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1v-7c0-.6.4-1 1-1zm1 7h5v-5H4v5z"
  }), /*#__PURE__*/jsx("path", {
    d: "M14 13h1c.6 0 1 .4 1 1v2h-2c-.6 0-1-.4-1-1v-1c0-.6.4-1 1-1zm5 3h-3v3h-2c-.6 0-1 .4-1 1v1c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-2h3v2c0 .6.4 1 1 1h1c.6 0 1-.4 1-1v-1c0-.6-.4-1-1-1h-2v-3zm0 0v-2c0-.6.4-1 1-1h1c.6 0 1 .4 1 1v1c0 .6-.4 1-1 1h-2z"
  })]
}));

/**
UiQrCodeLinedSmall icon

```jsx
import { UiQrCodeLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiQrCodeLinedSmall />
```

 */
const UiQrCodeLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1h4c.6 0 1 .4 1 1v4c0 .6-.4 1-1 1H2c-.6 0-1-.4-1-1V2c0-.6.4-1 1-1zm1 4h2V3H3v2zM2 9h4c.6 0 1 .4 1 1v4c0 .6-.4 1-1 1H2c-.6 0-1-.4-1-1v-4c0-.6.4-1 1-1zm1 4h2v-2H3v2zm7-6h4c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1h-4c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1zm1-4h2v2h-2V3z"
  }), /*#__PURE__*/jsx("path", {
    d: "M9 9.5c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5V11H9.5c-.3 0-.5-.2-.5-.5v-1zm4 1.5h-2v2H9.5c-.3 0-.5.2-.5.5v1c0 .3.2.5.5.5h1c.3 0 .5-.2.5-.5V13h2v1.5c0 .3.2.5.5.5h1c.3 0 .5-.2.5-.5v-1c0-.3-.2-.5-.5-.5H13v-2zm0 0V9.5c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5H13z"
  })]
}));

/**
UiRadiusLined icon

```jsx
import { UiRadiusLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRadiusLined />
```

 */
const UiRadiusLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsxs("g", {
    clipPath: "url(#omni-gravity-icon-ui-radius-lined-a)",
    children: [/*#__PURE__*/jsx("path", {
      d: "M19.17 15.53a8 8 0 110-7.06A3.92 3.92 0 0121 8h.17a10 10 0 100 8H21a3.92 3.92 0 01-1.83-.47z"
    }), /*#__PURE__*/jsx("path", {
      d: "M21 9a3 3 0 00-2.82 2h-4.46a2 2 0 100 2h4.46A3 3 0 1021 9zm0 4a1 1 0 110-2 1 1 0 010 2z"
    })]
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-radius-lined-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z"
      })
    })
  })]
}));

/**
UiRadiusLinedSmall icon

```jsx
import { UiRadiusLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRadiusLinedSmall />
```

 */
const UiRadiusLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12.32 10.48a5 5 0 110-5A3 3 0 0114 5h.33a7 7 0 100 5.94L14 11a3 3 0 01-1.68-.52z"
  }), /*#__PURE__*/jsx("path", {
    d: "M14 6a2 2 0 00-1.72 1H8a1 1 0 000 2h4.28A2 2 0 0014 10a2 2 0 100-4z"
  })]
}));

/**
UiReceiptFilled icon

```jsx
import { UiReceiptFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiReceiptFilled />
```

 */
const UiReceiptFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M18 1H6c-.6 0-1 .4-1 1v20c0 .4.2.7.6.9.3.2.7.1 1-.1l1.4-1 1.4 1c.4.3.8.3 1.2 0l1.4-1 1.4 1c.4.3.8.3 1.2 0l1.4-1 1.4 1c.2.1.4.2.6.2.2 0 .3 0 .4-.1.3-.2.6-.5.6-.9V2c0-.6-.4-1-1-1zm-6.8 3.6v-.4c0-.4.3-.8.8-.8s.8.3.8.8v.3c.6.3 1.1.6 1.2.7.3.2.4.7.1 1.1-.2.3-.7.4-1 .2-.1-.2-.5-.5-1.1-.5 0 0-.8 0-.8.5 0 .3.1.4.4.5l1.4.6c.9.3 1.4 1 1.4 1.9 0 1.2-.9 1.9-1.8 2v.3c0 .4-.3.8-.8.8s-.8-.3-.8-.8v-.4c-.6-.2-1.1-.4-1.1-.4-.4-.2-.5-.7-.3-1 .2-.4.7-.5 1-.3 0 0 .7.4 1.6.4.4-.1.8-.1.8-.6 0-.2 0-.4-.4-.5l-1.4-.6c-.9-.3-1.4-1-1.4-1.9 0-1 .6-1.6 1.4-1.9zM14.5 18h-5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5c.3 0 .5.2.5.5s-.2.5-.5.5zm1-2h-7c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h7c.3 0 .5.2.5.5s-.2.5-.5.5z"
  })
}));

/**
UiReceiptFilledSmall icon

```jsx
import { UiReceiptFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiReceiptFilledSmall />
```

 */
const UiReceiptFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-receipt-filled-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M13 0H3c-.6 0-1 .4-1 1v14c0 .4.2.7.6.9.3.2.7.1 1-.1l1.1-.8 1.1.8c.4.3.8.3 1.2 0l1-.8 1.1.8c.4.3.8.3 1.2 0l1-.8 1.1.8c.2.1.4.2.6.2.2 0 .3 0 .4-.1.3-.2.6-.5.6-.9V1c0-.6-.4-1-1-1zM8.8 10.5v.3c0 .4-.3.8-.8.8s-.8-.3-.8-.8v-.4c-.6-.2-1.1-.4-1.1-.4-.4-.2-.5-.7-.3-1 .2-.4.7-.5 1-.3 0 0 .7.4 1.6.4.2-.1.6-.1.6-.6 0-.2 0-.4-.4-.5l-1.4-.6C6 7 5.8 6.2 5.8 5.5c0-1 .7-1.6 1.5-1.9v-.4c0-.4.3-.8.8-.8s.8.3.8.8v.3c.5.3 1 .6 1.1.7.3.2.4.7.1 1-.2.3-.7.4-1 .2C9 5.3 8.6 5 8 5c0 0-.8 0-.8.5 0 .3.1.4.4.5l1.4.6c.9.3 1.4 1 1.4 1.9.1 1.2-.8 1.9-1.6 2z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-receipt-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiReceiptLined icon

```jsx
import { UiReceiptLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiReceiptLined />
```

 */
const UiReceiptLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11.6 9.6l-.4-.2c-1-.3-1.4-.9-1.4-1.9 0-1 .6-1.6 1.4-1.9v-.4c0-.4.3-.8.8-.8s.8.4.8.8v.4c.467.134.8.356 1 .49.1.066.167.11.2.11.3.2.3.7.1 1-.2.4-.7.4-1 .2-.1-.1-.5-.4-1.1-.4 0 0-.8 0-.8.5 0 .3.1.4.5.5l.8.3.8.2c.9.3 1.4 1 1.4 1.9 0 1.2-.9 1.9-1.8 2v.3c0 .5-.3.8-.8.8s-.8-.4-.8-.8v-.4a3.112 3.112 0 01-.904-.318.69.69 0 00-.196-.082c-.4-.2-.5-.6-.3-1s.6-.5 1-.3c.2.1.8.4 1.6.4.1 0 .5 0 .5-.5 0-.2 0-.4-.4-.5l-1-.4zM8.5 16h7c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-7c-.3 0-.5.2-.5.5s.2.5.5.5zm1 1h5c.3 0 .5.2.5.5s-.2.5-.5.5h-5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1h12c.6 0 1 .4 1 1v20c0 .4-.3.7-.6.9-.1.1-.2.1-.4.1s-.4-.1-.6-.2l-1.4-1-1.4 1c-.4.3-.8.3-1.2 0l-1.4-1-1.4 1c-.4.3-.8.3-1.2 0l-1.4-1-1.4 1c-.3.2-.7.3-1 .1-.4-.2-.6-.5-.6-.9V2c0-.6.4-1 1-1zm10.6 18.7l.4.3V3H7v17l.4-.3c.4-.3.8-.3 1.2 0l1.4 1 1.4-1c.2-.1.4-.2.6-.2.2 0 .4.1.6.2l1.4 1 1.4-1c.4-.3.8-.3 1.2 0z"
  })]
}));

/**
UiReceiptUkFilled icon

```jsx
import { UiReceiptUkFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiReceiptUkFilled />
```

 */
const UiReceiptUkFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1h12c.6 0 1 .4 1 1v20c0 .4-.3.7-.6.9-.1.1-.2.1-.4.1s-.4-.1-.6-.2l-1.4-1-1.4 1c-.4.3-.8.3-1.2 0l-1.4-1-1.4 1c-.4.3-.8.3-1.2 0l-1.4-1-1.4 1c-.3.2-.7.3-1 .1-.4-.2-.6-.5-.6-.9V2c0-.6.4-1 1-1zm3.5 17h5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-5c-.3 0-.5.2-.5.5s.2.5.5.5zm-1-2h7c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-7c-.3 0-.5.2-.5.5s.2.5.5.5zm2.3-7H10c-.4 0-.8-.3-.8-.8s.4-.8.8-.8h.8V6.2C10.8 5 11.8 4 13 4c.8 0 1.6.4 2 1.1.2.4 0 .9-.3 1-.3.2-.8.1-1-.3-.2-.3-.4-.4-.7-.4-.5 0-.8.4-.8.8v1.3h.8c.4 0 .8.2.8.7 0 .5-.4.8-.8.8h-.7v.1c0 .5-.2 1-.4 1.4H14c.4 0 .8.2.8.7 0 .5-.4.8-.8.8h-4c-.4 0-.7-.3-.7-.6-.1-.4.1-.7.5-.8 0 0 1-.5 1-1.5V9z"
  })
}));

/**
UiReceiptUkFilledSmall icon

```jsx
import { UiReceiptUkFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiReceiptUkFilledSmall />
```

 */
const UiReceiptUkFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-receipt-uk-filled-small-a)",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 0h10c.6 0 1 .4 1 1v14c0 .4-.3.7-.6.9-.1.1-.2.1-.4.1s-.4-.1-.6-.2l-1.1-.8-1 .8c-.4.3-.8.3-1.2 0L8 15l-1 .8c-.4.3-.8.3-1.2 0L4.7 15l-1.1.8c-.3.2-.7.3-1 .1-.4-.2-.6-.5-.6-.9V1c0-.6.4-1 1-1zm3.8 8H6c-.4 0-.8-.3-.8-.8s.4-.8.8-.8h.8V5.2C6.8 4 7.8 3 9 3c.8 0 1.6.4 2 1.1.2.4 0 .9-.3 1-.3.2-.8.1-1-.3-.2-.3-.4-.4-.7-.4-.5 0-.8.4-.8.8v1.3H9c.4 0 .8.2.8.7 0 .5-.4.8-.8.8h-.7v.1c0 .5-.2 1-.4 1.4H10c.4 0 .8.2.8.7 0 .5-.4.8-.8.8H6c-.4 0-.7-.3-.7-.6-.1-.4.1-.7.5-.8 0 0 1-.5 1-1.5V8z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-receipt-uk-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiReceiptUkLined icon

```jsx
import { UiReceiptUkLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiReceiptUkLined />
```

 */
const UiReceiptUkLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M10.8 10H10c-.4 0-.8-.3-.8-.8s.4-.8.8-.8h.8V7.2C10.8 6 11.8 5 13 5c.8 0 1.6.4 2 1.1.2.4 0 .9-.3 1-.3.2-.8.1-1-.3-.2-.3-.4-.4-.7-.4-.5 0-.8.4-.8.8v1.3h.8c.4 0 .8.2.8.7 0 .5-.4.8-.8.8h-.7v.1c0 .5-.2 1-.4 1.4H14c.4 0 .8.2.8.7 0 .5-.4.8-.8.8h-4c-.4 0-.7-.3-.7-.6-.1-.4.1-.7.5-.8 0 0 1-.5 1-1.5V10zm-2.3 6h7c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-7c-.3 0-.5.2-.5.5s.2.5.5.5zm1 1h5c.3 0 .5.2.5.5s-.2.5-.5.5h-5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1h12c.6 0 1 .4 1 1v20c0 .4-.3.7-.6.9-.1.1-.2.1-.4.1s-.4-.1-.6-.2l-1.4-1-1.4 1c-.4.3-.8.3-1.2 0l-1.4-1-1.4 1c-.4.3-.8.3-1.2 0l-1.4-1-1.4 1c-.3.2-.7.3-1 .1-.4-.2-.6-.5-.6-.9V2c0-.6.4-1 1-1zm10.6 18.7l.4.3V3H7v17l.4-.3c.4-.3.8-.3 1.2 0l1.4 1 1.4-1c.2-.1.4-.2.6-.2.2 0 .4.1.6.2l1.4 1 1.4-1c.4-.3.8-.3 1.2 0z"
  })]
}));

/**
UiRecentLined icon

```jsx
import { UiRecentLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRecentLined />
```

 */
const UiRecentLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M4.9 5.3C6.7 3.2 9.1 2 11.9 2c5.6 0 10 4.5 10 10s-4.5 10-10 10c-5.1 0-9.3-3.8-9.9-8.9 0-.5.4-1 .9-1.1.5-.1 1 .3 1.1.9.5 4 3.9 7.1 8 7.1 4.4 0 8-3.6 8-8s-3.6-8-8-8C9.2 4 7.3 5.4 6.2 7h1.7c.6 0 1 .4 1 1s-.4 1-1 1h-4c-.6 0-1-.4-1-1V4c0-.6.4-1 1-1s1 .4 1 1v1.3z"
  }), /*#__PURE__*/jsx("path", {
    d: "M10.9 7c0-.6.4-1 1-1s1 .4 1 1v4.6l1.7 1.7c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3l-2-2c-.2-.2-.3-.4-.3-.7V7z"
  })]
}));

/**
UiRecentLinedSmall icon

```jsx
import { UiRecentLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRecentLinedSmall />
```

 */
const UiRecentLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M2 2.7C3.5 1 5.7 0 8 0c4.4 0 8 3.6 8 8s-3.6 8-8 8C4 16 .6 13 .1 9.1 0 8.6.4 8.1.9 8c.6-.1 1.1.3 1.2.8C2.5 11.8 5 14 8 14c3.3 0 6-2.7 6-6s-2.7-6-6-6c-1.7 0-3.3.8-4.5 2H4c.6 0 1 .4 1 1s-.4 1-1 1H1c-.6 0-1-.4-1-1V2c0-.6.4-1 1-1s1 .4 1 1v.7z"
  }), /*#__PURE__*/jsx("path", {
    d: "M7 4c0-.6.4-1 1-1 .5 0 1 .4 1 1v3.6l1.2 1.2c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0L7.3 8.7C7.1 8.5 7 8.3 7 8V4z"
  })]
}));

/**
UiRecurringLined icon

```jsx
import { UiRecurringLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRecurringLined />
```

 */
const UiRecurringLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 5.034c0-.6.4-1 1-1s1 .4 1 1v4c0 .6-.4 1-1 1h-4c-.6 0-1-.4-1-1s.4-1 1-1h1.7c-.8-1-1.6-1.9-2.6-2.6-1.4-1-3-1.5-4.7-1.4-1.7.1-3.3.8-4.6 1.9-1.3 1.1-2.2 2.7-2.6 4.3-.1.6-.7.9-1.2.8-.5-.1-.9-.7-.7-1.2.4-2.1 1.6-4 3.2-5.4 1.6-1.4 3.7-2.2 5.8-2.4 2.1-.2 4.3.5 6 1.7 1.1.8 2 1.7 2.7 2.8v-1.5zm-.2 8.785c.1-.6.7-.9 1.2-.8.5.2.9.7.8 1.2-.4 2.1-1.6 4-3.2 5.4-1.6 1.4-3.7 2.3-5.8 2.4-2.2.2-4.4-.5-6.1-1.7-1.1-.8-2-1.7-2.7-2.8v1.5c0 .6-.4 1-1 1s-1-.4-1-1v-4c0-.6.4-1 1-1h4c.6 0 1 .4 1 1s-.4 1-1 1H5.3c.8 1 1.6 1.9 2.6 2.6 1.4 1 3 1.5 4.7 1.4 1.7-.1 3.3-.8 4.6-1.9 1.3-1.1 2.2-2.6 2.6-4.3z"
  })
}));

/**
UiRecurringLinedSmall icon

```jsx
import { UiRecurringLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRecurringLinedSmall />
```

 */
const UiRecurringLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-recurring-lined-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M15 3.1c-.6 0-1 .4-1 1v.6c-.2-.4-.4-.9-.8-1.2-.8-1-1.9-1.8-3.2-2.1C8.8.9 7.5.9 6.2 1.2 5 1.6 3.8 2.3 3 3.2c-.3.4-.3 1 0 1.3.3.5 1 .5 1.4.1.7-.6 1.5-1.1 2.4-1.3.9-.2 1.8-.2 2.7.1.9.3 1.7.7 2.3 1.4.4.4.7.8 1 1.3H12c-.6 0-1 .4-1 1s.4 1 1 1h3c.6 0 1-.4 1-1v-3c0-.6-.4-1-1-1zm-3.4 8.4c-.7.6-1.5 1.1-2.4 1.3-.9.2-1.8.2-2.7-.1-.9-.3-1.7-.7-2.3-1.4-.4-.4-.7-.8-1-1.3H4c.6 0 1-.4 1-1s-.4-1-1-1H1c-.6 0-1 .4-1 1v3c0 .6.4 1 1 1s1-.4 1-1v-.6c.2.4.4.9.8 1.2.8 1 1.9 1.8 3.2 2.1 1.2.4 2.6.4 3.9.1 1.3-.3 2.4-1 3.3-2 .3-.4.3-1 0-1.3-.5-.3-1.2-.3-1.6 0z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-recurring-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiRecycleLined icon

```jsx
import { UiRecycleLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRecycleLined />
```

 */
const UiRecycleLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M15.055 9.435l-.4-.1c-.5-.201-1.1.2-1.2.703-.2.502.2 1.105.7 1.206l2.7.804h.3c.4 0 .8-.302 1-.704l.8-2.713c.2-.502-.2-1.105-.7-1.205-.5-.201-1.1.2-1.2.703l-.1.402-3-5.526c-.4-.603-1-1.005-1.7-1.005s-1.7.301-2 .904l-2 3.617c-.3.503-.2 1.106.3 1.407.5.302 1.1.1 1.4-.402l2-3.617 3.1 5.526zm7 8.541l-2.2-4.019c-.3-.502-.9-.703-1.4-.402-.5.302-.7.905-.4 1.407l2.2 4.038h-5.9l.3-.32a.975.975 0 000-1.407.964.964 0 00-1.4 0l-2 2.01a.974.974 0 000 1.406l2 2.01c.2.2.5.301.7.301.2 0 .5-.1.7-.301a.975.975 0 000-1.407l-.3-.292h5.9c.7 0 1.4-.411 1.7-1.014.4-.603.4-1.306.1-2.01zm-14-3.717c-.5 0-.9-.302-1-.704l-.2-.402L3.655 19h4.3c.6 0 1 .383 1 .986s-.4 1.014-1 1.014h-4.3c-.7 0-1.3-.411-1.7-1.014-.3-.603-.3-1.407 0-2.01l3.2-5.827-.4.1c-.5.1-1-.2-1.2-.703a.892.892 0 01.7-1.206l2.7-.804c.2-.1.5 0 .7.1.3.101.4.302.5.604l.9 2.813c.1.502-.2 1.005-.7 1.206h-.3z"
  })
}));

/**
UiRecycleLinedSmall icon

```jsx
import { UiRecycleLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRecycleLinedSmall />
```

 */
const UiRecycleLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-recycle-lined-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M6 3.9c.5.3 1.1.1 1.4-.4l.6-1 1.7 2.8h-.4c-.5-.2-1 .1-1.2.7-.1.5.2 1.1.8 1.2l2.6.7h.2c.4 0 .9-.3 1-.8l.7-2.6c.1-.5-.2-1.1-.7-1.2-.5-.1-1.1.2-1.2.7l-.1.3L9.3.7C9 .3 8.5 0 8 0S7 .3 6.7.7l-1 1.8c-.3.5-.1 1.1.3 1.4zm8.3 5.8c-.3-.5-.9-.6-1.4-.4-.5.3-.6.9-.4 1.4l1.1 1.2H10l.2-.2c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-1.9 1.9c-.1.1-.2.2-.2.3-.1.2-.1.5 0 .8.05.05.075.1.1.15.025.05.05.1.1.15l1.9 1.9c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4L10 14h4.5c.5 0 1-.3 1.3-.8.3-.4.3-1 0-1.5l-1.5-2zM4.6 5.3c.6-.1 1.1.2 1.3.7l.8 2.7c.2.5-.2 1.1-.7 1.2h-.3c-.5 0-.9-.3-1-.7l-.1-.3L2.4 12h1.2c.6 0 1 .4 1 1s-.4 1-1 1H1.5c-.5 0-1-.3-1.3-.8-.3-.5-.3-1 0-1.5l2.6-3.9-.3.1c-.5.2-1-.1-1.2-.7-.1-.5.2-1.1.7-1.2l2.6-.7z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-recycle-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiRedoLined icon

```jsx
import { UiRedoLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRedoLined />
```

 */
const UiRedoLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M9.5 6h8.09L15.8 4.21a.996.996 0 111.41-1.41l3.5 3.5c.39.39.39 1.02 0 1.41l-3.5 3.5c-.2.2-.45.29-.71.29s-.51-.1-.71-.29a.996.996 0 010-1.41l1.8-1.8H9.5C7.02 8 5 10.02 5 12.5S7.02 17 9.5 17H16c.55 0 1 .45 1 1s-.45 1-1 1H9.5C5.92 19 3 16.08 3 12.5S5.92 6 9.5 6z"
  })
}));

/**
UiRedoLinedSmall icon

```jsx
import { UiRedoLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRedoLinedSmall />
```

 */
const UiRedoLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M5.5 4.75h6.09l-.79-.79a.996.996 0 111.41-1.41l2.5 2.5c.39.39.39 1.02 0 1.41l-2.5 2.5c-.2.2-.45.29-.71.29s-.51-.1-.71-.29a.996.996 0 010-1.41l.79-.79H5.5C4.12 6.75 3 7.87 3 9.25s1.12 2.5 2.5 2.5H11c.55 0 1 .45 1 1s-.45 1-1 1H5.5c-2.48 0-4.5-2.02-4.5-4.5s2.02-4.5 4.5-4.5z"
  })
}));

/**
UiRefreshLined icon

```jsx
import { UiRefreshLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRefreshLined />
```

 */
const UiRefreshLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M3 13c0 5 4 9 9 9s9-4 9-9c0-1.8-.5-3.6-1.6-5.1-.3-.4-.9-.6-1.4-.2-.4.3-.5.9-.2 1.3.8 1.2 1.2 2.6 1.2 4 0 3.9-3.1 7-7 7s-7-3.1-7-7c0-3.7 2.9-6.8 6.6-7l-1.3 1.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3l3-3c.4-.4.4-1 0-1.4l-3-3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4L11.6 4C6.8 4.2 3 8.2 3 13z"
  })
}));

/**
UiRefreshLinedSmall icon

```jsx
import { UiRefreshLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRefreshLinedSmall />
```

 */
const UiRefreshLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("g", {
    clipPath: "url(#omni-gravity-icon-ui-refresh-lined-small-a)",
    children: /*#__PURE__*/jsx("path", {
      d: "M14.14 5.52a.996.996 0 00-1.35-.42c-.49.26-.68.86-.42 1.35l.01.03c.49.94.73 2.13.56 3.19-.13 1.08-.67 2.09-1.43 2.86-1.53 1.56-4.13 1.92-6.01.77-.95-.53-1.69-1.42-2.11-2.41C3 9.88 2.9 8.73 3.2 7.68c.28-1.05.92-2.01 1.78-2.68.43-.33.91-.6 1.43-.77.41-.14.84-.23 1.27-.32l-.38.38a.996.996 0 000 1.41c.2.2.45.3.71.3.26 0 .51-.1.71-.29l2-2a.996.996 0 000-1.41l-2-2A.996.996 0 107.3 1.7l.33.33c-1.4-.05-2.79.53-3.88 1.38-1.21.93-2.1 2.26-2.5 3.74-.42 1.47-.3 3.08.27 4.5.59 1.41 1.62 2.64 2.96 3.4 1.32.78 2.9 1.1 4.42.9 1.53-.18 2.97-.9 4.06-1.98 1.07-1.09 1.81-2.52 2-4.05.2-1.52-.1-3.03-.82-4.4z"
    })
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-refresh-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiRefreshmentsLined icon

```jsx
import { UiRefreshmentsLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRefreshmentsLined />
```

 */
const UiRefreshmentsLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 5h-2.75l.23-1.21 2.81-.83c.53-.16.83-.71.68-1.24-.15-.53-.71-.83-1.24-.68l-2.81.83c-.72.21-1.26.81-1.4 1.55L15.21 5H8c-.72 0-1.07.65-.99 1.13l.84 6.3-2.38-2.38a.996.996 0 00-1.41 0C2.73 11.37 2 13.13 2 15s.73 3.63 2.05 4.95S7.13 22 9 22h9c.5 0 .92-.37.99-.87l2-15C21.08 5.62 20.67 5 20 5zM4 14.98c0-.99.29-1.93.83-2.74l2.14 2.14-2.97.6zm3.06 4.63c-.59-.25-1.13-.61-1.6-1.07-.46-.47-.82-1.01-1.07-1.6l3.33-.67-.66 3.34zM14.84 7l-.56 3H9.54l-.4-3h5.7zM9.02 20l.59-2.97 2.14 2.14c-.8.54-1.74.82-2.73.83zm8.1 0h-3.23c.02-.02.04-.03.06-.05a.996.996 0 000-1.41l-3.77-3.77L9.81 12h8.38l-1.07 8zm1.34-10h-2.15l.56-3h1.99l-.4 3z"
  })
}));

/**
UiRelayFilled icon

```jsx
import { UiRelayFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRelayFilled />
```

 */
const UiRelayFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 2C6.5 2 2 6.5 2 12c0 4.3 2.7 7.9 6.5 9.3.1.1.3.1.4.1 1 .3 2 .5 3.1.5 5.5 0 10-4.5 10-10S17.5 2 12 2zm-5 8h7c.6 0 1 .4 1 1s-.4 1-1 1H7c-.6 0-1-.4-1-1s.4-1 1-1zm1.2 9l.8-5.2c.1-.4.5-.8 1-.8h4c1.1 0 2-.9 2-2s-.9-2-2-2h-4c-.6 0-1-.4-1-1s.4-1 1-1h4c2.2 0 4 1.8 4 4 0 1.8-1.2 3.3-2.9 3.8l.7 4.2c-.6.3-1.2.6-1.9.7l-.7-4.7h-2.3l-.7 4.8c-.7-.2-1.4-.4-2-.8z"
  })
}));

/**
UiRelayLined icon

```jsx
import { UiRelayLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRelayLined />
```

 */
const UiRelayLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12 2C6.5 2 2 6.5 2 12c0 4.3 2.7 7.9 6.5 9.3.1.1.2.1.4.1 1 .3 2 .5 3.1.5 5.5 0 10-4.5 10-10C22 6.5 17.5 2 12 2zm-1.9 17.8l.8-4.8h2.3l.8 4.8c-.7.1-1.3.2-2 .2-.6 0-1.3-.1-1.9-.2zm5.7-.8l-.7-4.2c1.6-.5 2.9-2 2.9-3.8 0-2.2-1.8-4-4-4h-4c-.6 0-1 .4-1 1s.4 1 1 1h4c1.1 0 2 .9 2 2s-.9 2-2 2h-4c-.5 0-.9.4-1 .8L8.2 19C5.7 17.7 4 15 4 12c0-4.4 3.6-8 8-8s8 3.6 8 8c0 3-1.7 5.6-4.2 7z"
  }), /*#__PURE__*/jsx("path", {
    d: "M6 11c0 .6.4 1 1 1h7c.6 0 1-.4 1-1s-.4-1-1-1H7c-.6 0-1 .4-1 1z"
  })]
}));

/**
UiReminderFilled icon

```jsx
import { UiReminderFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiReminderFilled />
```

 */
const UiReminderFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M19.9 12.4L13 10.6V10h1c1.7 0 3-1.3 3-3s-1.3-3-3-3c-.4 0-.7.1-1 .2v-.7C13 2.1 11.9 1 10.5 1S8 2.1 8 3.5v.7c-.3-.1-.7-.2-1-.2-1.7 0-3 1.3-3 3s1.3 3 3 3h1v5.3l-1.1-.9c-1.1-1-2.7-1-3.9-.1l-.3.3c-.4.3-.7.8-.7 1.4 0 .6.1 1.1.5 1.5l4.7 5.2c.2.2.5.3.8.3h11c.4 0 .8-.3 1-.7l1.9-6.1c.4-1.6-.4-3.3-2-3.8zM14 6c.6 0 1 .4 1 1s-.4 1-1 1h-1V7c0-.6.4-1 1-1zM6 7c0-.6.4-1 1-1s1 .4 1 1v1H7c-.6 0-1-.4-1-1z"
  })
}));

/**
UiReminderFilledSmall icon

```jsx
import { UiReminderFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiReminderFilledSmall />
```

 */
const UiReminderFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12.55 8.3L8 7h1c1.1 0 2-.9 2-2s-.9-2-2-2c-.4 0-.7.1-1 .3V1.5C8 .7 7.3 0 6.5 0S5 .7 5 1.5v1.8c-.3-.2-.6-.3-1-.3-1.1 0-2 .9-2 2s.9 2 2 2h1v4.2l-.3-.2c-1-.8-2.5-.7-3.4.2-.4.4-.4 1 0 1.4l3 3c.2.3.4.4.7.4h7c.5 0 .9-.3 1-.7l.95-4.5c.2-1.1-.3-2.2-1.4-2.5zM9 4c.6 0 1 .4 1 1s-.4 1-1 1H8V5c0-.6.4-1 1-1zM4 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1v1H4z"
  })
}));

/**
UiReminderLined icon

```jsx
import { UiReminderLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiReminderLined />
```

 */
const UiReminderLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M19.94 12.444l-5.9-1.797v-.6h1c1.7 0 3-1.297 3-2.994 0-1.697-1.3-2.995-3-2.995-.4 0-.7.1-1 .2v-.1c0-1.497-1.1-2.795-2.5-3.094-.9-.1-1.8.1-2.5.698-.6.6-1 1.398-1 2.296v.2c-.3-.1-.7-.2-1-.2-1.7 0-3 1.298-3 2.995s1.3 2.995 3 2.995h1v4.692l-1.2-.799a3.011 3.011 0 00-3.5.2l-.5.4c-.5.398-.8.897-.8 1.496 0 .6.1 1.099.5 1.498l4.7 5.19c.4.4 1 .4 1.4.1.4-.399.4-.998.1-1.397l-4.7-5.29.5-.4c.3-.3.8-.3 1.2-.1l2.8 1.697c.3.2.7.2 1 0 .3-.1.5-.4.5-.798v-6.49h2v1.299c0 .399.3.798.7.998l6.6 2.096c.5.2.8.699.7 1.298l-2 5.99c-.2.499.1 1.098.7 1.297h.3c.4 0 .8-.3 1-.698l1.9-6.09c.4-1.597-.4-3.294-2-3.793zm-4.9-6.39c.6 0 1 .4 1 1 0 .598-.4.997-1 .997h-1v-.998c0-.599.4-.998 1-.998zm-5-1.996c0-.3.1-.599.4-.798.2-.2.5-.2.8-.2.4.1.8.599.8 1.098v3.893h-2V4.058zm-4 2.995c0-.599.4-.998 1-.998s1 .4 1 .998v.998h-1c-.6 0-1-.399-1-.998z"
  })
}));

/**
UiReportsFilled icon

```jsx
import { UiReportsFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiReportsFilled />
```

 */
const UiReportsFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 16.5c0 .3-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v4zm4 0c0 .3-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5v-9c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v9zm4 0c0 .3-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5v-6c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v6z"
  })
}));

/**
UiReportsFilledSmall icon

```jsx
import { UiReportsFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiReportsFilledSmall />
```

 */
const UiReportsFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14 1H2c-.6 0-1 .4-1 1v12c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zM6 11.5c0 .3-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5v-2c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v2zm3 0c0 .3-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5v-6c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v6zm3 0c0 .3-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v4z"
  })
}));

/**
UiReportsLined icon

```jsx
import { UiReportsLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiReportsLined />
```

 */
const UiReportsLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M7.5 12h1c.3 0 .5.2.5.5v4c0 .3-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5zm5-5h-1c-.3 0-.5.2-.5.5v9c0 .3.2.5.5.5h1c.3 0 .5-.2.5-.5v-9c0-.3-.2-.5-.5-.5zm3 3h1c.3 0 .5.2.5.5v6c0 .3-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5v-6c0-.3.2-.5.5-.5z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2zm0 16h14V5H5v14z"
  })]
}));

/**
UiReportsLinedSmall icon

```jsx
import { UiReportsLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiReportsLinedSmall />
```

 */
const UiReportsLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M5.5 12h-1c-.3 0-.5-.2-.5-.5v-2c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v2c0 .3-.2.5-.5.5zm2 0h1c.3 0 .5-.2.5-.5v-6c0-.3-.2-.5-.5-.5h-1c-.3 0-.5.2-.5.5v6c0 .3.2.5.5.5zm4 0h-1c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v4c0 .3-.2.5-.5.5z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1h12c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1H2c-.6 0-1-.4-1-1V2c0-.6.4-1 1-1zm1 12h10V3H3v10z"
  })]
}));

/**
UiRequestMoneyFilled icon

```jsx
import { UiRequestMoneyFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRequestMoneyFilled />
```

 */
const UiRequestMoneyFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11c0-5 4.5-9 10-9s10 4 10 9-4.5 9-10 9c-.9 0-1.9-.1-2.8-.4l-3.9 1.3c-.1.1-.2.1-.3.1-.2 0-.5-.1-.7-.3-.2-.2-.4-.6-.3-.9l.5-2.9C2.9 15.3 2 13.2 2 11zm9.7-1l.8.3.6.3c.9.3 1.4 1 1.6 1.8 0 1.2-.9 1.9-1.8 2v.3c0 .5-.3.8-.8.8s-.8-.4-.8-.8v-.4a3.112 3.112 0 01-.904-.318.69.69 0 00-.196-.082c-.4-.2-.5-.6-.3-1s.6-.5 1-.3c.2.1.8.4 1.6.4.1 0 .5 0 .5-.5 0-.2 0-.4-.4-.5l-1-.4-.4-.2c-.9-.3-1.4-.9-1.4-1.9 0-1 .6-1.6 1.4-1.9v-.4c0-.4.3-.8.8-.8s.8.4.8.8v.3c.467.134.8.356 1 .49.1.066.167.11.2.11.3.3.3.8.1 1.1-.2.4-.7.4-1 .2-.1-.1-.5-.4-1.1-.4 0 0-.8 0-.8.5 0 .3.1.4.5.5z"
  })
}));

/**
UiRequestMoneyFilledSmall icon

```jsx
import { UiRequestMoneyFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRequestMoneyFilledSmall />
```

 */
const UiRequestMoneyFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M8 1C3.6 1 0 3.9 0 7.5c0 1.4.5 2.7 1.5 3.8L1 13.8c-.1.3.1.7.3.9.2.2.5.3.7.3.1 0 .2 0 .3-.1l3.6-1.2c.7.2 1.4.3 2.1.3 4.4 0 8-2.9 8-6.5S12.4 1 8 1zm.8 9.5c0 .4-.3.8-.8.8s-.8-.4-.8-.8v-.2c-.6-.1-1-.4-1.1-.4-.4-.2-.5-.7-.3-1 .2-.4.7-.5 1-.3 0 0 .7.4 1.6.4.2 0 .6 0 .6-.5 0-.2 0-.4-.4-.5l-1.4-.6C6 7 5.8 6.2 5.8 5.5c0-1 .7-1.6 1.5-1.9v-.1c0-.4.3-.8.8-.8s.8.3.8.8v.1c.5.2 1 .5 1.1.6.3.2.4.7.1 1.1-.2.3-.7.4-1 .2C9 5.3 8.6 5 8 5c0 0-.8 0-.8.5 0 .3.1.4.4.5l1.4.6c.9.3 1.4 1 1.4 1.9.1 1.2-.8 1.9-1.6 2z"
  })
}));

/**
UiRequestMoneyLined icon

```jsx
import { UiRequestMoneyLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRequestMoneyLined />
```

 */
const UiRequestMoneyLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12.5 10.3l.6.3c.9.3 1.4 1 1.6 1.8 0 1.2-.9 1.9-1.8 2v.3c0 .5-.3.8-.8.8s-.8-.4-.8-.8v-.4a3.112 3.112 0 01-.904-.318.69.69 0 00-.196-.082c-.4-.2-.5-.6-.3-1s.6-.5 1-.3c.2.1.8.4 1.6.4.1 0 .5 0 .5-.5 0-.2 0-.4-.4-.5l-1-.4-.4-.2c-.9-.3-1.4-.9-1.4-1.9 0-1 .6-1.6 1.4-1.9v-.4c0-.4.3-.8.8-.8s.8.4.8.8v.3c.467.134.8.356 1 .49.1.066.167.11.2.11.3.3.3.8.1 1.1-.2.4-.7.4-1 .2-.1-.1-.5-.4-1.1-.4 0 0-.8 0-.8.5 0 .3.1.4.5.5l.8.3z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11c0-5 4.5-9 10-9s10 4 10 9-4.5 9-10 9c-.9 0-1.9-.1-2.8-.4l-3.9 1.3c-.1.1-.2.1-.3.1-.2 0-.5-.1-.7-.3-.2-.2-.4-.6-.3-.9l.5-2.9C2.9 15.3 2 13.2 2 11zm7.5 6.6c.8.3 1.6.4 2.5.4 4.4 0 8-3.1 8-7s-3.6-7-8-7-8 3.1-8 7c0 1.8.8 3.5 2.3 4.8.2.2.4.6.3.9l-.3 1.8 2.6-.9c.2-.1.4-.1.6 0z"
  })]
}));

/**
UiRequestMoneyUkFilled icon

```jsx
import { UiRequestMoneyUkFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRequestMoneyUkFilled />
```

 */
const UiRequestMoneyUkFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.49 2 2 6.04 2 11c0 2.21.88 4.3 2.5 5.95l-.48 2.89c-.06.35.07.7.34.92.17.16.41.24.64.24.11 0 .21-.02.32-.05l3.91-1.3c.9.23 1.84.35 2.77.35 5.51 0 10-4.04 10-9s-4.49-9-10-9zm-2 10h.8v.1c0 1-1 1.5-1 1.5-.4.1-.6.4-.5.8 0 .3.3.6.7.6h4c.4 0 .8-.3.8-.8s-.4-.7-.8-.7h-2.1c.2-.4.4-.9.4-1.4V12h.7c.4 0 .8-.3.8-.8s-.4-.7-.8-.7h-.8V9.2c0-.4.3-.8.8-.8.3 0 .5.1.7.4.2.4.7.5 1 .3.3-.1.5-.6.3-1-.4-.7-1.2-1.1-2-1.1-1.2 0-2.2 1-2.2 2.2v1.2H10c-.4 0-.8.3-.8.8s.4.8.8.8z"
  })
}));

/**
UiRequestMoneyUkFilledSmall icon

```jsx
import { UiRequestMoneyUkFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRequestMoneyUkFilledSmall />
```

 */
const UiRequestMoneyUkFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1C3.59 1 0 3.92 0 7.5c0 1.38.53 2.71 1.52 3.82l-.5 2.49a1.004 1.004 0 00.98 1.2c.11 0 .21-.02.32-.05l3.55-1.18c.7.16 1.41.24 2.13.24 4.41 0 8-2.92 8-6.5S12.41 1 8 1zm1.7 3.9c.2.4.6.5 1 .3.3-.3.5-.7.3-1.1C10.6 3.4 9.8 3 9 3 7.8 3 6.8 4 6.8 5.2v1.3H6c-.4 0-.8.4-.8.8s.4.7.8.7h.7v.1c0 1-1 1.5-1 1.5-.3.1-.5.4-.4.8 0 .3.3.6.7.6h4c.4 0 .8-.2.8-.7 0-.5-.4-.8-.8-.8H7.8c.3-.4.4-.8.4-1.4V8H9c.4 0 .8-.1.8-.6s-.4-.8-.8-.8h-.8V5.3c0-.5.4-.8.8-.8.3 0 .5.1.7.4z"
  })
}));

/**
UiRequestMoneyUkLined icon

```jsx
import { UiRequestMoneyUkLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRequestMoneyUkLined />
```

 */
const UiRequestMoneyUkLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M10.8 12H10c-.4 0-.8-.3-.8-.8s.4-.8.8-.8h.8V9.2C10.8 8 11.8 7 13 7c.8 0 1.6.4 2 1.1.2.4 0 .9-.3 1-.3.2-.8.1-1-.3-.2-.3-.4-.4-.7-.4-.5 0-.8.4-.8.8v1.3h.8c.4 0 .8.2.8.7 0 .5-.4.8-.8.8h-.7v.1c0 .5-.2 1-.4 1.4H14c.4 0 .8.2.8.7 0 .5-.4.8-.8.8h-4c-.4 0-.7-.3-.7-.6-.1-.4.1-.7.5-.8 0 0 1-.5 1-1.5V12z"
  }), /*#__PURE__*/jsx("path", {
    d: "M12 2C6.49 2 2 6.04 2 11c0 2.21.88 4.3 2.5 5.95l-.48 2.89c-.06.35.07.7.34.92.17.16.41.24.64.24.11 0 .21-.02.32-.05l3.91-1.3c.9.23 1.84.35 2.77.35 5.51 0 10-4.04 10-9s-4.49-9-10-9zm0 16c-.85 0-1.7-.12-2.52-.36-.19-.06-.4-.05-.6.01l-2.62.88.29-1.77a.98.98 0 00-.31-.9C4.8 14.54 4 12.81 4 11c0-3.86 3.59-7 8-7s8 3.14 8 7-3.59 7-8 7z"
  })]
}));

/**
UiRewardsFilled icon

```jsx
import { UiRewardsFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRewardsFilled />
```

 */
const UiRewardsFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 6c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1h-7V8h-2v2H4c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h1.2c-.1-.3-.2-.6-.2-1 0-1.7 1.3-3 3-3 2 0 3.2 1.3 4 2.5.8-1.2 2-2.5 4-2.5 1.7 0 3 1.3 3 3 0 .4-.1.7-.2 1H20zm-3-1c0-.6-.4-1-1-1-1.3 0-2.1 1.1-2.5 2H16c.6 0 1-.4 1-1zM8 4c-.6 0-1 .4-1 1s.4 1 1 1h2.5c-.4-.9-1.2-2-2.5-2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M13 12h7v8c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1v-8h7v7h2v-7z"
  })]
}));

/**
UiRewardsFilledSmall icon

```jsx
import { UiRewardsFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRewardsFilledSmall />
```

 */
const UiRewardsFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8 4h.2c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1H9V6H7v2H2c-.6 0-1-.4-1-1V5c0-.6.4-1 1-1h.2c-.1-.3-.2-.6-.2-1 0-1.7 1.3-3 3-3 1.4 0 2.4.7 3 1.6C8.6.7 9.6 0 11 0c1.7 0 3 1.3 3 3 0 .4-.1.7-.2 1zM12 3c0-.6-.4-1-1-1-1.2 0-1.7 1.1-1.9 2H11c.6 0 1-.4 1-1zM5 2c-.6 0-1 .4-1 1s.4 1 1 1h1.9c-.2-.9-.7-2-1.9-2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M9 9h5v5c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V9h5v4h2V9z"
  })]
}));

/**
UiRewardsLined icon

```jsx
import { UiRewardsLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRewardsLined />
```

 */
const UiRewardsLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 6h-1.2c.1-.3.2-.6.2-1 0-1.7-1.3-3-3-3-2 0-3.2 1.3-4 2.5C11.2 3.3 10 2 8 2 6.3 2 5 3.3 5 5c0 .4.1.7.2 1H4c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1v8c0 .6.4 1 1 1h14c.6 0 1-.4 1-1v-8c.6 0 1-.4 1-1V7c0-.6-.4-1-1-1zm-1 4h-6V8h6v2zm-3-6c.6 0 1 .4 1 1s-.4 1-1 1h-2.5c.4-.9 1.2-2 2.5-2zM7 5c0-.6.4-1 1-1 1.3 0 2.1 1.1 2.5 2H8c-.6 0-1-.4-1-1zM5 8h6v2H5V8zm1 4h5v7H6v-7zm12 7h-5v-7h5v7z"
  })
}));

/**
UiRewardsLinedSmall icon

```jsx
import { UiRewardsLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRewardsLinedSmall />
```

 */
const UiRewardsLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14 4h-.2c.1-.3.2-.6.2-1 0-1.7-1.3-3-3-3-1.4 0-2.4.7-3 1.6C7.4.7 6.4 0 5 0 3.3 0 2 1.3 2 3c0 .4.1.7.2 1H2c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1v4c0 .6.4 1 1 1h10c.6 0 1-.4 1-1v-4c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1zM3 6h4v2H3V6zm6 0h4v2H9V6zm2-4c.6 0 1 .4 1 1s-.4 1-1 1H9.1c.2-.9.7-2 1.9-2zM4 3c0-.6.4-1 1-1 1.2 0 1.7 1.1 1.9 2H5c-.6 0-1-.4-1-1zm0 7h3v3H4v-3zm8 3H9v-3h3v3z"
  })
}));

/**
UiRobotFilled icon

```jsx
import { UiRobotFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRobotFilled />
```

 */
const UiRobotFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22 11h-1V8c0-.6-.4-1-1-1h-7V4.7c.6-.3 1-1 1-1.7 0-1.1-.9-2-2-2s-2 .9-2 2c0 .7.4 1.4 1 1.7V7H4c-.6 0-1 .4-1 1v3H2c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h1v3c0 .6.4 1 1 1h16c.6 0 1-.4 1-1v-3h1c.6 0 1-.4 1-1v-4c0-.6-.4-1-1-1zm-6.6 4c.3 0 .6.3.5.6-.3.9-1.1 2.4-3.9 2.4s-3.6-1.5-3.9-2.4c-.1-.3.2-.6.5-.6h6.8zM14 11.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5zM8.5 13c-.8 0-1.5-.7-1.5-1.5S7.7 10 8.5 10s1.5.7 1.5 1.5S9.3 13 8.5 13z"
  })
}));

/**
UiRobotFilledSmall icon

```jsx
import { UiRobotFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRobotFilledSmall />
```

 */
const UiRobotFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M15 8V6c0-.6-.4-1-1-1H9V3.7c.6-.3 1-1 1-1.7 0-1.1-.9-2-2-2S6 .9 6 2c0 .7.4 1.4 1 1.7V5H2c-.6 0-1 .4-1 1v2c-.6 0-1 .4-1 1v3c0 .6.4 1 1 1v2c0 .6.4 1 1 1h12c.6 0 1-.4 1-1v-2c.6 0 1-.4 1-1V9c0-.6-.4-1-1-1zm-8 .5c0 .8-.7 1.5-1.5 1.5S4 9.3 4 8.5 4.7 7 5.5 7 7 7.7 7 8.5zm-2 3.8c0-.2.1-.3.3-.3h5.5c.1 0 .2.1.2.2 0 0 0 1.8-3 1.8s-3-1.7-3-1.7zm7-3.8c0 .8-.7 1.5-1.5 1.5S9 9.3 9 8.5 9.7 7 10.5 7s1.5.7 1.5 1.5z"
  })
}));

/**
UiRobotLined icon

```jsx
import { UiRobotLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRobotLined />
```

 */
const UiRobotLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M10 12c0 .8-.7 1.5-1.5 1.5S7 12.8 7 12s.7-1.5 1.5-1.5 1.5.7 1.5 1.5zm5.5 1.5c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5-1.5.7-1.5 1.5.7 1.5 1.5 1.5zM8.6 15h6.8c.3 0 .6.3.5.6-.3.9-1.1 2.4-3.9 2.4s-3.6-1.5-3.9-2.4c-.1-.3.2-.6.5-.6z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 11h1c.6 0 1 .4 1 1v4c0 .6-.4 1-1 1h-1v3c0 .6-.4 1-1 1H4c-.6 0-1-.4-1-1v-3H2c-.6 0-1-.4-1-1v-4c0-.6.4-1 1-1h1V8c0-.6.4-1 1-1h7V4.7c-.6-.3-1-1-1-1.7 0-1.1.9-2 2-2s2 .9 2 2c0 .7-.4 1.4-1 1.7V7h7c.6 0 1 .4 1 1v3zm-2-2H5v10h14V9z"
  })]
}));

/**
UiRotateLeftLined icon

```jsx
import { UiRotateLeftLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRotateLeftLined />
```

 */
const UiRotateLeftLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 4l1.2-1.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-3 3c-.4.4-.4 1 0 1.4l3 3c.2.2.4.3.7.3.3 0 .5-.1.7-.3.4-.4.4-1 0-1.4L11.9 6h.1c3.9 0 7 3.1 7 7s-3.1 7-7 7c-.6 0-1 .4-1 1s.4 1 1 1c5 0 9-4 9-9s-4-9-9-9zM9.1 19.4c-.7-.3-1.4-.8-2-1.4-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4.8.7 1.6 1.3 2.6 1.8.1.1.3.1.4.1.4 0 .7-.2.9-.6.2-.5 0-1.1-.5-1.3zM5 13c0 .9.2 1.7.5 2.5.2.5-.1 1.1-.6 1.2-.2.1-.3.1-.4.1-.4 0-.7-.2-.9-.6-.4-1-.6-2.1-.6-3.2 0-.6.4-1 1-1s1 .4 1 1z"
  })
}));

/**
UiRotateLeftLinedSmall icon

```jsx
import { UiRotateLeftLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRotateLeftLinedSmall />
```

 */
const UiRotateLeftLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M11.61 12.348a4.948 4.948 0 01-3.628 1.65.99.99 0 00-.987 1.01c0 .541.439.981.977.991h.01a6.92 6.92 0 005.163-2.24 7.09 7.09 0 001.834-5.353 6.964 6.964 0 00-2.711-4.952 6.892 6.892 0 00-2.582-1.25 5.126 5.126 0 00-1.355-.15l.349-.35a.999.999 0 000-1.411.99.99 0 00-1.406 0l-1.993 2a.999.999 0 000 1.411l1.993 2c.2.191.449.291.708.291.26 0 .508-.1.708-.3a.999.999 0 000-1.41l-.29-.28c.27.04.539.08.798.15a5.05 5.05 0 011.824.91 4.929 4.929 0 011.874 3.521 4.98 4.98 0 01-1.286 3.762zM2.001 7.996c.549 0 .997.45.997 1 0 .41.05.82.15 1.221a.995.995 0 01-.967 1.24.99.99 0 01-.967-.76c-.14-.55-.21-1.13-.21-1.7 0-.55.45-1.001.997-1.001zm2.512 4.592c.28.27.578.5.907.7.469.28.628.9.34 1.37-.19.31-.52.49-.858.49-.17 0-.349-.05-.508-.14-.459-.28-.888-.6-1.266-.98a.99.99 0 01-.02-1.41.99.99 0 011.405-.03z"
  })
}));

/**
UiRotateRightLined icon

```jsx
import { UiRotateRightLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRotateRightLined />
```

 */
const UiRotateRightLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 4l-1.2-1.3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l3 3c.4.4.4 1 0 1.4l-3 3c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L12.1 6H12c-3.9 0-7 3.1-7 7s3.1 7 7 7c.6 0 1 .4 1 1s-.4 1-1 1c-5 0-9-4-9-9s4-9 9-9zm2.9 15.4c.7-.3 1.4-.8 2-1.4.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4-.8.7-1.6 1.3-2.6 1.8-.1.1-.3.1-.4.1-.4 0-.7-.2-.9-.6-.2-.5 0-1.1.5-1.3zM19 13c0 .9-.2 1.7-.5 2.5-.2.5.1 1.1.6 1.2.2.1.3.1.4.1.4 0 .7-.2.9-.6.4-1 .6-2.1.6-3.2 0-.6-.4-1-1-1s-1 .4-1 1z"
  })
}));

/**
UiRotateRightLinedSmall icon

```jsx
import { UiRotateRightLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiRotateRightLinedSmall />
```

 */
const UiRotateRightLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M4.399 12.348a4.948 4.948 0 003.628 1.65.99.99 0 01.987 1.01.996.996 0 01-.977.991h-.01a6.92 6.92 0 01-5.163-2.24A7.09 7.09 0 011.03 8.405a6.964 6.964 0 012.71-4.951 6.893 6.893 0 012.582-1.25c.438-.11.897-.16 1.355-.15l-.349-.35a.999.999 0 010-1.411.99.99 0 011.406 0l1.994 2a.999.999 0 010 1.411l-1.994 2c-.2.191-.449.291-.708.291a.986.986 0 01-.707-.3.999.999 0 010-1.41l.289-.28c-.27.04-.539.08-.798.15a5.05 5.05 0 00-1.824.91 4.928 4.928 0 00-1.874 3.521A4.98 4.98 0 004.4 12.348zm9.609-4.352c-.548 0-.997.45-.997 1 0 .41-.05.82-.15 1.221a.995.995 0 00.967 1.24.99.99 0 00.967-.76c.14-.55.21-1.13.21-1.7 0-.55-.449-1.001-.997-1.001zm-2.512 4.592c-.28.27-.578.5-.907.7a.997.997 0 00-.339 1.37c.19.31.518.49.857.49.17 0 .35-.05.509-.14.458-.28.887-.6 1.266-.98a.99.99 0 00.02-1.41.99.99 0 00-1.406-.03z"
  })
}));

/**
UiSavingsFilled icon

```jsx
import { UiSavingsFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSavingsFilled />
```

 */
const UiSavingsFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M15.5 5.5c0 1-.3 1.8-1 2.5h-5c-.6-.7-1-1.5-1-2.5C8.5 3.6 10 2 12 2s3.6 1.6 3.5 3.5z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9 12h.6c.6 0 1 .4 1 1s-.4 1-1 1h-.6c-.643 3.769-4.414 7.03-5.174 7.688-.066.058-.11.096-.126.112-.2.1-.4.2-.6.2h-2c-.6 0-1-.4-1-1v-1h-1.6l-1.7 1.7c-.2.2-.4.3-.7.3H7c-.6 0-1-.4-1-1v-1.1c-3-.4-5-2.7-5-5.9v-1c0-.6.4-1 1-1h1.4l.8-1.7-2-2.7c-.2-.3-.3-.8-.1-1.1.2-.3.5-.5.9-.5h4c.1.7.3 1.4.7 2h-.3c-.4 0-.8.4-.8.8s.4.7.8.7h9.2c.4 0 .8-.2.8-.7 0-.5-.4-.8-.8-.8h-.2c.3-.6.5-1.2.6-1.8 2.9.6 4.6 2.6 4.9 5.8zM8 12c0-.6-.4-1-1-1s-1 .4-1 1 .4 1 1 1 1-.4 1-1z"
  })]
}));

/**
UiSavingsFilledSmall icon

```jsx
import { UiSavingsFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSavingsFilledSmall />
```

 */
const UiSavingsFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsxs("g", {
    clipPath: "url(#omni-gravity-icon-ui-savings-filled-small-a)",
    children: [/*#__PURE__*/jsx("path", {
      d: "M8 1c1.1 0 2 .9 2 2 0 .4-.1.7-.3 1H6.3c-.2-.3-.3-.6-.3-1 0-1.1.9-2 2-2z"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.3 4c.1-.3.2-.7.2-1 2.2.3 4.5 2.5 4.5 6 0 3.23-2.81 5.353-3.323 5.74-.043.032-.07.052-.077.06-.2.1-.4.2-.6.2h-1c-.6 0-1-.4-1-1v-1H7.6l-1.9 1.7c-.2.2-.5.3-.7.3H4c-.6 0-1-.4-1-1v-1.1c-2-.6-3-2.7-3-3.9V8c0-.6.4-1 1-1h1v-.6L.3 4.7C0 4.4-.1 4 .1 3.6.2 3.2.6 3 1 3h3.5c0 .4.1.7.2 1-.4.1-.7.4-.7.8s.3.7.7.7h6.5c.5 0 .8-.4.8-.8s-.3-.7-.7-.7zM6 8c0-.6-.4-1-1-1s-1 .4-1 1 .4 1 1 1 1-.4 1-1z"
    })]
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-savings-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiSavingsLined icon

```jsx
import { UiSavingsLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSavingsLined />
```

 */
const UiSavingsLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9 12a1 1 0 11-2 0 1 1 0 012 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9 12h.6c.6 0 1 .4 1 1s-.4 1-1 1h-.6c-.643 3.769-4.414 7.03-5.174 7.688-.066.058-.11.096-.126.112-.2.1-.4.2-.6.2h-2c-.6 0-1-.4-1-1v-1h-1.6l-1.7 1.7c-.2.2-.4.3-.7.3H7c-.6 0-1-.4-1-1v-1.1c-3-.4-5-2.7-5-5.9v-1c0-.6.4-1 1-1h1.4l.8-1.7-2-2.7c-.2-.3-.3-.8-.1-1.1.2-.3.5-.5.9-.5h4c0-2.8 2.2-5 5-5s5 2.2 5 5v.2c2.9.6 4.6 2.6 4.9 5.8zM12 3c-1.7 0-3 1.3-3 3 0 .7.3 1.4.8 2h4.4c.5-.6.8-1.3.8-2 0-1.7-1.3-3-3-3zm3 16v1h.6c1-.8 4.4-4 4.4-6.9 0-2.9-1.1-4.5-3.5-4.9-.3.6-.7 1.1-1.2 1.6-.2.1-.5.2-.7.2H9.4c-.3 0-.5-.1-.6-.2-.6-.5-1-1.1-1.3-1.8H5l1.2 1.6c.2.3.3.7.1 1l-1.4 2.8c-.2.4-.5.6-.9.6H3c0 2.4 1.6 4 4 4 .6 0 1 .4 1 1v1h.6l1.7-1.7c.2-.2.4-.3.7-.3h3c.6 0 1 .4 1 1z"
  })]
}));

/**
UiSavingsLinedSmall icon

```jsx
import { UiSavingsLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSavingsLinedSmall />
```

 */
const UiSavingsLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsxs("g", {
    clipPath: "url(#omni-gravity-icon-ui-savings-lined-small-a)",
    children: [/*#__PURE__*/jsx("path", {
      d: "M7 8a1 1 0 11-2 0 1 1 0 012 0z"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.5 0c1.8 0 3.3 1.4 3.5 3.1 2 .5 4 2.7 4 5.9 0 3.23-2.81 5.353-3.323 5.74-.043.032-.07.052-.077.06-.2.1-.4.2-.6.2h-1c-.6 0-1-.4-1-1v-1H8.6l-1.9 1.7c-.2.2-.5.3-.7.3H4c-.6 0-1-.4-1-1v-1.1c-2-.6-3-2.7-3-3.9V8c0-.6.4-1 1-1h1v-.6L.3 4.7C0 4.4-.1 4 .1 3.6.2 3.2.6 3 1 3h4.1c.2-1.7 1.6-3 3.4-3zM10 3.5C10 2.7 9.3 2 8.5 2S7 2.7 7 3.5c0 .2 0 .4.1.5h2.8c.1-.1.1-.3.1-.5zm2 8.5v.7c.8-.6 2-2 2-3.7 0-2.1-1.2-3.5-2.4-3.9-.05.1-.1.175-.15.25-.05.075-.1.15-.15.25-.2.3-.5.4-.8.4h-4c-.3 0-.6-.1-.8-.4-.2-.2-.3-.4-.4-.6H3.4l.3.3c.2.2.3.4.3.7v2c0 .6-.4 1-1 1H2c0 .5.6 2 2 2 .6 0 1 .4 1 1v1h.6l1.9-1.7c.2-.2.5-.3.7-.3H11c.6 0 1 .4 1 1z"
    })]
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-savings-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiScanDocumentFilled icon

```jsx
import { UiScanDocumentFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiScanDocumentFilled />
```

 */
const UiScanDocumentFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M3 7c.55 0 1-.45 1-1V4h2c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm3 2l4-4v4H6z"
  }), /*#__PURE__*/jsx("path", {
    d: "M18 6v12c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-7h5c.55 0 1-.45 1-1V5h5c.55 0 1 .45 1 1zm0-4h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1s-1-.45-1-1V4h-2c-.55 0-1-.45-1-1s.45-1 1-1zm3 15c-.55 0-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zM4 20h2c.55 0 1 .45 1 1s-.45 1-1 1H3c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1s1 .45 1 1v2z"
  })]
}));

/**
UiScanDocumentLined icon

```jsx
import { UiScanDocumentLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiScanDocumentLined />
```

 */
const UiScanDocumentLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M3 7c.55 0 1-.45 1-1V4h2c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 18V6c0-.55-.45-1-1-1h-6.59c-.26 0-.52.11-.7.29L6.29 8.71c-.18.18-.29.44-.29.7V18c0 .55.45 1 1 1h10c.55 0 1-.45 1-1zm-2-1H8v-7h2c.55 0 1-.45 1-1V7h5v10z"
  }), /*#__PURE__*/jsx("path", {
    d: "M18 2h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1s-1-.45-1-1V4h-2c-.55 0-1-.45-1-1s.45-1 1-1zm3 15c-.55 0-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zM4 20h2c.55 0 1 .45 1 1s-.45 1-1 1H3c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1s1 .45 1 1v2z"
  })]
}));

/**
UiScanDocumentLinedSmall icon

```jsx
import { UiScanDocumentLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiScanDocumentLinedSmall />
```

 */
const UiScanDocumentLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M2 6c.55 0 1-.45 1-1V3h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm9-5h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1s-1-.45-1-1V3h-2c-.55 0-1-.45-1-1s.45-1 1-1zm3 9c-.55 0-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zM3 13h2c.55 0 1 .45 1 1s-.45 1-1 1H2c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1s1 .45 1 1v2z"
  })
}));

/**
UiSearchLined icon

```jsx
import { UiSearchLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSearchLined />
```

 */
const UiSearchLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20.4 17.6l-3.5-3.5c.7-1.2 1.1-2.6 1.1-4.1 0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8c1.5 0 2.9-.4 4.1-1.1l3.5 3.5c.4.4.9.6 1.4.6.5 0 1-.2 1.4-.6.8-.8.8-2 0-2.8zM10 16c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6z"
  })
}));

/**
UiSearchLinedSmall icon

```jsx
import { UiSearchLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSearchLinedSmall />
```

 */
const UiSearchLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14.56 12.44l-2.4-2.4c.53-.89.84-1.93.84-3.04 0-3.31-2.69-6-6-6S1 3.69 1 7s2.69 6 6 6c1.11 0 2.15-.31 3.04-.84l2.4 2.4c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.53 0-2.12zM7 3c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4z"
  })
}));

/**
UiSendFilled icon

```jsx
import { UiSendFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSendFilled />
```

 */
const UiSendFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9 3.21l15.79 7.45c.76.36.76 1.45 0 1.81L4.9 19.93c-1.42.71-3.06-.43-2.88-2.01l.42-3.76c.1-.93.84-1.66 1.77-1.77l7.41-.82-7.42-.82c-.93-.1-1.66-.84-1.77-1.77l-.42-3.76C1.84 3.65 3.48 2.51 4.9 3.21z"
  })
}));

/**
UiSendFilledSmall icon

```jsx
import { UiSendFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSendFilledSmall />
```

 */
const UiSendFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14.45 7.11l-12-6c-.31-.16-.68-.14-.98.04-.29.18-.47.5-.47.85v4c0 .47.33.87.78.98L6.39 8 1.78 9.02c-.45.11-.78.51-.78.98v4a.999.999 0 001 1c.15 0 .31-.04.45-.11l12-6c.34-.17.55-.51.55-.89s-.21-.73-.55-.89z"
  })
}));

/**
UiSendLined icon

```jsx
import { UiSendLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSendLined />
```

 */
const UiSendLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M4 21.55c-.42 0-.83-.13-1.18-.39-.59-.44-.9-1.16-.79-1.89l.74-5.16c.06-.4.35-.73.75-.83l4.12-1.03-4.13-1.03a.98.98 0 01-.75-.83l-.73-5.11c-.1-.74.21-1.47.81-1.91.6-.43 1.39-.5 2.05-.17l15.37 7.24c.71.33 1.15 1.03 1.15 1.81a2 2 0 01-1.14 1.81l-15.41 7.3c-.28.13-.57.19-.86.19zm.64-6.49L4 19.55l15.41-7.3L4.03 5.01c-.01 0-.02-.01-.02-.01H4l.64 4.45 7.35 1.84c.45.11.76.51.76.97 0 .46-.31.86-.76.97l-7.35 1.83z"
  })
}));

/**
UiSendLinedSmall icon

```jsx
import { UiSendLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSendLinedSmall />
```

 */
const UiSendLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M2 15a.999.999 0 01-1-1V9c0-.43.28-.81.68-.95L1.84 8l-.16-.05C1.28 7.81 1 7.43 1 7V2c0-.35.18-.67.47-.85.29-.18.66-.2.97-.04l12 6c.35.16.56.51.56.89s-.21.73-.55.89l-12 6c-.14.07-.3.11-.45.11zm1-5.28v2.66L11.76 8 3 3.62v2.66l2.32.77c.4.14.68.52.68.95 0 .43-.28.81-.68.95L3 9.72z"
  })
}));

/**
UiSettingsFilled icon

```jsx
import { UiSettingsFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSettingsFilled />
```

 */
const UiSettingsFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20.365 13.164c.1-.402.1-.803.1-1.204 0-.402 0-.803-.1-1.205l1.597-1.806c.3-.302.399-.803.1-1.205l-1.497-2.61c-.2-.4-.699-.602-1.098-.501l-2.395.602c-.699-.502-1.397-.903-2.196-1.205l-.698-2.308c-.1-.401-.5-.703-.998-.703h-2.994c-.2-.1-.599.201-.698.603L8.789 3.93c-.798.301-1.597.803-2.195 1.305l-2.396-.602c-.399-.1-.798.1-1.097.502l-1.497 2.61c-.2.4-.1.902.2 1.204L3.5 10.755c-.1.402-.1.803-.1 1.204 0 .402 0 .803.1 1.205l-1.697 1.807c-.299.3-.399.803-.1 1.204l1.498 2.61c.2.3.498.501.898.501h.2l2.394-.602c.6.502 1.397.903 2.196 1.205l.599 2.408c.1.402.498.703.998.703h2.993c.4 0 .799-.301.998-.703l.699-2.308c.798-.301 1.497-.703 2.195-1.204l2.395.602h.2c.399 0 .698-.201.898-.502l1.497-2.61c.2-.401.2-.903-.1-1.204l-1.896-1.907zM12 16a4.01 4.01 0 01-4-4c0-2.208 1.805-4 4-4 2.195 0 4 1.792 4 4s-1.805 4-4 4z"
  })
}));

/**
UiSettingsFilledSmall icon

```jsx
import { UiSettingsFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSettingsFilledSmall />
```

 */
const UiSettingsFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8c0 .3 0 .6-.1.9l1.4.9c.3.3.4.9.2 1.3l-1 1.7c-.2.3-.6.5-.9.5a.655.655 0 01-.268-.063c-.049-.02-.09-.037-.132-.037l-1.5-.6c-.5.4-1 .7-1.5.9l-.2 1.6c-.1.5-.5.9-1 .9H7c-.5 0-.9-.4-1-.9v-1.5c-.5-.2-1-.5-1.5-.9l-1.5.6c-.1.1-.3.1-.4.1-.4 0-.7-.2-.9-.5l-1-1.7c-.3-.4-.2-1 .2-1.3l1.2-1C2 8.6 2 8.3 2 8v-.9l-1.2-1C.5 5.8.4 5.2.6 4.8l1-1.7c.2-.4.7-.6 1.2-.4l1.5.6c.5-.4 1-.7 1.5-.9L6 .9c.1-.5.5-.9 1-.9h2c.5 0 .9.4 1 .9l.1 1.5c.5.2 1 .5 1.5.9l1.5-.6c.4-.2 1 0 1.2.4l1 1.7c.3.4.2 1-.2 1.3l-1.2 1c.1.3.1.6.1.9zm-6 2.5c1.4 0 2.5-1.1 2.5-2.5S9.4 5.5 8 5.5A2.474 2.474 0 005.5 8l.003.132A2.474 2.474 0 008 10.5z"
  })
}));

/**
UiSettingsLined icon

```jsx
import { UiSettingsLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSettingsLined />
```

 */
const UiSettingsLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M21.53 14.25l-1.11-.98c.06-.42.1-.84.1-1.27 0-.43-.04-.85-.1-1.27l1.11-.98c.54-.47.66-1.26.31-1.88l-1.59-2.75c-.36-.62-1.11-.9-1.78-.67l-1.4.48a8.89 8.89 0 00-2.2-1.27l-.29-1.45c-.14-.7-.76-1.21-1.47-1.21H9.93c-.71 0-1.33.51-1.47 1.21l-.29 1.44c-.8.32-1.53.75-2.2 1.27l-1.4-.47c-.67-.23-1.42.05-1.78.67L1.2 7.88c-.36.62-.23 1.41.31 1.88l1.11.98c-.06.42-.1.84-.1 1.27 0 .43.04.85.1 1.27l-1.11.98c-.54.47-.67 1.26-.31 1.88l1.59 2.74c.27.47.78.75 1.3.75.16 0 .32-.03.48-.08l1.4-.48c.66.52 1.4.95 2.2 1.27l.29 1.45c.14.7.76 1.21 1.47 1.21h3.18c.71 0 1.33-.51 1.47-1.21l.29-1.45c.8-.32 1.53-.75 2.2-1.27l1.41.48c.16.05.32.08.48.08.52 0 1.03-.28 1.3-.75l.5-.88 1.08-1.87c.36-.62.23-1.41-.31-1.88zM11.52 21c-.41 0-.81-.04-1.2-.09L9.9 18.8c-.53-.13-1.03-.31-1.51-.55-.15-.08-.31-.16-.46-.25-.09-.05-.17-.1-.26-.16-.45-.3-.86-.65-1.23-1.04l-2.04.69c-.49-.63-.9-1.32-1.21-2.07L4.82 14c-.15-.51-.24-1.04-.27-1.58-.02-.14-.03-.28-.03-.42 0-.14.01-.28.02-.42.04-.55.13-1.08.28-1.58L3.2 8.58c.31-.75.72-1.44 1.21-2.07l2.03.69c.37-.39.78-.74 1.23-1.04.23-.15.48-.29.73-.41.47-.24.97-.43 1.5-.55l.42-2.11c.4-.05.79-.09 1.2-.09.41 0 .8.04 1.2.09l.42 2.11a7.168 7.168 0 012.24.97c.45.3.86.65 1.23 1.04l2.04-.69c.49.63.9 1.32 1.21 2.07L18.23 10c.15.51.24 1.04.27 1.58.01.14.02.28.02.42 0 .14-.01.28-.02.42-.03.55-.12 1.08-.27 1.58l1.62 1.42c-.31.75-.72 1.44-1.21 2.07l-2.04-.69c-.37.39-.78.74-1.23 1.04-.08.06-.17.11-.26.16a6.971 6.971 0 01-1.98.81l-.42 2.11c-.38.04-.78.08-1.19.08z"
  }), /*#__PURE__*/jsx("path", {
    d: "M11.52 9c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3zm0-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5z"
  })]
}));

/**
UiSettingsLinedSmall icon

```jsx
import { UiSettingsLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSettingsLinedSmall />
```

 */
const UiSettingsLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M10.5 8a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 8.7l.9.7c.5.3.6.9.3 1.4l-1.4 2.4c-.3.5-.9.7-1.4.5l-1.1-.4c-.3.3-.7.5-1.1.7l-.2 1.1c-.1.5-.6.9-1.1.9H6.6c-.6 0-1-.4-1.1-.9L5.3 14c-.4-.2-.7-.4-1.1-.7l-1.1.4c-.5.2-1.1 0-1.4-.5L.3 10.8C0 10.4.2 9.7.6 9.4l.9-.7V7.3l-.9-.7C.2 6.3.1 5.7.4 5.2l1.4-2.4c.2-.5.8-.7 1.3-.5l1.1.4c.2-.1.375-.2.55-.3.175-.1.35-.2.55-.3L5.5.9C5.6.4 6 0 6.6 0h2.8c.6 0 1 .4 1.1.9l.2 1.1c.4.2.7.4 1.1.7l1.1-.4c.6-.2 1.1 0 1.4.5l1.4 2.4c.2.4.1 1.1-.3 1.4l-.9.7v1.4zM11 11.4l.4-.4 1.4.6.6-1.1-1.2-1 .1-.6c.1-.3.1-.6.1-.9 0-.3 0-.6-.1-.9l-.1-.6 1.2-1-.6-1.1-1.4.6-.4-.4c-.5-.4-1-.7-1.5-.9l-.6-.2L8.7 2H7.4l-.3 1.5-.6.2c-.5.2-1 .5-1.5.9l-.4.4-1.5-.6-.6 1.1 1.2 1-.1.6c-.1.3-.1.6-.1.9 0 .3 0 .6.1.9l.2.6-1.2 1 .6 1.1 1.4-.6.4.4c.5.4 1 .7 1.6.9l.6.2.2 1.5h1.2l.3-1.5.6-.2c.5-.2 1-.5 1.5-.9z"
  })]
}));

/**
UiShareAndroidFilled icon

```jsx
import { UiShareAndroidFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiShareAndroidFilled />
```

 */
const UiShareAndroidFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M18 16c-.8 0-1.5.3-2 .8l-8-4.3v-1l8-4.3c.5.5 1.2.8 2 .8 1.7 0 3-1.3 3-3s-1.3-3-3-3-3 1.3-3 3v.5L7 9.8C6.5 9.3 5.8 9 5 9c-1.7 0-3 1.3-3 3s1.3 3 3 3c.8 0 1.5-.3 2-.8l8 4.3v.5c0 1.7 1.3 3 3 3s3-1.3 3-3-1.3-3-3-3z"
  })
}));

/**
UiShareAndroidFilledSmall icon

```jsx
import { UiShareAndroidFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiShareAndroidFilledSmall />
```

 */
const UiShareAndroidFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 10c-.8 0-1.4.3-2 .8L6 8.5v-1l4-2.3c.6.5 1.2.8 2 .8 1.7 0 3-1.3 3-3s-1.3-3-3-3-3 1.3-3 3c0 .2 0 .3.1.5L5 5.8C4.4 5.3 3.8 5 3 5 1.3 5 0 6.3 0 8s1.3 3 3 3c.8 0 1.4-.3 2-.8l4.1 2.3c-.1.2-.1.3-.1.5 0 1.7 1.3 3 3 3s3-1.3 3-3-1.3-3-3-3z"
  })
}));

/**
UiShareAndroidLined icon

```jsx
import { UiShareAndroidLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiShareAndroidLined />
```

 */
const UiShareAndroidLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M18 16c-.8 0-1.5.3-2 .8l-8-4.3v-1l8-4.3c.5.5 1.2.8 2 .8 1.7 0 3-1.3 3-3s-1.3-3-3-3-3 1.3-3 3v.5L7 9.8C6.5 9.3 5.8 9 5 9c-1.7 0-3 1.3-3 3s1.3 3 3 3c.8 0 1.5-.3 2-.8l8 4.3v.5c0 1.7 1.3 3 3 3s3-1.3 3-3-1.3-3-3-3zm0 4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-15c0 .6-.4 1-1 1s-1-.4-1-1 .4-1 1-1 1 .4 1 1zM5 13c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
  })
}));

/**
UiShareAndroidLinedSmall icon

```jsx
import { UiShareAndroidLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiShareAndroidLinedSmall />
```

 */
const UiShareAndroidLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 10c-.8 0-1.4.3-2 .8L6 8.5v-1l4-2.3c.6.5 1.2.8 2 .8 1.7 0 3-1.3 3-3s-1.3-3-3-3-3 1.3-3 3c0 .2 0 .3.1.5L5 5.8C4.4 5.3 3.8 5 3 5 1.3 5 0 6.3 0 8s1.3 3 3 3c.8 0 1.4-.3 2-.8l4.1 2.3c-.1.2-.1.3-.1.5 0 1.7 1.3 3 3 3s3-1.3 3-3-1.3-3-3-3zm0 4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-11c0 .6-.4 1-1 1s-1-.4-1-1 .4-1 1-1 1 .4 1 1zM3 9c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
  })
}));

/**
UiShareLined icon

```jsx
import { UiShareLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiShareLined />
```

 */
const UiShareLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11 4.399l-1.3 1.3c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l3-3c.1-.1.2-.187.3-.22.3-.1.5-.1.8 0 .1.033.2.12.3.22l3 3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3l-1.3-1.3v9.6c0 .6-.4 1-1 1s-1-.4-1-1v-9.6z"
  }), /*#__PURE__*/jsx("path", {
    d: "M17 7.999h1c1.1 0 2 .9 2 2v11c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2v-11c0-1.1.9-2 2-2h1c.6 0 1 .4 1 1s-.4 1-1 1H6v11h12v-11h-1c-.6 0-1-.4-1-1s.4-1 1-1z"
  })]
}));

/**
UiShareLinedSmall icon

```jsx
import { UiShareLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiShareLinedSmall />
```

 */
const UiShareLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M7 3.25l-.8.95c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4L7.3.3c.2-.2.4-.3.7-.3.3 0 .5.1.7.3l2.5 2.5c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3L9 3.25V10c0 .6-.4 1-1 1s-1-.4-1-1V3.25z"
  }), /*#__PURE__*/jsx("path", {
    d: "M12 6h1c.6 0 1 .4 1 1v8c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h1c.6 0 1 .4 1 1s-.4 1-1 1v6h8V8c-.6 0-1-.4-1-1s.4-1 1-1z"
  })]
}));

/**
UiShoppingBagFilled icon

```jsx
import { UiShoppingBagFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiShoppingBagFilled />
```

 */
const UiShoppingBagFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8 5.3c.1.2.2.5.2.8L20 15l1 4.8c.1.3 0 .5-.2.8-.2.3-.5.4-.8.4H4c-.3 0-.6-.2-.8-.4-.2-.2-.3-.5-.2-.8L4 15 3 6.1c0-.3.1-.6.3-.8.1-.2.4-.3.7-.3h4c0-2.2 1.8-4 4-4s4 1.8 4 4h4c.3 0 .6.1.8.3zM14 5c0-1.1-.9-2-2-2s-2 .9-2 2h4zm-4 5a1 1 0 11-2 0 1 1 0 012 0zm6 0a1 1 0 11-2 0 1 1 0 012 0z"
  })
}));

/**
UiShoppingBagFilledSmall icon

```jsx
import { UiShoppingBagFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiShoppingBagFilledSmall />
```

 */
const UiShoppingBagFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14 5.022v-.045A1 1 0 0013 4h-2a3 3 0 00-6 0H3a1 1 0 00-.723.313A1 1 0 002 4.977v.045a.945.945 0 00.017.161l.956 5.736-.914 2.742a.994.994 0 00-.059.314v.043A1 1 0 003 15h10a1 1 0 00.74-.332 1 1 0 00.26-.65v-.043a.993.993 0 00-.059-.314l-.914-2.742.956-5.736A.946.946 0 0014 5.022zM8 3a1 1 0 011 1H7a1 1 0 011-1z"
  })
}));

/**
UiShoppingBagLined icon

```jsx
import { UiShoppingBagLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiShoppingBagLined />
```

 */
const UiShoppingBagLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M21 6.1c0-.3-.1-.6-.2-.8-.2-.2-.5-.3-.8-.3h-4c0-2.2-1.8-4-4-4S8 2.8 8 5H4c-.3 0-.6.1-.7.3-.2.2-.3.5-.3.8L4 15l-1 4.8c-.1.3 0 .6.2.8.2.2.5.4.8.4h16c.3 0 .6-.1.8-.4.2-.3.3-.5.2-.8L20 15l1-8.9zM12 3c1.1 0 2 .9 2 2h-4c0-1.1.9-2 2-2zm6 12.2l.8 3.8H5.2l.8-3.8v-.3L5.1 7h13.8l-.9 7.9v.3z"
  }), /*#__PURE__*/jsx("path", {
    d: "M9 11a1 1 0 100-2 1 1 0 000 2zm6 0a1 1 0 100-2 1 1 0 000 2z"
  })]
}));

/**
UiShoppingBagLinedSmall icon

```jsx
import { UiShoppingBagLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiShoppingBagLinedSmall />
```

 */
const UiShoppingBagLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14 5.022v-.045A1 1 0 0013 4h-2a3 3 0 00-6 0H3a1 1 0 00-.723.313A1 1 0 002 4.977v.045a.945.945 0 00.017.161l.956 5.736-.914 2.742a.994.994 0 00-.059.314v.043A1 1 0 003 15h10a1 1 0 00.74-.332 1 1 0 00.26-.65v-.043a.993.993 0 00-.059-.314l-.914-2.742.956-5.736A.946.946 0 0014 5.022zM8 3a1 1 0 011 1H7a1 1 0 011-1zm3.052 8.316l.56 1.684H4.388l.56-1.684a.979.979 0 00.038-.48L4.181 6h7.638l-.805 4.836a.98.98 0 00.038.48z"
  })
}));

/**
UiShoppingBasketFilled icon

```jsx
import { UiShoppingBasketFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiShoppingBasketFilled />
```

 */
const UiShoppingBasketFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22.97 15.76l-1.5-6a.982.982 0 00-.18-.37v-.01c-.01-.02-.03-.02-.05-.04a.934.934 0 00-.27-.22c-.04-.02-.09-.03-.13-.05a.876.876 0 00-.27-.06c-.03 0-.05-.01-.07-.01H19V3c0-.55-.45-1-1-1h-5c-.55 0-1 .45-1 1v3.03c-.64-.49-1.4-.82-2.23-.95-.23-.54-.71-1.24-1.72-1.91a.997.997 0 00-1.1 1.66c.23.15.4.29.54.43C5.78 5.81 4.46 7.22 4.1 9h-.6c-.02 0-.04.01-.07.02a.76.76 0 00-.26.06c-.05.01-.1.02-.14.05-.1.06-.19.13-.27.22-.01.01-.03.02-.05.03v.01c-.08.11-.15.23-.18.37l-1.5 6A.995.995 0 002 17c.45 0 .86-.3.97-.76l.53-2.12 1.53 6.12c.11.45.51.76.97.76h12c.46 0 .86-.31.97-.76l1.53-6.12.53 2.12a.992.992 0 001.21.73 1 1 0 00.73-1.21zM9 7c1.3 0 2.4.84 2.82 2H6.18C6.6 7.84 7.7 7 9 7zm-.08 10.98c-.46.1-.82-.23-.91-.62l-.99-4.4c-.11-.49.19-.86.56-.95.37-.08.8.13.91.62l.99 4.4c.1.49-.11.85-.56.95zm3.83-.77c0 .49-.28.79-.75.79s-.75-.39-.75-.79v-4.43c0-.48.37-.78.75-.78s.75.3.75.79v4.42zm4.23-4.25l-.99 4.4c-.09.39-.45.72-.91.62-.46-.1-.67-.46-.56-.95l.99-4.4c.11-.49.54-.7.91-.62.37.09.67.47.56.95zM17 9h-3V4h3v5z"
  })
}));

/**
UiShoppingBasketLined icon

```jsx
import { UiShoppingBasketLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiShoppingBasketLined />
```

 */
const UiShoppingBasketLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11.25 12.79c0-.49.37-.79.75-.79s.75.3.75.79v4.43c0 .49-.28.79-.75.79s-.75-.4-.75-.79v-4.43zm-2.26-.16c-.11-.49-.54-.7-.91-.62-.37.08-.67.46-.56.95l.99 4.4c.09.39.45.72.91.62.46-.1.67-.46.56-.95l-.99-4.4zm6.02.01c.11-.49.54-.7.91-.62.37.08.67.46.56.95l-.99 4.4c-.09.39-.45.72-.91.62-.46-.11-.67-.46-.56-.95l.99-4.4z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.47 9.76l1.5 6a1 1 0 01-1.94.48l-.53-2.12-1.53 6.12c-.11.45-.51.76-.97.76H6c-.46 0-.86-.31-.97-.76L3.5 14.12l-.53 2.12a.992.992 0 01-1.21.73.995.995 0 01-.73-1.21l1.5-6c.03-.14.1-.26.18-.37v-.01c.02-.01.04-.02.05-.03.08-.09.17-.16.27-.22.04-.03.09-.04.14-.05a.76.76 0 01.26-.06.78.78 0 00.022-.008A.14.14 0 013.5 9h.6c.36-1.78 1.68-3.19 3.39-3.74-.14-.14-.31-.28-.54-.43a.997.997 0 011.1-1.66c1.01.67 1.49 1.37 1.72 1.91.83.13 1.59.46 2.23.95V3c0-.55.45-1 1-1h5c.55 0 1 .45 1 1v6h1.5c.009 0 .018.002.028.004a.182.182 0 00.042.006c.09 0 .18.03.27.06a.5.5 0 00.065.025.5.5 0 01.065.025c.1.05.19.13.27.22a.107.107 0 00.026.018c.01.006.018.01.024.022v.01c.08.11.15.23.18.37zM17 4h-3v5h3V4zm-5.18 5C11.4 7.84 10.3 7 9 7c-1.3 0-2.4.84-2.82 2h5.64zM6.78 19h10.44l2-8H4.78l2 8z"
  })]
}));

/**
UiShowFilled icon

```jsx
import { UiShowFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiShowFilled />
```

 */
const UiShowFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22.765 11.7c-1.04-1.34-5.52-6.7-10.77-6.7s-9.73 5.36-10.77 6.7c-.14.18-.14.42 0 .6 1.04 1.34 5.52 6.7 10.77 6.7s9.73-5.36 10.77-6.7c.14-.18.14-.42 0-.6zm-10.77 3.8c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5V12l2.47-2.47c.63.63 1.03 1.51 1.03 2.47 0 1.93-1.57 3.5-3.5 3.5z"
  })
}));

/**
UiShowFilledSmall icon

```jsx
import { UiShowFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiShowFilledSmall />
```

 */
const UiShowFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M15.9 7.6C15.8 7.4 13.6 2 8 2 2.4 2 .2 7.4.1 7.6c-.1.3-.1.5 0 .8C.2 8.6 2.4 14 8 14c5.6 0 7.8-5.4 7.9-5.6.1-.3.1-.5 0-.8zM9.8 9.8c-1 1-2.6 1-3.5 0-.9-1-1-2.6 0-3.5.4-.6 1.1-.8 1.7-.8V8l1.8-1.8c.9 1 .9 2.6 0 3.6z"
  })
}));

/**
UiShowHideFilled icon

```jsx
import { UiShowHideFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiShowHideFilled />
```

 */
const UiShowHideFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.225 5.192c-.01 0-.01.01-.01.01l-15.02 15.01c-.2.19-.45.29-.71.29a.996.996 0 01-.71-1.7l2.06-2.06c-2.32-1.64-4.02-3.69-4.61-4.45a.481.481 0 010-.6c1.05-1.34 5.53-6.7 10.78-6.69 1.57 0 3.05.48 4.41 1.18l2.39-2.39a.996.996 0 011.41 0c.39.38.39 1.01.01 1.4zm-8.22 3.3c-1.93 0-3.5 1.57-3.5 3.5 0 .6.16 1.16.43 1.66l3.07-3.07v-2.09z"
  }), /*#__PURE__*/jsx("path", {
    d: "M9.615 18.622l3.25-3.25c1.24-.31 2.2-1.28 2.52-2.52l4.36-4.36c1.5 1.31 2.58 2.62 3.03 3.2.14.18.14.42 0 .6-1.04 1.34-5.52 6.7-10.77 6.7-.82 0-1.62-.14-2.39-.37z"
  })]
}));

/**
UiShowHideFilledSmall icon

```jsx
import { UiShowHideFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiShowHideFilledSmall />
```

 */
const UiShowHideFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8 2.6c0 .1-.1.1-.1.1l-12 12c-.1 0-.1.1-.1.1-.2.1-.4.2-.6.2-.3 0-.5-.1-.7-.2-.4-.4-.4-1 0-1.4L2.7 12C1.23 10.693.493 9.186.218 8.623A1.531 1.531 0 00.1 8.4a1.104 1.104 0 01.022-.849C.382 6.974 2.625 2 8 2c1.4 0 2.7.4 3.7.9l1.6-1.6c.4-.4 1-.4 1.4 0 .4.4.4.9.1 1.3zM8 5.5c-.6 0-1.3.2-1.8.7-.7.8-.9 1.8-.5 2.7L8 6.6V5.5z"
  }), /*#__PURE__*/jsx("path", {
    d: "M6.524 13.838A63.528 63.528 0 006.3 13.8l8.3-8.2c.9 1.1 1.3 2 1.3 2.1.1.2.1.5 0 .7l-.022.049C15.618 9.026 13.375 14 8 14c-.524 0-.971-.076-1.476-.162z"
  })]
}));

/**
UiShowHideLined icon

```jsx
import { UiShowHideLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiShowHideLined />
```

 */
const UiShowHideLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.205 3.792c.39.38.39 1.01 0 1.41l-15.01 15.01c-.2.19-.45.29-.71.29a.996.996 0 01-.71-1.7l2.06-2.06c-2.32-1.64-4.02-3.69-4.61-4.45a.481.481 0 010-.6c1.04-1.34 5.53-6.7 10.77-6.69 1.57 0 3.06.48 4.41 1.18l2.39-2.39a.996.996 0 011.41 0zm-8.2 3.2c-3.55 0-6.89 3.25-8.43 5 .81.92 2.12 2.26 3.69 3.32l2.03-2.03c-.19-.39-.3-.83-.3-1.29 0-1.66 1.34-3 3-3v1.59l2.92-2.92c-.93-.41-1.91-.67-2.91-.67z"
  }), /*#__PURE__*/jsx("path", {
    d: "M20.425 11.992c-1.54 1.75-4.88 5-8.43 5-.24 0-.48-.02-.72-.05l-1.68 1.68c.77.23 1.57.37 2.39.37 5.25 0 9.73-5.36 10.77-6.7.14-.18.14-.42 0-.6-.43-.58-1.51-1.89-3.01-3.2l-1.42 1.42a20.7 20.7 0 012.1 2.08z"
  })]
}));

/**
UiShowHideLinedSmall icon

```jsx
import { UiShowHideLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiShowHideLinedSmall />
```

 */
const UiShowHideLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.736 2.625a.33.33 0 00-.066.046l-12 11.99c-.024.024-.037.048-.05.072-.01.015-.018.031-.03.047-.18.14-.38.22-.59.22-.26 0-.51-.1-.71-.29a.996.996 0 010-1.41l1.36-1.36C.91 10.38.12 8.5.07 8.37c-.09-.24-.09-.5 0-.74C.16 7.4 2.39 2 8 2c1.45 0 2.67.36 3.69.9l1.61-1.61a.996.996 0 011.41 0c.36.36.37.91.08 1.3-.017.013-.036.024-.054.035zM8 4C4.45 4 2.64 6.94 2.1 8c.28.56.92 1.63 1.97 2.52l1.6-1.61c-.35-.9-.16-1.95.56-2.68A2.49 2.49 0 018 5.5v1.09L9.39 5.2l.78-.79C9.54 4.16 8.82 4 8 4z"
  }), /*#__PURE__*/jsx("path", {
    d: "M8.17 11.99c3.44-.09 5.2-2.94 5.73-3.99-.14-.27-.35-.65-.65-1.08l1.42-1.42a10.297 10.297 0 011.25 2.109l.01.022c.09.24.09.5 0 .74C15.84 8.6 13.61 14 8 14c-.59 0-1.14-.07-1.66-.18l1.83-1.83z"
  })]
}));

/**
UiShowLined icon

```jsx
import { UiShowLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiShowLined />
```

 */
const UiShowLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.005 5c5.25 0 9.73 5.36 10.77 6.7.14.18.14.42 0 .6-1.04 1.34-5.52 6.7-10.77 6.7s-9.74-5.36-10.78-6.7a.481.481 0 010-.6c1.04-1.34 5.53-6.7 10.78-6.7zm-8.43 7c1.55 1.75 4.88 5 8.43 5s6.88-3.25 8.43-5c-1.55-1.75-4.88-5-8.43-5s-6.88 3.25-8.43 5zm5.43 0c0-1.66 1.34-3 3-3v3l2.12-2.12a2.996 2.996 0 01-2.12 5.12c-1.66 0-3-1.34-3-3z"
  })
}));

/**
UiShowLinedSmall icon

```jsx
import { UiShowLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiShowLinedSmall />
```

 */
const UiShowLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M8 5.5V8l1.77-1.77c.98.98.98 2.56 0 3.54s-2.56.98-3.54 0A2.499 2.499 0 018 5.5z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2c5.61 0 7.84 5.4 7.93 5.63.09.24.09.5 0 .74C15.84 8.6 13.61 14 8 14 2.39 14 .16 8.6.07 8.37c-.09-.24-.09-.5 0-.74C.16 7.4 2.39 2 8 2zM2.1 8c.54 1.06 2.35 4 5.9 4 3.55 0 5.36-2.94 5.9-4-.54-1.06-2.35-4-5.9-4-3.55 0-5.36 2.94-5.9 4z"
  })]
}));

/**
UiSignOutFilled icon

```jsx
import { UiSignOutFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSignOutFilled />
```

 */
const UiSignOutFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M8 9c-1.65 0-3 1.35-3 3s1.35 3 3 3h5v5c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v5H8z"
  }), /*#__PURE__*/jsx("path", {
    d: "M17.71 6.29l5 5c.39.39.39 1.03 0 1.42l-5 5c-.2.19-.45.29-.71.29-.26 0-.51-.1-.7-.3a.996.996 0 010-1.41L19.59 13H8c-.55 0-1-.45-1-1s.45-1 1-1h11.59L16.3 7.7a.996.996 0 111.41-1.41z"
  })]
}));

/**
UiSignOutFilledSmall icon

```jsx
import { UiSignOutFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSignOutFilledSmall />
```

 */
const UiSignOutFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsxs("g", {
    clipPath: "url(#omni-gravity-icon-ui-sign-out-filled-small-a)",
    children: [/*#__PURE__*/jsx("path", {
      d: "M5.5 6c-1.1 0-2 .9-2 2s.9 2 2 2h3.59v4c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V2c0-.55.45-1 1-1h7.09c.55 0 1 .45 1 1v4H5.5z"
    }), /*#__PURE__*/jsx("path", {
      d: "M12.71 4.29l3 3c.39.39.39 1.03 0 1.42l-3 3c-.2.19-.45.29-.71.29-.26 0-.51-.1-.7-.3a.996.996 0 010-1.41L12.59 9H5.5c-.55 0-1-.45-1-1s.45-1 1-1h7.09L11.3 5.7a.996.996 0 111.41-1.41z"
    })]
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-sign-out-filled-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiSignOutLined icon

```jsx
import { UiSignOutLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSignOutLined />
```

 */
const UiSignOutLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11 18c0-.55.45-1 1-1s1 .45 1 1v2c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v2c0 .55-.45 1-1 1s-1-.45-1-1V4H3v16h8v-2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M17.71 6.29l5 5c.39.39.39 1.03 0 1.42l-5 5c-.2.19-.45.29-.71.29-.26 0-.51-.1-.7-.3a.996.996 0 010-1.41L19.59 13H8c-.55 0-1-.45-1-1s.45-1 1-1h11.59L16.3 7.7a.996.996 0 111.41-1.41z"
  })]
}));

/**
UiSignOutLinedSmall icon

```jsx
import { UiSignOutLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSignOutLinedSmall />
```

 */
const UiSignOutLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsxs("g", {
    clipPath: "url(#omni-gravity-icon-ui-sign-out-lined-small-a)",
    children: [/*#__PURE__*/jsx("path", {
      d: "M7 13c0-.55.45-1 1-1s1 .45 1 1v1c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V2c0-.55.45-1 1-1h7c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1s-1-.45-1-1H2v10h5z"
    }), /*#__PURE__*/jsx("path", {
      d: "M12.71 4.29l3 3c.39.39.39 1.03 0 1.42l-3 3c-.2.19-.45.29-.71.29-.26 0-.51-.1-.7-.3a.996.996 0 010-1.41L12.59 9H6c-.55 0-1-.45-1-1s.45-1 1-1h6.59L11.3 5.7a.996.996 0 111.41-1.41z"
    })]
  }), /*#__PURE__*/jsx("defs", {
    children: /*#__PURE__*/jsx("clipPath", {
      id: "omni-gravity-icon-ui-sign-out-lined-small-a",
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h16v16H0z"
      })
    })
  })]
}));

/**
UiSignatureLined icon

```jsx
import { UiSignatureLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSignatureLined />
```

 */
const UiSignatureLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M21.45 4.53c.7.7.7 1.85 0 2.55l-.55.55-2.59-2.51.59-.59a1.796 1.796 0 012.55 0zM9.98 16v-2.55l7.62-7.63 2.59 2.52L12.52 16H9.98zm-8.69.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29L4.5 14.5l1.79 1.79c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-1.8-1.8 1.79-1.79a.996.996 0 10-1.41-1.41L4.5 11.66 2.71 9.87a.996.996 0 10-1.41 1.41l1.79 1.79-1.79 1.79c-.4.4-.4 1.04-.01 1.43zm.74 1.66h19.95c.55 0 1 .45 1 1s-.45 1-1 1H2.03c-.55 0-1-.45-1-1s.45-1 1-1z"
  })
}));

/**
UiSignatureLinedSmall icon

```jsx
import { UiSignatureLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSignatureLinedSmall />
```

 */
const UiSignatureLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14.5 4.41c.55-.55.55-1.45 0-2-.28-.27-.64-.41-1-.41s-.72.14-1 .41L7 7.91v2h2l5.5-5.5zM1.67 10.32a.485.485 0 00.7 0l1.15-1.15 1.15 1.15a.485.485 0 00.7 0c.2-.2.2-.51 0-.71L4.23 8.46l1.15-1.15c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0L3.52 7.76 2.38 6.61c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.15 1.15-1.15 1.14c-.19.2-.19.51 0 .71zM1 11.87h14c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1s.45-1 1-1z"
  })
}));

/**
UiSlackFilled icon

```jsx
import { UiSlackFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSlackFilled />
```

 */
const UiSlackFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M9 6h2V4c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2zm-5 5h5c1.1 0 2-.9 2-2s-.9-2-2-2H4c-1.1 0-2 .9-2 2s.9 2 2 2zm8-2V4c0-1.1.9-2 2-2s2 .9 2 2v5c0 1.1-.9 2-2 2s-2-.9-2-2zm5 0v2h2c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2zm-3 3h5c1.1 0 2 .9 2 2s-.9 2-2 2h-5c-1.1 0-2-.9-2-2s.9-2 2-2zm0 5h-2v2c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2zm-3-3v5c0 1.1-.9 2-2 2s-2-.9-2-2v-5c0-1.1.9-2 2-2s2 .9 2 2zm-5 0v-2H4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2z"
  })
}));

/**
UiSortAltLined icon

```jsx
import { UiSortAltLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSortAltLined />
```

 */
const UiSortAltLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M21 4H3c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1zm-5 7H3c-.55 0-1 .45-1 1s.45 1 1 1h13c.55 0 1-.45 1-1s-.45-1-1-1zM3 18h8c.55 0 1 .45 1 1s-.45 1-1 1H3c-.55 0-1-.45-1-1s.45-1 1-1z"
  })
}));

/**
UiSortAltLinedSmall icon

```jsx
import { UiSortAltLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSortAltLinedSmall />
```

 */
const UiSortAltLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14 2H2c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1zm-3 5H2c-.55 0-1 .45-1 1s.45 1 1 1h9c.55 0 1-.45 1-1s-.45-1-1-1zm-9 5h7c.55 0 1 .45 1 1s-.45 1-1 1H2c-.55 0-1-.45-1-1s.45-1 1-1z"
  })
}));

/**
UiSortLined icon

```jsx
import { UiSortLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSortLined />
```

 */
const UiSortLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M7.487 3.324a1 1 0 00-1.474 0l-2.75 3a1 1 0 101.474 1.352L5.75 6.57V12a1 1 0 102 0V6.57l1.013 1.106a1 1 0 101.474-1.352l-2.75-3zm6.337 12.939a1 1 0 011.413.061l1.013 1.105V12a1 1 0 112 0v5.43l1.013-1.106a1 1 0 011.474 1.352l-2.75 3a1 1 0 01-1.474 0l-2.75-3a1 1 0 01.061-1.413zM6.75 17c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm1 3c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zm9.5-15c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm1 3c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1z"
  })
}));

/**
UiSortLinedSmall icon

```jsx
import { UiSortLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSortLinedSmall />
```

 */
const UiSortLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M4.707.293a1 1 0 00-1.414 0l-2 2a1 1 0 001.414 1.414L3 3.414V7a1 1 0 002 0V3.414l.293.293a1 1 0 001.414-1.414l-2-2zm4.586 12a1 1 0 011.414 0l.293.293V9a1 1 0 112 0v3.586l.293-.293a1 1 0 011.414 1.414l-2 2a1 1 0 01-1.414 0l-2-2a1 1 0 010-1.414zM4 16c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm1-5c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zm7-5c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm1-5c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1z"
  })
}));

/**
UiSplitLined icon

```jsx
import { UiSplitLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSplitLined />
```

 */
const UiSplitLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M10 3c-.55 0-1 .45-1 1v7.03c-.06-.01-.11-.03-.17-.03H5.41l1.12-1.12a.996.996 0 10-1.41-1.41L2.29 11.3c-.18.18-.29.43-.29.7s.11.52.29.71l2.83 2.83c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 000-1.41L5.41 13h3.41c.06 0 .11-.02.17-.03V20c0 .55.45 1 1 1s1-.45 1-1V4c.01-.55-.44-1-.99-1zm11.71 8.29l-2.83-2.83a.996.996 0 10-1.41 1.41L18.59 11h-3.41c-.06 0-.11.02-.17.03V4c0-.55-.45-1-1-1s-1 .45-1 1v16c0 .55.45 1 1 1s1-.45 1-1v-7.03c.06.01.11.03.17.03h3.41l-1.12 1.12a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l2.83-2.83c.38-.38.38-1.02-.01-1.41z"
  })
}));

/**
UiSplitLinedSmall icon

```jsx
import { UiSplitLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSplitLinedSmall />
```

 */
const UiSplitLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M6 1c-.55 0-1 .45-1 1v5.03l-2.29.07.73-.73c.29-.29.29-.77 0-1.06s-.77-.29-1.06 0L.22 7.47c-.29.29-.29.77 0 1.06l2.16 2.16c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06l-.73-.73L5 8.97V14c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1zm9.78 6.47l-2.16-2.16c-.15-.15-.34-.22-.53-.22s-.38.07-.53.22c-.29.29-.29.77 0 1.06l.73.73L11 7.03V2c0-.55-.45-1-1-1s-1 .45-1 1v12c0 .55.45 1 1 1s1-.45 1-1V8.97l2.29-.07-.73.73c-.29.29-.29.77 0 1.06s.77.29 1.06 0l2.16-2.16c.29-.29.29-.77 0-1.06z"
  })
}));

/**
UiStarFilled icon

```jsx
import { UiStarFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiStarFilled />
```

 */
const UiStarFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M21.97 9a.501.501 0 00-.47-.32h-6.76L12.47 2.3c-.14-.4-.8-.4-.94 0L9.26 8.67H2.5c-.21 0-.39.13-.47.33a.5.5 0 00.14.55l5.36 4.72-2.16 7.06c-.06.21.01.43.19.55.17.12.41.12.58 0l5.86-4.3 5.85 4.29c.09.06.19.1.3.1a.494.494 0 00.48-.64l-2.16-7.06 5.36-4.72a.5.5 0 00.14-.55z"
  })
}));

/**
UiStarFilledSmall icon

```jsx
import { UiStarFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiStarFilledSmall />
```

 */
const UiStarFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M15.46 5h-5.38L8.385.3c-.1-.2-.2-.3-.399-.3-.2 0-.299.1-.399.3L5.893 5H.511c-.498 0-.698.6-.299.9l4.385 3.5-1.893 6c-.2.3.1.6.398.6.1 0 .2 0 .3-.1l4.584-3.7 4.684 3.7c.1.1.2.1.3.1.298 0 .597-.3.398-.6l-1.894-6 4.386-3.5c.299-.3.1-.9-.4-.9z"
  })
}));

/**
UiStarLined icon

```jsx
import { UiStarLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiStarLined />
```

 */
const UiStarLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M21.97 9a.501.501 0 00-.47-.32h-6.76L12.47 2.3c-.14-.4-.8-.4-.94 0L9.26 8.67H2.5c-.21 0-.39.13-.47.33a.5.5 0 00.14.55l5.36 4.72-2.16 7.06c-.06.21.01.43.19.55.17.12.41.12.58 0l5.86-4.3 5.85 4.29c.09.06.19.1.3.1a.494.494 0 00.48-.64l-2.16-7.06 5.36-4.72a.5.5 0 00.14-.55zm-7.06 3.98l-.73.64.28.93.93 3.05-2.51-1.84-.88-.66-.89.65-2.51 1.84.93-3.05.28-.93-.73-.64-2.62-2.3h4.19l.36-1L12 6.93l.98 2.74.36 1h4.19l-2.62 2.31z"
  })
}));

/**
UiStarLinedSmall icon

```jsx
import { UiStarLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiStarLinedSmall />
```

 */
const UiStarLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M15.46 5h-5.38L8.385.3c-.1-.2-.2-.3-.399-.3-.2 0-.299.1-.399.3L5.893 5H.511c-.498 0-.698.6-.299.9l4.385 3.5-1.893 6c-.2.3.1.6.398.6.1 0 .2 0 .3-.1l4.584-3.7 4.684 3.7c.1.1.2.1.3.1.298 0 .597-.3.398-.6l-1.894-6 4.386-3.5c.299-.3.1-.9-.4-.9zm-5.182 3.1l-.897.7.399 1.2.598 1.9-1.296-1-1.096-1-1.096.9-1.296 1 .598-1.8.399-1.2-.897-.7-1.695-1.3h3.09l.399-1.2.498-1.2.399 1.2.398 1.2h3.19l-1.695 1.3z"
  })
}));

/**
UiStrategyFilled icon

```jsx
import { UiStrategyFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiStrategyFilled />
```

 */
const UiStrategyFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M19.968 21.76l-.5-2a.995.995 0 00-.97-.76h-.62c-.14-.69-.38-1.43-.65-2.25-.57-1.7-1.22-3.62-1.21-5.99.01-.89.32-1.69.88-2.25l1.8-1.8c.09-.09.17-.2.22-.32.05-.12.08-.25.08-.39V2c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v2h-2V2c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v2h-2V2c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v4c0 .13.03.26.08.39.05.12.12.23.22.32l1.8 1.8c.56.56.87 1.36.88 2.25.02 2.36-.63 4.29-1.21 5.99-.28.82-.52 1.56-.65 2.25h-.62c-.46 0-.86.31-.97.76l-.5 2c-.07.3-.01.62.18.86s.48.38.79.38h14c.31 0 .6-.14.79-.38.19-.25.25-.56.18-.86z"
  })
}));

/**
UiStrategyFilledSmall icon

```jsx
import { UiStrategyFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiStrategyFilledSmall />
```

 */
const UiStrategyFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14 13h-1.28c-.37-1.18-1.09-3.71-1.21-5.94l2-1.2c.3-.18.49-.51.49-.86V1c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v1.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5V1c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v1.5c0 .28-.22.5-.5.5S5 2.78 5 2.5V1c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4c0 .35.18.68.49.86l2 1.2C4.38 9.3 3.65 11.83 3.28 13H2c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1z"
  })
}));

/**
UiStrategyLined icon

```jsx
import { UiStrategyLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiStrategyLined />
```

 */
const UiStrategyLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M19.495 18.838c-.08-.48-.5-.84-.99-.84h-.61c-.15-.77-.43-1.581-.75-2.491-.52-1.461-1.1-3.112-1.1-4.753 0-.89.31-1.69.88-2.25l1.79-1.791a.99.99 0 00.29-.71V2c0-.55-.45-1-1-1h-12c-.55 0-1 .45-1 1v4.002c0 .27.11.52.29.71l1.79 1.791c.57.57.88 1.371.88 2.251 0 1.651-.59 3.302-1.1 4.753-.32.91-.6 1.72-.75 2.49h-.61a1 1 0 00-.99.841l-.5 3.002c-.05.29.03.59.22.81.19.22.48.35.77.35h14a.987.987 0 00.98-1.16l-.49-3.002zM8.505 7.083l-1.5-1.5V2.99h2v2c0 .551.45 1.001 1 1.001s1-.45 1-1V2.99h2v2c0 .551.45 1.001 1 1.001s1-.45 1-1V2.99h2v2.591l-1.5 1.5c-.94.941-1.46 2.252-1.46 3.672 0 1.991.65 3.812 1.22 5.423.23.65.45 1.27.59 1.82h-7.69c.14-.55.36-1.17.59-1.82.57-1.61 1.22-3.432 1.22-5.423 0-1.43-.52-2.73-1.47-3.671zm-2.32 13.916l.17-1h11.3l.17 1H6.185z"
  })
}));

/**
UiStrategyLinedSmall icon

```jsx
import { UiStrategyLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiStrategyLinedSmall />
```

 */
const UiStrategyLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14 13.01h-.27c-.13-.5-.28-.99-.43-1.47-.35-1.08-.71-2.2-.78-3.63l1.2-1.2a.99.99 0 00.29-.71V1c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v5c0 .27.11.52.29.71l1.2 1.2c-.06 1.44-.43 2.56-.78 3.64-.15.47-.31.95-.43 1.45H2c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-1a1 1 0 00-1-.99zM5.21 6.8L4 5.6V2.01h2v1.5c0 .28.22.5.5.5s.5-.22.5-.5v-1.5h2v1.5c0 .28.22.5.5.5s.5-.22.5-.5v-1.5h2V5.6l-1.21 1.21c-.19.19-.29.45-.29.71.01 1.94.48 3.38.89 4.64.1.29.18.57.27.85h-7.3c.08-.27.17-.54.26-.83.42-1.27.89-2.72.89-4.67a1.09 1.09 0 00-.3-.71z"
  })
}));

/**
UiStreamsLined icon

```jsx
import { UiStreamsLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiStreamsLined />
```

 */
const UiStreamsLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M8.5 2a1 1 0 00-2 0v10a1 1 0 102 0V2zM3 5a1 1 0 011 1v6a1 1 0 11-2 0V6a1 1 0 011-1zm9 0a1 1 0 011 1v12a1 1 0 11-2 0V6a1 1 0 011-1zm9 6a1 1 0 011 1v6a1 1 0 11-2 0v-6a1 1 0 011-1zm-3.5 1a1 1 0 10-2 0v10a1 1 0 102 0V12z"
  })
}));

/**
UiStreamsLinedSmall icon

```jsx
import { UiStreamsLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiStreamsLinedSmall />
```

 */
const UiStreamsLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M4.5 0a1 1 0 011 1v6.5a1 1 0 01-2 0V1a1 1 0 011-1zM8 3a1 1 0 011 1v8a1 1 0 11-2 0V4a1 1 0 011-1zm3.5 4.5a1 1 0 011 1V15a1 1 0 11-2 0V8.5a1 1 0 011-1zm4.5 1a1 1 0 10-2 0V12a1 1 0 102 0V8.5zM2 4a1 1 0 00-2 0v3.5a1 1 0 002 0V4z"
  })
}));

/**
UiSuitcaseFilled icon

```jsx
import { UiSuitcaseFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSuitcaseFilled />
```

 */
const UiSuitcaseFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 7h-4V5c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5z"
  })
}));

/**
UiSuitcaseFilledSmall icon

```jsx
import { UiSuitcaseFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSuitcaseFilledSmall />
```

 */
const UiSuitcaseFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14.5 4H12V2.5c0-.8-.7-1.5-1.5-1.5h-5C4.7 1 4 1.7 4 2.5V4H1.5C.7 4 0 4.7 0 5.5v8c0 .8.7 1.5 1.5 1.5h13c.8 0 1.5-.7 1.5-1.5v-8c0-.8-.7-1.5-1.5-1.5zm-9-1.5h5V4h-5V2.5z"
  })
}));

/**
UiSuitcaseLined icon

```jsx
import { UiSuitcaseLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSuitcaseLined />
```

 */
const UiSuitcaseLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 7h-4V5c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zM4 19V9h16v10H4z"
  })
}));

/**
UiSuitcaseLinedSmall icon

```jsx
import { UiSuitcaseLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiSuitcaseLinedSmall />
```

 */
const UiSuitcaseLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14.5 4H12V2.5c0-.8-.7-1.5-1.5-1.5h-5C4.7 1 4 1.7 4 2.5V4H1.5C.7 4 0 4.7 0 5.5v8c0 .8.7 1.5 1.5 1.5h13c.8 0 1.5-.7 1.5-1.5v-8c0-.8-.7-1.5-1.5-1.5zm-9-1.5h5V4h-5V2.5zM14 13H2V6h12v7z"
  })
}));

/**
UiTableLined icon

```jsx
import { UiTableLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTableLined />
```

 */
const UiTableLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5c0-1.102.898-2 2-2h14c1.102 0 2 .898 2 2v14c0 1.096-.881 2-2 2H5c-1.102 0-2-.898-2-2V5zm16 0H5v14h6v-2H5.01v-2H11v-1.998h2V15h2v2h-2v2h6v-2h-2v1.992h-2V13H5.01v-2H19V5zm-2 8v2h2v-2h-2z"
  })
}));

/**
UiTableLinedSmall icon

```jsx
import { UiTableLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTableLinedSmall />
```

 */
const UiTableLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 .898.898 0 2 0h12c1.102 0 2 .898 2 2v12c0 1.102-.898 2-2 2H2c-1.102 0-2-.898-2-2V2zm14 0H2v4h12V2zM9.997 8h-2v5.998h-2V12H2v2h12v-2h-2v-2h2V8h-2.003v5.998h-2V12H8v-2h1.997V8zM2 8h3.997v2H2V8z"
  })
}));

/**
UiTableViewsLined icon

```jsx
import { UiTableViewsLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTableViewsLined />
```

 */
const UiTableViewsLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M13 14.3V13h1.3c.9-.6 2-1 3.2-1 1.3 0 2.5.5 3.5 1.3V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8.3c-.8-1-1.3-2.2-1.3-3.5 0-1.2.4-2.3 1-3.2zm2-3.3h-2V9h2v2zm4 0h-2V9h2v2zM5 5h14v2H5V5zm6 14H5v-2h6v2zm0-4H5v-2h6v2zm0-4H5V9h6v2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M21.9 20.7c0-.2-.1-.3-.2-.4l-1-1s-.1-.1-.2-.1c.3-.5.5-1.1.5-1.7 0-1.9-1.6-3.5-3.5-3.5S14 15.6 14 17.5s1.6 3.5 3.5 3.5c.6 0 1.2-.2 1.7-.5 0 .1.1.1.1.2l1 1c.1.1.3.2.4.2.1 0 .2.1.3.1.3 0 .5-.1.7-.3.3-.3.3-.6.2-1zM17.5 19c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5z"
  })]
}));

/**
UiTableViewsLinedSmall icon

```jsx
import { UiTableViewsLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTableViewsLinedSmall />
```

 */
const UiTableViewsLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C.898 0 0 .898 0 2v9c0 1.102.898 2 2 2h3.603a5.48 5.48 0 01.902-6.274V6.01h.824A5.467 5.467 0 0110.5 5c.9 0 1.75.218 2.5.603V2c0-1.102-.898-2-2-2H2zm9 4.01V2H2v2.01h9zm-9 2v1.5h2.505v-1.5H2zm0 3.5V11h2.505V9.51H2z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 10.5a4 4 0 117.412 2.089.998.998 0 01.295.204l1.5 1.5a1 1 0 01-1.414 1.414l-1.5-1.5a.998.998 0 01-.204-.295A4 4 0 016.5 10.5zm4-2a2 2 0 100 4 2 2 0 000-4z"
  })]
}));

/**
UiTagFilled icon

```jsx
import { UiTagFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTagFilled />
```

 */
const UiTagFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6 14.4c-.4-.3-.6-.8-.6-1.4 0-.6.2-1.1.6-1.4l9-9c.3-.4.8-.6 1.4-.6h7c1.1 0 2 .9 2 2v7c0 .6-.2 1.1-.6 1.4l-9 9c-.3.4-.8.6-1.4.6-.6 0-1.1-.2-1.4-.6l-7-7zM19 6.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
  })
}));

/**
UiTagFilledSmall icon

```jsx
import { UiTagFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTagFilledSmall />
```

 */
const UiTagFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1h6c.6 0 1 .4 1 1v6c0 .3-.1.5-.3.7l-7 7c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3l-6-6c-.4-.4-.4-1 0-1.4l7-7c.2-.2.4-.3.7-.3zm5 3a1 1 0 11-2 0 1 1 0 012 0z"
  })
}));

/**
UiTagLined icon

```jsx
import { UiTagLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTagLined />
```

 */
const UiTagLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M18.5 7a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6 14.4c-.4-.3-.6-.8-.6-1.4 0-.6.2-1.1.6-1.4l9-9c.3-.4.8-.6 1.4-.6h7c1.1 0 2 .9 2 2v7c0 .6-.2 1.1-.6 1.4l-9 9c-.3.4-.8.6-1.4.6-.6 0-1.1-.2-1.4-.6l-7-7zM13 4l-9 9 7 7 9-9V4h-7z"
  })]
}));

/**
UiTagLinedSmall icon

```jsx
import { UiTagLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTagLinedSmall />
```

 */
const UiTagLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12 5a1 1 0 11-2 0 1 1 0 012 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1h6c.6 0 1 .4 1 1v6c0 .3-.1.5-.3.7l-7 7c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3l-6-6c-.4-.4-.4-1 0-1.4l7-7c.2-.2.4-.3.7-.3zM7 13.6l6-6V3H8.4l-6 6L7 13.6z"
  })]
}));

/**
UiTapCardKeyFilled icon

```jsx
import { UiTapCardKeyFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTapCardKeyFilled />
```

 */
const UiTapCardKeyFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M8 13a1 1 0 100-2 1 1 0 000 2z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5h18c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2zm13 9v-1h1v1c0 .6.4 1 1 1s1-.4 1-1v-2c0-.6-.4-1-1-1h-7.2C10.4 9.8 9.3 9 8 9c-1.7 0-3 1.3-3 3s1.3 3 3 3c1.3 0 2.4-.8 2.8-2H14v1c0 .6.4 1 1 1s1-.4 1-1z"
  })]
}));

/**
UiTapCardKeyFilledSmall icon

```jsx
import { UiTapCardKeyFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTapCardKeyFilledSmall />
```

 */
const UiTapCardKeyFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M4 9.2a1.2 1.2 0 100-2.4 1.2 1.2 0 000 2.4z"
  }), /*#__PURE__*/jsx("path", {
    d: "M15 3H1c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V4c0-.6-.4-1-1-1zm0 7c0 .6-.4 1-1 1s-1-.4-1-1V9h-1v1c0 .6-.4 1-1 1s-1-.4-1-1V9H6.8c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3s1.3-3 3-3c1.3 0 2.4.8 2.8 2H14c.6 0 1 .4 1 1v2z"
  })]
}));

/**
UiTapCardKeyLined icon

```jsx
import { UiTapCardKeyLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTapCardKeyLined />
```

 */
const UiTapCardKeyLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8 11H18c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1s-1-.4-1-1v-1h-1v1c0 .6-.4 1-1 1s-1-.4-1-1v-1h-3.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3s1.3-3 3-3c1.3 0 2.4.8 2.8 2zm-4 1c0 .7.5 1.3 1.2 1.3s1.2-.6 1.2-1.3c0-.6-.5-1.2-1.2-1.2-.6 0-1.2.5-1.2 1.2z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5h18c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2zm0 2v10h18V7H3z"
  })]
}));

/**
UiTemperatureFilled icon

```jsx
import { UiTemperatureFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTemperatureFilled />
```

 */
const UiTemperatureFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M16 10c.6 0 1-.4 1-1s-.4-1-1-1h-1V7h1c.6 0 1-.4 1-1s-.4-1-1-1h-1V4c0-1.7-1.3-3-3-3S9 2.3 9 4v10c-1.2.9-2 2.3-2 4 0 2.8 2.2 5 5 5s5-2.2 5-5c0-1.6-.8-3.1-2-4v-1h1c.6 0 1-.4 1-1s-.4-1-1-1h-1v-1h1zm-4 10c-1.1 0-2-.9-2-2 0-.7.4-1.4 1-1.7V12c0-.6.4-1 1-1s1 .4 1 1v4.3c.6.3 1 1 1 1.7 0 1.1-.9 2-2 2z"
  })
}));

/**
UiTemperatureLined icon

```jsx
import { UiTemperatureLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTemperatureLined />
```

 */
const UiTemperatureLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M13 15.28V11a1 1 0 00-2 0v4.28A2 2 0 0010 17a2 2 0 004 0 2 2 0 00-1-1.72z"
  }), /*#__PURE__*/jsx("path", {
    d: "M17 9a1 1 0 100-2h-1V6h1a1 1 0 100-2h-1.14A4 4 0 008 5v7.55A5.93 5.93 0 006 17a6 6 0 1011.479-2.44A5.93 5.93 0 0016 12.55V12h1a1 1 0 000-2h-1V9h1zm-5 12a4 4 0 01-2.4-7.18A1 1 0 0010 13V5a2 2 0 114 0v8a1 1 0 00.4.8A4 4 0 0112 21z"
  })]
}));

/**
UiThumbsDownFilled icon

```jsx
import { UiThumbsDownFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiThumbsDownFilled />
```

 */
const UiThumbsDownFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22.21 15.91c.52-.5.79-1.16.79-1.91a2.8 2.8 0 00-.79-2c.45-.47.79-1.13.79-2 0-1.04-.44-1.66-.81-2-.14-.12-.28-.22-.42-.3.15-.4.24-.87.2-1.42-.07-1.04-.72-1.71-1.43-2.11.09-.44.05-.96-.2-1.56C19.73 1.16 17.1 1 16 1h-2.76c-2.23 0-4.43.35-6.55 1.05-.41.14-.69.52-.69.95v11c0 .18.05.36.14.51a2.3 2.3 0 00.03.053c.077.131.288.493.57 1.017C8.18 18.27 9 20.61 9 22c0 .55.45 1 1 1 1.61 0 3.5-1.07 3.5-4 0-.58-.22-1.34-.47-2h5.975c.227 0 2.104 0 3.205-1.09zM1 4.02v7.99a2 2 0 002 2h2V2.02H3c-1.1 0-2 .9-2 2z"
  })
}));

/**
UiThumbsDownFilledSmall icon

```jsx
import { UiThumbsDownFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiThumbsDownFilledSmall />
```

 */
const UiThumbsDownFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M11.03 1.11c-7.99 0-7.03 1-7.03 1v7s2.33.79 3 3c.299.992.532 1.698.69 2.175l.1.304c.13.35.53.51.87.35.58-.27 1.33-.99 1.33-2.82v-2h2.99c.32 0 2.09-.61 1.19-2.39 0 0 1.22-.96 0-2.25 0 0 .83-1.24-.63-2.3 0 0 .94-1.94-2.51-2.07zM3 2.109H2c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h1v-7z"
  })
}));

/**
UiThumbsDownLined icon

```jsx
import { UiThumbsDownLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiThumbsDownLined />
```

 */
const UiThumbsDownLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.21 15.91c.52-.5.79-1.16.79-1.91a2.8 2.8 0 00-.79-2c.45-.47.79-1.13.79-2 0-1.04-.44-1.66-.81-2-.14-.12-.28-.22-.42-.3.15-.4.24-.87.2-1.42-.07-1.04-.72-1.71-1.43-2.11.09-.44.05-.96-.2-1.56C19.73 1.16 17.1 1 16 1h-2.76c-2.23 0-4.43.35-6.55 1.05-.41.14-.69.52-.69.95v11c0 .18.05.36.14.51a2.3 2.3 0 00.03.053c.077.131.288.493.57 1.017C8.18 18.27 9 20.61 9 22c0 .55.45 1 1 1 1.61 0 4-1.07 4-4 0-.58-.22-1.34-.47-2h5.475c.227 0 2.104 0 3.205-1.09zM21 10c0 .77-.82.99-.98 1.02-.46.1-.79.52-.79.99.01.47.34.88.8.97.16.04.97.26.97 1.02 0 .21-.06.35-.19.48-.41.41-1.41.52-1.8.52H12c-.35 0-.67.18-.85.48-.18.29-.19.66-.04.97.36.72.89 2.03.89 2.55 0 1.1-.56 1.6-1.11 1.83-.34-2.03-1.44-4.41-2.39-6.19a27.45 27.45 0 00-.39-.712c-.041-.075-.079-.14-.11-.198V3.74A18.9 18.9 0 0113.24 3H16c1.06 0 2.3.23 2.55.47.06.17.07.36-.02.44-.35.23-.49.63-.41 1.03.08.4.43.69.84.76 0 0 .99.21 1.02.72.04.74-.41 1-.41 1-.43.21-.64.7-.51 1.17s.58.77 1.06.72c.15-.01.55.02.73.19.1.09.15.26.15.5z"
  }), /*#__PURE__*/jsx("path", {
    d: "M1 3.9v8.21c0 1.05.9 1.9 2 1.9h2V2H3c-1.1 0-2 .85-2 1.9z"
  })]
}));

/**
UiThumbsUpFilled icon

```jsx
import { UiThumbsUpFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiThumbsUpFilled />
```

 */
const UiThumbsUpFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22.21 8.09c.52.5.79 1.16.79 1.91a2.8 2.8 0 01-.79 2c.45.47.79 1.13.79 2 0 1.04-.44 1.66-.81 2-.14.12-.28.22-.42.3.15.4.24.87.2 1.42-.07 1.04-.72 1.71-1.43 2.11.09.44.05.96-.2 1.56C19.73 22.84 17.1 23 16 23h-2.76c-2.23 0-4.43-.35-6.55-1.05A1.01 1.01 0 016 21V10c0-.18.05-.36.14-.51l.03-.053c.077-.131.288-.493.57-1.017C8.18 5.73 9 3.39 9 2c0-.55.45-1 1-1 1.61 0 3.5 1.07 3.5 4 0 .58-.25 1.34-.5 2h6.005c.227 0 2.104 0 3.205 1.09zM1 19.98v-7.99a2 2 0 012-2h2v11.99H3c-1.1 0-2-.9-2-2z"
  })
}));

/**
UiThumbsUpFilledSmall icon

```jsx
import { UiThumbsUpFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiThumbsUpFilledSmall />
```

 */
const UiThumbsUpFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M11.03 14.89c-7.99 0-7.03-1-7.03-1v-7s2.33-.79 3-3c.299-.992.532-1.698.69-2.176l.1-.304c.13-.35.53-.51.87-.35.58.27 1.33.99 1.33 2.82v2h2.99c.32 0 2.09.61 1.19 2.39 0 0 1.22.96 0 2.25 0 0 .83 1.24-.63 2.3 0 0 .94 1.94-2.51 2.07zm-8.03-1H2c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1h1v7z"
  })
}));

/**
UiThumbsUpLined icon

```jsx
import { UiThumbsUpLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiThumbsUpLined />
```

 */
const UiThumbsUpLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.21 8.09c.52.5.79 1.16.79 1.91a2.8 2.8 0 01-.79 2c.45.47.79 1.13.79 2 0 1.04-.44 1.66-.81 2-.14.12-.28.22-.42.3.15.4.24.87.2 1.42-.07 1.04-.72 1.71-1.43 2.11.09.44.05.96-.2 1.56C19.73 22.84 17.1 23 16 23h-2.76c-2.23 0-4.43-.35-6.55-1.05A1.01 1.01 0 016 21V10c0-.18.05-.36.14-.51l.03-.053c.077-.131.288-.493.57-1.017C8.18 5.73 9 3.39 9 2c0-.55.45-1 1-1 1.61 0 4 1.07 4 4 0 .58-.22 1.34-.47 2h5.475c.227 0 2.104 0 3.205 1.09zM21 14c0-.77-.82-.99-.98-1.02-.46-.1-.79-.52-.79-.99.01-.47.34-.88.8-.97.16-.04.97-.26.97-1.02 0-.21-.06-.35-.19-.48-.41-.41-1.41-.52-1.8-.52H12c-.35 0-.67-.18-.85-.48-.18-.29-.19-.66-.04-.97.36-.72.89-2.03.89-2.55 0-1.1-.56-1.6-1.11-1.83-.34 2.03-1.44 4.41-2.39 6.19a27.4 27.4 0 01-.39.712c-.041.075-.079.14-.11.198v9.99c1.7.49 3.46.74 5.24.74H16c1.06 0 2.3-.23 2.55-.47.06-.17.07-.36-.02-.44-.35-.23-.49-.63-.41-1.03.08-.4.43-.69.84-.76 0 0 .99-.21 1.02-.72.04-.74-.41-1-.41-1a.995.995 0 01-.51-1.17.99.99 0 011.06-.72c.15.01.55-.02.73-.19.1-.09.15-.26.15-.5z"
  }), /*#__PURE__*/jsx("path", {
    d: "M1 20.1v-8.21c0-1.05.9-1.9 2-1.9h2V22H3c-1.1 0-2-.85-2-1.9z"
  })]
}));

/**
UiTicketFilled icon

```jsx
import { UiTicketFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTicketFilled />
```

 */
const UiTicketFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22.62 10.04c.22-.05.38-.26.38-.49V6c0-.55-.45-1-1-1h-6v3c0 .28-.22.5-.5.5S15 8.28 15 8V5H2c-.55 0-1 .45-1 1v3.55c0 .23.16.44.38.48.92.18 1.62 1 1.62 1.97 0 .98-.7 1.79-1.62 1.96-.23.05-.38.25-.38.48V18c0 .55.45 1 1 1h13v-3c0-.28.5-.5.5-.5.28 0 .5.22.5.5v3h6c.55 0 1-.45 1-1v-3.56c0-.23-.15-.43-.38-.48C21.7 13.79 21 12.98 21 12c0-.97.7-1.78 1.62-1.96zM16 13.5c0 .28-.22.5-.5.5 0 0-.5-.22-.5-.5v-3c0-.28.5-.5.5-.5.28 0 .5.22.5.5v3z"
  })
}));

/**
UiTicketFilledSmall icon

```jsx
import { UiTicketFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTicketFilledSmall />
```

 */
const UiTicketFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M15 7c.6 0 1-.4 1-1V4c0-.6-.4-1-1-1h-4v1.5c0 .3-.2.5-.5.5s-.5-.2-.5-.5V3H1c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1s1 .4 1 1-.4 1-1 1-1 .4-1 1v2c0 .6.4 1 1 1h9v-1.5c0-.3.2-.5.5-.5s.5.2.5.5V13h4c.6 0 1-.4 1-1v-2c0-.6-.4-1-1-1s-1-.4-1-1 .4-1 1-1zm-4 0v2c0 .3-.2.5-.5.5S10 9.3 10 9V7c0-.3.2-.5.5-.5s.5.2.5.5z"
  })
}));

/**
UiTicketLined icon

```jsx
import { UiTicketLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTicketLined />
```

 */
const UiTicketLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M15 13.5c0 .28.22.5.5.5s.5-.22.5-.5v-3c0-.28-.22-.5-.5-.5s-.5.22-.5.5v3z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5h20c.55 0 1 .45 1 1v3.55c0 .23-.16.44-.38.49-.92.18-1.62.99-1.62 1.96 0 .98.7 1.79 1.62 1.96.23.05.38.25.38.48V18c0 .55-.45 1-1 1H2c-.55 0-1-.45-1-1v-3.56c0-.23.15-.43.38-.48C2.3 13.79 3 12.98 3 12c0-.97-.7-1.79-1.62-1.97A.485.485 0 011 9.55V6c0-.55.45-1 1-1zm19 3.54V7h-5v1c0 .28-.22.5-.5.5S15 8.28 15 8V7H3v1.54c1.21.69 2 2 2 3.46s-.79 2.77-2 3.46V17h12v-1c0-.28.22-.5.5-.5s.5.22.5.5v1h5v-1.54c-1.21-.69-2-2-2-3.46 0-1.45.79-2.76 2-3.46z"
  })]
}));

/**
UiTrackerFilled icon

```jsx
import { UiTrackerFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTrackerFilled />
```

 */
const UiTrackerFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M19.1 4.9c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4C19.2 7.9 20 9.9 20 12c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-4.1 3.1-7.4 7-7.9v1.5c-3.1.5-5.5 3.2-5.5 6.4 0 3.6 2.9 6.5 6.5 6.5s6.5-2.9 6.5-6.5c0-1.7-.7-3.4-1.9-4.6-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4.9.8 1.3 2 1.3 3.2 0 2.5-2 4.5-4.5 4.5s-4.5-2-4.5-4.5C7.5 9.9 9 8.1 11 7.6v1.6c-1.2.4-2 1.5-2 2.8 0 1.7 1.3 3 3 3s3-1.3 3-3c0-1.3-.8-2.4-2-2.8V2c0-.6-.4-1-1-1s-1 .4-1 1v.1C6 2.6 2 6.8 2 12c0 5.5 4.5 10 10 10s10-4.5 10-10c0-2.7-1-5.2-2.9-7.1z"
  })
}));

/**
UiTrackerLined icon

```jsx
import { UiTrackerLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTrackerLined />
```

 */
const UiTrackerLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M19.1 4.9c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4C19.2 7.9 20 9.9 20 12c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-4.1 3.1-7.4 7-7.9v2C8.2 6.6 6 9 6 12c0 3.3 2.7 6 6 6s6-2.7 6-6c0-1.6-.6-3.1-1.8-4.2-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4.8.7 1.2 1.7 1.2 2.8 0 2.2-1.8 4-4 4s-4-1.8-4-4c0-1.9 1.3-3.4 3-3.9v2.1c-.6.3-1 1-1 1.7 0 1.1.9 2 2 2s2-.9 2-2c0-.7-.4-1.4-1-1.7V2c0-.6-.4-1-1-1s-1 .4-1 1v.1C6 2.6 2 6.8 2 12c0 5.5 4.5 10 10 10s10-4.5 10-10c0-2.7-1-5.2-2.9-7.1z"
  })
}));

/**
UiTrackerLinedSmall icon

```jsx
import { UiTrackerLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTrackerLinedSmall />
```

 */
const UiTrackerLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M13.1 3.2c-.3-.3-.8-.3-1.1 0-.3.3-.3.8 0 1.1.9 1 1.5 2.3 1.5 3.7 0 3-2.5 5.5-5.5 5.5S2.5 11 2.5 8c0-2.8 2.1-5.1 4.8-5.4v1.5C5.4 4.4 4 6.1 4 8c0 2.2 1.8 4 4 4s4-1.8 4-4c0-1-.3-1.9-1-2.6-.2-.3-.7-.3-1-.1-.3.3-.4.8-.1 1.1.4.5.6 1 .6 1.6 0 1.4-1.1 2.5-2.5 2.5S5.5 9.4 5.5 8c0-1.1.7-2.1 1.8-2.4v1.7c-.2.2-.3.5-.3.7 0 .6.4 1 1 1s1-.4 1-1c0-.2-.05-.5-.25-.6V.8C8.85.3 8.4 0 8 0s-.8.3-.8.8V1C3.7 1.4 1 4.4 1 8c0 3.9 3.1 7 7 7s7-3.1 7-7c0-1.8-.7-3.5-1.9-4.8z"
  })
}));

/**
UiTrainFilled icon

```jsx
import { UiTrainFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTrainFilled />
```

 */
const UiTrainFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 6.9c0-1-.6-2-1.6-2.5C17.2 3.8 15.2 3 12 3s-5.2.8-6.4 1.4c-1 .5-1.5 1.5-1.6 2.5V18c0 1 .7 1.8 1.6 2l-1.3 1.3c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0L8.4 20h7.2l2.7 2.7c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4L18.4 20c.9-.2 1.6-1 1.6-2V6.9c0 .1 0 0 0 0zM18 17c0 .6-.4 1-1 1s-1-.4-1-1 .4-1 1-1 1 .4 1 1zM8 17c0 .6-.4 1-1 1s-1-.4-1-1 .4-1 1-1 1 .4 1 1zm10-9v5h-5V8h5zM6 8h5v5H6V8z"
  })
}));

/**
UiTrainFilledSmall icon

```jsx
import { UiTrainFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTrainFilledSmall />
```

 */
const UiTrainFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12.8.5C11.3.2 9.7 0 8 0 6.3 0 4.7.2 3.2.5 1.9.9 1 2.1 1 3.4V12c0 1 .7 1.8 1.6 2l-.3.3c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0L5.4 14h5.2l1.7 1.7c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4l-.3-.3c.9-.2 1.6-1 1.6-2V3.4c0-1.3-.9-2.5-2.2-2.9zM13 11c0 .6-.4 1-1 1s-1-.4-1-1 .4-1 1-1 1 .4 1 1zm-8 0c0 .6-.4 1-1 1s-1-.4-1-1 .4-1 1-1 1 .4 1 1zM3 5h10v3H3V5z"
  })
}));

/**
UiTrainLined icon

```jsx
import { UiTrainLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTrainLined />
```

 */
const UiTrainLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M8 17a1 1 0 100-2 1 1 0 000 2zm9-1a1 1 0 11-2 0 1 1 0 012 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4 4.4C17.2 3.8 15.2 3 12 3s-5.2.8-6.4 1.4C4.6 4.9 4 5.9 4 7v11c0 1 .7 1.8 1.6 2l-1.3 1.3c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0L8.4 20h7.2l2.7 2.7c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4L18.4 20c.9-.2 1.6-1 1.6-2V7c0-1.1-.6-2.1-1.6-2.6zM6 12V9h5v3H6zm7-3h5v3h-5V9zM6.5 6.2C7.5 5.6 9.2 5 12 5s4.5.6 5.5 1.2c.3.1.5.4.5.8H6c0-.4.2-.7.5-.8zM6 18v-4h12v4H6z"
  })]
}));

/**
UiTrainLinedSmall icon

```jsx
import { UiTrainLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTrainLinedSmall />
```

 */
const UiTrainLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M5 11a1 1 0 100-2 1 1 0 000 2zm7-1a1 1 0 11-2 0 1 1 0 012 0z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8.5C11.3.2 9.7 0 8 0 6.3 0 4.7.2 3.2.5 1.9.9 1 2.1 1 3.4V12c0 1 .7 1.8 1.6 2l-.3.3c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0L5.4 14h5.2l1.7 1.7c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4l-.3-.3c.9-.2 1.6-1 1.6-2V3.4c0-1.3-.9-2.5-2.2-2.9zm-9.1 2C4.6 2.3 6 2 8 2s3.4.3 4.3.5c.4.1.7.5.7.9V4H3v-.6c0-.4.3-.8.7-.9zM3 12V8h10v4H3z"
  })]
}));

/**
UiTransferLined icon

```jsx
import { UiTransferLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTransferLined />
```

 */
const UiTransferLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M5 9h12.8l-1.5 1.2c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l3.1-3c.1-.2.2-.4.2-.6 0-.1 0-.3-.2-.5 0-.1-.1-.2-.2-.3l-3-3c-.4-.3-1-.3-1.4.1-.3.4-.3 1 .1 1.4L17.8 7H5c-.5 0-1 .4-1 1s.5 1 1 1zm14 6H6.2l1.5-1.2c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-3.1 3c-.1.2-.2.4-.2.6 0 .1 0 .3.2.5 0 .1.1.2.2.3l3 3c.4.3 1 .3 1.4-.1.3-.4.3-1-.1-1.4L6.2 17H19c.5 0 1-.4 1-1s-.5-1-1-1z"
  })
}));

/**
UiTransferLinedSmall icon

```jsx
import { UiTransferLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTransferLinedSmall />
```

 */
const UiTransferLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M3 6.004h8.7l-.9.699c-.4.399-.4.998 0 1.397s1 .399 1.4 0l2.6-2.495c.1-.2.2-.399.2-.599 0-.1 0-.299-.2-.499 0-.1-.1-.2-.2-.299l-2.5-2.495c-.4-.299-1-.299-1.4.1-.3.4-.3.998.1 1.397l.9.79H3a1.001 1.001 0 000 2.004zm10 3.997H4.3l1-.804c.4-.399.4-.998 0-1.397s-1-.399-1.4 0l-2.6 2.495c-.2.2-.3.4-.3.699 0 .1 0 .299.1.399 0 .1.1.2.3.399l2.5 2.495c.4.299 1 .299 1.4-.1.3-.4.3-.998-.1-1.397L4.3 12H13c.5 0 1-.409 1-1.007 0-.6-.5-.993-1-.993z"
  })
}));

/**
UiTransmissionLined icon

```jsx
import { UiTransmissionLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTransmissionLined />
```

 */
const UiTransmissionLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 25,
  viewBox: "0 0 24 25",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M21 5.012a2 2 0 10-3 1.72v3.28a1 1 0 01-1 1h-4v-4.28a2 2 0 10-2 0v4.28H6v-4.28a2 2 0 10-2 0v10.56a2 2 0 102 0v-4.28h5v4.28a2 2 0 102 0v-4.28h4a3 3 0 003-3v-3.28a2 2 0 001-1.72z"
  })
}));

/**
UiTrashFilled icon

```jsx
import { UiTrashFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTrashFilled />
```

 */
const UiTrashFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 5H20c.55 0 1 .45 1 1s-.45 1-1 1H4c-.55 0-1-.45-1-1s.45-1 1-1h4.5V3c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v2zm-2-2h-3v2h3V3z"
  }), /*#__PURE__*/jsx("path", {
    d: "M7.89 22c-1.06 0-1.94-.82-2-1.88L5.24 9h13.53l-.65 11.12a2.01 2.01 0 01-2 1.88H7.89z"
  })]
}));

/**
UiTrashFilledSmall icon

```jsx
import { UiTrashFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTrashFilledSmall />
```

 */
const UiTrashFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6c-.55 0-1-.45-1-1s.45-1 1-1h3V2c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v2h3c.55 0 1 .45 1 1s-.45 1-1 1H2zm7-4H7v2h2V2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M2.96 14.1L2.65 7h10.71l-.3 7.1c-.05 1.07-.93 1.9-2 1.9h-6.1c-1.07 0-1.95-.83-2-1.9z"
  })]
}));

/**
UiTrashLined icon

```jsx
import { UiTrashLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTrashLined />
```

 */
const UiTrashLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 5h-4.5V3c0-1.1-.9-2-2-2h-3c-1.1 0-2 .9-2 2v2H4c-.55 0-1 .45-1 1s.45 1 1 1h1.12l.77 13.12c.06 1.06.94 1.88 2 1.88h8.23c1.06 0 1.93-.83 2-1.88L18.88 7H20c.55 0 1-.45 1-1s-.45-1-1-1zm-9.5-2h3v2h-3V3zm5.61 17H7.89L7.12 7h9.76l-.77 13z"
  })
}));

/**
UiTrashLinedSmall icon

```jsx
import { UiTrashLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTrashLinedSmall />
```

 */
const UiTrashLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14 4h-3V2c0-1.1-.9-2-2-2H7C5.9 0 5 .9 5 2v2H2c-.55 0-1 .45-1 1s.45 1 1 1h.55l.4 8.1c.05 1.07.93 1.9 2 1.9h6.1a2 2 0 002-1.9l.4-8.1H14c.55 0 1-.45 1-1s-.45-1-1-1zM7 2h2v2H7V2zm4.05 12h-6.1l-.4-8h6.9l-.4 8z"
  })
}));

/**
UiTrophyFilled icon

```jsx
import { UiTrophyFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTrophyFilled />
```

 */
const UiTrophyFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 5h-2V3c0-.6-.4-1-1-1H7c-.6 0-1 .4-1 1v2H4c-1.1 0-2 .9-2 2v1c0 2.7 1.8 5 4.3 5.7.7 2.2 2.5 3.8 4.7 4.2V20H9c-.6 0-1 .4-1 1s.4 1 1 1h6c.6 0 1-.4 1-1s-.4-1-1-1h-2v-2.1c2.3-.4 4.1-2 4.7-4.2 2.5-.7 4.3-3 4.3-5.7V7c0-1.1-.9-2-2-2zM4 8V7h2v4.4C4.8 10.8 4 9.5 4 8zm16 0c0 1.5-.8 2.8-2 3.4V7h2v1z"
  })
}));

/**
UiTrophyFilledSmall icon

```jsx
import { UiTrophyFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTrophyFilledSmall />
```

 */
const UiTrophyFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M15 3h-3V2c0-.6-.4-1-1-1H5c-.6 0-1 .4-1 1v1H1c-.6 0-1 .4-1 1v2c0 2.2 1.8 4 4 4h.6c.5.9 1.4 1.6 2.4 1.9V13H6c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1H9v-1.1c1-.3 1.9-.9 2.4-1.9h.6c2.2 0 4-1.8 4-4V4c0-.6-.4-1-1-1zM4 8c-1.1 0-2-.9-2-2V5h2v3zm10-2c0 1.1-.9 2-2 2V5h2v1z"
  })
}));

/**
UiTrophyLined icon

```jsx
import { UiTrophyLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTrophyLined />
```

 */
const UiTrophyLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 5h-2V3c0-.6-.4-1-1-1H7c-.6 0-1 .4-1 1v2H4c-1.1 0-2 .9-2 2v1c0 2.7 1.8 5 4.3 5.7.7 2.2 2.5 3.8 4.7 4.2V20H9c-.6 0-1 .4-1 1s.4 1 1 1h6c.6 0 1-.4 1-1s-.4-1-1-1h-2v-2.1c2.3-.4 4.1-2 4.7-4.2 2.5-.7 4.3-3 4.3-5.7V7c0-1.1-.9-2-2-2zm-4 7c0 2.2-1.8 4-4 4s-4-1.8-4-4V4h8v8zM4 8V7h2v4.4C4.8 10.8 4 9.5 4 8zm16 0c0 1.5-.8 2.8-2 3.4V7h2v1z"
  })
}));

/**
UiTrophyLinedSmall icon

```jsx
import { UiTrophyLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTrophyLinedSmall />
```

 */
const UiTrophyLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M15 3h-3V2c0-.6-.4-1-1-1H5c-.6 0-1 .4-1 1v1H1c-.6 0-1 .4-1 1v2c0 2.2 1.8 4 4 4h.6c.5.9 1.4 1.6 2.4 1.9V13H6c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1-.4 1-1s-.4-1-1-1H9v-1.1c1-.3 1.9-.9 2.4-1.9h.6c2.2 0 4-1.8 4-4V4c0-.6-.4-1-1-1zm-5 5c0 1.1-.9 2-2 2s-2-.9-2-2V3h4v5zM4 8c-1.1 0-2-.9-2-2V5h2v3zm10-2c0 1.1-.9 2-2 2V5h2v1z"
  })
}));

/**
UiTwitterFilled icon

```jsx
import { UiTwitterFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiTwitterFilled />
```

 */
const UiTwitterFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M21.88 5.41a.495.495 0 00-.58-.14c-.2.09-.41.14-.63.19.36-.5.62-1.05.78-1.53.06-.2 0-.41-.16-.54a.496.496 0 00-.57-.04c-.65.37-1.34.64-2.07.81-.8-.74-1.88-1.16-3-1.16-2.43 0-4.4 1.92-4.4 4.29 0 .11 0 .22.01.32-2.75-.29-5.3-1.63-7.06-3.73-.1-.13-.26-.2-.42-.18-.16.01-.3.1-.39.24-.41.69-.6 1.7-.6 2.4 0 .79.22 1.56.63 2.21-.13-.04-.29 0-.41.07-.15.09-.25.28-.25.45 0 1.33.63 2.54 1.64 3.34-.05.03-.1.07-.15.12-.12.13-.15.31-.1.48.43 1.32 1.48 2.32 2.78 2.75-1.07.56-2.26.86-3.5.86-.3 0-.88-.05-.89-.05-.21-.01-.39.08-.48.25-.09.17-.08.38.04.54.08.1 2.08 2.64 6.37 2.64 7.16 0 11.59-6.14 11.59-11.82v-.25A8.27 8.27 0 0021.91 6c.13-.18.12-.42-.03-.59z"
  })
}));

/**
UiUmbrellaFilled icon

```jsx
import { UiUmbrellaFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiUmbrellaFilled />
```

 */
const UiUmbrellaFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M13 3.1c0-.7-.4-1.1-1-1.1s-1 .4-1 1v.1C6 3.6 2 7.8 2 13c0 .6.4 1 1 1h8v6c0 .6-.4 1-1 1s-1-.4-1-1-.4-1-1-1-1 .4-1 1c0 1.7 1.3 3 3 3s3-1.3 3-3v-6h8c.6 0 1-.4 1-1 0-5.2-4-9.4-9-9.9z"
  })
}));

/**
UiUmbrellaFilledSmall icon

```jsx
import { UiUmbrellaFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiUmbrellaFilledSmall />
```

 */
const UiUmbrellaFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M8.998 1.062L9 1a1 1 0 10-1.998.062C3.068 1.558 0 4.938 0 9c0 .6.4 1 1 1h6v3c0 .6-.4 1-1 1s-1-.4-1-1-.4-1-1-1-1 .4-1 1c0 1.7 1.3 3 3 3s3-1.3 3-3v-3h6c.6 0 1-.4 1-1 0-4.062-3.068-7.442-7.002-7.938z"
  })
}));

/**
UiUmbrellaLined icon

```jsx
import { UiUmbrellaLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiUmbrellaLined />
```

 */
const UiUmbrellaLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M13 3.1c0-.7-.4-1.1-1-1.1s-1 .4-1 1v.1C6 3.6 2 7.8 2 13c0 .6.4 1 1 1h8v6c0 .6-.4 1-1 1s-1-.4-1-1-.4-1-1-1-1 .4-1 1c0 1.7 1.3 3 3 3s3-1.3 3-3v-6h8c.6 0 1-.4 1-1 0-5.2-4-9.4-9-9.9zM4.1 12c.5-3.9 3.8-7 7.9-7 4.1 0 7.4 3.1 7.9 7H4.1z"
  })
}));

/**
UiUmbrellaLinedSmall icon

```jsx
import { UiUmbrellaLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiUmbrellaLinedSmall />
```

 */
const UiUmbrellaLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.998 1.062L9 1a1 1 0 10-1.998.062C3.068 1.558 0 4.938 0 9c0 .6.4 1 1 1h6v3c0 .6-.4 1-1 1s-1-.4-1-1-.4-1-1-1-1 .4-1 1c0 1.7 1.3 3 3 3s3-1.3 3-3v-3h6c.6 0 1-.4 1-1 0-4.062-3.068-7.442-7.002-7.938zM13.9 8C13.4 5.2 11 3 8 3 5 3 2.6 5.2 2.1 8h11.8z"
  })
}));

/**
UiUndoLined icon

```jsx
import { UiUndoLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiUndoLined />
```

 */
const UiUndoLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14.5 6H6.41L8.2 4.21A.996.996 0 106.79 2.8l-3.5 3.5a.996.996 0 000 1.41l3.5 3.5c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 000-1.41L6.41 8h8.09c2.48 0 4.5 2.02 4.5 4.5S16.98 17 14.5 17H8c-.55 0-1 .45-1 1s.45 1 1 1h6.5c3.58 0 6.5-2.92 6.5-6.5S18.08 6 14.5 6z"
  })
}));

/**
UiUndoLinedSmall icon

```jsx
import { UiUndoLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiUndoLinedSmall />
```

 */
const UiUndoLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M10.5 4.75H4.41l.79-.79a.996.996 0 10-1.41-1.41l-2.5 2.5a.996.996 0 000 1.41l2.5 2.5c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 000-1.41l-.8-.8h6.09a2.5 2.5 0 010 5H5c-.55 0-1 .45-1 1s.45 1 1 1h5.5c2.48 0 4.5-2.02 4.5-4.5s-2.02-4.5-4.5-4.5z"
  })
}));

/**
UiUploadLined icon

```jsx
import { UiUploadLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiUploadLined />
```

 */
const UiUploadLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12.4 2.1c.1 0 .2.1.3.2l4 4c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0L13 5.4V15c0 .6-.4 1-1 1s-1-.4-1-1V5.4L8.7 7.7c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l4-4c.05-.05.1-.075.15-.1.05-.025.1-.05.15-.1.1-.1.3-.1.4-.1.1 0 .3 0 .4.1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M19 16c0-.6.4-1 1-1s1 .4 1 1v3c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-3c0-.6.4-1 1-1s1 .4 1 1v3h14v-3z"
  })]
}));

/**
UiUploadLinedSmall icon

```jsx
import { UiUploadLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiUploadLinedSmall />
```

 */
const UiUploadLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M8.4.1c.1 0 .2.1.3.2l3 3c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0L9 3.25V10c0 .6-.4 1-1 1s-1-.4-1-1V3.25L5.7 4.7c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l3-3c.05-.05.1-.075.15-.1.05-.025.1-.05.15-.1.1-.1.3-.1.4-.1.1 0 .3 0 .4.1z"
  }), /*#__PURE__*/jsx("path", {
    d: "M13 11c0-.6.4-1 1-1s1 .4 1 1v3c0 .6-.4 1-1 1H2c-.6 0-1-.4-1-1v-3c0-.6.4-1 1-1s1 .4 1 1v2h10v-2z"
  })]
}));

/**
UiUtilitiesFilled icon

```jsx
import { UiUtilitiesFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiUtilitiesFilled />
```

 */
const UiUtilitiesFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M13.64 7H18c1.21 0 3 .8 3 3v5c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-3h-2.36c-.38.5-1.12 1-2.64 1s-2.27-.5-2.64-1H4c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h4.36c.28-.37.77-.75 1.64-.91V5H7c-.55 0-1-.45-1-1s.45-1 1-1h3c0-.55.45-1 1-1s1 .45 1 1h3c.55 0 1 .45 1 1s-.45 1-1 1h-3v1.09c.87.16 1.36.54 1.64.91zm4.86 10s-3 3-2.5 5c.24.97 1.25 2 2.5 2s2.26-1.03 2.5-2c.5-2-2.5-5-2.5-5z"
  })
}));

/**
UiUtilitiesFilledSmall icon

```jsx
import { UiUtilitiesFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiUtilitiesFilledSmall />
```

 */
const UiUtilitiesFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M11.5 14.5c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5S13 12 13 12s-1.5 1.7-1.5 2.5zM12 5H9.2c-.3-.4-.7-.6-1.2-.8V4h2c.6 0 1-.4 1-1s-.4-1-1-1H8c0-.6-.4-1-1-1s-1 .4-1 1H4c-.6 0-1 .4-1 1s.4 1 1 1h2v.2c-.5.2-.9.4-1.2.8H2c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h2.8c.5.6 1.3 1 2.2 1 .9 0 1.7-.4 2.2-1H11v1c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V8c0-1.7-1.3-3-3-3z"
  })
}));

/**
UiUtilitiesLined icon

```jsx
import { UiUtilitiesLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiUtilitiesLined />
```

 */
const UiUtilitiesLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M18.006 17s-3 3-2.5 5c.24.97 1.25 2 2.5 2s2.26-1.03 2.5-2c.5-2-2.5-5-2.5-5zM18 7h-4.36c-.28-.37-.77-.75-1.64-.91V5h3c.55 0 1-.45 1-1s-.45-1-1-1h-3c0-.55-.45-1-1-1s-1 .45-1 1H7c-.55 0-1 .45-1 1s.45 1 1 1h3v1.09c-.87.16-1.36.54-1.64.91H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h4.36c.37.5 1.12 1 2.64 1s2.26-.5 2.64-1H15v2c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-5c0-2.2-1.79-3-3-3zm1 7h-2v-2c0-.55-.45-1-1-1h-3c-.49 0-.89.35-.98.81-.08.06-.34.19-1.02.19-.68 0-.94-.13-1.02-.19A.998.998 0 009 11H5V9h4c.49 0 .89-.35.98-.81.08-.06.34-.19 1.02-.19.68 0 .94.13 1.02.19.09.46.49.81.98.81h4.99c.46.01 1.01.19 1.01 1v4z"
  })
}));

/**
UiUtilitiesLinedSmall icon

```jsx
import { UiUtilitiesLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiUtilitiesLinedSmall />
```

 */
const UiUtilitiesLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 5H9.4c-.4-.4-.9-.7-1.4-.8V4h2c.6 0 1-.4 1-1s-.4-1-1-1H8c0-.6-.4-1-1-1s-1 .4-1 1H4c-.6 0-1 .4-1 1s.4 1 1 1h2v.2c-.5.1-1 .4-1.4.8H2c-.6 0-1 .4-1 1v3c0 .6.4 1 1 1h2.6c1.3 1.3 3.6 1.3 4.9 0h.5v1c0 .6.4 1 1 1h1.5S11 13.7 11 14.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-1.5-2.5-1.5-2.5H14c.6 0 1-.4 1-1V8c0-1.7-1.3-3-3-3zm1 5h-1V9c0-.6-.4-1-1-1H9c-.3 0-.6.1-.8.4-.6.8-1.8.8-2.4 0-.2-.3-.5-.4-.8-.4H3V7h2c.3 0 .6-.1.8-.4.6-.8 1.8-.8 2.4 0 .2.3.5.4.8.4h3c.6 0 1 .4 1 1v2z"
  })
}));

/**
UiVendorFilled icon

```jsx
import { UiVendorFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiVendorFilled />
```

 */
const UiVendorFilled = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M6.31 7.84c-.2.07-.43.07-.63 0L2.42 6.75l1.65-4.12A1 1 0 015 2h2.84l-.8 5.6-.73.24zm2.83-.72c.28.01.55.05.81.14l1.73.58c.2.07.43.07.63 0l1.74-.58c.26-.09.54-.13.81-.14L14.13 2H9.86l-.72 5.12zm7.81.48l.73.24c.2.07.43.07.63 0l2.37-.79.89-.32-1.64-4.1A1 1 0 0019 2h-2.85l.8 5.6zm2 2.14c-.61.2-1.29.2-1.9 0l-1.74-.58a.971.971 0 00-.63 0l-1.74.58c-.61.2-1.29.2-1.9 0l-1.73-.58a.971.971 0 00-.63 0l-1.73.58a3.092 3.092 0 01-1.9 0L4 9.39V21c0 .55.45 1 1 1h3v-8.1c0-.5.45-.9 1-.9h6c.55 0 1 .4 1 .9V22h3c.55 0 1-.45 1-1V9.39l-1.05.35z"
  }), /*#__PURE__*/jsx("path", {
    d: "M10 14.8h4V22h-4v-7.2z"
  })]
}));

/**
UiVendorFilledSmall icon

```jsx
import { UiVendorFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiVendorFilledSmall />
```

 */
const UiVendorFilledSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M3.8 4.6l-.4.2c-.3.1-.6.1-.9 0L.3 3.7 1 .8c.1-.5.5-.8 1-.8h3l-.9 4.5c-.05 0-.1.025-.15.05-.05.025-.1.05-.15.05zm8.2-.1c.043 0 .067 0 .089.008.03.01.054.035.111.092l.4.2c.3.1.6.1.9 0l2.2-1.1L15 .8c-.1-.4-.5-.8-1-.8h-3l.9 4.5h.1zm-.4 2l-.3-.1c-.2-.1-.5-.1-.8 0l-1.6.4c-.3.1-.6.2-.9.2-.3 0-.6 0-1-.1l-1.6-.6c-.2-.1-.5-.1-.8 0l-.3.2c-.8.5-1.8.5-2.7 0L1 6.2V15c0 .5.5 1 1 1h3v-6c0-.6.4-1 1-1h4c.6 0 1 .4 1 1v6h3c.5 0 1-.5 1-1V6.2l-.7.3c-.8.5-1.8.5-2.7 0zM8.3 4.9l1.5-.5L9 0H7l-.9 4.4 1.5.5c.3.1.5.1.7 0z"
  }), /*#__PURE__*/jsx("path", {
    d: "M7 16v-5h2v5H7z"
  })]
}));

/**
UiVendorLined icon

```jsx
import { UiVendorLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiVendorLined />
```

 */
const UiVendorLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M19.93 2.63A1 1 0 0019 2H5a1 1 0 00-.93.63l-2 5c-.1.26-.09.54.02.79.12.25.33.44.59.53L4 9.39V21c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V9.39l1.32-.44a.997.997 0 00.61-1.32l-2-5zm-.25 4.76l-1.36.45c-.2.07-.43.07-.63 0l-1.74-.58c-.03-.01-.05-.01-.08-.02L15.22 4h3.1l1.36 3.39zM10.82 4h2.36l.67 3.33-1.53.51c-.2.07-.43.07-.63 0l-1.54-.51.67-3.33zM5.68 4h3.1l-.65 3.24c-.02.01-.05.01-.08.02l-1.73.58c-.2.07-.43.07-.63 0l-1.37-.45L5.68 4zM10 20v-6h4v6h-4zm6 0v-7c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v7H6V9.89c.32 0 .64-.05.95-.15l1.73-.58c.2-.07.43-.07.63 0l1.73.58c.61.2 1.29.2 1.9 0l1.74-.58c.2-.07.43-.07.63 0l1.74.58c.31.1.63.15.95.15V20h-2z"
  })
}));

/**
UiVendorLinedSmall icon

```jsx
import { UiVendorLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiVendorLinedSmall />
```

 */
const UiVendorLinedSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M15.97 4.76l-1-4A.995.995 0 0014 0H2c-.46 0-.86.31-.97.76l-1 4c-.11.45.1.93.52 1.14l.45.22V15c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6.12l.45-.22c.42-.22.63-.69.52-1.14zm-2.13-.3l-.39.19c-.28.14-.61.14-.89 0l-.37-.18c-.1-.05-.21-.08-.32-.12L11.28 2h1.94l.62 2.46zM6.78 2h2.44l.59 2.34-1.49.5c-.2.07-.43.07-.63 0l-1.49-.5L6.78 2zm-4 0h1.94l-.59 2.36c-.11.04-.22.07-.32.12l-.36.18c-.28.14-.61.14-.89 0l-.4-.2L2.78 2zM9 14H7v-4h2v4zm2 0V8.99c0-.55-.44-.99-.99-.99H5.99c-.55 0-.99.44-.99.99V14H3V6.76c.46 0 .92-.1 1.34-.31l.37-.18a.96.96 0 01.76-.05l1.58.53c.31.09.63.14.95.14.32 0 .64-.05.95-.15l1.58-.53c.25-.08.53-.06.76.05l.37.18c.42.21.88.31 1.34.31V14h-2z"
  })
}));

/**
UiVinFilled icon

```jsx
import { UiVinFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiVinFilled />
```

 */
const UiVinFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 5H4a3 3 0 00-3 3v8a3 3 0 003 3h16a3 3 0 003-3V8a3 3 0 00-3-3zM9.45 10.72l-1.5 3a.5.5 0 01-.9 0l-1.5-3a.5.5 0 11.9-.44l1 2.1 1.05-2.1a.501.501 0 01.9.44h.05zM12 13.5a.5.5 0 01-1 0v-3a.5.5 0 011 0v3zm6 0a.5.5 0 01-.31.46.429.429 0 01-.19 0 .469.469 0 01-.35-.15L15 11.71v1.79a.5.5 0 01-1 0v-3a.5.5 0 01.31-.46.47.47 0 01.54.11L17 12.29V10.5a.5.5 0 011 0v3z"
  })
}));

/**
UiVinLined icon

```jsx
import { UiVinLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiVinLined />
```

 */
const UiVinLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M20 5H4a3 3 0 00-3 3v8a3 3 0 003 3h16a3 3 0 003-3V8a3 3 0 00-3-3zm1 11a1 1 0 01-1 1H4a1 1 0 01-1-1V8a1 1 0 011-1h16a1 1 0 011 1v8z"
  }), /*#__PURE__*/jsx("path", {
    d: "M11.5 10a.5.5 0 00-.5.5v3a.5.5 0 001 0v-3a.5.5 0 00-.5-.5zm6 0a.5.5 0 00-.5.5v1.79l-2.15-2.14a.48.48 0 00-.54-.11.5.5 0 00-.31.46v3a.5.5 0 001 0v-1.79l2.15 2.14a.47.47 0 00.35.15.429.429 0 00.19 0 .5.5 0 00.31-.5v-3a.5.5 0 00-.5-.5zm-8.28.05a.51.51 0 00-.67.23l-1.05 2.1-1-2.1a.501.501 0 00-.9.44l1.5 3a.5.5 0 00.9 0l1.5-3a.51.51 0 00-.28-.67z"
  })]
}));

/**
UiVirtualNumberFilled icon

```jsx
import { UiVirtualNumberFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiVirtualNumberFilled />
```

 */
const UiVirtualNumberFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M20 4H4C2.34 4 1 5.34 1 7v10c0 1.66 1.34 3 3 3h11.56c-.54 2.08 2.26 3.44 3.54 1.7l1.31-1.74A2.98 2.98 0 0023 17V7c0-1.66-1.34-3-3-3zM3 11V8h18v3H3zm6 5H5c-1.31-.02-1.31-1.97 0-2h4c1.31.02 1.31 1.97 0 2zm8.5 5c-.3.01-.55-.29-.49-.58l.4-2.42H15.5c-.4 0-.63-.48-.4-.8l3-4a.5.5 0 01.6-.16c.21.09.33.31.3.54L18.6 16h1.91c.4 0 .63.48.4.8l-3 4a.54.54 0 01-.41.2z"
  })
}));

/**
UiVirtualNumberFilledSmall icon

```jsx
import { UiVirtualNumberFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiVirtualNumberFilledSmall />
```

 */
const UiVirtualNumberFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M14 2H2C.9 2 0 2.9 0 4v8c0 1.1.9 2 2 2h8.5a2.001 2.001 0 002 2c.69 0 1.35-.36 1.71-.97l.79-1.31c.59-.35 1-.99 1-1.72V4c0-1.1-.9-2-2-2zM1 7V5h14v2H1zm5.5 4h-3c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h3c.28 0 .5.22.5.5s-.22.5-.5.5zm6 3.5c-.04 0-.09-.01-.13-.02A.501.501 0 0112 14v-2h-1a.52.52 0 01-.44-.25.474.474 0 01.01-.5l1.5-2.5c.12-.19.34-.29.56-.22.22.06.37.26.37.48v2h1c.18 0 .35.1.44.25.09.16.09.35-.01.5l-1.5 2.5c-.09.15-.26.24-.43.24z"
  })
}));

/**
UiVirtualNumberLined icon

```jsx
import { UiVirtualNumberLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiVirtualNumberLined />
```

 */
const UiVirtualNumberLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M20 4H4C2.35 4 1 5.35 1 7v10c0 1.65 1.35 3 3 3h8.5c1.3-.01 1.31-1.99 0-2H4c-.55 0-1-.45-1-1v-5h18v2.5c0 1.31 1.99 1.31 2 0V7c0-1.65-1.35-3-3-3zM3 8V7c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v1H3z"
  }), /*#__PURE__*/jsx("path", {
    d: "M20.99 17.47c.01-.26-.24-.47-.49-.47h-1.91l.4-2.42a.486.486 0 00-.3-.54.51.51 0 00-.6.16l-3 4c-.23.32 0 .8.4.8h1.91l-.4 2.42c-.1.5.6.8.89.38l3-4c.06-.1.12-.21.1-.33zM6 14c-1.31 0-1.31 1.99 0 2h4c1.31 0 1.31-1.99 0-2H6z"
  })]
}));

/**
UiVirtualNumberLinedSmall icon

```jsx
import { UiVirtualNumberLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiVirtualNumberLinedSmall />
```

 */
const UiVirtualNumberLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M13 12h-1v-2c0-.22-.15-.42-.37-.48a.493.493 0 00-.56.22l-1.5 2.5c-.09.15-.09.35-.01.5.09.16.26.26.44.26h1v2c0 .22.15.42.37.48.04.01.09.02.13.02.17 0 .34-.09.43-.24l1.5-2.5c.09-.15.09-.35.01-.5A.509.509 0 0013 12z"
  }), /*#__PURE__*/jsx("path", {
    d: "M14 2H2C.9 2 0 2.9 0 4v8c0 1.1.9 2 2 2h5c.55 0 1-.45 1-1s-.45-1-1-1H2V8h12v2.5c0 .55.45 1 1 1s1-.45 1-1V4c0-1.1-.9-2-2-2zM2 5V4h12v1H2z"
  }), /*#__PURE__*/jsx("path", {
    d: "M3.5 10c-.28 0-.5.22-.5.5s.22.5.5.5h3c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-3z"
  })]
}));

/**
UiWalletFilled icon

```jsx
import { UiWalletFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiWalletFilled />
```

 */
const UiWalletFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M18 3H6C4.3 3 3 4.3 3 6v12c0 1.7 1.3 3 3 3h12c1.7 0 3-1.3 3-3V6c0-1.7-1.3-3-3-3zM6 5h12c.6 0 1 .4 1 1v1.2c-.3-.1-.6-.2-1-.2H6c-.4 0-.7.1-1 .2V6c0-.6.4-1 1-1zm13 6h-4c-.6 0-1 .4-1 1 0 1.1-.9 2-2 2s-2-.9-2-2c0-.6-.4-1-1-1H5v-1c0-.6.4-1 1-1h12c.6 0 1 .4 1 1v1z"
  })
}));

/**
UiWalletFilledSmall icon

```jsx
import { UiWalletFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiWalletFilledSmall />
```

 */
const UiWalletFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 1H4C2.3 1 1 2.3 1 4v8c0 1.7 1.3 3 3 3h8c1.7 0 3-1.3 3-3V4c0-1.7-1.3-3-3-3zM4 3h8c.6 0 1 .4 1 1v1.2c-.3-.1-.6-.2-1-.2H4c-.4 0-.7.1-1 .2V4c0-.6.4-1 1-1zM3 8c0-.6.4-1 1-1h8c.6 0 1 .4 1 1v1h-2.5c-.6 0-1 .4-1 1 0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5c0-.6-.4-1-1-1H3V8z"
  })
}));

/**
UiWalletLined icon

```jsx
import { UiWalletLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiWalletLined />
```

 */
const UiWalletLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M18 3H6C4.3 3 3 4.3 3 6v12c0 1.7 1.3 3 3 3h12c1.7 0 3-1.3 3-3V6c0-1.7-1.3-3-3-3zM6 5h12c.6 0 1 .4 1 1v1.2c-.3-.1-.6-.2-1-.2H6c-.4 0-.7.1-1 .2V6c0-.6.4-1 1-1zm-1 5c0-.6.4-1 1-1h12c.6 0 1 .4 1 1v1h-5c-.6 0-1 .4-1 1s-.4 1-1 1-1-.4-1-1-.4-1-1-1H5v-1zm13 9H6c-.6 0-1-.4-1-1v-5h4.2c.4 1.2 1.5 2 2.8 2 1.3 0 2.4-.8 2.8-2H19v5c0 .6-.4 1-1 1z"
  })
}));

/**
UiWalletPassFilled icon

```jsx
import { UiWalletPassFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiWalletPassFilled />
```

 */
const UiWalletPassFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M17 1H7C5.35 1 4 2.35 4 4v16c0 1.65 1.35 3 3 3h10c1.65 0 3-1.35 3-3V4c0-1.65-1.35-3-3-3zM8.41 6.85l.07-.22c.08-.17.17-.34.27-.5h.2c3.22-.28 6.11-.15 6.83.72.73.87-.78 2.41-3.1 4.02-.8.58-1.63 1.12-2.49 1.61l-.13-.07c-.11-.09-.22-.18-.32-.28l.51-.42c1.38-1.15 3.02-2.78 2.04-3.8-.63-.66-2.1-.97-3.88-.97a.139.139 0 010-.09zM13.5 19h-5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h5c.28 0 .5.22.5.5s-.22.5-.5.5zm2-2h-7c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h7c.28 0 .5.22.5.5s-.22.5-.5.5z"
  })
}));

/**
UiWalletPassFilledSmall icon

```jsx
import { UiWalletPassFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiWalletPassFilledSmall />
```

 */
const UiWalletPassFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M12 0H4C2.9 0 2 .9 2 2v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zM5 4.66l.05-.17c.07-.14.14-.26.21-.39h.15c2.49-.21 4.71-.11 5.28.56.56.67-.6 1.86-2.39 3.1-.62.44-1.26.86-1.92 1.24l-.1-.05c-.09-.07-.17-.14-.25-.22l.39-.32C7.49 7.53 8.76 6.26 8 5.48c-.49-.51-1.62-.75-3-.75v-.07zM10.5 12h-5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h5c.28 0 .5.22.5.5s-.22.5-.5.5z"
  })
}));

/**
UiWalletPassLined icon

```jsx
import { UiWalletPassLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiWalletPassLined />
```

 */
const UiWalletPassLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M17 1H7C5.35 1 4 2.35 4 4v16c0 1.65 1.35 3 3 3h10c1.65 0 3-1.35 3-3V4c0-1.65-1.35-3-3-3zm1 19c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v16z"
  }), /*#__PURE__*/jsx("path", {
    d: "M15.5 16h-7c-.28 0-.5.22-.5.5s.22.5.5.5h7c.28 0 .5-.22.5-.5s-.22-.5-.5-.5zm-2 2h-5c-.28 0-.5.22-.5.5s.22.5.5.5h5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5zm-3.25-6.28l-.51.42c.1.1.21.19.32.28l.13.07c.86-.49 1.69-1.03 2.49-1.61C15 9.27 16.5 7.73 15.77 6.86c-.73-.87-3.61-1-6.83-.72h-.2c-.09.16-.19.32-.27.5l-.06.21c-.01.03-.01.06 0 .09 1.78 0 3.26.31 3.88.97.99 1.02-.66 2.66-2.04 3.81z"
  })]
}));

/**
UiWalletPassLinedSmall icon

```jsx
import { UiWalletPassLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiWalletPassLinedSmall />
```

 */
const UiWalletPassLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M12 0H4C2.9 0 2 .9 2 2v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zM4 14V2h8v12H4z"
  }), /*#__PURE__*/jsx("path", {
    d: "M10.5 11h-5c-.28 0-.5.22-.5.5s.22.5.5.5h5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5zM6.42 8.41l-.39.32c.08.08.16.15.25.21l.1.06c.66-.38 1.3-.8 1.92-1.24 1.79-1.24 2.95-2.43 2.39-3.1-.57-.67-2.79-.77-5.28-.56h-.15c-.07.13-.14.25-.2.39L5 4.66v.07c1.38 0 2.51.24 2.99.75.77.78-.5 2.05-1.57 2.93z"
  })]
}));

/**
UiWrenchFilled icon

```jsx
import { UiWrenchFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiWrenchFilled />
```

 */
const UiWrenchFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22.8 5.991c-.1-.399-.3-.698-.7-.798-.399-.1-.699 0-.999.2l-2.797 2.795c-.2.2-.5.2-.7 0L15.706 6.29c-.1-.1-.1-.3-.1-.4 0-.1 0-.2.1-.399l2.797-2.795c.3-.3.305-.58.2-.998-.1-.4-.628-.699-.8-.699h-.998c-3.298 0-5.996 2.695-5.996 5.99 0 .698.1 1.397.4 2.096L1.816 18.57c-.8.798-1.099 2.196-.5 3.194.9 1.498 2.798 1.597 3.997.5l9.593-9.584c.7.2 1.4.4 2.099.4 3.297 0 5.995-2.696 5.995-5.99 0-.09-.112-.748-.2-1.099z"
  })
}));

/**
UiWrenchFilledSmall icon

```jsx
import { UiWrenchFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiWrenchFilledSmall />
```

 */
const UiWrenchFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.123 8.428c.55.2 1.161.3 1.791.26 2.142-.13 3.922-1.899 4.072-4.027.03-.38.01-.76-.06-1.11a.367.367 0 00-.62-.19l-2.07 2.07a.378.378 0 01-.521 0l-2.161-2.16a.362.362 0 010-.51l2.07-2.068c.21-.21.1-.57-.19-.62a4.15 4.15 0 00-1.12-.06c-2 .14-3.912 2.06-4.032 4.068-.04.63.05 1.24.26 1.789L.59 12.816c-.6.6-.79 1.558-.34 2.288a1.834 1.834 0 002.871.36l7.003-7.036z"
  })
}));

/**
UiWrenchLined icon

```jsx
import { UiWrenchLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiWrenchLined />
```

 */
const UiWrenchLined = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M4.29 23c-.84 0-1.68-.32-2.33-.96a3.298 3.298 0 010-4.653l8.33-8.333A6.46 6.46 0 0116.54 1c.73 0 1.45.12 2.13.36.33.11.57.39.65.72.08.33-.02.68-.27.93l-2.76 2.762 1.93 1.931c3.06-3.061 3.08-3.061 3.47-3.061.43 0 .81.27.95.67a6.454 6.454 0 01-7.69 8.384L6.62 22.03c-.65.65-1.49.97-2.33.97zM16.21 3.01a4.462 4.462 0 00-3.85 5.974c.14.37.04.78-.23 1.06l-8.76 8.764c-.5.5-.5 1.32 0 1.82.5.501 1.32.501 1.82 0l8.76-8.763c.28-.28.69-.37 1.06-.23a4.461 4.461 0 005.98-3.852l-2.05 2.051c-.38.38-1.04.38-1.42 0l-3.35-3.352c-.39-.39-.39-1.03 0-1.42l2.04-2.051z"
  })
}));

/**
UiYoutubeFilled icon

```jsx
import { UiYoutubeFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiYoutubeFilled />
```

 */
const UiYoutubeFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    d: "M22.54 6.5a2.768 2.768 0 00-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.48a2.768 2.768 0 00-1.94 2C1.14 8.3.99 10.15 1 12c-.01 1.84.14 3.68.46 5.5a2.768 2.768 0 001.94 2c1.72.5 8.6.5 8.6.5s6.88 0 8.6-.48c.47-.14.9-.39 1.24-.74.34-.35.58-.78.7-1.26.32-1.82.47-3.67.46-5.52.01-1.84-.14-3.68-.46-5.5zM10 15.38V8.62L15.75 12 10 15.38z"
  })
}));

/**
UiZelleFilled icon

```jsx
import { UiZelleFilled } from '@cof/omni-gravity-icons-react'

const Example = () => <UiZelleFilled />
```

 */
const UiZelleFilled = props => /*#__PURE__*/jsx("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 5a1 1 0 00-1-1h-3V2a1 1 0 00-1-1h-2a1 1 0 00-1 1v2H7a1 1 0 00-1 1v2a1 1 0 001 1h5.537l-6.321 8.38.014.005A.987.987 0 006 17v2a1 1 0 001 1h3v2a1 1 0 001 1h2a1 1 0 001-1v-2h3a1 1 0 001-1v-2a1 1 0 00-1-1h-5.058l5.862-8.405-.02-.002A.978.978 0 0018 7V5z"
  })
}));

/**
UiZelleFilledSmall icon

```jsx
import { UiZelleFilledSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiZelleFilledSmall />
```

 */
const UiZelleFilledSmall = props => /*#__PURE__*/jsx("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 2.73a.73.73 0 00-.727-.73H10V.727A.727.727 0 009.273 0H7.727A.727.727 0 007 .727V2H4.727A.73.73 0 004 2.73v1.543c0 .401.325.727.727.727h4.027l-4.597 6.095a.72.72 0 00-.157.45v1.728c0 .401.325.727.727.727H7v1.273c0 .401.325.727.727.727h1.546a.727.727 0 00.727-.727V14h2.273a.727.727 0 00.727-.727v-1.546a.727.727 0 00-.727-.727H8.594l4.249-6.114c.092-.122.157-.357.157-.522V2.73z"
  })
}));

/**
UiZoomInLined icon

```jsx
import { UiZoomInLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiZoomInLined />
```

 */
const UiZoomInLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M9 11H7c-.6 0-1-.4-1-1s.4-1 1-1h2V7c0-.6.4-1 1-1s1 .4 1 1v2h2c.6 0 1 .4 1 1s-.4 1-1 1h-2v2c0 .6-.4 1-1 1s-1-.4-1-1v-2z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9 14.1l3.5 3.5c.8.8.8 2 0 2.8-.4.4-.9.6-1.4.6-.5 0-1-.2-1.4-.6l-3.5-3.5c-1.2.7-2.6 1.1-4.1 1.1-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8c0 1.5-.4 2.9-1.1 4.1zM10 16c3.3 0 6-2.7 6-6s-2.7-6-6-6-6 2.7-6 6 2.7 6 6 6z"
  })]
}));

/**
UiZoomInLinedSmall icon

```jsx
import { UiZoomInLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiZoomInLinedSmall />
```

 */
const UiZoomInLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M8 6h1c.6 0 1 .4 1 1s-.4 1-1 1H8v1c0 .6-.4 1-1 1s-1-.4-1-1V8H5c-.6 0-1-.4-1-1s.4-1 1-1h1V5c0-.6.4-1 1-1s1 .4 1 1v1z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2 10l2.4 2.4c.5.6.5 1.6 0 2.2-.3.3-.7.4-1.1.4-.4 0-.8-.1-1.1-.4L10 12.2c-.9.5-1.9.8-3 .8-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6c0 1.1-.3 2.1-.8 3zM7 3C4.8 3 3 4.8 3 7s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4z"
  })]
}));

/**
UiZoomOutLined icon

```jsx
import { UiZoomOutLined } from '@cof/omni-gravity-icons-react'

const Example = () => <UiZoomOutLined />
```

 */
const UiZoomOutLined = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M14 10c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1s.4-1 1-1h6c.6 0 1 .4 1 1z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9 14.1l3.5 3.5c.8.8.8 2 0 2.8-.4.4-.9.6-1.4.6-.5 0-1-.2-1.4-.6l-3.5-3.5c-1.2.7-2.6 1.1-4.1 1.1-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8c0 1.5-.4 2.9-1.1 4.1zM10 16c3.3 0 6-2.7 6-6s-2.7-6-6-6-6 2.7-6 6 2.7 6 6 6z"
  })]
}));

/**
UiZoomOutLinedSmall icon

```jsx
import { UiZoomOutLinedSmall } from '@cof/omni-gravity-icons-react'

const Example = () => <UiZoomOutLinedSmall />
```

 */
const UiZoomOutLinedSmall = props => /*#__PURE__*/jsxs("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, props, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M4 7c0-.6.4-1 1-1h4c.6 0 1 .4 1 1s-.4 1-1 1H5c-.6 0-1-.4-1-1z"
  }), /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2 10l2.4 2.4c.5.6.5 1.6 0 2.2-.3.3-.7.4-1.1.4-.4 0-.8-.1-1.1-.4L10 12.2c-.9.5-1.9.8-3 .8-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6c0 1.1-.3 2.1-.8 3zM7 3C4.8 3 3 4.8 3 7s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4z"
  })]
}));

export { UiAccessibilityFilled, UiAccessibilityFilledSmall, UiAccountsFilled, UiAccountsFilledSmall, UiAccountsLined, UiAgentFilled, UiAgentFilledSmall, UiAgentLined, UiAgentLinedSmall, UiAggregateLined, UiAggregateLinedSmall, UiApiLined, UiApiLinedSmall, UiApplicationFilled, UiApplicationFilledSmall, UiApplicationLined, UiApplicationLinedSmall, UiArrowDownEncircledFilled, UiArrowDownEncircledFilledSmall, UiArrowDownEncircledLined, UiArrowDownLined, UiArrowDownLinedSmall, UiArrowLeftEncircledFilled, UiArrowLeftEncircledFilledSmall, UiArrowLeftEncircledLined, UiArrowLeftLined, UiArrowLeftLinedSmall, UiArrowLevelDownLined, UiArrowLevelDownLinedSmall, UiArrowLevelUpLined, UiArrowLevelUpLinedSmall, UiArrowRightEncircledFilled, UiArrowRightEncircledFilledSmall, UiArrowRightEncircledLined, UiArrowRightLined, UiArrowRightLinedSmall, UiArrowSortFilled, UiArrowSortFilledSmall, UiArrowSortLined, UiArrowSortLinedSmall, UiArrowUpEncircledFilled, UiArrowUpEncircledFilledSmall, UiArrowUpEncircledLined, UiArrowUpLined, UiArrowUpLinedSmall, UiAspectRatioFilled, UiAspectRatioFilledSmall, UiAspectRatioLined, UiAspectRatioLinedSmall, UiAtmFilled, UiAtmFilledSmall, UiAtmLined, UiAtmUkFilled, UiAtmUkFilledSmall, UiAtmUkLined, UiAttachLined, UiAttachLinedSmall, UiAutopayLined, UiAutopayUkLined, UiBacklogLined, UiBacklogLinedSmall, UiBankC1Filled, UiBankC1FilledSmall, UiBankC1Lined, UiBankFilled, UiBankFilledSmall, UiBankLined, UiBasicsFilled, UiBasicsFilledSmall, UiBatteryFilled, UiBatteryFilledSmall, UiBatteryLined, UiBatteryLinedSmall, UiBellFilled, UiBellFilledSmall, UiBellLined, UiBellLinedSmall, UiBillFilled, UiBillFilledSmall, UiBillLined, UiBillLinedSmall, UiBillUkFilled, UiBillUkFilledSmall, UiBillUkLined, UiBillUkLinedSmall, UiBirthdayFilled, UiBirthdayFilledSmall, UiBirthdayLined, UiBirthdayLinedSmall, UiBookmarkFilled, UiBookmarkFilledSmall, UiBookmarkLined, UiBookmarkLinedSmall, UiBrightnessDownFilled, UiBrightnessDownFilledSmall, UiBrightnessDownLined, UiBrightnessDownLinedSmall, UiBrightnessUpFilled, UiBrightnessUpFilledSmall, UiBrightnessUpLined, UiBrightnessUpLinedSmall, UiBugLined, UiBugLinedSmall, UiBundleFilled, UiBundleFilledSmall, UiBundleLined, UiBundleLinedSmall, UiC1AppCircleFilled, UiC1AppCircleFilledSmall, UiC1AppCircleLined, UiC1AppCircleLinedSmall, UiC1AppFilled, UiC1AppFilledSmall, UiC1AppLined, UiC1AppLinedSmall, UiCafeFilled, UiCafeFilledSmall, UiCafeLined, UiCalculatorFilled, UiCalculatorFilledSmall, UiCalculatorLined, UiCalendarAddLined, UiCalendarLined, UiCalendarLinedSmall, UiCameraFilled, UiCameraFilledSmall, UiCameraLined, UiCameraLinedSmall, UiCancelLined, UiCancelLinedSmall, UiCarConvertibleFilled, UiCarConvertibleLined, UiCarCoupeFilled, UiCarCoupeLined, UiCarCrossoverFilled, UiCarCrossoverLined, UiCarFilled, UiCarFilledSmall, UiCarHatchbackFilled, UiCarHatchbackLined, UiCarHeartFilled, UiCarHeartLined, UiCarLined, UiCarLinedSmall, UiCarMinivanFilled, UiCarMinivanLined, UiCarSedanFilled, UiCarSedanLined, UiCarSuvFilled, UiCarSuvLined, UiCarTradeInFilled, UiCarTradeInLined, UiCarTruckFilled, UiCarTruckLined, UiCarVanFilled, UiCarVanLined, UiCarWagonFilled, UiCarWagonLined, UiCardDamagedFilled, UiCardDamagedFilledSmall, UiCardDamagedLined, UiCardDamagedLinedSmall, UiCardDeliveryFilled, UiCardDeliveryFilledSmall, UiCardDeliveryLined, UiCardDeliveryLinedSmall, UiCardFilled, UiCardFilledSmall, UiCardLined, UiCardLinedSmall, UiCardMissingLined, UiCardMissingLinedSmall, UiCardRecurringChargeFilled, UiCardRecurringChargeLined, UiCashGenericFilled, UiCashGenericFilledSmall, UiCashGenericLined, UiCashGenericLinedSmall, UiCashUkFilled, UiCashUkFilledSmall, UiCashUkLined, UiCashUsFilled, UiCashUsFilledSmall, UiCashUsLined, UiCautionCircleFilled, UiCautionCircleFilledSmall, UiCautionCircleLined, UiCautionCircleLinedSmall, UiCautionTriangleFilled, UiCautionTriangleFilledSmall, UiCautionTriangleLined, UiCertifiedLined, UiCertifiedLinedSmall, UiChatFilled, UiChatFilledSmall, UiChatLined, UiChatLinedSmall, UiCheckLined, UiCheckLinedSmall, UiChecklistFilled, UiChecklistFilledSmall, UiChecklistLined, UiChecklistLinedSmall, UiCheckmarkEncircledFilled, UiCheckmarkEncircledFilledSmall, UiCheckmarkEncircledLined, UiCheckmarkEncircledLinedSmall, UiCheckmarkLined, UiCheckmarkLinedSmall, UiChevronDownEncircledFilled, UiChevronDownEncircledFilledSmall, UiChevronDownEncircledLined, UiChevronDownLined, UiChevronDownLinedSmall, UiChevronFirstLined, UiChevronFirstLinedSmall, UiChevronLastLined, UiChevronLastLinedSmall, UiChevronLeftEncircledFilled, UiChevronLeftEncircledFilledSmall, UiChevronLeftEncircledLined, UiChevronLeftLined, UiChevronLeftLinedSmall, UiChevronRightEncircledFilled, UiChevronRightEncircledFilledSmall, UiChevronRightEncircledLined, UiChevronRightLined, UiChevronRightLinedSmall, UiChevronUpEncircledFilled, UiChevronUpEncircledFilledSmall, UiChevronUpEncircledLined, UiChevronUpLined, UiChevronUpLinedSmall, UiClipboardLined, UiClipboardLinedSmall, UiClockFilled, UiClockFilledSmall, UiClockLined, UiClockLinedSmall, UiCloseFilled, UiCloseFilledSmall, UiCloseLined, UiCloseLinedSmall, UiClothingFilled, UiClothingFilledSmall, UiClothingLined, UiClothingLinedSmall, UiCodeExpressionLined, UiCodeExpressionLinedSmall, UiCodeLined, UiCodeLinedSmall, UiCollapseLined, UiCollapseLinedSmall, UiCommentFilled, UiCommentFilledSmall, UiCommentLined, UiCommentLinedSmall, UiContentLined, UiContentLinedSmall, UiContrastDownLined, UiContrastDownLinedSmall, UiContrastLined, UiContrastLinedSmall, UiContrastUpLined, UiContrastUpLinedSmall, UiCopyFilled, UiCopyFilledSmall, UiCopyLined, UiCopyLinedSmall, UiCreditBureauFilled, UiCreditBureauFilledSmall, UiCreditBureauLined, UiCreditBureauLinedSmall, UiCreditLineIncreaseFilled, UiCreditLineIncreaseLined, UiCreditwiseFilled, UiCreditwiseFilledSmall, UiCreditwiseLined, UiCreditwiseLinedSmall, UiCropLined, UiCropLinedSmall, UiDashboardLined, UiDashboardLinedSmall, UiDatasetLined, UiDatasetLinedSmall, UiDealershipFilled, UiDealershipFilledSmall, UiDealershipLined, UiDealershipLinedSmall, UiDeeplinkLined, UiDeeplinkLinedSmall, UiDeviceDesktopFilled, UiDeviceDesktopFilledSmall, UiDeviceDesktopLined, UiDeviceDesktopLinedSmall, UiDeviceLaptopFilled, UiDeviceLaptopFilledSmall, UiDeviceLaptopLined, UiDeviceLaptopLinedSmall, UiDevicePhoneLandscapeFilled, UiDevicePhoneLandscapeFilledSmall, UiDevicePhoneLandscapeLined, UiDevicePhoneLandscapeLinedSmall, UiDevicePhonePortraitFilled, UiDevicePhonePortraitFilledSmall, UiDevicePhonePortraitLined, UiDevicePhonePortraitLinedSmall, UiDeviceTabletLandscapeFilled, UiDeviceTabletLandscapeFilledSmall, UiDeviceTabletLandscapeLined, UiDeviceTabletLandscapeLinedSmall, UiDeviceTabletPortraitFilled, UiDeviceTabletPortraitFilledSmall, UiDeviceTabletPortraitLined, UiDeviceTabletPortraitLinedSmall, UiDeviceWatchFilled, UiDeviceWatchFilledSmall, UiDeviceWatchLined, UiDeviceWatchLinedSmall, UiDiningFilled, UiDiningFilledSmall, UiDiningLined, UiDirectionsFilled, UiDirectionsFilledSmall, UiDirectionsLined, UiDirectionsLinedSmall, UiDocumentCsvFilled, UiDocumentCsvLined, UiDocumentDocFilled, UiDocumentDocLined, UiDocumentDocxFilled, UiDocumentDocxLined, UiDocumentJpgFilled, UiDocumentJpgLined, UiDocumentPdfFilled, UiDocumentPdfLined, UiDocumentPngFilled, UiDocumentPngLined, UiDocumentPptFilled, UiDocumentPptLined, UiDocumentPptxFilled, UiDocumentPptxLined, UiDocumentXlsFilled, UiDocumentXlsLined, UiDocumentXlsxFilled, UiDocumentXlsxLined, UiDownloadLined, UiDownloadLinedSmall, UiDraggableColumnLined, UiDraggableColumnLinedSmall, UiDraggableCornerLined, UiDraggableCornerLinedSmall, UiDraggableGridLined, UiDraggableGridLinedSmall, UiDrivetrainFilled, UiDrivetrainLined, UiEditFilled, UiEditFilledSmall, UiEditLined, UiEditLinedSmall, UiEmployerLined, UiEmployerLinedSmall, UiEmpty, UiEmptySmall, UiEngineFilled, UiEngineLined, UiEnoFilled, UiEnoFilledSmall, UiEnoLined, UiEnoLinedSmall, UiEnvelopeFilled, UiEnvelopeFilledSmall, UiEnvelopeLined, UiEnvelopeLinedSmall, UiEqualLined, UiEqualLinedSmall, UiExpandLined, UiExpandLinedSmall, UiExperimentLined, UiExperimentLinedSmall, UiExternalLined, UiExternalLinedSmall, UiFaceIdLined, UiFaceIdLinedSmall, UiFacebookFilled, UiFeatureBlindSpotMonitorFilled, UiFeatureBlindSpotMonitorLined, UiFeatureBluetoothFilled, UiFeatureBluetoothLined, UiFeatureCooledSeatsFilled, UiFeatureCooledSeatsLined, UiFeatureGpsFilled, UiFeatureGpsLined, UiFeatureHeatedSeatsFilled, UiFeatureHeatedSeatsLined, UiFeatureLeatherSeatsFilled, UiFeatureLeatherSeatsLined, UiFeatureRearViewCameraFilled, UiFeatureRearViewCameraLined, UiFeatureSunroofLined, UiFeatureThirdRowSeatsFilled, UiFeatureThirdRowSeatsLined, UiFeatureTowHitchFilled, UiFeatureTowHitchLined, UiFeaturesLined, UiFeaturesLinedSmall, UiFeedbackDissatisfiedFilled, UiFeedbackDissatisfiedLined, UiFeedbackDissatisfiedLinedSmall, UiFeedbackFilled, UiFeedbackLined, UiFeedbackNeutralFilled, UiFeedbackNeutralLined, UiFeedbackNeutralLinedSmall, UiFeedbackSatisfiedFilled, UiFeedbackSatisfiedLined, UiFeedbackSatisfiedLinedSmall, UiFeedbackTriggerFilled, UiFeedbackTriggerLined, UiFeedbackTriggerLinedSmall, UiFeedbackVeryDissatisfiedFilled, UiFeedbackVeryDissatisfiedLined, UiFeedbackVeryDissatisfiedLinedSmall, UiFeedbackVerySatisfiedFilled, UiFeedbackVerySatisfiedLined, UiFeedbackVerySatisfiedLinedSmall, UiFilterAltFilled, UiFilterAltFilledSmall, UiFilterAltLined, UiFilterAltLinedSmall, UiFilterFilled, UiFilterFilledSmall, UiFilterLined, UiFilterLinedSmall, UiFingerprintLined, UiFingerprintLinedSmall, UiFlagFilled, UiFlagFilledSmall, UiFlagLined, UiFlagLinedSmall, UiFlashOffFilled, UiFlashOffFilledSmall, UiFlashOnFilled, UiFlashOnFilledSmall, UiFolderAddFilled, UiFolderAddLined, UiFolderDeleteFilled, UiFolderDeleteLined, UiFolderDownloadFilled, UiFolderDownloadLined, UiFolderFilled, UiFolderFilledSmall, UiFolderLevelDownFilled, UiFolderLevelDownLined, UiFolderLined, UiFolderLinedSmall, UiFolderMoveRightFilled, UiFolderMoveRightLined, UiFolderUploadFilled, UiFolderUploadLined, UiFraudFilled, UiFraudLined, UiFraudLinedSmall, UiFuelPumpFilled, UiFuelPumpLined, UiGalleryFilled, UiGalleryFilledSmall, UiGalleryLined, UiGalleryLinedSmall, UiGaugeHighFilled, UiGaugeHighFilledSmall, UiGaugeHighLined, UiGaugeHighLinedSmall, UiGaugeLowFilled, UiGaugeLowFilledSmall, UiGaugeLowLined, UiGaugeLowLinedSmall, UiGaugeMediumFilled, UiGaugeMediumFilledSmall, UiGaugeMediumLined, UiGaugeMediumLinedSmall, UiGithubLined, UiGithubLinedSmall, UiGlobeLined, UiGlobeLinedSmall, UiGridFilled, UiGridFilledSmall, UiGridLined, UiGridLinedSmall, UiHandbookLined, UiHandbookLinedSmall, UiHandshakeFilled, UiHandshakeFilledSmall, UiHandshakeLined, UiHandshakeLinedSmall, UiHashEncircledFilled, UiHashEncircledFilledSmall, UiHashEncircledLined, UiHeartFilled, UiHeartFilledSmall, UiHeartLined, UiHeartLinedSmall, UiHelpEncircledFilled, UiHelpEncircledLined, UiHelpLined, UiHelpLinedSmall, UiHomeFilled, UiHomeFilledSmall, UiHomeLined, UiHomeLinedSmall, UiHourglassLined, UiHourglassLinedSmall, UiIconPlaceholderLined, UiIconPlaceholderLinedSmall, UiInProgressFilled, UiInProgressFilledSmall, UiInboxFilled, UiInboxFilledSmall, UiInboxLined, UiInboxLinedSmall, UiInfoFilled, UiInfoFilledSmall, UiInfoLined, UiInfoLinedSmall, UiInstagramLined, UiJoinAltLined, UiJoinAltLinedSmall, UiJoinLined, UiJoinLinedSmall, UiKeyFilled, UiKeyFilledSmall, UiLeafFilled, UiLeafFilledSmall, UiLeafLined, UiLeafLinedSmall, UiLensLined, UiLensLinedSmall, UiLightbulbFilled, UiLightbulbFilledSmall, UiLightbulbLined, UiLightbulbLinedSmall, UiLinkLined, UiLinkLinedSmall, UiLinkUnlinkLined, UiLinkUnlinkLinedSmall, UiLinkedInFilled, UiListLined, UiListLinedSmall, UiLocationAndroidFilled, UiLocationAndroidFilledSmall, UiLocationAndroidLined, UiLocationAndroidLinedSmall, UiLocationFilled, UiLocationFilledSmall, UiLocationLined, UiLocationLinedSmall, UiLockFilled, UiLockFilledSmall, UiLockLined, UiLockLinedSmall, UiLockNoAccessFilled, UiLockNoAccessFilledSmall, UiLockNoAccessLined, UiLockUnlockFilled, UiLockUnlockFilledSmall, UiLockUnlockLined, UiLockUnlockLinedSmall, UiMagicBallFilled, UiMagicBallLined, UiMagicBallLinedSmall, UiMagicWandFilled, UiMagicWandFilledSmall, UiMailboxFilled, UiMailboxFilledSmall, UiMailboxLined, UiMailboxLinedSmall, UiMapFilled, UiMapFilledSmall, UiMapLined, UiMapLinedSmall, UiMapPinFilled, UiMapPinFilledSmall, UiMapPinLined, UiMapPinLinedSmall, UiMegaphoneFilled, UiMegaphoneFilledSmall, UiMegaphoneLined, UiMegaphoneLinedSmall, UiMenuLined, UiMenuLinedSmall, UiMessagesLined, UiMessagesLinedSmall, UiMicrophoneFilled, UiMicrophoneFilledSmall, UiMicrophoneLined, UiMicrophoneLinedSmall, UiMileageFilled, UiMileageLined, UiMinusEncircledFilled, UiMinusEncircledFilledSmall, UiMinusEncircledLined, UiMinusEncircledLinedSmall, UiMinusLined, UiMinusLinedSmall, UiModalLined, UiModalLinedSmall, UiMoneyBagFilled, UiMoneyBagFilledSmall, UiMoneyBagLined, UiMoneyBagSmallFilled, UiMoneyBagUkFilled, UiMoneyBagUkFilledSmall, UiMoneyBagUkLined, UiMoneyBagUkSmallFilled, UiMoneyFilled, UiMoneyFilledSmall, UiMoneyInFilled, UiMoneyInFilledSmall, UiMoneyInSmallFilled, UiMoneyLined, UiMoneyLinedSmall, UiMoneyOutFilled, UiMoneyOutFilledSmall, UiMoneyOutSmallFilled, UiMoneyProtectedFilled, UiMoneyProtectedFilledSmall, UiMoneyProtectedLined, UiMoneyProtectedSmallFilled, UiMoneyProtectedUkFilled, UiMoneyProtectedUkFilledSmall, UiMoneyProtectedUkLined, UiMoneyProtectedUkSmallFilled, UiMoneySmallFilled, UiMoneySmallLined, UiMoneyUkFilled, UiMoneyUkFilledSmall, UiMoneyUkLined, UiMoneyUkLinedSmall, UiMoneyUkSmallFilled, UiMoneyUkSmallLined, UiMoveMoneyFilled, UiMoveMoneyLined, UiMoveMoneyUkFilled, UiMoveMoneyUkLined, UiNotesCloseFilled, UiNotesCloseLined, UiNotesFilled, UiNotesFilledSmall, UiNotesHideFilled, UiNotesHideLined, UiNotesLined, UiNotesLinedSmall, UiNotesOpenFilled, UiNotesOpenLined, UiOfferLined, UiOilFilled, UiOilLined, UiOverflowEncircledFilled, UiOverflowEncircledFilledSmall, UiOverflowEncircledLined, UiOverflowEncircledSmallFilled, UiOverflowLined, UiOverflowLinedSmall, UiOverflowSmallLined, UiOverflowVerticalEncircledFilled, UiOverflowVerticalEncircledFilledSmall, UiOverflowVerticalEncircledLined, UiOverflowVerticalEncircledSmallFilled, UiOverflowVerticalLined, UiOverflowVerticalLinedSmall, UiOverflowVerticalSmallLined, UiPaperFilled, UiPaperFilledSmall, UiPaperLined, UiPaperLinedSmall, UiPaperlessFilled, UiPaperlessFilledSmall, UiPaperlessLined, UiPaperlessLinedSmall, UiPartialPaymentLined, UiPaypalFilled, UiPaypalFilledSmall, UiPaypalLined, UiPaypalLinedSmall, UiPeopleFilled, UiPeopleFilledSmall, UiPeopleLined, UiPeopleLinedSmall, UiPercentageEncircledFilled, UiPercentageEncircledFilledSmall, UiPercentageEncircledLined, UiPercentageFilled, UiPercentageLined, UiPercentageLinedSmall, UiPersonEncircledFilled, UiPersonEncircledFilledSmall, UiPersonEncircledLined, UiPersonEncircledLinedSmall, UiPersonFilled, UiPersonFilledSmall, UiPersonLined, UiPersonLinedSmall, UiPersonSettingsFilled, UiPersonSettingsLined, UiPhoneFilled, UiPhoneFilledSmall, UiPhoneLined, UiPhoneLinedSmall, UiPinFilled, UiPinFilledSmall, UiPinLined, UiPinLinedSmall, UiPistonFilled, UiPistonLined, UiPlaneFilled, UiPlaneFilledSmall, UiPlaneLined, UiPlayEncircledFilled, UiPlayEncircledFilledSmall, UiPlayEncircledLined, UiPlayFilled, UiPlayFilledSmall, UiPlayLined, UiPlayLinedSmall, UiPlusEncircledFilled, UiPlusEncircledFilledSmall, UiPlusEncircledLined, UiPlusEncircledLinedSmall, UiPlusLined, UiPlusLinedSmall, UiPreQualifyFilled, UiPreQualifyLined, UiPrintFilled, UiPrintFilledSmall, UiPrintLined, UiPrintLinedSmall, UiProtectedFilled, UiProtectedFilledSmall, UiProtectedLined, UiProtectedLinedSmall, UiQrCodeLined, UiQrCodeLinedSmall, UiRadiusLined, UiRadiusLinedSmall, UiReceiptFilled, UiReceiptFilledSmall, UiReceiptLined, UiReceiptUkFilled, UiReceiptUkFilledSmall, UiReceiptUkLined, UiRecentLined, UiRecentLinedSmall, UiRecurringLined, UiRecurringLinedSmall, UiRecycleLined, UiRecycleLinedSmall, UiRedoLined, UiRedoLinedSmall, UiRefreshLined, UiRefreshLinedSmall, UiRefreshmentsLined, UiRelayFilled, UiRelayLined, UiReminderFilled, UiReminderFilledSmall, UiReminderLined, UiReportsFilled, UiReportsFilledSmall, UiReportsLined, UiReportsLinedSmall, UiRequestMoneyFilled, UiRequestMoneyFilledSmall, UiRequestMoneyLined, UiRequestMoneyUkFilled, UiRequestMoneyUkFilledSmall, UiRequestMoneyUkLined, UiRewardsFilled, UiRewardsFilledSmall, UiRewardsLined, UiRewardsLinedSmall, UiRobotFilled, UiRobotFilledSmall, UiRobotLined, UiRotateLeftLined, UiRotateLeftLinedSmall, UiRotateRightLined, UiRotateRightLinedSmall, UiSavingsFilled, UiSavingsFilledSmall, UiSavingsLined, UiSavingsLinedSmall, UiScanDocumentFilled, UiScanDocumentLined, UiScanDocumentLinedSmall, UiSearchLined, UiSearchLinedSmall, UiSendFilled, UiSendFilledSmall, UiSendLined, UiSendLinedSmall, UiSettingsFilled, UiSettingsFilledSmall, UiSettingsLined, UiSettingsLinedSmall, UiShareAndroidFilled, UiShareAndroidFilledSmall, UiShareAndroidLined, UiShareAndroidLinedSmall, UiShareLined, UiShareLinedSmall, UiShoppingBagFilled, UiShoppingBagFilledSmall, UiShoppingBagLined, UiShoppingBagLinedSmall, UiShoppingBasketFilled, UiShoppingBasketLined, UiShowFilled, UiShowFilledSmall, UiShowHideFilled, UiShowHideFilledSmall, UiShowHideLined, UiShowHideLinedSmall, UiShowLined, UiShowLinedSmall, UiSignOutFilled, UiSignOutFilledSmall, UiSignOutLined, UiSignOutLinedSmall, UiSignatureLined, UiSignatureLinedSmall, UiSlackFilled, UiSortAltLined, UiSortAltLinedSmall, UiSortLined, UiSortLinedSmall, UiSplitLined, UiSplitLinedSmall, UiStarFilled, UiStarFilledSmall, UiStarLined, UiStarLinedSmall, UiStrategyFilled, UiStrategyFilledSmall, UiStrategyLined, UiStrategyLinedSmall, UiStreamsLined, UiStreamsLinedSmall, UiSuitcaseFilled, UiSuitcaseFilledSmall, UiSuitcaseLined, UiSuitcaseLinedSmall, UiTableLined, UiTableLinedSmall, UiTableViewsLined, UiTableViewsLinedSmall, UiTagFilled, UiTagFilledSmall, UiTagLined, UiTagLinedSmall, UiTapCardKeyFilled, UiTapCardKeyFilledSmall, UiTapCardKeyLined, UiTemperatureFilled, UiTemperatureLined, UiThumbsDownFilled, UiThumbsDownFilledSmall, UiThumbsDownLined, UiThumbsUpFilled, UiThumbsUpFilledSmall, UiThumbsUpLined, UiTicketFilled, UiTicketFilledSmall, UiTicketLined, UiTrackerFilled, UiTrackerLined, UiTrackerLinedSmall, UiTrainFilled, UiTrainFilledSmall, UiTrainLined, UiTrainLinedSmall, UiTransferLined, UiTransferLinedSmall, UiTransmissionLined, UiTrashFilled, UiTrashFilledSmall, UiTrashLined, UiTrashLinedSmall, UiTrophyFilled, UiTrophyFilledSmall, UiTrophyLined, UiTrophyLinedSmall, UiTwitterFilled, UiUmbrellaFilled, UiUmbrellaFilledSmall, UiUmbrellaLined, UiUmbrellaLinedSmall, UiUndoLined, UiUndoLinedSmall, UiUploadLined, UiUploadLinedSmall, UiUtilitiesFilled, UiUtilitiesFilledSmall, UiUtilitiesLined, UiUtilitiesLinedSmall, UiVendorFilled, UiVendorFilledSmall, UiVendorLined, UiVendorLinedSmall, UiVinFilled, UiVinLined, UiVirtualNumberFilled, UiVirtualNumberFilledSmall, UiVirtualNumberLined, UiVirtualNumberLinedSmall, UiWalletFilled, UiWalletFilledSmall, UiWalletLined, UiWalletPassFilled, UiWalletPassFilledSmall, UiWalletPassLined, UiWalletPassLinedSmall, UiWrenchFilled, UiWrenchFilledSmall, UiWrenchLined, UiYoutubeFilled, UiZelleFilled, UiZelleFilledSmall, UiZoomInLined, UiZoomInLinedSmall, UiZoomOutLined, UiZoomOutLinedSmall };
